
/** chimeePlayer
 * chimee-player v1.4.9
 * (c) 2017-2020 huzunjie
 * Released under MIT
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.ChimeePlayer = factory());
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var classCallCheck = _classCallCheck;

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
  });

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var assertThisInitialized = _assertThisInitialized;

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
      return call;
    }

    return assertThisInitialized(self);
  }

  var possibleConstructorReturn = _possibleConstructorReturn;

  var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
  });

  var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
  });

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }

  var inherits = _inherits;

  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };

  // true  -> String#at
  // false -> String#codePointAt
  var _stringAt = function (TO_STRING) {
    return function (that, pos) {
      var s = String(_defined(that));
      var i = _toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
        ? TO_STRING ? s.charAt(i) : a
        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

  var _library = true;

  var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule(function (module) {
  var core = module.exports = { version: '2.6.11' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  });
  var _core_1 = _core.version;

  var _aFunction = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function (fn, that, length) {
    _aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var _isObject = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function (it) {
    if (!_isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document$1 = _global.document;
  // typeof document.createElement is 'object' in old IE
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function (it) {
    return is ? document$1.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function () {
    return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function (it, S) {
    if (!_isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if (_ie8DomDefine) try {
      return dP(O, P, Attributes);
    } catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var _hide = _descriptors ? function (object, key, value) {
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  var PROTOTYPE = 'prototype';

  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && _has(exports, key)) continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? _ctx(out, _global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? (function (C) {
        var F = function (a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0: return new C();
              case 1: return new C(a);
              case 2: return new C(a, b);
            } return new C(a, b, c);
          } return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      // make static versions for prototype methods
      })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library`
  var _export = $export;

  var _redefine = _hide;

  var _iterators = {};

  var toString = {}.toString;

  var _cof = function (it) {
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  // eslint-disable-next-line no-prototype-builtins
  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings


  var _toIobject = function (it) {
    return _iobject(_defined(it));
  };

  // 7.1.15 ToLength

  var min = Math.min;
  var _toLength = function (it) {
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max = Math.max;
  var min$1 = Math.min;
  var _toAbsoluteIndex = function (index, length) {
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes



  var _arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = _toIobject($this);
      var length = _toLength(O.length);
      var index = _toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
      } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode: 'pure',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
  });

  var id = 0;
  var px = Math.random();
  var _uid = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var shared = _shared('keys');

  var _sharedKey = function (key) {
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function (object, names) {
    var O = _toIobject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)



  var _objectKeys = Object.keys || function keys(O) {
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    _anObject(O);
    var keys = _objectKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
    return O;
  };

  var document$2 = _global.document;
  var _html = document$2 && document$2.documentElement;

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



  var IE_PROTO$1 = _sharedKey('IE_PROTO');
  var Empty = function () { /* empty */ };
  var PROTOTYPE$1 = 'prototype';

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = _domCreate('iframe');
    var i = _enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    _html.appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
    return createDict();
  };

  var _objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE$1] = _anObject(O);
      result = new Empty();
      Empty[PROTOTYPE$1] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO$1] = O;
    } else result = createDict();
    return Properties === undefined ? result : _objectDps(result, Properties);
  };

  var _wks = createCommonjsModule(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] =
      USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
  });

  var def = _objectDp.f;

  var TAG = _wks('toStringTag');

  var _setToStringTag = function (it, tag, stat) {
    if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
  };

  var IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  _hide(IteratorPrototype, _wks('iterator'), function () { return this; });

  var _iterCreate = function (Constructor, NAME, next) {
    Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
    _setToStringTag(Constructor, NAME + ' Iterator');
  };

  // 7.1.13 ToObject(argument)

  var _toObject = function (it) {
    return Object(_defined(it));
  };

  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


  var IE_PROTO$2 = _sharedKey('IE_PROTO');
  var ObjectProto = Object.prototype;

  var _objectGpo = Object.getPrototypeOf || function (O) {
    O = _toObject(O);
    if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectProto : null;
  };

  var ITERATOR = _wks('iterator');
  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';

  var returnThis = function () { return this; };

  var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    _iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
      if (!BUGGY && kind in proto) return proto[kind];
      switch (kind) {
        case KEYS: return function keys() { return new Constructor(this, kind); };
        case VALUES: return function values() { return new Constructor(this, kind); };
      } return function entries() { return new Constructor(this, kind); };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
      IteratorPrototype = _objectGpo($anyNative.call(new Base()));
      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        _setToStringTag(IteratorPrototype, TAG, true);
        // fix for some old engines
        if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
      }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;
      $default = function values() { return $native.call(this); };
    }
    // Define iterator
    if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      _hide(proto, ITERATOR, $default);
    }
    // Plug for library
    _iterators[NAME] = $default;
    _iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) _redefine(proto, key, methods[key]);
      } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

  var $at = _stringAt(true);

  // 21.1.3.27 String.prototype[@@iterator]()
  _iterDefine(String, 'String', function (iterated) {
    this._t = String(iterated); // target
    this._i = 0;                // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return { value: undefined, done: true };
    point = $at(O, index);
    this._i += point.length;
    return { value: point, done: false };
  });

  var _iterStep = function (done, value) {
    return { value: value, done: !!done };
  };

  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
    this._t = _toIobject(iterated); // target
    this._i = 0;                   // next index
    this._k = kind;                // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return _iterStep(1);
    }
    if (kind == 'keys') return _iterStep(0, index);
    if (kind == 'values') return _iterStep(0, O[index]);
    return _iterStep(0, [index, O[index]]);
  }, 'values');

  // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
  _iterators.Arguments = _iterators.Array;

  var TO_STRING_TAG = _wks('toStringTag');

  var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
    'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
    'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
    'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
    'TextTrackList,TouchList').split(',');

  for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = _global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
    _iterators[NAME] = _iterators.Array;
  }

  var f$1 = _wks;

  var _wksExt = {
  	f: f$1
  };

  var iterator = _wksExt.f('iterator');

  var iterator$1 = createCommonjsModule(function (module) {
  module.exports = { "default": iterator, __esModule: true };
  });

  unwrapExports(iterator$1);

  var _meta = createCommonjsModule(function (module) {
  var META = _uid('meta');


  var setDesc = _objectDp.f;
  var id = 0;
  var isExtensible = Object.isExtensible || function () {
    return true;
  };
  var FREEZE = !_fails(function () {
    return isExtensible(Object.preventExtensions({}));
  });
  var setMeta = function (it) {
    setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {}          // weak collections IDs
    } });
  };
  var fastKey = function (it, create) {
    // return primitive with prefix
    if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F';
      // not necessary to add metadata
      if (!create) return 'E';
      // add missing metadata
      setMeta(it);
    // return object ID
    } return it[META].i;
  };
  var getWeak = function (it, create) {
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true;
      // not necessary to add metadata
      if (!create) return false;
      // add missing metadata
      setMeta(it);
    // return hash weak collections IDs
    } return it[META].w;
  };
  // add metadata on freeze-family methods calling
  var onFreeze = function (it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
    return it;
  };
  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  });
  var _meta_1 = _meta.KEY;
  var _meta_2 = _meta.NEED;
  var _meta_3 = _meta.fastKey;
  var _meta_4 = _meta.getWeak;
  var _meta_5 = _meta.onFreeze;

  var defineProperty = _objectDp.f;
  var _wksDefine = function (name) {
    var $Symbol = _core.Symbol || (_core.Symbol = {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
  };

  var f$2 = Object.getOwnPropertySymbols;

  var _objectGops = {
  	f: f$2
  };

  var f$3 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$3
  };

  // all enumerable object keys, includes symbols



  var _enumKeys = function (it) {
    var result = _objectKeys(it);
    var getSymbols = _objectGops.f;
    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = _objectPie.f;
      var i = 0;
      var key;
      while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
    } return result;
  };

  // 7.2.2 IsArray(argument)

  var _isArray = Array.isArray || function isArray(arg) {
    return _cof(arg) == 'Array';
  };

  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

  var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

  var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return _objectKeysInternal(O, hiddenKeys);
  };

  var _objectGopn = {
  	f: f$4
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

  var gOPN = _objectGopn.f;
  var toString$1 = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function (it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  var f$5 = function getOwnPropertyNames(it) {
    return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
  };

  var _objectGopnExt = {
  	f: f$5
  };

  var gOPD = Object.getOwnPropertyDescriptor;

  var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = _toIobject(O);
    P = _toPrimitive(P, true);
    if (_ie8DomDefine) try {
      return gOPD(O, P);
    } catch (e) { /* empty */ }
    if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
  };

  var _objectGopd = {
  	f: f$6
  };

  // ECMAScript 6 symbols shim





  var META = _meta.KEY;





















  var gOPD$1 = _objectGopd.f;
  var dP$1 = _objectDp.f;
  var gOPN$1 = _objectGopnExt.f;
  var $Symbol = _global.Symbol;
  var $JSON = _global.JSON;
  var _stringify = $JSON && $JSON.stringify;
  var PROTOTYPE$2 = 'prototype';
  var HIDDEN = _wks('_hidden');
  var TO_PRIMITIVE = _wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = _shared('symbol-registry');
  var AllSymbols = _shared('symbols');
  var OPSymbols = _shared('op-symbols');
  var ObjectProto$1 = Object[PROTOTYPE$2];
  var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
  var QObject = _global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = _descriptors && _fails(function () {
    return _objectCreate(dP$1({}, 'a', {
      get: function () { return dP$1(this, 'a', { value: 7 }).a; }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD$1(ObjectProto$1, key);
    if (protoDesc) delete ObjectProto$1[key];
    dP$1(it, key, D);
    if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
  } : dP$1;

  var wrap = function (tag) {
    var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
    _anObject(it);
    key = _toPrimitive(key, true);
    _anObject(D);
    if (_has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
      } return setSymbolDesc(it, key, D);
    } return dP$1(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P) {
    _anObject(it);
    var keys = _enumKeys(P = _toIobject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i) $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P) {
    return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = _toPrimitive(key, true));
    if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
    return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = _toIobject(it);
    key = _toPrimitive(key, true);
    if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
    var D = gOPD$1(it, key);
    if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN$1(_toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    } return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto$1;
    var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
    } return result;
  };

  // 19.4.1.1 Symbol([description])
  if (!USE_NATIVE) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function (value) {
        if (this === ObjectProto$1) $set.call(OPSymbols, value);
        if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, _propertyDesc(1, value));
      };
      if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
      return wrap(tag);
    };
    _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
      return this._k;
    });

    _objectGopd.f = $getOwnPropertyDescriptor;
    _objectDp.f = $defineProperty;
    _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
    _objectPie.f = $propertyIsEnumerable;
    _objectGops.f = $getOwnPropertySymbols;

    if (_descriptors && !_library) {
      _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    _wksExt.f = function (name) {
      return wrap(_wks(name));
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

  for (var es6Symbols = (
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
  ).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

  for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

  _export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function (key) {
      return _has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
      for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function () { setter = true; },
    useSimple: function () { setter = false; }
  });

  _export(_export.S + _export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
  // https://bugs.chromium.org/p/v8/issues/detail?id=3443
  var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

  _export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
      return _objectGops.f(_toObject(it));
    }
  });

  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;
      while (arguments.length > i) args.push(arguments[i++]);
      $replacer = replacer = args[1];
      if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!_isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });

  // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
  $Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  _setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  _setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  _setToStringTag(_global.JSON, 'JSON', true);

  _wksDefine('asyncIterator');

  _wksDefine('observable');

  var symbol = _core.Symbol;

  var symbol$1 = createCommonjsModule(function (module) {
  module.exports = { "default": symbol, __esModule: true };
  });

  unwrapExports(symbol$1);

  var _typeof_1$1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _iterator2 = _interopRequireDefault(iterator$1);



  var _symbol2 = _interopRequireDefault(symbol$1);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  });

  var _typeof = unwrapExports(_typeof_1$1);

  // most Object methods by ES6 should accept primitives



  var _objectSap = function (KEY, exec) {
    var fn = (_core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
  };

  // 19.1.2.9 Object.getPrototypeOf(O)



  _objectSap('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return _objectGpo(_toObject(it));
    };
  });

  var getPrototypeOf$1 = _core.Object.getPrototypeOf;

  var getPrototypeOf$2 = createCommonjsModule(function (module) {
  module.exports = { "default": getPrototypeOf$1, __esModule: true };
  });

  var _Object$getPrototypeOf = unwrapExports(getPrototypeOf$2);

  var classCallCheck$1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  });

  var _classCallCheck$1 = unwrapExports(classCallCheck$1);

  var possibleConstructorReturn$1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _typeof3 = _interopRequireDefault(_typeof_1$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };
  });

  var _possibleConstructorReturn$1 = unwrapExports(possibleConstructorReturn$1);

  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  _export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

  var $Object = _core.Object;
  var defineProperty$1 = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
  };

  var defineProperty$2 = createCommonjsModule(function (module) {
  module.exports = { "default": defineProperty$1, __esModule: true };
  });

  var _Object$defineProperty = unwrapExports(defineProperty$2);

  var createClass = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _defineProperty2 = _interopRequireDefault(defineProperty$2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  });

  var _createClass = unwrapExports(createClass);

  // Works with __proto__ only. Old v8 can't work with null proto objects.
  /* eslint-disable no-proto */


  var check = function (O, proto) {
    _anObject(O);
    if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };
  var _setProto = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
      function (test, buggy, set) {
        try {
          set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
          set(test, []);
          buggy = !(test instanceof Array);
        } catch (e) { buggy = true; }
        return function setPrototypeOf(O, proto) {
          check(O, proto);
          if (buggy) O.__proto__ = proto;
          else set(O, proto);
          return O;
        };
      }({}, false) : undefined),
    check: check
  };

  // 19.1.3.19 Object.setPrototypeOf(O, proto)

  _export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

  var setPrototypeOf$1 = _core.Object.setPrototypeOf;

  var setPrototypeOf$2 = createCommonjsModule(function (module) {
  module.exports = { "default": setPrototypeOf$1, __esModule: true };
  });

  unwrapExports(setPrototypeOf$2);

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  _export(_export.S, 'Object', { create: _objectCreate });

  var $Object$1 = _core.Object;
  var create = function create(P, D) {
    return $Object$1.create(P, D);
  };

  var create$1 = createCommonjsModule(function (module) {
  module.exports = { "default": create, __esModule: true };
  });

  var _Object$create = unwrapExports(create$1);

  var inherits$1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$2);



  var _create2 = _interopRequireDefault(create$1);



  var _typeof3 = _interopRequireDefault(_typeof_1$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };
  });

  var _inherits$1 = unwrapExports(inherits$1);

  // 19.1.2.14 Object.keys(O)



  _objectSap('keys', function () {
    return function keys(it) {
      return _objectKeys(_toObject(it));
    };
  });

  var keys = _core.Object.keys;

  var keys$1 = createCommonjsModule(function (module) {
  module.exports = { "default": keys, __esModule: true };
  });

  var _Object$keys = unwrapExports(keys$1);

  // 20.1.2.3 Number.isInteger(number)

  var floor$1 = Math.floor;
  var _isInteger = function isInteger(it) {
    return !_isObject(it) && isFinite(it) && floor$1(it) === it;
  };

  // 20.1.2.3 Number.isInteger(number)


  _export(_export.S, 'Number', { isInteger: _isInteger });

  var isInteger = _core.Number.isInteger;

  var isInteger$1 = createCommonjsModule(function (module) {
  module.exports = { "default": isInteger, __esModule: true };
  });

  var _Number$isInteger = unwrapExports(isInteger$1);

  var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

  var space = '[' + _stringWs + ']';
  var non = '\u200b\u0085';
  var ltrim = RegExp('^' + space + space + '*');
  var rtrim = RegExp(space + space + '*$');

  var exporter = function (KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = _fails(function () {
      return !!_stringWs[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    _export(_export.P + _export.F * FORCE, 'String', exp);
  };

  // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim
  var trim = exporter.trim = function (string, TYPE) {
    string = String(_defined(string));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };

  var _stringTrim = exporter;

  var $parseFloat = _global.parseFloat;
  var $trim = _stringTrim.trim;

  var _parseFloat = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $trim(String(str), 3);
    var result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;

  // 20.1.2.12 Number.parseFloat(string)
  _export(_export.S + _export.F * (Number.parseFloat != _parseFloat), 'Number', { parseFloat: _parseFloat });

  var _parseFloat$1 = _core.Number.parseFloat;

  var _parseFloat$2 = createCommonjsModule(function (module) {
  module.exports = { "default": _parseFloat$1, __esModule: true };
  });

  var _Number$parseFloat = unwrapExports(_parseFloat$2);

  /**
   * to check whether the object is defined or not
   */
  function defined(obj) {
    return typeof obj !== 'undefined';
  }
  /**
   * is void element or not ? Means it will return true when val is undefined or null
   */
  function isVoid(obj) {
    return obj === undefined || obj === null;
  }
  /**
   * to check whether a variable is array
   */
  function isArray(arr) {
    return Array.isArray(arr);
  }

  /**
   * is it a function or not
   */
  function isFunction(obj) {
    return typeof obj === 'function';
  }

  /**
   * is it an object or not
   */
  function isObject(obj) {
    // incase of arrow function and array
    return Object(obj) === obj && String(obj) === '[object Object]' && !isFunction(obj) && !isArray(obj);
  }
  /**
   * to tell you if it's a real number
   */
  function isNumber(obj) {
    return typeof obj === 'number';
  }
  /**
   * to tell you if the val can be transfer into number
   */
  function isNumeric(obj) {
    return !isArray(obj) && obj - _Number$parseFloat(obj) + 1 >= 0;
  }
  /**
   * is it an interget or not
   */
  function isInteger$2(num) {
    return _Number$isInteger(num);
  }

  /**
   * return true when the value is "", {}, [], 0, null, undefined, false.
   */
  function isEmpty(obj) {
    if (isArray(obj)) {
      return obj.length === 0;
    } else if (isObject(obj)) {
      return _Object$keys(obj).length === 0;
    } else {
      return !obj;
    }
  }
  /**
   * is it an event or not
   */
  function isEvent(obj) {
    return obj instanceof Event || (obj && obj.originalEvent) instanceof Event;
  }
  /**
   * is it a string
   */
  function isString(str) {
    return typeof str === 'string' || str instanceof String;
  }
  /**
   * is Boolean or not
   */
  function isBoolean(bool) {
    return typeof bool === 'boolean';
  }
  /**
   * is a promise or not
   */
  function isPromise(obj) {
    return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
  }
  /**
   * is Primitive type or not, whick means it will return true when data is number/string/boolean/undefined/null
   */
  function isPrimitive(val) {
    return isVoid(val) || isBoolean(val) || isString(val) || isNumber(val);
  }
  /**
   * is it an url, but this test require the url to have an protocol
   */
  function isUrl(str) {
    return isString(str) && !!str.match(/^((https?|ftp|rtsp|mms):\/\/)(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}\.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+\.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.[a-z]{2,6}|localhost)(:[0-9]{1,4})?((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\/?)$/i);
  }
  /**
   * to test if a HTML node
   */
  function isNode(obj) {
    return !!((typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string');
  }
  /**
   * to test if a HTML element
   */
  function isElement(obj) {
    return !!((typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string');
  }
  /**
   * check if node B is node A's posterrity or not
   */
  function isPosterityNode(parent, child) {
    if (!isNode(parent) || !isNode(child)) {
      return false;
    }
    while (child.parentNode) {
      child = child.parentNode;
      if (child === parent) {
        return true;
      }
    }
    return false;
  }
  /**
   * check if the string is an HTMLString
   */
  function isHTMLString(str) {
    return (/<[^>]+?>/.test(str)
    );
  }
  /**
   * check if is an error
   */
  function isError(val) {
    return val instanceof Error;
  }

  function formatter(tag, msg) {
    if (!isString(tag)) throw new TypeError('Log\'s method only acccept string as argument, but not ' + tag + ' in ' + (typeof tag === 'undefined' ? 'undefined' : _typeof(tag)));
    if (!isString(msg)) return '[' + Log$1.GLOBAL_TAG + '] > ' + tag;
    tag = Log$1.FORCE_GLOBAL_TAG ? Log$1.GLOBAL_TAG : tag || Log$1.GLOBAL_TAG;
    return '[' + tag + '] > ' + msg;
  }
  /**
   * Log Object
   */

  var Log$1 = function () {
    function Log() {
      _classCallCheck$1(this, Log);
    }

    _createClass(Log, null, [{
      key: 'error',

      /**
       * equal to console.error, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */
      value: function error(tag, msg) {
        if (!Log.ENABLE_ERROR) {
          return;
        }

        (console.error || console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.info, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {string}
       */

    }, {
      key: 'info',
      value: function info(tag, msg) {
        if (!Log.ENABLE_INFO) {
          return;
        }
        (console.info || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.warn, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'warn',
      value: function warn(tag, msg) {
        if (!Log.ENABLE_WARN) {
          return;
        }
        (console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.debug, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'debug',
      value: function debug(tag, msg) {
        if (!Log.ENABLE_DEBUG) {
          return;
        }
        (console.debug || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.verbose, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'verbose',
      value: function verbose(tag, msg) {
        if (!Log.ENABLE_VERBOSE) {
          return;
        }
        console.log(formatter(tag, msg));
      }
    }]);

    return Log;
  }();

  Log$1.GLOBAL_TAG = 'chimee';
  Log$1.FORCE_GLOBAL_TAG = false;
  Log$1.ENABLE_ERROR = true;
  Log$1.ENABLE_INFO = true;
  Log$1.ENABLE_WARN = true;
  Log$1.ENABLE_DEBUG = true;
  Log$1.ENABLE_VERBOSE = true;

  var uaParser = createCommonjsModule(function (module, exports) {
  /*!
   * UAParser.js v0.7.21
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
   * Licensed under MIT License
   */

  (function (window, undefined) {

      //////////////
      // Constants
      /////////////


      var LIBVERSION  = '0.7.21',
          EMPTY       = '',
          UNKNOWN     = '?',
          FUNC_TYPE   = 'function',
          OBJ_TYPE    = 'object',
          STR_TYPE    = 'string',
          MAJOR       = 'major', // deprecated
          MODEL       = 'model',
          NAME        = 'name',
          TYPE        = 'type',
          VENDOR      = 'vendor',
          VERSION     = 'version',
          ARCHITECTURE= 'architecture',
          CONSOLE     = 'console',
          MOBILE      = 'mobile',
          TABLET      = 'tablet',
          SMARTTV     = 'smarttv',
          WEARABLE    = 'wearable',
          EMBEDDED    = 'embedded';


      ///////////
      // Helper
      //////////


      var util = {
          extend : function (regexes, extensions) {
              var mergedRegexes = {};
              for (var i in regexes) {
                  if (extensions[i] && extensions[i].length % 2 === 0) {
                      mergedRegexes[i] = extensions[i].concat(regexes[i]);
                  } else {
                      mergedRegexes[i] = regexes[i];
                  }
              }
              return mergedRegexes;
          },
          has : function (str1, str2) {
            if (typeof str1 === "string") {
              return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
            } else {
              return false;
            }
          },
          lowerize : function (str) {
              return str.toLowerCase();
          },
          major : function (version) {
              return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
          },
          trim : function (str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
          }
      };


      ///////////////
      // Map helper
      //////////////


      var mapper = {

          rgx : function (ua, arrays) {

              var i = 0, j, k, p, q, matches, match;

              // loop through all regexes maps
              while (i < arrays.length && !matches) {

                  var regex = arrays[i],       // even sequence (0,2,4,..)
                      props = arrays[i + 1];   // odd sequence (1,3,5,..)
                  j = k = 0;

                  // try matching uastring with regexes
                  while (j < regex.length && !matches) {

                      matches = regex[j++].exec(ua);

                      if (!!matches) {
                          for (p = 0; p < props.length; p++) {
                              match = matches[++k];
                              q = props[p];
                              // check if given property is actually array
                              if (typeof q === OBJ_TYPE && q.length > 0) {
                                  if (q.length == 2) {
                                      if (typeof q[1] == FUNC_TYPE) {
                                          // assign modified match
                                          this[q[0]] = q[1].call(this, match);
                                      } else {
                                          // assign given value, ignore regex match
                                          this[q[0]] = q[1];
                                      }
                                  } else if (q.length == 3) {
                                      // check whether function or regex
                                      if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                          // call function (usually string mapper)
                                          this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                      } else {
                                          // sanitize match using given regex
                                          this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                      }
                                  } else if (q.length == 4) {
                                          this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                  }
                              } else {
                                  this[q] = match ? match : undefined;
                              }
                          }
                      }
                  }
                  i += 2;
              }
          },

          str : function (str, map) {

              for (var i in map) {
                  // check if array
                  if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                      for (var j = 0; j < map[i].length; j++) {
                          if (util.has(map[i][j], str)) {
                              return (i === UNKNOWN) ? undefined : i;
                          }
                      }
                  } else if (util.has(map[i], str)) {
                      return (i === UNKNOWN) ? undefined : i;
                  }
              }
              return str;
          }
      };


      ///////////////
      // String map
      //////////////


      var maps = {

          browser : {
              oldsafari : {
                  version : {
                      '1.0'   : '/8',
                      '1.2'   : '/1',
                      '1.3'   : '/3',
                      '2.0'   : '/412',
                      '2.0.2' : '/416',
                      '2.0.3' : '/417',
                      '2.0.4' : '/419',
                      '?'     : '/'
                  }
              }
          },

          device : {
              amazon : {
                  model : {
                      'Fire Phone' : ['SD', 'KF']
                  }
              },
              sprint : {
                  model : {
                      'Evo Shift 4G' : '7373KT'
                  },
                  vendor : {
                      'HTC'       : 'APA',
                      'Sprint'    : 'Sprint'
                  }
              }
          },

          os : {
              windows : {
                  version : {
                      'ME'        : '4.90',
                      'NT 3.11'   : 'NT3.51',
                      'NT 4.0'    : 'NT4.0',
                      '2000'      : 'NT 5.0',
                      'XP'        : ['NT 5.1', 'NT 5.2'],
                      'Vista'     : 'NT 6.0',
                      '7'         : 'NT 6.1',
                      '8'         : 'NT 6.2',
                      '8.1'       : 'NT 6.3',
                      '10'        : ['NT 6.4', 'NT 10.0'],
                      'RT'        : 'ARM'
                  }
              }
          }
      };


      //////////////
      // Regex map
      /////////////


      var regexes = {

          browser : [[

              // Presto based
              /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
              /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
              /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
              /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
              ], [NAME, VERSION], [

              /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
              ], [[NAME, 'Opera Mini'], VERSION], [

              /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
              ], [[NAME, 'Opera'], VERSION], [

              // Mixed
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                  // Lunascape/Maxthon/Netfront/Jasmine/Blazer
              // Trident based
              /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                  // Avant/IEMobile/SlimBrowser
              /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,                      // Baidu Browser
              /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

              // Webkit/KHTML based
              /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
              /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                  // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
              ], [NAME, VERSION], [

              /(konqueror)\/([\w\.]+)/i                                           // Konqueror
              ], [[NAME, 'Konqueror'], VERSION], [

              /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
              ], [[NAME, 'IE'], VERSION], [

              /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
              ], [[NAME, 'Edge'], VERSION], [

              /(yabrowser)\/([\w\.]+)/i                                           // Yandex
              ], [[NAME, 'Yandex'], VERSION], [

              /(Avast)\/([\w\.]+)/i                                               // Avast Secure Browser
              ], [[NAME, 'Avast Secure Browser'], VERSION], [

              /(AVG)\/([\w\.]+)/i                                                 // AVG Secure Browser
              ], [[NAME, 'AVG Secure Browser'], VERSION], [

              /(puffin)\/([\w\.]+)/i                                              // Puffin
              ], [[NAME, 'Puffin'], VERSION], [

              /(focus)\/([\w\.]+)/i                                               // Firefox Focus
              ], [[NAME, 'Firefox Focus'], VERSION], [

              /(opt)\/([\w\.]+)/i                                                 // Opera Touch
              ], [[NAME, 'Opera Touch'], VERSION], [

              /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
              ], [[NAME, 'UCBrowser'], VERSION], [

              /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
              ], [[NAME, /_/g, ' '], VERSION], [

              /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
              ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

              /(micromessenger)\/([\w\.]+)/i                                      // WeChat
              ], [[NAME, 'WeChat'], VERSION], [

              /(brave)\/([\w\.]+)/i                                               // Brave browser
              ], [[NAME, 'Brave'], VERSION], [

              /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
              ], [NAME, VERSION], [

              /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
              ], [NAME, VERSION], [

              /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
              ], [NAME, VERSION], [

              /(baiduboxapp)[\/\s]?([\w\.]+)/i                                    // Baidu App
              ], [NAME, VERSION], [

              /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
              ], [NAME, VERSION], [

              /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
              ], [NAME], [

              /(LBBROWSER)/i                                                      // LieBao Browser
              ], [NAME], [

              /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
              ], [VERSION, [NAME, 'MIUI Browser']], [

              /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
              ], [VERSION, [NAME, 'Facebook']], [

              /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
              /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
              ], [NAME, VERSION], [

              /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
              ], [VERSION, [NAME, 'Chrome Headless']], [

              /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
              ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

              /((?:oculus|samsung)browser)\/([\w\.]+)/i
              ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

              /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
              ], [VERSION, [NAME, 'Android Browser']], [

              /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
              ], [[NAME, 'Sailfish Browser'], VERSION], [

              /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                  // Chrome/OmniWeb/Arora/Tizen/Nokia
              ], [NAME, VERSION], [

              /(dolfin)\/([\w\.]+)/i                                              // Dolphin
              ], [[NAME, 'Dolphin'], VERSION], [

              /(qihu|qhbrowser|qihoobrowser|360browser)/i                         // 360
              ], [[NAME, '360 Browser']], [

              /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
              ], [[NAME, 'Chrome'], VERSION], [

              /(coast)\/([\w\.]+)/i                                               // Opera Coast
              ], [[NAME, 'Opera Coast'], VERSION], [

              /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
              ], [VERSION, [NAME, 'Firefox']], [

              /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
              ], [VERSION, [NAME, 'Mobile Safari']], [

              /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
              ], [VERSION, NAME], [

              /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
              ], [[NAME, 'GSA'], VERSION], [

              /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
              ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

              /(webkit|khtml)\/([\w\.]+)/i
              ], [NAME, VERSION], [

              // Gecko based
              /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
              ], [[NAME, 'Netscape'], VERSION], [
              /(swiftfox)/i,                                                      // Swiftfox
              /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                  // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
              /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                  // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
              /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

              // Other
              /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                  // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
              /(links)\s\(([\w\.]+)/i,                                            // Links
              /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
              /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
              /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
              ], [NAME, VERSION]
          ],

          cpu : [[

              /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
              ], [[ARCHITECTURE, 'amd64']], [

              /(ia32(?=;))/i                                                      // IA32 (quicktime)
              ], [[ARCHITECTURE, util.lowerize]], [

              /((?:i[346]|x)86)[;\)]/i                                            // IA32
              ], [[ARCHITECTURE, 'ia32']], [

              // PocketPC mistakenly identified as PowerPC
              /windows\s(ce|mobile);\sppc;/i
              ], [[ARCHITECTURE, 'arm']], [

              /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
              ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

              /(sun4\w)[;\)]/i                                                    // SPARC
              ], [[ARCHITECTURE, 'sparc']], [

              /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                  // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
              ], [[ARCHITECTURE, util.lowerize]]
          ],

          device : [[

              /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
              ], [MODEL, VENDOR, [TYPE, TABLET]], [

              /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
              ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

              /(apple\s{0,1}tv)/i                                                 // Apple TV
              ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple'], [TYPE, SMARTTV]], [

              /(archos)\s(gamepad2?)/i,                                           // Archos
              /(hp).+(touchpad)/i,                                                // HP TouchPad
              /(hp).+(tablet)/i,                                                  // HP Tablet
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
              /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
              ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
              /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
              ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
              /android.+aft([bms])\sbuild/i                                       // Fire TV
              ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

              /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
              ], [MODEL, VENDOR, [TYPE, MOBILE]], [
              /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
              ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

              /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
              /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                  // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
              /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
              /(asus)-?(\w+)/i                                                    // Asus
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
              ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                  // Asus Tablets
              /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
              ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

              /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
              /(sony)?(?:sgp.+)\sbuild\//i
              ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
              /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
              ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

              /\s(ouya)\s/i,                                                      // Ouya
              /(nintendo)\s([wids3u]+)/i                                          // Nintendo
              ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

              /android.+;\s(shield)\sbuild/i                                      // Nvidia
              ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

              /(playstation\s[34portablevi]+)/i                                   // Playstation
              ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

              /(sprint\s(\w+))/i                                                  // Sprint Phones
              ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

              /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
              /(zte)-(\w*)/i,                                                     // ZTE
              /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                  // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
              ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

              /(nexus\s9)/i                                                       // HTC Nexus 9
              ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

              /d\/huawei([\w\s-]+)[;\)]/i,
              /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i                              // Huawei
              ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

              /android.+(bah2?-a?[lw]\d{2})/i                                     // Huawei MediaPad
              ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [

              /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
              ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
              /(kin\.[onetw]{3})/i                                                // Microsoft Kin
              ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                  // Motorola
              /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
              /mot[\s-]?(\w*)/i,
              /(XT\d{3,4}) build\//i,
              /(nexus\s6)/i
              ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
              /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
              ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

              /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
              ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

              /hbbtv.+maple;(\d+)/i
              ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

              /\(dtv[\);].+(aquos)/i                                              // Sharp
              ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

              /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
              /((SM-T\w+))/i
              ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
              /smart-tv.+(samsung)/i
              ], [VENDOR, [TYPE, SMARTTV], MODEL], [
              /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
              /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
              /sec-((sgh\w+))/i
              ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

              /sie-(\w*)/i                                                        // Siemens
              ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

              /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
              /(nokia)[\s_-]?([\w-]*)/i
              ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

              /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
              ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

              /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
              ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
              /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
              ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
              /(lg) netcast\.tv/i                                                 // LG SmartTV
              ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
              /(nexus\s[45])/i,                                                   // LG
              /lg[e;\s\/-]+(\w*)/i,
              /android.+lg(\-?[\d\w]+)\s+build/i
              ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

              /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [
              /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
              ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
              /(lenovo)[_\s-]?([\w-]+)/i
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /linux;.+((jolla));/i                                               // Jolla
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /((pebble))app\/[\d\.]+\s/i                                         // Pebble
              ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

              /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /crkey/i                                                            // Google Chromecast
              ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [

              /android.+;\s(glass)\s\d/i                                          // Google Glass
              ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

              /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
              ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

              /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
              ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

              /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
              /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
              /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                  // Xiaomi Mi
              /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
              ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
              /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
              ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
              /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
              ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
              /(mz)-([\w-]{2,})/i
              ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

              /android.+a000(1)\s+build/i,                                        // OnePlus
              /android.+oneplus\s(a\d{4})[\s)]/i
              ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

              /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
              ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

              /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
              ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
              ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

              /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
              ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
              ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

              /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
              ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
              ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

              /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
              ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

              /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
              ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

              /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
              /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
              ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
              ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

              /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
              ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
              ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

              /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
              ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

              /android.+;\s(PH-1)\s/i
              ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

              /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
              ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
              ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
              ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

              /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
              ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

              /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
              /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
              ], [[TYPE, util.lowerize], VENDOR, MODEL], [

              /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
              ], [[TYPE, SMARTTV]], [

              /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
              ], [MODEL, [VENDOR, 'Generic']]
          ],

          engine : [[

              /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
              ], [VERSION, [NAME, 'EdgeHTML']], [

              /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
              ], [VERSION, [NAME, 'Blink']], [

              /(presto)\/([\w\.]+)/i,                                             // Presto
              /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                  // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
              /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
              /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
              ], [NAME, VERSION], [

              /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
              ], [VERSION, NAME]
          ],

          os : [[

              // Windows based
              /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
              ], [NAME, VERSION], [
              /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
              /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
              /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
              ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
              /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
              ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

              // Mobile/Embedded OS
              /\((bb)(10);/i                                                      // BlackBerry 10
              ], [[NAME, 'BlackBerry'], VERSION], [
              /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
              /(tizen|kaios)[\/\s]([\w\.]+)/i,                                    // Tizen/KaiOS
              /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                  // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
              ], [NAME, VERSION], [
              /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
              ], [[NAME, 'Symbian'], VERSION], [
              /\((series40);/i                                                    // Series 40
              ], [NAME], [
              /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
              ], [[NAME, 'Firefox OS'], VERSION], [

              // Console
              /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

              // GNU/Linux based
              /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
              /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
              /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                  // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                  // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
              /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
              /(gnu)\s?([\w\.]*)/i                                                // GNU
              ], [NAME, VERSION], [

              /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
              ], [[NAME, 'Chromium OS'], VERSION],[

              // Solaris
              /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
              ], [[NAME, 'Solaris'], VERSION], [

              // BSD based
              /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
              ], [NAME, VERSION],[

              /(haiku)\s(\w+)/i                                                   // Haiku
              ], [NAME, VERSION],[

              /cfnetwork\/.+darwin/i,
              /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
              ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

              /(mac\sos\sx)\s?([\w\s\.]*)/i,
              /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
              ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

              // Other
              /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
              /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
              /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                  // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
              /(unix)\s?([\w\.]*)/i                                               // UNIX
              ], [NAME, VERSION]
          ]
      };


      /////////////////
      // Constructor
      ////////////////
      var UAParser = function (uastring, extensions) {

          if (typeof uastring === 'object') {
              extensions = uastring;
              uastring = undefined;
          }

          if (!(this instanceof UAParser)) {
              return new UAParser(uastring, extensions).getResult();
          }

          var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
          var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

          this.getBrowser = function () {
              var browser = { name: undefined, version: undefined };
              mapper.rgx.call(browser, ua, rgxmap.browser);
              browser.major = util.major(browser.version); // deprecated
              return browser;
          };
          this.getCPU = function () {
              var cpu = { architecture: undefined };
              mapper.rgx.call(cpu, ua, rgxmap.cpu);
              return cpu;
          };
          this.getDevice = function () {
              var device = { vendor: undefined, model: undefined, type: undefined };
              mapper.rgx.call(device, ua, rgxmap.device);
              return device;
          };
          this.getEngine = function () {
              var engine = { name: undefined, version: undefined };
              mapper.rgx.call(engine, ua, rgxmap.engine);
              return engine;
          };
          this.getOS = function () {
              var os = { name: undefined, version: undefined };
              mapper.rgx.call(os, ua, rgxmap.os);
              return os;
          };
          this.getResult = function () {
              return {
                  ua      : this.getUA(),
                  browser : this.getBrowser(),
                  engine  : this.getEngine(),
                  os      : this.getOS(),
                  device  : this.getDevice(),
                  cpu     : this.getCPU()
              };
          };
          this.getUA = function () {
              return ua;
          };
          this.setUA = function (uastring) {
              ua = uastring;
              return this;
          };
          return this;
      };

      UAParser.VERSION = LIBVERSION;
      UAParser.BROWSER = {
          NAME    : NAME,
          MAJOR   : MAJOR, // deprecated
          VERSION : VERSION
      };
      UAParser.CPU = {
          ARCHITECTURE : ARCHITECTURE
      };
      UAParser.DEVICE = {
          MODEL   : MODEL,
          VENDOR  : VENDOR,
          TYPE    : TYPE,
          CONSOLE : CONSOLE,
          MOBILE  : MOBILE,
          SMARTTV : SMARTTV,
          TABLET  : TABLET,
          WEARABLE: WEARABLE,
          EMBEDDED: EMBEDDED
      };
      UAParser.ENGINE = {
          NAME    : NAME,
          VERSION : VERSION
      };
      UAParser.OS = {
          NAME    : NAME,
          VERSION : VERSION
      };

      ///////////
      // Export
      //////////


      // check js environment
      {
          // nodejs env
          if (module.exports) {
              exports = module.exports = UAParser;
          }
          exports.UAParser = UAParser;
      }

      // jQuery/Zepto specific (optional)
      // Note:
      //   In AMD env the global scope should be kept clean, but jQuery is an exception.
      //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
      //   and we should catch that.
      var $ = window && (window.jQuery || window.Zepto);
      if ($ && !$.ua) {
          var parser = new UAParser();
          $.ua = parser.getResult();
          $.ua.get = function () {
              return parser.getUA();
          };
          $.ua.set = function (uastring) {
              parser.setUA(uastring);
              var result = parser.getResult();
              for (var prop in result) {
                  $.ua[prop] = result[prop];
              }
          };
      }

  })(typeof window === 'object' ? window : commonjsGlobal);
  });
  var uaParser_1 = uaParser.UAParser;

  // call something on iterator step with safe closing on error

  var _iterCall = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) _anObject(ret.call(iterator));
      throw e;
    }
  };

  // check on default Array iterator

  var ITERATOR$1 = _wks('iterator');
  var ArrayProto = Array.prototype;

  var _isArrayIter = function (it) {
    return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
  };

  var _createProperty = function (object, index, value) {
    if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
    else object[index] = value;
  };

  // getting tag from 19.1.3.6 Object.prototype.toString()

  var TAG$1 = _wks('toStringTag');
  // ES3 wrong here
  var ARG = _cof(function () { return arguments; }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (e) { /* empty */ }
  };

  var _classof = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
      // builtinTag case
      : ARG ? _cof(O)
      // ES3 arguments fallback
      : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };

  var ITERATOR$2 = _wks('iterator');

  var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR$2]
      || it['@@iterator']
      || _iterators[_classof(it)];
  };

  var ITERATOR$3 = _wks('iterator');
  var SAFE_CLOSING = false;

  try {
    var riter = [7][ITERATOR$3]();
    riter['return'] = function () { SAFE_CLOSING = true; };
  } catch (e) { /* empty */ }

  var _iterDetect = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;
    try {
      var arr = [7];
      var iter = arr[ITERATOR$3]();
      iter.next = function () { return { done: safe = true }; };
      arr[ITERATOR$3] = function () { return iter; };
      exec(arr);
    } catch (e) { /* empty */ }
    return safe;
  };

  _export(_export.S + _export.F * !_iterDetect(function (iter) { }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
      var O = _toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = core_getIteratorMethod(O);
      var length, result, step, iterator;
      if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
      // if object isn't iterable or it's array with default iterator - use simple case
      if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = _toLength(O.length);
        for (result = new C(length); length > index; index++) {
          _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }
      result.length = index;
      return result;
    }
  });

  var from_1 = _core.Array.from;

  var from_1$1 = createCommonjsModule(function (module) {
  module.exports = { "default": from_1, __esModule: true };
  });

  var _Array$from = unwrapExports(from_1$1);

  var toConsumableArray = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _from2 = _interopRequireDefault(from_1$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  };
  });

  var _toConsumableArray = unwrapExports(toConsumableArray);

  /**
   * the handler to generate an deep traversal handler
   * @param  {Function} fn the function you wanna run when you reach in the deep property
   * @return {Function}    the handler
   */
  function genTraversalHandler(fn) {
    var setter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (target, key, value) {
      target[key] = value;
    };

    // use recursive to move what in source to the target
    // if you do not provide a target, we will create a new target
    function recursiveFn(source, target, key) {
      if (isArray(source) || isObject(source)) {
        target = isPrimitive(target) ? isObject(source) ? {} : [] : target;
        for (var _key in source) {
          // $FlowFixMe: support computed key here
          setter(target, _key, recursiveFn(source[_key], target[_key], _key));
          // target[key] = recursiveFn(source[key], target[key], key);
        }
        return target;
      }
      return fn(source, target, key);
    }
    return recursiveFn;
  }
  var _deepAssign = genTraversalHandler(function (val) {
    return val;
  });
  /**
   * deeply clone an object
   * @param  {Array|Object} source if you pass in other type, it will throw an error
   * @return {clone-target}        the new Object
   */
  function deepClone(source) {
    if (isPrimitive(source)) {
      throw new TypeError('deepClone only accept non primitive type');
    }
    return _deepAssign(source);
  }
  /**
   * merge multiple objects
   * @param  {...Object} args [description]
   * @return {merge-object}         [description]
   */
  function deepAssign() {
    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args.length < 2) {
      throw new Error('deepAssign accept two and more argument');
    }
    for (var i = args.length - 1; i > -1; i--) {
      if (isPrimitive(args[i])) {
        throw new TypeError('deepAssign only accept non primitive type');
      }
    }
    var target = args.shift();
    args.forEach(function (source) {
      return _deepAssign(source, target);
    });
    return target;
  }

  /**
   * camelize any string, e.g hello world -> helloWorld
   * @param  {string} str only accept string!
   * @return {string}     camelize string
   */
  function camelize(str, isBig) {
    return str.replace(/(^|[^a-zA-Z]+)([a-zA-Z])/g, function (match, spilt, initials, index) {
      return !isBig && index === 0 ? initials.toLowerCase() : initials.toUpperCase();
    });
  }
  /**
   * hypenate any string e.g hello world -> hello-world
   * @param  {string} str only accept string
   * @return {string}
   */
  function hypenate(str) {
    return camelize(str).replace(/([A-Z])/g, function (match) {
      return '-' + match.toLowerCase();
    });
  }

  /**
   * bind the function with some context. we have some fallback strategy here
   * @param {function} fn the function which we need to bind the context on
   * @param {any} context the context object
   */
  function bind(fn, context) {
    if (fn.bind) {
      return fn.bind(context);
    } else if (fn.apply) {
      return function __autobind__() {
        for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return fn.apply(context, args);
      };
    } else {
      return function __autobind__() {
        for (var _len3 = arguments.length, args = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return fn.call.apply(fn, [context].concat(_toConsumableArray(args)));
      };
    }
  }

  /**
   * generate an uuid
   */
  function uuid() {
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
  }
  /**
   * generate an random number which length is 4
   */
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }

  /**
   * get an deep property
   */
  function getDeepProperty(obj, keys) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$throwError = _ref.throwError,
        throwError = _ref$throwError === undefined ? false : _ref$throwError,
        backup = _ref.backup;

    if (isString(keys)) {
      keys = keys.split('.');
    }
    if (!isArray(keys)) {
      throw new TypeError('keys of getDeepProperty must be string or Array<string>');
    }
    var read = [];
    var target = obj;
    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];
      if (isVoid(target)) {
        if (throwError) {
          throw new Error('obj' + (read.length > 0 ? '.' + read.join('.') : ' itself') + ' is ' + target);
        } else {
          return backup;
        }
      }
      target = target[key];
      read.push(key);
    }
    return target;
  }

  var _anInstance = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
      throw TypeError(name + ': incorrect invocation!');
    } return it;
  };

  var _forOf = createCommonjsModule(function (module) {
  var BREAK = {};
  var RETURN = {};
  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
    var f = _ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
      result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = _iterCall(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };
  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
  });

  // 7.3.20 SpeciesConstructor(O, defaultConstructor)


  var SPECIES = _wks('species');
  var _speciesConstructor = function (O, D) {
    var C = _anObject(O).constructor;
    var S;
    return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
  };

  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  var _invoke = function (fn, args, that) {
    var un = that === undefined;
    switch (args.length) {
      case 0: return un ? fn()
                        : fn.call(that);
      case 1: return un ? fn(args[0])
                        : fn.call(that, args[0]);
      case 2: return un ? fn(args[0], args[1])
                        : fn.call(that, args[0], args[1]);
      case 3: return un ? fn(args[0], args[1], args[2])
                        : fn.call(that, args[0], args[1], args[2]);
      case 4: return un ? fn(args[0], args[1], args[2], args[3])
                        : fn.call(that, args[0], args[1], args[2], args[3]);
    } return fn.apply(that, args);
  };

  var process = _global.process;
  var setTask = _global.setImmediate;
  var clearTask = _global.clearImmediate;
  var MessageChannel = _global.MessageChannel;
  var Dispatch = _global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer, channel, port;
  var run = function () {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };
  var listener = function (event) {
    run.call(event.data);
  };
  // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;
      while (arguments.length > i) args.push(arguments[i++]);
      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        _invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };
      defer(counter);
      return counter;
    };
    clearTask = function clearImmediate(id) {
      delete queue[id];
    };
    // Node.js 0.8-
    if (_cof(process) == 'process') {
      defer = function (id) {
        process.nextTick(_ctx(run, id, 1));
      };
    // Sphere (JS game engine) Dispatch API
    } else if (Dispatch && Dispatch.now) {
      defer = function (id) {
        Dispatch.now(_ctx(run, id, 1));
      };
    // Browsers with MessageChannel, includes WebWorkers
    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = _ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
      defer = function (id) {
        _global.postMessage(id + '', '*');
      };
      _global.addEventListener('message', listener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in _domCreate('script')) {
      defer = function (id) {
        _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
          _html.removeChild(this);
          run.call(id);
        };
      };
    // Rest old browsers
    } else {
      defer = function (id) {
        setTimeout(_ctx(run, id, 1), 0);
      };
    }
  }
  var _task = {
    set: setTask,
    clear: clearTask
  };

  var macrotask = _task.set;
  var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
  var process$1 = _global.process;
  var Promise$1 = _global.Promise;
  var isNode$1 = _cof(process$1) == 'process';

  var _microtask = function () {
    var head, last, notify;

    var flush = function () {
      var parent, fn;
      if (isNode$1 && (parent = process$1.domain)) parent.exit();
      while (head) {
        fn = head.fn;
        head = head.next;
        try {
          fn();
        } catch (e) {
          if (head) notify();
          else last = undefined;
          throw e;
        }
      } last = undefined;
      if (parent) parent.enter();
    };

    // Node.js
    if (isNode$1) {
      notify = function () {
        process$1.nextTick(flush);
      };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
    } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode('');
      new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
      notify = function () {
        node.data = toggle = !toggle;
      };
    // environments with maybe non-completely correct, but existent Promise
    } else if (Promise$1 && Promise$1.resolve) {
      // Promise.resolve without an argument throws an error in LG WebOS 2
      var promise = Promise$1.resolve(undefined);
      notify = function () {
        promise.then(flush);
      };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else {
      notify = function () {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(_global, flush);
      };
    }

    return function (fn) {
      var task = { fn: fn, next: undefined };
      if (last) last.next = task;
      if (!head) {
        head = task;
        notify();
      } last = task;
    };
  };

  // 25.4.1.5 NewPromiseCapability(C)


  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = _aFunction(resolve);
    this.reject = _aFunction(reject);
  }

  var f$7 = function (C) {
    return new PromiseCapability(C);
  };

  var _newPromiseCapability = {
  	f: f$7
  };

  var _perform = function (exec) {
    try {
      return { e: false, v: exec() };
    } catch (e) {
      return { e: true, v: e };
    }
  };

  var navigator$1 = _global.navigator;

  var _userAgent = navigator$1 && navigator$1.userAgent || '';

  var _promiseResolve = function (C, x) {
    _anObject(C);
    if (_isObject(x) && x.constructor === C) return x;
    var promiseCapability = _newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };

  var _redefineAll = function (target, src, safe) {
    for (var key in src) {
      if (safe && target[key]) target[key] = src[key];
      else _hide(target, key, src[key]);
    } return target;
  };

  var SPECIES$1 = _wks('species');

  var _setSpecies = function (KEY) {
    var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
    if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  };

  var task = _task.set;
  var microtask = _microtask();




  var PROMISE = 'Promise';
  var TypeError$1 = _global.TypeError;
  var process$2 = _global.process;
  var versions = process$2 && process$2.versions;
  var v8 = versions && versions.v8 || '';
  var $Promise = _global[PROMISE];
  var isNode$2 = _classof(process$2) == 'process';
  var empty = function () { /* empty */ };
  var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

  var USE_NATIVE$1 = !!function () {
    try {
      // correct subclassing with @@species support
      var promise = $Promise.resolve(1);
      var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
        exec(empty, empty);
      };
      // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
      return (isNode$2 || typeof PromiseRejectionEvent == 'function')
        && promise.then(empty) instanceof FakePromise
        // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
        // we can't detect it synchronously, so just check versions
        && v8.indexOf('6.6') !== 0
        && _userAgent.indexOf('Chrome/66') === -1;
    } catch (e) { /* empty */ }
  }();

  // helpers
  var isThenable = function (it) {
    var then;
    return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };
  var notify = function (promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;
      var run = function (reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;
        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }
            if (handler === true) result = value;
            else {
              if (domain) domain.enter();
              result = handler(value); // may throw
              if (domain) {
                domain.exit();
                exited = true;
              }
            }
            if (result === reaction.promise) {
              reject(TypeError$1('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          if (domain && !exited) domain.exit();
          reject(e);
        }
      };
      while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };
  var onUnhandled = function (promise) {
    task.call(_global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;
      if (unhandled) {
        result = _perform(function () {
          if (isNode$2) {
            process$2.emit('unhandledRejection', value, promise);
          } else if (handler = _global.onunhandledrejection) {
            handler({ promise: promise, reason: value });
          } else if ((console = _global.console) && console.error) {
            console.error('Unhandled promise rejection', value);
          }
        });
        // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
        promise._h = isNode$2 || isUnhandled(promise) ? 2 : 1;
      } promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };
  var isUnhandled = function (promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };
  var onHandleUnhandled = function (promise) {
    task.call(_global, function () {
      var handler;
      if (isNode$2) {
        process$2.emit('rejectionHandled', promise);
      } else if (handler = _global.onrejectionhandled) {
        handler({ promise: promise, reason: promise._v });
      }
    });
  };
  var $reject = function (value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };
  var $resolve = function (value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
      if (promise === value) throw TypeError$1("Promise can't be resolved itself");
      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = { _w: promise, _d: false }; // wrap
          try {
            then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({ _w: promise, _d: false }, e); // wrap
    }
  };

  // constructor polyfill
  if (!USE_NATIVE$1) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
      _anInstance(this, $Promise, PROMISE, '_h');
      _aFunction(executor);
      Internal.call(this);
      try {
        executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    };
    // eslint-disable-next-line no-unused-vars
    Internal = function Promise(executor) {
      this._c = [];             // <- awaiting reactions
      this._a = undefined;      // <- checked in isUnhandled reactions
      this._s = 0;              // <- state
      this._d = false;          // <- done
      this._v = undefined;      // <- value
      this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
      this._n = false;          // <- notify
    };
    Internal.prototype = _redefineAll($Promise.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = isNode$2 ? process$2.domain : undefined;
        this._c.push(reaction);
        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function (onRejected) {
        return this.then(undefined, onRejected);
      }
    });
    OwnPromiseCapability = function () {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = _ctx($resolve, promise, 1);
      this.reject = _ctx($reject, promise, 1);
    };
    _newPromiseCapability.f = newPromiseCapability = function (C) {
      return C === $Promise || C === Wrapper
        ? new OwnPromiseCapability(C)
        : newGenericPromiseCapability(C);
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
  _setToStringTag($Promise, PROMISE);
  _setSpecies(PROMISE);
  Wrapper = _core[PROMISE];

  // statics
  _export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  _export(_export.S + _export.F * (_library || !USE_NATIVE$1), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
      return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
    }
  });
  _export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
    $Promise.all(iter)['catch'](empty);
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = _perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        _forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = _perform(function () {
        _forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });

  _export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
    var C = _speciesConstructor(this, _core.Promise || _global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return _promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return _promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  } });

  // https://github.com/tc39/proposal-promise-try




  _export(_export.S, 'Promise', { 'try': function (callbackfn) {
    var promiseCapability = _newPromiseCapability.f(this);
    var result = _perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

  var promise = _core.Promise;

  var promise$1 = createCommonjsModule(function (module) {
  module.exports = { "default": promise, __esModule: true };
  });

  var _Promise = unwrapExports(promise$1);

  // **********************  judgement   ************************
  /**
   * check if the code running in browser environment (not include worker env)
   * @returns {Boolean}
   */
  var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

  // **********************  对象操作  ************************
  /**
   * 转变一个类数组对象为数组
   */
  function makeArray(obj) {
    return _Array$from(obj);
  }

  /**
   * sort Object attributes by function
   * and transfer them into array
   * @param  {Object} obj Object form from numric
   * @param  {Function} fn sort function
   * @return {Array} the sorted attirbutes array
   */
  function transObjectAttrIntoArray(obj) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
      return +a - +b;
    };

    return _Object$keys(obj).sort(fn).reduce(function (order, key) {
      return order.concat(obj[key]);
    }, []);
  }
  /**
   * run a queue one by one.If include function reject or return false it will stop
   * @param  {Array} queue the queue which we want to run one by one
   * @return {Promise}    tell us whether a queue run finished
   */
  function runRejectableQueue(queue) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return new _Promise(function (resolve, reject) {
      var step = function step(index) {
        if (index >= queue.length) {
          resolve();
          return;
        }
        var result = isFunction(queue[index]) ? queue[index].apply(queue, _toConsumableArray(args)) : queue[index];
        if (result === false) return reject('stop');
        return _Promise.resolve(result).then(function () {
          return step(index + 1);
        }).catch(function (err) {
          return reject(err || 'stop');
        });
      };
      step(0);
    });
  }
  /**
   * run a queue one by one.If include function return false it will stop
   * @param  {Array} queue the queue which we want to run one by one
   * @return {boolean} tell the user if the queue run finished
   */
  function runStoppableQueue(queue) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var step = function step(index) {
      if (index >= queue.length) {
        return true;
      }
      var result = isFunction(queue[index]) ? queue[index].apply(queue, _toConsumableArray(args)) : queue[index];
      if (result === false) return false;
      return step(++index);
    };
    return step(0);
  }

  // requestAnimationFrame
  var raf = inBrowser && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame) || function (cb) {
    return setTimeout(cb, 17);
  };

  // cancelAnimationFrame
  var caf = inBrowser && (window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.msCancelAnimationFrame || window.oCancelAnimationFrame) || function (id) {
    clearTimeout(id);
  };

  // 根据要求的位数，将9格式化为 09\009\0009...
  function strRepeat(num, bit) {
    var pBit = bit;
    num = '' + (num || '');
    var numLen = num.length;
    bit = (bit || numLen) - numLen;
    var paddingStr = bit > 0 ? num.repeat ? '0'.repeat(bit) : new Array(bit + 1).join('0') : '';
    return (paddingStr + num).slice(0, pBit);
  }

  // video 时间格式化
  function formatTime(time) {
    var hh = Math.floor(time / 3600);
    time = Math.floor(time % 3600);
    var mm = strRepeat(Math.floor(time / 60), 2);
    time = Math.floor(time % 60);
    var ss = strRepeat(time, 2);
    return hh >= 1 ? hh + ':' + mm + ':' + ss : mm + ':' + ss;
  }

  /**
   * 格式化日期对象为：年-月-日 时:分:秒.毫秒
   * @param {Date} date Date日期对象
   * @param {String} pattern 要输出的日期格式，默认：`yyyy-MM-dd hh:mm:ss.i`
   * @return {String}
   */
  function formatDate() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss.i';

    var year = date.getFullYear().toString();
    var fields = {
      M: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds(),
      i: date.getMilliseconds()
    };
    pattern = pattern.replace(/(y+)/ig, function (_, yearPattern) {
      return year.substr(4 - Math.min(4, yearPattern.length));
    });

    var _loop = function _loop(i) {
      pattern = pattern.replace(new RegExp('(' + i + '+)', 'g'), function (_, pattStr) {
        return (fields[i] < 10 && pattStr.length > 1 ? '0' : '') + fields[i];
      });
    };

    for (var i in fields) {
      _loop(i);
    }
    return pattern;
  }

  /**
   * 读取本地存储的值（不支持localStorage则降级到cookie）
   * @param {String} key 目标数据key
   * @return {String}
   */
  function getLocalStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      try {
        var regRt = document.cookie.match(new RegExp('(^| )' + key + '=([^;]*)(;|$)'));
        return isArray(regRt) ? unescape(regRt[2]) : '';
      } catch (e) {
        return '';
      }
    }
  }
  /**
   * 将指定key对应值写入本地存储（不支持localStorage则降级到cookie）
   * @param {String} key
   * @param {String} val
   * @return {String}
   */
  function setLocalStorage(key, val) {
    try {
      window.localStorage.setItem(key, val);
    } catch (e) {
      var expires = new Date();
      // 默认存储300天
      expires.setTime(expires.getTime() + 24 * 3600 * 1000 * 300);
      try {
        document.cookie = key + '=' + escape(val) + ';expires=' + expires.toUTCString() + ';path=/;';
      } catch (e) {
        console.error(e);
      }
    }
  }

  // 19.1.2.1 Object.assign(target, source, ...)






  var $assign = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  var _objectAssign = !$assign || _fails(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) { // eslint-disable-line no-unused-vars
    var T = _toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = _objectGops.f;
    var isEnum = _objectPie.f;
    while (aLen > index) {
      var S = _iobject(arguments[index++]);
      var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) {
        key = keys[j++];
        if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
      }
    } return T;
  } : $assign;

  // 19.1.3.1 Object.assign(target, source)


  _export(_export.S + _export.F, 'Object', { assign: _objectAssign });

  var assign = _core.Object.assign;

  var assign$1 = createCommonjsModule(function (module) {
  module.exports = { "default": assign, __esModule: true };
  });

  var _Object$assign = unwrapExports(assign$1);

  /**
  * @module event
  * @author huzunjie
  * @description 自定义事件基础类
  */

  /* 缓存事件监听方法及包装，内部数据格式：
   * targetIndex_<type:'click|mouseup|done'>: [ [
   *   function(){ ... handler ... },
   *   function(){ ... handlerWrap ... handler.apply(target, arguments) ... },
   *   isOnce
   * ]]
   */
  var _evtListenerCache = _Object$create(null);
  _evtListenerCache.count = 0;

  /**
   * 得到某对象的某事件类型对应的监听队列数组
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型(这里的时间类型不只是名称，还是缓存标识，可以通过添加后缀来区分)
   * @return {Array}
   */
  function getEvtTypeCache(target, type) {

    var evtId = target.__evt_id;
    if (!evtId) {

      /* 设置__evt_id不可枚举 */
      Object.defineProperty(target, '__evt_id', {
        writable: true,
        enumerable: false,
        configurable: true
      });

      /* 空对象初始化绑定索引 */
      evtId = target.__evt_id = ++_evtListenerCache.count;
    }

    var typeCacheKey = evtId + '_' + type;
    var evtTypeCache = _evtListenerCache[typeCacheKey];
    if (!evtTypeCache) {
      evtTypeCache = _evtListenerCache[typeCacheKey] = [];
    }

    return evtTypeCache;
  }

  /**
   * 触发事件监听方法
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Object} eventObj 触发事件时要传回的event对象
   * @return {undefined}
   */
  function emitEventCache(target, type, eventObj) {
    var evt = _Object$create(null);
    evt.type = type;
    evt.target = target;
    if (eventObj) {
      _Object$assign(evt, isObject(eventObj) ? eventObj : { data: eventObj });
    }
    getEvtTypeCache(target, type).forEach(function (item) {
      (item[1] || item[0]).apply(target, [evt]);
    });
  }

  /**
   * 添加事件监听到缓存
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @param {Boolean} isOnce 是否单次执行
   * @param {Function} handlerWrap
   * @return {undefined}
   */
  function addEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var handlerWrap = arguments[4];

    if (isFunction(isOnce) && !handlerWrap) {
      handlerWrap = isOnce;
      isOnce = undefined;
    }
    var handlers = [handler, undefined, isOnce];
    if (isOnce && !handlerWrap) {
      handlerWrap = function handlerWrap() {
        removeEventCache(target, type, handler, isOnce);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(target, args);
      };
    }
    if (handlerWrap) {
      handlers[1] = handlerWrap;
    }
    getEvtTypeCache(target, type).push(handlers);
  }

  /**
   * 移除事件监听
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @return {undefined}
   */
  function removeEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var typeCache = getEvtTypeCache(target, type);

    if (handler || isOnce) {
      /* 有指定 handler 则清除对应监听 */
      var handlerId = -1;
      var handlerWrap = void 0;
      typeCache.find(function (item, i) {
        if ((!handler || item[0] === handler) && (!isOnce || item[2])) {
          handlerId = i;
          handlerWrap = item[1];
          return true;
        }
      });
      if (handlerId !== -1) {
        typeCache.splice(handlerId, 1);
      }
      return handlerWrap;
    } else {
      /* 未指定 handler 则清除type对应的所有监听 */
      typeCache.length = 0;
    }
  }

  /**
   * @class CustEvent
   * @description
   * Event 自定义事件类
   * 1. 可以使用不传参得到的实例作为eventBus使用
   * 2. 可以通过指定target，用多个实例操作同一target对象的事件管理
   * 3. 当设定target时，可以通过设置assign为true，来给target实现"on\once\off\emit"方法
   * @param  {Object}  target 发生事件的对象（空则默认为event实例）
   * @param  {Boolean}  assign 是否将"on\once\off\emit"方法实现到target对象上
   * @return {event}
   */
  var CustEvent = function () {
    function CustEvent(target, assign) {
      var _this = this;

      _classCallCheck$1(this, CustEvent);

      /* 设置__target不可枚举 */
      Object.defineProperty(this, '__target', {
        writable: true,
        enumerable: false,
        configurable: true
      });
      this.__target = this;

      if (target) {

        if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
          throw new Error('CusEvent target are not object');
        }
        this.__target = target;

        /* 为target实现on\once\off\emit */
        if (assign) {
          ['on', 'once', 'off', 'emit'].forEach(function (mth) {
            target[mth] = _this[mth];
          });
        }
      }
    }

    /**
     * 添加事件监听
     * @param {String} type 事件类型
     * @param {Function} handler 监听函数
     * @param {Boolean} isOnce 单次监听类型
     * @return {event}
     */


    _createClass(CustEvent, [{
      key: 'on',
      value: function on(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        addEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 添加事件监听,并且只执行一次
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数
       * @return {event}
       */

    }, {
      key: 'once',
      value: function once(type, handler) {
        return this.on(type, handler, true);
      }

      /**
       * 移除事件监听
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数(不指定handler则清除type对应的所有事件监听)
       * @param {Boolean} isOnce 单次监听类型
       * @return {event}
       */

    }, {
      key: 'off',
      value: function off(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        removeEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 触发事件监听函数
       * @param {String} type 事件类型
       * @return {event}
       */

    }, {
      key: 'emit',
      value: function emit(type, data) {
        emitEventCache(this.__target, type, { data: data });
        return this;
      }
    }]);

    return CustEvent;
  }();

  /**
   * @module dom
   * @author huzunjie
   * @description 一些常用的DOM判断及操作方法，可以使用dom.$('*')包装DOM，实现类jQuery的链式操作；当然这里的静态方法也可以直接使用。
   */

  var _divEl = inBrowser ? document.createElement('div') : {};
  var _textAttrName = 'innerText';
  'textContent' in _divEl && (_textAttrName = 'textContent');
  var _arrPrototype = Array.prototype;

  /**
   * 读取HTML元素属性值
   * @param {HTMLElement} el 目标元素
   * @param {String} attrName 目标属性名称
   * @return {String}
   */
  function getAttr(el, attrName) {
    return el.getAttribute(attrName);
  }

  /**
   * 设置HTML元素属性值
   * @param {HTMLElement} el 目标元素
   * @param {String} attrName 目标属性名称
   * @param {String} attrVal 目标属性值
   */
  function setAttr(el, attrName, attrVal) {
    if (attrVal === undefined) {
      el.removeAttribute(attrName);
    } else {
      el.setAttribute(attrName, attrVal);
    }
  }

  /**
   * 为HTML元素添加className
   * @param {HTMLElement} el 目标元素
   * @param {String} cls 要添加的className（多个以空格分割）
   */
  function addClassName(el, cls) {
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    var clsArr = cls.split(/\s+/);
    if (el.classList) {
      clsArr.forEach(function (c) {
        return el.classList.add(c);
      });
    } else {
      var curCls = ' ' + (el.className || '') + ' ';
      clsArr.forEach(function (c) {
        curCls.indexOf(' ' + c + ' ') === -1 && (curCls += ' ' + c);
      });
      el.className = curCls.trim();
    }
  }

  /**
   * 为HTML元素移除className
   * @param {HTMLElement} el 目标元素
   * @param {String} cls 要移除的className（多个以空格分割）
   */
  function removeClassName(el, cls) {
    if (!cls || !(cls = cls.trim())) {
      return;
    }

    var clsArr = cls.split(/\s+/);
    if (el.classList) {
      clsArr.forEach(function (c) {
        return el.classList.remove(c);
      });
    } else {
      var curCls = ' ' + el.className + ' ';
      clsArr.forEach(function (c) {
        var tar = ' ' + c + ' ';
        while (curCls.indexOf(tar) !== -1) {
          curCls = curCls.replace(tar, ' ');
        }
      });
      el.className = curCls.trim();
    }
  }

  /**
   * 检查HTML元素是否已设置className
   * @param {HTMLElement} el 目标元素
   * @param {String} className 要检查的className
   * @return {Boolean}
   */
  function hasClassName(el, className) {
    return new RegExp('(?:^|\\s)' + className + '(?=\\s|$)').test(el.className);
  }

  /**
   * addEventListener 是否已支持 passive
   * @return {Boolean}
   */
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    if (inBrowser) window.addEventListener('test', null, opts);
  } catch (e) {
    console.error(e);
  }

  /**
   * 为HTML元素移除事件监听
   * @param {HTMLElement} el 目标元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} once 是否只监听一次
   * @param {Boolean} capture 是否在捕获阶段的监听
   */
  function removeEvent(el, type, handler) {
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && supportsPassive) {
      capture = { passive: true };
    }
    if (once) {
      /* 尝试从缓存中读取包装后的方法 */
      var handlerWrap = removeEventCache(el, type + '_once', handler);
      if (handlerWrap) {
        handler = handlerWrap;
      }
    }
    el.removeEventListener(type, handler, capture);
  }

  /**
   * 为HTML元素添加事件监听
   * @param {HTMLElement} el 目标元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} once 是否只监听一次
   * @param {Boolean|Object} capture 是否在捕获阶段监听，这里也可以传入 { passive: true } 表示被动模式
   */
  function addEvent(el, type, handler) {
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && supportsPassive) {
      capture = { passive: true };
    }
    if (once) {
      var oldHandler = handler;
      handler = function () {
        return function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          oldHandler.apply(this, args);
          removeEvent(el, type, handler, once, capture);
        };
      }();
      /* 将包装后的方法记录到缓存中 */
      addEventCache(el, type + '_once', oldHandler, handler);
    }

    el.addEventListener(type, handler, capture);
  }

  /**
   * 为HTML元素添加事件代理
   * @param {HTMLElement} el 目标元素
   * @param {String} selector 要被代理的元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} capture 是否在捕获阶段监听
   */
  function addDelegate(el, selector, type, handler) {
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && supportsPassive) {
      capture = { passive: true };
    }
    var handlerWrap = function handlerWrap(e) {
      var targetElsArr = findParents(e.target || e.srcElement, el, true);
      var targetElArr = query(selector, el, true);
      var retEl = void 0;
      if (targetElArr.find) {
        retEl = targetElArr.find(function (seEl) {
          return targetElsArr.find(function (tgEl) {
            return seEl === tgEl;
          });
        });
      } else {
        // Fixed IE11 Array.find not defined bug
        targetElArr.forEach(function (seEl) {
          return !retEl && targetElsArr.forEach(function (tgEl) {
            if (!retEl && seEl === tgEl) {
              retEl = tgEl;
            }
          });
        });
      }
      retEl && handler.apply(retEl, arguments);
    };
    /* 将包装后的方法记录到缓存中 */
    addEventCache(el, type + '_delegate_' + selector, handler, handlerWrap);
    el.addEventListener(type, handlerWrap, capture);
  }

  /**
   * 为HTML元素移除事件代理
   * @param {HTMLElement} el 目标元素
   * @param {String} selector 要被代理的元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} capture 是否在捕获阶段监听
   */
  function removeDelegate(el, selector, type, handler) {
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && supportsPassive) {
      capture = { passive: true };
    }
    /* 尝试从缓存中读取包装后的方法 */
    var handlerWrap = removeEventCache(el, type + '_delegate_' + selector, handler);
    handlerWrap && el.removeEventListener(type, handlerWrap, capture);
  }

  /**
   * 读取HTML元素样式值
   * @param {HTMLElement} el 目标元素
   * @param {String} key 样式key
   * @return {String}
   */
  function getStyle(el, key) {
    return (el.currentStyle || document.defaultView.getComputedStyle(el, null))[key] || el.style[key];
  }

  /**
   * 设置HTML元素样式值
   * @param {HTMLElement} el 目标元素
   * @param {String} key 样式key
   * @param {String} val 样式值
   */
  function setStyle(el, key, val) {
    if (isObject(key)) {
      for (var k in key) {
        setStyle(el, k, key[k]);
      }
    } else {
      el.style[key] = val;
    }
  }

  /**
   * 根据选择器查询目标元素
   * @param {String} selector 选择器,用于 querySelectorAll
   * @param {HTMLElement} container 父容器
   * @param {Boolean} toArray 强制输出为数组
   * @return {NodeList|Array}
   */
  function query(selector) {
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    var toArray = arguments[2];

    var retNodeList = container.querySelectorAll(selector);
    return toArray ? _Array$from(retNodeList) : retNodeList;
  }

  /**
   * 从DOM树中移除el
   * @param {HTMLElement} el 目标元素
   */
  function removeEl(el) {
    el.parentNode.removeChild(el);
  }

  /**
   * 查找元素的父节点们
   * @param {HTMLElement} el 目标元素
   * @param {HTMLElement} endEl 最大父容器（不指定则找到html）
   * @param {Boolean} haveEl 包含当前元素
   * @param {Boolean} haveEndEl 包含设定的最大父容器
   */
  function findParents(el) {
    var endEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var haveEl = arguments[2];
    var haveEndEl = arguments[3];

    var retEls = [];
    if (haveEl) {
      retEls.push(el);
    }
    while (el && el.parentNode !== endEl) {
      el = el.parentNode;
      el && retEls.push(el);
    }
    if (haveEndEl) {
      retEls.push(endEl);
    }
    return retEls;
  }

  /**
   * @class NodeWrap
   * @description
   * NodeWrap DOM包装器，用以实现基本的链式操作
   * new dom.NodeWrap('*') 相当于 dom.$('*')
   * 这里面用于DOM操作的属性方法都是基于上面静态方法实现，有需要可以随时修改补充
   * @param {String} selector 选择器(兼容 String||HTMLString||NodeList||NodeArray||HTMLElement)
   * @param {HTMLElement} container 父容器（默认为document）
   */

  var NodeWrap = function () {
    function NodeWrap(selector) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

      _classCallCheck$1(this, NodeWrap);

      var _this = this;
      _this.selector = selector;

      /* String||NodeList||HTMLElement 识别处理 */
      var elsArr = void 0;
      if (selector && selector.constructor === NodeList) {
        /* 支持直接传入NodeList来构建包装器 */
        elsArr = makeArray(selector);
      } else if (isArray(selector)) {
        /* 支持直接传入Node数组来构建包装器 */
        elsArr = selector;
      } else if (isString(selector)) {
        if (selector.indexOf('<') === 0) {
          /* 支持直接传入HTML字符串来新建DOM并构建包装器 */
          _divEl.innerHTML = selector;
          elsArr = query('*', _divEl, true);
        } else {
          /* 支持直接传入字符串选择器来查找DOM并构建包装器 */
          elsArr = query(selector, container, true);
        }
      } else {
        /* 其他任意对象直接构建包装器 */
        elsArr = [selector];
      }
      _Object$assign(_this, elsArr);

      /* NodeWrap本意可以 extends Array省略构造方法中下面这部分代码，但目前编译不支持 */
      _this.length = elsArr.length;
    }

    /**
     * 循环遍历DOM集合
     * @param {Function} fn 遍历函数 fn(item, i)
     * @return {Object}
     */


    _createClass(NodeWrap, [{
      key: 'each',
      value: function each() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _arrPrototype.forEach.apply(this, args);
        return this;
      }

      /**
       * 添加元素到DOM集合
       * @param {HTMLElement} el 要加入的元素
       * @return {this}
       */

    }, {
      key: 'push',
      value: function push() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _arrPrototype.push.apply(this, args);
        return this;
      }

      /**
       * 截取DOM集合片段，并得到新的包装器splice
       * @param {Nubmer} start
       * @param {Nubmer} count
       * @return {NodeWrap} 新的DOM集合包装器
       */

    }, {
      key: 'splice',
      value: function splice() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return $(_arrPrototype.splice.apply(this, args));
      }

      /**
       * 查找子元素
       * @param {String} selector 选择器
       * @return {NodeWrap} 新的DOM集合包装器
       */

    }, {
      key: 'find',
      value: function find(selector) {
        var childs = [];
        this.each(function (el) {
          childs = childs.concat(query(selector, el, true));
        });
        var childsWrap = $(childs);
        childsWrap.parent = this;
        childsWrap.selector = selector;
        return childsWrap;
      }

      /**
       * 添加子元素
       * @param {HTMLElement} childEls 要添加的HTML元素
       * @return {this}
       */

    }, {
      key: 'append',
      value: function append(childEls) {
        var childsWrap = $(childEls);
        var firstEl = this[0];
        childsWrap.each(function (newEl) {
          return firstEl.appendChild(newEl);
        });
        return this;
      }

      /**
       * 将元素集合添加到指定容器
       * @param {HTMLElement} parentEl 要添加到父容器
       * @return {this}
       */

    }, {
      key: 'appendTo',
      value: function appendTo(parentEl) {
        $(parentEl).append(this);
        return this;
      }

      /**
       * DOM集合text内容读写操作
       * @param {String} val 文本内容（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'text',
      value: function text(val) {
        if (arguments.length === 0) {
          return this[0][_textAttrName];
        }
        return this.each(function (el) {
          el[_textAttrName] = val;
        });
      }

      /**
       * DOM集合HTML内容读写操作
       * @param {String} html html内容（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'html',
      value: function html(_html) {
        if (arguments.length === 0) {
          return this[0].innerHTML;
        }
        return this.each(function (el) {
          el.innerHTML = _html;
        });
      }

      /**
       * DOM集合属性读写操作
       * @param {String} name 属性名称
       * @param {String} val 属性值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'attr',
      value: function attr(name, val) {
        if (arguments.length === 1) {
          return getAttr(this[0], name);
        }
        return this.each(function (el) {
          return setAttr(el, name, val);
        });
      }

      /**
       * DOM集合dataset读写操作
       * @param {String} key 键名
       * @param {Any} val 键值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'data',
      value: function data(key, val) {
        if (arguments.length === 0) {
          return this[0].dataset || {};
        }
        if (arguments.length === 1) {
          return (this[0].dataset || {})[key];
        }
        return this.each(function (el) {
          (el.dataset || (el.dataset = {}))[key] = val;
        });
      }

      /**
       * DOM集合样式读写操作
       * @param {String} key 样式key
       * @param {String} val 样式值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'css',
      value: function css(key, val) {
        if (arguments.length === 1 && !isObject(key)) {
          return getStyle(this[0], key);
        }
        return this.each(function (el) {
          return setStyle(el, key, val);
        });
      }

      /**
       * 为DOM集合增加className
       * @param {String} cls 要增加的className
       * @return {this}
       */

    }, {
      key: 'addClass',
      value: function addClass(cls) {
        return this.each(function (el) {
          return addClassName(el, cls);
        });
      }

      /**
       * 移除当前DOM集合的className
       * @param {String} cls 要移除的className
       * @return {this}
       */

    }, {
      key: 'removeClass',
      value: function removeClass(cls) {
        return this.each(function (el) {
          return removeClassName(el, cls);
        });
      }

      /**
       * 检查索引0的DOM是否有className
       * @param {String} cls 要检查的className
       * @return {this}
       */

    }, {
      key: 'hasClass',
      value: function hasClass(cls) {
        return hasClassName(this[0], cls);
      }

      /**
       * 为DOM集合添加事件监听
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} once 是否只监听一次
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'on',
      value: function on(type, handler) {
        var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return addEvent(el, type, handler, once, capture);
        });
      }

      /**
       * 为DOM集合解除事件监听
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} once 是否只监听一次
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'off',
      value: function off(type, handler) {
        var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return removeEvent(el, type, handler, once, capture);
        });
      }

      /**
       * 为DOM集合绑定事件代理
       * @param {String} selector 目标子元素选择器
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'delegate',
      value: function delegate(selector, type, handler) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return addDelegate(el, selector, type, handler, capture);
        });
      }

      /**
       * 为DOM集合解绑事件代理
       * @param {String} selector 目标子元素选择器
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'undelegate',
      value: function undelegate(selector, type, handler) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return removeDelegate(el, selector, type, handler, capture);
        });
      }

      /**
       * 从DOM树中移除
       * @return {this}
       */

    }, {
      key: 'remove',
      value: function remove() {
        return this.each(function (el) {
          return removeEl(el);
        });
      }
    }]);

    return NodeWrap;
  }();

  function $(selector, container) {
    return selector.constructor === NodeWrap ? selector : new NodeWrap(selector, container);
  }

  // 20.1.2.4 Number.isNaN(number)


  _export(_export.S, 'Number', {
    isNaN: function isNaN(number) {
      // eslint-disable-next-line no-self-compare
      return number != number;
    }
  });

  var isNan = _core.Number.isNaN;

  var isNan$1 = createCommonjsModule(function (module) {
  module.exports = { "default": isNan, __esModule: true };
  });

  var _Number$isNaN = unwrapExports(isNan$1);

  // all object keys, includes non-enumerable and symbols



  var Reflect$1 = _global.Reflect;
  var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
    var keys = _objectGopn.f(_anObject(it));
    var getSymbols = _objectGops.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
  };

  // https://github.com/tc39/proposal-object-getownpropertydescriptors






  _export(_export.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
      var O = _toIobject(object);
      var getDesc = _objectGopd.f;
      var keys = _ownKeys(O);
      var result = {};
      var i = 0;
      var key, desc;
      while (keys.length > i) {
        desc = getDesc(O, key = keys[i++]);
        if (desc !== undefined) _createProperty(result, key, desc);
      }
      return result;
    }
  });

  var getOwnPropertyDescriptors = _core.Object.getOwnPropertyDescriptors;

  var getOwnPropertyDescriptors$1 = createCommonjsModule(function (module) {
  module.exports = { "default": getOwnPropertyDescriptors, __esModule: true };
  });

  var _Object$getOwnPropertyDescriptors = unwrapExports(getOwnPropertyDescriptors$1);

  var getOwnPropertySymbols = _core.Object.getOwnPropertySymbols;

  var getOwnPropertySymbols$1 = createCommonjsModule(function (module) {
  module.exports = { "default": getOwnPropertySymbols, __esModule: true };
  });

  var _Object$getOwnPropertySymbols = unwrapExports(getOwnPropertySymbols$1);

  // 19.1.2.7 Object.getOwnPropertyNames(O)
  _objectSap('getOwnPropertyNames', function () {
    return _objectGopnExt.f;
  });

  var $Object$2 = _core.Object;
  var getOwnPropertyNames = function getOwnPropertyNames(it) {
    return $Object$2.getOwnPropertyNames(it);
  };

  var getOwnPropertyNames$1 = createCommonjsModule(function (module) {
  module.exports = { "default": getOwnPropertyNames, __esModule: true };
  });

  var _Object$getOwnPropertyNames = unwrapExports(getOwnPropertyNames$1);

  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

  var $getOwnPropertyDescriptor$1 = _objectGopd.f;

  _objectSap('getOwnPropertyDescriptor', function () {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor$1(_toIobject(it), key);
    };
  });

  var $Object$3 = _core.Object;
  var getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    return $Object$3.getOwnPropertyDescriptor(it, key);
  };

  var getOwnPropertyDescriptor$1 = createCommonjsModule(function (module) {
  module.exports = { "default": getOwnPropertyDescriptor, __esModule: true };
  });

  var _Object$getOwnPropertyDescriptor = unwrapExports(getOwnPropertyDescriptor$1);

  /**
   * bind the function with some context. we have some fallback strategy here
   * @param {function} fn the function which we need to bind the context on
   * @param {any} context the context object
   */
  function bind$1(fn, context) {
    if (fn.bind) {
      return fn.bind(context);
    } else if (fn.apply) {
      return function __autobind__() {
        for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return fn.apply(context, args);
      };
    } else {
      return function __autobind__() {
        for (var _len3 = arguments.length, args = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return fn.call.apply(fn, [context].concat(_toConsumableArray(args)));
      };
    }
  }

  /**
   * get an deep property
   */
  function getDeepProperty$1(obj, keys) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$throwError = _ref.throwError,
        throwError = _ref$throwError === undefined ? false : _ref$throwError,
        backup = _ref.backup;

    if (isString(keys)) {
      keys = keys.split('.');
    }
    if (!isArray(keys)) {
      throw new TypeError('keys of getDeepProperty must be string or Array<string>');
    }
    var read = [];
    var target = obj;
    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];
      if (isVoid(target)) {
        if (throwError) {
          throw new Error('obj' + (read.length > 0 ? '.' + read.join('.') : ' itself') + ' is ' + target);
        } else {
          return backup;
        }
      }
      target = target[key];
      read.push(key);
    }
    return target;
  }

  var ITERATOR$4 = _wks('iterator');

  var core_isIterable = _core.isIterable = function (it) {
    var O = Object(it);
    return O[ITERATOR$4] !== undefined
      || '@@iterator' in O
      // eslint-disable-next-line no-prototype-builtins
      || _iterators.hasOwnProperty(_classof(O));
  };

  var isIterable = core_isIterable;

  var isIterable$1 = createCommonjsModule(function (module) {
  module.exports = { "default": isIterable, __esModule: true };
  });

  unwrapExports(isIterable$1);

  var core_getIterator = _core.getIterator = function (it) {
    var iterFn = core_getIteratorMethod(it);
    if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
    return _anObject(iterFn.call(it));
  };

  var getIterator = core_getIterator;

  var getIterator$1 = createCommonjsModule(function (module) {
  module.exports = { "default": getIterator, __esModule: true };
  });

  var _getIterator = unwrapExports(getIterator$1);

  var slicedToArray = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _isIterable3 = _interopRequireDefault(isIterable$1);



  var _getIterator3 = _interopRequireDefault(getIterator$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if ((0, _isIterable3.default)(Object(arr))) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  });

  var _slicedToArray = unwrapExports(slicedToArray);

  var SPECIES$2 = _wks('species');

  var _arraySpeciesConstructor = function (original) {
    var C;
    if (_isArray(original)) {
      C = original.constructor;
      // cross-realm fallback
      if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
      if (_isObject(C)) {
        C = C[SPECIES$2];
        if (C === null) C = undefined;
      }
    } return C === undefined ? Array : C;
  };

  // 9.4.2.3 ArraySpeciesCreate(originalArray, length)


  var _arraySpeciesCreate = function (original, length) {
    return new (_arraySpeciesConstructor(original))(length);
  };

  // 0 -> Array#forEach
  // 1 -> Array#map
  // 2 -> Array#filter
  // 3 -> Array#some
  // 4 -> Array#every
  // 5 -> Array#find
  // 6 -> Array#findIndex





  var _arrayMethods = function (TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || _arraySpeciesCreate;
    return function ($this, callbackfn, that) {
      var O = _toObject($this);
      var self = _iobject(O);
      var f = _ctx(callbackfn, that, 3);
      var length = _toLength(self.length);
      var index = 0;
      var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var val, res;
      for (;length > index; index++) if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res;   // map
          else if (res) switch (TYPE) {
            case 3: return true;             // some
            case 5: return val;              // find
            case 6: return index;            // findIndex
            case 2: result.push(val);        // filter
          } else if (IS_EVERY) return false; // every
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
  };

  var _validateCollection = function (it, TYPE) {
    if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
  };

  var getWeak = _meta.getWeak;







  var arrayFind = _arrayMethods(5);
  var arrayFindIndex = _arrayMethods(6);
  var id$1 = 0;

  // fallback for uncaught frozen keys
  var uncaughtFrozenStore = function (that) {
    return that._l || (that._l = new UncaughtFrozenStore());
  };
  var UncaughtFrozenStore = function () {
    this.a = [];
  };
  var findUncaughtFrozen = function (store, key) {
    return arrayFind(store.a, function (it) {
      return it[0] === key;
    });
  };
  UncaughtFrozenStore.prototype = {
    get: function (key) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) return entry[1];
    },
    has: function (key) {
      return !!findUncaughtFrozen(this, key);
    },
    set: function (key, value) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) entry[1] = value;
      else this.a.push([key, value]);
    },
    'delete': function (key) {
      var index = arrayFindIndex(this.a, function (it) {
        return it[0] === key;
      });
      if (~index) this.a.splice(index, 1);
      return !!~index;
    }
  };

  var _collectionWeak = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        _anInstance(that, C, NAME, '_i');
        that._t = NAME;      // collection type
        that._i = id$1++;      // collection id
        that._l = undefined; // leak store for uncaught frozen objects
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
      });
      _redefineAll(C.prototype, {
        // 23.3.3.2 WeakMap.prototype.delete(key)
        // 23.4.3.3 WeakSet.prototype.delete(value)
        'delete': function (key) {
          if (!_isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME))['delete'](key);
          return data && _has(data, this._i) && delete data[this._i];
        },
        // 23.3.3.4 WeakMap.prototype.has(key)
        // 23.4.3.4 WeakSet.prototype.has(value)
        has: function has(key) {
          if (!_isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME)).has(key);
          return data && _has(data, this._i);
        }
      });
      return C;
    },
    def: function (that, key, value) {
      var data = getWeak(_anObject(key), true);
      if (data === true) uncaughtFrozenStore(that).set(key, value);
      else data[that._i] = value;
      return that;
    },
    ufstore: uncaughtFrozenStore
  };

  var dP$2 = _objectDp.f;
  var each = _arrayMethods(0);


  var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = _global[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    if (!_descriptors || typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
      new C().entries().next();
    }))) {
      // create collection constructor
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      _redefineAll(C.prototype, methods);
      _meta.NEED = true;
    } else {
      C = wrapper(function (target, iterable) {
        _anInstance(target, C, NAME, '_c');
        target._c = new Base();
        if (iterable != undefined) _forOf(iterable, IS_MAP, target[ADDER], target);
      });
      each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
        var IS_ADDER = KEY == 'add' || KEY == 'set';
        if (KEY in proto && !(IS_WEAK && KEY == 'clear')) _hide(C.prototype, KEY, function (a, b) {
          _anInstance(this, C, KEY);
          if (!IS_ADDER && IS_WEAK && !_isObject(a)) return KEY == 'get' ? undefined : false;
          var result = this._c[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      });
      IS_WEAK || dP$2(C.prototype, 'size', {
        get: function () {
          return this._c.size;
        }
      });
    }

    _setToStringTag(C, NAME);

    O[NAME] = C;
    _export(_export.G + _export.W + _export.F, O);

    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

    return C;
  };

  var es6_weakMap = createCommonjsModule(function (module) {

  var each = _arrayMethods(0);






  var NATIVE_WEAK_MAP = _validateCollection;
  var IS_IE11 = !_global.ActiveXObject && 'ActiveXObject' in _global;
  var WEAK_MAP = 'WeakMap';
  var getWeak = _meta.getWeak;
  var isExtensible = Object.isExtensible;
  var uncaughtFrozenStore = _collectionWeak.ufstore;
  var InternalMap;

  var wrapper = function (get) {
    return function WeakMap() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  };

  var methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
      if (_isObject(key)) {
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, WEAK_MAP)).get(key);
        return data ? data[this._i] : undefined;
      }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
      return _collectionWeak.def(_validateCollection(this, WEAK_MAP), key, value);
    }
  };

  // 23.3 WeakMap Objects
  var $WeakMap = module.exports = _collection(WEAK_MAP, wrapper, methods, _collectionWeak, true, true);

  // IE11 WeakMap frozen keys fix
  if (NATIVE_WEAK_MAP && IS_IE11) {
    InternalMap = _collectionWeak.getConstructor(wrapper, WEAK_MAP);
    _objectAssign(InternalMap.prototype, methods);
    _meta.NEED = true;
    each(['delete', 'has', 'get', 'set'], function (key) {
      var proto = $WeakMap.prototype;
      var method = proto[key];
      _redefine(proto, key, function (a, b) {
        // store frozen objects on internal weakmap shim
        if (_isObject(a) && !isExtensible(a)) {
          if (!this._f) this._f = new InternalMap();
          var result = this._f[key](a, b);
          return key == 'set' ? this : result;
        // store all the rest on native weakmap
        } return method.call(this, a, b);
      });
    });
  }
  });

  // https://tc39.github.io/proposal-setmap-offrom/


  var _setCollectionOf = function (COLLECTION) {
    _export(_export.S, COLLECTION, { of: function of() {
      var length = arguments.length;
      var A = new Array(length);
      while (length--) A[length] = arguments[length];
      return new this(A);
    } });
  };

  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
  _setCollectionOf('WeakMap');

  // https://tc39.github.io/proposal-setmap-offrom/





  var _setCollectionFrom = function (COLLECTION) {
    _export(_export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      _aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) _aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];
      if (mapping) {
        n = 0;
        cb = _ctx(mapFn, arguments[2], 2);
        _forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        _forOf(source, false, A.push, A);
      }
      return new this(A);
    } });
  };

  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
  _setCollectionFrom('WeakMap');

  var weakMap = _core.WeakMap;

  var weakMap$1 = createCommonjsModule(function (module) {
  module.exports = { "default": weakMap, __esModule: true };
  });

  var _WeakMap = unwrapExports(weakMap$1);

  var defineProperty$3 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _defineProperty2 = _interopRequireDefault(defineProperty$2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (obj, key, value) {
    if (key in obj) {
      (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };
  });

  var _defineProperty = unwrapExports(defineProperty$3);

  // 19.1.2.15 Object.preventExtensions(O)

  var meta = _meta.onFreeze;

  _objectSap('preventExtensions', function ($preventExtensions) {
    return function preventExtensions(it) {
      return $preventExtensions && _isObject(it) ? $preventExtensions(meta(it)) : it;
    };
  });

  var preventExtensions = _core.Object.preventExtensions;

  var preventExtensions$1 = createCommonjsModule(function (module) {
  module.exports = { "default": preventExtensions, __esModule: true };
  });

  unwrapExports(preventExtensions$1);

  var getOwnPropertyDescriptor$2 = _Object$getOwnPropertyDescriptor;
  // **********************  对象操作  ************************
  /**
   * sort Object attributes by function
   * and transfer them into array
   * @param  {Object} obj Object form from numric
   * @param  {Function} fn sort function
   * @return {Array} the sorted attirbutes array
   */


  /**
   * to check if an descriptor
   * @param {anything} desc
   */
  function isDescriptor(desc) {
    if (!desc || !desc.hasOwnProperty) {
      return false;
    }

    var keys = ['value', 'initializer', 'get', 'set'];

    for (var i = 0, l = keys.length; i < l; i++) {
      if (desc.hasOwnProperty(keys[i])) {
        return true;
      }
    }
    return false;
  }
  /**
   * to check if the descirptor is an accessor descriptor
   * @param {descriptor} desc it should be a descriptor better
   */
  function isAccessorDescriptor(desc) {
    return !!desc && (isFunction(desc.get) || isFunction(desc.set)) && isBoolean(desc.configurable) && isBoolean(desc.enumerable) && desc.writable === undefined;
  }
  /**
   * to check if the descirptor is an data descriptor
   * @param {descriptor} desc it should be a descriptor better
   */
  function isDataDescriptor(desc) {
    return !!desc && desc.hasOwnProperty('value') && isBoolean(desc.configurable) && isBoolean(desc.enumerable) && isBoolean(desc.writable);
  }
  /**
   * to check if the descirptor is an initiallizer descriptor
   * @param {descriptor} desc it should be a descriptor better
   */
  function isInitializerDescriptor(desc) {
    return !!desc && isFunction(desc.initializer) && isBoolean(desc.configurable) && isBoolean(desc.enumerable) && isBoolean(desc.writable);
  }
  /**
   * set one value on the object
   * @param {string} key
   */
  function createDefaultSetter(key) {
    return function set(newValue) {
      _Object$defineProperty(this, key, {
        configurable: true,
        writable: true,
        // IS enumerable when reassigned by the outside word
        enumerable: true,
        value: newValue
      });
      return newValue;
    };
  }

  /**
   * Compress many function into one function, but this function only accept one arguments;
   * @param {Array<Function>} fns the array of function we need to compress into one function
   * @param {string} errmsg When we check that there is something is not function, we will throw an error, you can set your own error message
   */
  function compressOneArgFnArray(fns) {
    var errmsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'You must pass me an array of function';

    if (!isArray(fns) || fns.length < 1) {
      throw new TypeError(errmsg);
    }
    if (fns.length === 1) {
      if (!isFunction(fns[0])) {
        throw new TypeError(errmsg);
      }
      return fns[0];
    }
    return fns.reduce(function (prev, curr) {
      if (!isFunction(curr) || !isFunction(prev)) throw new TypeError(errmsg);
      return function (value) {
        return bind$1(curr, this)(bind$1(prev, this)(value));
      };
    });
  }

  function getOwnKeysFn() {
    var getOwnPropertyNames = _Object$getOwnPropertyNames,
        getOwnPropertySymbols = _Object$getOwnPropertySymbols;

    return isFunction(getOwnPropertySymbols) ? function (obj) {
      // $FlowFixMe: do not support symwbol yet
      return _Array$from(getOwnPropertyNames(obj).concat(getOwnPropertySymbols(obj)));
    } : getOwnPropertyNames;
  }

  var getOwnKeys = getOwnKeysFn();

  function getOwnPropertyDescriptorsFn() {
    // $FlowFixMe: In some environment, Object.getOwnPropertyDescriptors has been implemented;
    return isFunction(_Object$getOwnPropertyDescriptors) ? _Object$getOwnPropertyDescriptors : function (obj) {
      return getOwnKeys(obj).reduce(function (descs, key) {
        descs[key] = getOwnPropertyDescriptor$2(obj, key);
        return descs;
      }, {});
    };
  }

  var getOwnPropertyDescriptors$2 = getOwnPropertyDescriptorsFn();

  function compressMultipleDecorators() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    if (!fns.length) throw new TypeError('You must pass in decorators in compressMultipleDecorators');
    fns.forEach(function (fn) {
      if (!isFunction(fn)) throw new TypeError('Decorators must be a function, but not "' + fn + '" in ' + (typeof fn === 'undefined' ? 'undefined' : _typeof(fn)));
    });
    if (fns.length === 1) return fns[0];
    return function (obj, prop, descirptor) {
      // $FlowFixMe: the reduce will return a descriptor
      return fns.reduce(function (descirptor, fn) {
        return fn(obj, prop, descirptor);
      }, descirptor);
    };
  }

  function accessor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        get = _ref.get,
        set = _ref.set;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$preGet = _ref2.preGet,
        preGet = _ref2$preGet === undefined ? false : _ref2$preGet,
        _ref2$preSet = _ref2.preSet,
        preSet = _ref2$preSet === undefined ? true : _ref2$preSet;

    if (!isFunction(get) && !isFunction(set) && !(isArray(get) && get.length > 0) && !(isArray(set) && set.length > 0)) throw new TypeError("@accessor need a getter or setter. If you don't need to add setter/getter. You should remove @accessor");
    var errmsg = '@accessor only accept function or array of function as getter/setter';
    get = isArray(get) ? compressOneArgFnArray(get, errmsg) : get;
    set = isArray(set) ? compressOneArgFnArray(set, errmsg) : set;
    return function (obj, prop, descriptor) {
      var _ref3 = descriptor || {},
          _ref3$configurable = _ref3.configurable,
          configurable = _ref3$configurable === undefined ? true : _ref3$configurable,
          _ref3$enumerable = _ref3.enumerable,
          enumerable = _ref3$enumerable === undefined ? true : _ref3$enumerable;

      var hasGet = isFunction(get);
      var hasSet = isFunction(set);
      var handleGet = function handleGet(value) {
        // $FlowFixMe: it's really function here
        return hasGet ? bind$1(get, this)(value) : value;
      };
      var handleSet = function handleSet(value) {
        // $FlowFixMe: it's really function here
        return hasSet ? bind$1(set, this)(value) : value;
      };
      if (isAccessorDescriptor(descriptor)) {
        var originGet = descriptor.get,
            originSet = descriptor.set;

        var hasOriginGet = isFunction(originGet);
        var hasOriginSet = isFunction(originSet);
        var getter = hasOriginGet || hasGet ? function () {
          var _this = this;

          var boundGetter = bind$1(handleGet, this);
          var originBoundGetter = function originBoundGetter() {
            return hasOriginGet
            // $FlowFixMe: we have do a check here
            ? bind$1(originGet, _this)() : undefined;
          };
          var order = preGet ? [boundGetter, originBoundGetter] : [originBoundGetter, boundGetter];
          // $FlowFixMe: it's all function here
          return order.reduce(function (value, fn) {
            return fn(value);
          }, undefined);
        } : undefined;
        var setter = hasOriginSet || hasSet ? function (val) {
          var _this2 = this;

          var boundSetter = bind$1(handleSet, this);
          var originBoundSetter = function originBoundSetter(value) {
            return hasOriginSet
            // $FlowFixMe: flow act like a retarded child on optional property
            ? bind$1(originSet, _this2)(value) : value;
          };
          var order = preSet ? [boundSetter, originBoundSetter] : [originBoundSetter, boundSetter];
          return order.reduce(function (value, fn) {
            return fn(value);
          }, val);
        } : undefined;
        return {
          get: getter,
          set: setter,
          configurable: configurable,
          enumerable: enumerable
        };
      } else if (isInitializerDescriptor(descriptor)) {
        // $FlowFixMe: disjoint union is horrible, descriptor is initializerDescriptor now
        var initializer = descriptor.initializer;

        var value = void 0;
        var inited = false;
        return {
          get: function get() {
            var boundFn = bind$1(handleGet, this);
            if (inited) return boundFn(value);
            value = bind$1(initializer, this)();
            inited = true;
            return boundFn(value);
          },
          set: function set(val) {
            var boundFn = bind$1(handleSet, this);
            value = preSet ? boundFn(val) : val;
            inited = true;
            if (!preSet) {
              boundFn(value);
            }
            return value;
          },

          configurable: configurable,
          enumerable: enumerable
        };
      } else {
        // $FlowFixMe: disjoint union is horrible, descriptor is DataDescriptor now
        var _ref4 = descriptor || {},
            _value = _ref4.value;

        return {
          get: function get() {
            return bind$1(handleGet, this)(_value);
          },
          set: function set(val) {
            var boundFn = bind$1(handleSet, this);
            _value = preSet ? boundFn(val) : val;
            if (!preSet) {
              boundFn(_value);
            }
            return _value;
          },

          configurable: configurable,
          enumerable: enumerable
        };
      }
    };
  }

  function before() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    if (fns.length === 0) throw new Error("@before accept at least one parameter. If you don't need to preprocess before your function, do not add @before decorators");
    if (fns.length > 2 && isDescriptor(fns[2])) {
      throw new Error('You may use @before straightly, @before return decorators, you should call it before you set it as decorator.');
    }
    for (var i = fns.length - 1; i > -1; i--) {
      if (!isFunction(fns[i])) throw new TypeError('@before only accept function parameter');
    }
    return function (obj, prop, descriptor) {
      var _ref = descriptor || {},
          fn = _ref.value,
          configurable = _ref.configurable,
          enumerable = _ref.enumerable,
          writable = _ref.writable;

      if (!isFunction(fn)) throw new TypeError('@before can only be used on function, please check the property "' + prop + '" is a method or not.');
      var handler = function handler() {
        var _this = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var paras = fns.reduce(function (paras, fn) {
          var result = bind$1(fn, _this).apply(undefined, _toConsumableArray(paras));
          return result === undefined ? paras : isArray(result) ? result
          // $FlowFixMe: what the hell, it can be anything
          : [result];
        }, args);
        return bind$1(fn, this).apply(undefined, _toConsumableArray(paras));
      };
      return {
        value: handler,
        configurable: configurable,
        enumerable: enumerable,
        writable: writable
      };
    };
  }

  function initialize() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    if (fns.length === 0) throw new Error("@initialize accept at least one parameter. If you don't need to initialize your value, do not add @initialize.");
    if (fns.length > 2 && isDescriptor(fns[2])) {
      throw new Error('You may use @initialize straightly, @initialize return decorators, you need to call it');
    }
    var fn = compressOneArgFnArray(fns, '@initialize only accept function parameter');
    return function (obj, prop, descriptor) {
      if (descriptor === undefined) {
        return {
          value: bind$1(fn, obj)(),
          configurable: true,
          writable: true,
          enumerable: true
        };
      }
      if (isAccessorDescriptor(descriptor)) {
        var hasBeenReset = false;
        var originSet = descriptor.set;

        return accessor({
          get: function get(value) {
            if (hasBeenReset) return value;
            return bind$1(fn, this)(value);
          },

          set: originSet ? function (value) {
            hasBeenReset = true;
            return value;
          } : undefined
        })(obj, prop, descriptor);
      }
      /**
       * when we set decorator on propery
       * we will get a descriptor with initializer
       * as they will be attach on the instance later
       * so, we need to substitute the initializer function
       */
      if (isInitializerDescriptor(descriptor)) {
        // $FlowFixMe: useless disjoint union
        var initializer = descriptor.initializer;

        var handler = function handler() {
          return bind$1(fn, this)(bind$1(initializer, this)());
        };
        return {
          initializer: handler,
          configurable: descriptor.configurable,
          // $FlowFixMe: useless disjoint union
          writable: descriptor.writable,
          enumerable: descriptor.enumerable
        };
      }
      // $FlowFixMe: useless disjoint union
      var value = bind$1(fn, this)(descriptor.value);
      return {
        value: value,
        // $FlowFixMe: useless disjoint union
        writable: descriptor.writable,
        configurable: descriptor.configurable,
        enumerable: descriptor.enumerable
      };
    };
  }

  var getOwnPropertyDescriptor$1$1 = _Object$getOwnPropertyDescriptor;
  var defineProperty$4 = _Object$defineProperty;

  function setAlias(root, prop, _ref, obj, key, _ref2) {
    var configurable = _ref.configurable,
        enumerable = _ref.enumerable;
    var force = _ref2.force,
        omit = _ref2.omit;

    var originDesc = getOwnPropertyDescriptor$1$1(obj, key);
    if (originDesc !== undefined) {
      if (omit) return;
      // TODO: we should add an github link here
      if (!force) throw new Error('"' + prop + '" is an existing property, if you want to override it, please set "force" true in @alias option.');
      if (!originDesc.configurable) {
        throw new Error('property "' + prop + '" is unconfigurable.');
      }
    }
    defineProperty$4(obj, key, {
      get: function get() {
        return root[prop];
      },
      set: function set(value) {
        root[prop] = value;
        return prop;
      },

      configurable: configurable,
      enumerable: enumerable
    });
  }
  function alias(other, key, option) {
    // set argument into right position
    if (arguments.length === 2) {
      if (isString(other)) {
        // $FlowFixMe: i will check this later
        option = key;
        key = other;
        other = undefined;
      }
    } else if (arguments.length === 1) {
      // $FlowFixMe: i will check this later
      key = other;
      other = undefined;
    }
    // argument validate
    if (!isString(key)) throw new TypeError('@alias need a string as a key to find the porperty to set alias on');
    var illegalObjErrorMsg = 'If you want to use @alias to set alias on other instance, you must pass in a legal instance';
    if (other !== undefined && isPrimitive(other)) throw new TypeError(illegalObjErrorMsg);

    var _ref3 = isObject(option) ? option : { force: false, omit: false },
        force = _ref3.force,
        omit = _ref3.omit;

    return function (obj, prop, descriptor) {
      descriptor = descriptor || {
        value: undefined,
        configurable: true,
        writable: true,
        enumerable: true
      };
      function getTargetAndName(other, obj, key) {
        var target = isPrimitive(other) ? obj : other;
        var keys = key.split('.');

        var _keys$slice = keys.slice(-1),
            _keys$slice2 = _slicedToArray(_keys$slice, 1),
            name = _keys$slice2[0];

        target = getDeepProperty$1(target, keys.slice(0, -1), { throwError: true });
        if (isPrimitive(target)) {
          throw new TypeError(illegalObjErrorMsg);
        }
        return {
          target: target,
          name: name
        };
      }
      if (isInitializerDescriptor(descriptor)) {
        return initialize(function (value) {
          var _getTargetAndName = getTargetAndName(other, this, key),
              target = _getTargetAndName.target,
              name = _getTargetAndName.name;

          setAlias(this, prop, descriptor, target, name, { force: force, omit: omit });
          return value;
        })(obj, prop, descriptor);
      }
      if (isAccessorDescriptor(descriptor)) {
        var inited = void 0;
        var handler = function handler(value) {
          if (inited) return value;

          var _getTargetAndName2 = getTargetAndName(other, this, key),
              target = _getTargetAndName2.target,
              name = _getTargetAndName2.name;

          setAlias(this, prop, descriptor, target, name, { force: force, omit: omit });
          inited = true;
          return value;
        };
        return accessor({ get: handler, set: handler })(obj, prop, descriptor);
      }

      var _getTargetAndName3 = getTargetAndName(other, obj, key),
          target = _getTargetAndName3.target,
          name = _getTargetAndName3.name;

      setAlias(obj, prop, descriptor, target, name, { force: force, omit: omit });
      return descriptor;
    };
  }

  var defineProperty$1$1 = _Object$defineProperty;

  function classify(decorator) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        requirement = _ref.requirement,
        _ref$customArgs = _ref.customArgs,
        customArgs = _ref$customArgs === undefined ? false : _ref$customArgs;

    return function () {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$exclude = _ref2.exclude,
          exclude = _ref2$exclude === undefined ? [] : _ref2$exclude,
          _ref2$include = _ref2.include,
          include = _ref2$include === undefined ? [] : _ref2$include,
          _ref2$construct = _ref2.construct,
          construct = _ref2$construct === undefined ? false : _ref2$construct,
          _ref2$self = _ref2.self,
          self = _ref2$self === undefined ? false : _ref2$self;

      if (!isArray(exclude)) throw new TypeError('options.exclude must be an array');
      if (!isArray(include)) throw new TypeError('options.include must be an array');
      return function (Klass) {
        var isClass = isFunction(Klass);
        if (!self && !isClass) throw new TypeError('@' + decorator.name + 'Class can only be used on class');
        if (self && isPrimitive(Klass)) throw new TypeError('@' + decorator.name + 'Class must be used on non-primitive type value in \'self\' mode');
        var prototype = self ? Klass : Klass.prototype;
        if (isVoid(prototype)) throw new Error('The prototype of the ' + Klass.name + ' is empty, please check it');
        var descs = getOwnPropertyDescriptors$2(prototype);
        getOwnKeys(prototype).concat(include).forEach(function (key) {
          var desc = descs[key];
          if (key === 'constructor' && !construct || self && isClass && ['name', 'length', 'prototype'].indexOf(key) > -1 || exclude.indexOf(key) > -1 || isFunction(requirement) && requirement(prototype, key, desc, { self: self }) === false) return;
          defineProperty$1$1(prototype, key, (customArgs ? decorator.apply(undefined, _toConsumableArray(args)) : decorator)(prototype, key, desc));
        });
      };
    };
  }

  var autobindClass = classify(autobind, {
    requirement: function requirement(obj, prop, desc) {
      // $FlowFixMe: it's data descriptor now
      return isDataDescriptor(desc) && isFunction(desc.value);
    }
  });

  var mapStore = void 0;
  // save bound function for super
  function getBoundSuper(obj, fn) {
    if (typeof _WeakMap === 'undefined') {
      throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()');
    }

    if (!mapStore) {
      mapStore = new _WeakMap();
    }

    if (mapStore.has(obj) === false) {
      mapStore.set(obj, new _WeakMap());
    }

    var superStore = mapStore.get(obj);
    // $FlowFixMe: already insure superStore is not undefined
    if (superStore.has(fn) === false) {
      // $FlowFixMe: already insure superStore is not undefined
      superStore.set(fn, bind$1(fn, obj));
    }
    // $FlowFixMe: already insure superStore is not undefined
    return superStore.get(fn);
  }
  /**
   * auto bind the function on the class, just support function
   * @param {Object} obj Target Object
   * @param {string} prop prop strong
   * @param {Object} descriptor
   */
  function autobind(obj, prop, descriptor) {
    if (arguments.length === 1) return autobindClass()(obj);

    var _ref = descriptor || {},
        fn = _ref.value,
        configurable = _ref.configurable;

    if (!isFunction(fn)) {
      throw new TypeError('@autobind can only be used on functions, not "' + fn + '" in ' + (typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) + ' on property "' + prop + '"');
    }
    var constructor = obj.constructor;

    return {
      configurable: configurable,
      enumerable: false,
      get: function get() {
        var _this = this;

        var boundFn = function boundFn() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return fn.call.apply(fn, [_this].concat(_toConsumableArray(args)));
        };
        // Someone accesses the property directly on the prototype on which it is
        // actually defined on, i.e. Class.prototype.hasOwnProperty(key)
        if (this === obj) {
          return fn;
        }
        // Someone accesses the property directly on a prototype,
        // but it was found up the chain, not defined directly on it
        // i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
        if (this.constructor !== constructor && _Object$getPrototypeOf(this).constructor === constructor) {
          return fn;
        }

        // Autobound method calling super.sameMethod() which is also autobound and so on.
        if (this.constructor !== constructor && prop in this.constructor.prototype) {
          return getBoundSuper(this, fn);
        }
        _Object$defineProperty(this, prop, {
          configurable: true,
          writable: true,
          // NOT enumerable when it's a bound method
          enumerable: false,
          value: boundFn
        });

        return boundFn;
      },

      set: createDefaultSetter(prop)
    };
  }

  var defineProperty$2$1 = _Object$defineProperty;
  /**
   * make one attr only can be read, but could not be rewrited/ deleted
   * @param {Object} obj
   * @param {string} prop
   * @param {Object} descriptor
   * @return {descriptor}
   */

  function frozen(obj, prop, descriptor) {
    if (descriptor === undefined) {
      return {
        value: undefined,
        writable: false,
        enumerable: false,
        configurable: false
      };
    }
    descriptor.enumerable = false;
    descriptor.configurable = false;
    if (isAccessorDescriptor(descriptor)) {
      var _get = descriptor.get;

      descriptor.set = undefined;
      if (!isFunction(_get)) {
        return;
      }
      return {
        get: function get() {
          var value = bind$1(_get, this)();
          defineProperty$2$1(this, prop, {
            value: value,
            writable: false,
            configurable: false,
            enumerable: false
          });
          return value;
        },

        set: undefined,
        configurable: false,
        enumerable: false
      };
    }
    // $FlowFixMe: comeon, can disjoint union be reliable?
    descriptor.writable = false;
    return descriptor;
  }

  var getOwnPropertyDescriptor$2$1 = _Object$getOwnPropertyDescriptor;
  var defineProperty$3$1 = _Object$defineProperty;

  function waituntil(key) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        other = _ref.other;

    if (!isFunction(key) && !isPromise(key) && !isString(key)) throw new TypeError('@waitUntil only accept Function, Promise or String');
    return function (obj, prop, descriptor) {
      var _ref2 = descriptor || {},
          _value = _ref2.value,
          configurable = _ref2.configurable;

      if (!isFunction(_value)) throw new TypeError('@waituntil can only be used on function, but not ' + _value + ' on property "' + prop + '"');
      var binded = false;
      var waitingQueue = [];
      var canIRun = isPromise(key) ? function () {
        return key;
      } : isFunction(key) ? key : function () {
        // $FlowFixMe: We have use isPromise to exclude
        var keys = key.split('.');
        var prop = keys.slice(-1);
        var originTarget = isPrimitive(other) ? this : other;
        if (!binded) {
          var target = getDeepProperty$1(originTarget, keys.slice(0, -1));
          if (isVoid(target)) return target;
          var _descriptor = getOwnPropertyDescriptor$2$1(target, prop);
          /**
           * create a setter hook here
           * when it get ture, it will run all function in waiting queue immediately
           */
          var set = function set(value) {
            if (value === true) {
              while (waitingQueue.length > 0) {
                waitingQueue[0]();
                waitingQueue.shift();
              }
            }
            return value;
          };
          var desc = isDescriptor(_descriptor) ? accessor({ set: set })(target, prop, _descriptor) : accessor({ set: set })(target, prop, {
            value: undefined,
            configurable: true,
            enumerable: true,
            writable: true
          });
          defineProperty$3$1(target, prop, desc);
          binded = true;
        }
        return getDeepProperty$1(originTarget, keys);
      };
      return {
        value: function value() {
          var _this = this;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var boundFn = bind$1(_value, this);
          var runnable = bind$1(canIRun, this).apply(undefined, args);
          if (isPromise(runnable)) {
            return _Promise.resolve(runnable).then(function () {
              return bind$1(_value, _this).apply(undefined, args);
            });
          } else if (runnable === true) {
            return bind$1(_value, this).apply(undefined, args);
          } else {
            return new _Promise(function (resolve) {
              var cb = function cb() {
                boundFn.apply(undefined, args);
                resolve();
              };
              waitingQueue.push(cb);
            });
          }
        },

        // function should not be enmuerable
        enumerable: false,
        configurable: configurable,
        // as we have delay this function
        // it's not a good idea to change it
        writable: false
      };
    };
  }

  function nonenumerable(obj, prop, descriptor) {
    if (descriptor === undefined) {
      return {
        value: undefined,
        enumerable: false,
        configurable: true,
        writable: true
      };
    }
    descriptor.enumerable = false;
    return descriptor;
  }

  var defineProperty$6 = _Object$defineProperty;
  var getOwnPropertyDescriptor$3 = _Object$getOwnPropertyDescriptor;


  function applyDecorators(Class, props) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$self = _ref.self,
        self = _ref$self === undefined ? false : _ref$self,
        _ref$omit = _ref.omit,
        omit = _ref$omit === undefined ? false : _ref$omit;

    var isPropsFunction = isFunction(props);
    if (isPropsFunction || isArray(props)) {
      // apply decorators on class
      if (!isFunction(Class)) throw new TypeError('If you want to decorator class, you must pass it a legal class');
      // $FlowFixMe: Terrible union, it's function now
      if (isPropsFunction) props(Class);else {
        // $FlowFixMe: Terrible union, it's array now
        for (var i = 0, len = props.length; i < len; i++) {
          // $FlowFixMe: Terrible union, it's array now
          var fn = props[i];
          if (!isFunction(fn)) throw new TypeError('If you want to decorate an class, you must pass it function or array of function');
          fn(Class);
        }
      }
      return Class;
    }
    if (!self && !isFunction(Class)) throw new TypeError('applyDecorators only accept class as first arguments. If you want to modify instance, you should set options.self true.');
    if (self && isPrimitive(Class)) throw new TypeError("We can't apply docorators on a primitive value, even in self mode");
    if (!isObject(props)) throw new TypeError('applyDecorators only accept object as second arguments');
    var prototype = self ? Class : Class.prototype;
    if (isVoid(prototype)) throw new Error('The class muse have a prototype, please take a check');
    for (var key in props) {
      var value = props[key];
      var decorators = isArray(value) ? value : [value];
      var handler = void 0;
      try {
        handler = compressMultipleDecorators.apply(undefined, _toConsumableArray(decorators));
      } catch (err) {
        throw new Error('The decorators set on props must be Function or Array of Function');
      }
      var descriptor = getOwnPropertyDescriptor$3(prototype, key);
      if (descriptor && !descriptor.configurable) {
        if (!omit) throw new Error(key + ' of ' + prototype + ' is unconfigurable');
        continue;
      }
      defineProperty$6(prototype, key, handler(prototype, key, descriptor));
    }
    return Class;
  }

  var arrayChangeMethod = ['push', 'pop', 'unshift', 'shift', 'splice', 'sort', 'reverse'];

  function deepProxy(value, hook, _ref) {
    var _operateProps;

    var diff = _ref.diff,
        operationPrefix = _ref.operationPrefix;

    var mapStore = {};
    var arrayChanging = false;
    var proxyValue = new Proxy(value, {
      get: function get(target, property, receiver) {
        var value = target[property];
        if (isArray(target) && arrayChangeMethod.indexOf(property) > -1) {
          return function () {
            arrayChanging = true;
            bind$1(value, receiver).apply(undefined, arguments);
            arrayChanging = false;
            hook();
          };
        }
        if (mapStore[property] === true) return value;
        if (isObject(value) || isArray(value)) {
          var _proxyValue = mapStore[property] || deepProxy(value, hook, { diff: diff, operationPrefix: operationPrefix });
          mapStore[property] = _proxyValue;
          return _proxyValue;
        }
        mapStore[property] = true;
        return value;
      },
      set: function set(target, property, value) {
        var oldVal = target[property];
        var newVal = isObject(value) || isArray(value) ? deepProxy(value, hook, { diff: diff, operationPrefix: operationPrefix }) : value;
        target[property] = newVal;
        mapStore[property] = true;
        if (arrayChanging || diff && oldVal === newVal) return true;
        hook();
        return true;
      },
      deleteProperty: function deleteProperty(target, property) {
        delete target[property];
        delete mapStore[property];
        if (arrayChanging) return true;
        hook();
        return true;
      }
    });
    var operateProps = (_operateProps = {}, _defineProperty(_operateProps, operationPrefix + 'set', [initialize(function (method) {
      return function (property, val) {
        // $FlowFixMe: we have check the computed value
        proxyValue[property] = val;
      };
    }), nonenumerable]), _defineProperty(_operateProps, operationPrefix + 'del', [initialize(function (method) {
      return function (property) {
        // $FlowFixMe: we have check the computed value
        delete proxyValue[property];
      };
    }), nonenumerable]), _operateProps);
    applyDecorators(proxyValue, operateProps, { self: true });
    return proxyValue;
  }

  function deepObserve(value, hook, _ref2) {
    var _this = this,
        _operateProps2;

    var operationPrefix = _ref2.operationPrefix,
        diff = _ref2.diff;

    var mapStore = {};
    var arrayChanging = false;
    function getPropertyDecorators(keys) {
      var oldVal = void 0;
      return keys.reduce(function (props, key) {
        props[key] = [accessor({
          set: function set(value) {
            oldVal = this[key];
            return value;
          }
        }), accessor({
          get: function get(val) {
            if (mapStore[key]) return val;
            if (isObject(val) || isArray(val)) {
              deepObserve(val, hook, { operationPrefix: operationPrefix, diff: diff });
            }
            mapStore[key] = true;
            return val;
          },
          set: function set(val) {
            if (isObject(val) || isArray(val)) deepObserve(val, hook, { operationPrefix: operationPrefix, diff: diff });
            mapStore[key] = true;
            if (!arrayChanging && (!diff || oldVal !== val)) hook();
            return val;
          }
        }, { preSet: false })];
        return props;
      }, {});
    }
    var props = getPropertyDecorators(getOwnKeys(value));
    applyDecorators(value, props, { self: true, omit: true });
    if (isArray(value)) {
      var methodProps = arrayChangeMethod.reduce(function (props, key) {
        props[key] = [initialize(function (method) {
          method = isFunction(method) ? method
          // $FlowFixMe: we have check the key
          : Array.prototype[key];
          return function () {
            var originLength = value.length;
            arrayChanging = true;
            bind$1(method, value).apply(undefined, arguments);
            arrayChanging = false;
            if (originLength < value.length) {
              var keys = new Array(value.length - originLength).fill(1).map(function (value, index) {
                return (index + originLength).toString();
              });
              var _props = getPropertyDecorators(keys);
              applyDecorators(value, _props, { self: true, omit: true });
            }
            hook();
          };
        }), nonenumerable];
        return props;
      }, {});
      applyDecorators(value, methodProps, { self: true });
    }
    var operateProps = (_operateProps2 = {}, _defineProperty(_operateProps2, operationPrefix + 'set', [initialize(function (method) {
      return function (property, val) {
        var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            disable = _ref3.disable,
            isNewVal = _ref3.isNewVal;

        isNewVal = isNewVal || getOwnKeys(value).indexOf(property) === -1;
        if (isFunction(method)) {
          bind$1(method, _this)(property, val, { disable: true, isNewVal: isNewVal });
        }
        if (isNewVal) {
          var _props2 = getPropertyDecorators([property]);
          applyDecorators(value, _props2, { self: true, omit: true });
        }
        if (!disable) {
          value[property] = val;
        }
      };
    }), nonenumerable]), _defineProperty(_operateProps2, operationPrefix + 'del', [initialize(function (method) {
      return function (property) {
        if (isFunction(method)) {
          bind$1(method, _this)(property);
        } else {
          delete value[property];
        }
        hook();
      };
    }), nonenumerable]), _operateProps2);
    applyDecorators(value, operateProps, { self: true });
    return value;
  }

  function watch() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var option = isObject(args[args.length - 1]) ? args[args.length - 1] : {};
    // $FlowFixMe: we have check if it's an object
    var deep = option.deep,
        omit = option.omit,
        other = option.other,
        _option$operationPref = option.operationPrefix,
        operationPrefix = _option$operationPref === undefined ? '__' : _option$operationPref,
        _option$diff = option.diff,
        diff = _option$diff === undefined ? true : _option$diff;
    // $FlowFixMe: we have check if it's an object

    var proxy = option.proxy;

    if (typeof Proxy !== 'function') {
      proxy = false;
    }
    if (!args.length) throw new TypeError('You must pass a function or a string to find the hanlder function.');
    if (other !== undefined && isPrimitive(other)) throw new TypeError('If you want us to trigger function on the other instance, you must pass in a legal instance');
    if (!isString(operationPrefix)) throw new TypeError('operationPrefix must be an string');
    return function (obj, prop, descriptor) {
      var fns = args.reduce(function (fns, keyOrFn, index) {
        if (!isString(keyOrFn) && !isFunction(keyOrFn)) {
          if (!index || index !== args.length - 1) throw new TypeError('You can only pass function or string as handler');
          return fns;
        }
        fns.push(isString(keyOrFn) ? function (newVal, oldVal) {
          var target = other || obj;
          // $FlowFixMe: we have ensure it must be a string
          var fn = getDeepProperty$1(target, keyOrFn);
          if (!isFunction(fn)) {
            if (!omit) throw new Error('You pass in a function for us to trigger, please ensure the property to be a function or set omit flag true');
            return;
          }
          return bind$1(fn, this)(newVal, oldVal);
        } : keyOrFn);
        return fns;
      }, []);
      var handler = function handler(newVal, oldVal) {
        var _this2 = this;

        fns.forEach(function (fn) {
          return bind$1(fn, _this2)(newVal, oldVal);
        });
      };
      var inited = false;
      var oldVal = void 0;
      var newVal = void 0;
      var proxyValue = void 0;
      return compressMultipleDecorators(accessor({
        set: function set(value) {
          var _this3 = this;

          oldVal = this[prop];
          proxyValue = undefined;
          var hook = function hook() {
            return bind$1(handler, _this3)(newVal, oldVal);
          };
          return deep && (isObject(value) || isArray(value)) ? proxy ? deepProxy(value, hook, { diff: diff, operationPrefix: operationPrefix }) : deepObserve(value, hook, { operationPrefix: operationPrefix, diff: diff }) : value;
        },
        get: function get(value) {
          var _this4 = this;

          if (proxyValue) return proxyValue;
          if (!inited) {
            inited = true;
            var hook = function hook() {
              return bind$1(handler, _this4)(newVal, oldVal);
            };
            if (deep && (isObject(value) || isArray(value))) {
              if (proxy) {
                proxyValue = deepProxy(value, hook, { diff: diff, operationPrefix: operationPrefix });
                oldVal = proxyValue;
                newVal = proxyValue;
                return proxyValue;
              }
              deepObserve(value, hook, { operationPrefix: operationPrefix, diff: diff });
            }
            oldVal = value;
            newVal = value;
          }
          return value;
        }
      }, { preSet: true }), accessor({
        set: function set(value) {
          newVal = value;
          if (!diff || oldVal !== value) bind$1(handler, this)(newVal, oldVal);
          oldVal = value;
          return value;
        }
      }, { preSet: false }))(obj, prop, descriptor);
    };
  }

  function runnable(key) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        other = _ref.other,
        backup = _ref.backup;

    if (!isFunction(key) && !isString(key)) throw new TypeError('@runnable only accept Function or String');
    return function (obj, prop, descriptor) {
      var _ref2 = descriptor || {},
          _value = _ref2.value,
          configurable = _ref2.configurable;

      if (!isFunction(_value)) throw new TypeError('@runnable can only be used on method, but not ' + _value + ' on property "' + prop + '".');
      var canIRun = isFunction(key) ? key : function () {
        var keys = key.split('.');
        var originTarget = isPrimitive(other) ? this : other;
        return getDeepProperty$1(originTarget, keys);
      };
      backup = isFunction(backup) ? backup : function () {};
      return {
        value: function value() {
          if (bind$1(canIRun, this).apply(undefined, arguments) === true) {
            return bind$1(_value, this).apply(undefined, arguments);
          } else {
            // $FlowFixMe: I have reassign it when it's not a function
            return bind$1(backup, this).apply(undefined, arguments);
          }
        },

        // function should not be enmuerable
        enumerable: false,
        configurable: configurable,
        // as we have delay this function
        // it's not a good idea to change it
        writable: false
      };
    };
  }

  function nonconfigurable(obj, prop, descriptor) {
    if (descriptor === undefined) {
      return {
        value: undefined,
        enumerable: true,
        configurable: true,
        writable: true
      };
    }
    descriptor.configurable = true;
    return descriptor;
  }

  function string() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var defaultValue = isString(args[0]) ? args.shift() : '';
    args.unshift(function (value) {
      return isString(value) ? value : defaultValue;
    });
    return initialize.apply(undefined, args);
  }

  function boolean() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var defaultValue = isBoolean(args[0]) ? args.shift() : false;
    args.unshift(function (value) {
      return isBoolean(value) ? value : defaultValue;
    });
    return initialize.apply(undefined, args);
  }

  function string$1() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var defaultValue = isString(args[0]) ? args.shift() : '';
    args.unshift(function (value) {
      return isString(value) ? value : defaultValue;
    });
    return accessor({ set: args, get: args });
  }

  function boolean$1() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var defaultValue = isBoolean(args[0]) ? args.shift() : false;
    args.unshift(function (value) {
      return isBoolean(value) ? value : defaultValue;
    });
    return accessor({ set: args, get: args });
  }

  function number$1() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var defaultValue = isNumber(args[0]) ? args.shift() : 0;
    args.unshift(function (value) {
      return isNumber(value) ? value : defaultValue;
    });
    return accessor({ set: args, get: args });
  }

  var $JSON$1 = _core.JSON || (_core.JSON = { stringify: JSON.stringify });
  var stringify = function stringify(it) { // eslint-disable-line no-unused-vars
    return $JSON$1.stringify.apply($JSON$1, arguments);
  };

  var stringify$1 = createCommonjsModule(function (module) {
  module.exports = { "default": stringify, __esModule: true };
  });

  var _JSON$stringify = unwrapExports(stringify$1);

  var get = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf$2);



  var _getOwnPropertyDescriptor2 = _interopRequireDefault(getOwnPropertyDescriptor$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

    if (desc === undefined) {
      var parent = (0, _getPrototypeOf2.default)(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };
  });

  var _get = unwrapExports(get);

  var VENDOR_PREFIXES = ['', 'o', 'ms', 'moz', 'webkit', 'webkitCurrent'];

  var SYNONYMS = [['', ''], // empty
  ['exit', 'cancel'], // firefox & old webkits expect cancelFullScreen instead of exitFullscreen
  ['screen', 'Screen']];

  var DESKTOP_FULLSCREEN_STYLE = {
    position: 'fixed',
    zIndex: '2147483647',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    width: '100%',
    height: '100%'
  };

  var FULLSCREEN_CHANGE = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];

  var FULLSCREEN_ERROR = ['fullscreenerror', 'webkitfullscreenerror', 'mozfullscreenerror', 'MSFullscreenError'];

  var supportDocument = typeof document !== 'undefined';

  function setStyle$1(el, key, val) {
    if (isObject(key)) {
      for (var k in key) {
        setStyle$1(el, k, key[k]);
      }
    } else {
      // $FlowFixMe: we found it
      el.style[key] = val;
    }
  }

  function native(target, name) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (isObject(name)) {
      option = name;
    }
    if (isString(target)) {
      name = target;
    }
    var _option = option,
        _option$keyOnly = _option.keyOnly,
        keyOnly = _option$keyOnly === undefined ? false : _option$keyOnly;
    /* istanbul ignore if */

    if (!supportDocument) {
      return keyOnly ? '' : undefined;
    }
    if (!isElement(target)) {
      target = document;
    }
    if (!isString(name)) throw new Error('You must pass in a string as name, but not ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + '.');
    for (var i = 0; i < SYNONYMS.length; i++) {
      name = name.replace(SYNONYMS[i][0], SYNONYMS[i][1]);
      for (var j = 0; j < VENDOR_PREFIXES.length; j++) {
        var prefixed = j === 0 ? name : VENDOR_PREFIXES[j] + name.charAt(0).toUpperCase() + name.substr(1);
        // $FlowFixMe: we support document computed property here
        if (target[prefixed] !== undefined) return keyOnly ? prefixed : target[prefixed];
      }
    }
    return keyOnly ? '' : undefined;
  }

  function dispatchEvent(element, name) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$bubbles = _ref.bubbles,
        bubbles = _ref$bubbles === undefined ? true : _ref$bubbles,
        _ref$cancelable = _ref.cancelable,
        cancelable = _ref$cancelable === undefined ? true : _ref$cancelable;

    var event = void 0;
    /* istanbul ignore else  */
    if (isFunction(Event)) {
      event = new Event(name, {
        bubbles: bubbles,
        cancelable: cancelable
      });
    } else if (supportDocument && document.createEvent) {
      event = document.createEvent('HTMLEvents');
      event.initEvent(name, true, true);
    } else if (supportDocument && document.createEventObject) {
      // $FlowFixMe: IE < 9
      event = document.createEventObject();
      event.eventType = name;
      event.eventName = name;
    }
    /* istanbul ignore next  */
    if (!isObject(event) && !isEvent(event)) throw new Error("We can't create an object on this browser, please report to author");
    /* istanbul ignore else  */
    if (element.dispatchEvent) {
      element.dispatchEvent(event);
      // $FlowFixMe: IE < 9
    } else if (element.fireEvent) {
      // $FlowFixMe: IE < 9
      element.fireEvent('on' + event.eventType, event); // can trigger only real event (e.g. 'click')
      // $FlowFixMe: support computed key
    } else if (element[name]) {
      // $FlowFixMe: support computed key
      element[name]();
      // $FlowFixMe: support computed key
    } else if (element['on' + name]) {
      // $FlowFixMe: support computed key
      element['on' + name]();
    }
  }

  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  var fullscreenEnabled = native('fullscreenEnabled');
  var useStyleFirst = false;

  var ESFullScreen = (_dec = autobindClass(), _dec2 = alias('requestFullscreen'), _dec3 = alias('exitFullscreen'), _dec4 = alias('addEventListener'), _dec5 = alias('removeEventListener'), _dec(_class = (_class2 = function () {
    function ESFullScreen() {
      _classCallCheck$1(this, ESFullScreen);

      this._fullscreenElement = null;
      this.isNativelySupport = defined(native('fullscreenElement')) && (!defined(fullscreenEnabled) || fullscreenEnabled === true);
      this._openKey = supportDocument ? native(document.body || document.documentElement, 'requestFullscreen', { keyOnly: true }) : '';
      this._exitKey = native('exitFullscreen', { keyOnly: true });
      this._useStyleFirst = false;
      this.hasUsedStyle = false;
    }

    _createClass(ESFullScreen, [{
      key: 'open',
      value: function open(element) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$force = _ref.force,
            force = _ref$force === undefined ? false : _ref$force;
        var originElement = this.fullscreenElement;
        if (originElement && originElement !== element) {
          if (!force) {
            dispatchEvent(document, 'fullscreenerror');
            return false;
          }
          this.exit();
        }

        if (!this.useStyleFirst) {
          if (this.isNativelySupport) {
            // $FlowFixMe: support computed key on HTMLElment here
            isFunction(element[this._openKey]) && element[this._openKey]();
            return true;
          }

          // add wekitEnterFullscreen support as required in https://github.com/toxic-johann/es-fullscreen/issues/4
          /* istanbul ignore if  */
          if (element instanceof HTMLVideoElement && element.webkitSupportsFullscreen &&
          // $FlowFixMe: support webkitEnterFullscreen on some werid safari
          isFunction(element.webkitEnterFullscreen)) {
            element.webkitEnterFullscreen();
            this._fullscreenElement = element;
            return true;
          }
        }

        this._savedStyles = _Object$keys(DESKTOP_FULLSCREEN_STYLE).reduce(function (styles, key) {
          // $FlowFixMe: support string here
          styles[key] = element.style[key];
          return styles;
        }, {});
        setStyle$1(element, DESKTOP_FULLSCREEN_STYLE);

        /* istanbul ignore else  */
        if (document.body) {
          this._bodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        /* istanbul ignore else  */
        if (document.documentElement) {
          this._htmlOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }
        this._fullscreenElement = element;
        this.hasUsedStyle = true;
        dispatchEvent(element, 'fullscreenchange');
        return true;
      }
    }, {
      key: 'exit',
      value: function exit() {
        if (!this.isFullscreen) return false;
        if (this.isNativelySupport && !this.useStyleFirst && !this.hasUsedStyle) {
          // $FlowFixMe: support document computed key here
          document[this._exitKey]();
          return true;
        }
        // $FlowFixMe: element is an Elment here
        var element = this._fullscreenElement;
        setStyle$1(element, this._savedStyles);
        /* istanbul ignore else  */
        if (document.body) document.body.style.overflow = this._bodyOverflow;
        /* istanbul ignore else  */
        if (document.documentElement) document.documentElement.style.overflow = this._htmlOverflow;

        this._fullscreenElement = null;
        this._savedStyles = {};
        dispatchEvent(element, 'fullscreenchange');
        return true;
      }
    }, {
      key: 'on',
      value: function on(name, fn) {
        var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

        this._handleEvent(element, 'addEventListener', name, fn);
      }
    }, {
      key: 'off',
      value: function off(name, fn) {
        var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

        this._handleEvent(element, 'removeEventListener', name, fn);
      }
    }, {
      key: '_handleEvent',
      value: function _handleEvent(element, behavior, name, fn) {
        var names = name === 'fullscreenchange' ? FULLSCREEN_CHANGE : name === 'fullscreenerror' ? FULLSCREEN_ERROR : [name];
        names.forEach(function (name) {
          // $FlowFixMe: support computed attribute here
          element[behavior](name, fn);
        });
      }
    }, {
      key: 'useStyleFirst',
      get: function get() {
        return useStyleFirst;
      },
      set: function set(value) {
        value = !!value;
        if (value === useStyleFirst) return value;
        useStyleFirst = value;
        dispatchEvent(document, 'esfullscreenmethodchange');
        return value;
      }
    }, {
      key: 'fullscreenElement',
      get: function get() {
        var element = ['fullscreenElement', 'webkitFullscreenElement', 'mozFullScreenElement', 'msFullscreenElement'].reduce(function (element, key) {
          // $FlowFixMe: support computed element on document
          return element || document[key];
        }, null);
        return element || this._fullscreenElement;
      }
    }, {
      key: 'isFullscreen',
      get: function get() {
        return isElement(this.fullscreenElement);
      }
    }]);

    return ESFullScreen;
  }(), _applyDecoratedDescriptor(_class2.prototype, 'open', [_dec2], _Object$getOwnPropertyDescriptor(_class2.prototype, 'open'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'exit', [_dec3], _Object$getOwnPropertyDescriptor(_class2.prototype, 'exit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'on', [_dec4], _Object$getOwnPropertyDescriptor(_class2.prototype, 'on'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'off', [_dec5], _Object$getOwnPropertyDescriptor(_class2.prototype, 'off'), _class2.prototype), _class2)) || _class);

  var index = new ESFullScreen();

  var dP$3 = _objectDp.f;









  var fastKey = _meta.fastKey;

  var SIZE = _descriptors ? '_s' : 'size';

  var getEntry = function (that, key) {
    // fast case
    var index = fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for (entry = that._f; entry; entry = entry.n) {
      if (entry.k == key) return entry;
    }
  };

  var _collectionStrong = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        _anInstance(that, C, NAME, '_i');
        that._t = NAME;         // collection type
        that._i = _objectCreate(null); // index
        that._f = undefined;    // first entry
        that._l = undefined;    // last entry
        that[SIZE] = 0;         // size
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
      });
      _redefineAll(C.prototype, {
        // 23.1.3.1 Map.prototype.clear()
        // 23.2.3.2 Set.prototype.clear()
        clear: function clear() {
          for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
            entry.r = true;
            if (entry.p) entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }
          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        // 23.1.3.3 Map.prototype.delete(key)
        // 23.2.3.4 Set.prototype.delete(value)
        'delete': function (key) {
          var that = _validateCollection(this, NAME);
          var entry = getEntry(that, key);
          if (entry) {
            var next = entry.n;
            var prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if (prev) prev.n = next;
            if (next) next.p = prev;
            if (that._f == entry) that._f = next;
            if (that._l == entry) that._l = prev;
            that[SIZE]--;
          } return !!entry;
        },
        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
        forEach: function forEach(callbackfn /* , that = undefined */) {
          _validateCollection(this, NAME);
          var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
          var entry;
          while (entry = entry ? entry.n : this._f) {
            f(entry.v, entry.k, this);
            // revert to the last existing entry
            while (entry && entry.r) entry = entry.p;
          }
        },
        // 23.1.3.7 Map.prototype.has(key)
        // 23.2.3.7 Set.prototype.has(value)
        has: function has(key) {
          return !!getEntry(_validateCollection(this, NAME), key);
        }
      });
      if (_descriptors) dP$3(C.prototype, 'size', {
        get: function () {
          return _validateCollection(this, NAME)[SIZE];
        }
      });
      return C;
    },
    def: function (that, key, value) {
      var entry = getEntry(that, key);
      var prev, index;
      // change existing entry
      if (entry) {
        entry.v = value;
      // create new entry
      } else {
        that._l = entry = {
          i: index = fastKey(key, true), // <- index
          k: key,                        // <- key
          v: value,                      // <- value
          p: prev = that._l,             // <- previous entry
          n: undefined,                  // <- next entry
          r: false                       // <- removed
        };
        if (!that._f) that._f = entry;
        if (prev) prev.n = entry;
        that[SIZE]++;
        // add to index
        if (index !== 'F') that._i[index] = entry;
      } return that;
    },
    getEntry: getEntry,
    setStrong: function (C, NAME, IS_MAP) {
      // add .keys, .values, .entries, [@@iterator]
      // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
      _iterDefine(C, NAME, function (iterated, kind) {
        this._t = _validateCollection(iterated, NAME); // target
        this._k = kind;                     // kind
        this._l = undefined;                // previous
      }, function () {
        var that = this;
        var kind = that._k;
        var entry = that._l;
        // revert to the last existing entry
        while (entry && entry.r) entry = entry.p;
        // get next entry
        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
          // or finish the iteration
          that._t = undefined;
          return _iterStep(1);
        }
        // return step by kind
        if (kind == 'keys') return _iterStep(0, entry.k);
        if (kind == 'values') return _iterStep(0, entry.v);
        return _iterStep(0, [entry.k, entry.v]);
      }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

      // add [@@species], 23.1.2.2, 23.2.2.2
      _setSpecies(NAME);
    }
  };

  var MAP = 'Map';

  // 23.1 Map Objects
  var es6_map = _collection(MAP, function (get) {
    return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
  }, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
      var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
      return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
      return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
    }
  }, _collectionStrong, true);

  var _arrayFromIterable = function (iter, ITERATOR) {
    var result = [];
    _forOf(iter, false, result.push, result, ITERATOR);
    return result;
  };

  // https://github.com/DavidBruant/Map-Set.prototype.toJSON


  var _collectionToJson = function (NAME) {
    return function toJSON() {
      if (_classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
      return _arrayFromIterable(this);
    };
  };

  // https://github.com/DavidBruant/Map-Set.prototype.toJSON


  _export(_export.P + _export.R, 'Map', { toJSON: _collectionToJson('Map') });

  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
  _setCollectionOf('Map');

  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
  _setCollectionFrom('Map');

  var map = _core.Map;

  var map$1 = createCommonjsModule(function (module) {
  module.exports = { "default": map, __esModule: true };
  });

  var _Map = unwrapExports(map$1);

  var isEnum$1 = _objectPie.f;
  var _objectToArray = function (isEntries) {
    return function (it) {
      var O = _toIobject(it);
      var keys = _objectKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;
      while (length > i) {
        key = keys[i++];
        if (!_descriptors || isEnum$1.call(O, key)) {
          result.push(isEntries ? [key, O[key]] : O[key]);
        }
      }
      return result;
    };
  };

  // https://github.com/tc39/proposal-object-values-entries

  var $entries = _objectToArray(true);

  _export(_export.S, 'Object', {
    entries: function entries(it) {
      return $entries(it);
    }
  });

  var entries = _core.Object.entries;

  var entries$1 = createCommonjsModule(function (module) {
  module.exports = { "default": entries, __esModule: true };
  });

  var _Object$entries = unwrapExports(entries$1);

  var runtime = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  !(function(global) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var runtime = global.regeneratorRuntime;
    if (runtime) {
      {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      }
      // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.
      return;
    }

    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = module.exports;

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);

      return generator;
    }
    runtime.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype &&
        NativeIteratorPrototype !== Op &&
        hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype =
      Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] =
      GeneratorFunction.displayName = "GeneratorFunction";

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        prototype[method] = function(arg) {
          return this._invoke(method, arg);
        };
      });
    }

    runtime.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor
        ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction"
        : false;
    };

    runtime.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function(arg) {
      return { __await: arg };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value &&
              typeof value === "object" &&
              hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function(value) {
              invoke("next", value, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function(unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration. If the Promise is rejected, however, the
            // result for this iteration will be rejected with the same
            // reason. Note that rejections of yielded Promises are not
            // thrown back into the generator function, as is the case
            // when an awaited Promise is rejected. This difference in
            // behavior between yield and await is important, because it
            // allows the consumer to decide what to do with the yielded
            // rejection (swallow it and continue, manually .throw it back
            // into the generator, abandon iteration, whatever). With
            // await, by contrast, there is no opportunity to examine the
            // rejection reason outside the generator function, so the
            // only option is to throw it from the await expression, and
            // let the generator function handle the exception.
            result.value = unwrapped;
            resolve(result);
          }, reject);
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(
            callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg
          ) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    runtime.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(
        wrap(innerFn, outerFn, self, tryLocsList)
      );

      return runtime.isGeneratorFunction(outerFn)
        ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
          });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;

      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;

          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);

          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;

          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done
              ? GenStateCompleted
              : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };

          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError(
            "The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (! info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }

      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);

    Gp[toStringTagSymbol] = "Generator";

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
      return this;
    };

    Gp.toString = function() {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    runtime.keys = function(object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1, next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;

            return next;
          };

          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return { next: doneResult };
    }
    runtime.values = values;

    function doneResult() {
      return { value: undefined, done: true };
    }

    Context.prototype = {
      constructor: Context,

      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;

        this.method = "next";
        this.arg = undefined;

        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" &&
                hasOwn.call(this, name) &&
                !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },

      stop: function() {
        this.done = true;

        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },

      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !! caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }

            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }

            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }

            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },

      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev &&
              hasOwn.call(entry, "finallyLoc") &&
              this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry &&
            (type === "break" ||
             type === "continue") &&
            finallyEntry.tryLoc <= arg &&
            arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },

      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" ||
            record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },

      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },

      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },

      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    };
  })(
    // In sloppy mode, unbound `this` refers to the global object, fallback to
    // Function constructor if we're in global strict mode. That is sadly a form
    // of indirect eval which violates Content Security Policy.
    (function() { return this })() || Function("return this")()
  );
  });

  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  // This method of obtaining a reference to the global object needs to be
  // kept identical to the way it is obtained in runtime.js
  var g = (function() { return this })() || Function("return this")();

  // Use `getOwnPropertyNames` because not all browsers support calling
  // `hasOwnProperty` on the global `self` object in a worker. See #183.
  var hadRuntime = g.regeneratorRuntime &&
    Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

  // Save the old regeneratorRuntime in case it needs to be restored later.
  var oldRuntime = hadRuntime && g.regeneratorRuntime;

  // Force reevalutation of runtime.js.
  g.regeneratorRuntime = undefined;

  var runtimeModule = runtime;

  if (hadRuntime) {
    // Restore the original runtime.
    g.regeneratorRuntime = oldRuntime;
  } else {
    // Remove the global property added by runtime.js.
    try {
      delete g.regeneratorRuntime;
    } catch(e) {
      g.regeneratorRuntime = undefined;
    }
  }

  var regenerator = runtimeModule;

  var asyncToGenerator = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;



  var _promise2 = _interopRequireDefault(promise$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new _promise2.default(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            return _promise2.default.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }

        return step("next");
      });
    };
  };
  });

  var _asyncToGenerator = unwrapExports(asyncToGenerator);

  var _global$1 = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  });

  var _core$1 = createCommonjsModule(function (module) {
  var core = module.exports = { version: '2.6.11' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  });
  var _core_1$1 = _core$1.version;

  var _isObject$1 = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject$1 = function (it) {
    if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails$1 = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors$1 = !_fails$1(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document$3 = _global$1.document;
  // typeof document.createElement is 'object' in old IE
  var is$1 = _isObject$1(document$3) && _isObject$1(document$3.createElement);
  var _domCreate$1 = function (it) {
    return is$1 ? document$3.createElement(it) : {};
  };

  var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
    return Object.defineProperty(_domCreate$1('div'), 'a', { get: function () { return 7; } }).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive$1 = function (it, S) {
    if (!_isObject$1(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP$4 = Object.defineProperty;

  var f$8 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject$1(O);
    P = _toPrimitive$1(P, true);
    _anObject$1(Attributes);
    if (_ie8DomDefine$1) try {
      return dP$4(O, P, Attributes);
    } catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var _objectDp$1 = {
  	f: f$8
  };

  var _propertyDesc$1 = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var _hide$1 = _descriptors$1 ? function (object, key, value) {
    return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var hasOwnProperty$1 = {}.hasOwnProperty;
  var _has$1 = function (it, key) {
    return hasOwnProperty$1.call(it, key);
  };

  var id$2 = 0;
  var px$1 = Math.random();
  var _uid$1 = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$2 + px$1).toString(36));
  };

  var _library$1 = false;

  var _shared$1 = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global$1[SHARED] || (_global$1[SHARED] = {});

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core$1.version,
    mode: _library$1 ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
  });

  var _functionToString = _shared$1('native-function-to-string', Function.toString);

  var _redefine$1 = createCommonjsModule(function (module) {
  var SRC = _uid$1('src');

  var TO_STRING = 'toString';
  var TPL = ('' + _functionToString).split(TO_STRING);

  _core$1.inspectSource = function (it) {
    return _functionToString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) _has$1(val, 'name') || _hide$1(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) _has$1(val, SRC) || _hide$1(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
    if (O === _global$1) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];
      _hide$1(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      _hide$1(O, key, val);
    }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || _functionToString.call(this);
  });
  });

  var _aFunction$1 = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx$1 = function (fn, that, length) {
    _aFunction$1(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var PROTOTYPE$3 = 'prototype';

  var $export$1 = function (type, name, source) {
    var IS_FORCED = type & $export$1.F;
    var IS_GLOBAL = type & $export$1.G;
    var IS_STATIC = type & $export$1.S;
    var IS_PROTO = type & $export$1.P;
    var IS_BIND = type & $export$1.B;
    var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] || (_global$1[name] = {}) : (_global$1[name] || {})[PROTOTYPE$3];
    var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
    var expProto = exports[PROTOTYPE$3] || (exports[PROTOTYPE$3] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      // export native or passed
      out = (own ? target : source)[key];
      // bind timers to global for call from export context
      exp = IS_BIND && own ? _ctx$1(out, _global$1) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out;
      // extend global
      if (target) _redefine$1(target, key, out, type & $export$1.U);
      // export
      if (exports[key] != out) _hide$1(exports, key, exp);
      if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
  };
  _global$1.core = _core$1;
  // type bitmap
  $export$1.F = 1;   // forced
  $export$1.G = 2;   // global
  $export$1.S = 4;   // static
  $export$1.P = 8;   // proto
  $export$1.B = 16;  // bind
  $export$1.W = 32;  // wrap
  $export$1.U = 64;  // safe
  $export$1.R = 128; // real proto method for `library`
  var _export$1 = $export$1;

  // https://github.com/tc39/proposal-global


  _export$1(_export$1.G, { global: _global$1 });

  var global$1 = _core$1.global;

  var tempCurrentTime = 0;

  var NativeVideoKernel = function (_CustEvent) {
    _inherits$1(NativeVideoKernel, _CustEvent);

    _createClass(NativeVideoKernel, null, [{
      key: 'isSupport',

      /* istanbul ignore next  */
      value: function isSupport() {
        return true;
      }
    }]);

    function NativeVideoKernel(videoElement, config, customConfig) {
      _classCallCheck$1(this, NativeVideoKernel);

      var _this = _possibleConstructorReturn$1(this, (NativeVideoKernel.__proto__ || _Object$getPrototypeOf(NativeVideoKernel)).call(this));

      if (!isElement(videoElement)) throw new Error('You must pass in an legal video element but not ' + (typeof videoElement === 'undefined' ? 'undefined' : _typeof(videoElement)));
      _this.video = videoElement;
      _this.config = config;
      _this.customConfig = customConfig;
      return _this;
    }

    _createClass(NativeVideoKernel, [{
      key: 'load',
      value: function load(src) {
        this.video.setAttribute('src', src);
        this.video.src = src;
      }
    }, {
      key: 'startLoad',
      value: function startLoad(src) {
        /* istanbul ignore next */
        var currentTime = this.video.currentTime || tempCurrentTime;
        this.load(src);
        this.seek(currentTime);
      }

      // https://developer.mozilla.org/de/docs/Web/HTML/Using_HTML5_audio_and_video#Stopping_the_download_of_media

    }, {
      key: 'stopLoad',
      value: function stopLoad() {
        tempCurrentTime = this.video.currentTime;
        this.video.src = '';
        this.video.removeAttribute('src');
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        /* istanbul ignore next  */
        if (isElement(this.video)) this.stopLoad();
      }
    }, {
      key: 'play',
      value: function play() {
        return this.video.play();
      }
    }, {
      key: 'pause',
      value: function pause() {
        return this.video.pause();
      }
    }, {
      key: 'refresh',
      value: function refresh() {
        this.video.src = this.config.src;
      }
    }, {
      key: 'attachMedia',
      value: function attachMedia() {}
    }, {
      key: 'seek',
      value: function seek(seconds) {
        this.video.currentTime = seconds;
      }
    }]);

    return NativeVideoKernel;
  }(CustEvent);

  var LOG_TAG = 'chimee';
  var boxSuffixMap = {
    flv: '.flv',
    hls: '.m3u8',
    native: '.mp4'
  };

  // return the config box
  // or choose the right one according to the src
  function getLegalBox(_ref) {
    var src = _ref.src,
        box = _ref.box;

    if (isString(box) && box) return box;
    src = src.toLowerCase();
    for (var key in boxSuffixMap) {
      var suffix = boxSuffixMap[key];
      if (src.indexOf(suffix) > -1) return key;
    }
    return 'native';
  }

  var ChimeeKernel = function () {
    /**
    * kernelWrapper
    * @param {any} wrap videoElement
    * @param {any} option
    * @class kernel
    */
    function ChimeeKernel(videoElement, config) {
      _classCallCheck$1(this, ChimeeKernel);

      if (!isElement(videoElement)) throw new Error('You must pass in an video element to the chimee-kernel');
      this.config = config;
      this.videoElement = videoElement;
      this.initVideoKernel();
    }

    _createClass(ChimeeKernel, [{
      key: 'destroy',
      value: function destroy() {
        this.videoKernel.destroy();
      }
    }, {
      key: 'initVideoKernel',
      value: function initVideoKernel() {
        var config = this.config;
        var box = getLegalBox(config);
        this.box = box;
        var VideoKernel = this.chooseVideoKernel(this.box, config.preset);

        if (!isFunction(VideoKernel)) throw new Error('We can\'t find video kernel for ' + box + '. Please check your config and make sure it\'s installed or provided');

        var customConfig = config.presetConfig[this.box];

        // TODO: nowaday, kernels all get config from one config
        // it's not a good way, because custom config may override kernel config
        // so we may remove this code when we check all the chimee-kernel-* setting
        if (customConfig) deepAssign(config, customConfig);

        this.videoKernel = new VideoKernel(this.videoElement, config, customConfig);
      }

      // choose the right video kernel according to the box setting

    }, {
      key: 'chooseVideoKernel',
      value: function chooseVideoKernel(box, preset) {
        switch (box) {
          case 'native':
            // $FlowFixMe: it's the same as videoKernel
            return NativeVideoKernel;
          case 'mp4':
            return this.getMp4Kernel(preset.mp4);
          case 'flv':
          case 'hls':
            return preset[box];
          default:
            throw new Error('We currently do not support box ' + box + ', please contact us through https://github.com/Chimeejs/chimee/issues.');
        }
      }

      // fetch the legal mp4 kernel
      // if it's not exist or not support
      // we will fall back to the native video kernel

    }, {
      key: 'getMp4Kernel',
      value: function getMp4Kernel(Mp4Kernel) {
        var hasLegalMp4Kernel = Mp4Kernel && isFunction(Mp4Kernel.isSupport);
        // $FlowFixMe: we have make sure it's an kernel now
        var supportMp4Kernel = hasLegalMp4Kernel && Mp4Kernel.isSupport();
        // $FlowFixMe: we have make sure it's an kernel now
        if (supportMp4Kernel) return Mp4Kernel;
        if (hasLegalMp4Kernel) Log$1.warn(LOG_TAG, 'mp4 decode is not support in this browser, we will switch to the native video kernel');
        this.box = 'native';
        // $FlowFixMe: it's the same as videoKernel
        return NativeVideoKernel;
      }
    }, {
      key: 'attachMedia',
      value: function attachMedia() {
        this.videoKernel.attachMedia();
      }
    }, {
      key: 'load',
      value: function load() {
        var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config.src;

        this.config.src = src;
        this.videoKernel.load(src);
      }
    }, {
      key: 'startLoad',
      value: function startLoad() {
        /* istanbul ignore if */
        if (!isFunction(this.videoKernel.startLoad)) throw new Error('This video kernel do not support startLoad, please contact us on https://github.com/Chimeejs/chimee/issues');
        this.videoKernel.startLoad(this.config.src);
      }
    }, {
      key: 'stopLoad',
      value: function stopLoad() {
        /* istanbul ignore else */
        if (isFunction(this.videoKernel.stopLoad)) this.videoKernel.stopLoad();
      }
    }, {
      key: 'play',
      value: function play() {
        this.videoKernel.play();
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.videoKernel.pause();
      }
    }, {
      key: 'seek',
      value: function seek(seconds) {
        if (!isNumber(seconds)) {
          Log$1.error(LOG_TAG, 'When you try to seek, you must offer us a number, but not ' + (typeof seconds === 'undefined' ? 'undefined' : _typeof(seconds)));
          return;
        }
        this.videoKernel.seek(seconds);
      }
    }, {
      key: 'refresh',
      value: function refresh() {
        this.videoKernel.refresh();
      }
    }, {
      key: 'on',
      value: function on(key, fn) {
        this.videoKernel.on(key, fn);
      }
    }, {
      key: 'off',
      value: function off(key, fn) {
        this.videoKernel.off(key, fn);
      }
    }, {
      key: 'currentTime',
      get: function get$$1() {
        return this.videoElement.currentTime || 0;
      }
    }]);

    return ChimeeKernel;
  }();

  var videoEvents = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'interruptbegin', 'interruptend', 'loadeddata', 'loadedmetadata', 'loadstart', 'mozaudioavailable', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting', 'enterpictureinpicture', 'leavepictureinpicture'];
  var videoReadOnlyProperties = ['buffered', 'currentSrc', 'duration', 'error', 'ended', 'networkState', 'paused', 'readyState', 'seekable', 'sinkId', 'controlsList', 'tabIndex', 'dataset', 'offsetHeight', 'offsetLeft', 'offsetParent', 'offsetTop', 'offsetWidth'];
  var domEvents = ['beforeinput', 'blur', 'click', 'compositionend', 'compositionstart', 'compositionupdate', 'dblclick', 'focus', 'focusin', 'focusout', 'input', 'keydown', 'keypress', 'keyup', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'resize', 'scroll', 'select', 'wheel', 'mousewheel', 'contextmenu', 'touchstart', 'touchmove', 'touchend', 'fullscreen'];
  var esFullscreenEvents = ['fullscreenchange'];
  var passiveEvents = ['wheel', 'mousewheel', 'touchstart', 'touchmove'];
  var selfProcessorEvents = ['silentLoad', 'fullscreen'];
  var mustListenVideoDomEvents = ['mouseenter', 'mouseleave'];
  var kernelMethods = ['play', 'pause', 'seek', 'startLoad', 'stopLoad'];
  var dispatcherEventMethodMap = {
    load: 'load',
    enterpictureinpicture: 'requestPictureInPicture',
    leavepictureinpicture: 'exitPictureInPicture'
  };
  var kernelEvents = ['mediaInfo', 'heartbeat', 'error'];
  var domMethods = ['focus', 'fullscreen', 'requestFullscreen', 'exitFullscreen'];
  var videoMethods = ['canPlayType', 'captureStream', 'setSinkId'];

  /**
   * checker for on, off, once function
   * @param {string} key
   * @param {Function} fn
   */
  function eventBinderCheck(key, fn) {
    if (!isString(key)) throw new TypeError('key parameter must be String');
    if (!isFunction(fn)) throw new TypeError('fn parameter must be Function');
  }
  /**
   * checker for attr or css function
   */
  function attrAndStyleCheck() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length > 2) {
      return ['set'].concat(args);
    }
    if (args.length === 2) {
      if (['video', 'container', 'wrapper', 'videoElement'].indexOf(args[0]) > -1) {
        return ['get'].concat(args);
      }
      return ['set', 'container'].concat(args);
    }
    return ['get', 'container'].concat(args);
  }

  var _dec$1, _dec2$1, _class$1, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    _Object$defineProperty(target, property, {
      enumerable: descriptor.enumerable,
      configurable: descriptor.configurable,
      writable: descriptor.writable,
      value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
  }

  function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  function stringOrVoid(value) {
    return isString(value) ? value : undefined;
  }

  function accessorVideoProperty(property) {
    return accessor({
      get: function get$$1(value) {
        return this.dispatcher.videoConfigReady && this.inited ? this.dom.videoElement[property] : value;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        this.dom.videoElement[property] = value;
        return value;
      }
    });
  }

  function accessorVideoAttribute(attribute) {
    var _ref = isObject(attribute) ? attribute : {
      set: attribute,
      get: attribute,
      isBoolean: false
    },
        _set = _ref.set,
        _get$$1 = _ref.get,
        isBoolean$$1 = _ref.isBoolean;

    return accessor({
      get: function get$$1(value) {
        return this.dispatcher.videoConfigReady && this.inited ? this.dom.videoElement[_get$$1] : value;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        var val = isBoolean$$1 ? value ? '' : undefined
        /* istanbul ignore next */
        : value === null ? undefined : value;
        this.dom.setAttr('video', _set, val);
        return value;
      }
    }, {
      preSet: false
    });
  }

  function accessorCustomAttribute(attribute, isBoolean$$1) {
    return accessor({
      get: function get$$1(value) {
        var attrValue = this.dom.getAttr('video', attribute);
        return this.dispatcher.videoConfigReady && this.inited ? isBoolean$$1 ? !!attrValue : attrValue : value;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        var val = isBoolean$$1 ? value || undefined : value === null ? undefined : value;
        this.dom.setAttr('video', attribute, val);
        return value;
      }
    });
  }

  function accessorWidthAndHeight(property) {
    return accessor({
      get: function get$$1(value) {
        if (!this.dispatcher.videoConfigReady || !this.inited) return value;
        var attr = this.dom.getAttr('video', property);
        var prop = this.dom.videoElement[property];
        if (isNumeric(attr) && isNumber(prop)) return prop;
        return attr || undefined;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        var val = void 0;
        if (value === undefined || isNumber(value)) {
          val = value;
        } else if (isString(value) && !_Number$isNaN(parseFloat(value))) {
          val = value;
        }
        this.dom.setAttr('video', property, val);
        return val;
      }
    });
  }

  var accessorMap = {
    src: [string$1(), accessor({
      set: function set(val) {
        // must check val !== this.src here
        // as we will set config.src in the video
        // the may cause dead lock
        if (this.dispatcher.readySync && this.autoload && val !== this.src) this.needToLoadSrc = true;
        return val;
      }
    }), accessor({
      set: function set(val) {
        if (this.needToLoadSrc) {
          // unlock it at first, to avoid deadlock
          this.needToLoadSrc = false;
          this.dispatcher.binder.emit({
            name: 'load',
            target: 'plugin',
            id: 'dispatcher'
          }, val);
        }
        return val;
      }
    }, { preSet: false })],
    autoload: boolean$1(),
    autoplay: [boolean$1(), accessorVideoProperty('autoplay')],
    controls: [boolean$1(), accessorVideoProperty('controls')],
    width: [accessorWidthAndHeight('width')],
    height: [accessorWidthAndHeight('height')],
    crossOrigin: [accessor({ set: stringOrVoid }), accessorVideoAttribute({ set: 'crossorigin', get: 'crossOrigin' })],
    loop: [boolean$1(), accessorVideoProperty('loop')],
    defaultMuted: [boolean$1(), accessorVideoAttribute({ get: 'defaultMuted', set: 'muted', isBoolean: true })],
    muted: [boolean$1(), accessorVideoProperty('muted')],
    preload: [accessor({
      set: function set(value) {
        var options = ['none', 'auto', 'metadata', ''];
        return options.indexOf(value) > -1 ? value : 'none';
      }
    }, {
      preSet: true
    }), accessorVideoAttribute('preload')],
    poster: [
    // 因为如果在 video 上随便加一个字符串，他会将其拼接到地址上，所以这里要避免
    // 单元测试无法检测
    string$1(), accessor({
      get: function get$$1(value) {
        return this.dispatcher.videoConfigReady && this.inited ? this.dom.videoElement.poster : value;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        if (value.length) this.dom.setAttr('video', 'poster', value);
        return value;
      }
    })],
    playsInline: [accessor({
      get: function get$$1(value) {
        var playsInline = this.dom.videoElement.playsInline;
        return this.dispatcher.videoConfigReady && this.inited ? playsInline === undefined ? value : playsInline : value;
      },
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        this.dom.videoElement.playsInline = value;
        var val = value ? '' : undefined;
        this.dom.setAttr('video', 'playsinline', val);
        this.dom.setAttr('video', 'webkit-playsinline', val);
        this.dom.setAttr('video', 'x5-playsinline', val);
        return value;
      }
    }), boolean$1()],
    x5VideoPlayerFullscreen: [accessor({
      set: function set(value) {
        return !!value;
      },
      get: function get$$1(value) {
        return !!value;
      }
    }), accessorCustomAttribute('x5-video-player-fullscreen', true)],
    x5VideoOrientation: [accessor({ set: stringOrVoid }), accessorCustomAttribute('x5-video-orientation')],
    x5VideoPlayerType: [accessor({
      set: function set(value) {
        if (!this.dispatcher.videoConfigReady) return value;
        var val = value === 'h5' ? 'h5' : undefined;
        this.dom.setAttr('video', 'x5-video-player-type', val);
        return value;
      },
      get: function get$$1(value) {
        return this.dispatcher.videoConfigReady && value || (this.dom.getAttr('video', 'x5-video-player-type') ? 'h5' : undefined);
      }
    })],
    xWebkitAirplay: [accessor({
      set: function set(value) {
        return !!value;
      },
      get: function get$$1(value) {
        return !!value;
      }
    }), accessorCustomAttribute('x-webkit-airplay', true)],
    playbackRate: [number$1(1), accessorVideoProperty('playbackRate')],
    defaultPlaybackRate: [accessorVideoProperty('defaultPlaybackRate'), number$1(1)],
    disableRemotePlayback: [boolean$1(), accessorVideoProperty('disableRemotePlayback')],
    volume: [number$1(1), accessorVideoProperty('volume')]
  };

  var VideoConfig = (_dec$1 = boolean(), _dec2$1 = string(function (str) {
    return str.toLocaleLowerCase();
  }), (_class$1 = function () {

    // 转为供 kernel 使用的内部参数
    function VideoConfig(dispatcher, config) {
      _classCallCheck$1(this, VideoConfig);

      _initDefineProp(this, 'needToLoadSrc', _descriptor, this);

      _initDefineProp(this, 'changeWatchable', _descriptor2, this);

      _initDefineProp(this, 'inited', _descriptor3, this);

      this.src = '';

      _initDefineProp(this, 'isLive', _descriptor4, this);

      _initDefineProp(this, 'box', _descriptor5, this);

      this.preset = {};
      this.presetConfig = {};
      this.autoload = true;
      this.autoplay = false;
      this.controls = false;
      this.width = '100%';
      this.height = '100%';
      this.crossOrigin = undefined;
      this.loop = false;
      this.defaultMuted = false;
      this.muted = false;
      this.preload = 'auto';
      this.poster = undefined;
      this.playsInline = false;
      this.x5VideoPlayerFullscreen = false;
      this.x5VideoOrientation = undefined;
      this.x5VideoPlayerType = undefined;
      this.xWebkitAirplay = false;
      this.playbackRate = 1;
      this.defaultPlaybackRate = 1;
      this.disableRemotePlayback = false;
      this.volume = 1;

      _initDefineProp(this, '_kernelProperty', _descriptor6, this);

      _initDefineProp(this, '_realDomAttr', _descriptor7, this);

      applyDecorators(this, accessorMap, { self: true });
      Object.defineProperty(this, 'dispatcher', {
        value: dispatcher,
        enumerable: false,
        writable: false,
        configurable: false
      });
      Object.defineProperty(this, 'dom', {
        value: dispatcher.dom,
        enumerable: false,
        writable: false,
        configurable: false
      });
      deepAssign(this, config);
    }

    // 此处 box 只能置空，因为 kernel 会自动根据你的安装 kernel 和相关地址作智能判断。
    // 曾经 bug 详见 https://github.com/Chimeejs/chimee-kernel/issues/1

    // kernels 不在 videoConfig 上设置默认值，防止判断出错


    _createClass(VideoConfig, [{
      key: 'init',
      value: function init() {
        var _this = this;

        this._realDomAttr.forEach(function (key) {
          // $FlowFixMe: we have check the computed here
          _this[key] = _this[key];
        });
        this.inited = true;
      }
    }]);

    return VideoConfig;
  }(), (_descriptor = _applyDecoratedDescriptor$1(_class$1.prototype, 'needToLoadSrc', [nonenumerable], {
    enumerable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor$1(_class$1.prototype, 'changeWatchable', [nonenumerable], {
    enumerable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor3 = _applyDecoratedDescriptor$1(_class$1.prototype, 'inited', [nonenumerable], {
    enumerable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor$1(_class$1.prototype, 'isLive', [_dec$1, nonconfigurable], {
    enumerable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor$1(_class$1.prototype, 'box', [_dec2$1, nonconfigurable], {
    enumerable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor6 = _applyDecoratedDescriptor$1(_class$1.prototype, '_kernelProperty', [frozen], {
    enumerable: true,
    initializer: function initializer() {
      return ['isLive', 'box', 'preset', 'kernels', 'presetConfig'];
    }
  }), _descriptor7 = _applyDecoratedDescriptor$1(_class$1.prototype, '_realDomAttr', [frozen], {
    enumerable: true,
    initializer: function initializer() {
      return ['src', 'controls', 'width', 'height', 'crossOrigin', 'loop', 'muted', 'preload', 'poster', 'autoplay', 'playsInline', 'x5VideoPlayerFullscreen', 'x5VideoOrientation', 'xWebkitAirplay', 'playbackRate', 'defaultPlaybackRate', 'autoload', 'disableRemotePlayback', 'defaultMuted', 'volume', 'x5VideoPlayerType'];
    }
  })), _class$1));

  var _dec$1$1, _dec2$1$1, _dec3$1, _dec4$1, _dec5$1, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class$1$1, _class2$1;

  function _applyDecoratedDescriptor$1$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  var VideoWrapper = (_dec$1$1 = autobindClass(), _dec2$1$1 = alias('silentLoad'), _dec3$1 = alias('fullScreen'), _dec4$1 = alias('$fullScreen'), _dec5$1 = alias('fullscreen'), _dec6 = alias('emit'), _dec7 = alias('emitSync'), _dec8 = alias('on'), _dec9 = alias('addEventListener'), _dec10 = before(eventBinderCheck), _dec11 = alias('off'), _dec12 = alias('removeEventListener'), _dec13 = before(eventBinderCheck), _dec14 = alias('once'), _dec15 = before(eventBinderCheck), _dec16 = alias('css'), _dec17 = before(attrAndStyleCheck), _dec18 = alias('attr'), _dec19 = before(attrAndStyleCheck), _dec$1$1(_class$1$1 = (_class2$1 = function () {
    function VideoWrapper() {
      _classCallCheck$1(this, VideoWrapper);

      this.__events = {};
      this.__unwatchHandlers = [];
    }

    _createClass(VideoWrapper, [{
      key: '__wrapAsVideo',
      value: function __wrapAsVideo(videoConfig) {
        var _this = this;

        // bind video read only properties on instance, so that you can get info like buffered
        videoReadOnlyProperties.forEach(function (key) {
          _Object$defineProperty(_this, key, {
            get: function get$$1() {
              return this.__dispatcher.dom.videoElement[key];
            },

            set: undefined,
            configurable: false,
            enumerable: false
          });
        });
        // bind videoMethods like canplaytype on instance
        videoMethods.forEach(function (key) {
          _Object$defineProperty(_this, key, {
            get: function get$$1() {
              var video = this.__dispatcher.dom.videoElement;
              return bind(video[key], video);
            },

            set: undefined,
            configurable: false,
            enumerable: false
          });
        });
        // bind video config properties on instance, so that you can just set src by this
        var props = videoConfig._realDomAttr.concat(videoConfig._kernelProperty).reduce(function (props, key) {
          props[key] = [accessor({
            get: function get$$1() {
              // $FlowFixMe: support computed key here
              return videoConfig[key];
            },
            set: function set(value) {
              // $FlowFixMe: support computed key here
              videoConfig[key] = value;
              return value;
            }
          }), nonenumerable];
          return props;
        }, {});
        applyDecorators(this, props, { self: true });
        kernelMethods.forEach(function (key) {
          _Object$defineProperty(_this, key, {
            value: function value() {
              var _this2 = this;

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return new _Promise(function (resolve) {
                var _dispatcher$binder;

                var id = _this2.__id;
                _this2.__dispatcher.binder.once({
                  id: id,
                  name: '_' + key,
                  fn: resolve
                });
                (_dispatcher$binder = _this2.__dispatcher.binder)[/^(seek)$/.test(key) ? 'emitSync' : 'emit'].apply(_dispatcher$binder, [{
                  target: 'video',
                  name: key,
                  id: id
                }].concat(_toConsumableArray(args)));
              });
            },

            configurable: true,
            enumerable: false,
            writable: true
          });
        });
        domMethods.forEach(function (key) {
          if (key === 'fullscreen') return;
          _Object$defineProperty(_this, key, {
            value: function value() {
              var _dispatcher$dom;

              return (_dispatcher$dom = this.__dispatcher.dom)[key].apply(_dispatcher$dom, arguments);
            },

            configurable: true,
            enumerable: false,
            writable: true
          });
        });
      }
    }, {
      key: '$watch',
      value: function $watch(key, handler) {
        var _this3 = this;

        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            deep = _ref.deep,
            _ref$diff = _ref.diff,
            diff = _ref$diff === undefined ? true : _ref$diff,
            other = _ref.other,
            _ref$proxy = _ref.proxy,
            proxy = _ref$proxy === undefined ? false : _ref$proxy;

        if (!isString(key) && !isArray(key)) throw new TypeError('$watch only accept string and Array<string> as key to find the target to spy on, but not ' + key + ', whose type is ' + (typeof key === 'undefined' ? 'undefined' : _typeof(key)));
        var watching = true;
        var watcher = function watcher() {
          if (watching && (!(this instanceof VideoConfig) || this.dispatcher.changeWatchable)) bind(handler, this).apply(undefined, arguments);
        };
        var unwatcher = function unwatcher() {
          watching = false;
          var index$$1 = _this3.__unwatchHandlers.indexOf(unwatcher);
          if (index$$1 > -1) _this3.__unwatchHandlers.splice(index$$1, 1);
        };
        var keys = isString(key) ? key.split('.') : key;
        var property = keys.pop();
        var videoConfig = this.__dispatcher.videoConfig;
        var target = keys.length === 0 && !other && videoConfig._realDomAttr.indexOf(property) > -1 ? videoConfig : ['isFullscreen', 'fullscreenElement'].indexOf(property) > -1 ? this.__dispatcher.dom : getDeepProperty(other || this, keys, { throwError: true });
        applyDecorators(target, _defineProperty({}, property, watch(watcher, { deep: deep, diff: diff, proxy: proxy })), { self: true });
        this.__unwatchHandlers.push(unwatcher);
        return unwatcher;
      }
    }, {
      key: '$set',
      value: function $set(obj, property, value) {
        if (!isObject(obj) && !isArray(obj)) throw new TypeError('$set only support Array or Object, but not ' + obj + ', whose type is ' + (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)));
        // $FlowFixMe: we have custom this function
        if (!isFunction(obj.__set)) {
          // $FlowFixMe: we support computed string on array here
          obj[property] = value;
          return;
        }
        obj.__set(property, value);
      }
    }, {
      key: '$del',
      value: function $del(obj, property) {
        if (!isObject(obj) && !isArray(obj)) throw new TypeError('$del only support Array or Object, but not ' + obj + ', whose type is ' + (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)));
        // $FlowFixMe: we have custom this function
        if (!isFunction(obj.__del)) {
          // $FlowFixMe: we support computed string on array here
          delete obj[property];
          return;
        }
        obj.__del(property);
      }
    }, {
      key: 'load',
      value: function load() {
        var _this4 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return new _Promise(function (resolve) {
          var _dispatcher$binder2;

          _this4.__dispatcher.binder.once({
            id: _this4.__id,
            name: '_load',
            target: 'plugin',
            fn: resolve
          });
          (_dispatcher$binder2 = _this4.__dispatcher.binder).emit.apply(_dispatcher$binder2, [{
            name: 'load',
            target: 'plugin',
            id: _this4.__id
          }].concat(args));
        });
      }
    }, {
      key: '$silentLoad',
      value: function $silentLoad() {
        var _this5 = this;

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return this.__dispatcher.binder.emit({
          name: 'silentLoad',
          target: 'video',
          id: this.__id
        }).then(function () {
          var _dispatcher;

          return (_dispatcher = _this5.__dispatcher).silentLoad.apply(_dispatcher, args);
        }).then(function (result) {
          _this5.__dispatcher.binder.trigger({
            name: 'silentLoad',
            target: 'video',
            id: _this5.__id
          }, result);
        });
      }

      /**
       * call fullscreen api on some specific element
       * @param {boolean} flag true means fullscreen and means exit fullscreen
       * @param {string} element the element you want to fullscreen, default it's container, you can choose from video | container | wrapper
       */

    }, {
      key: '$fullscreen',
      value: function $fullscreen() {
        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'container';

        if (!this.__dispatcher.binder.emitSync({
          name: 'fullscreen',
          id: this.__id,
          target: 'video-dom'
        }, flag, element)) return false;
        var result = this.__dispatcher.dom.fullscreen(flag, element);
        this.__dispatcher.binder.triggerSync({
          name: 'fullscreen',
          id: this.__id,
          target: 'video-dom'
        }, flag, element);
        return result;
      }

      /**
       * emit an event
       * @param  {string}    key event's name
       * @param  {...args} args
       */

    }, {
      key: '$emit',
      value: function $emit(key) {
        var _dispatcher$binder3;

        var target = void 0;
        if (isObject(key) && isString(key.name) && isString(key.target)) {
          target = key.target;
          key = key.name;
        }
        if (!isString(key)) throw new TypeError('emit key parameter must be String');

        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        return (_dispatcher$binder3 = this.__dispatcher.binder).emit.apply(_dispatcher$binder3, [{
          name: key,
          id: this.__id,
          target: target
        }].concat(_toConsumableArray(args)));
      }

      /**
       * emit a sync event
       * @param  {string}    key event's name
       * @param  {...args} args
       */

    }, {
      key: '$emitSync',
      value: function $emitSync(key) {
        var _dispatcher$binder4;

        var target = void 0;
        if (isObject(key) && isString(key.name) && isString(key.target)) {
          target = key.target;
          key = key.name;
        }
        if (!isString(key)) throw new TypeError('emitSync key parameter must be String');

        for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        return (_dispatcher$binder4 = this.__dispatcher.binder).emitSync.apply(_dispatcher$binder4, [{
          name: key,
          id: this.__id,
          target: target
        }].concat(_toConsumableArray(args)));
      }

      /**
       * bind event handler through this function
       * @param  {string} key event's name
       * @param  {Function} fn event's handler
       */

    }, {
      key: '$on',
      value: function $on(key, fn) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var eventInfo = _Object$assign({}, options, {
          name: key,
          id: this.__id,
          fn: fn
        });
        this.__dispatcher.binder.on(eventInfo);
        // set on __events as mark so that i can destroy it when i destroy
        this.__addEvents(key, fn);
      }
      /**
       * remove event handler through this function
       * @param  {string} key event's name
       * @param  {Function} fn event's handler
       */

    }, {
      key: '$off',
      value: function $off(key, fn) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var eventInfo = _Object$assign({}, options, {
          name: key,
          id: this.__id,
          fn: fn
        });
        this.__dispatcher.binder.off(eventInfo);
        this.__removeEvents(key, fn);
      }
      /**
       * bind one time event handler
       * @param {string} key event's name
       * @param {Function} fn event's handler
       */

    }, {
      key: '$once',
      value: function $once(key, fn) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var self = this;
        var boundFn = function boundFn() {
          bind(fn, this).apply(undefined, arguments);
          self.__removeEvents(key, boundFn);
        };
        self.__addEvents(key, boundFn);
        var eventInfo = _Object$assign({}, options, {
          name: key,
          id: this.__id,
          fn: boundFn
        });
        this.__dispatcher.binder.once(eventInfo);
      }

      /**
       * set style
       * @param {string} element optional, default to be video, you can choose from video | container | wrapper
       * @param {string} attribute the atrribue name
       * @param {any} value optional, when it's no offer, we consider you want to get the attribute's value. When it's offered, we consider you to set the attribute's value, if the value you passed is undefined, that means you want to remove the value;
       */

    }, {
      key: '$css',
      value: function $css(method) {
        var _dispatcher$dom2;

        for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          args[_key6 - 1] = arguments[_key6];
        }

        return (_dispatcher$dom2 = this.__dispatcher.dom)[method + 'Style'].apply(_dispatcher$dom2, args);
      }

      /**
       * set attr
       * @param {string} element optional, default to be video, you can choose from video | container | wrapper
       * @param {string} attribute the atrribue nameß
       * @param {any} value optional, when it's no offer, we consider you want to get the attribute's value. When it's offered, we consider you to set the attribute's value, if the value you passed is undefined, that means you want to remove the value;
       */

    }, {
      key: '$attr',
      value: function $attr(method) {
        var _dispatcher$dom3;

        for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }

        if (method === 'set' && /video/.test(args[0])) {
          if (!this.__dispatcher.videoConfigReady) {
            return args[2];
          }
          if (this.__dispatcher.videoConfig._realDomAttr.indexOf(args[1]) > -1) {
            var key = args[1],
                val = args[2];

            this.__dispatcher.videoConfig[key] = val;
            return val;
          }
        }
        return (_dispatcher$dom3 = this.__dispatcher.dom)[method + 'Attr'].apply(_dispatcher$dom3, args);
      }
    }, {
      key: 'requestPictureInPicture',
      value: function requestPictureInPicture() {
        return this.__dispatcher.binder.emit({
          target: 'video',
          name: 'enterpictureinpicture',
          id: this.__id
        });
      }
    }, {
      key: 'exitPictureInPicture',
      value: function exitPictureInPicture() {
        return this.__dispatcher.binder.emit({
          target: 'video',
          name: 'leavepictureinpicture',
          id: this.__id
        });
      }
    }, {
      key: '__addEvents',
      value: function __addEvents(key, fn) {
        this.__events[key] = this.__events[key] || [];
        this.__events[key].push(fn);
      }
    }, {
      key: '__removeEvents',
      value: function __removeEvents(key, fn) {
        if (isEmpty(this.__events[key])) return;
        var index$$1 = this.__events[key].indexOf(fn);
        if (index$$1 < 0) return;
        this.__events[key].splice(index$$1, 1);
        if (isEmpty(this.__events[key])) delete this.__events[key];
      }
    }, {
      key: '__destroy',
      value: function __destroy() {
        var _this6 = this;

        this.__unwatchHandlers.forEach(function (unwatcher) {
          return unwatcher();
        });
        _Object$keys(this.__events).forEach(function (key) {
          if (!isArray(_this6.__events[key])) return;
          _this6.__events[key].forEach(function (fn) {
            return _this6.$off(key, fn);
          });
        });
        delete this.__events;
      }
    }, {
      key: 'currentTime',
      get: function get$$1() {
        return this.__dispatcher.kernel.currentTime;
      },
      set: function set(second) {
        this.__dispatcher.binder.emitSync({
          name: 'seek',
          target: 'video',
          id: this.__id
        }, second);
      }
    }, {
      key: 'inPictureInPictureMode',
      get: function get$$1() {
        return this.__dispatcher.inPictureInPictureMode;
      }
    }, {
      key: 'pictureInPictureWindow',
      get: function get$$1() {
        return window.__chimee_picture_in_picture_window;
      }
    }, {
      key: '$plugins',
      get: function get$$1() {
        return this.__dispatcher.plugins;
      }
    }, {
      key: '$pluginOrder',
      get: function get$$1() {
        return this.__dispatcher.order;
      }
    }, {
      key: '$wrapper',
      get: function get$$1() {
        return this.__dispatcher.dom.wrapper;
      }
    }, {
      key: '$container',
      get: function get$$1() {
        return this.__dispatcher.dom.container;
      }
    }, {
      key: '$video',
      get: function get$$1() {
        return this.__dispatcher.dom.videoElement;
      }
    }, {
      key: 'isFullscreen',
      get: function get$$1() {
        return this.__dispatcher.dom.isFullscreen;
      }
    }, {
      key: 'fullscreenElement',
      get: function get$$1() {
        return this.__dispatcher.dom.fullscreenElement;
      }
    }, {
      key: 'container',
      get: function get$$1() {
        return this.__dispatcher.containerConfig;
      },
      set: function set(config) {
        if (!isObject(config)) {
          throw new Error('The config of container must be Object, but not ' + (typeof config === 'undefined' ? 'undefined' : _typeof(config)) + '.');
        }
        deepAssign(this.__dispatcher.containerConfig, config);
        return this.__dispatcher.container;
      }
    }, {
      key: 'videoRequireGuardedAttributes',
      get: function get$$1() {
        return this.__dispatcher.dom.videoRequireGuardedAttributes;
      }
    }]);

    return VideoWrapper;
  }(), (_applyDecoratedDescriptor$1$1(_class2$1.prototype, '$silentLoad', [_dec2$1$1], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$silentLoad'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$fullscreen', [_dec3$1, _dec4$1, _dec5$1], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$fullscreen'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$emit', [_dec6], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$emit'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$emitSync', [_dec7], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$emitSync'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$on', [_dec8, _dec9, _dec10], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$on'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$off', [_dec11, _dec12, _dec13], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$off'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$once', [_dec14, _dec15], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$once'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$css', [_dec16, _dec17], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$css'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$attr', [_dec18, _dec19], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$attr'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, 'inPictureInPictureMode', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, 'inPictureInPictureMode'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, 'pictureInPictureWindow', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, 'pictureInPictureWindow'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$plugins', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$plugins'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$pluginOrder', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$pluginOrder'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$wrapper', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$wrapper'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$container', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$container'), _class2$1.prototype), _applyDecoratedDescriptor$1$1(_class2$1.prototype, '$video', [nonenumerable], _Object$getOwnPropertyDescriptor(_class2$1.prototype, '$video'), _class2$1.prototype)), _class2$1)) || _class$1$1);

  var _dec$2, _class$2;

  /**
   * <pre>
   * Plugin is the class for plugin developer.
   * When we use a plugin, we will generate an instance of plugin.
   * Developer can do most of things base on this plugin
   * </pre>
   */
  var Plugin = (_dec$2 = autobindClass(), _dec$2(_class$2 = function (_VideoWrapper) {
    _inherits$1(Plugin, _VideoWrapper);

    /**
     * <pre>
     * to create a plugin, we need three parameter
     * 1. the config of a plugin
     * 2. the dispatcher
     * 3. this option for plugin to read
     * this is the plugin base class, which you can get on Chimee
     * You can just extends it and then install
     * But in that way you must remember to pass the arguments to super()
     * </pre>
     * @param  {string}  PluginConfig.id        camelize from plugin's name or class name.
     * @param  {string}  PluginConfig.name      plugin's name or class name
     * @param  {Number}  PluginConfig.level     the level of z-index
     * @param  {Boolean} PluginConfig.operable  to tell if the plugin can be operable, if not, we will add pointer-events: none on it.
     * @param  {Function}  PluginConfig.create  the create function which we will called when plugin is used. sth like constructor in object style.
     * @param  {Function}  PluginConfig.destroy   function to be called when we destroy a plugin
     * @param  {Object}  PluginConfig.events    You can set some events handler in this object, we will bind it once you use the plugin.
     * @param  {Object}  PluginConfig.data      dataset we will bind on data in object style
     * @param  {Object<{get: Function, set: Function}}  PluginConfig.computed  dataset we will handle by getter and setter
     * @param  {Object<Function>}  PluginConfig.methods   some function we will bind on plugin
     * @param  {string|HTMLElment}  PluginConfig.el  can be string or HTMLElement, we will use this to create the dom for plugin
     * @param  {boolean} PluginConfig.penetrate boolean to let us do we need to forward the dom events for this plugin.
     * @param  {Dispatcher}  dispatcher referrence of dispatcher
     * @param  {Object}  option  PluginOption that will pass to the plugin
     * @return {Plugin}  plugin instance
     */
    function Plugin() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref.id,
          name = _ref.name,
          _ref$level = _ref.level,
          level = _ref$level === undefined ? 0 : _ref$level,
          _ref$operable = _ref.operable,
          operable = _ref$operable === undefined ? true : _ref$operable,
          beforeCreate = _ref.beforeCreate,
          create = _ref.create,
          init = _ref.init,
          inited = _ref.inited,
          destroy = _ref.destroy,
          _ref$events = _ref.events,
          events = _ref$events === undefined ? {} : _ref$events,
          _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data,
          _ref$computed = _ref.computed,
          computed = _ref$computed === undefined ? {} : _ref$computed,
          _ref$methods = _ref.methods,
          methods = _ref$methods === undefined ? {} : _ref$methods,
          el = _ref.el,
          _ref$penetrate = _ref.penetrate,
          penetrate = _ref$penetrate === undefined ? false : _ref$penetrate,
          _ref$inner = _ref.inner,
          inner = _ref$inner === undefined ? true : _ref$inner,
          autoFocus = _ref.autoFocus,
          className = _ref.className;

      var dispatcher = arguments[1];
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { name: name };

      _classCallCheck$1(this, Plugin);

      var _this = _possibleConstructorReturn$1(this, (Plugin.__proto__ || _Object$getPrototypeOf(Plugin)).call(this));

      _this.destroyed = false;
      _this.VERSION = '0.11.0';
      _this.__operable = true;
      _this.__level = 0;

      if (isEmpty(dispatcher)) {
        throw new TypeError('lack of dispatcher');
      }
      if (!isString(id)) {
        throw new TypeError('id of PluginConfig must be string');
      }
      _this.__id = id;
      _this.__dispatcher = dispatcher;
      _this.$videoConfig = _this.__dispatcher.videoConfig;
      _this.__wrapAsVideo(_this.$videoConfig);
      _this.beforeCreate = _this.beforeCreate || beforeCreate;
      try {
        isFunction(_this.beforeCreate) && _this.beforeCreate({
          events: events,
          data: data,
          computed: computed,
          methods: methods
        }, option);
      } catch (error) {
        _this.$throwError(error);
      }
      // bind plugin methods into instance
      if (!isEmpty(methods) && isObject(methods)) {
        _Object$keys(methods).forEach(function (key) {
          var fn = methods[key];
          if (!isFunction(fn)) throw new TypeError('plugins methods must be Function');
          _Object$defineProperty(_this, key, {
            value: bind(fn, _this),
            writable: true,
            enumerable: false,
            configurable: true
          });
        });
      }
      // hook plugin events on bus
      if (!isEmpty(events) && isObject(events)) {
        _Object$keys(events).forEach(function (key) {
          if (!isFunction(events[key])) throw new TypeError('plugins events hook must bind with Function');
          _this.$on(key, events[key]);
        });
      }
      // bind data into plugin instance
      if (!isEmpty(data) && isObject(data)) {
        deepAssign(_this, data);
      }
      // set the computed member by getter and setter
      if (!isEmpty(computed) && isObject(computed)) {
        var props = _Object$keys(computed).reduce(function (props, key) {
          var val = computed[key];
          if (isFunction(val)) {
            props[key] = accessor({ get: val });
            return props;
          }
          if (isObject(val) && (isFunction(val.get) || isFunction(val.set))) {
            props[key] = accessor(val);
            return props;
          }
          return props;
        }, {});
        applyDecorators(_this, props, { self: true });
      }
      /**
       * the create Function of plugin
       * @type {Function}
       */
      _this.create = _this.create || create;
      /**
       * this init Function of plugin
       * which will be called when we start to create the video player
       * the plugin can handle some config here
       * @type {Function}
       */
      _this.init = _this.init || init;
      /**
       * this inited Function of plugin
       * which will be called when we have created the video player
       * @type {Function}
       */
      _this.inited = _this.inited || inited;
      /**
       * the destroy Function of plugin
       * @type {Function}
       */
      _this.destroy = _this.destroy || destroy;
      /**
       * the dom node of whole plugin
       * @type {HTMLElement}
       */
      _this.$dom = _this.__dispatcher.dom.insertPlugin(_this.__id, el, { penetrate: penetrate, inner: inner, className: className });
      _this.$autoFocus = isBoolean(autoFocus) ? autoFocus : inner;
      // now we can frozen inner, autoFocus and penetrate
      _this.$inner = inner;
      _this.$penetrate = penetrate;
      applyDecorators(_this, {
        $inner: frozen,
        $penetrate: frozen
      }, { self: true });
      /**
       * to tell us if the plugin can be operable, can be dynamic change
       * @type {boolean}
       */
      _this.$operable = isBoolean(option.operable) ? option.operable : operable;
      _this.__level = isInteger$2(option.level) ? option.level : level;
      /**
       * pluginOption, so it's easy for plugin developer to check the config
       * @type {Object}
       */
      _this.$config = option;
      try {
        isFunction(_this.create) && _this.create();
      } catch (error) {
        _this.$throwError(error);
      }
      return _this;
    }
    /**
     * call for init lifecycle hook, which mainly handle the original config of video and kernel.
     * @param {VideoConfig} videoConfig the original config of the videoElement or Kernel
     */


    _createClass(Plugin, [{
      key: '__init',
      value: function __init(videoConfig) {
        try {
          isFunction(this.init) && this.init(videoConfig);
        } catch (error) {
          this.$throwError(error);
        }
      }
      /**
       * call for inited lifecycle hook, which just to tell the plugin we have inited.
       */

    }, {
      key: '__inited',
      value: function __inited() {
        var _this2 = this;

        var result = void 0;
        try {
          result = isFunction(this.inited) && this.inited();
        } catch (error) {
          this.$throwError(error);
        }
        this.readySync = !isPromise(result);
        this.ready = this.readySync ? _Promise.resolve(this)
        // $FlowFixMe: it's promise now
        : result.then(function () {
          _this2.readySync = true;
          return _this2;
        }).catch(function (error) {
          if (isError(error)) return _this2.$throwError(error);
          return _Promise.reject(error);
        });
        return this.readySync ? this : this.ready;
      }

      /**
       * set the plugin to be the top of all plugins
       */

    }, {
      key: '$bumpToTop',
      value: function $bumpToTop() {
        var topLevel = this.__dispatcher._getTopLevel(this.$inner);
        this.$level = topLevel + 1;
      }
    }, {
      key: '$throwError',
      value: function $throwError(error) {
        this.__dispatcher.throwError(error);
      }
      /**
       * officail destroy function for plugin
       * we will call user destory function in this method
       */

    }, {
      key: '$destroy',
      value: function $destroy() {
        if (this.destroyed) return;
        isFunction(this.destroy) && this.destroy();
        _get(Plugin.prototype.__proto__ || _Object$getPrototypeOf(Plugin.prototype), '__destroy', this).call(this);
        this.__dispatcher.dom.removePlugin(this.__id);
        delete this.__dispatcher;
        delete this.$dom;
        this.destroyed = true;
      }
      /**
       * to tell us if the plugin can be operable, can be dynamic change
       * @type {boolean}
       */

    }, {
      key: '$operable',
      set: function set(val) {
        if (!isBoolean(val)) return;
        this.$dom.style.pointerEvents = val ? 'auto' : 'none';
        this.__operable = val;
      },
      get: function get$$1() {
        return this.__operable;
      }
      /**
       * the z-index level, higher when you set higher
       * @type {boolean}
       */

    }, {
      key: '$level',
      set: function set(val) {
        if (!isInteger$2(val)) return;
        this.__level = val;
        this.__dispatcher._sortZIndex();
      },
      get: function get$$1() {
        return this.__level;
      }
    }, {
      key: '$autoFocus',
      get: function get$$1() {
        return this.__autoFocus;
      },
      set: function set(val) {
        this.__autoFocus = val;
        this.__dispatcher.dom._autoFocusToVideo(this.$dom, !val);
      }
    }]);

    return Plugin;
  }(VideoWrapper)) || _class$2);

  var _dec$3, _dec2$2, _dec3$1$1, _dec4$1$1, _dec5$1$1, _dec6$1, _class$3;

  function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  function targetCheck(target) {
    if (target === 'video') target = 'videoElement';
    if (!isElement(this[target])) throw new TypeError('Your target "' + target + '" is not a legal HTMLElement');

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [target].concat(args);
  }
  function attrOperationCheck(target, attr, val) {
    if (!isString(attr)) throw new TypeError('to handle dom\'s attribute or style, your attr parameter must be string, but not ' + attr + ' in ' + (typeof attr === 'undefined' ? 'undefined' : _typeof(attr)));
    if (!isString(target)) throw new TypeError('to handle dom\'s attribute or style, your target parameter must be string, , but not ' + target + ' in ' + (typeof target === 'undefined' ? 'undefined' : _typeof(target)));
    return [target, attr, val];
  }
  /**
   * <pre>
   * Dom work for Dispatcher.
   * It take charge of dom management of Dispatcher.
   * </pre>
   */
  var Dom = (_dec$3 = waituntil('__dispatcher.videoConfigReady'), _dec2$2 = before(attrOperationCheck, targetCheck), _dec3$1$1 = before(attrOperationCheck, targetCheck), _dec4$1$1 = before(attrOperationCheck, targetCheck), _dec5$1$1 = before(attrOperationCheck, targetCheck), _dec6$1 = before(targetCheck), (_class$3 = function () {
    _createClass(Dom, [{
      key: 'mouseInVideo',

      /**
       * to mark is the mouse in the video area
       */

      /**
       * all plugin's dom element set
       */
      get: function get$$1() {
        return this.__mouseInVideo;
      }
      /**
       * the html to restore when we are destroyed
       */
      ,
      set: function set(val) {
        this.__mouseInVideo = !!val;
      }
      /**
       * collection of video extension nodes
       * some nodes can be regarded as part of video (such as penetrate element)
       * so we store them here
       */

    }, {
      key: 'videoExtendedNodes',
      get: function get$$1() {
        return this.__videoExtendedNodes;
      }
    }]);

    function Dom(config, dispatcher) {
      _classCallCheck$1(this, Dom);

      this.plugins = {};
      this.originHTML = '';
      this.__mouseInVideo = false;
      this.destroyed = false;
      this.__videoExtendedNodes = [];
      this.isFullscreen = false;
      this.fullscreenElement = undefined;

      var _ref = config || {},
          wrapper = _ref.wrapper;

      this.__dispatcher = dispatcher;
      if (!isElement(wrapper) && !isString(wrapper)) throw new TypeError('Wrapper can only be string or HTMLElement, but not ' + (typeof wrapper === 'undefined' ? 'undefined' : _typeof(wrapper)));
      var $wrapper = $(wrapper);
      // TODO: we have to decalre length for wrapper
      // $FlowFixMe: we have to decalre length here
      if ($wrapper.length === 0) {
        throw new TypeError('Can not get dom node accroding wrapper. Please check your wrapper');
      }
      /**
       * the referrence of the dom wrapper of whole Chimee
       */
      // $FlowFixMe: support computed key on nodewrap
      this.wrapper = $wrapper[0];
      this.originHTML = this.wrapper.innerHTML;
      // if we find video element inside wrapper
      // we use it
      // or we create a video element by ourself.
      // $FlowFixMe: support computed key on nodewrap
      var videoElement = $wrapper.find('video')[0];
      if (!videoElement) {
        videoElement = document.createElement('video');
      }
      /**
       * referrence of video's dom element
       */
      this.installVideo(videoElement);
      this._fullscreenMonitor();
      index.on('fullscreenchange', this._fullscreenMonitor);
      // As some video attributes will missed when we switch kernel
      // we set a guarder for it
      // and we must make sure style be guarded
      var videoRequiredGuardedAttributes = isArray(config.videoRequiredGuardedAttributes) ? config.videoRequiredGuardedAttributes : [];
      if (videoRequiredGuardedAttributes.indexOf('style') < 0) {
        videoRequiredGuardedAttributes.unshift('style');
      }
      this.videoRequireGuardedAttributes = videoRequiredGuardedAttributes;
    }

    _createClass(Dom, [{
      key: 'installVideo',
      value: function installVideo(videoElement) {
        this.__videoExtendedNodes.push(videoElement);
        setAttr(videoElement, 'tabindex', -1);
        this._autoFocusToVideo(videoElement);
        if (!isElement(this.container)) {
          // create container
          if (videoElement.parentElement && isElement(videoElement.parentElement) && videoElement.parentElement !== this.wrapper) {
            this.container = videoElement.parentElement;
          } else {
            this.container = document.createElement('container');
            $(this.container).append(videoElement);
          }
        } else {
          var container = this.container;
          if (container.childNodes.length === 0) {
            container.appendChild(videoElement);
          } else {
            container.insertBefore(videoElement, container.childNodes[0]);
          }
        }
        // check container.position
        if (this.container.parentElement !== this.wrapper) {
          $(this.wrapper).append(this.container);
        }
        this.videoElement = videoElement;
        return videoElement;
      }
    }, {
      key: 'removeVideo',
      value: function removeVideo() {
        var videoElement = this.videoElement;
        this._autoFocusToVideo(this.videoElement, false);
        // when we destroy the chimee
        // binder is destroyed before dom
        // so we need to make a check here
        this.__dispatcher.binder && this.__dispatcher.binder.bindEventOnVideo(videoElement, true);
        $(videoElement).remove();
        delete this.videoElement;
        return videoElement;
      }

      /**
       * each plugin has its own dom node, this function will create one or them.
       * we support multiple kind of el
       * 1. Element, we will append this dom node on wrapper straight
       * 2. HTMLString, we will create dom based on this HTMLString and append it on wrapper
       * 3. string, we will transfer this string into hypen string, then we create a custom elment called by this and bind it on wrapper
       * 4. nothing, we will create a div and bind it on the wrapper
       */

    }, {
      key: 'insertPlugin',
      value: function insertPlugin(id, el) {
        var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!isString(id)) throw new TypeError('insertPlugin id parameter must be string');
        if (isElement(this.plugins[id])) {
          this.removePlugin(id);
        }
        if (isString(el)) {
          if (isHTMLString(el)) {
            var outer = document.createElement('div');
            outer.innerHTML = el;
            el = outer.children[0];
          } else {
            el = document.createElement(hypenate(el));
          }
        } else if (isObject(el)) {
          // $FlowFixMe: we have check el's type here and make sure it's an object
          option = el;
        }
        var _option = option,
            inner = _option.inner,
            penetrate = _option.penetrate;
        var _option2 = option,
            className = _option2.className;

        var node = el && isElement(el) ? el : document.createElement('div');
        if (isArray(className)) {
          className = className.join(' ');
        }
        if (isString(className)) {
          addClassName(node, className);
        }
        this.plugins[id] = node;
        var outerElement = inner ? this.container : this.wrapper;
        var originElement = inner ? this.videoElement : this.container;
        // auto forward the event if this plugin can be penetrate
        if (penetrate) {
          this.__dispatcher.binder.bindEventOnPenetrateNode(node);
          this.__videoExtendedNodes.push(node);
        }
        if (outerElement.lastChild === originElement) {
          outerElement.appendChild(node);
          return node;
        }
        outerElement.insertBefore(node, originElement.nextSibling);
        return node;
      }

      /**
       * remove plugin's dom
       */

    }, {
      key: 'removePlugin',
      value: function removePlugin(id) {
        if (!isString(id)) return;
        var dom = this.plugins[id];
        if (isElement(dom)) {
          dom.parentNode && dom.parentNode.removeChild(dom);
          this._autoFocusToVideo(dom, true);
        }

        var _ref2 = Dispatcher.getPluginConfig(id) || {},
            _ref2$penetrate = _ref2.penetrate,
            penetrate = _ref2$penetrate === undefined ? false : _ref2$penetrate;

        if (penetrate) this.__dispatcher.binder.bindEventOnPenetrateNode(dom, true);
        delete this.plugins[id];
      }

      /**
       * Set zIndex for a plugins list
       */

    }, {
      key: 'setPluginsZIndex',
      value: function setPluginsZIndex(plugins) {
        var _this = this;

        // $FlowFixMe: there are videoElment and container here
        plugins.forEach(function (key, index$$1) {
          return setStyle(key.match(/^(videoElement|container)$/) ? _this[key] : _this.plugins[key], 'z-index', ++index$$1);
        });
      }

      /**
       * set attribute on our dom
       * @param {string} attr attribute's name
       * @param {anything} val attribute's value
       * @param {string} target the HTMLElemnt string name, only support video/wrapper/container now
       */

    }, {
      key: 'setAttr',
      value: function setAttr$$1(target, attr, val) {
        // $FlowFixMe: flow do not support computed property/element on class, which is silly here.
        setAttr(this[target], attr, val);
      }
    }, {
      key: 'getAttr',
      value: function getAttr$$1(target, attr) {
        // $FlowFixMe: flow do not support computed property/element on class, which is silly here.
        return getAttr(this[target], attr);
      }
    }, {
      key: 'setStyle',
      value: function setStyle$$1(target, attr, val) {
        // $FlowFixMe: flow do not support computed property/element on class, which is silly here.
        setStyle(this[target], attr, val);
      }
    }, {
      key: 'getStyle',
      value: function getStyle$$1(target, attr) {
        // $FlowFixMe: flow do not support computed property/element on class, which is silly here.
        return getStyle(this[target], attr);
      }
    }, {
      key: 'requestFullscreen',
      value: function requestFullscreen(target) {
        // $FlowFixMe: flow do not support computed property/element on document, which is silly here.
        return index.open(this[target]);
      }
    }, {
      key: 'exitFullscreen',
      value: function exitFullscreen() {
        return index.exit();
      }
    }, {
      key: 'fullscreen',
      value: function fullscreen() {
        var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'container';

        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        return request ? this.requestFullscreen.apply(this, [target].concat(_toConsumableArray(args))) : this.exitFullscreen.apply(this, _toConsumableArray(args));
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.videoElement.focus();
      }
    }, {
      key: 'isNodeInsideVideo',
      value: function isNodeInsideVideo(node) {
        return this.__videoExtendedNodes.indexOf(node) > -1 || this.__videoExtendedNodes.reduce(function (flag, video) {
          if (flag) return flag;
          return isPosterityNode(video, node);
        }, false);
      }
    }, {
      key: 'migrateVideoRequiredGuardedAttributes',
      value: function migrateVideoRequiredGuardedAttributes(video) {
        var _this2 = this;

        var guardedAttributesAndValue = this.videoRequireGuardedAttributes.map(function (attr) {
          return [attr, getAttr(_this2.videoElement, attr)];
        });
        guardedAttributesAndValue.forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              attr = _ref4[0],
              value = _ref4[1];

          return setAttr(video, attr, value);
        });
      }

      /**
       * function called when we distory
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.removeVideo();
        index.off('fullscreenchange', this._fullscreenMonitor);
        this.wrapper.innerHTML = this.originHTML;
        delete this.wrapper;
        delete this.plugins;
        this.destroyed = true;
      }
    }, {
      key: '_autoFocusToVideo',
      value: function _autoFocusToVideo(element) {
        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        /* istanbule ignore next */
        if (!isElement(element)) return;
        (remove ? removeEvent : addEvent)(element, 'mouseup', this._focusToVideo, false, true);
        (remove ? removeEvent : addEvent)(element, 'touchend', this._focusToVideo, false, true);
      }
    }, {
      key: '_focusToVideo',
      value: function _focusToVideo() {
        var x = window.scrollX;
        var y = window.scrollY;
        isFunction(this.videoElement.focus) && this.videoElement.focus();
        window.scrollTo(x, y);
      }
    }, {
      key: '_fullscreenMonitor',
      value: function _fullscreenMonitor(evt) {
        var element = index.fullscreenElement;
        var original = this.isFullscreen;
        if (!element || !isPosterityNode(this.wrapper, element) && element !== this.wrapper) {
          this.isFullscreen = false;
          this.fullscreenElement = undefined;
        } else {
          this.isFullscreen = true;
          this.fullscreenElement = this.wrapper === element ? 'wrapper' : this.container === element ? 'container' : this.videoElement === element ? 'video' : element;
        }
        if (isEvent(evt) && original !== this.isFullscreen) {
          this.__dispatcher.binder.triggerSync({
            name: 'fullscreenchange',
            target: 'esFullscreen',
            id: 'dispatcher'
          }, evt);
        }
      }
    }]);

    return Dom;
  }(), (_applyDecoratedDescriptor$2(_class$3.prototype, 'setAttr', [_dec$3, _dec2$2], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'setAttr'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, 'getAttr', [_dec3$1$1], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'getAttr'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, 'setStyle', [_dec4$1$1], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'setStyle'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, 'getStyle', [_dec5$1$1], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'getStyle'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, 'requestFullscreen', [_dec6$1], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'requestFullscreen'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, '_focusToVideo', [autobind], _Object$getOwnPropertyDescriptor(_class$3.prototype, '_focusToVideo'), _class$3.prototype), _applyDecoratedDescriptor$2(_class$3.prototype, '_fullscreenMonitor', [autobind], _Object$getOwnPropertyDescriptor(_class$3.prototype, '_fullscreenMonitor'), _class$3.prototype)), _class$3));

  var defaultContainerConfig = {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'block'
  };

  // base css controller for container and wrapper

  var Vessel = function Vessel(dispatcher, target, config) {
    var _this = this;

    _classCallCheck$1(this, Vessel);

    this.__dispatcher = dispatcher;
    this.__target = target;
    ['width', 'height', 'position', 'display'].forEach(function (key) {
      _Object$defineProperty(_this, key, {
        get: function get$$1() {
          return this.__dispatcher.dom.getStyle(this.__target, key);
        },
        set: function set(value) {
          if (isNumber(value)) {
            value = value + 'px';
          }
          if (!isString(value)) {
            throw new Error('The value of ' + key + ' in ' + this.__target + 'Config must be string, but not ' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '.');
          }
          this.__dispatcher.dom.setStyle(this.__target, key, value);
          // return value;
        },

        configurable: true,
        enumerable: true
      });
    });
    deepAssign(this, config);
  };

  var _dec$4, _dec2$3, _dec3$2, _dec4$2, _class$4;

  function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  var secondaryReg = /^(before|after|_)/;
  function secondaryChecker(key) {
    if (key.match(secondaryReg)) {
      return false;
    }
    return true;
  }
  /**
   * <pre>
   * event Bus class. Bus take charge of commuication between plugins and user.
   * Some of the event may trigger the kernel to do some task.
   * An event will run in four lifecycle
   * before -> processor -> main -> after -> side effect(_)
   * -------------------- emit period ----------------
   * before: once an event emit, it will run through plugins in bubble to know is it possible to run.
   * processor: if sth need to be done on kernel. It will tell kernel. If kernel will trigger event later, it will break down here. Else will run into trigger period
   * -------------------- trigger period -----------------
   * main: this procedure will trigger the main event in bubble, which means it can be stop in one plugin.
   * after: once event run through all events. It will trigger after event. This event will be trigger in broadcast way.
   * side effect(_): This events will always trigger once we bump into trigger period. So that you can know if the events been blocked. But it's not advice to listen on this effect.
   * </pre>
   */
  var Bus = (_dec$4 = runnable(secondaryChecker), _dec2$3 = runnable(secondaryChecker, {
    backup: function backup() {
      return false;
    }
  }), _dec3$2 = runnable(secondaryChecker), _dec4$2 = runnable(secondaryChecker, {
    backup: function backup() {
      return false;
    }
  }), (_class$4 = function () {
    /**
     * @param {Dispatcheer} dispatcher bus rely on dispatcher, so you mush pass dispatcher at first when you generate Bus.
     * @return {Bus}
     */

    /**
     * the handler set of all events
     * @type {Object}
     * @member events
     */
    function Bus(dispatcher, kind) {
      _classCallCheck$1(this, Bus);

      this.events = {};
      this.onceMap = {};

      /**
       * the referrence to dispatcher
       * @type {Dispatcher}
       */
      this.__dispatcher = dispatcher;
      this.__kind = kind;
    }
    /**
     * [Can only be called in dispatcher]bind event on bus.
     */


    _createClass(Bus, [{
      key: 'on',
      value: function on(id, eventName, fn, stage) {
        this._addEvent([eventName, stage, id], fn);
      }
      /**
       * [Can only be called in dispatcher]remove event off bus. Only suggest one by one.
       */

    }, {
      key: 'off',
      value: function off(id, eventName, fn, stage) {
        var keys = [eventName, stage, id];
        var deleted = this._removeEvent(keys, fn);
        if (deleted) return;
        var handler = this._getHandlerFromOnceMap(keys, fn);
        if (isFunction(handler)) {
          this._removeEvent(keys, handler) && this._removeFromOnceMap(keys, fn, handler);
        }
      }
      /**
       * [Can only be called in dispatcher]bind event on bus and remove it once event is triggered.
       */

    }, {
      key: 'once',
      value: function once(id, eventName, fn, stage) {
        var bus = this;
        var keys = [eventName, stage, id];
        var handler = function handler() {
          // keep the this so that it can run
          bind(fn, this).apply(undefined, arguments);
          bus._removeEvent(keys, handler);
          bus._removeFromOnceMap(keys, fn, handler);
        };
        this._addEvent(keys, handler);
        this._addToOnceMap(keys, fn, handler);
      }
      /**
       * [Can only be called in dispatcher]emit an event, which will run before -> processor period.
       * It may stop in before period.
       * @param  {string}    key event's name
       * @param  {anything} args other argument will be passed into handler
       * @return {Promise}  this promise maybe useful if the event would not trigger kernel event. In that will you can know if it runs successful. But you can know if the event been stopped by the promise.
       */

    }, {
      key: 'emit',
      value: function emit(key) {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var event = this.events[key];
        if (isEmpty(event)) {
          if (selfProcessorEvents.indexOf(key) > -1) return _Promise.resolve();
          // $FlowFixMe: conditional return here
          return this._eventProcessor.apply(this, [key, { sync: false }].concat(_toConsumableArray(args)));
        }
        var beforeQueue = this._getEventQueue(event.before, this.__dispatcher.order);
        return runRejectableQueue.apply(undefined, [beforeQueue].concat(_toConsumableArray(args))).then(function () {
          if (selfProcessorEvents.indexOf(key) > -1) return;
          return _this._eventProcessor.apply(_this, [key, { sync: false }].concat(_toConsumableArray(args)));
        }).catch(function (error) {
          if (isError(error)) _this.__dispatcher.throwError(error);
          return _Promise.reject(error);
        });
      }
      /**
       * [Can only be called in dispatcher]emit an event, which will run before -> processor period synchronize.
       * It may stop in before period.
       * @param  {string}    key event's name
       * @param  {anything} args other argument will be passed into handler
       * @return {Promise}  this promise maybe useful if the event would not trigger kernel event. In that will you can know if it runs successful. But you can know if the event been stopped by the promise.
       */

    }, {
      key: 'emitSync',
      value: function emitSync(key) {
        var event = this.events[key];

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        if (isEmpty(event)) {
          if (selfProcessorEvents.indexOf(key) > -1) return true;
          // $FlowFixMe: conditional return here
          return this._eventProcessor.apply(this, [key, { sync: true }].concat(_toConsumableArray(args)));
        }
        var beforeQueue = this._getEventQueue(event.before, this.__dispatcher.order);
        return runStoppableQueue.apply(undefined, [beforeQueue].concat(_toConsumableArray(args))) && (selfProcessorEvents.indexOf(key) > -1 ||
        // $FlowFixMe: conditional return here
        this._eventProcessor.apply(this, [key, { sync: true }].concat(_toConsumableArray(args))));
      }
      /**
       * [Can only be called in dispatcher]trigger an event, which will run main -> after -> side effect period
       * @param  {string}    key event's name
       * @param  {anything} args
       * @return {Promise|undefined}    you can know if event trigger finished~ However, if it's unlegal
       */

    }, {
      key: 'trigger',
      value: function trigger(key) {
        var _this2 = this;

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        var event = this.events[key];
        if (isEmpty(event)) {
          return _Promise.resolve(true);
        }
        var mainQueue = this._getEventQueue(event.main, this.__dispatcher.order);
        return runRejectableQueue.apply(undefined, [mainQueue].concat(_toConsumableArray(args))).then(function () {
          var afterQueue = _this2._getEventQueue(event.after, _this2.__dispatcher.order);
          return runRejectableQueue.apply(undefined, [afterQueue].concat(_toConsumableArray(args)));
        }).then(function () {
          return _this2._runSideEffectEvent.apply(_this2, [key, _this2.__dispatcher.order].concat(_toConsumableArray(args)));
        }).catch(function (error) {
          if (isError(error)) _this2.__dispatcher.throwError(error);
          return _this2._runSideEffectEvent.apply(_this2, [key, _this2.__dispatcher.order].concat(_toConsumableArray(args)));
        });
      }
      /**
       * [Can only be called in dispatcher]trigger an event, which will run main -> after -> side effect period in synchronize
       * @param  {string}    key event's name
       * @param  {anything} args
       * @return {boolean}    you can know if event trigger finished~ However, if it's unlegal
       */

    }, {
      key: 'triggerSync',
      value: function triggerSync(key) {
        var event = this.events[key];
        if (isEmpty(event)) {
          return true;
        }
        var mainQueue = this._getEventQueue(event.main, this.__dispatcher.order);
        var afterQueue = this._getEventQueue(event.after, this.__dispatcher.order);

        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        var result = runStoppableQueue.apply(undefined, [mainQueue].concat(_toConsumableArray(args))) && runStoppableQueue.apply(undefined, [afterQueue].concat(_toConsumableArray(args)));
        this._runSideEffectEvent.apply(this, [key, this.__dispatcher.order].concat(_toConsumableArray(args)));
        return result;
      }
      /**
       * destroy hook which will be called when object destroy
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        delete this.events;
        delete this.__dispatcher;
      }
      /**
       * add event into bus
       * @private
       * @param {Array} keys keys map pointing to position to put event handler
       * @param {function} fn handler to put
       */

    }, {
      key: '_addEvent',
      value: function _addEvent(keys, fn) {
        keys = deepClone(keys);
        var id = keys.pop();
        var target = keys.reduce(function (target, key) {
          target[key] = target[key] || {};
          return target[key];
        }, this.events);
        // events will store like {play: {main: {plugin: []}}}
        target[id] = target[id] || [];
        target[id].push(fn);
      }
      /**
       * remove event from bus
       * @private
       * @param {Array} keys keys map pointing to position to get event handler
       * @param {function} fn handler to put
       */

    }, {
      key: '_removeEvent',
      value: function _removeEvent(keys, fn) {
        keys = deepClone(keys);
        var id = keys.pop();
        var target = this.events;
        var backtrackList = [];
        for (var i = 0, len = keys.length; i < len; i++) {
          var son = target[keys[i]];
          // if we can't find the event binder, just return
          if (isEmpty(son)) return;
          backtrackList.push([target, keys[i]]);
          target = son;
        }
        var queue = target[id] || [];
        var index$$1 = queue.indexOf(fn);
        var hasFn = index$$1 > -1;
        // if we found handler remove it
        if (hasFn) {
          queue.splice(index$$1, 1);
        }
        // if this plugin has no event binding, we remove this event session, which make us perform faster in emit & trigger period.
        if (queue.length < 1) {
          delete target[id];
          // backtrack to remove the redudant object
          for (var _i = backtrackList.length - 1; _i > -1; _i--) {
            var _backtrackList$_i = _slicedToArray(backtrackList[_i], 2),
                parent = _backtrackList$_i[0],
                key = _backtrackList$_i[1];

            if (!isEmpty(parent[key])) break;
            delete parent[key];
          }
        }
        return hasFn;
      }
    }, {
      key: '_addToOnceMap',
      value: function _addToOnceMap(keys, fn, handler) {
        var key = keys.join('-');
        var map = this.onceMap[key] = this.onceMap[key] || new _Map();
        if (!map.has(fn)) map.set(fn, []);
        var handlers = map.get(fn);
        // $FlowFixMe: flow do not understand map yet
        handlers.push(handler);
      }
    }, {
      key: '_removeFromOnceMap',
      value: function _removeFromOnceMap(keys, fn, handler) {
        var key = keys.join('-');
        var map = this.onceMap[key];
        // do not need to check now
        // if(isVoid(map) || !map.has(fn)) return;
        var handlers = map.get(fn);
        var index$$1 = handlers.indexOf(handler);
        handlers.splice(index$$1, 1);
        if (isEmpty(handlers)) map.delete(fn);
      }
    }, {
      key: '_getHandlerFromOnceMap',
      value: function _getHandlerFromOnceMap(keys, fn) {
        var key = keys.join('-');
        var map = this.onceMap[key];
        if (isVoid(map) || !map.has(fn)) return;
        var handlers = map.get(fn);
        return handlers[0];
      }
      /**
       * get event stage by evnet key name
       * @private
       * @param  {key} key event's name
       * @return {stage}  event stage
       */

    }, {
      key: '_getEventStage',
      value: function _getEventStage(key) {
        var secondaryCheck = key.match(secondaryReg);
        // $FlowFixMe: make sure it's event stage here
        var stage = secondaryCheck && secondaryCheck[0] || 'main';
        if (secondaryCheck) {
          key = camelize(key.replace(secondaryReg, ''));
        }
        return { stage: stage, key: key };
      }
      /**
       * get event handlers queue to run
       * @private
       * @param  {Object} handlerSet the object include all handler
       * @param  {Array} Array form of plugin id
       * @return {Array<Function>} event handler in queue to run
       */

    }, {
      key: '_getEventQueue',
      value: function _getEventQueue(handlerSet, order) {
        var _this3 = this;

        order = isArray(order) ? order.concat(['_vm']) : ['_vm'];
        return isEmpty(handlerSet) ? [] : order.reduce(function (queue, id) {
          if (isEmpty(handlerSet[id]) || !isArray(handlerSet[id]) ||
          // in case plugins is missed
          // _vm indicate the user. This is the function for user
          !_this3.__dispatcher.plugins[id] && id !== '_vm') {
            return queue;
          }
          return queue.concat(handlerSet[id].map(function (fn) {
            // bind context for plugin instance
            return bind(fn, _this3.__dispatcher.plugins[id] || _this3.__dispatcher.vm);
          }));
        }, []);
      }
      /**
       * event processor period. If event needs call kernel function.
       * I will called here.
       * If kernel will reponse. I will stop here.
       * Else I will trigger next period.
       * @param  {string}    key event's name
       * @param  {boolean}  options.sync we will take triggerSync if true, otherwise we will run trigger. default is false
       * @param  {anything} args
       * @return {Promise|undefined}
       */

    }, {
      key: '_eventProcessor',
      value: function _eventProcessor(key, _ref) {
        var sync = _ref.sync;

        var isKernelMethod = kernelMethods.indexOf(key) > -1;
        var isDomMethod = domMethods.indexOf(key) > -1;
        var isDispatcherMethod = Boolean(dispatcherEventMethodMap[key]);

        for (var _len5 = arguments.length, args = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
          args[_key5 - 2] = arguments[_key5];
        }

        if (isKernelMethod || isDomMethod || isDispatcherMethod) {
          if (isDispatcherMethod) {
            var _dispatcher;

            (_dispatcher = this.__dispatcher)[dispatcherEventMethodMap[key]].apply(_dispatcher, _toConsumableArray(args));
          } else {
            var _dispatcher2;

            (_dispatcher2 = this.__dispatcher[isKernelMethod ? 'kernel' : 'dom'])[key].apply(_dispatcher2, _toConsumableArray(args));
          }
          if (videoEvents.indexOf(key) > -1 || domEvents.indexOf(key) > -1) return true;
        }
        // $FlowFixMe: flow do not support computed sytax on classs, but it's ok here
        return this[sync ? 'triggerSync' : 'trigger'].apply(this, [key].concat(_toConsumableArray(args)));
      }
      /**
       * run side effect period
       * @param  {string}    key event's name
       * @param  {args} args
       */

    }, {
      key: '_runSideEffectEvent',
      value: function _runSideEffectEvent(key, order) {
        for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
          args[_key6 - 2] = arguments[_key6];
        }

        var event = this.events[key];
        if (isEmpty(event)) {
          return false;
        }
        var queue = this._getEventQueue(event._, order);
        queue.forEach(function (run) {
          return run.apply(undefined, _toConsumableArray(args));
        });
        return true;
      }
    }]);

    return Bus;
  }(), (_applyDecoratedDescriptor$3(_class$4.prototype, 'emit', [_dec$4], _Object$getOwnPropertyDescriptor(_class$4.prototype, 'emit'), _class$4.prototype), _applyDecoratedDescriptor$3(_class$4.prototype, 'emitSync', [_dec2$3], _Object$getOwnPropertyDescriptor(_class$4.prototype, 'emitSync'), _class$4.prototype), _applyDecoratedDescriptor$3(_class$4.prototype, 'trigger', [_dec3$2], _Object$getOwnPropertyDescriptor(_class$4.prototype, 'trigger'), _class$4.prototype), _applyDecoratedDescriptor$3(_class$4.prototype, 'triggerSync', [_dec4$2], _Object$getOwnPropertyDescriptor(_class$4.prototype, 'triggerSync'), _class$4.prototype)), _class$4));

  var _dec$5, _dec2$4, _dec3$3, _dec4$3, _dec5$2, _dec6$2, _dec7$1, _dec8$1, _dec9$1, _dec10$1, _dec11$1, _class$5;

  function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  var secondaryReg$1 = /^(before|after|_)/;

  /**
   * In logic before 0.10.0, we use 'c_' and 'w_' to mark event of container and wrapper
   * we need to keep that logic work until next major version.
   * @param {string} name 事件名字
   */
  function getEventTargetByOldLogic(oldName) {
    var targetKeyReg = new RegExp('^(c|w)_');
    var matches = oldName.match(targetKeyReg);
    if (matches) {
      var _name = oldName.replace(targetKeyReg, '');
      var _target = oldName.indexOf('c') === 0 ? 'container' : 'wrapper';
      return { name: _name, target: _target };
    } else if (oldName === 'error') {
      return { name: 'error', target: 'kernel' };
    }
    return false;
  }

  function getEventStage(name) {
    var matches = name.match(secondaryReg$1);
    // $FlowFixMe: We make sure it's event stage here
    var stage = matches && matches[0] || 'main';
    if (matches) {
      name = camelize(name.replace(secondaryReg$1, ''));
    }
    return { name: name, stage: stage };
  }

  function getEventTargetByEventName(name) {
    if (videoEvents.indexOf(name) > -1) return 'video';
    if (kernelEvents.indexOf(name) > -1) return 'kernel';
    if (domEvents.indexOf(name) > -1) return 'video-dom';
    if (esFullscreenEvents.indexOf(name) > -1) return 'esFullscreen';
    return 'plugin';
  }

  function getEventInfo(_ref) {
    var name = _ref.name,
        target = _ref.target,
        stage = _ref.stage;

    var oldInfo = getEventTargetByOldLogic(name);
    if (oldInfo) {
      name = oldInfo.name;
      target = oldInfo.target;
    }

    var _getEventStage = getEventStage(name),
        newStage = _getEventStage.stage,
        newName = _getEventStage.name;

    name = newName;

    if (!target) {
      target = getEventTargetByEventName(name);
    }

    return {
      name: name,
      stage: stage || newStage,
      target: target
    };
  }

  function prettifyEventParameter(info) {
    var id = info.id,
        fn = info.fn;

    var _getEventInfo = getEventInfo(info),
        name = _getEventInfo.name,
        target = _getEventInfo.target,
        stage = _getEventInfo.stage;

    if (!isFunction(fn)) {
      throw new Error('You must provide a function to handle with event ' + name + ', but not ' + (typeof fn === 'undefined' ? 'undefined' : _typeof(fn)));
    }
    return {
      id: id,
      fn: fn,
      name: name,
      target: target,
      stage: stage
    };
  }

  function isEventEmitalbe(_ref2) {
    var id = _ref2.id,
        name = _ref2.name;

    if (!name || !isString(name) || secondaryReg$1.test(name)) {
      Log$1.error('You must provide a legal event name, which is string and could not started with before/after/_');
      return false;
    }
    if (!id || !isString(id)) {
      Log$1.error('You must provide the id of emitter');
      return false;
    }
    return true;
  }

  function checkEventEmitParameter(info) {
    // $FlowFixMe: the info match requirement here
    info.target = getEventInfo(info).target;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [info].concat(_toConsumableArray(args));
  }

  var Binder = (_dec$5 = before(prettifyEventParameter), _dec2$4 = before(prettifyEventParameter), _dec3$3 = before(prettifyEventParameter), _dec4$3 = runnable(isEventEmitalbe), _dec5$2 = before(checkEventEmitParameter), _dec6$2 = runnable(isEventEmitalbe, {
    backup: function backup() {
      return false;
    }
  }), _dec7$1 = before(checkEventEmitParameter), _dec8$1 = runnable(isEventEmitalbe), _dec9$1 = before(checkEventEmitParameter), _dec10$1 = runnable(isEventEmitalbe, {
    backup: function backup() {
      return false;
    }
  }), _dec11$1 = before(checkEventEmitParameter), (_class$5 = function () {
    function Binder(dispatcher) {
      _classCallCheck$1(this, Binder);

      this.__dispatcher = dispatcher;
      this.kinds = ['kernel', 'container', 'wrapper', 'video', 'video-dom', 'plugin', 'esFullscreen'];
      this.buses = {};
      this.bindedEventNames = {};
      this.bindedEventInfo = {};
      this.pendingEventsInfo = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(this.kinds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var kind = _step.value;

          this.bindedEventNames[kind] = [];
          this.bindedEventInfo[kind] = [];
          this.pendingEventsInfo[kind] = [];
          this.buses[kind] = new Bus(dispatcher, kind);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    _createClass(Binder, [{
      key: 'on',
      value: function on(_ref3) {
        var target = _ref3.target,
            id = _ref3.id,
            name = _ref3.name,
            fn = _ref3.fn,
            stage = _ref3.stage;

        this._addEventListenerOnTarget({
          name: name,
          target: target,
          id: id
        });
        return this.buses[target].on(id, name, fn, stage);
      }
    }, {
      key: 'off',
      value: function off(_ref4) {
        var target = _ref4.target,
            id = _ref4.id,
            name = _ref4.name,
            fn = _ref4.fn,
            stage = _ref4.stage;

        var ret = this.buses[target].off(id, name, fn, stage);
        this._removeEventListenerOnTargetWhenIsUseless({ name: name, target: target });
        return ret;
      }
    }, {
      key: 'once',
      value: function once(_ref5) {
        var target = _ref5.target,
            id = _ref5.id,
            name = _ref5.name,
            fn = _ref5.fn,
            stage = _ref5.stage;

        return this.buses[target].once(id, name, fn, stage);
      }
    }, {
      key: 'emit',
      value: function emit(_ref6) {
        var _buses$target;

        var target = _ref6.target,
            name = _ref6.name;

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return (_buses$target = this.buses[target]).emit.apply(_buses$target, [name].concat(_toConsumableArray(args)));
      }
    }, {
      key: 'emitSync',
      value: function emitSync(_ref7) {
        var _buses$target2;

        var target = _ref7.target,
            name = _ref7.name;

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return (_buses$target2 = this.buses[target]).emitSync.apply(_buses$target2, [name].concat(_toConsumableArray(args)));
      }
    }, {
      key: 'trigger',
      value: function trigger(_ref8) {
        var _buses$target3;

        var target = _ref8.target,
            name = _ref8.name;

        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        return (_buses$target3 = this.buses[target]).trigger.apply(_buses$target3, [name].concat(_toConsumableArray(args)));
      }
    }, {
      key: 'triggerSync',
      value: function triggerSync(_ref9) {
        var _buses$target4;

        var target = _ref9.target,
            name = _ref9.name;

        for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        return (_buses$target4 = this.buses[target]).triggerSync.apply(_buses$target4, [name].concat(_toConsumableArray(args)));
      }

      // when we create a penetrate plugin, we need to rebind video events on it

    }, {
      key: 'bindEventOnPenetrateNode',
      value: function bindEventOnPenetrateNode(node) {
        var _this = this;

        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        this.bindedEventInfo['video-dom'].forEach(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              name = _ref11[0],
              fn = _ref11[1];

          remove ? removeEvent(node, name, fn) : _this._addEventOnDom(node, name, fn);
        });
      }

      // when we switch kernel, we will create a new video.
      // we need to transfer the event from the oldvideo to it.

    }, {
      key: 'bindEventOnVideo',
      value: function bindEventOnVideo(node) {
        var _this2 = this;

        var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        this.bindedEventInfo['video-dom'].concat(this.bindedEventInfo.video).forEach(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
              name = _ref13[0],
              fn = _ref13[1];

          remove ? removeEvent(node, name, fn) : _this2._addEventOnDom(node, name, fn);
        });
      }

      // As penetrate plugin is considered to be part of video
      // we need to transfer event for it
      // so we need some specail event handler

    }, {
      key: 'listenOnMouseMoveEvent',
      value: function listenOnMouseMoveEvent(node) {
        var _this3 = this;

        var dom = this.__dispatcher.dom;
        var target = 'video-dom';
        var id = '_vm';
        mustListenVideoDomEvents.forEach(function (name) {
          var fn = function fn() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
              args[_key6] = arguments[_key6];
            }

            var _args$ = args[0],
                toElement = _args$.toElement,
                currentTarget = _args$.currentTarget,
                relatedTarget = _args$.relatedTarget,
                type = _args$.type;

            var to = toElement || relatedTarget;
            // As we support penetrate plugin, the video dom event may be differnet.
            if (dom.mouseInVideo && type === 'mouseleave' && !dom.isNodeInsideVideo(to)) {
              dom.mouseInVideo = false;
              return _this3.triggerSync.apply(_this3, [{
                target: target,
                name: name,
                id: id
              }].concat(args));
            }
            if (!dom.mouseInVideo && type === 'mouseenter' && dom.isNodeInsideVideo(currentTarget)) {
              dom.mouseInVideo = true;
              return _this3.triggerSync.apply(_this3, [{
                target: target,
                name: name,
                id: id
              }].concat(args));
            }
          };
          _this3._addEventOnDom(node, name, fn);
          // this function is only used once now
          // so we do not cover this branch
          // but we still keep this judegement
          /* istanbul ignore else  */
          if (_this3.bindedEventNames[target].indexOf(name) < 0) {
            _this3.bindedEventNames[target].push(name);
            // $FlowFixMe: fn must be function now
            _this3.bindedEventInfo[target].push([name, fn]);
          }
        });
      }

      // When we switch kernel, we need to rebind the events

    }, {
      key: 'migrateKernelEvent',
      value: function migrateKernelEvent(oldKernel, newKernel) {
        var bindedEventInfoList = this.bindedEventInfo.kernel;
        bindedEventInfoList.forEach(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
              name = _ref15[0],
              fn = _ref15[1];

          oldKernel.off(name, fn);
          newKernel.on(name, fn);
        });
      }

      // when we destroy, we remove all binder

    }, {
      key: 'destroy',
      value: function destroy() {
        var _this4 = this;

        this.kinds.forEach(function (target) {
          if (target === 'kernel') {
            _this4.bindedEventInfo.kernel.forEach(function (_ref16) {
              var _ref17 = _slicedToArray(_ref16, 2),
                  name = _ref17[0],
                  fn = _ref17[1];

              _this4.__dispatcher.kernel.off(name, fn);
            });
          } else {
            var targetDom = _this4._getTargetDom(target);
            _this4.bindedEventInfo[target].forEach(function (_ref18) {
              var _ref19 = _slicedToArray(_ref18, 2),
                  name = _ref19[0],
                  fn = _ref19[1];

              removeEvent(targetDom, name, fn);

              if (target === 'video-dom') {
                _this4.__dispatcher.dom.videoExtendedNodes.forEach(function (node) {
                  return removeEvent(node, name, fn);
                });
              }
            });
          }
          _this4.bindedEventInfo.kernel = [];
          _this4.bindedEventNames.kernel = [];
        });
      }
    }, {
      key: '_addEventOnDom',
      value: function _addEventOnDom(element, key, fn) {
        if (passiveEvents.indexOf(key) > -1) {
          return addEvent(element, key, fn, false, { passive: true });
        }
        addEvent(element, key, fn);
      }

      // Some event needs us to transfer it from the real target
      // such as dom event

    }, {
      key: '_addEventListenerOnTarget',
      value: function _addEventListenerOnTarget(_ref20) {
        var _this5 = this;

        var name = _ref20.name,
            target = _ref20.target,
            id = _ref20.id;

        if (!this._isEventNeedToBeHandled(target, name)) return;
        var fn = void 0;
        // if this event has been binded, return;
        if (this.bindedEventNames[target].indexOf(name) > -1) return;
        var targetDom = this._getTargetDom(target);
        // choose the correspond method to bind
        if (target === 'kernel') {
          if (!this.__dispatcher.kernel) {
            this.addPendingEvent(target, name, id);
            return;
          }
          fn = function fn() {
            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
              args[_key7] = arguments[_key7];
            }

            return _this5.triggerSync.apply(_this5, [{ target: target, name: name, id: 'kernel' }].concat(args));
          };
          this.__dispatcher.kernel.on(name, fn);
        } else if (target === 'container' || target === 'wrapper') {
          fn = function fn() {
            for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              args[_key8] = arguments[_key8];
            }

            return _this5.triggerSync.apply(_this5, [{ target: target, name: name, id: target }].concat(args));
          };
          this._addEventOnDom(targetDom, name, fn);
        } else if (target === 'video') {
          fn = function fn() {
            for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
              args[_key9] = arguments[_key9];
            }

            return _this5.trigger.apply(_this5, [{ target: target, name: name, id: target }].concat(args));
          };
          this._addEventOnDom(targetDom, name, fn);
        } else if (target === 'video-dom') {
          fn = function fn() {
            for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
              args[_key10] = arguments[_key10];
            }

            return _this5.triggerSync.apply(_this5, [{ target: target, name: name, id: target }].concat(args));
          };
          this.__dispatcher.dom.videoExtendedNodes.forEach(function (node) {
            return _this5._addEventOnDom(node, name, fn);
          });
          this._addEventOnDom(targetDom, name, fn);
        }
        this.bindedEventNames[target].push(name);
        // $FlowFixMe: fn must be function now
        this.bindedEventInfo[target].push([name, fn]);
      }

      // when we off one event, we can remove the useless binder
      // actually we should remove on once event too
      // but it seems ugliy
      // TODO: add this function on once event too

    }, {
      key: '_removeEventListenerOnTargetWhenIsUseless',
      value: function _removeEventListenerOnTargetWhenIsUseless(_ref21) {
        var name = _ref21.name,
            target = _ref21.target;

        if (!this._isEventNeedToBeHandled(target, name)) return;
        var eventNamesList = this.bindedEventNames[target];
        var nameIndex = eventNamesList.indexOf(name);
        // if we have not bind this event before, we omit it
        if (nameIndex < 0) return;
        // if the buses still have another function on bind, we do not need to remove the binder
        if (!isEmpty(this.buses[target].events[name])) return;

        // we fetch the binded function from bindedEventInfo
        var bindedEventInfoList = this.bindedEventInfo[target];
        var fn = void 0;
        var index$$1 = void 0;
        for (index$$1 = 0; index$$1 < bindedEventInfoList.length; index$$1++) {
          if (bindedEventInfoList[index$$1][0] === name) {
            fn = bindedEventInfoList[index$$1][1];
            break;
          }
        }
        if (!isFunction(fn)) return;

        if (target === 'kernel') {
          this.__dispatcher.kernel.off(name, fn);
        } else {
          var targetDom = this._getTargetDom(target);

          removeEvent(targetDom, name, fn);

          // When we remove something on video dom, we also need to remove event on penetrate plugin
          if (target === 'video-dom') {
            this.__dispatcher.dom.videoExtendedNodes.forEach(function (node) {
              // $FlowFixMe: fn is function now
              removeEvent(node, name, fn);
            });
          }
        }

        bindedEventInfoList.splice(index$$1, 1);
        eventNamesList.splice(nameIndex, 1);
      }
    }, {
      key: '_getTargetDom',
      value: function _getTargetDom(target) {
        var targetDom = void 0;
        switch (target) {
          case 'container':
          case 'wrapper':
            // $FlowFixMe: fix dom index bug
            targetDom = this.__dispatcher.dom[target];
            break;
          default:
            targetDom = this.__dispatcher.dom.videoElement;
            break;
        }
        return targetDom;
      }
    }, {
      key: '_isEventNeedToBeHandled',
      value: function _isEventNeedToBeHandled(target, name) {
        // the plugin target do not need us to transfer
        // we have listened on esFullscreen in dom
        // we have listened mustListenVideoDomEvents
        // so the events above do not need to rebind
        return target !== 'plugin' && target !== 'esFullscreen' && (mustListenVideoDomEvents.indexOf(name) < 0 || target !== 'video');
      }
    }, {
      key: 'addPendingEvent',
      value: function addPendingEvent(target, name, id) {
        this.pendingEventsInfo[target].push([name, id]);
      }
    }, {
      key: 'applyPendingEvents',
      value: function applyPendingEvents(target) {
        var pendingEvents = this.pendingEventsInfo[target];
        var pendingEventsCopy = pendingEvents.splice(0, pendingEvents.length);
        while (pendingEventsCopy.length) {
          var _pendingEventsCopy$po = pendingEventsCopy.pop(),
              _pendingEventsCopy$po2 = _slicedToArray(_pendingEventsCopy$po, 2),
              _name2 = _pendingEventsCopy$po2[0],
              id = _pendingEventsCopy$po2[1];

          this._addEventListenerOnTarget({ name: _name2, target: target, id: id });
        }
      }
    }]);

    return Binder;
  }(), (_applyDecoratedDescriptor$4(_class$5.prototype, 'on', [_dec$5], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'on'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'off', [_dec2$4], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'off'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'once', [_dec3$3], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'once'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'emit', [_dec4$3, _dec5$2], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'emit'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'emitSync', [_dec6$2, _dec7$1], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'emitSync'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'trigger', [_dec8$1, _dec9$1], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'trigger'), _class$5.prototype), _applyDecoratedDescriptor$4(_class$5.prototype, 'triggerSync', [_dec10$1, _dec11$1], _Object$getOwnPropertyDescriptor(_class$5.prototype, 'triggerSync'), _class$5.prototype)), _class$5));

  var _dec$6, _dec2$5, _dec3$4, _dec4$4, _dec5$3, _dec6$3, _class$6;

  function _applyDecoratedDescriptor$5(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  var pluginConfigSet = {};
  var kernelsSet = {};
  function convertNameIntoId(name) {
    if (!isString(name)) throw new Error('Plugin\'s name must be a string, but not "' + name + '" in ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)));
    return camelize(name);
  }
  function checkPluginConfig(config) {
    if (isFunction(config)) {
      if (!(config.prototype instanceof Plugin)) {
        throw new TypeError('Your are trying to install plugin ' + config.name + ', but it\'s not extends from Chimee.plugin.');
      }
      return;
    }
    if (!isObject(config) || isEmpty(config)) throw new TypeError('plugin\'s config must be an Object, but not "' + config + '" in ' + (typeof config === 'undefined' ? 'undefined' : _typeof(config)));
    var name = config.name;

    if (!isString(name) || name.length < 1) throw new TypeError('plugin must have a legal namea, but not "' + name + '" in ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)));
  }
  /**
   * <pre>
   * Dispatcher is the hub of plugins, user, and video kernel.
   * It take charge of plugins install, use and remove
   * It also offer a bridge to let user handle video kernel.
   * </pre>
   */
  var Dispatcher = (_dec$6 = before(convertNameIntoId), _dec2$5 = before(convertNameIntoId), _dec3$4 = before(checkPluginConfig), _dec4$4 = before(convertNameIntoId), _dec5$3 = before(convertNameIntoId), _dec6$3 = before(convertNameIntoId), (_class$6 = function () {
    /**
     * @param  {UserConfig} config UserConfig for whole Chimee player
     * @param  {Chimee} vm referrence of outer class
     * @return {Dispatcher}
     */

    /**
     * the synchronous ready flag
     * @type {boolean}
     * @member readySync
     */

    /**
     * all plugins instance set
     * @type {Object}
     * @member plugins
     */
    function Dispatcher(config, vm) {
      var _this = this;

      _classCallCheck$1(this, Dispatcher);

      this.plugins = {};
      this.order = [];
      this.readySync = false;
      this.zIndexMap = {
        inner: [],
        outer: []
      };
      this.changeWatchable = true;
      this.kernelEventHandlerList = [];

      if (!isObject(config)) throw new TypeError('UserConfig must be an Object, but not "' + config + '" in ' + (typeof config === 'undefined' ? 'undefined' : _typeof(config)));
      /**
       * dom Manager
       * @type {Dom}
       */
      this.dom = new Dom(config, this);
      /**
       * Chimee's referrence
       * @type {[type]}
       */
      this.vm = vm;
      /**
       * tell user have Chimee installed finished
       * @type {Promises}
       */
      this.videoConfigReady = false;
      // create the videoconfig
      this.videoConfig = new VideoConfig(this, config);
      // support both plugin and plugins here as people often cofuse both
      // $FlowFixMe: we support plugins here, which should be illegal
      if (isArray(config.plugins) && !isArray(config.plugin)) {
        config.plugin = config.plugins;
        delete config.plugins;
      }
      this.binder = new Binder(this);
      this.binder.listenOnMouseMoveEvent(this.dom.videoElement);
      // use the plugin user want to use
      this._initUserPlugin(config.plugin);
      // add default config for container
      var containerConfig = deepAssign({}, defaultContainerConfig, config.container || {});
      // trigger the init life hook of plugin
      this.order.forEach(function (key) {
        return _this.plugins[key].__init(_this.videoConfig, containerConfig);
      });
      this.videoConfigReady = true;
      this.videoConfig.init();
      this.containerConfig = new Vessel(this, 'container', containerConfig);
      /**
       * video kernel
       * @type {Kernel}
       */
      this.kernel = this._createKernel(this.dom.videoElement, this.videoConfig);
      this.binder.applyPendingEvents('kernel');
      if (config.noDefaultContextMenu) {
        var noDefaultContextMenu = config.noDefaultContextMenu;

        var target = noDefaultContextMenu === 'container' || noDefaultContextMenu === 'wrapper' ? noDefaultContextMenu : 'video-dom';
        this.binder.on({
          target: target,
          id: '_vm',
          name: 'contextmenu',
          fn: function fn(evt) {
            return evt.preventDefault();
          },
          stage: 'main'
        });
      }
      // trigger auto load event
      var asyncInitedTasks = [];
      this.order.forEach(function (key) {
        var ready = _this.plugins[key].__inited();
        if (isPromise(ready)) {
          asyncInitedTasks.push(ready);
        }
      });
      this.readySync = asyncInitedTasks.length === 0;
      // tell them we have inited the whold player
      this.ready = this.readySync ? _Promise.resolve() : _Promise.all(asyncInitedTasks).then(function () {
        _this.readySync = true;
        _this.onReady();
      });
      if (this.readySync) this.onReady();
    }
    // to save the kernel event handler, so that we can remove it when we destroy the kernel

    /**
     * the z-index map of the dom, it contain some important infomation
     * @type {Object}
     * @member zIndexMap
     */

    /**
     * plugin's order
     * @type {Array<string>}
     * @member order
     */


    _createClass(Dispatcher, [{
      key: 'onReady',
      value: function onReady() {
        this.binder.trigger({
          target: 'plugin',
          name: 'ready',
          id: 'dispatcher'
        });
        this._autoloadVideoSrcAtFirst();
      }

      /**
       * use a plugin, which means we will new a plugin instance and include int this Chimee instance
       * @param  {Object|string} option you can just set a plugin name or plugin config
       * @return {Promise}
       */

    }, {
      key: 'use',
      value: function use(option) {
        if (isString(option)) option = { name: option, alias: undefined };
        if (!isObject(option) || isObject(option) && !isString(option.name)) {
          throw new TypeError('pluginConfig do not match requirement');
        }
        if (!isString(option.alias)) option.alias = undefined;
        var _option = option,
            name = _option.name,
            alias$$1 = _option.alias;

        option.name = alias$$1 || name;
        delete option.alias;
        var key = camelize(name);
        var id = camelize(alias$$1 || name);
        var pluginOption = option;
        var pluginConfig = Dispatcher.getPluginConfig(key);
        if (isEmpty(pluginConfig)) throw new TypeError('You have not installed plugin ' + key);
        if (isObject(pluginConfig)) {
          pluginConfig.id = id;
        }
        var plugin = isFunction(pluginConfig) ? new pluginConfig({ id: id }, this, pluginOption) // eslint-disable-line 
        : new Plugin(pluginConfig, this, pluginOption);
        this.plugins[id] = plugin;
        _Object$defineProperty(this.vm, id, {
          value: plugin,
          configurable: true,
          enumerable: false,
          writable: false
        });
        this.order.push(id);
        this._sortZIndex();
        if (this.videoConfigReady) plugin.__inited();
        return plugin.ready;
      }

      /**
       * unuse an plugin, we will destroy the plugin instance and exlude it
       * @param  {string} name plugin's name
       */

    }, {
      key: 'unuse',
      value: function unuse(id) {
        var plugin = this.plugins[id];
        if (!isObject(plugin) || !isFunction(plugin.$destroy)) {
          delete this.plugins[id];
          return;
        }
        plugin.$destroy();
        var orderIndex = this.order.indexOf(id);
        if (orderIndex > -1) {
          this.order.splice(orderIndex, 1);
        }
        delete this.plugins[id];
        delete this.vm[id];
      }
    }, {
      key: 'hasUsed',
      value: function hasUsed(id) {
        var plugin = this.plugins[id];
        return isObject(plugin);
      }
    }, {
      key: 'throwError',
      value: function throwError(error) {
        this.vm.__throwError(error);
      }
    }, {
      key: 'silentLoad',
      value: function silentLoad(src) {
        var _this2 = this;

        var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _option$duration = option.duration,
            duration = _option$duration === undefined ? 3 : _option$duration,
            _option$bias = option.bias,
            bias = _option$bias === undefined ? 0 : _option$bias,
            _option$repeatTimes = option.repeatTimes,
            repeatTimes = _option$repeatTimes === undefined ? 0 : _option$repeatTimes,
            _option$increment = option.increment,
            increment = _option$increment === undefined ? 0 : _option$increment,
            _option$isLive = option.isLive,
            isLive = _option$isLive === undefined ? this.videoConfig.isLive : _option$isLive,
            _option$box = option.box,
            box = _option$box === undefined ? this.videoConfig.box : _option$box,
            _option$kernels = option.kernels,
            kernels = _option$kernels === undefined ? this.videoConfig.kernels : _option$kernels,
            _option$preset = option.preset,
            preset = _option$preset === undefined ? this.videoConfig.preset : _option$preset;
        // all live stream seem as immediate mode
        // it's impossible to seek on live stream

        var immediate = option.immediate || isLive;
        // form the base config for kernel
        // it should be the same as the config now
        var config = { isLive: isLive, box: box, src: src, kernels: kernels, preset: preset };
        // build tasks accroding repeat times
        var tasks = new Array(repeatTimes + 1).fill(1).map(function (value, index$$1) {
          return function () {
            return new _Promise(function (resolve, reject) {
              // if abort, give up and reject
              if (option.abort) reject({ error: true, message: 'user abort the mission' });
              var video = document.createElement('video');
              var idealTime = _this2.kernel.currentTime + duration + increment * index$$1;
              video.muted = true;
              var newVideoReady = false;
              var kernel = void 0;
              var _videoError = void 0;
              var videoCanplay = void 0;
              var videoLoadedmetadata = void 0;
              // bind time update on old video
              // when we bump into the switch point and ready
              // we switch
              var oldVideoTimeupdate = function oldVideoTimeupdate() {
                var currentTime = _this2.kernel.currentTime;
                if (bias <= 0 && currentTime >= idealTime || bias > 0 && (Math.abs(idealTime - currentTime) <= bias && newVideoReady || currentTime - idealTime > bias)) {
                  removeEvent(_this2.dom.videoElement, 'timeupdate', oldVideoTimeupdate);
                  removeEvent(video, 'error', _videoError, true);
                  if (!newVideoReady) {
                    removeEvent(video, 'canplay', videoCanplay, true);
                    removeEvent(video, 'loadedmetadata', videoLoadedmetadata, true);
                    kernel.destroy();
                    return resolve();
                  }
                  return reject({
                    error: false,
                    video: video,
                    kernel: kernel
                  });
                }
              };
              videoCanplay = function videoCanplay() {
                newVideoReady = true;
                // you can set it immediately run by yourself
                if (immediate) {
                  removeEvent(_this2.dom.videoElement, 'timeupdate', oldVideoTimeupdate);
                  removeEvent(video, 'error', _videoError, true);
                  return reject({
                    error: false,
                    video: video,
                    kernel: kernel
                  });
                }
              };
              videoLoadedmetadata = function videoLoadedmetadata() {
                if (!isLive) {
                  kernel.seek(immediate ? _this2.kernel.currentTime : idealTime);
                }
              };
              _videoError = function videoError(evt) {
                removeEvent(video, 'canplay', videoCanplay, true);
                removeEvent(video, 'loadedmetadata', videoLoadedmetadata, true);
                removeEvent(_this2.dom.videoElement, 'timeupdate', oldVideoTimeupdate);
                kernel.off('error', _videoError);
                var error = void 0;
                if (!isEmpty(evt.data) && evt.data.errmsg) {
                  var errmsg = evt.data.errmsg;

                  Log$1.error("chimee's silentload bump into a kernel error", errmsg);
                  error = new Error(errmsg);
                } else {
                  error = !isEmpty(video.error) ? new Error(video.error.message) : new Error('unknow video error');
                  Log$1.error("chimee's silentload", error.message);
                }
                kernel.destroy();
                _this2._silentLoadTempKernel = undefined;
                return index$$1 === repeatTimes ? reject(error) : resolve(error);
              };
              addEvent(video, 'canplay', videoCanplay, true);
              addEvent(video, 'loadedmetadata', videoLoadedmetadata, true);
              addEvent(video, 'error', _videoError, true);
              kernel = _this2._createKernel(video, config);
              _this2._silentLoadTempKernel = kernel;
              kernel.on('error', _videoError);
              addEvent(_this2.dom.videoElement, 'timeupdate', oldVideoTimeupdate);
              kernel.load();
            });
          };
        });
        return runRejectableQueue(tasks).then(function () {
          var message = 'The silentLoad for ' + src + ' timed out. Please set a longer duration or check your network';
          return _Promise.reject(new Error(message));
        }).catch(function (data) {
          if (isError(data)) {
            return _Promise.reject(data);
          }
          if (data.error) {
            return _Promise.reject(new Error(data.message));
          }
          var video = data.video,
              kernel = data.kernel;

          if (option.abort) {
            kernel.destroy();
            return _Promise.reject(new Error('user abort the mission'));
          }
          var paused = _this2.dom.videoElement.paused;
          if (paused) {
            _this2.switchKernel({ video: video, kernel: kernel, config: config });
            return _Promise.resolve();
          }
          return new _Promise(function (resolve) {
            addEvent(video, 'play', function () {
              _this2.switchKernel({ video: video, kernel: kernel, config: config });
              resolve();
            }, true);
            video.play();
          });
        });
      }
    }, {
      key: 'load',
      value: function load(srcOrOption) {
        var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var src = isString(srcOrOption) ? srcOrOption : isObject(srcOrOption) && isString(srcOrOption.src) ? srcOrOption.src
        // give a chance for user to clear the src
        : '';
        if (isObject(srcOrOption)) {
          delete srcOrOption.src;
          option = srcOrOption;
        }
        var oldBox = this.kernel.box;
        var videoConfig = this.videoConfig;
        var _option2 = option,
            _option2$isLive = _option2.isLive,
            isLive = _option2$isLive === undefined ? videoConfig.isLive : _option2$isLive,
            _option2$box = _option2.box,
            box = _option2$box === undefined ? getLegalBox({ src: src, box: videoConfig.box }) : _option2$box,
            _option2$preset = _option2.preset,
            preset = _option2$preset === undefined ? videoConfig.preset : _option2$preset,
            _option2$kernels = _option2.kernels,
            kernels = _option2$kernels === undefined ? videoConfig.kernels : _option2$kernels;

        if (box !== 'native' || box !== oldBox || !isEmpty(option)) {
          var video = document.createElement('video');
          var config = { isLive: isLive, box: box, preset: preset, src: src, kernels: kernels };
          var kernel = this._createKernel(video, config);
          this.switchKernel({ video: video, kernel: kernel, config: config, notifyChange: true });
        }
        var originAutoLoad = this.videoConfig.autoload;
        this._changeUnwatchable(this.videoConfig, 'autoload', false);
        this.videoConfig.src = src || this.videoConfig.src;
        this.kernel.load(this.videoConfig.src);
        this._changeUnwatchable(this.videoConfig, 'autoload', originAutoLoad);
      }
    }, {
      key: 'switchKernel',
      value: function switchKernel(_ref) {
        var _this3 = this;

        var video = _ref.video,
            kernel = _ref.kernel,
            config = _ref.config,
            notifyChange = _ref.notifyChange;

        var oldKernel = this.kernel;
        var originVideoConfig = deepClone(this.videoConfig);
        this.dom.migrateVideoRequiredGuardedAttributes(video);
        this.dom.removeVideo();
        this.dom.installVideo(video);
        // as we will reset the currentVideoConfig on the new video
        // it will trigger the watch function as they maybe differnet
        // because video config will return the real situation
        // so we need to stop them
        this.videoConfig.changeWatchable = false;
        this.videoConfig.autoload = false;
        this.videoConfig.src = config.src;
        this.videoConfig._realDomAttr.forEach(function (key) {
          // $FlowFixMe: support computed key here
          if (key !== 'src') _this3.videoConfig[key] = originVideoConfig[key];
        });
        this.videoConfig.changeWatchable = true;
        this.binder.migrateKernelEvent(oldKernel, kernel);
        this.kernel = kernel;
        this._silentLoadTempKernel = undefined;
        var isLive = config.isLive,
            box = config.box,
            preset = config.preset,
            kernels = config.kernels;

        _Object$assign(this.videoConfig, { isLive: isLive, box: box, preset: preset, kernels: kernels });
        oldKernel.destroy();
        // delay video event binding
        // so that people can't feel the default value change
        // unless it's caused by autoload
        if (notifyChange) {
          this.binder && this.binder.bindEventOnVideo && this.binder.bindEventOnVideo(video);
        } else {
          setTimeout(function () {
            _this3.binder && _this3.binder.bindEventOnVideo && _this3.binder.bindEventOnVideo(video);
          });
        }
        // if we are in picutre in picture mode
        // we need to exit thie picture in picture mode
        if (this.inPictureInPictureMode) {
          this.exitPictureInPicture();
        }
      }
    }, {
      key: 'requestPictureInPicture',
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          var pipWindow, _ref3, PictureInPicture;

          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!('pictureInPictureEnabled' in document)) {
                    _context.next = 8;
                    break;
                  }

                  if (!this.inPictureInPictureMode) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt('return', _Promise.resolve(window.__chimee_picture_in_picture_window));

                case 3:
                  _context.next = 5;
                  return this.dom.videoElement.requestPictureInPicture();

                case 5:
                  pipWindow = _context.sent;

                  window.__chimee_picture_in_picture_window = pipWindow;
                  // if (autoplay) this.play();
                  return _context.abrupt('return', pipWindow);

                case 8:
                  _context.next = 10;
                  return Promise.resolve().then(function () { return pictureInPicture; });

                case 10:
                  _ref3 = _context.sent;
                  PictureInPicture = _ref3.default;

                  if (!Dispatcher.hasInstalled(PictureInPicture.name)) {
                    Dispatcher.install(PictureInPicture);
                  }
                  if (!this.hasUsed(PictureInPicture.name)) {
                    this.use(PictureInPicture.name);
                  }
                  return _context.abrupt('return', this.plugins.pictureInPicture.requestPictureInPicture());

                case 15:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function requestPictureInPicture() {
          return _ref2.apply(this, arguments);
        }

        return requestPictureInPicture;
      }()
    }, {
      key: 'exitPictureInPicture',
      value: function exitPictureInPicture() {
        if ('pictureInPictureEnabled' in document) {
          // if current video is not in picture-in-picture mode, do nothing
          if (this.inPictureInPictureMode) {
            window.__chimee_picture_in_picture_window = undefined;
            // $FlowFixMe: support new function in document
            return document.exitPictureInPicture();
          }
        }
        return this.plugins.pictureInPicture && this.plugins.pictureInPicture.exitPictureInPicture();
      }
    }, {
      key: 'destroy',


      /**
       * destroy function called when dispatcher destroyed
       */
      value: function destroy() {
        for (var _key in this.plugins) {
          this.unuse(_key);
        }
        this.binder.destroy();
        delete this.binder;
        this.dom.destroy();
        delete this.dom;
        this.kernel.destroy();
        delete this.kernel;
        delete this.vm;
        delete this.plugins;
        delete this.order;
      }

      /**
       * use a set of plugin
       * @param  {Array<UserPluginConfig>}  configs  a set of plugin config
       * @return {Array<Promise>}   a set of Promise indicate the plugin install stage
       */

    }, {
      key: '_initUserPlugin',
      value: function _initUserPlugin() {
        var _this4 = this;

        var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (!isArray(configs)) {
          configs = [];
        }
        return configs.map(function (config) {
          return _this4.use(config);
        });
      }

      /**
       * sort zIndex of plugins to make plugin display in order
       */

    }, {
      key: '_sortZIndex',
      value: function _sortZIndex() {
        var _this5 = this;

        var _order$reduce = this.order.reduce(function (levelSet, key) {
          var plugin = _this5.plugins[key];
          if (isEmpty(plugin)) return levelSet;
          var set = levelSet[plugin.$inner ? 'inner' : 'outer'];
          var level = plugin.$level;
          set[level] = set[level] || [];
          set[level].push(key);
          return levelSet;
        }, { inner: {}, outer: {} }),
            inner = _order$reduce.inner,
            outer = _order$reduce.outer;

        inner[0] = inner[0] || [];
        inner[0].unshift('videoElement');
        outer[0] = outer[0] || [];
        outer[0].unshift('container');
        var innerOrderArr = transObjectAttrIntoArray(inner);
        var outerOrderArr = transObjectAttrIntoArray(outer);
        this.dom.setPluginsZIndex(innerOrderArr);
        this.dom.setPluginsZIndex(outerOrderArr);
        this.zIndexMap.inner = innerOrderArr;
        this.zIndexMap.outer = outerOrderArr;
      }

      /**
       * get the top element's level
       * @param {boolean} inner get the inner array or the outer array
       */

    }, {
      key: '_getTopLevel',
      value: function _getTopLevel(inner) {
        var arr = this.zIndexMap[inner ? 'inner' : 'outer'];
        var plugin = this.plugins[arr[arr.length - 1]];
        return isEmpty(plugin) ? 0 : plugin.$level;
      }
    }, {
      key: '_autoloadVideoSrcAtFirst',
      value: function _autoloadVideoSrcAtFirst() {
        if (this.videoConfig.autoload) {
          if (!this.videoConfig.src) {
            Log$1.warn('You have not set the src, so you better set autoload to be false. Accroding to https://github.com/Chimeejs/chimee/blob/master/doc/zh-cn/chimee-api.md#src.');
            return;
          }
          this.binder.emit({
            name: 'load',
            target: 'plugin',
            id: 'dispatcher'
          }, { src: this.videoConfig.src });
        }
      }
    }, {
      key: '_changeUnwatchable',
      value: function _changeUnwatchable(object, property, value) {
        this.changeWatchable = false;
        object[property] = value;
        this.changeWatchable = true;
      }
    }, {
      key: '_createKernel',
      value: function _createKernel(video, config) {
        var kernels = config.kernels,
            preset = config.preset;
        var presetConfig = {};
        var newPreset = {};
        if (isArray(kernels)) {
          // SKC means SingleKernelConfig
          newPreset = kernels.reduce(function (kernels, keyOrSKC) {
            // if it is a string key, it means the kernel has been pre installed.
            if (isString(keyOrSKC)) {
              var kernelFn = kernelsSet[keyOrSKC];
              if (!isFunction(kernelFn)) {
                Log$1.warn('You have not installed kernel for ' + keyOrSKC + '.');
                return kernels;
              }
              kernels[keyOrSKC] = kernelFn;
              return kernels;
            }
            // if it is a SingleKernelConfig, it means user may pass in some config here
            // so we need to extract the handler
            // get the name of the handler
            // and collect the config for the handler
            if (isObject(keyOrSKC)) {
              var name = keyOrSKC.name,
                  handler = keyOrSKC.handler;
              // if the handler is a pure string, it means the kernel has been pre installed

              if (isString(handler)) {
                var _kernelFn = kernelsSet[handler];
                if (!isFunction(_kernelFn)) {
                  Log$1.warn('You have not installed kernel for ' + handler + '.');
                  return kernels;
                }
                kernels[handler] = _kernelFn;
                presetConfig[handler] = keyOrSKC;
                return kernels;
              }
              // if the handler is a function, it means that the user pass in the kernel directly
              // if the provide name, we use it as kernel name
              // if they do not provide name, we just use the function's name
              if (isFunction(handler)) {
                var kernelName = name || handler.name;
                kernels[kernelName] = handler;
                presetConfig[kernelName] = keyOrSKC;
                return kernels;
              }
              Log$1.warn('When you pass in an SingleKernelConfig in Array, you must clarify it\'s handler, we only support handler in string or function but not ' + (typeof handler === 'undefined' ? 'undefined' : _typeof(handler)));
              return kernels;
            }
            Log$1.warn('If you pass in kernels as array, you must pass in kernels in string or function, but not ' + (typeof keyOrSKC === 'undefined' ? 'undefined' : _typeof(keyOrSKC)));
            return kernels;
          }, {});
        }

        if (isObject(kernels)) {
          // SKC means SingleKernelConfig
          _Object$keys(kernels).forEach(function (key) {
            var fnOrSKC = kernels[key];
            // if it's a function, means we need to do nothing
            if (isFunction(fnOrSKC)) {
              newPreset[key] = fnOrSKC;
              return;
            }
            if (isObject(fnOrSKC)) {
              var handler = fnOrSKC.handler;
              // if handler is an string, it means user has pre install it

              if (isString(handler)) {
                var kernelFn = kernelsSet[handler];
                if (!isFunction(kernelFn)) {
                  Log$1.warn('You have not installed kernel for ' + handler + '.');
                  return;
                }
                newPreset[key] = kernelFn;
                presetConfig[key] = fnOrSKC;
                return;
              }
              if (isFunction(handler)) {
                newPreset[key] = handler;
                presetConfig[key] = fnOrSKC;
                return;
              }
              Log$1.warn('When you pass in an SingleKernelConfig in Object, you must clarify it\'s handler, we only support handler in string or function but not ' + (typeof handler === 'undefined' ? 'undefined' : _typeof(handler)));
              return;
            }
            Log$1.warn('If you pass in kernels as object, you must pass in kernels in string or function, but not ' + (typeof fnOrSKC === 'undefined' ? 'undefined' : _typeof(fnOrSKC)));
            return kernels;
          });
        }
        config.preset = _Object$assign(newPreset, preset);
        config.presetConfig = presetConfig;
        var kernel = new ChimeeKernel(video, config);
        return kernel;
      }
      /**
       * static method to install plugin
       * we will store the plugin config
       * @type {string} plugin's id
       */

    }, {
      key: 'inPictureInPictureMode',
      get: function get$$1() {
        return 'pictureInPictureEnabled' in document
        // $FlowFixMe: support new function in document
        ? this.dom.videoElement === document.pictureInPictureElement : Boolean(this.plugins.pictureInPicture && this.plugins.pictureInPicture.isShown);
      }
    }], [{
      key: 'install',
      value: function install(config) {
        var name = config.name;

        var id = camelize(name);
        if (!isEmpty(pluginConfigSet[id])) ;
        var pluginConfig = isFunction(config) ? config : deepAssign({ id: id }, config);
        pluginConfigSet[id] = pluginConfig;
        return id;
      }
    }, {
      key: 'hasInstalled',
      value: function hasInstalled(id) {
        return !isEmpty(pluginConfigSet[id]);
      }
    }, {
      key: 'uninstall',
      value: function uninstall(id) {
        delete pluginConfigSet[id];
      }
      /**
       * get Plugin config based on plugin's id
       * @type {[type]}
       */

    }, {
      key: 'getPluginConfig',
      value: function getPluginConfig(id) {
        return pluginConfigSet[id];
      }
    }, {
      key: 'installKernel',
      value: function installKernel(key, value) {
        var tasks = isObject(key) ? _Object$entries(key) : [[key, value]];
        tasks.forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          if (!isFunction(value)) throw new Error('The kernel you install on ' + key + ' must be a Function, but not ' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)));
          if (isFunction(kernelsSet[key])) Log$1.warn('You have alrady install a kernel on ' + key + ', and now we will replace it');
          kernelsSet[key] = value;
        });
      }

      // only use for debug in internal

    }, {
      key: 'uninstallKernel',
      value: function uninstallKernel(key) {
        delete kernelsSet[key];
      }
    }, {
      key: 'hasInstalledKernel',
      value: function hasInstalledKernel(key) {
        return isFunction(kernelsSet[key]);
      }
    }]);

    return Dispatcher;
  }(), (_applyDecoratedDescriptor$5(_class$6.prototype, 'unuse', [_dec$6], _Object$getOwnPropertyDescriptor(_class$6.prototype, 'unuse'), _class$6.prototype), _applyDecoratedDescriptor$5(_class$6.prototype, 'hasUsed', [_dec2$5], _Object$getOwnPropertyDescriptor(_class$6.prototype, 'hasUsed'), _class$6.prototype), _applyDecoratedDescriptor$5(_class$6.prototype, 'throwError', [autobind], _Object$getOwnPropertyDescriptor(_class$6.prototype, 'throwError'), _class$6.prototype), _applyDecoratedDescriptor$5(_class$6.prototype, 'inPictureInPictureMode', [nonenumerable], _Object$getOwnPropertyDescriptor(_class$6.prototype, 'inPictureInPictureMode'), _class$6.prototype), _applyDecoratedDescriptor$5(_class$6, 'install', [_dec3$4], _Object$getOwnPropertyDescriptor(_class$6, 'install'), _class$6), _applyDecoratedDescriptor$5(_class$6, 'hasInstalled', [_dec4$4], _Object$getOwnPropertyDescriptor(_class$6, 'hasInstalled'), _class$6), _applyDecoratedDescriptor$5(_class$6, 'uninstall', [_dec5$3], _Object$getOwnPropertyDescriptor(_class$6, 'uninstall'), _class$6), _applyDecoratedDescriptor$5(_class$6, 'getPluginConfig', [_dec6$3], _Object$getOwnPropertyDescriptor(_class$6, 'getPluginConfig'), _class$6)), _class$6));

  var _class$7, _descriptor$1;

  function _initDefineProp$1(target, property, descriptor, context) {
    if (!descriptor) return;

    _Object$defineProperty(target, property, {
      enumerable: descriptor.enumerable,
      configurable: descriptor.configurable,
      writable: descriptor.writable,
      value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
  }

  function _applyDecoratedDescriptor$6(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }
  var GlobalConfig = (_class$7 = function () {
    _createClass(GlobalConfig, [{
      key: 'silent',
      get: function get$$1() {
        return this._silent;
      },
      set: function set(val) {
        var _this = this;

        val = !!val;
        this._silent = val;
        _Object$keys(this.log).forEach(function (key) {
          _this.log[key] = !val;
        });
      }
    }, {
      key: 'useStyleFullscreen',
      get: function get$$1() {
        return index.useStyleFirst;
      },
      set: function set(val) {
        index.useStyleFirst = !!val;
      }
    }]);

    function GlobalConfig() {
      _classCallCheck$1(this, GlobalConfig);

      this.log = {
        error: true,
        info: true,
        warn: true,
        debug: true,
        verbose: true
      };

      _initDefineProp$1(this, '_silent', _descriptor$1, this);

      this.errorHandler = undefined;

      var props = _Object$keys(this.log).reduce(function (props, key) {
        props[key] = accessor({
          get: function get$$1() {
            // $FlowFixMe: we have check the keys
            return Log$1['ENABLE_' + key.toUpperCase()];
          },
          set: function set(val) {
            // $FlowFixMe: we have check the keys
            Log$1['ENABLE_' + key.toUpperCase()] = val;
            if (val === true) this.silent = false;
            return val;
          }
        });
        return props;
      }, {});
      applyDecorators(this.log, props, { self: true });
    }

    return GlobalConfig;
  }(), (_descriptor$1 = _applyDecoratedDescriptor$6(_class$7.prototype, '_silent', [nonenumerable], {
    enumerable: true,
    initializer: function initializer() {
      return false;
    }
  })), _class$7);

  var _dec$7, _class$8, _class2$1$1, _descriptor$2, _descriptor2$1, _descriptor3$1, _init, _init2, _init3, _init4, _init5, _init6, _init7, _init8, _init9, _class3, _temp;

  function _initDefineProp$2(target, property, descriptor, context) {
    if (!descriptor) return;

    _Object$defineProperty(target, property, {
      enumerable: descriptor.enumerable,
      configurable: descriptor.configurable,
      writable: descriptor.writable,
      value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
  }

  function _applyDecoratedDescriptor$7(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  var Chimee = (_dec$7 = autobindClass(), _dec$7(_class$8 = (_class2$1$1 = (_temp = _class3 = function (_VideoWrapper) {
    _inherits$1(Chimee, _VideoWrapper);

    _createClass(Chimee, null, [{
      key: 'registerEvents',


      // In some situation, we may have custom events
      // For example, we may have a custom kernel event
      // We can register the event through this method
      value: function registerEvents() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            name = _ref.name,
            target = _ref.target;

        if (!name || !isString(name)) throw new Error('The event name must be a string, but not ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)));
        if (!target || !isString(target)) throw new Error('The event target must be a string, but not ' + (typeof target === 'undefined' ? 'undefined' : _typeof(target)));
        if (target === 'kernel') {
          kernelEvents.push(name);
        }
      }
    }]);

    function Chimee(config) {
      _classCallCheck$1(this, Chimee);

      /* istanbul ignore if */
      var _this = _possibleConstructorReturn$1(this, (Chimee.__proto__ || _Object$getPrototypeOf(Chimee)).call(this));

      _this.destroyed = false;

      _initDefineProp$2(_this, '__id', _descriptor$2, _this);

      _initDefineProp$2(_this, 'version', _descriptor2$1, _this);

      _initDefineProp$2(_this, 'config', _descriptor3$1, _this);
      if (isString(config) || isElement(config)) {
        config = {
          wrapper: config,
          controls: true
        };
      } else if (isObject(config)) {
        if (!config.wrapper) throw new Error('You must pass in an legal object');
      } else {
        throw new Error('You must pass in an Object containing wrapper or string or element to new a Chimee');
      }
      // $FlowFixMe: we have check wrapper here
      _this.__dispatcher = new Dispatcher(config, _this);
      _this.ready = _this.__dispatcher.ready;
      _this.readySync = _this.__dispatcher.readySync;
      _this.__wrapAsVideo(_this.__dispatcher.videoConfig);
      return _this;
    }

    _createClass(Chimee, [{
      key: 'destroy',
      value: function destroy() {
        if (this.destroyed) return;
        _get(Chimee.prototype.__proto__ || _Object$getPrototypeOf(Chimee.prototype), '__destroy', this).call(this);
        this.__dispatcher.destroy();
        // $FlowFixMe: normal obejct define
        Object.defineProperty(this, '__dispatcher', {
          get: function get$$1() {
            throw new Error('This instance has been destroyed.');
          },

          enumerable: true,
          configurable: true
        });
        this.destroyed = true;
      }
    }, {
      key: 'use',
      value: function use(option) {
        return this.__dispatcher.use(option);
      }
    }, {
      key: 'unuse',
      value: function unuse(name) {
        return this.__dispatcher.unuse(name);
      }
    }, {
      key: '__throwError',
      value: function __throwError(error) {
        if (isString(error)) error = new Error(error);
        var errorHandler = this.config.errorHandler || Chimee.config.errorHandler;
        if (isFunction(errorHandler)) return errorHandler(error);
        if (Chimee.config.silent) return;
        /* istanbul ignore else */
        if (isError(error)) throw error;else console.error(error);
      }
    }]);

    return Chimee;
  }(VideoWrapper), _class3.plugin = Plugin, _class3.config = new GlobalConfig(), _class3.install = Dispatcher.install, _class3.uninstall = Dispatcher.uninstall, _class3.hasInstalled = Dispatcher.hasInstalled, _class3.installKernel = Dispatcher.installKernel, _class3.uninstallKernel = Dispatcher.uninstallKernel, _class3.hasInstalledKernel = Dispatcher.hasInstalledKernel, _class3.getPluginConfig = Dispatcher.getPluginConfig, _temp), (_descriptor$2 = _applyDecoratedDescriptor$7(_class2$1$1.prototype, '__id', [frozen], {
    enumerable: true,
    initializer: function initializer() {
      return '_vm';
    }
  }), _descriptor2$1 = _applyDecoratedDescriptor$7(_class2$1$1.prototype, 'version', [frozen], {
    enumerable: true,
    initializer: function initializer() {
      return '0.11.0';
    }
  }), _descriptor3$1 = _applyDecoratedDescriptor$7(_class2$1$1.prototype, 'config', [frozen], {
    enumerable: true,
    initializer: function initializer() {
      return {
        errorHandler: undefined
      };
    }
  }), _applyDecoratedDescriptor$7(_class2$1$1, 'plugin', [frozen], (_init = _Object$getOwnPropertyDescriptor(_class2$1$1, 'plugin'), _init = _init ? _init.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'config', [frozen], (_init2 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'config'), _init2 = _init2 ? _init2.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init2;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'install', [frozen], (_init3 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'install'), _init3 = _init3 ? _init3.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init3;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'uninstall', [frozen], (_init4 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'uninstall'), _init4 = _init4 ? _init4.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init4;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'hasInstalled', [frozen], (_init5 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'hasInstalled'), _init5 = _init5 ? _init5.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init5;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'installKernel', [frozen], (_init6 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'installKernel'), _init6 = _init6 ? _init6.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init6;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'uninstallKernel', [frozen], (_init7 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'uninstallKernel'), _init7 = _init7 ? _init7.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init7;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'hasInstalledKernel', [frozen], (_init8 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'hasInstalledKernel'), _init8 = _init8 ? _init8.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init8;
    }
  }), _class2$1$1), _applyDecoratedDescriptor$7(_class2$1$1, 'getPluginConfig', [frozen], (_init9 = _Object$getOwnPropertyDescriptor(_class2$1$1, 'getPluginConfig'), _init9 = _init9 ? _init9.value : undefined, {
    enumerable: true,
    configurable: true,
    writable: true,
    initializer: function initializer() {
      return _init9;
    }
  }), _class2$1$1)), _class2$1$1)) || _class$8);

  // $FlowFixMe: we can extend create here

  var PictureInPicture = function (_Plugin) {
    _inherits$1(PictureInPicture, _Plugin);

    function PictureInPicture(config) {
      var _ref;

      _classCallCheck$1(this, PictureInPicture);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _this = _possibleConstructorReturn$1(this, (_ref = PictureInPicture.__proto__ || _Object$getPrototypeOf(PictureInPicture)).call.apply(_ref, [this, _Object$assign(config, {
        el: document.createElement('canvas'),
        penetrate: true,
        inner: false
      })].concat(_toConsumableArray(args))));

      _this.isShown = false;
      _this.hasStopRender = true;
      _this.myStyle = {
        position: 'fixed',
        top: '',
        left: '',
        right: 0,
        bottom: 0,
        width: 277,
        height: 156
      };
      return _this;
    }

    _createClass(PictureInPicture, [{
      key: 'create',
      value: function create() {
        addClassName(this.$dom, 'chimee-plugin-picture-in-picture');
        this.getContext();
      }
    }, {
      key: 'inited',
      value: function inited() {
        this.setStyle();
      }
    }, {
      key: 'show',
      value: function show() {
        setStyle(this.$dom, 'display', 'block');
        this.isShown = true;
      }
    }, {
      key: 'hide',
      value: function hide() {
        setStyle(this.$dom, 'display', 'none');
        this.isShown = false;
      }
    }, {
      key: 'closeCurrentPicture',
      value: function closeCurrentPicture() {
        if (window.__chimee_picture_in_picture && window.__chimee_picture_in_picture.plugin) {
          window.__chimee_picture_in_picture.plugin.exitPictureInPicture();
        }
      }
    }, {
      key: 'requestPictureInPicture',
      value: function requestPictureInPicture() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$autoplay = _ref2.autoplay,
            autoplay = _ref2$autoplay === undefined ? false : _ref2$autoplay;

        this.closeCurrentPicture();
        this.show();
        this.poller(this.render);
        if (autoplay && this.paused) this.play();else if (!autoplay && !this.paused) this.pause();
        window.__chimee_picture_in_picture = {
          plugin: this,
          window: this.$dom,
          element: this.$video
        };
      }
    }, {
      key: 'exitPictureInPicture',
      value: function exitPictureInPicture() {
        this.hide();
        window.__chimee_picture_in_picture = {};
      }
    }, {
      key: 'getContext',
      value: function getContext() {
        this.ctx = this.$dom.getContext('2d');
      }
    }, {
      key: 'poller',
      value: function poller(fn) {
        var _this2 = this;

        requestAnimationFrame(function () {
          fn.call(_this2);
          if (_this2.isShown) {
            _this2.poller(fn);
            _this2.hasStopRender = false;
          } else {
            _this2.hasStopRender = true;
          }
        });
      }
    }, {
      key: 'render',
      value: function render() {
        if (this.isShown) {
          this.ctx.drawImage(this.$video, 0, 0, this.myStyle.width, this.myStyle.height);
        }
      }
    }, {
      key: 'setStyle',
      value: function setStyle$$1() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _Object$assign(this.myStyle, styles);
        this.$dom.setAttribute('width', this.myStyle.width.toString());
        this.$dom.setAttribute('height', this.myStyle.height.toString());
        for (var key in this.myStyle) {
          if (key === 'width' || key === 'height') continue;
          var value = this.myStyle[key];
          setStyle(this.$dom, key, value);
        }
      }
    }]);

    return PictureInPicture;
  }(Plugin);

  var pictureInPicture = /*#__PURE__*/Object.freeze({
    default: PictureInPicture
  });

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var _freeGlobal = freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = _freeGlobal || freeSelf || Function('return this')();

  var _root = root;

  /** Built-in value references. */
  var Symbol$1 = _root.Symbol;

  var _Symbol = Symbol$1;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty$2.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag;

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  var _objectToString = objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag$1 && symToStringTag$1 in Object(value))
      ? _getRawTag(value)
      : _objectToString(value);
  }

  var _baseGetTag = baseGetTag;

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray$1 = Array.isArray;

  var isArray_1 = isArray$1;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike;

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  var _overArg = overArg;

  /** Built-in value references. */
  var getPrototype = _overArg(Object.getPrototypeOf, Object);

  var _getPrototype = getPrototype;

  /** `Object#toString` result references. */
  var objectTag = '[object Object]';

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
      objectProto$2 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = _getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty$3.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor &&
      funcToString.call(Ctor) == objectCtorString;
  }

  var isPlainObject_1 = isPlainObject;

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  var isObject_1 = isObject$1;

  /**
   * Checks if `value` is `null` or `undefined`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
   * @example
   *
   * _.isNil(null);
   * // => true
   *
   * _.isNil(void 0);
   * // => true
   *
   * _.isNil(NaN);
   * // => false
   */

  function genTraversalHandler$2(fn, setter) {
    if (setter === void 0) {
      setter = function setter(target, key, value) {
        target[key] = value;
      };
    }

    function recursiveFn(source, target, key) {
      if (isArray_1(source) || isPlainObject_1(source)) {
        target = !isObject_1(target) ? isPlainObject_1(source) ? {} : [] : target;

        for (var name_1 in source) {
          if (!source.hasOwnProperty(name_1)) {
            continue;
          }

          setter(target, name_1, recursiveFn(source[name_1], target[name_1], name_1));
        }

        return target;
      }

      return fn(source, target, key);
    }

    return recursiveFn;
  }
  var myDeepAssign = genTraversalHandler$2(function (val) {
    return val;
  });
  function deepAssign$2() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (args.length < 2) {
      throw new Error("deepAssign accept two and more argument");
    }

    for (var i = args.length - 1; i > -1; i--) {
      if (!isObject_1(args[i])) {
        throw new TypeError("deepAssign only accept non primitive type");
      }
    }

    var target = args.shift();
    args.forEach(function (source) {
      return myDeepAssign(source, target);
    });
    return target;
  }
  function bind$2(fn, context) {
    if (fn.bind) {
      return fn.bind(context);
    } else if (fn.apply) {
      return function __autobind__() {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return fn.apply(context, args);
      };
    }

    return function __autobind__() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return fn.call.apply(fn, [context].concat(args));
    };
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */

  var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && _freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  module.exports = nodeUtil;
  });

  /* Node.js helper references. */
  var nodeIsRegExp = _nodeUtil && _nodeUtil.isRegExp;

  /* Node.js helper references. */
  var nodeIsDate = _nodeUtil && _nodeUtil.isDate;

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   *
   * _.isUndefined(null);
   * // => false
   */

  /**
   * toxic-predicate-functions v0.2.5
   * (c) 2017-2019 toxic-johann
   * Released under MIT
   * Built ad Thu Apr 25 2019 22:20:44 GMT+0800 (China Standard Time)
   */
  var inBrowser$1 = typeof window !== "undefined" && Object.prototype.toString.call(window) !== "[object Object]";
  var isObject$2 = isPlainObject_1;

  /**
   * chimee-helper v0.2.11
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var createClass$1 = _createClass$1;

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  var superPropBase = _superPropBase;

  var get$1 = createCommonjsModule(function (module) {
  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      module.exports = _get = Reflect.get;
    } else {
      module.exports = _get = function _get(target, property, receiver) {
        var base = superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  module.exports = _get;
  });

  var Base = /*#__PURE__*/function () {
    function Base(parent) {
      classCallCheck(this, Base);

      this.parent = parent;
    }

    createClass$1(Base, [{
      key: "create",
      value: function create() {
        this.createEl();
        this.addAllEvent();
        this.option.create && this.option.create.apply(this);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.removeAllEvent();
        this.option.destroy && this.option.destroy.apply(this);
      }
    }, {
      key: "createEl",
      value: function createEl() {
        this.$dom = document.createElement(this.option.tag);
        typeof this.option.html === 'string' ? this.$dom.innerHTML = this.option.html : this.$dom.appendChild(this.option.html);
        this.parent.$wrap.appendChild(this.$dom);
      }
    }, {
      key: "addAllEvent",
      value: function addAllEvent() {
        var _this = this;

        this.option.defaultEvent && Object.keys(this.option.defaultEvent).forEach(function (item) {
          var key = _this.option.defaultEvent[item];
          _this[key] = bind$2(_this[key], _this);
          addEvent(_this.$dom, item, _this[key], false, false);
        });
        this.option.event && Object.keys(this.option.event).forEach(function (item) {
          var key = '__' + item;
          _this[key] = bind$2(_this.option.event[item], _this);
          addEvent(_this.$dom, item, _this[key], false, false);
        });
      }
    }, {
      key: "removeAllEvent",
      value: function removeAllEvent() {
        var _this2 = this;

        if (!(this.$dom instanceof HTMLElement)) {
          this.$dom = this.$dom[0];
        }

        this.option.defaultEvent && Object.keys(this.option.defaultEvent).forEach(function (item) {
          var key = _this2.option.defaultEvent[item];
          _this2[key] = bind$2(_this2[key], _this2);
          removeEvent(_this2.$dom, item, _this2[key], false, false);
        });
        this.option.event && Object.keys(this.option.event).forEach(function (item) {
          var key = '__' + item;
          _this2[key] = bind$2(_this2.option.event[item], _this2);
          removeEvent(_this2.$dom, item, _this2[key], false, false);
        });
      }
    }]);

    return Base;
  }();

  /**
   * 自定义组件配置
   */

  var Component = /*#__PURE__*/function (_Base) {
    inherits(Component, _Base);

    function Component(parent, option) {
      var _this;

      classCallCheck(this, Component);

      _this = possibleConstructorReturn(this, getPrototypeOf(Component).call(this, parent));
      _this.option = option;

      _this.init();

      return _this;
    }

    createClass$1(Component, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(Component.prototype), "create", this).call(this);

        addClassName(this.$dom, 'chimee-flex-component');
      }
    }]);

    return Component;
  }(Base);

  /**
   * play 配置
   */

  var defaultOption = {
    tag: 'chimee-control-state',
    html: "\n    <chimee-control-state-play></chimee-control-state-play>\n    <chimee-control-state-pause></chimee-control-state-pause>\n  ",
    animate: {
      icon: "\n      <svg viewBox=\"0 0 200 200\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <g fill=\"#ffffff\" stroke=\"#ffffff\">\n          <path class=\"left\"></path>\n          <path class=\"right\"></path>\n        </g>\n      </svg>\n    ",
      path: {
        play: {
          left: 'M0.921875,0.265625L0.921875,197.074852L95.7890625,149L96.2929688,49Z',
          right: 'M90.3142151,45.9315226L90.3142151,151.774115L201.600944,99.9938782L201.600944,98.0237571Z'
        },
        pause: {
          left: 'M0.921875,1.265625L0.921875,198.074852L79.3611677,198.074852L79.3611677,0.258923126Z',
          right: 'M126.921875,1.265625L126.921875,198.074852L205.361168,198.074852L205.361168,0.258923126Z'
        }
      }
    },
    defaultEvent: {
      click: 'click'
    }
  };

  var Play = /*#__PURE__*/function (_Base) {
    inherits(Play, _Base);

    function Play(parent, option) {
      var _this;

      classCallCheck(this, Play);

      _this = possibleConstructorReturn(this, getPrototypeOf(Play).call(this, parent));
      _this.option = deepAssign$2(defaultOption, isObject$2(option) ? option : {});
      _this.animate = false;

      _this.init();

      return _this;
    }

    createClass$1(Play, [{
      key: "init",
      value: function init() {
        // 创建 html ／ 绑定事件
        get$1(getPrototypeOf(Play.prototype), "create", this).call(this);

        this.$dom = $(this.$dom);
        this.$dom.addClass('chimee-flex-component'); // 判断是否是默认或者用户提供 icon

        if (this.option.icon && this.option.icon.play && this.option.icon.pause) {
          this.$play = this.$dom.find('chimee-control-state-play');
          this.$pause = this.$dom.find('chimee-control-state-pause');
          this.$play.html(this.option.icon.play);
          this.$pause.html(this.option.icon.pause);
        } else if (!this.option.bitmap) {
          this.animate = true;
          this.option.animate.path = this.option.path ? this.option.path : this.option.animate.path;
          this.$dom.html(this.option.animate.icon);
          this.$left = this.$dom.find('.left');
          this.$right = this.$dom.find('.right');
        }

        this.changeState('pause');
      }
    }, {
      key: "changeState",
      value: function changeState(state) {
        var nextState = state === 'play' ? 'pause' : 'play';
        this.state = state;
        addClassName(this.parent.$dom, nextState);
        removeClassName(this.parent.$dom, state);
        this.animate && this.setPath(nextState);
      }
    }, {
      key: "setPath",
      value: function setPath(state) {
        var path = this.option.animate.path;

        if (state === 'play') {
          this.$left.attr('d', path.play.left);
          this.$right.attr('d', path.play.right);
        } else {
          this.$left.attr('d', path.pause.left);
          this.$right.attr('d', path.pause.right);
        }
      }
    }, {
      key: "click",
      value: function click(e) {
        var nextState = this.state === 'play' ? 'pause' : 'play';
        this.changeState(nextState);
        this.parent.$emit(nextState);
      }
    }]);

    return Play;
  }(Base);

  function _applyDecoratedDescriptor$8(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }

    return desc;
  }

  var applyDecoratedDescriptor = _applyDecoratedDescriptor$8;

  var _class$9;
  /**
   * Volume 配置
   */

  var defaultOption$1 = {
    tag: 'chimee-volume',
    html: "\n    <chimee-volume-state>\n      <chimee-volume-state-mute></chimee-volume-state-mute>\n      <chimee-volume-state-low></chimee-volume-state-low>\n      <chimee-volume-state-high></chimee-volume-state-high>\n    </chimee-volume-state>\n    <chimee-volume-bar>\n      <chimee-volume-bar-wrap>\n        <chimee-volume-bar-bg></chimee-volume-bar-bg>\n        <chimee-volume-bar-all>\n          <chimee-volume-bar-ball></chimee-volume-bar-ball>\n        </chimee-volume-bar-all>\n        <chimee-volume-bar-track></chimee-volume-bar-track>\n      </chimee-volume-bar-wrap>\n    </chimee-volume-bar>\n  ",
    animate: {
      icon: "\n      <svg viewBox=\"0 0 107 101\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <g class=\"volume\">\n          <polygon class=\"horn\" points=\"0.403399942 30 27.3842118 30 56.8220589 2.84217094e-14 57.9139815 100 27.3842118 70 0.403399942 70\"></polygon>\n          <path class=\"ring1\" d=\"M63,5.00975239 C69.037659,4.78612057 75.9178585,8.40856146 83.6405984,15.877075 C95.2247083,27.0798454 100,34.7975125 100,50.9608558 C100,67.1241991 95.3628694,73.7907482 83.6405984,83.8306724 C75.8257511,90.5239552 68.9455516,94.0320644 63,94.355\" fill-opacity=\"0\" stroke-width=\"10\"></path>\n          <path class=\"ring2\" d=\"M65.2173913,29.4929195 C67.8779343,29.3931169 70.9097496,31.0097416 74.3128371,34.3427934 C79.4174684,39.3423712 81.5217391,42.7866154 81.5217391,50 C81.5217391,57.2133846 79.4783502,60.1885354 74.3128371,64.6691576 C70.8691617,67.656239 67.8373465,69.2218397 65.2173913,69.3659595\" fill-opacity=\"0\" stroke-width=\"10\"></path>\n          <path class=\"line\" d=\"M4.19119202,3.65220497 L102,96\" stroke-width=\"10\"></path>\n        </g>\n      </svg>\n    "
    },
    defaultEvent: {
      mousedown: 'mousedown'
    }
  };

  var getElementPath = function getElementPath(elem) {
    var path = [];
    if (elem === null) return path;
    path.push(elem);

    while (elem.parentNode !== null) {
      elem = elem.parentNode;
      path.push(elem);
    }
    return path;
  };

  var Volume = (_class$9 = /*#__PURE__*/function (_Base) {
    inherits(Volume, _Base);

    function Volume(parent, option) {
      var _this;

      classCallCheck(this, Volume);

      _this = possibleConstructorReturn(this, getPrototypeOf(Volume).call(this, parent));
      _this.parent.preVolume = 0;
      _this.option = deepAssign$2(defaultOption$1, isObject$2(option) ? option : {});

      _this.init();

      return _this;
    }

    createClass$1(Volume, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        get$1(getPrototypeOf(Volume.prototype), "create", this).call(this);

        this.$dom = $(this.$dom);
        this.$state = this.$dom.find('chimee-volume-state');
        this.$bar = this.$dom.find('chimee-volume-bar');
        this.$all = this.$dom.find('chimee-volume-bar-all');
        this.$bg = this.$dom.find('chimee-volume-bar-bg');
        this.layout = this.option.layout === 'vertical' ? 'vertical' : 'horizonal'; // 判断是否是默认或者用户提供 icon

        if (this.option.icon && this.option.icon.mute && this.option.icon.low) {
          this.option.icon.high = this.option.icon.high || this.option.icon.low;
          this.$mute = this.$dom.find('chimee-volume-state-mute');
          this.$low = this.$dom.find('chimee-volume-state-low');
          this.$high = this.$dom.find('chimee-volume-state-high');
          this.$mute.html(this.option.icon.mute);
          this.$low.html(this.option.icon.low);
          this.$high.html(this.option.icon.high);
        } else if (!this.option.bitmap) {
          this.animate = true;
          this.$state.html(this.option.animate.icon);
        }

        this.$dom.addClass("chimee-flex-component ".concat(this.layout));
        this.changeState();
        this.watch_muted = this.parent.$watch('muted', function (val) {
          _this2.update();
        });
      }
    }, {
      key: "inited",
      value: function inited() {
        this.update();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.watch_muted();

        get$1(getPrototypeOf(Volume.prototype), "destroy", this).call(this);
      }
    }, {
      key: "changeState",
      value: function changeState() {
        if (this.parent.muted || this.parent.volume === 0) {
          this.state = 'mute';
        } else if (this.parent.volume > 0 && this.parent.volume <= 0.5) {
          this.state = 'low';
        } else if (this.parent.volume > 0.5 && this.parent.volume <= 1) {
          this.state = 'high';
        }

        this.$dom.removeClass('mute low high');
        this.$dom.addClass(this.state);
      }
    }, {
      key: "click",
      value: function click(e) {
        var path = e.path || getElementPath(e.target);

        if (path.indexOf(this.$state[0]) !== -1) {
          this.stateClick(e);
          return 'state';
        } else if (path.indexOf(this.$bar[0]) !== -1) {
          this.barClick(e);
          return 'bar';
        }

        return 'padding';
      }
    }, {
      key: "stateClick",
      value: function stateClick() {
        if (this.parent.muted) {
          this.parent.muted = false;
          return;
        }

        var currentVolume = this.parent.volume;
        this.parent.volume = currentVolume === 0 ? this.parent.preVolume : 0;
        this.parent.preVolume = currentVolume;
        this.changeState();
      }
    }, {
      key: "barClick",
      value: function barClick(e) {
        var volume = this.layout === 'vertical' ? 1 - e.offsetY / this.$bg[0].offsetHeight : e.offsetX / this.$bg[0].offsetWidth;
        this.parent.volume = volume < 0 ? 0 : volume > 1 ? 1 : volume;
        this.update();
      }
    }, {
      key: "mousedown",
      value: function mousedown(e) {
        if (this.click(e) !== 'bar') return;
        this.startX = this.layout === 'vertical' ? e.clientY : e.clientX;
        this.startVolume = this.parent.volume;
        addEvent(window, 'mousemove', this.draging);
        addEvent(window, 'mouseup', this.dragEnd);
        addEvent(window, 'contextmenu', this.dragEnd);
      }
      /**
       * 更新声音条
       */

    }, {
      key: "update",
      value: function update() {
        this.changeState();
        var volume = this.parent.muted ? 0 : this.parent.volume;
        this.layout === 'vertical' ? this.$all.css('height', "".concat(volume * 100, "%")) : this.$all.css('width', "".concat(volume * 100, "%"));
      }
      /**
       * 开始拖拽
       * @param {EventObject} e 鼠标事件
       */

    }, {
      key: "draging",
      value: function draging(e) {
        this.endX = this.layout === 'vertical' ? e.clientY : e.clientX;
        var dragVolume = this.layout === 'vertical' ? (this.startX - this.endX) / this.$bg[0].offsetHeight : (this.endX - this.startX) / this.$bg[0].offsetWidth;
        var dragAfterVolume = +(this.startVolume + dragVolume).toFixed(2);
        this.parent.volume = dragAfterVolume < 0 ? 0 : dragAfterVolume > 1 ? 1 : dragAfterVolume;
        this.parent.muted = false;
      }
      /**
       * 结束拖拽
       */

    }, {
      key: "dragEnd",
      value: function dragEnd() {
        this.startX = 0;
        this.startVolume = 0;
        removeEvent(window, 'mousemove', this.draging);
        removeEvent(window, 'mouseup', this.dragEnd);
        removeEvent(window, 'contextmenu', this.dragEnd);
      }
    }]);

    return Volume;
  }(Base), (applyDecoratedDescriptor(_class$9.prototype, "draging", [autobind], Object.getOwnPropertyDescriptor(_class$9.prototype, "draging"), _class$9.prototype), applyDecoratedDescriptor(_class$9.prototype, "dragEnd", [autobind], Object.getOwnPropertyDescriptor(_class$9.prototype, "dragEnd"), _class$9.prototype)), _class$9);

  var _class$a;
  var defaultOption$2 = {
    tag: 'chimee-progressbar',
    html: "\n    <chimee-progressbar-wrap>\n      <chimee-progressbar-bg class=\"chimee-progressbar-line\"></chimee-progressbar-bg>\n      <chimee-progressbar-buffer class=\"chimee-progressbar-line\"></chimee-progressbar-buffer>\n      <chimee-progressbar-all class=\"chimee-progressbar-line\">\n        <chimee-progressbar-ball></chimee-progressbar-ball>\n      </chimee-progressbar-all>\n      <chimee-progressbar-tip></chimee-progressbar-tip>\n    </chimee-progressbar-wrap>\n  "
  };
  var ProgressBar = (_class$a = /*#__PURE__*/function (_Base) {
    inherits(ProgressBar, _Base);

    function ProgressBar(parent, option) {
      var _this;

      classCallCheck(this, ProgressBar);

      _this = possibleConstructorReturn(this, getPrototypeOf(ProgressBar).call(this, parent));
      _this.option = deepAssign$2(defaultOption$2, isObject$2(option) ? option : {});
      _this.visiable = option !== false;

      _this.init();

      return _this;
    }

    createClass$1(ProgressBar, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(ProgressBar.prototype), "create", this).call(this);

        this.$dom = $(this.$dom);
        this.$wrap = this.$dom.find('chimee-progressbar-wrap');
        this.$buffer = this.$dom.find('chimee-progressbar-buffer');
        this.$all = this.$dom.find('chimee-progressbar-all');
        this.$tip = this.$dom.find('chimee-progressbar-tip');
        this.$track = this.$dom.find('chimee-progressbar-track');
        this.$line = this.$dom.find('.chimee-progressbar-line');
        this.$ball = this.$dom.find('chimee-progressbar-ball');
        this.$dom.addClass('chimee-flex-component'); // css 配置

        !this.visiable && this.$dom.css('visibility', 'hidden'); // this.$line.css({
        //   top: this.$wrap.
        // });
        // 进度条居中布局，还是在上方

        if (this.option.layout === 'top') {
          this.$dom.addClass('progressbar-layout-top');
          this.$wrap.css({
            // left: -this.$dom[0].offsetLeft + 'px',
            top: -this.$ball[0].offsetHeight + 'px' // height: this.$ball[0].offsetHeight * 2 + 'px'

          }); // this.$line.css({
          //   top: this.$ball[0].offsetHeight + 'px'
          // })

          setStyle(this.parent.$wrap, 'paddingTop', this.$ball[0].offsetHeight + 'px');
        }

        this.addWrapEvent();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.removeWrapEvent(); // 解绑全屏监听事件

        this.watch_screen && this.watch_screen();

        get$1(getPrototypeOf(ProgressBar.prototype), "destroy", this).call(this);
      }
    }, {
      key: "addWrapEvent",
      value: function addWrapEvent() {
        this.$wrap.on('mousedown', this.mousedown);
        this.$wrap.on('mousemove', this.tipShow);
        this.$wrap.on('mouseleave', this.tipEnd);
      }
    }, {
      key: "removeWrapEvent",
      value: function removeWrapEvent() {
        this.$wrap.off('mousedown', this.mousedown);
        this.$wrap.off('mousemove', this.tipShow);
        this.$wrap.off('mouseleave', this.tipEnd);
      }
      /**
       * 缓存进度条更新 progress 事件
       */

    }, {
      key: "progress",
      value: function progress() {
        var buffer = 0;

        try {
          buffer = this.parent.buffered.end(0);
        } catch (e) {}

        var bufferWidth = buffer / this.parent.duration * 100 + '%';
        this.$buffer.css('width', bufferWidth);
      }
      /**
       * requestAnimationFrame 来更新进度条, timeupdate 事件
       */

    }, {
      key: "update",
      value: function update() {
        // const allWidth = this.$wrap[0].offsetWidth - this.$ball[0].offsetWidth;
        var time = this._currentTime !== undefined ? this._currentTime : this.parent.currentTime;
        var timePer = time ? time / this.parent.duration : 0; // const timeWidth = timePer * allWidth;

        this.$all.css('width', "calc(".concat(timePer * 100, "% - ").concat(this.$ball[0].offsetWidth / 2, "px"));
      }
    }, {
      key: "mousedown",
      value: function mousedown(e) {
        // const ballRect = this.$ball[0].getClientRects()[0];
        // const ballLeft = ballRect.left;
        // const ballRight = ballRect.left + ballRect.width;
        // this.inBall = e.clientX <= ballRight && e.clientX >= ballLeft;
        if (e.target === this.$tip[0]) return; // return when duration is NaN chimee#129

        if (this.parent.duration !== this.parent.duration) {
          console.error('isNaN(duration) === true');
          return;
        }

        this._currentTime = e.offsetX / this.$wrap[0].offsetWidth * this.parent.duration; // if(!this.inBall) this.update();

        this.startX = e.clientX;
        this.startTime = this._currentTime;
        addEvent(window, 'mousemove', this.draging);
        addEvent(window, 'mouseup', this.dragEnd);
        addEvent(window, 'contextmenu', this.dragEnd);
      }
      /**
       * 开始拖拽
       * @param {EventObject} e 鼠标事件
       */

    }, {
      key: "draging",
      value: function draging(e) {
        this.endX = e.clientX;
        var dragTime = (this.endX - this.startX) / this.$wrap[0].offsetWidth * this.parent.duration;
        var dragAfterTime = +(this.startTime + dragTime).toFixed(2);
        this._currentTime = dragAfterTime < 0 ? 0 : dragAfterTime > this.parent.duration ? this.parent.duration : dragAfterTime;
        this.update();
      }
      /**
       * 结束拖拽
       */

    }, {
      key: "dragEnd",
      value: function dragEnd() {
        this.update();
        this.startX = 0;
        this.startTime = 0; // if(!this.inBall) {

        this.parent.currentTime = this._currentTime; // this.inBall = false;
        // }

        this._currentTime = undefined;
        removeEvent(window, 'mousemove', this.draging);
        removeEvent(window, 'mouseup', this.dragEnd);
        removeEvent(window, 'contextmenu', this.dragEnd);
      }
    }, {
      key: "tipShow",
      value: function tipShow(e) {
        if (e.target === this.$tip[0] || e.target === this.$ball[0]) {
          this.$tip.css('display', 'none');
          return;
        }
        var time = e.offsetX / this.$wrap[0].offsetWidth * this.parent.duration;
        time = time < 0 ? 0 : time > this.parent.duration ? this.parent.duration : time;
        var tipContent = formatTime(time);
        var left = e.offsetX - this.$tip[0].offsetWidth / 2;
        var leftBound = this.$wrap[0].offsetWidth - this.$tip[0].offsetWidth;
        left = left < 0 ? 0 : left > leftBound ? leftBound : left;
        this.$tip.text(tipContent);
        this.$tip.css('display', 'inline-block');
        this.$tip.css('left', "".concat(left, "px"));
      }
    }, {
      key: "tipEnd",
      value: function tipEnd() {
        this.$tip.css('display', 'none');
      }
    }, {
      key: "changePointerEvent",
      value: function changePointerEvent(value) {
        this.$wrap.css('pointerEvents', value);
      }
    }]);

    return ProgressBar;
  }(Base), (applyDecoratedDescriptor(_class$a.prototype, "mousedown", [autobind], Object.getOwnPropertyDescriptor(_class$a.prototype, "mousedown"), _class$a.prototype), applyDecoratedDescriptor(_class$a.prototype, "draging", [autobind], Object.getOwnPropertyDescriptor(_class$a.prototype, "draging"), _class$a.prototype), applyDecoratedDescriptor(_class$a.prototype, "dragEnd", [autobind], Object.getOwnPropertyDescriptor(_class$a.prototype, "dragEnd"), _class$a.prototype), applyDecoratedDescriptor(_class$a.prototype, "tipShow", [autobind], Object.getOwnPropertyDescriptor(_class$a.prototype, "tipShow"), _class$a.prototype), applyDecoratedDescriptor(_class$a.prototype, "tipEnd", [autobind], Object.getOwnPropertyDescriptor(_class$a.prototype, "tipEnd"), _class$a.prototype)), _class$a);

  /**
   * progressTime 配置
   */

  var defaultOption$3 = {
    tag: 'chimee-progresstime',
    html: "\n    <chimee-progresstime-pass>00:00</chimee-progresstime-pass\n    ><chimee-progresstime-total\n      ><span>/</span\n      ><chimee-progresstime-total-value>00:00</chimee-progresstime-total-value>\n    </chimee-progresstime-total>\n  "
  };

  var ProgressTime = /*#__PURE__*/function (_Base) {
    inherits(ProgressTime, _Base);

    function ProgressTime(parent, option) {
      var _this;

      classCallCheck(this, ProgressTime);

      _this = possibleConstructorReturn(this, getPrototypeOf(ProgressTime).call(this, parent));
      _this.option = deepAssign$2(defaultOption$3, isObject$2(option) ? option : {});

      _this.init();

      return _this;
    }

    createClass$1(ProgressTime, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(ProgressTime.prototype), "create", this).call(this);

        this.$dom = $(this.$dom);
        this.$total = this.$dom.find('chimee-progresstime-total-value');
        this.$pass = this.$dom.find('chimee-progresstime-pass');
        this.$dom.addClass('chimee-flex-component');
      }
    }, {
      key: "updatePass",
      value: function updatePass() {
        this.$pass.text(formatTime(this.parent.currentTime));
      }
    }, {
      key: "updateTotal",
      value: function updateTotal() {
        this.$total.text(formatTime(this.parent.duration));
      }
    }]);

    return ProgressTime;
  }(Base);

  var _class$b;
  /**
   * Screen 配置
   */

  var defaultOption$4 = {
    tag: 'chimee-screen',
    html: "\n    <chimee-screen-full>\n      <svg viewBox=\"0 0 67 66\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n          <!-- Generator: Sketch 43.1 (39012) - http://www.bohemiancoding.com/sketch -->\n          <desc>Created with Sketch.</desc>\n          <defs></defs>\n          <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n              <g id=\"screen-small\" transform=\"translate(33.756308, 32.621867) rotate(45.000000) translate(-33.756308, -32.621867) translate(18.756308, -10.378133)\" fill=\"#FFFFFF\">\n                  <polygon id=\"Path\" transform=\"translate(14.967695, 66.389245) rotate(180.000000) translate(-14.967695, -66.389245) \" points=\"11.5190786 46.9431778 11.7210093 70.7913773 0.565180527 70.7913773 15.4674455 85.8353125 29.3702096 70.7913773 18.5573247 70.7702156 18.5573247 46.9431778\"></polygon>\n                  <polygon id=\"Path\" points=\"11.5190786 0.274130278 11.7210093 24.1223298 0.565180527 24.1223298 15.4674455 39.1662649 29.3702096 24.1223298 18.5573247 24.1011681 18.5573247 0.274130278\"></polygon>\n              </g>\n          </g>\n      </svg>\n    </chimee-screen-full>\n    <chimee-screen-small>\n      <svg viewBox=\"0 0 61 62\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <!-- Generator: Sketch 43.1 (39012) - http://www.bohemiancoding.com/sketch -->\n        <desc>Created with Sketch.</desc>\n        <defs></defs>\n        <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n            <g id=\"Group\" transform=\"translate(30.756308, 30.621867) rotate(45.000000) translate(-30.756308, -30.621867) translate(15.756308, -12.378133)\" fill=\"#FFFFFF\">\n                <polygon id=\"Path\" points=\"11.5190786 46.9431778 11.7210093 70.7913773 0.565180527 70.7913773 15.4674455 85.8353125 29.3702096 70.7913773 18.5573247 70.7702156 18.5573247 46.9431778\"></polygon>\n                <polygon id=\"Path\" transform=\"translate(14.967695, 19.720198) rotate(180.000000) translate(-14.967695, -19.720198) \" points=\"11.5190786 0.274130278 11.7210093 24.1223298 0.565180527 24.1223298 15.4674455 39.1662649 29.3702096 24.1223298 18.5573247 24.1011681 18.5573247 0.274130278\"></polygon>\n            </g>\n        </g>\n      </svg>\n    </chimee-screen-small>\n  ",
    defaultEvent: {
      click: 'click'
    }
  };
  var Screen = (_class$b = /*#__PURE__*/function (_Base) {
    inherits(Screen, _Base);

    function Screen(parent, option) {
      var _this;

      classCallCheck(this, Screen);

      _this = possibleConstructorReturn(this, getPrototypeOf(Screen).call(this, parent));
      _this.state = 'small';
      _this.option = deepAssign$2(defaultOption$4, isObject$2(option) ? option : {});

      _this.init();

      return _this;
    }

    createClass$1(Screen, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(Screen.prototype), "create", this).call(this);

        this.$dom = $(this.$dom);
        this.changeState(this.state); // addClassName(this.$dom, 'flex-item');

        this.$dom.addClass('chimee-flex-component');
        this.$full = this.$dom.find('chimee-screen-full');
        this.$small = this.$dom.find('chimee-screen-small'); // 判断是否是默认或者用户提供 icon

        if (this.option.icon && this.option.icon.full && this.option.icon.small) {
          // if((!this.option.icon.play && this.option.icon.puase) || (this.option.icon.play && !this.option.icon.puase)) {
          //   console.warn(`Please provide a play and pause icon！If you can't, we will use default icon!`);
          // }
          this.$full.html(this.option.icon.full);
          this.$small.html(this.option.icon.small);
        } else if (this.option.bitmap) {
          this.$full.html('');
          this.$small.html('');
        }
      }
    }, {
      key: "changeState",
      value: function changeState(state) {
        var removeState = state === 'small' ? 'full' : 'small';
        addClassName(this.parent.$dom, state);
        removeClassName(this.parent.$dom, removeState);
      }
    }, {
      key: "click",
      value: function click() {
        var full = false;

        if (this.state === 'small') {
          this.state = 'full';
          full = true;
        } else {
          this.state = 'small';
          full = false;
        }

        this.changeState(this.state);
        this.parent.$fullscreen(full, 'container');

        if (full) {
          this.watch_screen = this.parent.$watch('isFullscreen', this.screenChange);
        } else {
          this.watch_screen();
        }
      }
    }, {
      key: "screenChange",
      value: function screenChange() {
        if (!this.parent.fullscreenElement) return;
        this.state = 'small';
        this.changeState('small');
        this.parent.$fullscreen(false, 'container');
      }
    }]);

    return Screen;
  }(Base), (applyDecoratedDescriptor(_class$b.prototype, "screenChange", [autobind], Object.getOwnPropertyDescriptor(_class$b.prototype, "screenChange"), _class$b.prototype)), _class$b);

  /**
   * clarity 配置
   */

  var defaultOption$5 = {
    tag: 'chimee-clarity',
    width: '2em',
    html: "\n    <chimee-clarity-text></chimee-clarity-text>\n    <chimee-clarity-list>\n      <ul></ul>\n      <div class=\"chimee-clarity-list-arrow\">\n        <svg viewBox=\"0 0 115 6\"  version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n          <g id=\"Group-3-Copy\" fill=\"#57B0F6\">\n            <polygon id=\"Path-2\" points=\"0.0205224145 0.0374249581 0.0205224145 2.12677903 53.9230712 2.12677903 57.1127727 5.3468462 60.2283558 2.12677903 113.820935 2.12677903 113.820935 0.0374249581\"></polygon>\n          </g>\n        </svg>\n      </div>\n    </chimee-clarity-list>\n  ",
    defaultEvent: {
      click: 'click'
    },
    duration: 3,
    bias: 0,
    increment: 0,
    repeatTimes: 0,
    immediate: false,
    abort: false,
    list: []
  };

  var Clarity = /*#__PURE__*/function (_Base) {
    inherits(Clarity, _Base);

    function Clarity(parent, option) {
      var _this;

      classCallCheck(this, Clarity);

      _this = possibleConstructorReturn(this, getPrototypeOf(Clarity).call(this, parent));
      _this.option = deepAssign$2(defaultOption$5, isObject$2(option) ? option : {});

      _this.init();

      return _this;
    }

    createClass$1(Clarity, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(Clarity.prototype), "create", this).call(this);

        addClassName(this.$dom, 'chimee-flex-component');
        this.$text = $(this.$dom).find('chimee-clarity-text');
        this.$list = $(this.$dom).find('chimee-clarity-list');
        this.$listUl = this.$list.find('ul'); // 用户自定义配置

        this.option.width && setStyle(this.$dom, 'width', this.option.width);
        var list = this.option.list;

        if (!list.length) {
          return setStyle(this.$dom, {
            display: 'none'
          });
        }

        this.initTextList(this.option.list);
      }
    }, {
      key: "initTextList",
      value: function initTextList(list) {
        var _this2 = this;

        this.$listUl.html('');
        list.forEach(function (item) {
          var li = $(document.createElement('li'));
          li.attr('data-url', item.src);
          li.text(item.name);

          if (item.src === _this2.parent.$videoConfig.src) {
            _this2.$text.text(item.name);

            li.addClass('active');
          }

          _this2.$listUl.append(li);
        });
      }
    }, {
      key: "click",
      value: function click(e) {
        var _this3 = this;

        var elem = e.target;

        if (elem.tagName === 'LI') {
          var url = elem.getAttribute('data-url') || '';
          this.switchClarity(url).then(function () {
            _this3.loadOption = undefined;
            Array.from(elem.parentElement.children).map(function (item) {
              removeClassName(item, 'active');
            });
            addClassName(e.target, 'active');

            _this3.$text.text(e.target.textContent);
          }).catch(function (e) {
            console.warn(e);
          });
        }
      }
    }, {
      key: "switchClarity",
      value: function switchClarity(url) {
        if (this.loadOption) {
          this.loadOption.abort = true;
        }

        var _this$option = this.option,
            duration = _this$option.duration,
            bias = _this$option.bias,
            increment = _this$option.increment,
            repeatTimes = _this$option.repeatTimes,
            immediate = _this$option.immediate,
            abort = _this$option.abort;
        this.loadOption = {
          duration: duration,
          bias: bias,
          increment: increment,
          repeatTimes: repeatTimes,
          immediate: immediate,
          abort: abort
        };
        return this.parent.$silentLoad(url, this.loadOption);
      }
    }]);

    return Clarity;
  }(Base);

  /**
   * playbackrate 配置
   */

  var defaultOption$6 = {
    tag: 'chimee-playbackrate',
    width: '4em',
    html: "\n    <chimee-playbackrate-text></chimee-playbackrate-text>\n    <chimee-playbackrate-list>\n      <ul></ul>\n      <div class=\"chimee-playbackrate-list-arrow\">\n        <svg viewBox=\"0 0 115 6\"  version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n          <g id=\"Group-3-Copy\" fill=\"#57B0F6\">\n            <polygon id=\"Path-2\" points=\"0.0205224145 0.0374249581 0.0205224145 2.12677903 53.9230712 2.12677903 57.1127727 5.3468462 60.2283558 2.12677903 113.820935 2.12677903 113.820935 0.0374249581\"></polygon>\n          </g>\n        </svg>\n      </div>\n    </chimee-playbackrate-list>\n  ",
    defaultEvent: {
      click: 'click'
    }
  };

  var Playbackrate = /*#__PURE__*/function (_Base) {
    inherits(Playbackrate, _Base);

    function Playbackrate(parent, option) {
      var _this;

      classCallCheck(this, Playbackrate);

      _this = possibleConstructorReturn(this, getPrototypeOf(Playbackrate).call(this, parent));
      _this.option = deepAssign$2(defaultOption$6, isObject$2(option) ? option : {});

      _this.init();

      return _this;
    }

    createClass$1(Playbackrate, [{
      key: "init",
      value: function init() {
        get$1(getPrototypeOf(Playbackrate.prototype), "create", this).call(this);

        addClassName(this.$dom, 'chimee-flex-component');
        this.$text = $(this.$dom).find('chimee-playbackrate-text');
        this.$list = $(this.$dom).find('chimee-playbackrate-list');
        this.$listUl = this.$list.find('ul'); // 用户自定义配置

        this.option.width && setStyle(this.$dom, 'width', this.option.width);
        this.initTextList();
      }
    }, {
      key: "initTextList",
      value: function initTextList() {
        var _this2 = this;

        var length = this.option.list.length;
        var hasRenderDefault = false;
        this.option.list.forEach(function (item, i) {
          var li = $(document.createElement('li'));
          li.attr('data-value', item.value);
          li.text(item.name);

          if (item.default || !hasRenderDefault && i === length - 1) {
            hasRenderDefault = true;
            !item.default && console.warn('播放速率列表需要给每项配置 `default(boolean)` 来标明是否是默认播放速率');

            _this2.$text.text(item.name);

            li.addClass('active');

            _this2.switchPlaybackrate(item.value);
          }

          _this2.$listUl.append(li);
        });
      }
    }, {
      key: "click",
      value: function click(e) {
        var elem = e.target;

        if (elem.tagName === 'LI') {
          var rate = elem.getAttribute('data-value') || 1;
          this.switchPlaybackrate(rate);
          Array.from(elem.parentElement.children).map(function (item) {
            removeClassName(item, 'active');
          });
          addClassName(e.target, 'active');
          this.$text.text(e.target.textContent);
        }
      }
    }, {
      key: "switchPlaybackrate",
      value: function switchPlaybackrate(rate) {
        var _this3 = this;

        setTimeout(function (_) {
          _this3.parent.playbackRate = rate;
        }, 0);
      }
    }]);

    return Playbackrate;
  }(Base);

  function hundleChildren(plugin) {
    var childConfig = {};

    if (!plugin.$config.children) {
      childConfig = plugin.isLive ? {
        play: true,
        // 底部播放暂停按钮
        progressTime: false,
        // 播放时间
        progressBar: false,
        // 播放进度控制条
        volume: true,
        // 声音控制
        screen: true // 全屏控制

      } : {
        play: true,
        // 底部播放暂停按钮
        progressTime: true,
        // 播放时间
        progressBar: true,
        // 播放进度控制条
        volume: true,
        // 声音控制
        screen: true // 全屏控制

      };
    } else {
      childConfig = plugin.$config.children;
    }

    return childConfig;
  }
  /**
   * 1. 将所有的 ui component 输出到 html 结构中
   * 2. 为这些 component 绑定响应的事件
   * @param {*} dom 所有 ui 节点的子容器
   * @param {*} config 关于 ui 的一些列设置
   * @return {Array} 所有子节点
   */


  function createChild(plugin) {
    var childConfig = plugin.config.children = hundleChildren(plugin);
    var children = {};

    if (!childConfig) {
      children.play = new Play(plugin);
      children.progressTime = new ProgressTime(plugin);
      children.progressBar = new ProgressBar(plugin);
      children.volume = new Volume(plugin);
      children.screen = new Screen(plugin);
    } else {
      Object.keys(childConfig).forEach(function (item) {
        switch (item) {
          case 'play':
            if (childConfig.play) {
              children.play = new Play(plugin, childConfig.play);
            }

            break;

          case 'progressTime':
            if (childConfig.progressTime) {
              children.progressTime = new ProgressTime(plugin, childConfig.progressTime);
            }

            break;

          case 'progressBar':
            children.progressBar = new ProgressBar(plugin, childConfig.progressBar);
            break;

          case 'volume':
            if (childConfig.volume) {
              children.volume = new Volume(plugin, childConfig.volume);
            }

            break;

          case 'screen':
            if (childConfig.screen) {
              children.screen = new Screen(plugin, childConfig.screen);
            }

            break;

          case 'clarity':
            if (childConfig.clarity) {
              children.clarity = new Clarity(plugin, childConfig.clarity);
            }

            break;

          case 'playbackrate':
            if (childConfig.playbackrate && Array.isArray(childConfig.playbackrate.list) && childConfig.playbackrate.list.length) {
              children.playbackrate = new Playbackrate(plugin, childConfig.playbackrate);
            }

            break;

          default:
            children[item] = new Component(plugin, childConfig[item]);
            break;
        }
      });
    }

    return children;
  }

  var majorColorStyle = "\n  .chimee-flex-component svg * {\n    fill: majorColor;\n    stroke: majorColor;\n  }\n\n  chimee-progressbar-all {\n    background: majorColor;\n  }\n\n  chimee-volume.chimee-flex-component chimee-volume-bar-all {\n    background: majorColor;\n  }\n\n  chimee-playbackrate-list li:hover,\n  chimee-playbackrate-list li.active,\n  chimee-clarity-list li:hover,\n  chimee-clarity-list li.active {\n    color: majorColor;\n  }\n";
  var hoverColorStyle = "\n  .chimee-flex-component svg:hover *{\n    fill: hoverColor;\n    stroke: hoverColor;\n  }\n";
  /**
   * 插件默认配置
   */

  var defaultConfig = {
    hideBarTime: 2000,
    // hidebar 延迟时间， barShowByMouse 为 move 时有效，enter 时为0， 用户设置无效
    barShowByMouse: 'move' // 控制条显示由， move 还是 enter/leave 来控制显示／隐藏,

  };
  var chimeeControl = {
    name: 'chimeeControl',
    el: 'chimee-control',
    data: {
      children: {},
      show: false,
      disabled: true
    },
    level: 99,
    operable: false,
    penetrate: false,
    create: function create() {},
    init: function init(videoConfig) {},
    destroy: function destroy() {
      window.clearTimeout(this.timeId);

      for (var i in this.children) {
        this.children[i].destroy();
      }
    },
    inited: function inited() {
      var videoConfig = this.$videoConfig;

      if (videoConfig.controls) {
        this.show = true;
        videoConfig.controls = false;
      }

      var _this = this;

      applyDecorators(videoConfig, {
        controls: accessor({
          get: function get() {
            return _this.show;
          },
          set: function set(value) {
            _this.show = Boolean(value);

            _this._display();

            return false;
          }
        }, {
          preSet: true
        })
      }, {
        self: true
      });
      this.config = isObject$2(this.$config) ? deepAssign$2(defaultConfig, this.$config) : defaultConfig;
      this.config.hideBarTime = this.config.barShowByMouse === 'move' ? this.config.hideBarTime : 0;
      this.$dom.innerHTML = '<chimee-control-wrap></chimee-control-wrap>';
      this.$wrap = this.$dom.querySelector('chimee-control-wrap');
      this.children = createChild(this);

      this._setStyle();

      for (var i in this.children) {
        this.children[i].inited && this.children[i].inited();
      }
    },
    events: {
      load: function load() {
        // update src 充值进度条/时间/播放状态
        // load 的时候不会触发 pause(), 手动将控制条显示出来
        this._showItself();

        this._progressUpdate();

        this.children.play && this.children.play.changeState('pause');
        this.children.progressTime && this.children.progressTime.updateTotal();
        this.children.progressBar && this.children.progressBar.changePointerEvent('none');
      },
      loadstart: function loadstart() {
        this._disable(true);
      },
      canplay: function canplay() {
        this._disable(false);
      },
      play: function play() {
        this.children.play && this.children.play.changeState('play');
        this.config.barShowByMouse === 'move' && this._hideItself();
      },
      pause: function pause() {
        this.children.play && this.children.play.changeState('pause');

        this._showItself();
      },
      c_mouseenter: function c_mouseenter() {
        if (this.config.barShowByMouse === 'move') return;

        this._showItself();
      },
      c_mousemove: function c_mousemove() {
        this._mousemove();
      },
      c_mouseleave: function c_mouseleave() {
        if (this.config.barShowByMouse === 'move') return;

        this._hideItself();
      },
      durationchange: function durationchange() {
        this.children.progressTime && this.children.progressTime.updateTotal();
        this.children.progressBar && this.children.progressBar.changePointerEvent('auto');
      },
      timeupdate: function timeupdate() {
        this._progressUpdate();
      },
      progress: function progress() {
        this.children.progressBar && this.children.progressBar.progress();
      },
      volumechange: function volumechange() {
        this.children.volume && this.children.volume.update();
      },
      keydown: function keydown(e) {
        // if(this.disabled) return;
        e.stopPropagation();

        switch (e.keyCode) {
          case 32:
            {
              e.preventDefault();
              this.children.play && this.children.play.click(e);
              break;
            }

          case 37:
            {
              e.preventDefault();
              var reduceTime = this.currentTime - 10;
              this.currentTime = reduceTime < 0 ? 0 : reduceTime;

              this._mousemove();

              break;
            }

          case 39:
            {
              e.preventDefault();
              var raiseTime = this.currentTime + 10;
              this.currentTime = raiseTime > this.duration ? this.duration : raiseTime;

              this._mousemove();

              break;
            }

          case 38:
            {
              e.preventDefault();
              var raiseVolume = this.volume + 0.1;
              this.volume = raiseVolume > 1 ? 1 : raiseVolume;

              this._mousemove();

              break;
            }

          case 40:
            {
              e.preventDefault();
              var reduceVolume = this.volume - 0.1;
              this.volume = reduceVolume < 0 ? 0 : reduceVolume;

              this._mousemove();

              break;
            }
        }
      },
      click: function click(e) {
        var _this2 = this;

        var time = new Date();
        var preTime = this.clickTime;
        this.clickTime = time;

        if (time - preTime < 300) {
          clearTimeout(this.clickTimeId);
          return;
        }

        this.clickTimeId = setTimeout(function () {
          !_this2.disabled && _this2.children.play && _this2.children.play.click(e);
        }, 300);
      },
      dblclick: function dblclick(e) {
        // this.dblclick = true;
        !this.disabled && this.children.screen && this.children.screen.click();
      }
    },
    methods: {
      _progressUpdate: function _progressUpdate() {
        this.children.progressBar && this.children.progressBar.update();
        this.children.progressTime && this.children.progressTime.updatePass();
      },
      _hideItself: function _hideItself() {
        var _this3 = this;

        window.clearTimeout(this.timeId);
        this.timeId = setTimeout(function () {
          var bottom = _this3.$wrap.offsetHeight;
          bottom = _this3.children.progressBar ? _this3.children.progressBar.$wrap[0].offsetTop - bottom : -bottom;
          setStyle(_this3.$wrap, {
            bottom: bottom + 'px'
          });
          setStyle(_this3.$dom, {
            visibility: 'hidden'
          });
        }, this.config.hideBarTime);
      },
      _showItself: function _showItself() {
        window.clearTimeout(this.timeId);
        setStyle(this.$wrap, {
          bottom: '0'
        });
        setStyle(this.$dom, {
          visibility: 'visible'
        });
      },
      _display: function _display() {
        var display = this.show ? 'block' : 'none';
        setStyle(this.$dom, {
          display: display
        });
      },
      _mousemove: function _mousemove(e) {
        if (this.paused || this.config.barShowByMouse === 'enter') return;

        this._showItself();

        this._hideItself();
      },
      // controlbar 不可以点
      // 键盘／鼠标事件不监听
      _disable: function _disable(disabled) {
        if (!this.show) return;
        this.disabled = disabled; // setStyle(this.$wrap, 'pointerEvents', disabled ? 'none' : 'auto');
      },
      _setStyle: function _setStyle() {
        var css = '';
        css += this.config.majorColor ? majorColorStyle.replace(/majorColor/g, this.config.majorColor) : '';
        css += this.config.hoverColor ? hoverColorStyle.replace(/hoverColor/g, this.config.hoverColor) : '';
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.innerHTML = css;
        document.head.appendChild(style);
      },
      updateClarity: function updateClarity(list) {
        if (!isArray_1(list)) {
          return console.error('list must be an array.');
        }

        this.children.clarity.initTextList(list);
      }
    }
  };

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  var arrayWithHoles = _arrayWithHoles;

  function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
      return;
    }

    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  var iterableToArrayLimit = _iterableToArrayLimit;

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var nonIterableRest = _nonIterableRest;

  function _slicedToArray$1(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
  }

  var slicedToArray$1 = _slicedToArray$1;

  /**
   * 这里提供一个工厂方法，用于生产一个popup插件配置，或基于popup特性实现自己的插件
   * @param {Object} optons 针对popup扩展了定制化参数，另外也用来重写部分PluginConfig配置
   * @param {String} optons.name 插件名
   * @param {String} optons.tagName Popup DOM容器的tagName
   * @param {String} optons.className Popup DOM容器的className
   * @param {String} optons.title Popup 标题，当设置值为 false 则不渲染title对应DOM
   * @param {String} optons.body Popup 内容，当设置值为 false 则不渲染body对应DOM
   * @param {String} optons.html html 用于构架popup的模板，重写后上面的title、body无效
   * @param {String} optons.offset 设定相对播放器要展示的坐标位置，空格分割的坐标值：'X:left Y:top'||'top right bottom left', 具体的像素百分比值或者auto；实例化后可重写 popupplugin.offset('0 0 0 0')
   * @param {String} optons.offsetAttr offset对应的CSS属性key，默认'left top'、'top right bottom left'-当offset空格分割的参数值多余2个时，便于只设定个别或特定方向边距
   * @param {String} optons.translate 在offset基础上的偏移量，格式如："leftVal topVal"，当offset为50%这里没设定值，则默认偏移-50%；实例化后可重写 popupplugin.translate('0 0')
   * @param {String} optons.width 宽度值（需要带单位）；实例化后可重写 popupplugin.width('100px')
   * @param {String} optons.height 高度值（需要带单位）；实例化后可重写 popupplugin.height('100px')
   * @param {Boolean} optons.hide 初始状态是否设置为关闭，默认值 false
   * @param {Function} optons.opened 开启时执行
   * @param {Function} optons.closed 关闭时执行
   * @param {Boolean} optons.penetrate 是否将交互事件同步到video元素(点击当前popup同样实现video的暂停播放)，默认值 false
   * @param {Boolean} optons.operable 是否启用事件交互（false则设置CSS事件穿透），默认值 true
   * @return {PluginConfig}
   */

  function popupFactory() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === void 0 ? 'chimee-popup' : _ref$tagName,
        className = _ref.className,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'popup' : _ref$name,
        html = _ref.html,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '这是一个信息框' : _ref$title,
        _ref$body = _ref.body,
        body = _ref$body === void 0 ? '这里是信息内容' : _ref$body,
        _ref$offsetAttr = _ref.offsetAttr,
        offsetAttr = _ref$offsetAttr === void 0 ? 'left top' : _ref$offsetAttr,
        _ref$offset = _ref.offset,
        offset = _ref$offset === void 0 ? '50% 50%' : _ref$offset,
        _ref$translate = _ref.translate,
        translate = _ref$translate === void 0 ? '' : _ref$translate,
        width = _ref.width,
        height = _ref.height,
        level = _ref.level,
        init = _ref.init,
        inited = _ref.inited,
        data = _ref.data,
        _create = _ref.create,
        _beforeCreate = _ref.beforeCreate,
        _destroy = _ref.destroy,
        events = _ref.events,
        computed = _ref.computed,
        _ref$methods = _ref.methods,
        methods = _ref$methods === void 0 ? {} : _ref$methods,
        _ref$penetrate = _ref.penetrate,
        penetrate = _ref$penetrate === void 0 ? false : _ref$penetrate,
        _ref$operable = _ref.operable,
        operable = _ref$operable === void 0 ? true : _ref$operable,
        _ref$hide = _ref.hide,
        hide = _ref$hide === void 0 ? false : _ref$hide,
        opened = _ref.opened,
        closed = _ref.closed,
        autoFocus = _ref.autoFocus;

    var defaultConfig = {
      html: html || "\n      <cm-pp-close>\xD7</cm-pp-close>\n      ".concat(title !== false ? "<cm-pp-head>".concat(title, "</cm-pp-head>") : '', "\n      ").concat(body !== false ? "<cm-pp-body>".concat(body, "</cm-pp-body>") : '', "\n    "),
      closeSelector: '._close'
    };
    return {
      name: name,
      el: tagName,
      className: className,
      beforeCreate: function beforeCreate() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            events = _ref2.events,
            methods = _ref2.methods;

        var option = arguments.length > 1 ? arguments[1] : undefined;

        if (isObject(option)) {
          isObject(option.events) && deepAssign(events, option.events);
          isObject(option.methods) && deepAssign(methods, option.methods);
        }

        _beforeCreate && _beforeCreate.apply(this, arguments);
      },
      create: function create() {
        var config = isObject(this.$config) ? deepAssign(defaultConfig, this.$config) : defaultConfig;
        var $dom = this.$domWrap = $(this.$dom).css('display', 'none');
        $dom.html(config.html).delegate('cm-pp-close, ' + config.closeSelector, 'click', this.close);
        this.width(width).height(height).offset(offset).translate(translate);
        this._hide = hide;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _create && _create.apply(this, args);
        !this._hide && this.open();
      },
      destroy: function destroy() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _destroy && _destroy.apply(this, args);
        this.$domWrap.undelegate(this.$config.closeSelector, 'click', this.close).remove();
      },
      level: level,
      init: init,
      inited: inited,
      data: data,
      events: events,
      computed: computed,
      penetrate: penetrate,
      operable: operable,
      autoFocus: autoFocus,
      methods: deepAssign({
        open: function open() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'block');
          this._hide = false;

          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          this.$emit('popupOpen', args, this);
          isFunction(opened) && opened.apply(this, args);
          return this;
        },
        close: function close() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'none');
          this._hide = true;

          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          this.$emit('popupClose', args, this);
          isFunction(closed) && closed.apply(this, args);
          return this;
        },
        width: function width(_width) {
          _width && this.$domWrap.css('width', _width);
          return this;
        },
        height: function height(_height) {
          _height && this.$domWrap.css('height', _height);
          return this;
        },
        offset: function offset(vals) {
          var trblArr = "".concat(vals || '').split(' ');
          var cssObj = {};

          if (trblArr.length > 2) {
            ['top', 'right', 'bottom', 'left'].forEach(function (dir, i) {
              if (trblArr[i]) {
                cssObj[dir] = trblArr[i];
              }
            });
            this.$domWrap.css(cssObj);
            return this;
          }

          var _trblArr = slicedToArray$1(trblArr, 2),
              left = _trblArr[0],
              _top = _trblArr[1];

          if (left === '') {
            return this;
          }

          var top = _top || left;
          var xyAttr = offsetAttr.split(' ');
          cssObj[xyAttr[0]] = left;
          cssObj[xyAttr[1]] = top;
          this.$domWrap.css(cssObj);
          var translateXY = [];

          if (left === '50%') {
            translateXY.push('-50%');
          }

          if (top === '50%') {
            translateXY.push('-50%');
          }

          translateXY.length > 0 && this.translate(translateXY.join(' '));
          return this;
        },
        translate: function translate(xy) {
          var _$split = "".concat(xy || '').split(' '),
              _$split2 = slicedToArray$1(_$split, 2),
              x = _$split2[0],
              y = _$split2[1];

          if (x !== '') {
            this.$domWrap.css('transform', "translate(".concat(x, ", ").concat(y || x, ")"));
            this.$domWrap.css('-ms-transform', "translate(".concat(x, ", ").concat(y || x, ")"));

            if (!('transform' in document.createElement('a').style) && window.console && window.console.warn) {
              console.warn('[chimee-plugin-popup] 当前环境不支持CSS3的transform特性，Dom元素无法正常使用translate。');
            }
          }

          return this;
        }
      }, methods)
    };
  }

  /**
   * chimee-plugin-popup v0.0.5
   * (c) 2017 huzunjie
   * Released under MIT
   */
  function __$styleInject(css, returnValue) {
    if (typeof document === 'undefined') {
      return returnValue;
    }

    css = css || '';
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    return returnValue;
  }

  __$styleInject("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}", undefined);
  /**
   * 这里提供一个工厂方法，用于生产一个popup插件配置，或基于popup特性实现自己的插件
   * @param {Object} optons 针对popup扩展了定制化参数，另外也用来重写部分PluginConfig配置
   * @param {String} optons.name 插件名
   * @param {String} optons.tagName Popup DOM容器的tagName
   * @param {String} optons.className Popup DOM容器的className
   * @param {String} optons.title Popup 标题，当设置值为 false 则不渲染title对应DOM
   * @param {String} optons.body Popup 内容，当设置值为 false 则不渲染body对应DOM
   * @param {String} optons.html html 用于构架popup的模板，重写后上面的title、body无效
   * @param {String} optons.offset 设定相对播放器要展示的坐标位置，空格分割的坐标值：'X:left Y:top'||'top right bottom left', 具体的像素百分比值或者auto；实例化后可重写 popupplugin.offset('0 0 0 0')
   * @param {String} optons.offsetAttr offset对应的CSS属性key，默认'left top'、'top right bottom left'-当offset空格分割的参数值多余2个时，便于只设定个别或特定方向边距
   * @param {String} optons.translate 在offset基础上的偏移量，格式如："leftVal topVal"，当offset为50%这里没设定值，则默认偏移-50%；实例化后可重写 popupplugin.translate('0 0')
   * @param {String} optons.width 宽度值（需要带单位）；实例化后可重写 popupplugin.width('100px')
   * @param {String} optons.height 高度值（需要带单位）；实例化后可重写 popupplugin.height('100px')
   * @param {Boolean} optons.hide 初始状态是否设置为关闭，默认值 false
   * @param {Function} optons.opened 开启时执行
   * @param {Function} optons.closed 关闭时执行
   * @param {Boolean} optons.penetrate 是否将交互事件同步到video元素(点击当前popup同样实现video的暂停播放)，默认值 false
   * @param {Boolean} optons.operable 是否启用事件交互（false则设置CSS事件穿透），默认值 true
   * @return {PluginConfig}
   */


  function popupFactory$1() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === undefined ? 'chimee-popup' : _ref$tagName,
        className = _ref.className,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? 'popup' : _ref$name,
        html = _ref.html,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? '这是一个信息框' : _ref$title,
        _ref$body = _ref.body,
        body = _ref$body === undefined ? '这里是信息内容' : _ref$body,
        _ref$offsetAttr = _ref.offsetAttr,
        offsetAttr = _ref$offsetAttr === undefined ? 'left top' : _ref$offsetAttr,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? '50% 50%' : _ref$offset,
        _ref$translate = _ref.translate,
        translate = _ref$translate === undefined ? '' : _ref$translate,
        width = _ref.width,
        height = _ref.height,
        level = _ref.level,
        init = _ref.init,
        inited = _ref.inited,
        data = _ref.data,
        _create = _ref.create,
        _beforeCreate = _ref.beforeCreate,
        _destroy = _ref.destroy,
        events = _ref.events,
        computed = _ref.computed,
        _ref$methods = _ref.methods,
        methods = _ref$methods === undefined ? {} : _ref$methods,
        _ref$penetrate = _ref.penetrate,
        penetrate = _ref$penetrate === undefined ? false : _ref$penetrate,
        _ref$operable = _ref.operable,
        operable = _ref$operable === undefined ? true : _ref$operable,
        _ref$hide = _ref.hide,
        hide = _ref$hide === undefined ? false : _ref$hide,
        opened = _ref.opened,
        closed = _ref.closed,
        autoFocus = _ref.autoFocus;

    var defaultConfig = {
      html: html || '\n      <cm-pp-close>\xD7</cm-pp-close>\n      ' + (title !== false ? '<cm-pp-head>' + title + '</cm-pp-head>' : '') + '\n      ' + (body !== false ? '<cm-pp-body>' + body + '</cm-pp-body>' : '') + '\n    ',
      closeSelector: '._close'
    };
    return {
      name: name,
      el: tagName,
      className: className,
      beforeCreate: function beforeCreate() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            events = _ref2.events,
            methods = _ref2.methods;

        var option = arguments[1];

        if (isObject(option)) {
          isObject(option.events) && deepAssign(events, option.events);
          isObject(option.methods) && deepAssign(methods, option.methods);
        }

        _beforeCreate && _beforeCreate.apply(this, arguments);
      },
      create: function create() {
        var config = isObject(this.$config) ? deepAssign(defaultConfig, this.$config) : defaultConfig;
        var $dom = this.$domWrap = $(this.$dom).css('display', 'none');
        $dom.html(config.html).delegate('cm-pp-close, ' + config.closeSelector, 'click', this.close);
        this.width(width).height(height).offset(offset).translate(translate);
        this._hide = hide;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _create && _create.apply(this, args);
        !this._hide && this.open();
      },
      destroy: function destroy() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _destroy && _destroy.apply(this, args);
        this.$domWrap.undelegate(this.$config.closeSelector, 'click', this.close).remove();
      },
      level: level,
      init: init,
      inited: inited,
      data: data,
      events: events,
      computed: computed,
      penetrate: penetrate,
      operable: operable,
      autoFocus: autoFocus,
      methods: deepAssign({
        open: function open() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'block');
          this._hide = false;

          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          this.$emit('popupOpen', args, this);
          isFunction(opened) && opened.apply(this, args);
          return this;
        },
        close: function close() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'none');
          this._hide = true;

          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          this.$emit('popupClose', args, this);
          isFunction(closed) && closed.apply(this, args);
          return this;
        },
        width: function width(_width) {
          _width && this.$domWrap.css('width', _width);
          return this;
        },
        height: function height(_height) {
          _height && this.$domWrap.css('height', _height);
          return this;
        },
        offset: function offset(vals) {
          var trblArr = ('' + (vals || '')).split(' ');
          var cssObj = {};

          if (trblArr.length > 2) {
            ['top', 'right', 'bottom', 'left'].forEach(function (dir, i) {
              if (trblArr[i] && trblArr[i] !== 'auto') {
                cssObj[dir] = trblArr[i];
              }
            });
            this.$domWrap.css(cssObj);
            return this;
          }

          var _trblArr = _slicedToArray(trblArr, 2),
              left = _trblArr[0],
              _top = _trblArr[1];

          if (left === '') {
            return this;
          }

          var top = _top || left;
          var xyAttr = offsetAttr.split(' ');
          cssObj[xyAttr[0]] = left;
          cssObj[xyAttr[1]] = top;
          this.$domWrap.css(cssObj);
          var translateXY = [];

          if (left === '50%') {
            translateXY.push('-50%');
          }

          if (top === '50%') {
            translateXY.push('-50%');
          }

          translateXY.length > 0 && this.translate(translateXY.join(' '));
          return this;
        },
        translate: function translate(xy) {
          var _$split = ('' + (xy || '')).split(' '),
              _$split2 = _slicedToArray(_$split, 2),
              x = _$split2[0],
              y = _$split2[1];

          x && this.$domWrap.css('transform', 'translate(' + x + ', ' + (y || x) + ')');
          return this;
        }
      }, methods)
    };
  }

  var logPopupOpenEvt = 'openLogPopup';
  /* 右键菜单插件
   * 接收参数：baseMenus, menus
   * 也可通过方法 updatemenu 更新自定义菜单项
   */

  var contextmenuConf = popupFactory$1({
    tagName: 'chimee-menu',
    name: 'chimeeContextmenu',
    html: '<ul></ul>',
    offset: '0',
    hide: true,
    data: {
      // 默认菜单项
      baseMenus: [{
        text: '查看日志',
        action: logPopupOpenEvt,
        hide: true
      }, {
        text: 'Chimee {VERSION} &copy; 360',
        url: 'http://chimee.org',
        disable: true
      }
      /* ,
      {
       text: '关闭',
       className: '_close'
      }*/
      ]
    },
    create: function create() {
      var _this = this;

      var _this$$config = this.$config,
          baseMenus = _this$$config.baseMenus,
          menus = _this$$config.menus;

      if (isArray(baseMenus)) {
        this.baseMenus = baseMenus;
      }

      this.updatemenu(menus);
      this.$domWrap.on('click', this.clickHandler); // 如果已装载日志插件，则显示相应菜单项

      if (this.$plugins.chimeeLog) {
        this.switchLogMenu(false);
      } // 点击播放器之外的文档区域关闭右键菜单


      this._doc = new this.$domWrap.constructor(document);

      this._doc_click = function (e) {
        return _this.close();
      };

      this._doc.on('click', this._doc_click);
    },
    destroy: function destroy() {
      this._doc.off('click', this._doc_click);
    },
    opened: function opened() {
      // 盖住所有插件
      this.$bumpToTop();
    },
    events: {
      contextmenu: function contextmenu(e) {
        var left = e.offsetX;
        var top = e.offsetY;
        var containerEl = this.$dom.parentElement;

        if (isFunction(containerEl.getBoundingClientRect)) {
          var rect = containerEl.getBoundingClientRect();
          left = e.pageX - rect.left - (document.documentElement.scrollLeft || document.body.scrollLeft || 0);
          top = e.pageY - rect.top - (document.documentElement.scrollTop || document.body.scrollTop || 0);
        }

        this.offset(left + 'px ' + top + 'px').open(e);
        e.preventDefault();
      },
      // 当日志插件卸载时隐藏“查看日志”菜单项
      logPluginDestroy: function logPluginDestroy() {
        this.switchLogMenu(true);
      },
      // 当日志插件状态完毕显示“查看日志”菜单项
      logPluginCreate: function logPluginCreate() {
        this.switchLogMenu(false);
      }
    },
    methods: {
      switchLogMenu: function switchLogMenu(hide) {
        var logMenuConf = this.baseMenus.find(function (item) {
          return item.action === logPopupOpenEvt;
        });

        if (logMenuConf) {
          logMenuConf.hide = hide;
          this.$domWrap.find('[data-action="' + logPopupOpenEvt + '"]').css('display', hide ? 'none' : '');
        }
      },
      updatemenu: function updatemenu(menusConfig) {
        var _this2 = this;

        var menus = [];

        if (isArray(menusConfig)) {
          menus = menus.concat(menusConfig);
        } // 菜单模板编译


        var meunsHTML = menus.concat(this.baseMenus).map(function (_ref) {
          var hide = _ref.hide,
              disable = _ref.disable,
              action = _ref.action,
              className = _ref.className,
              text = _ref.text,
              url = _ref.url;
          var attrDis = disable ? 'disable' : '';
          var dataAct = action ? 'data-action="' + action + '"' : '';
          var clsAttr = className ? 'class="' + className + '"' : '';
          var hideSty = hide ? 'style="display:none"' : ''; // 文本替换，使之支持 {VERSION} 的变量写法

          var innText = text.replace(/\{([^)]*)\}/g, function (_, matchStr) {
            return _this2[matchStr];
          });

          if (url) {
            innText = "<a href=\"".concat(url, "\" target=\"_blank\">").concat(innText, "</a>");
          }

          return "<li ".concat(attrDis, " ").concat(dataAct, " ").concat(clsAttr, " ").concat(hideSty, ">").concat(innText, "</li>");
        }).join(''); // 输出菜单DOM

        this.$domWrap.find('ul').html(meunsHTML);
      },
      clickHandler: function clickHandler(e) {
        var el = e.target;

        if (!el.disable) {
          var act = el.dataset.action;

          if (act) {
            // 抛出右键项点击对应事件给全局
            this.$emit(act);
            isFunction(this[act]) && this[act](e);
          }

          this.close();
        }

        e.stopPropagation();
      }
    }
  });

  /**
   * chimee-plugin-popup v0.0.5
   * (c) 2017 huzunjie
   * Released under MIT
   */

  function __$styleInject$1(css, returnValue) {
    if (typeof document === 'undefined') {
      return returnValue;
    }
    css = css || '';
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);
    
    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    return returnValue;
  }

  __$styleInject$1("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}", undefined);

  /**
   * 这里提供一个工厂方法，用于生产一个popup插件配置，或基于popup特性实现自己的插件
   * @param {Object} optons 针对popup扩展了定制化参数，另外也用来重写部分PluginConfig配置
   * @param {String} optons.name 插件名
   * @param {String} optons.tagName Popup DOM容器的tagName
   * @param {String} optons.className Popup DOM容器的className
   * @param {String} optons.title Popup 标题，当设置值为 false 则不渲染title对应DOM
   * @param {String} optons.body Popup 内容，当设置值为 false 则不渲染body对应DOM
   * @param {String} optons.html html 用于构架popup的模板，重写后上面的title、body无效
   * @param {String} optons.offset 设定相对播放器要展示的坐标位置，空格分割的坐标值：'X:left Y:top'||'top right bottom left', 具体的像素百分比值或者auto；实例化后可重写 popupplugin.offset('0 0 0 0')
   * @param {String} optons.offsetAttr offset对应的CSS属性key，默认'left top'、'top right bottom left'-当offset空格分割的参数值多余2个时，便于只设定个别或特定方向边距
   * @param {String} optons.translate 在offset基础上的偏移量，格式如："leftVal topVal"，当offset为50%这里没设定值，则默认偏移-50%；实例化后可重写 popupplugin.translate('0 0')
   * @param {String} optons.width 宽度值（需要带单位）；实例化后可重写 popupplugin.width('100px')
   * @param {String} optons.height 高度值（需要带单位）；实例化后可重写 popupplugin.height('100px')
   * @param {Boolean} optons.hide 初始状态是否设置为关闭，默认值 false
   * @param {Function} optons.opened 开启时执行
   * @param {Function} optons.closed 关闭时执行
   * @param {Boolean} optons.penetrate 是否将交互事件同步到video元素(点击当前popup同样实现video的暂停播放)，默认值 false
   * @param {Boolean} optons.operable 是否启用事件交互（false则设置CSS事件穿透），默认值 true
   * @return {PluginConfig}
   */
  function popupFactory$2() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === undefined ? 'chimee-popup' : _ref$tagName,
        className = _ref.className,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? 'popup' : _ref$name,
        html = _ref.html,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? '这是一个信息框' : _ref$title,
        _ref$body = _ref.body,
        body = _ref$body === undefined ? '这里是信息内容' : _ref$body,
        _ref$offsetAttr = _ref.offsetAttr,
        offsetAttr = _ref$offsetAttr === undefined ? 'left top' : _ref$offsetAttr,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? '50% 50%' : _ref$offset,
        _ref$translate = _ref.translate,
        translate = _ref$translate === undefined ? '' : _ref$translate,
        width = _ref.width,
        height = _ref.height,
        level = _ref.level,
        init = _ref.init,
        inited = _ref.inited,
        data = _ref.data,
        _create = _ref.create,
        _beforeCreate = _ref.beforeCreate,
        _destroy = _ref.destroy,
        events = _ref.events,
        computed = _ref.computed,
        _ref$methods = _ref.methods,
        methods = _ref$methods === undefined ? {} : _ref$methods,
        _ref$penetrate = _ref.penetrate,
        penetrate = _ref$penetrate === undefined ? false : _ref$penetrate,
        _ref$operable = _ref.operable,
        operable = _ref$operable === undefined ? true : _ref$operable,
        _ref$hide = _ref.hide,
        hide = _ref$hide === undefined ? false : _ref$hide,
        opened = _ref.opened,
        closed = _ref.closed,
        autoFocus = _ref.autoFocus;

    var defaultConfig = {
      html: html || '\n      <cm-pp-close>\xD7</cm-pp-close>\n      ' + (title !== false ? '<cm-pp-head>' + title + '</cm-pp-head>' : '') + '\n      ' + (body !== false ? '<cm-pp-body>' + body + '</cm-pp-body>' : '') + '\n    ',
      closeSelector: '._close'
    };

    return {
      name: name,
      el: tagName,
      className: className,
      beforeCreate: function beforeCreate() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            events = _ref2.events,
            methods = _ref2.methods;

        var option = arguments[1];

        if (isObject(option)) {
          isObject(option.events) && deepAssign(events, option.events);
          isObject(option.methods) && deepAssign(methods, option.methods);
        }
        _beforeCreate && _beforeCreate.apply(this, arguments);
      },
      create: function create() {

        var config = isObject(this.$config) ? deepAssign(defaultConfig, this.$config) : defaultConfig;
        var $dom = this.$domWrap = $(this.$dom).css('display', 'none');

        $dom.html(config.html).delegate('cm-pp-close, ' + config.closeSelector, 'click', this.close);

        this.width(width).height(height).offset(offset).translate(translate);

        this._hide = hide;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _create && _create.apply(this, args);
        !this._hide && this.open();
      },
      destroy: function destroy() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _destroy && _destroy.apply(this, args);
        this.$domWrap.undelegate(this.$config.closeSelector, 'click', this.close).remove();
      },

      level: level,
      init: init,
      inited: inited,
      data: data,
      events: events,
      computed: computed,
      penetrate: penetrate,
      operable: operable,
      autoFocus: autoFocus,
      methods: deepAssign({
        open: function open() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'block');
          this._hide = false;

          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          this.$emit('popupOpen', args, this);
          isFunction(opened) && opened.apply(this, args);
          return this;
        },
        close: function close() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'none');
          this._hide = true;

          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          this.$emit('popupClose', args, this);
          isFunction(closed) && closed.apply(this, args);
          return this;
        },
        width: function width(_width) {
          _width && this.$domWrap.css('width', _width);
          return this;
        },
        height: function height(_height) {
          _height && this.$domWrap.css('height', _height);
          return this;
        },
        offset: function offset(vals) {
          var trblArr = ('' + (vals || '')).split(' ');
          var cssObj = {};
          if (trblArr.length > 2) {
            ['top', 'right', 'bottom', 'left'].forEach(function (dir, i) {
              if (trblArr[i] && trblArr[i] !== 'auto') {
                cssObj[dir] = trblArr[i];
              }
            });
            this.$domWrap.css(cssObj);
            return this;
          }

          var _trblArr = _slicedToArray(trblArr, 2),
              left = _trblArr[0],
              _top = _trblArr[1];

          if (left === '') {
            return this;
          }
          var top = _top || left;
          var xyAttr = offsetAttr.split(' ');
          cssObj[xyAttr[0]] = left;
          cssObj[xyAttr[1]] = top;
          this.$domWrap.css(cssObj);

          var translateXY = [];
          if (left === '50%') {
            translateXY.push('-50%');
          }
          if (top === '50%') {
            translateXY.push('-50%');
          }
          translateXY.length > 0 && this.translate(translateXY.join(' '));
          return this;
        },
        translate: function translate(xy) {
          var _$split = ('' + (xy || '')).split(' '),
              _$split2 = _slicedToArray(_$split, 2),
              x = _$split2[0],
              y = _$split2[1];

          x && this.$domWrap.css('transform', 'translate(' + x + ', ' + (y || x) + ')');
          return this;
        }
      }, methods)
    };
  }

  /**
   * chimee-plugin-log v0.0.4
   * (c) 2017 huzunjie
   * Released under MIT
   */

  function __$styleInject$2(css, returnValue) {
    if (typeof document === 'undefined') {
      return returnValue;
    }
    css = css || '';
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);
    
    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    return returnValue;
  }

  __$styleInject$2(".chimee-log{padding:2px;box-shadow:0 1px 4px rgba(0,0,0,.6)}.chimee-log label{margin-left:10px;font-weight:100;font-size:12px}.chimee-log label input{vertical-align:middle;display:inline;width:auto;padding:0;margin:0}.chimee-log vs-pp-body{padding:3px}.chimee-log textarea{display:block;width:100%;height:200px;margin:-3px;border:1px solid hsla(0,0%,100%,.5);background-color:hsla(0,0%,100%,.9)}", undefined);

  /** 日志插件(可以在实例化播放器时，通过重置部分参数，达成相应业务需求)
   * @param {String} logPostUrl 打点上报地址，默认为 undefined ，如果传入则将日志上报到该地址
   * @param {Object} events 可以重置事件绑定，自定义日志时机，也可以通过 methods 的 write_eventName_log或send_eventName_log 来进行输出或上报日志数据加工
  */

  // 存储页面开启时间，测试本地存储兼容性
  var pageLoadedTimestamp = new Date().getTime().toString();
  setLocalStorage('_chimee_t', pageLoadedTimestamp);
  var supportLS = getLocalStorage('_chimee_t') === pageLoadedTimestamp;

  // 为日志相关事件实现基本的日志输出绑定
  var defaultEvents = function () {
    for (var _len = arguments.length, evs = Array(_len), _key = 0; _key < _len; _key++) {
      evs[_key] = arguments[_key];
    }

    var rets = {};
    evs.forEach(function (evType) {
      rets[evType] = function (e) {
        var _this = this;

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this.writeLog(e);
        // 打点
        var box = this.box,
            type = this.type,
            src = this.src;
        var waitingNum = this._waiting_num,
            currentTime = this.currentTime,
            _is_seek = this._is_seek,
            isSeek = _is_seek === undefined ? false : _is_seek,
            _is_play = this._is_play,
            isPlay = _is_play === undefined ? false : _is_play,
            playingTimestamp = this.playingTimestamp,
            loadstartTimestamp = this.loadstartTimestamp,
            waitingTimestamp = this.waitingTimestamp;

        switch (evType) {
          case 'loadstart':
            this.sendLog(evType, { box: box, type: type, src: src });
            // 30秒后没加载完毕则认为超时
            this._ls_timeout = setTimeout(function () {
              _this.sendLog('timeout', { src: src });
            }, this.timeoutDelay);
            this._total_waiting_time = 0;
            break;
          case 'seeking':
            this._is_seek = true;
            break;
          case 'play':
            this._is_play = true;
            break;
          case 'pause':
            this.sendLog(evType, { src: src, currentTime: currentTime });
            break;
          case 'canplay':
            clearTimeout(this._ls_timeout);
            var canplayTime = this.canplayTimestamp;
            this.sendLog(evType, { src: src, currentTime: currentTime, waitingNum: waitingNum, waitingTime: canplayTime - (loadstartTimestamp || waitingTimestamp || canplayTime) });
            break;
          case 'playing':
            clearTimeout(this._ls_timeout);
            var waitingTime = playingTimestamp - (loadstartTimestamp || waitingTimestamp || playingTimestamp);
            this._total_waiting_time += waitingTime;
            this.sendLog(evType, {
              src: src,
              // 等待次数，0 为首次加载
              waitingNum: waitingNum,
              // 通过 currentTime 位置
              currentTime: currentTime,
              // 是否seek导致的缓冲
              isSeek: isSeek,
              isPlay: isPlay,
              // 等待时长
              waitingTime: waitingTime
            });
            this.loadstartTimestamp = 0;
            this.waitingTimestamp = 0;
            this._is_seek = false;
            this._is_play = false;
            break;
          case 'ended':
            this.sendLog(evType, { src: src, waitingNum: waitingNum, totalWaitingTime: this._total_waiting_time });
            break;
          case 'waiting':
            this._waiting_num++;
            this.sendLog(evType, {
              src: src,
              waitingNum: waitingNum,
              currentTime: currentTime,
              // 是否seek导致的缓冲
              isSeek: isSeek,
              isPlay: isPlay
            });
            break;
          case 'error':
            this.sendLog(evType, { src: src, args: args });
            break;
        }
      };
    });
    return rets;
  }('loadstart', // 客户端开始请求数据
  'abort', // 用户主动终止下载
  'durationchange', // 视频时长变化（video通过metadata拿到长度值 this.duration）
  'loadedmetadata', // 播放器获取到metadata
  'loadeddata', // 首帧加载完毕
  'progress', // 正在下载数据
  'canplay', // 可播放的，缓冲未必充分
  'canplaythrough', // 缓冲足够，可以播放了
  'pause', // 暂停
  'play', // 播放
  'playing', // 已切换到播放状态
  'emptied', // 媒体列表为空
  'ended', // 媒体列表播放完毕
  'seeking', // 播放位置跳转，寻找关键帧中
  'seeked', // 关键帧寻找完毕
  'stalled', // 浏览器尝试获取媒体数据，但数据不可用
  'suspend', // 当浏览器刻意不获取媒体数据时（比如播放中video被销毁）
  'timeupdate', // 播放的进度变化 this.currentTime
  'waiting', // 等待下一帧缓冲
  'error' // 异常
  );

  // 生产log组件对应的 PluginConfig
  var index$1 = popupFactory$2({
    name: 'chimeeLog',
    className: 'chimee-log',
    title: '日志信息' + (supportLS ? '<label><input type="checkbox">下次自动打开</label>' : ''),
    body: '<textarea>Chimee logs:</textarea>',
    offset: '0',
    width: '400px',
    hide: true,
    autoFocus: false,
    logPostUrl: undefined, // 日志上报地址，不填写则不上报
    beforeCreate: function beforeCreate(_, option) {
      if (isUrl(option.logPostUrl)) {
        this.logPostUrl = option.logPostUrl;
      }
      if (option.timeoutDelay) {
        this.timeoutDelay = option.timeoutDelay;
      }
    },
    create: function create() {
      this.logBase.ver = this.VERSION;
      var $wrap = this.$domWrap;
      this.$txtEl = $wrap.find('textarea');
      // 如果当前环境支持本地存储，则给予用户记住打开状态的复选框
      if (supportLS) {
        var lsKey = 'auto_on';
        // 下次自动打开日志展示窗口
        var autoOn = getLocalStorage(lsKey) === '1';
        $wrap.find('input[type="checkbox"]').on('change', function (e) {
          setLocalStorage(lsKey, +this.checked);
        })[0].checked = autoOn;
        // 告诉父组件是否create后开启
        this._hide = !autoOn;
      }
      this.writeLog({ type: 'ready' });
      this.$emitSync('logPluginCreate');
    },
    destroy: function destroy() {
      clearTimeout(this._ls_timeout);
      this.$emitSync('logPluginDestroy');
      this.sendLog('destroy');
    },

    // 播放器初始化完毕
    inited: function inited() {
      // this.writeLog({type: 'inited'});
      // this.sendLog('inited');
    },
    closed: function closed() {
      this.$txtEl.text('');
    },
    opened: function opened() {
      this.$bumpToTop();
    },

    methods: {
      writeLog: function writeLog(event) {
        var logName = event.type;
        // 记录事件发生的时间戳
        this[logName + 'Timestamp'] = +new Date();

        // 模态窗为隐藏状态则停止输出
        if (this._hide) return;

        var logData = void 0;
        var logWriteFunName = 'write_' + logName + '_log';
        if (this[logWriteFunName]) {
          for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          logData = this[logWriteFunName](logName, args);
        }
        var logText = this.$txtEl.text() + '\n[' + formatDate(new Date(this[logName + 'Timestamp']), 'yyyy-MM-dd hh:mm:ss.i') + '] ' + logName + ' ' + (logData !== undefined ? _JSON$stringify(logData) : '');
        var txtEl = this.$txtEl.text(logText)[0];
        txtEl.scrollTop = txtEl.scrollHeight;
      },

      // 定义loadstart要打印出的日志信息
      write_loadstart_log: function write_loadstart_log(logName) {
        var box = this.box,
            type = this.type,
            src = this.src;

        return { box: box, type: type, src: src };
      },

      // 定义loadstart要打印出的日志信息
      write_durationchange_log: function write_durationchange_log() {
        var duration = this.duration;
        return { duration: duration };
      },

      // 定义loadstart要打印出的日志信息
      write_timeupdate_log: function write_timeupdate_log() {
        var currentTime = this.currentTime;
        return { currentTime: currentTime };
      },


      // 得到 inited 时要上报的日志
      send_inited_log: function send_inited_log() {
        /* chimee 构建：
        pro - protocol
        box - box
        type - type
        src - src
        uid - cookie
        ver - chimee 版本
        _t - 时间戳
        _r - 随机数
        */
        var box = this.box,
            type = this.type,
            src = this.src,
            ctrs = this.controls,
            loop = this.loop;

        return { pro: location.protocol, box: box, type: type, src: src, ctrs: ctrs, loop: loop };
      },


      // 发送日志到服务端
      sendLog: function sendLog(logType, data) {
        var logPostUrl = this.logPostUrl;
        // 未设置上报地址则什么也不干
        if (!logPostUrl) return;
        var logData = deepAssign(data || {}, this.logBase);

        var logParseFunName = 'send_' + logType + '_log';
        if (this[logParseFunName]) {
          deepAssign(logData, this[logParseFunName](logType, logData));
        }
        deepAssign(logData, {
          evt: logType,
          _t: +new Date(),
          _r: Math.random()
        });
        // console.log(logType, ' logData:', logData);
        var logQuerys = [];
        _Object$keys(logData).forEach(function (key) {
          return logQuerys.push(encodeURIComponent(key) + '=' + encodeURIComponent(logData[key]));
        });

        // 上报打点
        var img = new Image();
        img.onload = img.onerror = function (e) {
          img = null;
        };
        img.src = logPostUrl + '?' + logQuerys.join('&');
      }
    },
    events: deepAssign(defaultEvents, {
      openLogPopup: function openLogPopup() {
        this.open();
      }
    }),
    // 以下为日志上报处理相关逻辑
    data: {
      timeoutDelay: 3e4,
      pageLoadedTimestamp: pageLoadedTimestamp,
      // 缓冲次数
      _waiting_num: 0,
      _total_waiting_time: 0,
      logBase: {
        uid: function (uid) {
          if (!uid) {
            uid = uuid();
            setLocalStorage('_chimee_uid', uid);
          }
          return uid;
        }(getLocalStorage('_chimee_uid')),
        ref: location.href
      }
    },
    computed: {
      type: function type() {
        return this.$videoConfig.isLive ? 'live' : 'vod';
      }
    }
  });

  function __$styleInject$3(css, returnValue) {
    if (typeof document === 'undefined') {
      return returnValue;
    }

    css = css || '';
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    return returnValue;
  }

  __$styleInject$3("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}", undefined);
  /**
   * 这里提供一个工厂方法，用于生产一个popup插件配置，或基于popup特性实现自己的插件
   * @param {Object} optons 针对popup扩展了定制化参数，另外也用来重写部分PluginConfig配置
   * @param {String} optons.name 插件名
   * @param {String} optons.tagName Popup DOM容器的tagName
   * @param {String} optons.className Popup DOM容器的className
   * @param {String} optons.title Popup 标题，当设置值为 false 则不渲染title对应DOM
   * @param {String} optons.body Popup 内容，当设置值为 false 则不渲染body对应DOM
   * @param {String} optons.html html 用于构架popup的模板，重写后上面的title、body无效
   * @param {String} optons.offset 设定相对播放器要展示的坐标位置，空格分割的坐标值：'X:left Y:top'||'top right bottom left', 具体的像素百分比值或者auto；实例化后可重写 popupplugin.offset('0 0 0 0')
   * @param {String} optons.offsetAttr offset对应的CSS属性key，默认'left top'、'top right bottom left'-当offset空格分割的参数值多余2个时，便于只设定个别或特定方向边距
   * @param {String} optons.translate 在offset基础上的偏移量，格式如："leftVal topVal"，当offset为50%这里没设定值，则默认偏移-50%；实例化后可重写 popupplugin.translate('0 0')
   * @param {String} optons.width 宽度值（需要带单位）；实例化后可重写 popupplugin.width('100px')
   * @param {String} optons.height 高度值（需要带单位）；实例化后可重写 popupplugin.height('100px')
   * @param {Boolean} optons.hide 初始状态是否设置为关闭，默认值 false
   * @param {Function} optons.opened 开启时执行
   * @param {Function} optons.closed 关闭时执行
   * @param {Boolean} optons.penetrate 是否将交互事件同步到video元素(点击当前popup同样实现video的暂停播放)，默认值 false
   * @param {Boolean} optons.operable 是否启用事件交互（false则设置CSS事件穿透），默认值 true
   * @return {PluginConfig}
   */


  function popupFactory$3() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === undefined ? 'chimee-popup' : _ref$tagName,
        className = _ref.className,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? 'popup' : _ref$name,
        html = _ref.html,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? '这是一个信息框' : _ref$title,
        _ref$body = _ref.body,
        body = _ref$body === undefined ? '这里是信息内容' : _ref$body,
        _ref$offsetAttr = _ref.offsetAttr,
        offsetAttr = _ref$offsetAttr === undefined ? 'left top' : _ref$offsetAttr,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? '50% 50%' : _ref$offset,
        _ref$translate = _ref.translate,
        translate = _ref$translate === undefined ? '' : _ref$translate,
        width = _ref.width,
        height = _ref.height,
        level = _ref.level,
        init = _ref.init,
        inited = _ref.inited,
        data = _ref.data,
        _create = _ref.create,
        _beforeCreate = _ref.beforeCreate,
        _destroy = _ref.destroy,
        events = _ref.events,
        computed = _ref.computed,
        _ref$methods = _ref.methods,
        methods = _ref$methods === undefined ? {} : _ref$methods,
        _ref$penetrate = _ref.penetrate,
        penetrate = _ref$penetrate === undefined ? false : _ref$penetrate,
        _ref$operable = _ref.operable,
        operable = _ref$operable === undefined ? true : _ref$operable,
        _ref$hide = _ref.hide,
        hide = _ref$hide === undefined ? false : _ref$hide,
        opened = _ref.opened,
        closed = _ref.closed,
        autoFocus = _ref.autoFocus;

    var defaultConfig = {
      html: html || '\n      <cm-pp-close>\xD7</cm-pp-close>\n      ' + (title !== false ? '<cm-pp-head>' + title + '</cm-pp-head>' : '') + '\n      ' + (body !== false ? '<cm-pp-body>' + body + '</cm-pp-body>' : '') + '\n    ',
      closeSelector: '._close'
    };
    return {
      name: name,
      el: tagName,
      className: className,
      beforeCreate: function beforeCreate() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            events = _ref2.events,
            methods = _ref2.methods;

        var option = arguments[1];

        if (isObject(option)) {
          isObject(option.events) && deepAssign(events, option.events);
          isObject(option.methods) && deepAssign(methods, option.methods);
        }

        _beforeCreate && _beforeCreate.apply(this, arguments);
      },
      create: function create() {
        var config = isObject(this.$config) ? deepAssign(defaultConfig, this.$config) : defaultConfig;
        var $dom = this.$domWrap = $(this.$dom).css('display', 'none');
        $dom.html(config.html).delegate('cm-pp-close, ' + config.closeSelector, 'click', this.close);
        this.width(width).height(height).offset(offset).translate(translate);
        this._hide = hide;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _create && _create.apply(this, args);
        !this._hide && this.open();
      },
      destroy: function destroy() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _destroy && _destroy.apply(this, args);
        this.$domWrap.undelegate(this.$config.closeSelector, 'click', this.close).remove();
      },
      level: level,
      init: init,
      inited: inited,
      data: data,
      events: events,
      computed: computed,
      penetrate: penetrate,
      operable: operable,
      autoFocus: autoFocus,
      methods: deepAssign({
        open: function open() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'block');
          this._hide = false;

          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          this.$emit('popupOpen', args, this);
          isFunction(opened) && opened.apply(this, args);
          return this;
        },
        close: function close() {
          if (this.destroyed) return this;
          this.$domWrap.css('display', 'none');
          this._hide = true;

          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          this.$emit('popupClose', args, this);
          isFunction(closed) && closed.apply(this, args);
          return this;
        },
        width: function width(_width) {
          _width && this.$domWrap.css('width', _width);
          return this;
        },
        height: function height(_height) {
          _height && this.$domWrap.css('height', _height);
          return this;
        },
        offset: function offset(vals) {
          var trblArr = ('' + (vals || '')).split(' ');
          var cssObj = {};

          if (trblArr.length > 2) {
            ['top', 'right', 'bottom', 'left'].forEach(function (dir, i) {
              if (trblArr[i]) {
                cssObj[dir] = trblArr[i];
              }
            });
            this.$domWrap.css(cssObj);
            return this;
          }

          var _trblArr = _slicedToArray(trblArr, 2),
              left = _trblArr[0],
              _top = _trblArr[1];

          if (left === '') {
            return this;
          }

          var top = _top || left;
          var xyAttr = offsetAttr.split(' ');
          cssObj[xyAttr[0]] = left;
          cssObj[xyAttr[1]] = top;
          this.$domWrap.css(cssObj);
          var translateXY = [];

          if (left === '50%') {
            translateXY.push('-50%');
          }

          if (top === '50%') {
            translateXY.push('-50%');
          }

          translateXY.length > 0 && this.translate(translateXY.join(' '));
          return this;
        },
        translate: function translate(xy) {
          var _$split = ('' + (xy || '')).split(' '),
              _$split2 = _slicedToArray(_$split, 2),
              x = _$split2[0],
              y = _$split2[1];

          if (x !== '') {
            this.$domWrap.css('transform', 'translate(' + x + ', ' + (y || x) + ')');
            this.$domWrap.css('-ms-transform', 'translate(' + x + ', ' + (y || x) + ')');

            if (!('transform' in document.createElement('a').style) && window.console && window.console.warn) {
              console.warn('[chimee-plugin-popup] 当前环境不支持CSS3的transform特性，Dom元素无法正常使用translate。');
            }
          }

          return this;
        }
      }, methods)
    };
  }

  var clss = 'correct tip play pause back forward volume-high volume-low';
  var defaultConfig$1 = {
    errorTips: '加载失败，请刷新重试'
  };
  var chimeeCenterState = popupFactory$3({
    name: 'chimeeCenterState',
    tagName: 'chimee-center-state',
    html: "\n    <chimee-center-state-correct>\n      <chimee-center-state-loading></chimee-center-state-loading>\n      <chimee-center-state-tip>\n        <span></span>\n      </chimee-center-state-tip>\n    </chimee-center-state-correct>\n    <chimee-center-state-error></chimee-center-state-error>\n  ",
    offset: '50%',
    hide: false,
    create: function create() {},
    inited: function inited() {
      this.config = isObject(this.$config) ? deepAssign(defaultConfig$1, this.$config) : defaultConfig$1;
      this.$dom.querySelector('chimee-center-state-error').innerText = this.config.errorTips;
      this.src && (this.preload === 'auto' || this.preload === 'metadata' || this.preload === '' || this.autoplay === true) && this.showLoading(true);
    },
    penetrate: true,
    operable: false,
    destroy: function destroy() {
      this.clearTimeout();
    },
    events: {
      pause: function pause() {
        this.showTip('pause');
        this.showLoading(false);
      },
      play: function play() {
        this.showTip('play');
      },
      canplay: function canplay() {
        this.playing();
      },
      playing: function playing() {
        this.playing();
      },
      // 默认会上来就会调用，显示 loading 不符合逻辑
      // loadstart () {
      //   this.waiting('loadstart');
      // },
      waiting: function waiting() {
        this.waiting();
      },
      // 卡顿(FLV|HLS加载异常待内部特供事件)
      // stalled () {
      //   this.showLoading();
      // },
      timeupdate: function timeupdate() {
        this.showLoading(false);
        this.clearTimeout();
      },
      keydown: function keydown(e) {
        // controlbar 存在，才会有键盘事件，因此如果 controlbar 组件没有加载时，return
        var hasControlbar = this.$videoConfig.plugin.some(function (item) {
          var name = item.name || item;
          return name === 'chimeeControl';
        });
        if (!hasControlbar) return;
        e.stopPropagation();

        switch (e.keyCode) {
          case 37:
            {
              e.preventDefault();
              !this.live && this.showTip('back');
              break;
            }

          case 39:
            {
              e.preventDefault();
              !this.live && this.showTip('forward');
              break;
            }

          case 38:
            {
              e.preventDefault();
              this.showTip('volume-high');
              break;
            }

          case 40:
            {
              e.preventDefault();
              this.showTip('volume-low');
              break;
            }
        }
      }
    },
    methods: {
      playing: function playing() {
        this.clearTimeout();
        this.showLoading(false);
        this.showError(false);
      },
      waiting: function waiting() {
        var _this = this;

        this.clearTimeout(); // 加载超过20秒则超时显示异常

        this._timeout = setTimeout(function () {
          return _this.showError();
        }, 3e4);
        !this.paused && this.showLoading(true);
      },
      clearTimeout: function (_clearTimeout) {
        function clearTimeout() {
          return _clearTimeout.apply(this, arguments);
        }

        clearTimeout.toString = function () {
          return _clearTimeout.toString();
        };

        return clearTimeout;
      }(function () {
        if (this._timeout) {
          clearTimeout(this._timeout);
          this._timeout = null;
        }
      }),
      showTip: function showTip(cls) {
        var _this2 = this;

        this.$domWrap.removeClass(clss).addClass('correct tip ' + cls); // this.tip = cls;

        setTimeout(function () {
          _this2.$domWrap.removeClass('tip ' + cls); // this.tip = undefined;

        }, 500);
      },
      showLoading: function showLoading(status) {
        if (status === false) {
          this.$domWrap.removeClass('loading');
        } else {
          this.$domWrap.addClass('correct loading');
        }
      },
      showError: function showError(status) {
        if (status === false) {
          this.$domWrap.removeClass('error');
        } else {
          this.$domWrap[0].className = '';
          this.$domWrap.addClass('error');
        }
      }
    }
  });

  var hls = createCommonjsModule(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
  	module.exports = factory();
  })(typeof self !== 'undefined' ? self : commonjsGlobal, function() {
  return /******/ (function(modules) { // webpackBootstrap
  /******/ 	// The module cache
  /******/ 	var installedModules = {};
  /******/
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
  /******/
  /******/ 		// Check if module is in cache
  /******/ 		if(installedModules[moduleId]) {
  /******/ 			return installedModules[moduleId].exports;
  /******/ 		}
  /******/ 		// Create a new module (and put it into the cache)
  /******/ 		var module = installedModules[moduleId] = {
  /******/ 			i: moduleId,
  /******/ 			l: false,
  /******/ 			exports: {}
  /******/ 		};
  /******/
  /******/ 		// Execute the module function
  /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
  /******/
  /******/ 		// Flag the module as loaded
  /******/ 		module.l = true;
  /******/
  /******/ 		// Return the exports of the module
  /******/ 		return module.exports;
  /******/ 	}
  /******/
  /******/
  /******/ 	// expose the modules object (__webpack_modules__)
  /******/ 	__webpack_require__.m = modules;
  /******/
  /******/ 	// expose the module cache
  /******/ 	__webpack_require__.c = installedModules;
  /******/
  /******/ 	// define getter function for harmony exports
  /******/ 	__webpack_require__.d = function(exports, name, getter) {
  /******/ 		if(!__webpack_require__.o(exports, name)) {
  /******/ 			Object.defineProperty(exports, name, {
  /******/ 				configurable: false,
  /******/ 				enumerable: true,
  /******/ 				get: getter
  /******/ 			});
  /******/ 		}
  /******/ 	};
  /******/
  /******/ 	// getDefaultExport function for compatibility with non-harmony modules
  /******/ 	__webpack_require__.n = function(module) {
  /******/ 		var getter = module && module.__esModule ?
  /******/ 			function getDefault() { return module['default']; } :
  /******/ 			function getModuleExports() { return module; };
  /******/ 		__webpack_require__.d(getter, 'a', getter);
  /******/ 		return getter;
  /******/ 	};
  /******/
  /******/ 	// Object.prototype.hasOwnProperty.call
  /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
  /******/
  /******/ 	// __webpack_public_path__
  /******/ 	__webpack_require__.p = "/dist/";
  /******/
  /******/ 	// Load entry module and return exports
  /******/ 	return __webpack_require__(__webpack_require__.s = 9);
  /******/ })
  /************************************************************************/
  /******/ ([
  /* 0 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enableLogs; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logger; });
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function noop() {}

  var fakeLogger = {
    trace: noop,
    debug: noop,
    log: noop,
    warn: noop,
    info: noop,
    error: noop
  };

  var exportedLogger = fakeLogger;

  /* globals self: false */

  // let lastCallTime;
  // function formatMsgWithTimeInfo(type, msg) {
  //   const now = Date.now();
  //   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
  //   lastCallTime = now;
  //   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
  //   return msg;
  // }

  function formatMsg(type, msg) {
    msg = '[' + type + '] > ' + msg;
    return msg;
  }

  function consolePrintFn(type) {
    var func = self.console[type];
    if (func) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (args[0]) args[0] = formatMsg(type, args[0]);

        func.apply(self.console, args);
      };
    }
    return noop;
  }

  function exportLoggerFunctions(debugConfig) {
    for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      functions[_key2 - 1] = arguments[_key2];
    }

    functions.forEach(function (type) {
      exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
    });
  }

  var enableLogs = function enableLogs(debugConfig) {
    if (debugConfig === true || (typeof debugConfig === 'undefined' ? 'undefined' : _typeof(debugConfig)) === 'object') {
      exportLoggerFunctions(debugConfig,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      'debug', 'log', 'info', 'warn', 'error');
      // Some browsers don't allow to use bind on console object anyway
      // fallback to default if needed
      try {
        exportedLogger.log();
      } catch (e) {
        exportedLogger = fakeLogger;
      }
    } else {
      exportedLogger = fakeLogger;
    }
  };

  var logger = exportedLogger;

  /***/ }),
  /* 1 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  /**
   * @readonly
   * @enum {string}
   */
  var HlsEvents = {
    // fired before MediaSource is attaching to media element - data: { media }
    MEDIA_ATTACHING: 'hlsMediaAttaching',
    // fired when MediaSource has been succesfully attached to media element - data: { }
    MEDIA_ATTACHED: 'hlsMediaAttached',
    // fired before detaching MediaSource from media element - data: { }
    MEDIA_DETACHING: 'hlsMediaDetaching',
    // fired when MediaSource has been detached from media element - data: { }
    MEDIA_DETACHED: 'hlsMediaDetached',
    // fired when we buffer is going to be reset - data: { }
    BUFFER_RESET: 'hlsBufferReset',
    // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
    BUFFER_CODECS: 'hlsBufferCodecs',
    // fired when sourcebuffers have been created - data: { tracks : tracks }
    BUFFER_CREATED: 'hlsBufferCreated',
    // fired when we append a segment to the buffer - data: { segment: segment object }
    BUFFER_APPENDING: 'hlsBufferAppending',
    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
    BUFFER_APPENDED: 'hlsBufferAppended',
    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
    BUFFER_EOS: 'hlsBufferEos',
    // fired when the media buffer should be flushed - data { startOffset, endOffset }
    BUFFER_FLUSHING: 'hlsBufferFlushing',
    // fired when the media buffer has been flushed - data: { }
    BUFFER_FLUSHED: 'hlsBufferFlushed',
    // fired to signal that a manifest loading starts - data: { url : manifestURL}
    MANIFEST_LOADING: 'hlsManifestLoading',
    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
    MANIFEST_LOADED: 'hlsManifestLoaded',
    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
    MANIFEST_PARSED: 'hlsManifestParsed',
    // fired when a level switch is requested - data: { level : id of new level }
    LEVEL_SWITCHING: 'hlsLevelSwitching',
    // fired when a level switch is effective - data: { level : id of new level }
    LEVEL_SWITCHED: 'hlsLevelSwitched',
    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
    LEVEL_LOADING: 'hlsLevelLoading',
    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
    LEVEL_LOADED: 'hlsLevelLoaded',
    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
    LEVEL_UPDATED: 'hlsLevelUpdated',
    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
    LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
    AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
    // fired when an audio track switching is requested - data: { id : audio track id }
    AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
    // fired when an audio track switch actually occurs - data: { id : audio track id }
    AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
    AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
    AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
    SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
    SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
    SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
    SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
    SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
    INIT_PTS_FOUND: 'hlsInitPtsFound',
    // fired when a fragment loading starts - data: { frag : fragment object }
    FRAG_LOADING: 'hlsFragLoading',
    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
    FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
    FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
    FRAG_LOADED: 'hlsFragLoaded',
    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
    FRAG_DECRYPTED: 'hlsFragDecrypted',
    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
    FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
    FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
    FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
    FRAG_PARSING_DATA: 'hlsFragParsingData',
    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
    FRAG_PARSED: 'hlsFragParsed',
    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
    FRAG_BUFFERED: 'hlsFragBuffered',
    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
    FRAG_CHANGED: 'hlsFragChanged',
    // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
    FPS_DROP: 'hlsFpsDrop',
    // triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
    FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
    ERROR: 'hlsError',
    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
    DESTROYING: 'hlsDestroying',
    // fired when a decrypt key loading starts - data: { frag : fragment object }
    KEY_LOADING: 'hlsKeyLoading',
    // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
    KEY_LOADED: 'hlsKeyLoaded',
    // fired upon stream controller state transitions - data: { previousState, nextState }
    STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
  };
  /* harmony default export */ __webpack_exports__["a"] = (HlsEvents);

  /***/ }),
  /* 2 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorTypes; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorDetails; });
  var ErrorTypes = {
    // Identifier for a network error (loading error / timeout ...)
    NETWORK_ERROR: 'networkError',
    // Identifier for a media Error (video/parsing/mediasource error)
    MEDIA_ERROR: 'mediaError',
    // EME (encrypted media extensions) errors
    KEY_SYSTEM_ERROR: 'keySystemError',
    // Identifier for a mux Error (demuxing/remuxing)
    MUX_ERROR: 'muxError',
    // Identifier for all other errors
    OTHER_ERROR: 'otherError'
  };

  /**
   * @enum {ErrorDetails}
   * @typedef {string} ErrorDetail
   */
  var ErrorDetails = {
    KEY_SYSTEM_NO_KEYS: 'keySystemNoKeys',
    KEY_SYSTEM_NO_ACCESS: 'keySystemNoAccess',
    KEY_SYSTEM_NO_SESSION: 'keySystemNoSession',
    KEY_SYSTEM_LICENSE_REQUEST_FAILED: 'keySystemLicenseRequestFailed',
    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_ERROR: 'manifestLoadError',
    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
    MANIFEST_PARSING_ERROR: 'manifestParsingError',
    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
    MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_ERROR: 'levelLoadError',
    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
    LEVEL_SWITCH_ERROR: 'levelSwitchError',
    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    FRAG_LOAD_ERROR: 'fragLoadError',
    // Identifier for fragment load timeout error - data: { frag : fragment object}
    FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
    FRAG_DECRYPT_ERROR: 'fragDecryptError',
    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
    FRAG_PARSING_ERROR: 'fragParsingError',
    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
    REMUX_ALLOC_ERROR: 'remuxAllocError',
    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    KEY_LOAD_ERROR: 'keyLoadError',
    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
    KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
    BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
    // Identifier for a buffer append error - data: append error description
    BUFFER_APPEND_ERROR: 'bufferAppendError',
    // Identifier for a buffer appending error event - data: appending error description
    BUFFER_APPENDING_ERROR: 'bufferAppendingError',
    // Identifier for a buffer stalled error event
    BUFFER_STALLED_ERROR: 'bufferStalledError',
    // Identifier for a buffer full event
    BUFFER_FULL_ERROR: 'bufferFullError',
    // Identifier for a buffer seek over hole event
    BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
    BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
    // Identifier for an internal exception happening inside hls.js while handling an event
    INTERNAL_EXCEPTION: 'internalException'
  };

  /***/ }),
  /* 3 */
  /***/ (function(module, exports, __webpack_require__) {

  // see https://tools.ietf.org/html/rfc1808

  /* jshint ignore:start */
  (function(root) { 
  /* jshint ignore:end */

    var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
    var FIRST_SEGMENT_REGEX = /^([^\/;?#]*)(.*)$/;
    var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
    var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;

    var URLToolkit = { // jshint ignore:line
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(baseURL, relativeURL, opts) {
        opts = opts || {};
        // remove any remaining space and CRLF
        baseURL = baseURL.trim();
        relativeURL = relativeURL.trim();
        if (!relativeURL) {
          // 2a) If the embedded URL is entirely empty, it inherits the
          // entire base URL (i.e., is set equal to the base URL)
          // and we are done.
          if (!opts.alwaysNormalize) {
            return baseURL;
          }
          var basePartsForNormalise = URLToolkit.parseURL(baseURL);
          if (!basePartsForNormalise) {
            throw new Error('Error trying to parse base URL.');
          }
          basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
          return URLToolkit.buildURLFromParts(basePartsForNormalise);
        }
        var relativeParts = URLToolkit.parseURL(relativeURL);
        if (!relativeParts) {
          throw new Error('Error trying to parse relative URL.');
        }
        if (relativeParts.scheme) {
          // 2b) If the embedded URL starts with a scheme name, it is
          // interpreted as an absolute URL and we are done.
          if (!opts.alwaysNormalize) {
            return relativeURL;
          }
          relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
          return URLToolkit.buildURLFromParts(relativeParts);
        }
        var baseParts = URLToolkit.parseURL(baseURL);
        if (!baseParts) {
          throw new Error('Error trying to parse base URL.');
        }
        if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
          // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
          // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
          var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
          baseParts.netLoc = pathParts[1];
          baseParts.path = pathParts[2];
        }
        if (baseParts.netLoc && !baseParts.path) {
          baseParts.path = '/';
        }
        var builtParts = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: baseParts.scheme,
          netLoc: relativeParts.netLoc,
          path: null,
          params: relativeParts.params,
          query: relativeParts.query,
          fragment: relativeParts.fragment
        };
        if (!relativeParts.netLoc) {
          // 3) If the embedded URL's <net_loc> is non-empty, we skip to
          // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
          // (if any) of the base URL.
          builtParts.netLoc = baseParts.netLoc;
          // 4) If the embedded URL path is preceded by a slash "/", the
          // path is not relative and we skip to Step 7.
          if (relativeParts.path[0] !== '/') {
            if (!relativeParts.path) {
              // 5) If the embedded URL path is empty (and not preceded by a
              // slash), then the embedded URL inherits the base URL path
              builtParts.path = baseParts.path;
              // 5a) if the embedded URL's <params> is non-empty, we skip to
              // step 7; otherwise, it inherits the <params> of the base
              // URL (if any) and
              if (!relativeParts.params) {
                builtParts.params = baseParts.params;
                // 5b) if the embedded URL's <query> is non-empty, we skip to
                // step 7; otherwise, it inherits the <query> of the base
                // URL (if any) and we skip to step 7.
                if (!relativeParts.query) {
                  builtParts.query = baseParts.query;
                }
              }
            } else {
              // 6) The last segment of the base URL's path (anything
              // following the rightmost slash "/", or the entire path if no
              // slash is present) is removed and the embedded URL's path is
              // appended in its place.
              var baseURLPath = baseParts.path;
              var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
              builtParts.path = URLToolkit.normalizePath(newPath);
            }
          }
        }
        if (builtParts.path === null) {
          builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
        }
        return URLToolkit.buildURLFromParts(builtParts);
      },
      parseURL: function(url) {
        var parts = URL_REGEX.exec(url);
        if (!parts) {
          return null;
        }
        return {
          scheme: parts[1] || '',
          netLoc: parts[2] || '',
          path: parts[3] || '',
          params: parts[4] || '',
          query: parts[5] || '',
          fragment: parts[6] || ''
        };
      },
      normalizePath: function(path) {
        // The following operations are
        // then applied, in order, to the new path:
        // 6a) All occurrences of "./", where "." is a complete path
        // segment, are removed.
        // 6b) If the path ends with "." as a complete path segment,
        // that "." is removed.
        path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
        // 6c) All occurrences of "<segment>/../", where <segment> is a
        // complete path segment not equal to "..", are removed.
        // Removal of these path segments is performed iteratively,
        // removing the leftmost matching pattern on each iteration,
        // until no matching pattern remains.
        // 6d) If the path ends with "<segment>/..", where <segment> is a
        // complete path segment not equal to "..", that
        // "<segment>/.." is removed.
        while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
        return path.split('').reverse().join('');
      },
      buildURLFromParts: function(parts) {
        return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
      }
    };

  /* jshint ignore:start */
    module.exports = URLToolkit;
  })(this);
  /* jshint ignore:end */


  /***/ }),
  /* 4 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utf8ArrayToStr; });
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * ID3 parser
   */
  var ID3 = function () {
    function ID3() {
      _classCallCheck(this, ID3);
    }

    /**
     * Returns true if an ID3 header can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 header is found
     */
    ID3.isHeader = function isHeader(data, offset) {
      /*
      * http://id3.org/id3v2.3.0
      * [0]     = 'I'
      * [1]     = 'D'
      * [2]     = '3'
      * [3,4]   = {Version}
      * [5]     = {Flags}
      * [6-9]   = {ID3 Size}
      *
      * An ID3v2 tag can be detected with the following pattern:
      *  $49 44 33 yy yy xx zz zz zz zz
      * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
      */
      if (offset + 10 <= data.length) {
        // look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
          // check version is within range
          if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
            // check size is within range
            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
          }
        }
      }

      return false;
    };

    /**
     * Returns true if an ID3 footer can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 footer is found
     */


    ID3.isFooter = function isFooter(data, offset) {
      /*
      * The footer is a copy of the header, but with a different identifier
      */
      if (offset + 10 <= data.length) {
        // look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
          // check version is within range
          if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
            // check size is within range
            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
          }
        }
      }

      return false;
    };

    /**
     * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {Uint8Array} - The block of data containing any ID3 tags found
     */


    ID3.getID3Data = function getID3Data(data, offset) {
      var front = offset;
      var length = 0;

      while (ID3.isHeader(data, offset)) {
        // ID3 header is 10 bytes
        length += 10;

        var size = ID3._readSize(data, offset + 6);
        length += size;

        if (ID3.isFooter(data, offset + 10)) {
          // ID3 footer is 10 bytes
          length += 10;
        }

        offset += length;
      }

      if (length > 0) return data.subarray(front, front + length);

      return undefined;
    };

    ID3._readSize = function _readSize(data, offset) {
      var size = 0;
      size = (data[offset] & 0x7f) << 21;
      size |= (data[offset + 1] & 0x7f) << 14;
      size |= (data[offset + 2] & 0x7f) << 7;
      size |= data[offset + 3] & 0x7f;
      return size;
    };

    /**
     * Searches for the Elementary Stream timestamp found in the ID3 data chunk
     * @param {Uint8Array} data - Block of data containing one or more ID3 tags
     * @return {number} - The timestamp
     */


    ID3.getTimeStamp = function getTimeStamp(data) {
      var frames = ID3.getID3Frames(data);
      for (var i = 0; i < frames.length; i++) {
        var frame = frames[i];
        if (ID3.isTimeStampFrame(frame)) return ID3._readTimeStamp(frame);
      }

      return undefined;
    };

    /**
     * Returns true if the ID3 frame is an Elementary Stream timestamp frame
     * @param {ID3 frame} frame
     */


    ID3.isTimeStampFrame = function isTimeStampFrame(frame) {
      return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
    };

    ID3._getFrameData = function _getFrameData(data) {
      /*
      Frame ID       $xx xx xx xx (four characters)
      Size           $xx xx xx xx
      Flags          $xx xx
      */
      var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
      var size = ID3._readSize(data, 4);

      // skip frame id, size, and flags
      var offset = 10;

      return { type: type, size: size, data: data.subarray(offset, offset + size) };
    };

    /**
     * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
     * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
     * @return {ID3 frame[]} - Array of ID3 frame objects
     */


    ID3.getID3Frames = function getID3Frames(id3Data) {
      var offset = 0;
      var frames = [];

      while (ID3.isHeader(id3Data, offset)) {
        var size = ID3._readSize(id3Data, offset + 6);
        // skip past ID3 header
        offset += 10;
        var end = offset + size;
        // loop through frames in the ID3 tag
        while (offset + 8 < end) {
          var frameData = ID3._getFrameData(id3Data.subarray(offset));
          var frame = ID3._decodeFrame(frameData);
          if (frame) frames.push(frame);

          // skip frame header and frame data
          offset += frameData.size + 10;
        }

        if (ID3.isFooter(id3Data, offset)) offset += 10;
      }

      return frames;
    };

    ID3._decodeFrame = function _decodeFrame(frame) {
      if (frame.type === 'PRIV') return ID3._decodePrivFrame(frame);else if (frame.type[0] === 'T') return ID3._decodeTextFrame(frame);else if (frame.type[0] === 'W') return ID3._decodeURLFrame(frame);

      return undefined;
    };

    ID3._readTimeStamp = function _readTimeStamp(timeStampFrame) {
      if (timeStampFrame.data.byteLength === 8) {
        var data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        var pts33Bit = data[3] & 0x1;
        var timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;

        if (pts33Bit) timestamp += 47721858.84; // 2^32 / 90

        return Math.round(timestamp);
      }

      return undefined;
    };

    ID3._decodePrivFrame = function _decodePrivFrame(frame) {
      /*
      Format: <text string>\0<binary data>
      */
      if (frame.size < 2) return undefined;

      var owner = ID3._utf8ArrayToStr(frame.data, true);
      var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));

      return { key: frame.type, info: owner, data: privateData.buffer };
    };

    ID3._decodeTextFrame = function _decodeTextFrame(frame) {
      if (frame.size < 2) return undefined;

      if (frame.type === 'TXXX') {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Description}\0{Value}
        */
        var index = 1;
        var description = ID3._utf8ArrayToStr(frame.data.subarray(index));

        index += description.length + 1;
        var value = ID3._utf8ArrayToStr(frame.data.subarray(index));

        return { key: frame.type, info: description, data: value };
      } else {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Value}
        */
        var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
        return { key: frame.type, data: text };
      }
    };

    ID3._decodeURLFrame = function _decodeURLFrame(frame) {
      if (frame.type === 'WXXX') {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Description}\0{URL}
        */
        if (frame.size < 2) return undefined;

        var index = 1;
        var description = ID3._utf8ArrayToStr(frame.data.subarray(index));

        index += description.length + 1;
        var value = ID3._utf8ArrayToStr(frame.data.subarray(index));

        return { key: frame.type, info: description, data: value };
      } else {
        /*
        Format:
        [0-?] = {URL}
        */
        var url = ID3._utf8ArrayToStr(frame.data);
        return { key: frame.type, data: url };
      }
    };

    // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
    // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
    /* utf.js - UTF-8 <=> UTF-16 convertion
     *
     * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
     * Version: 1.0
     * LastModified: Dec 25 1999
     * This library is free.  You can redistribute it and/or modify it.
     */


    ID3._utf8ArrayToStr = function _utf8ArrayToStr(array) {
      var exitOnNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var len = array.length;
      var c = void 0;
      var char2 = void 0;
      var char3 = void 0;
      var out = '';
      var i = 0;
      while (i < len) {
        c = array[i++];
        if (c === 0x00 && exitOnNull) {
          return out;
        } else if (c === 0x00 || c === 0x03) {
          // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
          continue;
        }
        switch (c >> 4) {
          case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
          case 12:case 13:
            // 110x xxxx   10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
            break;
          case 14:
            // 1110 xxxx  10xx xxxx  10xx xxxx
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
            break;
          default:
        }
      }
      return out;
    };

    return ID3;
  }();

  var utf8ArrayToStr = ID3._utf8ArrayToStr;

  /* harmony default export */ __webpack_exports__["a"] = (ID3);



  /***/ }),
  /* 5 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {

  // CONCATENATED MODULE: ./src/crypt/aes-crypto.js
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var AESCrypto = function () {
    function AESCrypto(subtle, iv) {
      _classCallCheck(this, AESCrypto);

      this.subtle = subtle;
      this.aesIV = iv;
    }

    AESCrypto.prototype.decrypt = function decrypt(data, key) {
      return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
    };

    return AESCrypto;
  }();

  /* harmony default export */ var aes_crypto = (AESCrypto);
  // CONCATENATED MODULE: ./src/crypt/fast-aes-key.js
  function fast_aes_key__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var FastAESKey = function () {
    function FastAESKey(subtle, key) {
      fast_aes_key__classCallCheck(this, FastAESKey);

      this.subtle = subtle;
      this.key = key;
    }

    FastAESKey.prototype.expandKey = function expandKey() {
      return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
    };

    return FastAESKey;
  }();

  /* harmony default export */ var fast_aes_key = (FastAESKey);
  // CONCATENATED MODULE: ./src/crypt/aes-decryptor.js
  function aes_decryptor__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  // PKCS7
  function removePadding(buffer) {
    var outputBytes = buffer.byteLength;
    var paddingBytes = outputBytes && new DataView(buffer).getUint8(outputBytes - 1);
    if (paddingBytes) return buffer.slice(0, outputBytes - paddingBytes);else return buffer;
  }

  var AESDecryptor = function () {
    function AESDecryptor() {
      aes_decryptor__classCallCheck(this, AESDecryptor);

      // Static after running initTable
      this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
      this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
      this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
      this.sBox = new Uint32Array(256);
      this.invSBox = new Uint32Array(256);

      // Changes during runtime
      this.key = new Uint32Array(0);

      this.initTable();
    }

    // Using view.getUint32() also swaps the byte order.


    AESDecryptor.prototype.uint8ArrayToUint32Array_ = function uint8ArrayToUint32Array_(arrayBuffer) {
      var view = new DataView(arrayBuffer);
      var newArray = new Uint32Array(4);
      for (var i = 0; i < 4; i++) {
        newArray[i] = view.getUint32(i * 4);
      }return newArray;
    };

    AESDecryptor.prototype.initTable = function initTable() {
      var sBox = this.sBox;
      var invSBox = this.invSBox;
      var subMix = this.subMix;
      var subMix0 = subMix[0];
      var subMix1 = subMix[1];
      var subMix2 = subMix[2];
      var subMix3 = subMix[3];
      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var d = new Uint32Array(256);
      var x = 0;
      var xi = 0;
      var i = 0;
      for (i = 0; i < 256; i++) {
        if (i < 128) d[i] = i << 1;else d[i] = i << 1 ^ 0x11b;
      }

      for (i = 0; i < 256; i++) {
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        sBox[x] = sx;
        invSBox[sx] = x;

        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];

        // Compute sub/invSub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        subMix0[x] = t << 24 | t >>> 8;
        subMix1[x] = t << 16 | t >>> 16;
        subMix2[x] = t << 8 | t >>> 24;
        subMix3[x] = t;

        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        invSubMix0[sx] = t << 24 | t >>> 8;
        invSubMix1[sx] = t << 16 | t >>> 16;
        invSubMix2[sx] = t << 8 | t >>> 24;
        invSubMix3[sx] = t;

        // Compute next counter
        if (!x) {
          x = xi = 1;
        } else {
          x = x2 ^ d[d[d[x8 ^ x2]]];
          xi ^= d[d[xi]];
        }
      }
    };

    AESDecryptor.prototype.expandKey = function expandKey(keyBuffer) {
      // convert keyBuffer to Uint32Array
      var key = this.uint8ArrayToUint32Array_(keyBuffer);
      var sameKey = true;
      var offset = 0;

      while (offset < key.length && sameKey) {
        sameKey = key[offset] === this.key[offset];
        offset++;
      }

      if (sameKey) return;

      this.key = key;
      var keySize = this.keySize = key.length;

      if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error('Invalid aes key size=' + keySize);

      var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
      var ksRow = void 0;
      var invKsRow = void 0;

      var keySchedule = this.keySchedule = new Uint32Array(ksRows);
      var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
      var sbox = this.sBox;
      var rcon = this.rcon;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var prev = void 0;
      var t = void 0;

      for (ksRow = 0; ksRow < ksRows; ksRow++) {
        if (ksRow < keySize) {
          prev = keySchedule[ksRow] = key[ksRow];
          continue;
        }
        t = prev;

        if (ksRow % keySize === 0) {
          // Rot word
          t = t << 8 | t >>> 24;

          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

          // Mix Rcon
          t ^= rcon[ksRow / keySize | 0] << 24;
        } else if (keySize > 6 && ksRow % keySize === 4) {
          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
        }

        keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
      }

      for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
        ksRow = ksRows - invKsRow;
        if (invKsRow & 3) t = keySchedule[ksRow];else t = keySchedule[ksRow - 4];

        if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];

        invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
      }
    };

    // Adding this as a method greatly improves performance.


    AESDecryptor.prototype.networkToHostOrderSwap = function networkToHostOrderSwap(word) {
      return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    };

    AESDecryptor.prototype.decrypt = function decrypt(inputArrayBuffer, offset, aesIV, removePKCS7Padding) {
      var nRounds = this.keySize + 6;
      var invKeySchedule = this.invKeySchedule;
      var invSBOX = this.invSBox;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var initVector = this.uint8ArrayToUint32Array_(aesIV);
      var initVector0 = initVector[0];
      var initVector1 = initVector[1];
      var initVector2 = initVector[2];
      var initVector3 = initVector[3];

      var inputInt32 = new Int32Array(inputArrayBuffer);
      var outputInt32 = new Int32Array(inputInt32.length);

      var t0 = void 0,
          t1 = void 0,
          t2 = void 0,
          t3 = void 0;
      var s0 = void 0,
          s1 = void 0,
          s2 = void 0,
          s3 = void 0;
      var inputWords0 = void 0,
          inputWords1 = void 0,
          inputWords2 = void 0,
          inputWords3 = void 0;

      var ksRow = void 0,
          i = void 0;
      var swapWord = this.networkToHostOrderSwap;

      while (offset < inputInt32.length) {
        inputWords0 = swapWord(inputInt32[offset]);
        inputWords1 = swapWord(inputInt32[offset + 1]);
        inputWords2 = swapWord(inputInt32[offset + 2]);
        inputWords3 = swapWord(inputInt32[offset + 3]);

        s0 = inputWords0 ^ invKeySchedule[0];
        s1 = inputWords3 ^ invKeySchedule[1];
        s2 = inputWords2 ^ invKeySchedule[2];
        s3 = inputWords1 ^ invKeySchedule[3];

        ksRow = 4;

        // Iterate through the rounds of decryption
        for (i = 1; i < nRounds; i++) {
          t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
          t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
          t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
          t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
          // Update state
          s0 = t0;
          s1 = t1;
          s2 = t2;
          s3 = t3;

          ksRow = ksRow + 4;
        }

        // Shift rows, sub bytes, add round key
        t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        ksRow = ksRow + 3;

        // Write
        outputInt32[offset] = swapWord(t0 ^ initVector0);
        outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
        outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
        outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

        // reset initVector to last 4 unsigned int
        initVector0 = inputWords0;
        initVector1 = inputWords1;
        initVector2 = inputWords2;
        initVector3 = inputWords3;

        offset = offset + 4;
      }

      return removePKCS7Padding ? removePadding(outputInt32.buffer) : outputInt32.buffer;
    };

    AESDecryptor.prototype.destroy = function destroy() {
      this.key = undefined;
      this.keySize = undefined;
      this.ksRows = undefined;

      this.sBox = undefined;
      this.invSBox = undefined;
      this.subMix = undefined;
      this.invSubMix = undefined;
      this.keySchedule = undefined;
      this.invKeySchedule = undefined;

      this.rcon = undefined;
    };

    return AESDecryptor;
  }();

  /* harmony default export */ var aes_decryptor = (AESDecryptor);
  // EXTERNAL MODULE: ./src/errors.js
  var errors = __webpack_require__(2);

  // EXTERNAL MODULE: ./src/utils/logger.js
  var logger = __webpack_require__(0);

  // CONCATENATED MODULE: ./src/crypt/decrypter.js
  function decrypter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








  /* globals self: false */

  var decrypter_Decrypter = function () {
    function Decrypter(observer, config) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$removePKCS7Paddi = _ref.removePKCS7Padding,
          removePKCS7Padding = _ref$removePKCS7Paddi === undefined ? true : _ref$removePKCS7Paddi;

      decrypter__classCallCheck(this, Decrypter);

      this.logEnabled = true;
      this.observer = observer;
      this.config = config;
      this.removePKCS7Padding = removePKCS7Padding;
      // built in decryptor expects PKCS7 padding
      if (removePKCS7Padding) {
        try {
          var browserCrypto = crypto || self.crypto;
          this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        } catch (e) {}
      }
      this.disableWebCrypto = !this.subtle;
    }

    Decrypter.prototype.isSync = function isSync() {
      return this.disableWebCrypto && this.config.enableSoftwareAES;
    };

    Decrypter.prototype.decrypt = function decrypt(data, key, iv, callback) {
      var _this = this;

      if (this.disableWebCrypto && this.config.enableSoftwareAES) {
        if (this.logEnabled) {
          logger["b" /* logger */].log('JS AES decrypt');
          this.logEnabled = false;
        }
        var decryptor = this.decryptor;
        if (!decryptor) this.decryptor = decryptor = new aes_decryptor();

        decryptor.expandKey(key);
        callback(decryptor.decrypt(data, 0, iv, this.removePKCS7Padding));
      } else {
        if (this.logEnabled) {
          logger["b" /* logger */].log('WebCrypto AES decrypt');
          this.logEnabled = false;
        }
        var subtle = this.subtle;
        if (this.key !== key) {
          this.key = key;
          this.fastAesKey = new fast_aes_key(subtle, key);
        }

        this.fastAesKey.expandKey().then(function (aesKey) {
          // decrypt using web crypto
          var crypto = new aes_crypto(subtle, iv);
          crypto.decrypt(data, aesKey).catch(function (err) {
            _this.onWebCryptoError(err, data, key, iv, callback);
          }).then(function (result) {
            callback(result);
          });
        }).catch(function (err) {
          _this.onWebCryptoError(err, data, key, iv, callback);
        });
      }
    };

    Decrypter.prototype.onWebCryptoError = function onWebCryptoError(err, data, key, iv, callback) {
      if (this.config.enableSoftwareAES) {
        logger["b" /* logger */].log('WebCrypto Error, disable WebCrypto API');
        this.disableWebCrypto = true;
        this.logEnabled = true;
        this.decrypt(data, key, iv, callback);
      } else {
        logger["b" /* logger */].error('decrypting error : ' + err.message);
        this.observer.trigger(Event.ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
      }
    };

    Decrypter.prototype.destroy = function destroy() {
      var decryptor = this.decryptor;
      if (decryptor) {
        decryptor.destroy();
        this.decryptor = undefined;
      }
    };

    return Decrypter;
  }();

  /* harmony default export */ var decrypter = __webpack_exports__["a"] = (decrypter_Decrypter);

  /***/ }),
  /* 6 */
  /***/ (function(module, exports) {

  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  function EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
  }
  module.exports = EventEmitter;

  // Backwards-compat with node 0.10.x
  EventEmitter.EventEmitter = EventEmitter;

  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined;

  // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.
  EventEmitter.defaultMaxListeners = 10;

  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.
  EventEmitter.prototype.setMaxListeners = function(n) {
    if (!isNumber(n) || n < 0 || isNaN(n))
      throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
  };

  EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;

    if (!this._events)
      this._events = {};

    // If there is no 'error' event listener then throw.
    if (type === 'error') {
      if (!this._events.error ||
          (isObject(this._events.error) && !this._events.error.length)) {
        er = arguments[1];
        if (er instanceof Error) {
          throw er; // Unhandled 'error' event
        } else {
          // At least give some kind of context to the user
          var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
          err.context = er;
          throw err;
        }
      }
    }

    handler = this._events[type];

    if (isUndefined(handler))
      return false;

    if (isFunction(handler)) {
      switch (arguments.length) {
        // fast cases
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this, arguments[1]);
          break;
        case 3:
          handler.call(this, arguments[1], arguments[2]);
          break;
        // slower
        default:
          args = Array.prototype.slice.call(arguments, 1);
          handler.apply(this, args);
      }
    } else if (isObject(handler)) {
      args = Array.prototype.slice.call(arguments, 1);
      listeners = handler.slice();
      len = listeners.length;
      for (i = 0; i < len; i++)
        listeners[i].apply(this, args);
    }

    return true;
  };

  EventEmitter.prototype.addListener = function(type, listener) {
    var m;

    if (!isFunction(listener))
      throw TypeError('listener must be a function');

    if (!this._events)
      this._events = {};

    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener)
      this.emit('newListener', type,
                isFunction(listener.listener) ?
                listener.listener : listener);

    if (!this._events[type])
      // Optimize the case of one listener. Don't need the extra array object.
      this._events[type] = listener;
    else if (isObject(this._events[type]))
      // If we've already got an array, just append.
      this._events[type].push(listener);
    else
      // Adding the second element, need to change to array.
      this._events[type] = [this._events[type], listener];

    // Check for listener leak
    if (isObject(this._events[type]) && !this._events[type].warned) {
      if (!isUndefined(this._maxListeners)) {
        m = this._maxListeners;
      } else {
        m = EventEmitter.defaultMaxListeners;
      }

      if (m && m > 0 && this._events[type].length > m) {
        this._events[type].warned = true;
        console.error('(node) warning: possible EventEmitter memory ' +
                      'leak detected. %d listeners added. ' +
                      'Use emitter.setMaxListeners() to increase limit.',
                      this._events[type].length);
        if (typeof console.trace === 'function') {
          // not supported in IE 10
          console.trace();
        }
      }
    }

    return this;
  };

  EventEmitter.prototype.on = EventEmitter.prototype.addListener;

  EventEmitter.prototype.once = function(type, listener) {
    if (!isFunction(listener))
      throw TypeError('listener must be a function');

    var fired = false;

    function g() {
      this.removeListener(type, g);

      if (!fired) {
        fired = true;
        listener.apply(this, arguments);
      }
    }

    g.listener = listener;
    this.on(type, g);

    return this;
  };

  // emits a 'removeListener' event iff the listener was removed
  EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;

    if (!isFunction(listener))
      throw TypeError('listener must be a function');

    if (!this._events || !this._events[type])
      return this;

    list = this._events[type];
    length = list.length;
    position = -1;

    if (list === listener ||
        (isFunction(list.listener) && list.listener === listener)) {
      delete this._events[type];
      if (this._events.removeListener)
        this.emit('removeListener', type, listener);

    } else if (isObject(list)) {
      for (i = length; i-- > 0;) {
        if (list[i] === listener ||
            (list[i].listener && list[i].listener === listener)) {
          position = i;
          break;
        }
      }

      if (position < 0)
        return this;

      if (list.length === 1) {
        list.length = 0;
        delete this._events[type];
      } else {
        list.splice(position, 1);
      }

      if (this._events.removeListener)
        this.emit('removeListener', type, listener);
    }

    return this;
  };

  EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;

    if (!this._events)
      return this;

    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
      if (arguments.length === 0)
        this._events = {};
      else if (this._events[type])
        delete this._events[type];
      return this;
    }

    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
      for (key in this._events) {
        if (key === 'removeListener') continue;
        this.removeAllListeners(key);
      }
      this.removeAllListeners('removeListener');
      this._events = {};
      return this;
    }

    listeners = this._events[type];

    if (isFunction(listeners)) {
      this.removeListener(type, listeners);
    } else if (listeners) {
      // LIFO order
      while (listeners.length)
        this.removeListener(type, listeners[listeners.length - 1]);
    }
    delete this._events[type];

    return this;
  };

  EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type])
      ret = [];
    else if (isFunction(this._events[type]))
      ret = [this._events[type]];
    else
      ret = this._events[type].slice();
    return ret;
  };

  EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
      var evlistener = this._events[type];

      if (isFunction(evlistener))
        return 1;
      else if (evlistener)
        return evlistener.length;
    }
    return 0;
  };

  EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
  };

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  function isUndefined(arg) {
    return arg === void 0;
  }


  /***/ }),
  /* 7 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(0);
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(1);
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * MP4 demuxer
   */



  var UINT32_MAX = Math.pow(2, 32) - 1;

  var MP4Demuxer = function () {
    function MP4Demuxer(observer, remuxer) {
      _classCallCheck(this, MP4Demuxer);

      this.observer = observer;
      this.remuxer = remuxer;
    }

    MP4Demuxer.prototype.resetTimeStamp = function resetTimeStamp(initPTS) {
      this.initPTS = initPTS;
    };

    MP4Demuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      // jshint unused:false
      if (initSegment && initSegment.byteLength) {
        var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);

        // default audio codec if nothing specified
        // TODO : extract that from initsegment
        if (audioCodec == null) audioCodec = 'mp4a.40.5';

        if (videoCodec == null) videoCodec = 'avc1.42e01e';

        var tracks = {};
        if (initData.audio && initData.video) {
          tracks.audiovideo = { container: 'video/mp4', codec: audioCodec + ',' + videoCodec, initSegment: duration ? initSegment : null };
        } else {
          if (initData.audio) tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: duration ? initSegment : null };

          if (initData.video) tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: duration ? initSegment : null };
        }
        this.observer.trigger(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
      } else {
        if (audioCodec) this.audioCodec = audioCodec;

        if (videoCodec) this.videoCodec = videoCodec;
      }
    };

    MP4Demuxer.probe = function probe(data) {
      // ensure we find a moof box in the first 16 kB
      return MP4Demuxer.findBox({ data: data, start: 0, end: Math.min(data.length, 16384) }, ['moof']).length > 0;
    };

    MP4Demuxer.bin2str = function bin2str(buffer) {
      return String.fromCharCode.apply(null, buffer);
    };

    MP4Demuxer.readUint16 = function readUint16(buffer, offset) {
      if (buffer.data) {
        offset += buffer.start;
        buffer = buffer.data;
      }

      var val = buffer[offset] << 8 | buffer[offset + 1];

      return val < 0 ? 65536 + val : val;
    };

    MP4Demuxer.readUint32 = function readUint32(buffer, offset) {
      if (buffer.data) {
        offset += buffer.start;
        buffer = buffer.data;
      }

      var val = buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
      return val < 0 ? 4294967296 + val : val;
    };

    MP4Demuxer.writeUint32 = function writeUint32(buffer, offset, value) {
      if (buffer.data) {
        offset += buffer.start;
        buffer = buffer.data;
      }
      buffer[offset] = value >> 24;
      buffer[offset + 1] = value >> 16 & 0xff;
      buffer[offset + 2] = value >> 8 & 0xff;
      buffer[offset + 3] = value & 0xff;
    };

    // Find the data for a box specified by its path


    MP4Demuxer.findBox = function findBox(data, path) {
      var results = [],
          i = void 0,
          size = void 0,
          type = void 0,
          end = void 0,
          subresults = void 0,
          start = void 0,
          endbox = void 0;

      if (data.data) {
        start = data.start;
        end = data.end;
        data = data.data;
      } else {
        start = 0;
        end = data.byteLength;
      }

      if (!path.length) {
        // short-circuit the search for empty paths
        return null;
      }

      for (i = start; i < end;) {
        size = MP4Demuxer.readUint32(data, i);
        type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
        endbox = size > 1 ? i + size : end;

        if (type === path[0]) {
          if (path.length === 1) {
            // this is the end of the path and we've found the box we were
            // looking for
            results.push({ data: data, start: i + 8, end: endbox });
          } else {
            // recursively search for the next box along the path
            subresults = MP4Demuxer.findBox({ data: data, start: i + 8, end: endbox }, path.slice(1));
            if (subresults.length) results = results.concat(subresults);
          }
        }
        i = endbox;
      }

      // we've finished searching all of data
      return results;
    };

    MP4Demuxer.parseSegmentIndex = function parseSegmentIndex(initSegment) {
      var moov = MP4Demuxer.findBox(initSegment, ['moov'])[0];
      var moovEndOffset = moov ? moov.end : null; // we need this in case we need to chop of garbage of the end of current data

      var index = 0;
      var sidx = MP4Demuxer.findBox(initSegment, ['sidx']);
      var references = void 0;

      if (!sidx || !sidx[0]) return null;

      references = [];
      sidx = sidx[0];

      var version = sidx.data[0];

      // set initial offset, we skip the reference ID (not needed)
      index = version === 0 ? 8 : 16;

      var timescale = MP4Demuxer.readUint32(sidx, index);
      index += 4;

      // TODO: parse earliestPresentationTime and firstOffset
      // usually zero in our case
      var earliestPresentationTime = 0;
      var firstOffset = 0;

      if (version === 0) index += 8;else index += 16;

      // skip reserved
      index += 2;

      var startByte = sidx.end + firstOffset;

      var referencesCount = MP4Demuxer.readUint16(sidx, index);
      index += 2;

      for (var i = 0; i < referencesCount; i++) {
        var referenceIndex = index;

        var referenceInfo = MP4Demuxer.readUint32(sidx, referenceIndex);
        referenceIndex += 4;

        var referenceSize = referenceInfo & 0x7FFFFFFF;
        var referenceType = (referenceInfo & 0x80000000) >>> 31;

        if (referenceType === 1) {
          console.warn('SIDX has hierarchical references (not supported)');
          return;
        }

        var subsegmentDuration = MP4Demuxer.readUint32(sidx, referenceIndex);
        referenceIndex += 4;

        references.push({
          referenceSize: referenceSize,
          subsegmentDuration: subsegmentDuration, // unscaled
          info: {
            duration: subsegmentDuration / timescale,
            start: startByte,
            end: startByte + referenceSize - 1
          }
        });

        startByte += referenceSize;

        // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
        // for |sapDelta|.
        referenceIndex += 4;

        // skip to next ref
        index = referenceIndex;
      }

      return {
        earliestPresentationTime: earliestPresentationTime,
        timescale: timescale,
        version: version,
        referencesCount: referencesCount,
        references: references,
        moovEndOffset: moovEndOffset
      };
    };

    /**
     * Parses an MP4 initialization segment and extracts stream type and
     * timescale values for any declared tracks. Timescale values indicate the
     * number of clock ticks per second to assume for time-based values
     * elsewhere in the MP4.
     *
     * To determine the start time of an MP4, you need two pieces of
     * information: the timescale unit and the earliest base media decode
     * time. Multiple timescales can be specified within an MP4 but the
     * base media decode time is always expressed in the timescale from
     * the media header box for the track:
     * ```
     * moov > trak > mdia > mdhd.timescale
     * moov > trak > mdia > hdlr
     * ```
     * @param init {Uint8Array} the bytes of the init segment
     * @return {object} a hash of track type to timescale values or null if
     * the init segment is malformed.
     */


    MP4Demuxer.parseInitSegment = function parseInitSegment(initSegment) {
      var result = [];
      var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);

      traks.forEach(function (trak) {
        var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
        if (tkhd) {
          var version = tkhd.data[tkhd.start];
          var index = version === 0 ? 12 : 20;
          var trackId = MP4Demuxer.readUint32(tkhd, index);

          var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
          if (mdhd) {
            version = mdhd.data[mdhd.start];
            index = version === 0 ? 12 : 20;
            var timescale = MP4Demuxer.readUint32(mdhd, index);

            var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
            if (hdlr) {
              var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
              var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
              if (type) {
                // extract codec info. TODO : parse codec details to be able to build MIME type
                var codecBox = MP4Demuxer.findBox(trak, ['mdia', 'minf', 'stbl', 'stsd']);
                if (codecBox.length) {
                  codecBox = codecBox[0];
                  var codecType = MP4Demuxer.bin2str(codecBox.data.subarray(codecBox.start + 12, codecBox.start + 16));
                  __WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* logger */].log('MP4Demuxer:' + type + ':' + codecType + ' found');
                }
                result[trackId] = { timescale: timescale, type: type };
                result[type] = { timescale: timescale, id: trackId };
              }
            }
          }
        }
      });
      return result;
    };

    /**
    * Determine the base media decode start time, in seconds, for an MP4
    * fragment. If multiple fragments are specified, the earliest time is
    * returned.
    *
    * The base media decode time can be parsed from track fragment
    * metadata:
    * ```
    * moof > traf > tfdt.baseMediaDecodeTime
    * ```
    * It requires the timescale value from the mdhd to interpret.
    *
    * @param timescale {object} a hash of track ids to timescale values.
    * @return {number} the earliest base media decode start time for the
    * fragment, in seconds
    */


    MP4Demuxer.getStartDTS = function getStartDTS(initData, fragment) {
      var trafs = void 0,
          baseTimes = void 0,
          result = void 0;

      // we need info from two childrend of each track fragment box
      trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);

      // determine the start times for each track
      baseTimes = [].concat.apply([], trafs.map(function (traf) {
        return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
          var id = void 0,
              scale = void 0,
              baseTime = void 0;

          // get the track id from the tfhd
          id = MP4Demuxer.readUint32(tfhd, 4);
          // assume a 90kHz clock if no timescale was specified
          scale = initData[id].timescale || 90e3;

          // get the base media decode time from the tfdt
          baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
            var version = void 0,
                result = void 0;

            version = tfdt.data[tfdt.start];
            result = MP4Demuxer.readUint32(tfdt, 4);
            if (version === 1) {
              result *= Math.pow(2, 32);

              result += MP4Demuxer.readUint32(tfdt, 8);
            }
            return result;
          })[0];
          // convert base time to seconds
          return baseTime / scale;
        });
      }));

      // return the minimum
      result = Math.min.apply(null, baseTimes);
      return isFinite(result) ? result : 0;
    };

    MP4Demuxer.offsetStartDTS = function offsetStartDTS(initData, fragment, timeOffset) {
      MP4Demuxer.findBox(fragment, ['moof', 'traf']).map(function (traf) {
        return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
          // get the track id from the tfhd
          var id = MP4Demuxer.readUint32(tfhd, 4);
          // assume a 90kHz clock if no timescale was specified
          var timescale = initData[id].timescale || 90e3;

          // get the base media decode time from the tfdt
          MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
            var version = tfdt.data[tfdt.start];
            var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
            if (version === 0) {
              MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
            } else {
              baseMediaDecodeTime *= Math.pow(2, 32);
              baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
              baseMediaDecodeTime -= timeOffset * timescale;
              baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
              var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
              var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
              MP4Demuxer.writeUint32(tfdt, 4, upper);
              MP4Demuxer.writeUint32(tfdt, 8, lower);
            }
          });
        });
      });
    };

    // feed incoming data to the front of the parsing pipeline


    MP4Demuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var initData = this.initData;
      if (!initData) {
        this.resetInitSegment(data, this.audioCodec, this.videoCodec, false);
        initData = this.initData;
      }
      var startDTS = void 0,
          initPTS = this.initPTS;
      if (initPTS === undefined) {
        var _startDTS = MP4Demuxer.getStartDTS(initData, data);
        this.initPTS = initPTS = _startDTS - timeOffset;
        this.observer.trigger(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].INIT_PTS_FOUND, { initPTS: initPTS });
      }
      MP4Demuxer.offsetStartDTS(initData, data, initPTS);
      startDTS = MP4Demuxer.getStartDTS(initData, data);
      this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
    };

    MP4Demuxer.prototype.destroy = function destroy() {};

    return MP4Demuxer;
  }();

  /* harmony default export */ __webpack_exports__["a"] = (MP4Demuxer);

  /***/ }),
  /* 8 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {

  // EXTERNAL MODULE: ./src/events.js
  var events = __webpack_require__(1);

  // EXTERNAL MODULE: ./src/errors.js
  var errors = __webpack_require__(2);

  // EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
  var crypt_decrypter = __webpack_require__(5);

  // EXTERNAL MODULE: ./src/utils/logger.js
  var logger = __webpack_require__(0);

  // CONCATENATED MODULE: ./src/demux/adts.js
  /**
   *  ADTS parser helper
   */



  function getAudioConfig(observer, data, offset, audioCodec) {
    var adtsObjectType = void 0,
        // :int
    adtsSampleingIndex = void 0,
        // :int
    adtsExtensionSampleingIndex = void 0,
        // :int
    adtsChanelConfig = void 0,
        // :int
    config = void 0,
        userAgent = navigator.userAgent.toLowerCase(),
        manifestCodec = audioCodec,
        adtsSampleingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
    adtsSampleingIndex = (data[offset + 2] & 0x3C) >>> 2;
    if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
      observer.trigger(Event.ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: true, reason: 'invalid ADTS sampling index:' + adtsSampleingIndex });
      return;
    }
    adtsChanelConfig = (data[offset + 2] & 0x01) << 2;
    // byte 3
    adtsChanelConfig |= (data[offset + 3] & 0xC0) >>> 6;
    logger["b" /* logger */].log('manifest codec:' + audioCodec + ',ADTS data:type:' + adtsObjectType + ',sampleingIndex:' + adtsSampleingIndex + '[' + adtsSampleingRates[adtsSampleingIndex] + 'Hz],channelConfig:' + adtsChanelConfig);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
      if (adtsSampleingIndex >= 6) {
        adtsObjectType = 5;
        config = new Array(4);
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
      // Android : always use AAC
    } else if (userAgent.indexOf('android') !== -1) {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSampleingIndex = adtsSampleingIndex;
    } else {
      /*  for other browsers (Chrome/Vivaldi/Opera ...)
          always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
      */
      adtsObjectType = 5;
      config = new Array(4);
      // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
      if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSampleingIndex >= 6) {
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
        // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
        if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSampleingIndex >= 6 && adtsChanelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChanelConfig === 1) {
          adtsObjectType = 2;
          config = new Array(2);
        }
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
        ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
      Audio Profile / Audio Object Type
      0: Null
      1: AAC Main
      2: AAC LC (Low Complexity)
      3: AAC SSR (Scalable Sample Rate)
      4: AAC LTP (Long Term Prediction)
      5: SBR (Spectral Band Replication)
      6: AAC Scalable
     sampling freq
      0: 96000 Hz
      1: 88200 Hz
      2: 64000 Hz
      3: 48000 Hz
      4: 44100 Hz
      5: 32000 Hz
      6: 24000 Hz
      7: 22050 Hz
      8: 16000 Hz
      9: 12000 Hz
      10: 11025 Hz
      11: 8000 Hz
      12: 7350 Hz
      13: Reserved
      14: Reserved
      15: frequency is written explictly
      Channel Configurations
      These are the channel configurations:
      0: Defined in AOT Specifc Config
      1: 1 channel: front-center
      2: 2 channels: front-left, front-right
    */
    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
    config[1] |= (adtsSampleingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChanelConfig << 3;
    if (adtsObjectType === 5) {
      // adtsExtensionSampleingIndex
      config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
      config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
      // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
      //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
      config[2] |= 2 << 2;
      config[3] = 0;
    }
    return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: 'mp4a.40.' + adtsObjectType, manifestCodec: manifestCodec };
  }

  function isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
  }

  function getHeaderLength(data, offset) {
    return data[offset + 1] & 0x01 ? 7 : 9;
  }

  function getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
  }

  function isHeader(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) return true;

    return false;
  }

  function adts_probe(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
      // ADTS header Length
      var headerLength = getHeaderLength(data, offset);
      // ADTS frame Length
      var frameLength = headerLength;
      if (offset + 5 < data.length) frameLength = getFullFrameLength(data, offset);

      var newOffset = offset + frameLength;
      if (newOffset === data.length || newOffset + 1 < data.length && isHeaderPattern(data, newOffset)) return true;
    }
    return false;
  }

  function initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
      var config = getAudioConfig(observer, data, offset, audioCodec);
      track.config = config.config;
      track.samplerate = config.samplerate;
      track.channelCount = config.channelCount;
      track.codec = config.codec;
      track.manifestCodec = config.manifestCodec;
      logger["b" /* logger */].log('parsed codec:' + track.codec + ',rate:' + config.samplerate + ',nb channel:' + config.channelCount);
    }
  }

  function getFrameDuration(samplerate) {
    return 1024 * 90000 / samplerate;
  }

  function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
    var headerLength = void 0,
        frameLength = void 0,
        stamp = void 0;
    var length = data.length;

    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    headerLength = getHeaderLength(data, offset);
    // retrieve frame size
    frameLength = getFullFrameLength(data, offset);
    frameLength -= headerLength;

    if (frameLength > 0 && offset + headerLength + frameLength <= length) {
      stamp = pts + frameIndex * frameDuration;
      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
      return { headerLength: headerLength, frameLength: frameLength, stamp: stamp };
    }

    return undefined;
  }

  function appendFrame(track, data, offset, pts, frameIndex) {
    var frameDuration = getFrameDuration(track.samplerate);
    var header = parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
    if (header) {
      var stamp = header.stamp;
      var headerLength = header.headerLength;
      var frameLength = header.frameLength;

      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
      var aacSample = {
        unit: data.subarray(offset + headerLength, offset + headerLength + frameLength),
        pts: stamp,
        dts: stamp
      };

      track.samples.push(aacSample);
      track.len += frameLength;

      return { sample: aacSample, length: frameLength + headerLength };
    }

    return undefined;
  }
  // EXTERNAL MODULE: ./src/demux/id3.js
  var id3 = __webpack_require__(4);

  // CONCATENATED MODULE: ./src/demux/aacdemuxer.js
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * AAC demuxer
   */




  var aacdemuxer_AACDemuxer = function () {
    function AACDemuxer(observer, remuxer, config) {
      _classCallCheck(this, AACDemuxer);

      this.observer = observer;
      this.config = config;
      this.remuxer = remuxer;
    }

    AACDemuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/adts', type: 'audio', id: 0, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };

    AACDemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};

    AACDemuxer.probe = function probe(data) {
      if (!data) return false;

      // Check for the ADTS sync word
      // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
      // Layer bits (position 14 and 15) in header should be always 0 for ADTS
      // More info https://wiki.multimedia.cx/index.php?title=ADTS
      var id3Data = id3["a" /* default */].getID3Data(data, 0) || [];
      var offset = id3Data.length;

      for (var length = data.length; offset < length; offset++) {
        if (adts_probe(data, offset)) {
          logger["b" /* logger */].log('ADTS sync word found !');
          return true;
        }
      }
      return false;
    };

    // feed incoming data to the front of the parsing pipeline


    AACDemuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var track = this._audioTrack;
      var id3Data = id3["a" /* default */].getID3Data(data, 0) || [];
      var timestamp = id3["a" /* default */].getTimeStamp(id3Data);
      var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
      var frameIndex = 0;
      var stamp = pts;
      var length = data.length;
      var offset = id3Data.length;

      var id3Samples = [{ pts: stamp, dts: stamp, data: id3Data }];

      while (offset < length - 1) {
        if (isHeader(data, offset) && offset + 5 < length) {
          initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
          var frame = appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            logger["b" /* logger */].log('Unable to parse AAC frame');
            break;
          }
        } else if (id3["a" /* default */].isHeader(data, offset)) {
          id3Data = id3["a" /* default */].getID3Data(data, offset);
          id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
          offset += id3Data.length;
        } else {
          // nothing found, keep looking
          offset++;
        }
      }

      this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };

    AACDemuxer.prototype.destroy = function destroy() {};

    return AACDemuxer;
  }();

  /* harmony default export */ var aacdemuxer = (aacdemuxer_AACDemuxer);
  // EXTERNAL MODULE: ./src/demux/mp4demuxer.js
  var mp4demuxer = __webpack_require__(7);

  // CONCATENATED MODULE: ./src/demux/mpegaudio.js
  /**
   *  MPEG parser helper
   */

  var MpegAudio = {

    BitratesMap: [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],

    SamplingRateMap: [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000],

    SamplesCoefficients: [
    // MPEG 2.5
    [0, // Reserved
    72, // Layer3
    144, // Layer2
    12 // Layer1
    ],
    // Reserved
    [0, // Reserved
    0, // Layer3
    0, // Layer2
    0 // Layer1
    ],
    // MPEG 2
    [0, // Reserved
    72, // Layer3
    144, // Layer2
    12 // Layer1
    ],
    // MPEG 1
    [0, // Reserved
    144, // Layer3
    144, // Layer2
    12 // Layer1
    ]],

    BytesInSlot: [0, // Reserved
    1, // Layer3
    1, // Layer2
    4 // Layer1
    ],

    appendFrame: function appendFrame(track, data, offset, pts, frameIndex) {
      // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
      if (offset + 24 > data.length) return undefined;

      var header = this.parseHeader(data, offset);
      if (header && offset + header.frameLength <= data.length) {
        var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
        var stamp = pts + frameIndex * frameDuration;
        var sample = { unit: data.subarray(offset, offset + header.frameLength), pts: stamp, dts: stamp };

        track.config = [];
        track.channelCount = header.channelCount;
        track.samplerate = header.sampleRate;
        track.samples.push(sample);
        track.len += header.frameLength;

        return { sample: sample, length: header.frameLength };
      }

      return undefined;
    },

    parseHeader: function parseHeader(data, offset) {
      var headerB = data[offset + 1] >> 3 & 3;
      var headerC = data[offset + 1] >> 1 & 3;
      var headerE = data[offset + 2] >> 4 & 15;
      var headerF = data[offset + 2] >> 2 & 3;
      var headerG = data[offset + 2] >> 1 & 1;
      if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
        var columnInBitrates = headerB === 3 ? 3 - headerC : headerC === 3 ? 3 : 4;
        var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
        var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
        var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
        var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
        var sampleCoefficient = MpegAudio.SamplesCoefficients[headerB][headerC];
        var bytesInSlot = MpegAudio.BytesInSlot[headerC];
        var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
        var frameLength = parseInt(sampleCoefficient * bitRate / sampleRate + headerG, 10) * bytesInSlot;

        return { sampleRate: sampleRate, channelCount: channelCount, frameLength: frameLength, samplesPerFrame: samplesPerFrame };
      }

      return undefined;
    },

    isHeaderPattern: function isHeaderPattern(data, offset) {
      return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
    },

    isHeader: function isHeader(data, offset) {
      // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
      // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
      // More info http://www.mp3-tech.org/programmer/frame_header.html
      if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) return true;

      return false;
    },

    probe: function probe(data, offset) {
      // same as isHeader but we also check that MPEG frame follows last MPEG frame
      // or end of data is reached
      if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
        // MPEG header Length
        var headerLength = 4;
        // MPEG frame Length
        var header = this.parseHeader(data, offset);
        var frameLength = headerLength;
        if (header && header.frameLength) frameLength = header.frameLength;

        var newOffset = offset + frameLength;
        if (newOffset === data.length || newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset)) return true;
      }
      return false;
    }
  };

  /* harmony default export */ var mpegaudio = (MpegAudio);
  // CONCATENATED MODULE: ./src/demux/exp-golomb.js
  function exp_golomb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
  */



  var exp_golomb_ExpGolomb = function () {
    function ExpGolomb(data) {
      exp_golomb__classCallCheck(this, ExpGolomb);

      this.data = data;
      // the number of bytes left to examine in this.data
      this.bytesAvailable = data.byteLength;
      // the current word being examined
      this.word = 0; // :uint
      // the number of bits left to examine in the current word
      this.bitsAvailable = 0; // :uint
    }

    // ():void


    ExpGolomb.prototype.loadWord = function loadWord() {
      var data = this.data,
          bytesAvailable = this.bytesAvailable,
          position = data.byteLength - bytesAvailable,
          workingBytes = new Uint8Array(4),
          availableBytes = Math.min(4, bytesAvailable);
      if (availableBytes === 0) throw new Error('no bytes available');

      workingBytes.set(data.subarray(position, position + availableBytes));
      this.word = new DataView(workingBytes.buffer).getUint32(0);
      // track the amount of this.data that has been processed
      this.bitsAvailable = availableBytes * 8;
      this.bytesAvailable -= availableBytes;
    };

    // (count:int):void


    ExpGolomb.prototype.skipBits = function skipBits(count) {
      var skipBytes = void 0; // :int
      if (this.bitsAvailable > count) {
        this.word <<= count;
        this.bitsAvailable -= count;
      } else {
        count -= this.bitsAvailable;
        skipBytes = count >> 3;
        count -= skipBytes >> 3;
        this.bytesAvailable -= skipBytes;
        this.loadWord();
        this.word <<= count;
        this.bitsAvailable -= count;
      }
    };

    // (size:int):uint


    ExpGolomb.prototype.readBits = function readBits(size) {
      var bits = Math.min(this.bitsAvailable, size),
          // :uint
      valu = this.word >>> 32 - bits; // :uint
      if (size > 32) logger["b" /* logger */].error('Cannot read more than 32 bits at a time');

      this.bitsAvailable -= bits;
      if (this.bitsAvailable > 0) this.word <<= bits;else if (this.bytesAvailable > 0) this.loadWord();

      bits = size - bits;
      if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);else return valu;
    };

    // ():uint


    ExpGolomb.prototype.skipLZ = function skipLZ() {
      var leadingZeroCount = void 0; // :uint
      for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
        if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
          // the first bit of working word is 1
          this.word <<= leadingZeroCount;
          this.bitsAvailable -= leadingZeroCount;
          return leadingZeroCount;
        }
      }
      // we exhausted word and still have not found a 1
      this.loadWord();
      return leadingZeroCount + this.skipLZ();
    };

    // ():void


    ExpGolomb.prototype.skipUEG = function skipUEG() {
      this.skipBits(1 + this.skipLZ());
    };

    // ():void


    ExpGolomb.prototype.skipEG = function skipEG() {
      this.skipBits(1 + this.skipLZ());
    };

    // ():uint


    ExpGolomb.prototype.readUEG = function readUEG() {
      var clz = this.skipLZ(); // :uint
      return this.readBits(clz + 1) - 1;
    };

    // ():int


    ExpGolomb.prototype.readEG = function readEG() {
      var valu = this.readUEG(); // :int
      if (0x01 & valu) {
        // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
      } else {
        return -1 * (valu >>> 1); // divide by two then make it negative
      }
    };

    // Some convenience functions
    // :Boolean


    ExpGolomb.prototype.readBoolean = function readBoolean() {
      return this.readBits(1) === 1;
    };

    // ():int


    ExpGolomb.prototype.readUByte = function readUByte() {
      return this.readBits(8);
    };

    // ():int


    ExpGolomb.prototype.readUShort = function readUShort() {
      return this.readBits(16);
    };
    // ():int


    ExpGolomb.prototype.readUInt = function readUInt() {
      return this.readBits(32);
    };

    /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */


    ExpGolomb.prototype.skipScalingList = function skipScalingList(count) {
      var lastScale = 8,
          nextScale = 8,
          j = void 0,
          deltaScale = void 0;
      for (j = 0; j < count; j++) {
        if (nextScale !== 0) {
          deltaScale = this.readEG();
          nextScale = (lastScale + deltaScale + 256) % 256;
        }
        lastScale = nextScale === 0 ? lastScale : nextScale;
      }
    };

    /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */


    ExpGolomb.prototype.readSPS = function readSPS() {
      var frameCropLeftOffset = 0,
          frameCropRightOffset = 0,
          frameCropTopOffset = 0,
          frameCropBottomOffset = 0,
          profileIdc = void 0,
          profileCompat = void 0,
          levelIdc = void 0,
          numRefFramesInPicOrderCntCycle = void 0,
          picWidthInMbsMinus1 = void 0,
          picHeightInMapUnitsMinus1 = void 0,
          frameMbsOnlyFlag = void 0,
          scalingListCount = void 0,
          i = void 0,
          readUByte = this.readUByte.bind(this),
          readBits = this.readBits.bind(this),
          readUEG = this.readUEG.bind(this),
          readBoolean = this.readBoolean.bind(this),
          skipBits = this.skipBits.bind(this),
          skipEG = this.skipEG.bind(this),
          skipUEG = this.skipUEG.bind(this),
          skipScalingList = this.skipScalingList.bind(this);

      readUByte();
      profileIdc = readUByte(); // profile_idc
      profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
      skipBits(3); // reserved_zero_3bits u(3),
      levelIdc = readUByte(); // level_idc u(8)
      skipUEG(); // seq_parameter_set_id
      // some profiles have more optional data we don't need
      if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
        var chromaFormatIdc = readUEG();
        if (chromaFormatIdc === 3) skipBits(1); // separate_colour_plane_flag

        skipUEG(); // bit_depth_luma_minus8
        skipUEG(); // bit_depth_chroma_minus8
        skipBits(1); // qpprime_y_zero_transform_bypass_flag
        if (readBoolean()) {
          // seq_scaling_matrix_present_flag
          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
          for (i = 0; i < scalingListCount; i++) {
            if (readBoolean()) {
              // seq_scaling_list_present_flag[ i ]
              if (i < 6) skipScalingList(16);else skipScalingList(64);
            }
          }
        }
      }
      skipUEG(); // log2_max_frame_num_minus4
      var picOrderCntType = readUEG();
      if (picOrderCntType === 0) {
        readUEG(); // log2_max_pic_order_cnt_lsb_minus4
      } else if (picOrderCntType === 1) {
        skipBits(1); // delta_pic_order_always_zero_flag
        skipEG(); // offset_for_non_ref_pic
        skipEG(); // offset_for_top_to_bottom_field
        numRefFramesInPicOrderCntCycle = readUEG();
        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
          skipEG();
        } // offset_for_ref_frame[ i ]
      }
      skipUEG(); // max_num_ref_frames
      skipBits(1); // gaps_in_frame_num_value_allowed_flag
      picWidthInMbsMinus1 = readUEG();
      picHeightInMapUnitsMinus1 = readUEG();
      frameMbsOnlyFlag = readBits(1);
      if (frameMbsOnlyFlag === 0) skipBits(1); // mb_adaptive_frame_field_flag

      skipBits(1); // direct_8x8_inference_flag
      if (readBoolean()) {
        // frame_cropping_flag
        frameCropLeftOffset = readUEG();
        frameCropRightOffset = readUEG();
        frameCropTopOffset = readUEG();
        frameCropBottomOffset = readUEG();
      }
      var pixelRatio = [1, 1];
      if (readBoolean()) {
        // vui_parameters_present_flag
        if (readBoolean()) {
          // aspect_ratio_info_present_flag
          var aspectRatioIdc = readUByte();
          switch (aspectRatioIdc) {
            case 1:
              pixelRatio = [1, 1];break;
            case 2:
              pixelRatio = [12, 11];break;
            case 3:
              pixelRatio = [10, 11];break;
            case 4:
              pixelRatio = [16, 11];break;
            case 5:
              pixelRatio = [40, 33];break;
            case 6:
              pixelRatio = [24, 11];break;
            case 7:
              pixelRatio = [20, 11];break;
            case 8:
              pixelRatio = [32, 11];break;
            case 9:
              pixelRatio = [80, 33];break;
            case 10:
              pixelRatio = [18, 11];break;
            case 11:
              pixelRatio = [15, 11];break;
            case 12:
              pixelRatio = [64, 33];break;
            case 13:
              pixelRatio = [160, 99];break;
            case 14:
              pixelRatio = [4, 3];break;
            case 15:
              pixelRatio = [3, 2];break;
            case 16:
              pixelRatio = [2, 1];break;
            case 255:
              {
                pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                break;
              }
          }
        }
      }
      return {
        width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
        pixelRatio: pixelRatio
      };
    };

    ExpGolomb.prototype.readSliceType = function readSliceType() {
      // skip NALu type
      this.readUByte();
      // discard first_mb_in_slice
      this.readUEG();
      // return slice_type
      return this.readUEG();
    };

    return ExpGolomb;
  }();

  /* harmony default export */ var exp_golomb = (exp_golomb_ExpGolomb);
  // CONCATENATED MODULE: ./src/demux/sample-aes.js
  function sample_aes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * SAMPLE-AES decrypter
  */



  var sample_aes_SampleAesDecrypter = function () {
    function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
      sample_aes__classCallCheck(this, SampleAesDecrypter);

      this.decryptdata = decryptdata;
      this.discardEPB = discardEPB;
      this.decrypter = new crypt_decrypter["a" /* default */](observer, config, { removePKCS7Padding: false });
    }

    SampleAesDecrypter.prototype.decryptBuffer = function decryptBuffer(encryptedData, callback) {
      this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
    };

    // AAC - encrypt all full 16 bytes blocks starting from offset 16


    SampleAesDecrypter.prototype.decryptAacSample = function decryptAacSample(samples, sampleIndex, callback, sync) {
      var curUnit = samples[sampleIndex].unit;
      var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
      var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);

      var localthis = this;
      this.decryptBuffer(encryptedBuffer, function (decryptedData) {
        decryptedData = new Uint8Array(decryptedData);
        curUnit.set(decryptedData, 16);

        if (!sync) localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
      });
    };

    SampleAesDecrypter.prototype.decryptAacSamples = function decryptAacSamples(samples, sampleIndex, callback) {
      for (;; sampleIndex++) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        if (samples[sampleIndex].unit.length < 32) continue;

        var sync = this.decrypter.isSync();

        this.decryptAacSample(samples, sampleIndex, callback, sync);

        if (!sync) return;
      }
    };

    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32


    SampleAesDecrypter.prototype.getAvcEncryptedData = function getAvcEncryptedData(decodedData) {
      var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
      var encryptedData = new Int8Array(encryptedDataLen);
      var outputPos = 0;
      for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
        encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
      }return encryptedData;
    };

    SampleAesDecrypter.prototype.getAvcDecryptedUnit = function getAvcDecryptedUnit(decodedData, decryptedData) {
      decryptedData = new Uint8Array(decryptedData);
      var inputPos = 0;
      for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
        decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
      }return decodedData;
    };

    SampleAesDecrypter.prototype.decryptAvcSample = function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
      var decodedData = this.discardEPB(curUnit.data);
      var encryptedData = this.getAvcEncryptedData(decodedData);
      var localthis = this;

      this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
        curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);

        if (!sync) localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
      });
    };

    SampleAesDecrypter.prototype.decryptAvcSamples = function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
      for (;; sampleIndex++, unitIndex = 0) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        var curUnits = samples[sampleIndex].units;
        for (;; unitIndex++) {
          if (unitIndex >= curUnits.length) break;

          var curUnit = curUnits[unitIndex];
          if (curUnit.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;

          var sync = this.decrypter.isSync();

          this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);

          if (!sync) return;
        }
      }
    };

    return SampleAesDecrypter;
  }();

  /* harmony default export */ var sample_aes = (sample_aes_SampleAesDecrypter);
  // CONCATENATED MODULE: ./src/demux/tsdemuxer.js
  function tsdemuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * highly optimized TS demuxer:
   * parse PAT, PMT
   * extract PES packet from audio and video PIDs
   * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
   * trigger the remuxer upon parsing completion
   * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
   * it also controls the remuxing process :
   * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
  */






  // import Hex from '../utils/hex';



  // We are using fixed track IDs for driving the MP4 remuxer
  // instead of following the TS PIDs.
  // There is no reason not to do this and some browsers/SourceBuffer-demuxers
  // may not like if there are TrackID "switches"
  // See https://github.com/video-dev/hls.js/issues/1331
  // Here we are mapping our internal track types to constant MP4 track IDs
  // With MSE currently one can only have one track of each, and we are muxing
  // whatever video/audio rendition in them.
  var RemuxerTrackIdConfig = {
    video: 0,
    audio: 1,
    id3: 2,
    text: 3
  };

  var tsdemuxer_TSDemuxer = function () {
    function TSDemuxer(observer, remuxer, config, typeSupported) {
      tsdemuxer__classCallCheck(this, TSDemuxer);

      this.observer = observer;
      this.config = config;
      this.typeSupported = typeSupported;
      this.remuxer = remuxer;
      this.sampleAes = null;
    }

    TSDemuxer.prototype.setDecryptData = function setDecryptData(decryptdata) {
      if (decryptdata != null && decryptdata.key != null && decryptdata.method === 'SAMPLE-AES') this.sampleAes = new sample_aes(this.observer, this.config, decryptdata, this.discardEPB);else this.sampleAes = null;
    };

    TSDemuxer.probe = function probe(data) {
      var syncOffset = TSDemuxer._syncOffset(data);
      if (syncOffset < 0) {
        return false;
      } else {
        if (syncOffset) logger["b" /* logger */].warn('MPEG2-TS detected but first sync word found @ offset ' + syncOffset + ', junk ahead ?');

        return true;
      }
    };

    TSDemuxer._syncOffset = function _syncOffset(data) {
      // scan 1000 first bytes
      var scanwindow = Math.min(1000, data.length - 3 * 188);
      var i = 0;
      while (i < scanwindow) {
        // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
        if (data[i] === 0x47 && data[i + 188] === 0x47 && data[i + 2 * 188] === 0x47) return i;else i++;
      }
      return -1;
    };

    /**
     * Creates a track model internal to demuxer used to drive remuxing input
     *
     * @param {string} type 'audio' | 'video' | 'id3' | 'text'
     * @param {number} duration
     * @return {object} TSDemuxer's internal track model
     */


    TSDemuxer.createTrack = function createTrack(type, duration) {
      return {
        container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
        type: type,
        id: RemuxerTrackIdConfig[type],
        pid: -1,
        inputTimeScale: 90000,
        sequenceNumber: 0,
        samples: [],
        len: 0,
        dropped: type === 'video' ? 0 : undefined,
        isAAC: type === 'audio' ? true : undefined,
        duration: type === 'audio' ? duration : undefined
      };
    };

    /**
     * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
     * Resets all internal track instances of the demuxer.
     *
     * @override Implements generic demuxing/remuxing interface (see DemuxerInline)
     * @param {object} initSegment
     * @param {string} audioCodec
     * @param {string} videoCodec
     * @param {number} duration (in TS timescale = 90kHz)
     */


    TSDemuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this.pmtParsed = false;
      this._pmtId = -1;

      this._avcTrack = TSDemuxer.createTrack('video', duration);
      this._audioTrack = TSDemuxer.createTrack('audio', duration);
      this._id3Track = TSDemuxer.createTrack('id3', duration);
      this._txtTrack = TSDemuxer.createTrack('text', duration);

      // flush any partial content
      this.aacOverFlow = null;
      this.aacLastPTS = null;
      this.avcSample = null;
      this.audioCodec = audioCodec;
      this.videoCodec = videoCodec;
      this._duration = duration;
    };

    /**
     *
     * @override
     */


    TSDemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};

    // feed incoming data to the front of the parsing pipeline


    TSDemuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var start = void 0,
          len = data.length,
          stt = void 0,
          pid = void 0,
          atf = void 0,
          offset = void 0,
          pes = void 0,
          unknownPIDs = false;
      this.contiguous = contiguous;
      var pmtParsed = this.pmtParsed,
          avcTrack = this._avcTrack,
          audioTrack = this._audioTrack,
          id3Track = this._id3Track,
          avcId = avcTrack.pid,
          audioId = audioTrack.pid,
          id3Id = id3Track.pid,
          pmtId = this._pmtId,
          avcData = avcTrack.pesData,
          audioData = audioTrack.pesData,
          id3Data = id3Track.pesData,
          parsePAT = this._parsePAT,
          parsePMT = this._parsePMT,
          parsePES = this._parsePES,
          parseAVCPES = this._parseAVCPES.bind(this),
          parseAACPES = this._parseAACPES.bind(this),
          parseMPEGPES = this._parseMPEGPES.bind(this),
          parseID3PES = this._parseID3PES.bind(this);

      var syncOffset = TSDemuxer._syncOffset(data);

      // don't parse last TS packet if incomplete
      len -= (len + syncOffset) % 188;

      // loop through TS packets
      for (start = syncOffset; start < len; start += 188) {
        if (data[start] === 0x47) {
          stt = !!(data[start + 1] & 0x40);
          // pid is a 13-bit field starting at the last bit of TS[1]
          pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
          atf = (data[start + 3] & 0x30) >> 4;
          // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
          if (atf > 1) {
            offset = start + 5 + data[start + 4];
            // continue if there is only adaptation field
            if (offset === start + 188) continue;
          } else {
            offset = start + 4;
          }
          switch (pid) {
            case avcId:
              if (stt) {
                if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) parseAVCPES(pes, false);

                avcData = { data: [], size: 0 };
              }
              if (avcData) {
                avcData.data.push(data.subarray(offset, start + 188));
                avcData.size += start + 188 - offset;
              }
              break;
            case audioId:
              if (stt) {
                if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
                  if (audioTrack.isAAC) parseAACPES(pes);else parseMPEGPES(pes);
                }
                audioData = { data: [], size: 0 };
              }
              if (audioData) {
                audioData.data.push(data.subarray(offset, start + 188));
                audioData.size += start + 188 - offset;
              }
              break;
            case id3Id:
              if (stt) {
                if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) parseID3PES(pes);

                id3Data = { data: [], size: 0 };
              }
              if (id3Data) {
                id3Data.data.push(data.subarray(offset, start + 188));
                id3Data.size += start + 188 - offset;
              }
              break;
            case 0:
              if (stt) offset += data[offset] + 1;

              pmtId = this._pmtId = parsePAT(data, offset);
              break;
            case pmtId:
              if (stt) offset += data[offset] + 1;

              var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              // NOTE this is only the PID of the track as found in TS,
              // but we are not using this for MP4 track IDs.
              avcId = parsedPIDs.avc;
              if (avcId > 0) avcTrack.pid = avcId;

              audioId = parsedPIDs.audio;
              if (audioId > 0) {
                audioTrack.pid = audioId;
                audioTrack.isAAC = parsedPIDs.isAAC;
              }
              id3Id = parsedPIDs.id3;
              if (id3Id > 0) id3Track.pid = id3Id;

              if (unknownPIDs && !pmtParsed) {
                logger["b" /* logger */].log('reparse from beginning');
                unknownPIDs = false;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = syncOffset - 188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            case 17:
            case 0x1fff:
              break;
            default:
              unknownPIDs = true;
              break;
          }
        } else {
          this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
        }
      }
      // try to parse last PES packets
      if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) {
        parseAVCPES(pes, true);
        avcTrack.pesData = null;
      } else {
        // either avcData null or PES truncated, keep it for next frag parsing
        avcTrack.pesData = avcData;
      }

      if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
        if (audioTrack.isAAC) parseAACPES(pes);else parseMPEGPES(pes);

        audioTrack.pesData = null;
      } else {
        if (audioData && audioData.size) logger["b" /* logger */].log('last AAC PES packet truncated,might overlap between fragments');

        // either audioData null or PES truncated, keep it for next frag parsing
        audioTrack.pesData = audioData;
      }

      if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) {
        parseID3PES(pes);
        id3Track.pesData = null;
      } else {
        // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
      }

      if (this.sampleAes == null) this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);else this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
    };

    TSDemuxer.prototype.decryptAndRemux = function decryptAndRemux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (audioTrack.samples && audioTrack.isAAC) {
        var localthis = this;
        this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
          localthis.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    };

    TSDemuxer.prototype.decryptAndRemuxAvc = function decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (videoTrack.samples) {
        var localthis = this;
        this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
          localthis.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    };

    TSDemuxer.prototype.destroy = function destroy() {
      this._initPTS = this._initDTS = undefined;
      this._duration = 0;
    };

    TSDemuxer.prototype._parsePAT = function _parsePAT(data, offset) {
      // skip the PSI header and parse the first PMT entry
      return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
      // logger.log('PMT PID:'  + this._pmtId);
    };

    TSDemuxer.prototype._parsePMT = function _parsePMT(data, offset, mpegSupported, isSampleAes) {
      var sectionLength = void 0,
          tableEnd = void 0,
          programInfoLength = void 0,
          pid = void 0,
          result = { audio: -1, avc: -1, id3: -1, isAAC: true };
      sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
      tableEnd = offset + 3 + sectionLength - 4;
      // to determine where the table is, we have to figure out how
      // long the program info descriptors are
      programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
      // advance the offset to the first entry in the mapping table
      offset += 12 + programInfoLength;
      while (offset < tableEnd) {
        pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
        switch (data[offset]) {
          case 0xcf:
            // SAMPLE-AES AAC
            if (!isSampleAes) {
              logger["b" /* logger */].log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
          case 0x0f:
            // logger.log('AAC PID:'  + pid);
            if (result.audio === -1) result.audio = pid;

            break;

          // Packetized metadata (ID3)
          case 0x15:
            // logger.log('ID3 PID:'  + pid);
            if (result.id3 === -1) result.id3 = pid;

            break;

          case 0xdb:
            // SAMPLE-AES AVC
            if (!isSampleAes) {
              logger["b" /* logger */].log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
          case 0x1b:
            // logger.log('AVC PID:'  + pid);
            if (result.avc === -1) result.avc = pid;

            break;

          // ISO/IEC 11172-3 (MPEG-1 audio)
          // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
          case 0x03:
          case 0x04:
            // logger.log('MPEG PID:'  + pid);
            if (!mpegSupported) {
              logger["b" /* logger */].log('MPEG audio found, not supported in this browser for now');
            } else if (result.audio === -1) {
              result.audio = pid;
              result.isAAC = false;
            }
            break;

          case 0x24:
            logger["b" /* logger */].warn('HEVC stream type found, not supported for now');
            break;

          default:
            logger["b" /* logger */].log('unkown stream type:' + data[offset]);
            break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
      }
      return result;
    };

    TSDemuxer.prototype._parsePES = function _parsePES(stream) {
      var i = 0,
          frag = void 0,
          pesFlags = void 0,
          pesPrefix = void 0,
          pesLen = void 0,
          pesHdrLen = void 0,
          pesData = void 0,
          pesPts = void 0,
          pesDts = void 0,
          payloadStartOffset = void 0,
          data = stream.data;
      // safety check
      if (!stream || stream.size === 0) return null;

      // we might need up to 19 bytes to read PES header
      // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
      // usually only one merge is needed (and this is rare ...)
      while (data[0].length < 19 && data.length > 1) {
        var newData = new Uint8Array(data[0].length + data[1].length);
        newData.set(data[0]);
        newData.set(data[1], data[0].length);
        data[0] = newData;
        data.splice(1, 1);
      }
      // retrieve PTS/DTS from first fragment
      frag = data[0];
      pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
      if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) return null;

        pesFlags = frag[7];
        if (pesFlags & 0xC0) {
          /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
              as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
              as Bitwise operators treat their operands as a sequence of 32 bits */
          pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
          (frag[10] & 0xFF) * 4194304 + // 1 << 22
          (frag[11] & 0xFE) * 16384 + // 1 << 14
          (frag[12] & 0xFF) * 128 + // 1 << 7
          (frag[13] & 0xFE) / 2;
          // check if greater than 2^32 -1
          if (pesPts > 4294967295) {
            // decrement 2^33
            pesPts -= 8589934592;
          }
          if (pesFlags & 0x40) {
            pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
            (frag[15] & 0xFF) * 4194304 + // 1 << 22
            (frag[16] & 0xFE) * 16384 + // 1 << 14
            (frag[17] & 0xFF) * 128 + // 1 << 7
            (frag[18] & 0xFE) / 2;
            // check if greater than 2^32 -1
            if (pesDts > 4294967295) {
              // decrement 2^33
              pesDts -= 8589934592;
            }
            if (pesPts - pesDts > 60 * 90000) {
              logger["b" /* logger */].warn(Math.round((pesPts - pesDts) / 90000) + 's delta between PTS and DTS, align them');
              pesPts = pesDts;
            }
          } else {
            pesDts = pesPts;
          }
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        payloadStartOffset = pesHdrLen + 9;

        stream.size -= payloadStartOffset;
        // reassemble PES packet
        pesData = new Uint8Array(stream.size);
        for (var j = 0, dataLen = data.length; j < dataLen; j++) {
          frag = data[j];
          var len = frag.byteLength;
          if (payloadStartOffset) {
            if (payloadStartOffset > len) {
              // trim full frag if PES header bigger than frag
              payloadStartOffset -= len;
              continue;
            } else {
              // trim partial frag if PES header smaller than frag
              frag = frag.subarray(payloadStartOffset);
              len -= payloadStartOffset;
              payloadStartOffset = 0;
            }
          }
          pesData.set(frag, i);
          i += len;
        }
        if (pesLen) {
          // payload size : remove PES header + PES extension
          pesLen -= pesHdrLen + 3;
        }
        return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
      } else {
        return null;
      }
    };

    TSDemuxer.prototype.pushAccesUnit = function pushAccesUnit(avcSample, avcTrack) {
      if (avcSample.units.length && avcSample.frame) {
        var samples = avcTrack.samples;
        var nbSamples = samples.length;
        // only push AVC sample if starting with a keyframe is not mandatory OR
        //    if keyframe already found in this fragment OR
        //       keyframe found in last fragment (track.sps) AND
        //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
        if (!this.config.forceKeyFrameOnDiscontinuity || avcSample.key === true || avcTrack.sps && (nbSamples || this.contiguous)) {
          avcSample.id = nbSamples;
          samples.push(avcSample);
        } else {
          // dropped samples, track it
          avcTrack.dropped++;
        }
      }
      if (avcSample.debug.length) logger["b" /* logger */].log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
    };

    TSDemuxer.prototype._parseAVCPES = function _parseAVCPES(pes, last) {
      var _this = this;

      // logger.log('parse new PES');
      var track = this._avcTrack,
          units = this._parseAVCNALu(pes.data),
          expGolombDecoder = void 0,
          avcSample = this.avcSample,
          push = void 0,
          spsfound = false,
          i = void 0,
          pushAccesUnit = this.pushAccesUnit.bind(this),
          createAVCSample = function createAVCSample(key, pts, dts, debug) {
        return { key: key, pts: pts, dts: dts, units: [], debug: debug };
      };
      // free pes.data to save up some memory
      pes.data = null;

      // if new NAL units found and last sample still there, let's push ...
      // this helps parsing streams with missing AUD (only do this if AUD never found)
      if (avcSample && units.length && !track.audFound) {
        pushAccesUnit(avcSample, track);
        avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
      }

      units.forEach(function (unit) {
        switch (unit.type) {
          // NDR
          case 1:
            push = true;
            if (!avcSample) avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');

            avcSample.frame = true;
            var data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              var sliceType = new exp_golomb(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              // if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) avcSample.key = true;
            }
            break;
          // IDR
          case 5:
            push = true;
            // handle PES not starting with AUD
            if (!avcSample) avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');

            avcSample.key = true;
            avcSample.frame = true;
            break;
          // SEI
          case 6:
            push = true;

            expGolombDecoder = new exp_golomb(_this.discardEPB(unit.data));

            // skip frameType
            expGolombDecoder.readUByte();

            var payloadType = 0;
            var payloadSize = 0;
            var endOfCaptions = false;
            var b = 0;

            while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
              payloadType = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadType += b;
              } while (b === 0xFF);

              // Parse payload size.
              payloadSize = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadSize += b;
              } while (b === 0xFF);

              // TODO: there can be more than one payload in an SEI packet...
              // TODO: need to read type and size in a while loop to get them all
              if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {
                endOfCaptions = true;

                var countryCode = expGolombDecoder.readUByte();

                if (countryCode === 181) {
                  var providerCode = expGolombDecoder.readUShort();

                  if (providerCode === 49) {
                    var userStructure = expGolombDecoder.readUInt();

                    if (userStructure === 0x47413934) {
                      var userDataType = expGolombDecoder.readUByte();

                      // Raw CEA-608 bytes wrapped in CEA-708 packet
                      if (userDataType === 3) {
                        var firstByte = expGolombDecoder.readUByte();
                        var secondByte = expGolombDecoder.readUByte();

                        var totalCCs = 31 & firstByte;
                        var byteArray = [firstByte, secondByte];

                        for (i = 0; i < totalCCs; i++) {
                          // 3 bytes per CC
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                        }

                        _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
                      }
                    }
                  }
                }
              } else if (payloadSize < expGolombDecoder.bytesAvailable) {
                for (i = 0; i < payloadSize; i++) {
                  expGolombDecoder.readUByte();
                }
              }
            }
            break;
          // SPS
          case 7:
            push = true;
            spsfound = true;

            if (!track.sps) {
              expGolombDecoder = new exp_golomb(unit.data);
              var config = expGolombDecoder.readSPS();
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [unit.data];
              track.duration = _this._duration;
              var codecarray = unit.data.subarray(1, 4);
              var codecstring = 'avc1.';
              for (i = 0; i < 3; i++) {
                var h = codecarray[i].toString(16);
                if (h.length < 2) h = '0' + h;

                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          // PPS
          case 8:
            push = true;

            if (!track.pps) track.pps = [unit.data];

            break;
          // AUD
          case 9:
            push = false;
            track.audFound = true;
            if (avcSample) pushAccesUnit(avcSample, track);

            avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
            break;
          // Filler Data
          case 12:
            push = false;
            break;
          default:
            push = false;
            if (avcSample) avcSample.debug += 'unknown NAL ' + unit.type + ' ';

            break;
        }
        if (avcSample && push) {
          var _units = avcSample.units;
          _units.push(unit);
        }
      });
      // if last PES packet, push samples
      if (last && avcSample) {
        pushAccesUnit(avcSample, track);
        this.avcSample = null;
      }
    };

    TSDemuxer.prototype._insertSampleInOrder = function _insertSampleInOrder(arr, data) {
      var len = arr.length;
      if (len > 0) {
        if (data.pts >= arr[len - 1].pts) {
          arr.push(data);
        } else {
          for (var pos = len - 1; pos >= 0; pos--) {
            if (data.pts < arr[pos].pts) {
              arr.splice(pos, 0, data);
              break;
            }
          }
        }
      } else {
        arr.push(data);
      }
    };

    TSDemuxer.prototype._getLastNalUnit = function _getLastNalUnit() {
      var avcSample = this.avcSample,
          lastUnit = void 0;
      // try to fallback to previous sample if current one is empty
      if (!avcSample || avcSample.units.length === 0) {
        var track = this._avcTrack,
            samples = track.samples;
        avcSample = samples[samples.length - 1];
      }
      if (avcSample) {
        var units = avcSample.units;
        lastUnit = units[units.length - 1];
      }
      return lastUnit;
    };

    TSDemuxer.prototype._parseAVCNALu = function _parseAVCNALu(array) {
      var i = 0,
          len = array.byteLength,
          value = void 0,
          overflow = void 0,
          track = this._avcTrack,
          state = track.naluState || 0,
          lastState = state;
      var units = [],
          unit = void 0,
          unitType = void 0,
          lastUnitStart = -1,
          lastUnitType = void 0;
      // logger.log('PES:' + Hex.hexDump(array));

      if (state === -1) {
        // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
        lastUnitStart = 0;
        // NALu type is value read from offset 0
        lastUnitType = array[0] & 0x1f;
        state = 0;
        i = 1;
      }

      while (i < len) {
        value = array[i++];
        // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
        if (!state) {
          state = value ? 0 : 1;
          continue;
        }
        if (state === 1) {
          state = value ? 0 : 2;
          continue;
        }
        // here we have state either equal to 2 or 3
        if (!value) {
          state = 3;
        } else if (value === 1) {
          if (lastUnitStart >= 0) {
            unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
            // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
            units.push(unit);
          } else {
            // lastUnitStart is undefined => this is the first start code found in this PES packet
            // first check if start code delimiter is overlapping between 2 PES packets,
            // ie it started in last packet (lastState not zero)
            // and ended at the beginning of this PES packet (i <= 4 - lastState)
            var lastUnit = this._getLastNalUnit();
            if (lastUnit) {
              if (lastState && i <= 4 - lastState) {
                // start delimiter overlapping between PES packets
                // strip start delimiter bytes from the end of last NAL unit
                // check if lastUnit had a state different from zero
                if (lastUnit.state) {
                  // strip last bytes
                  lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                }
              }
              // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
              overflow = i - state - 1;
              if (overflow > 0) {
                // logger.log('first NALU found with overflow:' + overflow);
                var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                tmp.set(lastUnit.data, 0);
                tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                lastUnit.data = tmp;
              }
            }
          }
          // check if we can read unit type
          if (i < len) {
            unitType = array[i] & 0x1f;
            // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
            lastUnitStart = i;
            lastUnitType = unitType;
            state = 0;
          } else {
            // not enough byte to read unit type. let's read it on next PES parsing
            state = -1;
          }
        } else {
          state = 0;
        }
      }
      if (lastUnitStart >= 0 && state >= 0) {
        unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
        units.push(unit);
        // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
      }
      // no NALu found
      if (units.length === 0) {
        // append pes.data to previous NAL unit
        var _lastUnit = this._getLastNalUnit();
        if (_lastUnit) {
          var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
          _tmp.set(_lastUnit.data, 0);
          _tmp.set(array, _lastUnit.data.byteLength);
          _lastUnit.data = _tmp;
        }
      }
      track.naluState = state;
      return units;
    };

    /**
     * remove Emulation Prevention bytes from a RBSP
     */


    TSDemuxer.prototype.discardEPB = function discardEPB(data) {
      var length = data.byteLength,
          EPBPositions = [],
          i = 1,
          newLength = void 0,
          newData = void 0;

      // Find all `Emulation Prevention Bytes`
      while (i < length - 2) {
        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
          EPBPositions.push(i + 2);
          i += 2;
        } else {
          i++;
        }
      }

      // If no Emulation Prevention Bytes were found just return the original
      // array
      if (EPBPositions.length === 0) return data;

      // Create a new array to hold the NAL unit data
      newLength = length - EPBPositions.length;
      newData = new Uint8Array(newLength);
      var sourceIndex = 0;

      for (i = 0; i < newLength; sourceIndex++, i++) {
        if (sourceIndex === EPBPositions[0]) {
          // Skip this byte
          sourceIndex++;
          // Remove this position index
          EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
      }
      return newData;
    };

    TSDemuxer.prototype._parseAACPES = function _parseAACPES(pes) {
      var track = this._audioTrack,
          data = pes.data,
          pts = pes.pts,
          startOffset = 0,
          aacOverFlow = this.aacOverFlow,
          aacLastPTS = this.aacLastPTS,
          frameDuration = void 0,
          frameIndex = void 0,
          offset = void 0,
          stamp = void 0,
          len = void 0;
      if (aacOverFlow) {
        var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
        tmp.set(aacOverFlow, 0);
        tmp.set(data, aacOverFlow.byteLength);
        // logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
        data = tmp;
      }
      // look for ADTS header (0xFFFx)
      for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
        if (isHeader(data, offset)) break;
      }
      // if ADTS header does not start straight from the beginning of the PES payload, raise an error
      if (offset) {
        var reason = void 0,
            fatal = void 0;
        if (offset < len - 1) {
          reason = 'AAC PES did not start with ADTS header,offset:' + offset;
          fatal = false;
        } else {
          reason = 'no ADTS header found in AAC PES';
          fatal = true;
        }
        logger["b" /* logger */].warn('parsing error:' + reason);
        this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
        if (fatal) return;
      }

      initTrackConfig(track, this.observer, data, offset, this.audioCodec);
      frameIndex = 0;
      frameDuration = getFrameDuration(track.samplerate);

      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      if (aacOverFlow && aacLastPTS) {
        var newPTS = aacLastPTS + frameDuration;
        if (Math.abs(newPTS - pts) > 1) {
          logger["b" /* logger */].log('AAC: align PTS for overlapping frames by ' + Math.round((newPTS - pts) / 90));
          pts = newPTS;
        }
      }

      // scan for aac samples
      while (offset < len) {
        if (isHeader(data, offset) && offset + 5 < len) {
          var frame = appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            // logger.log(`${Math.round(frame.sample.pts)} : AAC`);
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            // logger.log('Unable to parse AAC frame');
            break;
          }
        } else {
          // nothing found, keep looking
          offset++;
        }
      }

      if (offset < len) aacOverFlow = data.subarray(offset, len);
      // logger.log(`AAC: overflow detected:${len-offset}`);
      else aacOverFlow = null;

      this.aacOverFlow = aacOverFlow;
      this.aacLastPTS = stamp;
    };

    TSDemuxer.prototype._parseMPEGPES = function _parseMPEGPES(pes) {
      var data = pes.data;
      var length = data.length;
      var frameIndex = 0;
      var offset = 0;
      var pts = pes.pts;

      while (offset < length) {
        if (mpegaudio.isHeader(data, offset)) {
          var frame = mpegaudio.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            frameIndex++;
          } else {
            // logger.log('Unable to parse Mpeg audio frame');
            break;
          }
        } else {
          // nothing found, keep looking
          offset++;
        }
      }
    };

    TSDemuxer.prototype._parseID3PES = function _parseID3PES(pes) {
      this._id3Track.samples.push(pes);
    };

    return TSDemuxer;
  }();

  /* harmony default export */ var tsdemuxer = (tsdemuxer_TSDemuxer);
  // CONCATENATED MODULE: ./src/demux/mp3demuxer.js
  function mp3demuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * MP3 demuxer
   */




  var mp3demuxer_MP3Demuxer = function () {
    function MP3Demuxer(observer, remuxer, config) {
      mp3demuxer__classCallCheck(this, MP3Demuxer);

      this.observer = observer;
      this.config = config;
      this.remuxer = remuxer;
    }

    MP3Demuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };

    MP3Demuxer.prototype.resetTimeStamp = function resetTimeStamp() {};

    MP3Demuxer.probe = function probe(data) {
      // check if data contains ID3 timestamp and MPEG sync word
      var offset = void 0,
          length = void 0;
      var id3Data = id3["a" /* default */].getID3Data(data, 0);
      if (id3Data && id3["a" /* default */].getTimeStamp(id3Data) !== undefined) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
          if (mpegaudio.probe(data, offset)) {
            logger["b" /* logger */].log('MPEG Audio sync word found !');
            return true;
          }
        }
      }
      return false;
    };

    // feed incoming data to the front of the parsing pipeline


    MP3Demuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var id3Data = id3["a" /* default */].getID3Data(data, 0);
      var timestamp = id3["a" /* default */].getTimeStamp(id3Data);
      var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
      var offset = id3Data.length;
      var length = data.length;
      var frameIndex = 0,
          stamp = 0;
      var track = this._audioTrack;

      var id3Samples = [{ pts: pts, dts: pts, data: id3Data }];

      while (offset < length) {
        if (mpegaudio.isHeader(data, offset)) {
          var frame = mpegaudio.appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            // logger.log('Unable to parse Mpeg audio frame');
            break;
          }
        } else if (id3["a" /* default */].isHeader(data, offset)) {
          id3Data = id3["a" /* default */].getID3Data(data, offset);
          id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
          offset += id3Data.length;
        } else {
          // nothing found, keep looking
          offset++;
        }
      }

      this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };

    MP3Demuxer.prototype.destroy = function destroy() {};

    return MP3Demuxer;
  }();

  /* harmony default export */ var mp3demuxer = (mp3demuxer_MP3Demuxer);
  // CONCATENATED MODULE: ./src/helper/aac.js
  function aac__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   *  AAC helper
   */

  var AAC = function () {
    function AAC() {
      aac__classCallCheck(this, AAC);
    }

    AAC.getSilentFrame = function getSilentFrame(codec, channelCount) {
      switch (codec) {
        case 'mp4a.40.2':
          if (channelCount === 1) return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);else if (channelCount === 2) return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);else if (channelCount === 3) return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);else if (channelCount === 4) return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);else if (channelCount === 5) return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);else if (channelCount === 6) return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);

          break;
        // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
        default:
          if (channelCount === 1) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 2) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 3) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          }
          break;
      }
      return null;
    };

    return AAC;
  }();

  /* harmony default export */ var aac = (AAC);
  // CONCATENATED MODULE: ./src/remux/mp4-generator.js
  function mp4_generator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * Generate MP4 Box
  */

  // import Hex from '../utils/hex';

  var UINT32_MAX = Math.pow(2, 32) - 1;

  var MP4 = function () {
    function MP4() {
      mp4_generator__classCallCheck(this, MP4);
    }

    MP4.init = function init() {
      MP4.types = {
        avc1: [], // codingname
        avcC: [],
        btrt: [],
        dinf: [],
        dref: [],
        esds: [],
        ftyp: [],
        hdlr: [],
        mdat: [],
        mdhd: [],
        mdia: [],
        mfhd: [],
        minf: [],
        moof: [],
        moov: [],
        mp4a: [],
        '.mp3': [],
        mvex: [],
        mvhd: [],
        pasp: [],
        sdtp: [],
        stbl: [],
        stco: [],
        stsc: [],
        stsd: [],
        stsz: [],
        stts: [],
        tfdt: [],
        tfhd: [],
        traf: [],
        trak: [],
        trun: [],
        trex: [],
        tkhd: [],
        vmhd: [],
        smhd: []
      };

      var i = void 0;
      for (i in MP4.types) {
        if (MP4.types.hasOwnProperty(i)) {
          MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
        }
      }

      var videoHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
      ]);

      var audioHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
      ]);

      MP4.HDLR_TYPES = {
        'video': videoHdlr,
        'audio': audioHdlr
      };

      var dref = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01, // entry_count
      0x00, 0x00, 0x00, 0x0c, // entry_size
      0x75, 0x72, 0x6c, 0x20, // 'url' type
      0x00, // version 0
      0x00, 0x00, 0x01 // entry_flags
      ]);

      var stco = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00 // entry_count
      ]);

      MP4.STTS = MP4.STSC = MP4.STCO = stco;

      MP4.STSZ = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // sample_size
      0x00, 0x00, 0x00, 0x00 // sample_count
      ]);
      MP4.VMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x01, // flags
      0x00, 0x00, // graphicsmode
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
      ]);
      MP4.SMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, // balance
      0x00, 0x00 // reserved
      ]);

      MP4.STSD = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01]); // entry_count

      var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
      var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
      var minorVersion = new Uint8Array([0, 0, 0, 1]);

      MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
      MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    };

    MP4.box = function box(type) {
      var payload = Array.prototype.slice.call(arguments, 1),
          size = 8,
          i = payload.length,
          len = i,
          result = void 0;
      // calculate the total size we need to allocate
      while (i--) {
        size += payload[i].byteLength;
      }result = new Uint8Array(size);
      result[0] = size >> 24 & 0xff;
      result[1] = size >> 16 & 0xff;
      result[2] = size >> 8 & 0xff;
      result[3] = size & 0xff;
      result.set(type, 4);
      // copy the payload into the result
      for (i = 0, size = 8; i < len; i++) {
        // copy payload[i] array @ offset size
        result.set(payload[i], size);
        size += payload[i].byteLength;
      }
      return result;
    };

    MP4.hdlr = function hdlr(type) {
      return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    };

    MP4.mdat = function mdat(data) {
      return MP4.box(MP4.types.mdat, data);
    };

    MP4.mdhd = function mdhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.mdhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x55, 0xc4, // 'und' language (undetermined)
      0x00, 0x00]));
    };

    MP4.mdia = function mdia(track) {
      return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    };

    MP4.mfhd = function mfhd(sequenceNumber) {
      return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
      sequenceNumber >> 24, sequenceNumber >> 16 & 0xFF, sequenceNumber >> 8 & 0xFF, sequenceNumber & 0xFF // sequence_number
      ]));
    };

    MP4.minf = function minf(track) {
      if (track.type === 'audio') return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));else return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    };

    MP4.moof = function moof(sn, baseMediaDecodeTime, track) {
      return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    };
    /**
    * @param tracks... (optional) {array} the tracks associated with this movie
    */


    MP4.moov = function moov(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trak(tracks[i]);
      }return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
    };

    MP4.mvex = function mvex(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trex(tracks[i]);
      }return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
    };

    MP4.mvhd = function mvhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      var bytes = new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x01, 0x00, 0x00, // 1.0 rate
      0x01, 0x00, // 1.0 volume
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      0xff, 0xff, 0xff, 0xff // next_track_ID
      ]);
      return MP4.box(MP4.types.mvhd, bytes);
    };

    MP4.sdtp = function sdtp(track) {
      var samples = track.samples || [],
          bytes = new Uint8Array(4 + samples.length),
          flags = void 0,
          i = void 0;
      // leave the full box header (4 bytes) all zero
      // write the sample table
      for (i = 0; i < samples.length; i++) {
        flags = samples[i].flags;
        bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
      }

      return MP4.box(MP4.types.sdtp, bytes);
    };

    MP4.stbl = function stbl(track) {
      return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    };

    MP4.avc1 = function avc1(track) {
      var sps = [],
          pps = [],
          i = void 0,
          data = void 0,
          len = void 0;
      // assemble the SPSs

      for (i = 0; i < track.sps.length; i++) {
        data = track.sps[i];
        len = data.byteLength;
        sps.push(len >>> 8 & 0xFF);
        sps.push(len & 0xFF);
        sps = sps.concat(Array.prototype.slice.call(data)); // SPS
      }

      // assemble the PPSs
      for (i = 0; i < track.pps.length; i++) {
        data = track.pps[i];
        len = data.byteLength;
        pps.push(len >>> 8 & 0xFF);
        pps.push(len & 0xFF);
        pps = pps.concat(Array.prototype.slice.call(data));
      }

      var avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01, // version
      sps[3], // profile
      sps[4], // profile compat
      sps[5], // level
      0xfc | 3, // lengthSizeMinusOne, hard-coded to 4 bytes
      0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
      ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
      ]).concat(pps))),
          // "PPS"
      width = track.width,
          height = track.height,
          hSpacing = track.pixelRatio[0],
          vSpacing = track.pixelRatio[1];

      return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, // pre_defined
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      width >> 8 & 0xFF, width & 0xff, // width
      height >> 8 & 0xFF, height & 0xff, // height
      0x00, 0x48, 0x00, 0x00, // horizresolution
      0x00, 0x48, 0x00, 0x00, // vertresolution
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // frame_count
      0x12, 0x64, 0x61, 0x69, 0x6C, // dailymotion/hls.js
      0x79, 0x6D, 0x6F, 0x74, 0x69, 0x6F, 0x6E, 0x2F, 0x68, 0x6C, 0x73, 0x2E, 0x6A, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
      0x00, 0x18, // depth = 24
      0x11, 0x11]), // pre_defined = -1
      avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
      0x00, 0x2d, 0xc6, 0xc0])), // avgBitrate
      MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24, // hSpacing
      hSpacing >> 16 & 0xFF, hSpacing >> 8 & 0xFF, hSpacing & 0xFF, vSpacing >> 24, // vSpacing
      vSpacing >> 16 & 0xFF, vSpacing >> 8 & 0xFF, vSpacing & 0xFF])));
    };

    MP4.esds = function esds(track) {
      var configlen = track.config.length;
      return new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags

      0x03, // descriptor_type
      0x17 + configlen, // length
      0x00, 0x01, // es_id
      0x00, // stream_priority

      0x04, // descriptor_type
      0x0f + configlen, // length
      0x40, // codec : mpeg4_audio
      0x15, // stream_type
      0x00, 0x00, 0x00, // buffer_size
      0x00, 0x00, 0x00, 0x00, // maxBitrate
      0x00, 0x00, 0x00, 0x00, // avgBitrate

      0x05 // descriptor_type
      ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
    };

    MP4.mp4a = function mp4a(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));
    };

    MP4.mp3 = function mp3(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types['.mp3'], new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]));
    };

    MP4.stsd = function stsd(track) {
      if (track.type === 'audio') {
        if (!track.isAAC && track.codec === 'mp3') return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));

        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
      } else {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
      }
    };

    MP4.tkhd = function tkhd(track) {
      var id = track.id,
          duration = track.duration * track.timescale,
          width = track.width,
          height = track.height,
          upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)),
          lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.tkhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x07, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      id >> 24 & 0xFF, id >> 16 & 0xFF, id >> 8 & 0xFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x00, // reserved
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, // layer
      0x00, 0x00, // alternate_group
      0x00, 0x00, // non-audio track volume
      0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      width >> 8 & 0xFF, width & 0xFF, 0x00, 0x00, // width
      height >> 8 & 0xFF, height & 0xFF, 0x00, 0x00 // height
      ]));
    };

    MP4.traf = function traf(track, baseMediaDecodeTime) {
      var sampleDependencyTable = MP4.sdtp(track),
          id = track.id,
          upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)),
          lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
      return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF]) // track_ID
      ), MP4.box(MP4.types.tfdt, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0XFF, upperWordBaseMediaDecodeTime >> 8 & 0XFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0XFF, lowerWordBaseMediaDecodeTime >> 8 & 0XFF, lowerWordBaseMediaDecodeTime & 0xFF])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8), // mdat header
      sampleDependencyTable);
    };

    /**
     * Generate a track box.
     * @param track {object} a track definition
     * @return {Uint8Array} the track box
     */


    MP4.trak = function trak(track) {
      track.duration = track.duration || 0xffffffff;
      return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    };

    MP4.trex = function trex(track) {
      var id = track.id;
      return MP4.box(MP4.types.trex, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x01, // default_sample_description_index
      0x00, 0x00, 0x00, 0x00, // default_sample_duration
      0x00, 0x00, 0x00, 0x00, // default_sample_size
      0x00, 0x01, 0x00, 0x01 // default_sample_flags
      ]));
    };

    MP4.trun = function trun(track, offset) {
      var samples = track.samples || [],
          len = samples.length,
          arraylen = 12 + 16 * len,
          array = new Uint8Array(arraylen),
          i = void 0,
          sample = void 0,
          duration = void 0,
          size = void 0,
          flags = void 0,
          cts = void 0;
      offset += 8 + arraylen;
      array.set([0x00, // version 0
      0x00, 0x0f, 0x01, // flags
      len >>> 24 & 0xFF, len >>> 16 & 0xFF, len >>> 8 & 0xFF, len & 0xFF, // sample_count
      offset >>> 24 & 0xFF, offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF // data_offset
      ], 0);
      for (i = 0; i < len; i++) {
        sample = samples[i];
        duration = sample.duration;
        size = sample.size;
        flags = sample.flags;
        cts = sample.cts;
        array.set([duration >>> 24 & 0xFF, duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, // sample_duration
        size >>> 24 & 0xFF, size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF, // sample_size
        flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xF0 << 8, flags.degradPrio & 0x0F, // sample_flags
        cts >>> 24 & 0xFF, cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF // sample_composition_time_offset
        ], 12 + 16 * i);
      }
      return MP4.box(MP4.types.trun, array);
    };

    MP4.initSegment = function initSegment(tracks) {
      if (!MP4.types) MP4.init();

      var movie = MP4.moov(tracks),
          result = void 0;
      result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
      result.set(MP4.FTYP);
      result.set(movie, MP4.FTYP.byteLength);
      return result;
    };

    return MP4;
  }();

  /* harmony default export */ var mp4_generator = (MP4);
  // CONCATENATED MODULE: ./src/remux/mp4-remuxer.js
  function mp4_remuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * fMP4 remuxer
  */







  // 10 seconds
  var MAX_SILENT_FRAME_DURATION = 10 * 1000;

  var mp4_remuxer_MP4Remuxer = function () {
    function MP4Remuxer(observer, config, typeSupported, vendor) {
      mp4_remuxer__classCallCheck(this, MP4Remuxer);

      this.observer = observer;
      this.config = config;
      this.typeSupported = typeSupported;
      var userAgent = navigator.userAgent;
      this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
      this.ISGenerated = false;
    }

    MP4Remuxer.prototype.destroy = function destroy() {};

    MP4Remuxer.prototype.resetTimeStamp = function resetTimeStamp(defaultTimeStamp) {
      this._initPTS = this._initDTS = defaultTimeStamp;
    };

    MP4Remuxer.prototype.resetInitSegment = function resetInitSegment() {
      this.ISGenerated = false;
    };

    MP4Remuxer.prototype.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      // generate Init Segment if needed
      if (!this.ISGenerated) this.generateIS(audioTrack, videoTrack, timeOffset);

      if (this.ISGenerated) {
        var nbAudioSamples = audioTrack.samples.length;
        var nbVideoSamples = videoTrack.samples.length;
        var audioTimeOffset = timeOffset;
        var videoTimeOffset = timeOffset;
        if (nbAudioSamples && nbVideoSamples) {
          // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
          // if first audio DTS is not aligned with first video DTS then we need to take that into account
          // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
          // drift between audio and video streams
          var audiovideoDeltaDts = (audioTrack.samples[0].dts - videoTrack.samples[0].dts) / videoTrack.inputTimeScale;
          audioTimeOffset += Math.max(0, audiovideoDeltaDts);
          videoTimeOffset += Math.max(0, -audiovideoDeltaDts);
        }
        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
        // calculated in remuxAudio.
        // logger.log('nb AAC samples:' + audioTrack.samples.length);
        if (nbAudioSamples) {
          // if initSegment was generated without video samples, regenerate it again
          if (!audioTrack.timescale) {
            logger["b" /* logger */].warn('regenerate InitSegment as audio detected');
            this.generateIS(audioTrack, videoTrack, timeOffset);
          }
          var audioData = this.remuxAudio(audioTrack, audioTimeOffset, contiguous, accurateTimeOffset);
          // logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (nbVideoSamples) {
            var audioTrackLength = void 0;
            if (audioData) audioTrackLength = audioData.endPTS - audioData.startPTS;

            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.timescale) {
              logger["b" /* logger */].warn('regenerate InitSegment as video detected');
              this.generateIS(audioTrack, videoTrack, timeOffset);
            }
            this.remuxVideo(videoTrack, videoTimeOffset, contiguous, audioTrackLength, accurateTimeOffset);
          }
        } else {
          // logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (nbVideoSamples) {
            var videoData = this.remuxVideo(videoTrack, videoTimeOffset, contiguous, 0, accurateTimeOffset);
            if (videoData && audioTrack.codec) this.remuxEmptyAudio(audioTrack, audioTimeOffset, contiguous, videoData);
          }
        }
      }
      // logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (id3Track.samples.length) this.remuxID3(id3Track, timeOffset);

      // logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (textTrack.samples.length) this.remuxText(textTrack, timeOffset);

      // notify end of parsing
      this.observer.trigger(events["a" /* default */].FRAG_PARSED);
    };

    MP4Remuxer.prototype.generateIS = function generateIS(audioTrack, videoTrack, timeOffset) {
      var observer = this.observer,
          audioSamples = audioTrack.samples,
          videoSamples = videoTrack.samples,
          typeSupported = this.typeSupported,
          container = 'audio/mp4',
          tracks = {},
          data = { tracks: tracks },
          computePTSDTS = this._initPTS === undefined,
          initPTS = void 0,
          initDTS = void 0;

      if (computePTSDTS) initPTS = initDTS = Infinity;

      if (audioTrack.config && audioSamples.length) {
        // let's use audio sampling rate as MP4 time scale.
        // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
        // using audio sampling rate here helps having an integer MP4 frame duration
        // this avoids potential rounding issue and AV sync issue
        audioTrack.timescale = audioTrack.samplerate;
        logger["b" /* logger */].log('audio sampling rate : ' + audioTrack.samplerate);
        if (!audioTrack.isAAC) {
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
        }
        tracks.audio = {
          container: container,
          codec: audioTrack.codec,
          initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : mp4_generator.initSegment([audioTrack]),
          metadata: {
            channelCount: audioTrack.channelCount
          }
        };
        if (computePTSDTS) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
        }
      }

      if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
        // let's use input time scale as MP4 video timescale
        // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
        var inputTimeScale = videoTrack.inputTimeScale;
        videoTrack.timescale = inputTimeScale;
        tracks.video = {
          container: 'video/mp4',
          codec: videoTrack.codec,
          initSegment: mp4_generator.initSegment([videoTrack]),
          metadata: {
            width: videoTrack.width,
            height: videoTrack.height
          }
        };
        if (computePTSDTS) {
          initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
          initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
          this.observer.trigger(events["a" /* default */].INIT_PTS_FOUND, { initPTS: initPTS });
        }
      }

      if (Object.keys(tracks).length) {
        observer.trigger(events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, data);
        this.ISGenerated = true;
        if (computePTSDTS) {
          this._initPTS = initPTS;
          this._initDTS = initDTS;
        }
      } else {
        observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
      }
    };

    MP4Remuxer.prototype.remuxVideo = function remuxVideo(track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
      var offset = 8,
          timeScale = track.timescale,
          mp4SampleDuration = void 0,
          mdat = void 0,
          moof = void 0,
          firstPTS = void 0,
          firstDTS = void 0,
          lastPTS = void 0,
          lastDTS = void 0,
          inputSamples = track.samples,
          outputSamples = [],
          nbSamples = inputSamples.length,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS;

      // for (let i = 0; i < track.samples.length; i++) {
      //   let avcSample = track.samples[i];
      //   let units = avcSample.units;
      //   let unitsString = '';
      //   for (let j = 0; j < units.length ; j++) {
      //     unitsString += units[j].type + ',';
      //     if (units[j].data.length < 500) {
      //       unitsString += Hex.hexDump(units[j].data);
      //     }
      //   }
      //   logger.log(avcSample.pts + '/' + avcSample.dts + ',' + unitsString + avcSample.units.length);
      // }

      // if parsed fragment is contiguous with last one, let's use last DTS value as reference
      var nextAvcDts = this.nextAvcDts;

      var isSafari = this.isSafari;

      if (nbSamples === 0) return;

      // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
      if (isSafari) {
        // also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 200 ms PTS gaps (timeScale/5)
        contiguous |= inputSamples.length && nextAvcDts && (accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAvcDts - initDTS) < timeScale / 5);
      }

      if (!contiguous) {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = timeOffset * timeScale;
      }

      // PTS is coded on 33bits, and can loop from -2^32 to 2^32
      // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
      inputSamples.forEach(function (sample) {
        sample.pts = ptsNormalize(sample.pts - initDTS, nextAvcDts);
        sample.dts = ptsNormalize(sample.dts - initDTS, nextAvcDts);
      });

      // sort video samples by DTS then PTS then demux id order
      inputSamples.sort(function (a, b) {
        var deltadts = a.dts - b.dts;
        var deltapts = a.pts - b.pts;
        return deltadts || deltapts || a.id - b.id;
      });

      // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
      var PTSDTSshift = inputSamples.reduce(function (prev, curr) {
        return Math.max(Math.min(prev, curr.pts - curr.dts), -18000);
      }, 0);
      if (PTSDTSshift < 0) {
        logger["b" /* logger */].warn('PTS < DTS detected in video samples, shifting DTS by ' + Math.round(PTSDTSshift / 90) + ' ms to overcome this issue');
        for (var i = 0; i < inputSamples.length; i++) {
          inputSamples[i].dts += PTSDTSshift;
        }
      }

      // compute first DTS and last DTS, normalize them against reference value
      var sample = inputSamples[0];
      firstDTS = Math.max(sample.dts, 0);
      firstPTS = Math.max(sample.pts, 0);

      // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
      var delta = Math.round((firstDTS - nextAvcDts) / 90);
      // if fragment are contiguous, detect hole/overlapping between fragments
      if (contiguous) {
        if (delta) {
          if (delta > 1) logger["b" /* logger */].log('AVC:' + delta + ' ms hole between fragments detected,filling it');else if (delta < -1) logger["b" /* logger */].log('AVC:' + -delta + ' ms overlapping between fragments detected');

          // remove hole/gap : set DTS to next expected DTS
          firstDTS = nextAvcDts;
          inputSamples[0].dts = firstDTS;
          // offset PTS as well, ensure that PTS is smaller or equal than new DTS
          firstPTS = Math.max(firstPTS - delta, nextAvcDts);
          inputSamples[0].pts = firstPTS;
          logger["b" /* logger */].log('Video/PTS/DTS adjusted: ' + Math.round(firstPTS / 90) + '/' + Math.round(firstDTS / 90) + ',delta:' + delta + ' ms');
        }
      }

      // compute lastPTS/lastDTS
      sample = inputSamples[inputSamples.length - 1];
      lastDTS = Math.max(sample.dts, 0);
      lastPTS = Math.max(sample.pts, 0, lastDTS);

      // on Safari let's signal the same sample duration for all samples
      // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
      // set this constant duration as being the avg delta between consecutive DTS.
      if (isSafari) mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));

      var nbNalu = 0,
          naluLen = 0;
      for (var _i = 0; _i < nbSamples; _i++) {
        // compute total/avc sample length and nb of NAL units
        var _sample = inputSamples[_i],
            units = _sample.units,
            nbUnits = units.length,
            sampleLen = 0;
        for (var j = 0; j < nbUnits; j++) {
          sampleLen += units[j].data.length;
        }naluLen += sampleLen;
        nbNalu += nbUnits;
        _sample.length = sampleLen;

        // normalize PTS/DTS
        if (isSafari) {
          // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
          _sample.dts = firstDTS + _i * mp4SampleDuration;
        } else {
          // ensure sample monotonic DTS
          _sample.dts = Math.max(_sample.dts, firstDTS);
        }
        // ensure that computed value is greater or equal than sample DTS
        _sample.pts = Math.max(_sample.pts, _sample.dts);
      }

      /* concatenate the video data and construct the mdat in place
        (need 8 more bytes to fill length and mpdat type) */
      var mdatSize = naluLen + 4 * nbNalu + 8;
      try {
        mdat = new Uint8Array(mdatSize);
      } catch (err) {
        this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MUX_ERROR, details: errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating video mdat ' + mdatSize });
        return;
      }
      var view = new DataView(mdat.buffer);
      view.setUint32(0, mdatSize);
      mdat.set(mp4_generator.types.mdat, 4);

      for (var _i2 = 0; _i2 < nbSamples; _i2++) {
        var avcSample = inputSamples[_i2],
            avcSampleUnits = avcSample.units,
            mp4SampleLength = 0,
            compositionTimeOffset = void 0;
        // convert NALU bitstream to MP4 format (prepend NALU with size field)
        for (var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++) {
          var unit = avcSampleUnits[_j],
              unitData = unit.data,
              unitDataLen = unit.data.byteLength;
          view.setUint32(offset, unitDataLen);
          offset += 4;
          mdat.set(unitData, offset);
          offset += unitDataLen;
          mp4SampleLength += 4 + unitDataLen;
        }

        if (!isSafari) {
          // expected sample duration is the Decoding Timestamp diff of consecutive samples
          if (_i2 < nbSamples - 1) {
            mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
          } else {
            var config = this.config,
                lastFrameDuration = avcSample.dts - inputSamples[_i2 > 0 ? _i2 - 1 : _i2].dts;
            if (config.stretchShortVideoTrack) {
              // In some cases, a segment's audio track duration may exceed the video track duration.
              // Since we've already remuxed audio, and we know how long the audio track is, we look to
              // see if the delta to the next segment is longer than maxBufferHole.
              // If so, playback would potentially get stuck, so we artificially inflate
              // the duration of the last frame to minimize any potential gap between segments.
              var maxBufferHole = config.maxBufferHole,
                  gapTolerance = Math.floor(maxBufferHole * timeScale),
                  deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
              if (deltaToFrameEnd > gapTolerance) {
                // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;

                logger["b" /* logger */].log('It is approximately ' + deltaToFrameEnd / 90 + ' ms to the next segment; using duration ' + mp4SampleDuration / 90 + ' ms for the last video frame.');
              } else {
                mp4SampleDuration = lastFrameDuration;
              }
            } else {
              mp4SampleDuration = lastFrameDuration;
            }
          }
          compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
        } else {
          compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
        }

        // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
        outputSamples.push({
          size: mp4SampleLength,
          // constant duration
          duration: mp4SampleDuration,
          cts: compositionTimeOffset,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: avcSample.key ? 2 : 1,
            isNonSync: avcSample.key ? 0 : 1
          }
        });
      }
      // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
      this.nextAvcDts = lastDTS + mp4SampleDuration;
      var dropped = track.dropped;
      track.len = 0;
      track.nbNalu = 0;
      track.dropped = 0;
      if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var flags = outputSamples[0].flags;
        // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
        // https://code.google.com/p/chromium/issues/detail?id=229412
        flags.dependsOn = 2;
        flags.isNonSync = 0;
      }
      track.samples = outputSamples;
      moof = mp4_generator.moof(track.sequenceNumber++, firstDTS, track);
      track.samples = [];

      var data = {
        data1: moof,
        data2: mdat,
        startPTS: firstPTS / timeScale,
        endPTS: (lastPTS + mp4SampleDuration) / timeScale,
        startDTS: firstDTS / timeScale,
        endDTS: this.nextAvcDts / timeScale,
        type: 'video',
        hasAudio: false,
        hasVideo: true,
        nb: outputSamples.length,
        dropped: dropped
      };
      this.observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, data);
      return data;
    };

    MP4Remuxer.prototype.remuxAudio = function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.timescale,
          scaleFactor = inputTimeScale / mp4timeScale,
          mp4SampleDuration = track.isAAC ? 1024 : 1152,
          inputSampleDuration = mp4SampleDuration * scaleFactor,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS,
          rawMPEG = !track.isAAC && this.typeSupported.mpeg;

      var offset = void 0,
          mp4Sample = void 0,
          fillFrame = void 0,
          mdat = void 0,
          moof = void 0,
          firstPTS = void 0,
          lastPTS = void 0,
          inputSamples = track.samples,
          outputSamples = [],
          nextAudioPts = this.nextAudioPts;

      // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
      // for sake of clarity:
      // consecutive fragments are frags with
      //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
      //  - less than 20 audio frames distance
      // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
      // this helps ensuring audio continuity
      // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
      contiguous |= inputSamples.length && nextAudioPts && (accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAudioPts - initDTS) < 20 * inputSampleDuration);

      // compute normalized PTS
      inputSamples.forEach(function (sample) {
        sample.pts = sample.dts = ptsNormalize(sample.pts - initDTS, timeOffset * inputTimeScale);
      });

      // filter out sample with negative PTS that are not playable anyway
      // if we don't remove these negative samples, they will shift all audio samples forward.
      // leading to audio overlap between current / next fragment
      inputSamples = inputSamples.filter(function (sample) {
        return sample.pts >= 0;
      });

      // in case all samples have negative PTS, and have been filtered out, return now
      if (inputSamples.length === 0) return;

      if (!contiguous) {
        if (!accurateTimeOffset) {
          // if frag are mot contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
          nextAudioPts = inputSamples[0].pts;
        } else {
          // if timeOffset is accurate, let's use it as predicted next audio PTS
          nextAudioPts = timeOffset * inputTimeScale;
        }
      }

      // If the audio track is missing samples, the frames seem to get "left-shifted" within the
      // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
      // In an effort to prevent this from happening, we inject frames here where there are gaps.
      // When possible, we inject a silent frame; when that's not possible, we duplicate the last
      // frame.

      if (track.isAAC) {
        var maxAudioFramesDrift = this.config.maxAudioFramesDrift;
        for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length;) {
          // First, let's see how far off this frame is from where we expect it to be
          var sample = inputSamples[i],
              delta;
          var pts = sample.pts;
          delta = pts - nextPts;

          var duration = Math.abs(1000 * delta / inputTimeScale);

          // If we're overlapping by more than a duration, drop this sample
          if (delta <= -maxAudioFramesDrift * inputSampleDuration) {
            logger["b" /* logger */].warn('Dropping 1 audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + Math.round(duration) + ' ms overlap.');
            inputSamples.splice(i, 1);
            track.len -= sample.unit.length;
            // Don't touch nextPtsNorm or i
          } // eslint-disable-line brace-style

          // Insert missing frames if:
          // 1: We're more than maxAudioFramesDrift frame away
          // 2: Not more than MAX_SILENT_FRAME_DURATION away
          // 3: currentTime (aka nextPtsNorm) is not 0
          else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPts) {
              var missing = Math.round(delta / inputSampleDuration);
              logger["b" /* logger */].warn('Injecting ' + missing + ' audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + Math.round(1000 * delta / inputTimeScale) + ' ms gap.');
              for (var j = 0; j < missing; j++) {
                var newStamp = Math.max(nextPts, 0);
                fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                if (!fillFrame) {
                  logger["b" /* logger */].log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                  fillFrame = sample.unit.subarray();
                }
                inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
                track.len += fillFrame.length;
                nextPts += inputSampleDuration;
                i++;
              }

              // Adjust sample to next expected pts
              sample.pts = sample.dts = nextPts;
              nextPts += inputSampleDuration;
              i++;
            } else {
              sample.pts = sample.dts = nextPts;
              nextPts += inputSampleDuration;
              i++;
            }
        }
      }

      for (var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++) {
        var audioSample = inputSamples[_j2];
        var unit = audioSample.unit;
        var _pts = audioSample.pts;
        // logger.log(`Audio/PTS:${Math.round(pts/90)}`);
        // if not first sample
        if (lastPTS !== undefined) {
          mp4Sample.duration = Math.round((_pts - lastPTS) / scaleFactor);
        } else {
          var _delta = Math.round(1000 * (_pts - nextAudioPts) / inputTimeScale),
              numMissingFrames = 0;
          // if fragment are contiguous, detect hole/overlapping between fragments
          // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
          if (contiguous && track.isAAC) {
            // log delta
            if (_delta) {
              if (_delta > 0 && _delta < MAX_SILENT_FRAME_DURATION) {
                numMissingFrames = Math.round((_pts - nextAudioPts) / inputSampleDuration);
                logger["b" /* logger */].log(_delta + ' ms hole between AAC samples detected,filling it');
                if (numMissingFrames > 0) {
                  fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                  if (!fillFrame) fillFrame = unit.subarray();

                  track.len += numMissingFrames * fillFrame.length;
                }
                // if we have frame overlap, overlapping for more than half a frame duraion
              } else if (_delta < -12) {
                // drop overlapping audio frames... browser will deal with it
                logger["b" /* logger */].log('drop overlapping AAC sample, expected/parsed/delta:' + (nextAudioPts / inputTimeScale).toFixed(3) + 's/' + (_pts / inputTimeScale).toFixed(3) + 's/' + -_delta + 'ms');
                track.len -= unit.byteLength;
                continue;
              }
              // set PTS/DTS to expected PTS/DTS
              _pts = nextAudioPts;
            }
          }
          // remember first PTS of our audioSamples
          firstPTS = _pts;
          if (track.len > 0) {
            /* concatenate the audio data and construct the mdat in place
              (need 8 more bytes to fill length and mdat type) */
            var mdatSize = rawMPEG ? track.len : track.len + 8;
            offset = rawMPEG ? 0 : 8;
            try {
              mdat = new Uint8Array(mdatSize);
            } catch (err) {
              this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MUX_ERROR, details: errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating audio mdat ' + mdatSize });
              return;
            }
            if (!rawMPEG) {
              var view = new DataView(mdat.buffer);
              view.setUint32(0, mdatSize);
              mdat.set(mp4_generator.types.mdat, 4);
            }
          } else {
            // no audio samples
            return;
          }
          for (var _i3 = 0; _i3 < numMissingFrames; _i3++) {
            fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              logger["b" /* logger */].log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
              fillFrame = unit.subarray();
            }
            mdat.set(fillFrame, offset);
            offset += fillFrame.byteLength;
            mp4Sample = {
              size: fillFrame.byteLength,
              cts: 0,
              duration: 1024,
              flags: {
                isLeading: 0,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradPrio: 0,
                dependsOn: 1
              }
            };
            outputSamples.push(mp4Sample);
          }
        }
        mdat.set(unit, offset);
        var unitLen = unit.byteLength;
        offset += unitLen;
        // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
        mp4Sample = {
          size: unitLen,
          cts: 0,
          duration: 0,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: 1
          }
        };
        outputSamples.push(mp4Sample);
        lastPTS = _pts;
      }
      var lastSampleDuration = 0;
      var nbSamples = outputSamples.length;
      // set last sample duration as being identical to previous sample
      if (nbSamples >= 2) {
        lastSampleDuration = outputSamples[nbSamples - 2].duration;
        mp4Sample.duration = lastSampleDuration;
      }
      if (nbSamples) {
        // next audio sample PTS should be equal to last sample PTS + duration
        this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration;
        // logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
        track.len = 0;
        track.samples = outputSamples;
        if (rawMPEG) moof = new Uint8Array();else moof = mp4_generator.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);

        track.samples = [];
        var start = firstPTS / inputTimeScale;
        var end = nextAudioPts / inputTimeScale;
        var audioData = {
          data1: moof,
          data2: mdat,
          startPTS: start,
          endPTS: end,
          startDTS: start,
          endDTS: end,
          type: 'audio',
          hasAudio: true,
          hasVideo: false,
          nb: nbSamples
        };
        this.observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, audioData);
        return audioData;
      }
      return null;
    };

    MP4Remuxer.prototype.remuxEmptyAudio = function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale,
          scaleFactor = inputTimeScale / mp4timeScale,
          nextAudioPts = this.nextAudioPts,


      // sync with video's timestamp
      startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS,
          endDTS = videoData.endDTS * inputTimeScale + this._initDTS,

      // one sample's duration value
      sampleDuration = 1024,
          frameDuration = scaleFactor * sampleDuration,


      // samples count of this segment's duration
      nbSamples = Math.ceil((endDTS - startDTS) / frameDuration),


      // silent frame
      silentFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);

      logger["b" /* logger */].warn('remux empty Audio');
      // Can't remux if we can't generate a silent frame...
      if (!silentFrame) {
        logger["b" /* logger */].trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
        return;
      }

      var samples = [];
      for (var i = 0; i < nbSamples; i++) {
        var stamp = startDTS + i * frameDuration;
        samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
        track.len += silentFrame.length;
      }
      track.samples = samples;

      this.remuxAudio(track, timeOffset, contiguous);
    };

    MP4Remuxer.prototype.remuxID3 = function remuxID3(track, timeOffset) {
      var length = track.samples.length,
          sample = void 0;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      var initDTS = this._initDTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting id3 pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
          sample.dts = (sample.dts - initDTS) / inputTimeScale;
        }
        this.observer.trigger(events["a" /* default */].FRAG_PARSING_METADATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    };

    MP4Remuxer.prototype.remuxText = function remuxText(track, timeOffset) {
      track.samples.sort(function (a, b) {
        return a.pts - b.pts;
      });

      var length = track.samples.length,
          sample = void 0;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting text pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
        }
        this.observer.trigger(events["a" /* default */].FRAG_PARSING_USERDATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    };

    MP4Remuxer.prototype._PTSNormalize = function _PTSNormalize(value, reference) {
      var offset = void 0;
      if (reference === undefined) return value;

      if (reference < value) {
        // - 2^33
        offset = -8589934592;
      } else {
        // + 2^33
        offset = 8589934592;
      }
      /* PTS is 33bit (from 0 to 2^33 -1)
        if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
        PTS looping occured. fill the gap */
      while (Math.abs(value - reference) > 4294967296) {
        value += offset;
      }return value;
    };

    return MP4Remuxer;
  }();

  /* harmony default export */ var mp4_remuxer = (mp4_remuxer_MP4Remuxer);
  // CONCATENATED MODULE: ./src/remux/passthrough-remuxer.js
  function passthrough_remuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * passthrough remuxer
  */


  var passthrough_remuxer_PassThroughRemuxer = function () {
    function PassThroughRemuxer(observer) {
      passthrough_remuxer__classCallCheck(this, PassThroughRemuxer);

      this.observer = observer;
    }

    PassThroughRemuxer.prototype.destroy = function destroy() {};

    PassThroughRemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};

    PassThroughRemuxer.prototype.resetInitSegment = function resetInitSegment() {};

    PassThroughRemuxer.prototype.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
      var observer = this.observer;
      var streamType = '';
      if (audioTrack) streamType += 'audio';

      if (videoTrack) streamType += 'video';

      observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, {
        data1: rawData,
        startPTS: timeOffset,
        startDTS: timeOffset,
        type: streamType,
        hasAudio: !!audioTrack,
        hasVideo: !!videoTrack,
        nb: 1,
        dropped: 0
      });
      // notify end of parsing
      observer.trigger(events["a" /* default */].FRAG_PARSED);
    };

    return PassThroughRemuxer;
  }();

  /* harmony default export */ var passthrough_remuxer = (passthrough_remuxer_PassThroughRemuxer);
  // CONCATENATED MODULE: ./src/demux/demuxer-inline.js
  function demuxer_inline__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*  inline demuxer.
   *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
   */











  var demuxer_inline_DemuxerInline = function () {
    function DemuxerInline(observer, typeSupported, config, vendor) {
      demuxer_inline__classCallCheck(this, DemuxerInline);

      this.observer = observer;
      this.typeSupported = typeSupported;
      this.config = config;
      this.vendor = vendor;
    }

    DemuxerInline.prototype.destroy = function destroy() {
      var demuxer = this.demuxer;
      if (demuxer) demuxer.destroy();
    };

    DemuxerInline.prototype.push = function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
        var decrypter = this.decrypter;
        if (decrypter == null) decrypter = this.decrypter = new crypt_decrypter["a" /* default */](this.observer, this.config);

        var localthis = this;
        // performance.now() not available on WebWorker, at least on Safari Desktop
        var startTime = void 0;
        try {
          startTime = performance.now();
        } catch (error) {
          startTime = Date.now();
        }
        decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
          var endTime = void 0;
          try {
            endTime = performance.now();
          } catch (error) {
            endTime = Date.now();
          }
          localthis.observer.trigger(events["a" /* default */].FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
          localthis.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        });
      } else {
        this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
      }
    };

    DemuxerInline.prototype.pushDecrypted = function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      var demuxer = this.demuxer;
      if (!demuxer ||
      // in case of continuity change, or track switch
      // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
      // so let's check that current demuxer is still valid
      (discontinuity || trackSwitch) && !this.probe(data)) {
        var observer = this.observer;
        var typeSupported = this.typeSupported;
        var config = this.config;
        // probing order is TS/AAC/MP3/MP4
        var muxConfig = [{ demux: tsdemuxer, remux: mp4_remuxer }, { demux: mp4demuxer["a" /* default */], remux: passthrough_remuxer }, { demux: aacdemuxer, remux: mp4_remuxer }, { demux: mp3demuxer, remux: mp4_remuxer }];

        // probe for content type
        for (var i = 0, len = muxConfig.length; i < len; i++) {
          var mux = muxConfig[i];
          var probe = mux.demux.probe;
          if (probe(data)) {
            var _remuxer = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
            demuxer = new mux.demux(observer, _remuxer, config, typeSupported);
            this.probe = probe;
            break;
          }
        }
        if (!demuxer) {
          observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
          return;
        }
        this.demuxer = demuxer;
      }
      var remuxer = this.remuxer;

      if (discontinuity || trackSwitch) {
        demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
        remuxer.resetInitSegment();
      }
      if (discontinuity) {
        demuxer.resetTimeStamp(defaultInitPTS);
        remuxer.resetTimeStamp(defaultInitPTS);
      }
      if (typeof demuxer.setDecryptData === 'function') demuxer.setDecryptData(decryptdata);

      demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
    };

    return DemuxerInline;
  }();

  /* harmony default export */ var demuxer_inline = __webpack_exports__["a"] = (demuxer_inline_DemuxerInline);

  /***/ }),
  /* 9 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
  var cues_namespaceObject = {};
  __webpack_require__.d(cues_namespaceObject, "newCue", function() { return newCue; });

  // EXTERNAL MODULE: ./node_modules/url-toolkit/src/url-toolkit.js
  var url_toolkit = __webpack_require__(3);
  var url_toolkit_default = /*#__PURE__*/__webpack_require__.n(url_toolkit);

  // EXTERNAL MODULE: ./src/errors.js
  var errors = __webpack_require__(2);

  // EXTERNAL MODULE: ./src/events.js
  var events = __webpack_require__(1);

  // EXTERNAL MODULE: ./src/utils/logger.js
  var logger = __webpack_require__(0);

  // CONCATENATED MODULE: ./src/event-handler.js
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
  *
  * All objects in the event handling chain should inherit from this class
  *
  */





  var FORBIDDEN_EVENT_NAMES = new Set(['hlsEventGeneric', 'hlsHandlerDestroying', 'hlsHandlerDestroyed']);

  var event_handler_EventHandler = function () {
    function EventHandler(hls) {
      _classCallCheck(this, EventHandler);

      this.hls = hls;
      this.onEvent = this.onEvent.bind(this);

      for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        events[_key - 1] = arguments[_key];
      }

      this.handledEvents = events;
      this.useGenericHandler = true;

      this.registerListeners();
    }

    EventHandler.prototype.destroy = function destroy() {
      this.onHandlerDestroying();
      this.unregisterListeners();
      this.onHandlerDestroyed();
    };

    EventHandler.prototype.onHandlerDestroying = function onHandlerDestroying() {};

    EventHandler.prototype.onHandlerDestroyed = function onHandlerDestroyed() {};

    EventHandler.prototype.isEventHandler = function isEventHandler() {
      return _typeof(this.handledEvents) === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
    };

    EventHandler.prototype.registerListeners = function registerListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          if (FORBIDDEN_EVENT_NAMES.has(event)) throw new Error('Forbidden event-name: ' + event);

          this.hls.on(event, this.onEvent);
        }, this);
      }
    };

    EventHandler.prototype.unregisterListeners = function unregisterListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          this.hls.off(event, this.onEvent);
        }, this);
      }
    };

    /**
     * arguments: event (string), data (any)
     */


    EventHandler.prototype.onEvent = function onEvent(event, data) {
      this.onEventGeneric(event, data);
    };

    EventHandler.prototype.onEventGeneric = function onEventGeneric(event, data) {
      var eventToFunction = function eventToFunction(event, data) {
        var funcName = 'on' + event.replace('hls', '');
        if (typeof this[funcName] !== 'function') throw new Error('Event ' + event + ' has no generic handler in this ' + this.constructor.name + ' class (tried ' + funcName + ')');

        return this[funcName].bind(this, data);
      };
      try {
        eventToFunction.call(this, event, data).call();
      } catch (err) {
        logger["b" /* logger */].error('An internal error happened while handling event ' + event + '. Error message: "' + err.message + '". Here is a stacktrace:', err);
        this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].OTHER_ERROR, details: errors["a" /* ErrorDetails */].INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
      }
    };

    return EventHandler;
  }();

  /* harmony default export */ var event_handler = (event_handler_EventHandler);
  // EXTERNAL MODULE: ./src/demux/mp4demuxer.js
  var mp4demuxer = __webpack_require__(7);

  // CONCATENATED MODULE: ./src/loader/level-key.js
  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function level_key__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



  var level_key_LevelKey = function () {
    function LevelKey() {
      level_key__classCallCheck(this, LevelKey);

      this.method = null;
      this.key = null;
      this.iv = null;
      this._uri = null;
    }

    _createClass(LevelKey, [{
      key: 'uri',
      get: function get() {
        if (!this._uri && this.reluri) this._uri = url_toolkit_default.a.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });

        return this._uri;
      }
    }]);

    return LevelKey;
  }();

  /* harmony default export */ var level_key = (level_key_LevelKey);
  // CONCATENATED MODULE: ./src/loader/fragment.js
  var fragment__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function fragment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





  var fragment_Fragment = function () {
    function Fragment() {
      var _elementaryStreams;

      fragment__classCallCheck(this, Fragment);

      this._url = null;
      this._byteRange = null;
      this._decryptdata = null;
      this.tagList = [];

      // Holds the types of data this fragment supports
      this._elementaryStreams = (_elementaryStreams = {}, _elementaryStreams[Fragment.ElementaryStreamTypes.AUDIO] = false, _elementaryStreams[Fragment.ElementaryStreamTypes.VIDEO] = false, _elementaryStreams);
    }

    /**
     * `type` property for this._elementaryStreams
     *
     * @enum
     */


    /**
     * @param {ElementaryStreamType} type
     */
    Fragment.prototype.addElementaryStream = function addElementaryStream(type) {
      this._elementaryStreams[type] = true;
    };

    /**
     * @param {ElementaryStreamType} type
     */


    Fragment.prototype.hasElementaryStream = function hasElementaryStream(type) {
      return this._elementaryStreams[type] === true;
    };

    /**
     * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
     * @returns {Uint8Array}
     */


    Fragment.prototype.createInitializationVector = function createInitializationVector(segmentNumber) {
      var uint8View = new Uint8Array(16);

      for (var i = 12; i < 16; i++) {
        uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
      }return uint8View;
    };

    /**
     * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
     * @param levelkey - a playlist's encryption info
     * @param segmentNumber - the fragment's segment number
     * @returns {*} - an object to be applied as a fragment's decryptdata
     */


    Fragment.prototype.fragmentDecryptdataFromLevelkey = function fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
      var decryptdata = levelkey;

      if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
        decryptdata = new level_key();
        decryptdata.method = levelkey.method;
        decryptdata.baseuri = levelkey.baseuri;
        decryptdata.reluri = levelkey.reluri;
        decryptdata.iv = this.createInitializationVector(segmentNumber);
      }

      return decryptdata;
    };

    fragment__createClass(Fragment, [{
      key: 'url',
      get: function get() {
        if (!this._url && this.relurl) this._url = url_toolkit_default.a.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });

        return this._url;
      },
      set: function set(value) {
        this._url = value;
      }
    }, {
      key: 'programDateTime',
      get: function get() {
        if (!this._programDateTime && this.rawProgramDateTime) this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));

        return this._programDateTime;
      }
    }, {
      key: 'byteRange',
      get: function get() {
        if (!this._byteRange && !this.rawByteRange) return [];

        if (this._byteRange) return this._byteRange;

        var byteRange = [];
        if (this.rawByteRange) {
          var params = this.rawByteRange.split('@', 2);
          if (params.length === 1) {
            var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
            byteRange[0] = lastByteRangeEndOffset || 0;
          } else {
            byteRange[0] = parseInt(params[1]);
          }
          byteRange[1] = parseInt(params[0]) + byteRange[0];
          this._byteRange = byteRange;
        }
        return byteRange;
      }

      /**
       * @type {number}
       */

    }, {
      key: 'byteRangeStartOffset',
      get: function get() {
        return this.byteRange[0];
      }
    }, {
      key: 'byteRangeEndOffset',
      get: function get() {
        return this.byteRange[1];
      }
    }, {
      key: 'decryptdata',
      get: function get() {
        if (!this._decryptdata) this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);

        return this._decryptdata;
      }
    }], [{
      key: 'ElementaryStreamTypes',
      get: function get() {
        return {
          AUDIO: 'audio',
          VIDEO: 'video'
        };
      }
    }]);

    return Fragment;
  }();

  /* harmony default export */ var loader_fragment = (fragment_Fragment);
  // CONCATENATED MODULE: ./src/utils/attr-list.js
  function attr_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/; // eslint-disable-line no-useless-escape
  var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g; // eslint-disable-line no-useless-escape

  // adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js

  var AttrList = function () {
    function AttrList(attrs) {
      attr_list__classCallCheck(this, AttrList);

      if (typeof attrs === 'string') attrs = AttrList.parseAttrList(attrs);

      for (var attr in attrs) {
        if (attrs.hasOwnProperty(attr)) this[attr] = attrs[attr];
      }
    }

    AttrList.prototype.decimalInteger = function decimalInteger(attrName) {
      var intValue = parseInt(this[attrName], 10);
      if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;

      return intValue;
    };

    AttrList.prototype.hexadecimalInteger = function hexadecimalInteger(attrName) {
      if (this[attrName]) {
        var stringValue = (this[attrName] || '0x').slice(2);
        stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;

        var value = new Uint8Array(stringValue.length / 2);
        for (var i = 0; i < stringValue.length / 2; i++) {
          value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
        }return value;
      } else {
        return null;
      }
    };

    AttrList.prototype.hexadecimalIntegerAsNumber = function hexadecimalIntegerAsNumber(attrName) {
      var intValue = parseInt(this[attrName], 16);
      if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;

      return intValue;
    };

    AttrList.prototype.decimalFloatingPoint = function decimalFloatingPoint(attrName) {
      return parseFloat(this[attrName]);
    };

    AttrList.prototype.enumeratedString = function enumeratedString(attrName) {
      return this[attrName];
    };

    AttrList.prototype.decimalResolution = function decimalResolution(attrName) {
      var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
      if (res === null) return undefined;

      return {
        width: parseInt(res[1], 10),
        height: parseInt(res[2], 10)
      };
    };

    AttrList.parseAttrList = function parseAttrList(input) {
      var match = void 0,
          attrs = {};
      ATTR_LIST_REGEX.lastIndex = 0;
      while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
        var value = match[2],
            quote = '"';

        if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) value = value.slice(1, -1);

        attrs[match[1]] = value;
      }
      return attrs;
    };

    return AttrList;
  }();

  /* harmony default export */ var attr_list = (AttrList);
  // CONCATENATED MODULE: ./src/utils/codecs.js
  // from http://mp4ra.org/codecs.html
  var sampleEntryCodesISO = {
    audio: {
      'a3ds': true,
      'ac-3': true,
      'ac-4': true,
      'alac': true,
      'alaw': true,
      'dra1': true,
      'dts+': true,
      'dts-': true,
      'dtsc': true,
      'dtse': true,
      'dtsh': true,
      'ec-3': true,
      'enca': true,
      'g719': true,
      'g726': true,
      'm4ae': true,
      'mha1': true,
      'mha2': true,
      'mhm1': true,
      'mhm2': true,
      'mlpa': true,
      'mp4a': true,
      'raw ': true,
      'Opus': true,
      'samr': true,
      'sawb': true,
      'sawp': true,
      'sevc': true,
      'sqcp': true,
      'ssmv': true,
      'twos': true,
      'ulaw': true
    },
    video: {
      'avc1': true,
      'avc2': true,
      'avc3': true,
      'avc4': true,
      'avcp': true,
      'drac': true,
      'dvav': true,
      'dvhe': true,
      'encv': true,
      'hev1': true,
      'hvc1': true,
      'mjp2': true,
      'mp4v': true,
      'mvc1': true,
      'mvc2': true,
      'mvc3': true,
      'mvc4': true,
      'resv': true,
      'rv60': true,
      's263': true,
      'svc1': true,
      'svc2': true,
      'vc-1': true,
      'vp08': true,
      'vp09': true
    }
  };

  function isCodecType(codec, type) {
    var typeCodes = sampleEntryCodesISO[type];
    return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
  }

  function isCodecSupportedInMp4(codec, type) {
    return MediaSource.isTypeSupported((type || 'video') + '/mp4;codecs="' + codec + '"');
  }


  // CONCATENATED MODULE: ./src/loader/m3u8-parser.js
  function m3u8_parser__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










  /**
   * M3U8 parser
   * @module
   */

  // https://regex101.com is your friend
  var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
  var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;

  var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /|(?!#)(\S+)/.source, // segment URI, group 3 => the URI (note newline is not eaten)
  /|#EXT-X-BYTERANGE:*(.+)/.source, // next segment's byterange, group 4 => range spec (x@y)
  /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, // next segment's program date/time group 5 => the datetime spec
  /|#.*/.source // All other non-segment oriented tags will match with all groups empty
  ].join(''), 'g');

  var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;

  var m3u8_parser_M3U8Parser = function () {
    function M3U8Parser() {
      m3u8_parser__classCallCheck(this, M3U8Parser);
    }

    M3U8Parser.findGroup = function findGroup(groups, mediaGroupId) {
      if (!groups) return null;

      var matchingGroup = null;

      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        if (group.id === mediaGroupId) matchingGroup = group;
      }

      return matchingGroup;
    };

    M3U8Parser.convertAVC1ToAVCOTI = function convertAVC1ToAVCOTI(codec) {
      var result = void 0,
          avcdata = codec.split('.');
      if (avcdata.length > 2) {
        result = avcdata.shift() + '.';
        result += parseInt(avcdata.shift()).toString(16);
        result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
      } else {
        result = codec;
      }
      return result;
    };

    M3U8Parser.resolve = function resolve(url, baseUrl) {
      return url_toolkit_default.a.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
    };

    M3U8Parser.parseMasterPlaylist = function parseMasterPlaylist(string, baseurl) {
      var levels = [],
          result = void 0;
      MASTER_PLAYLIST_REGEX.lastIndex = 0;

      function setCodecs(codecs, level) {
        ['video', 'audio'].forEach(function (type) {
          var filtered = codecs.filter(function (codec) {
            return isCodecType(codec, type);
          });
          if (filtered.length) {
            var preferred = filtered.filter(function (codec) {
              return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
            });
            level[type + 'Codec'] = preferred.length > 0 ? preferred[0] : filtered[0];

            // remove from list
            codecs = codecs.filter(function (codec) {
              return filtered.indexOf(codec) === -1;
            });
          }
        });

        level.unknownCodecs = codecs;
      }

      while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
        var level = {};

        var attrs = level.attrs = new attr_list(result[1]);
        level.url = M3U8Parser.resolve(result[2], baseurl);

        var resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
        level.name = attrs.NAME;

        setCodecs([].concat((attrs.CODECS || '').split(/[ ,]+/)), level);

        if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);

        levels.push(level);
      }
      return levels;
    };

    M3U8Parser.parseMasterPlaylistMedia = function parseMasterPlaylistMedia(string, baseurl, type) {
      var audioGroups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var result = void 0;
      var medias = [];
      var id = 0;
      MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
      while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
        var media = {};
        var attrs = new attr_list(result[1]);
        if (attrs.TYPE === type) {
          media.groupId = attrs['GROUP-ID'];
          media.name = attrs.NAME;
          media.type = type;
          media.default = attrs.DEFAULT === 'YES';
          media.autoselect = attrs.AUTOSELECT === 'YES';
          media.forced = attrs.FORCED === 'YES';
          if (attrs.URI) media.url = M3U8Parser.resolve(attrs.URI, baseurl);

          media.lang = attrs.LANGUAGE;
          if (!media.name) media.name = media.lang;

          if (audioGroups.length) {
            var groupCodec = M3U8Parser.findGroup(audioGroups, media.groupId);
            media.audioCodec = groupCodec ? groupCodec.codec : audioGroups[0].codec;
          }
          media.id = id++;
          medias.push(media);
        }
      }
      return medias;
    };

    M3U8Parser.parseLevelPlaylist = function parseLevelPlaylist(string, baseurl, id, type) {
      var currentSN = 0,
          totalduration = 0,
          level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 },
          levelkey = new level_key(),
          cc = 0,
          prevFrag = null,
          frag = new loader_fragment(),
          result = void 0,
          i = void 0;

      LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;

      while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
        var duration = result[1];
        if (duration) {
          // INF
          frag.duration = parseFloat(duration);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var title = (' ' + result[2]).slice(1);
          frag.title = title || null;
          frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
        } else if (result[3]) {
          // url
          if (!isNaN(frag.duration)) {
            var sn = currentSN++;
            frag.type = type;
            frag.start = totalduration;
            frag.levelkey = levelkey;
            frag.sn = sn;
            frag.level = id;
            frag.cc = cc;
            frag.baseurl = baseurl;
            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
            frag.relurl = (' ' + result[3]).slice(1);

            if (level.programDateTime) {
              if (prevFrag) {
                if (frag.rawProgramDateTime) {
                  // PDT discontinuity found
                  frag.pdt = Date.parse(frag.rawProgramDateTime);
                } else {
                  // Contiguous fragment
                  frag.pdt = prevFrag.pdt + prevFrag.duration * 1000;
                }
              } else {
                // First fragment
                frag.pdt = Date.parse(level.programDateTime);
              }
              frag.endPdt = frag.pdt + frag.duration * 1000;
            }

            level.fragments.push(frag);
            prevFrag = frag;
            totalduration += frag.duration;

            frag = new loader_fragment();
          }
        } else if (result[4]) {
          // X-BYTERANGE
          frag.rawByteRange = (' ' + result[4]).slice(1);
          if (prevFrag) {
            var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
            if (lastByteRangeEndOffset) frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
          }
        } else if (result[5]) {
          // PROGRAM-DATE-TIME
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          frag.rawProgramDateTime = (' ' + result[5]).slice(1);
          frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
          if (level.programDateTime === undefined) level.programDateTime = new Date(new Date(Date.parse(result[5])) - 1000 * totalduration);
        } else {
          result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
          for (i = 1; i < result.length; i++) {
            if (result[i] !== undefined) break;
          }

          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var value1 = (' ' + result[i + 1]).slice(1);
          var value2 = (' ' + result[i + 2]).slice(1);

          switch (result[i]) {
            case '#':
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
              break;
            case 'PLAYLIST-TYPE':
              level.type = value1.toUpperCase();
              break;
            case 'MEDIA-SEQUENCE':
              currentSN = level.startSN = parseInt(value1);
              break;
            case 'TARGETDURATION':
              level.targetduration = parseFloat(value1);
              break;
            case 'VERSION':
              level.version = parseInt(value1);
              break;
            case 'EXTM3U':
              break;
            case 'ENDLIST':
              level.live = false;
              break;
            case 'DIS':
              cc++;
              frag.tagList.push(['DIS']);
              break;
            case 'DISCONTINUITY-SEQ':
              cc = parseInt(value1);
              break;
            case 'KEY':
              // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
              var decryptparams = value1;
              var keyAttrs = new attr_list(decryptparams);
              var decryptmethod = keyAttrs.enumeratedString('METHOD'),
                  decrypturi = keyAttrs.URI,
                  decryptiv = keyAttrs.hexadecimalInteger('IV');
              if (decryptmethod) {
                levelkey = new level_key();
                if (decrypturi && ['AES-128', 'SAMPLE-AES', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0) {
                  levelkey.method = decryptmethod;
                  // URI to get the key
                  levelkey.baseuri = baseurl;
                  levelkey.reluri = decrypturi;
                  levelkey.key = null;
                  // Initialization Vector (IV)
                  levelkey.iv = decryptiv;
                }
              }
              break;
            case 'START':
              var startParams = value1;
              var startAttrs = new attr_list(startParams);
              var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
              // TIME-OFFSET can be 0
              if (!isNaN(startTimeOffset)) level.startTimeOffset = startTimeOffset;

              break;
            case 'MAP':
              var mapAttrs = new attr_list(value1);
              frag.relurl = mapAttrs.URI;
              frag.rawByteRange = mapAttrs.BYTERANGE;
              frag.baseurl = baseurl;
              frag.level = id;
              frag.type = type;
              frag.sn = 'initSegment';
              level.initSegment = frag;
              frag = new loader_fragment();
              break;
            default:
              logger["b" /* logger */].warn('line parsed but not handled: ' + result);
              break;
          }
        }
      }
      frag = prevFrag;
      // logger.log('found ' + level.fragments.length + ' fragments');
      if (frag && !frag.relurl) {
        level.fragments.pop();
        totalduration -= frag.duration;
      }
      level.totalduration = totalduration;
      level.averagetargetduration = totalduration / level.fragments.length;
      level.endSN = currentSN - 1;
      level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
      level.endCC = cc;

      if (!level.initSegment && level.fragments.length) {
        // this is a bit lurky but HLS really has no other way to tell us
        // if the fragments are TS or MP4, except if we download them :/
        // but this is to be able to handle SIDX.
        // FIXME: replace string test by a regex that matches
        //        also `m4s` `m4a` `m4v` and other popular extensions
        if (level.fragments.every(function (frag) {
          return frag.relurl.endsWith('.mp4');
        })) {
          logger["b" /* logger */].warn('MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX');

          frag = new loader_fragment();
          frag.relurl = level.fragments[0].relurl;
          frag.baseurl = baseurl;
          frag.level = id;
          frag.type = type;
          frag.sn = 'initSegment';

          level.initSegment = frag;
          level.needSidxRanges = true;
        }
      }

      return level;
    };

    return M3U8Parser;
  }();

  /* harmony default export */ var m3u8_parser = (m3u8_parser_M3U8Parser);
  // CONCATENATED MODULE: ./src/loader/playlist-loader.js
  var playlist_loader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function playlist_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /**
   * PlaylistLoader - delegate for media manifest/playlist loading tasks. Takes care of parsing media to internal data-models.
   *
   * Once loaded, dispatches events with parsed data-models of manifest/levels/audio/subtitle tracks.
   *
   * Uses loader(s) set in config to do actual internal loading of resource tasks.
   *
   * @module
   *
   */










  /**
   * `type` property values for this loaders' context object
   * @enum
   *
   */
  var ContextType = {
    MANIFEST: 'manifest',
    LEVEL: 'level',
    AUDIO_TRACK: 'audioTrack',
    SUBTITLE_TRACK: 'subtitleTrack'
  };

  /**
   * @enum {string}
   */
  var LevelType = {
    MAIN: 'main',
    AUDIO: 'audio',
    SUBTITLE: 'subtitle'
  };

  /**
   * @constructor
   */

  var playlist_loader_PlaylistLoader = function (_EventHandler) {
    _inherits(PlaylistLoader, _EventHandler);

    /**
     * @constructs
     * @param {Hls} hls
     */
    function PlaylistLoader(hls) {
      playlist_loader__classCallCheck(this, PlaylistLoader);

      var _this = _possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].LEVEL_LOADING, events["a" /* default */].AUDIO_TRACK_LOADING, events["a" /* default */].SUBTITLE_TRACK_LOADING));

      _this.loaders = {};
      return _this;
    }

    /**
     * @param {ContextType} type
     * @returns {boolean}
     */
    PlaylistLoader.canHaveQualityLevels = function canHaveQualityLevels(type) {
      return type !== ContextType.AUDIO_TRACK && type !== ContextType.SUBTITLE_TRACK;
    };

    /**
     * Map context.type to LevelType
     * @param {{type: ContextType}} context
     * @returns {LevelType}
     */


    PlaylistLoader.mapContextToLevelType = function mapContextToLevelType(context) {
      var type = context.type;


      switch (type) {
        case ContextType.AUDIO_TRACK:
          return LevelType.AUDIO;
        case ContextType.SUBTITLE_TRACK:
          return LevelType.SUBTITLE;
        default:
          return LevelType.MAIN;
      }
    };

    PlaylistLoader.getResponseUrl = function getResponseUrl(response, context) {
      var url = response.url;
      // responseURL not supported on some browsers (it is used to detect URL redirection)
      // data-uri mode also not supported (but no need to detect redirection)
      if (url === undefined || url.indexOf('data:') === 0) {
        // fallback to initial URL
        url = context.url;
      }
      return url;
    };

    /**
     * Returns defaults or configured loader-type overloads (pLoader and loader config params)
     * Default loader is XHRLoader (see utils)
     * @param {object} context
     * @returns {XHRLoader} or other compatible configured overload
     */


    PlaylistLoader.prototype.createInternalLoader = function createInternalLoader(context) {
      var config = this.hls.config;
      var PLoader = config.pLoader;
      var Loader = config.loader;
      var InternalLoader = PLoader || Loader;

      var loader = new InternalLoader(config);

      context.loader = loader;
      this.loaders[context.type] = loader;

      return loader;
    };

    PlaylistLoader.prototype.getInternalLoader = function getInternalLoader(context) {
      return this.loaders[context.type];
    };

    PlaylistLoader.prototype.resetInternalLoader = function resetInternalLoader(contextType) {
      if (this.loaders[contextType]) delete this.loaders[contextType];
    };

    /**
     * Call `destroy` on all internal loader instances mapped (one per context type)
     */


    PlaylistLoader.prototype.destroyInternalLoaders = function destroyInternalLoaders() {
      for (var contextType in this.loaders) {
        var loader = this.loaders[contextType];
        if (loader) loader.destroy();

        this.resetInternalLoader(contextType);
      }
    };

    PlaylistLoader.prototype.destroy = function destroy() {
      this.destroyInternalLoaders();

      _EventHandler.prototype.destroy.call(this);
    };

    PlaylistLoader.prototype.onManifestLoading = function onManifestLoading(data) {
      this.load(data.url, { type: ContextType.MANIFEST });
    };

    PlaylistLoader.prototype.onLevelLoading = function onLevelLoading(data) {
      this.load(data.url, { type: ContextType.LEVEL, level: data.level, id: data.id });
    };

    PlaylistLoader.prototype.onAudioTrackLoading = function onAudioTrackLoading(data) {
      this.load(data.url, { type: ContextType.AUDIO_TRACK, id: data.id });
    };

    PlaylistLoader.prototype.onSubtitleTrackLoading = function onSubtitleTrackLoading(data) {
      this.load(data.url, { type: ContextType.SUBTITLE_TRACK, id: data.id });
    };

    PlaylistLoader.prototype.load = function load(url, context) {
      var config = this.hls.config;

      // Check if a loader for this context already exists
      var loader = this.getInternalLoader(context);
      if (loader) {
        var loaderContext = loader.context;
        if (loaderContext && loaderContext.url === url) {
          // same URL can't overlap
          logger["b" /* logger */].trace('playlist request ongoing');
          return false;
        } else {
          logger["b" /* logger */].warn('aborting previous loader for type: ' + context.type);
          loader.abort();
        }
      }
      var maxRetry = void 0,
          timeout = void 0,
          retryDelay = void 0,
          maxRetryDelay = void 0;

      // apply different configs for retries depending on
      // context (manifest, level, audio/subs playlist)
      switch (context.type) {
        case ContextType.MANIFEST:
          maxRetry = config.manifestLoadingMaxRetry;
          timeout = config.manifestLoadingTimeOut;
          retryDelay = config.manifestLoadingRetryDelay;
          maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
          break;
        case ContextType.LEVEL:
          // Disable internal loader retry logic, since we are managing retries in Level Controller
          maxRetry = 0;
          timeout = config.levelLoadingTimeOut;
          // TODO Introduce retry settings for audio-track and subtitle-track, it should not use level retry config
          break;
        default:
          maxRetry = config.levelLoadingMaxRetry;
          timeout = config.levelLoadingTimeOut;
          retryDelay = config.levelLoadingRetryDelay;
          maxRetryDelay = config.levelLoadingMaxRetryTimeout;
          logger["b" /* logger */].log('Playlist loader for ' + context.type + ' ' + (context.level || context.id));
          break;
      }

      loader = this.createInternalLoader(context);

      context.url = url;
      context.responseType = context.responseType || ''; // FIXME: (should not be necessary to do this)

      var loaderConfig = void 0,
          loaderCallbacks = void 0;

      loaderConfig = {
        timeout: timeout,
        maxRetry: maxRetry,
        retryDelay: retryDelay,
        maxRetryDelay: maxRetryDelay
      };

      loaderCallbacks = {
        onSuccess: this.loadsuccess.bind(this),
        onError: this.loaderror.bind(this),
        onTimeout: this.loadtimeout.bind(this)
      };

      loader.load(context, loaderConfig, loaderCallbacks);

      return true;
    };

    PlaylistLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (context.isSidxRequest) {
        this._handleSidxRequest(response, context);
        this._handlePlaylistLoaded(response, stats, context, networkDetails);
        return;
      }

      this.resetInternalLoader(context.type);

      var string = response.data;

      stats.tload = performance.now();
      // stats.mtime = new Date(target.getResponseHeader('Last-Modified'));

      // Validate if it is an M3U8 at all
      if (string.indexOf('#EXTM3U') !== 0) {
        this._handleManifestParsingError(response, context, 'no EXTM3U delimiter', networkDetails);
        return;
      }

      // Check if chunk-list or master. handle empty chunk list case (first EXTINF not signaled, but TARGETDURATION present)
      if (string.indexOf('#EXTINF:') > 0 || string.indexOf('#EXT-X-TARGETDURATION:') > 0) this._handleTrackOrLevelPlaylist(response, stats, context, networkDetails);else this._handleMasterPlaylist(response, stats, context, networkDetails);
    };

    PlaylistLoader.prototype.loaderror = function loaderror(response, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this._handleNetworkError(context, networkDetails);
    };

    PlaylistLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this._handleNetworkError(context, networkDetails, true);
    };

    PlaylistLoader.prototype._handleMasterPlaylist = function _handleMasterPlaylist(response, stats, context, networkDetails) {
      var hls = this.hls;
      var string = response.data;

      var url = PlaylistLoader.getResponseUrl(response, context);

      var levels = m3u8_parser.parseMasterPlaylist(string, url);
      if (!levels.length) {
        this._handleManifestParsingError(response, context, 'no level found in manifest', networkDetails);
        return;
      }

      // multi level playlist, parse level info

      var audioGroups = levels.map(function (level) {
        return {
          id: level.attrs.AUDIO,
          codec: level.audioCodec
        };
      });

      var audioTracks = m3u8_parser.parseMasterPlaylistMedia(string, url, 'AUDIO', audioGroups);
      var subtitles = m3u8_parser.parseMasterPlaylistMedia(string, url, 'SUBTITLES');

      if (audioTracks.length) {
        // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
        var embeddedAudioFound = false;
        audioTracks.forEach(function (audioTrack) {
          if (!audioTrack.url) embeddedAudioFound = true;
        });

        // if no embedded audio track defined, but audio codec signaled in quality level,
        // we need to signal this main audio track this could happen with playlists with
        // alt audio rendition in which quality levels (main)
        // contains both audio+video. but with mixed audio track not signaled
        if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
          logger["b" /* logger */].log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
          audioTracks.unshift({
            type: 'main',
            name: 'main'
          });
        }
      }

      hls.trigger(events["a" /* default */].MANIFEST_LOADED, {
        levels: levels,
        audioTracks: audioTracks,
        subtitles: subtitles,
        url: url,
        stats: stats,
        networkDetails: networkDetails
      });
    };

    PlaylistLoader.prototype._handleTrackOrLevelPlaylist = function _handleTrackOrLevelPlaylist(response, stats, context, networkDetails) {
      var hls = this.hls;

      var id = context.id,
          level = context.level,
          type = context.type;


      var url = PlaylistLoader.getResponseUrl(response, context);

      var levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0; // level -> id -> 0
      var levelType = PlaylistLoader.mapContextToLevelType(context);

      var levelDetails = m3u8_parser.parseLevelPlaylist(response.data, url, levelId, levelType);

      // set stats on level structure
      levelDetails.tload = stats.tload;

      // We have done our first request (Manifest-type) and receive
      // not a master playlist but a chunk-list (track/level)
      // We fire the manifest-loaded event anyway with the parsed level-details
      // by creating a single-level structure for it.
      if (type === ContextType.MANIFEST) {
        var singleLevel = {
          url: url,
          details: levelDetails
        };

        hls.trigger(events["a" /* default */].MANIFEST_LOADED, {
          levels: [singleLevel],
          audioTracks: [],
          url: url,
          stats: stats,
          networkDetails: networkDetails
        });
      }

      // save parsing time
      stats.tparsed = performance.now();

      // in case we need SIDX ranges
      // return early after calling load for
      // the SIDX box.
      if (levelDetails.needSidxRanges) {
        var sidxUrl = levelDetails.initSegment.url;
        this.load(sidxUrl, {
          isSidxRequest: true,
          type: type,
          level: level,
          levelDetails: levelDetails,
          id: id,
          rangeStart: 0,
          rangeEnd: 2048,
          responseType: 'arraybuffer'
        });
        return;
      }

      // extend the context with the new levelDetails property
      context.levelDetails = levelDetails;

      this._handlePlaylistLoaded(response, stats, context, networkDetails);
    };

    PlaylistLoader.prototype._handleSidxRequest = function _handleSidxRequest(response, context) {
      var sidxInfo = mp4demuxer["a" /* default */].parseSegmentIndex(new Uint8Array(response.data));
      sidxInfo.references.forEach(function (segmentRef, index) {
        var segRefInfo = segmentRef.info;
        var frag = context.levelDetails.fragments[index];

        if (frag.byteRange.length === 0) frag.rawByteRange = String(1 + segRefInfo.end - segRefInfo.start) + '@' + String(segRefInfo.start);
      });

      context.levelDetails.initSegment.rawByteRange = String(sidxInfo.moovEndOffset) + '@0';
    };

    PlaylistLoader.prototype._handleManifestParsingError = function _handleManifestParsingError(response, context, reason, networkDetails) {
      this.hls.trigger(events["a" /* default */].ERROR, {
        type: errors["b" /* ErrorTypes */].NETWORK_ERROR,
        details: errors["a" /* ErrorDetails */].MANIFEST_PARSING_ERROR,
        fatal: true,
        url: response.url,
        reason: reason,
        networkDetails: networkDetails
      });
    };

    PlaylistLoader.prototype._handleNetworkError = function _handleNetworkError(context, networkDetails) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var details = void 0;
      var fatal = void 0;

      var loader = this.getInternalLoader(context);

      switch (context.type) {
        case ContextType.MANIFEST:
          details = timeout ? errors["a" /* ErrorDetails */].MANIFEST_LOAD_TIMEOUT : errors["a" /* ErrorDetails */].MANIFEST_LOAD_ERROR;
          fatal = true;
          break;
        case ContextType.LEVEL:
          details = timeout ? errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT : errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR;
          fatal = false;
          break;
        case ContextType.AUDIO_TRACK:
          details = timeout ? errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_TIMEOUT : errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_ERROR;
          fatal = false;
          break;
        default:
          // details = ...?
          fatal = false;
      }

      if (loader) {
        loader.abort();
        this.resetInternalLoader(context.type);
      }

      this.hls.trigger(events["a" /* default */].ERROR, {
        type: errors["b" /* ErrorTypes */].NETWORK_ERROR,
        details: details,
        fatal: fatal,
        url: loader.url,
        loader: loader,
        context: context,
        networkDetails: networkDetails
      });
    };

    PlaylistLoader.prototype._handlePlaylistLoaded = function _handlePlaylistLoaded(response, stats, context, networkDetails) {
      var type = context.type,
          level = context.level,
          id = context.id,
          levelDetails = context.levelDetails;


      if (!levelDetails.targetduration) {
        this._handleManifestParsingError(response, context, 'invalid target duration', networkDetails);
        return;
      }

      var canHaveLevels = PlaylistLoader.canHaveQualityLevels(context.type);
      if (canHaveLevels) {
        this.hls.trigger(events["a" /* default */].LEVEL_LOADED, {
          details: levelDetails,
          level: level || 0,
          id: id || 0,
          stats: stats,
          networkDetails: networkDetails
        });
      } else {
        switch (type) {
          case ContextType.AUDIO_TRACK:
            this.hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADED, {
              details: levelDetails,
              id: id,
              stats: stats,
              networkDetails: networkDetails
            });
            break;
          case ContextType.SUBTITLE_TRACK:
            this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADED, {
              details: levelDetails,
              id: id,
              stats: stats,
              networkDetails: networkDetails
            });
            break;
        }
      }
    };

    playlist_loader__createClass(PlaylistLoader, null, [{
      key: 'ContextType',
      get: function get() {
        return ContextType;
      }
    }, {
      key: 'LevelType',
      get: function get() {
        return LevelType;
      }
    }]);

    return PlaylistLoader;
  }(event_handler);

  /* harmony default export */ var playlist_loader = (playlist_loader_PlaylistLoader);
  // CONCATENATED MODULE: ./src/loader/fragment-loader.js
  function fragment_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function fragment_loader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function fragment_loader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Fragment Loader
  */






  var fragment_loader_FragmentLoader = function (_EventHandler) {
    fragment_loader__inherits(FragmentLoader, _EventHandler);

    function FragmentLoader(hls) {
      fragment_loader__classCallCheck(this, FragmentLoader);

      var _this = fragment_loader__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FRAG_LOADING));

      _this.loaders = {};
      return _this;
    }

    FragmentLoader.prototype.destroy = function destroy() {
      var loaders = this.loaders;
      for (var loaderName in loaders) {
        var loader = loaders[loaderName];
        if (loader) loader.destroy();
      }
      this.loaders = {};

      _EventHandler.prototype.destroy.call(this);
    };

    FragmentLoader.prototype.onFragLoading = function onFragLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loaders = this.loaders,
          config = this.hls.config,
          FragmentILoader = config.fLoader,
          DefaultILoader = config.loader;

      // reset fragment state
      frag.loaded = 0;

      var loader = loaders[type];
      if (loader) {
        logger["b" /* logger */].warn('abort previous fragment loader for type: ' + type);
        loader.abort();
      }

      loader = loaders[type] = frag.loader = config.fLoader ? new FragmentILoader(config) : new DefaultILoader(config);

      var loaderContext = void 0,
          loaderConfig = void 0,
          loaderCallbacks = void 0;

      loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };

      var start = frag.byteRangeStartOffset,
          end = frag.byteRangeEndOffset;

      if (!isNaN(start) && !isNaN(end)) {
        loaderContext.rangeStart = start;
        loaderContext.rangeEnd = end;
      }

      loaderConfig = {
        timeout: config.fragLoadingTimeOut,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: config.fragLoadingMaxRetryTimeout
      };

      loaderCallbacks = {
        onSuccess: this.loadsuccess.bind(this),
        onError: this.loaderror.bind(this),
        onTimeout: this.loadtimeout.bind(this),
        onProgress: this.loadprogress.bind(this)
      };

      loader.load(loaderContext, loaderConfig, loaderCallbacks);
    };

    FragmentLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var payload = response.data,
          frag = context.frag;
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(events["a" /* default */].FRAG_LOADED, { payload: payload, frag: frag, stats: stats, networkDetails: networkDetails });
    };

    FragmentLoader.prototype.loaderror = function loaderror(response, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var loader = context.loader;
      if (loader) loader.abort();

      this.loaders[context.type] = undefined;
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response, networkDetails: networkDetails });
    };

    FragmentLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var loader = context.loader;
      if (loader) loader.abort();

      this.loaders[context.type] = undefined;
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag, networkDetails: networkDetails });
    };

    // data will be used for progressive parsing


    FragmentLoader.prototype.loadprogress = function loadprogress(stats, context, data) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      // jshint ignore:line
      var frag = context.frag;
      frag.loaded = stats.loaded;
      this.hls.trigger(events["a" /* default */].FRAG_LOAD_PROGRESS, { frag: frag, stats: stats, networkDetails: networkDetails });
    };

    return FragmentLoader;
  }(event_handler);

  /* harmony default export */ var fragment_loader = (fragment_loader_FragmentLoader);
  // CONCATENATED MODULE: ./src/loader/key-loader.js
  function key_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function key_loader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function key_loader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Decrypt key Loader
  */






  var key_loader_KeyLoader = function (_EventHandler) {
    key_loader__inherits(KeyLoader, _EventHandler);

    function KeyLoader(hls) {
      key_loader__classCallCheck(this, KeyLoader);

      var _this = key_loader__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].KEY_LOADING));

      _this.loaders = {};
      _this.decryptkey = null;
      _this.decrypturl = null;
      return _this;
    }

    KeyLoader.prototype.destroy = function destroy() {
      for (var loaderName in this.loaders) {
        var loader = this.loaders[loaderName];
        if (loader) loader.destroy();
      }
      this.loaders = {};
      event_handler.prototype.destroy.call(this);
    };

    KeyLoader.prototype.onKeyLoading = function onKeyLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loader = this.loaders[type],
          decryptdata = frag.decryptdata,
          uri = decryptdata.uri;
      // if uri is different from previous one or if decrypt key not retrieved yet
      if (uri !== this.decrypturl || this.decryptkey === null) {
        var config = this.hls.config;

        if (loader) {
          logger["b" /* logger */].warn('abort previous key loader for type:' + type);
          loader.abort();
        }
        frag.loader = this.loaders[type] = new config.loader(config);
        this.decrypturl = uri;
        this.decryptkey = null;

        var loaderContext = void 0,
            loaderConfig = void 0,
            loaderCallbacks = void 0;
        loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
        loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: config.fragLoadingMaxRetry, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
        loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
        frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
      } else if (this.decryptkey) {
        // we already loaded this key, return it
        decryptdata.key = this.decryptkey;
        this.hls.trigger(events["a" /* default */].KEY_LOADED, { frag: frag });
      }
    };

    KeyLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
      var frag = context.frag;
      this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(events["a" /* default */].KEY_LOADED, { frag: frag });
    };

    KeyLoader.prototype.loaderror = function loaderror(response, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) loader.abort();

      this.loaders[context.type] = undefined;
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
    };

    KeyLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) loader.abort();

      this.loaders[context.type] = undefined;
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
    };

    return KeyLoader;
  }(event_handler);

  /* harmony default export */ var key_loader = (key_loader_KeyLoader);
  // CONCATENATED MODULE: ./src/utils/binary-search.js
  var BinarySearch = {
    /**
       * Searches for an item in an array which matches a certain condition.
       * This requires the condition to only match one item in the array,
       * and for the array to be ordered.
       *
       * @param {Array} list The array to search.
       * @param {Function} comparisonFunction
       *      Called and provided a candidate item as the first argument.
       *      Should return:
       *          > -1 if the item should be located at a lower index than the provided item.
       *          > 1 if the item should be located at a higher index than the provided item.
       *          > 0 if the item is the item you're looking for.
       *
       * @return {*} The object if it is found or null otherwise.
       */
    search: function search(list, comparisonFunction) {
      var minIndex = 0;
      var maxIndex = list.length - 1;
      var currentIndex = null;
      var currentElement = null;

      while (minIndex <= maxIndex) {
        currentIndex = (minIndex + maxIndex) / 2 | 0;
        currentElement = list[currentIndex];

        var comparisonResult = comparisonFunction(currentElement);
        if (comparisonResult > 0) minIndex = currentIndex + 1;else if (comparisonResult < 0) maxIndex = currentIndex - 1;else return currentElement;
      }

      return null;
    }
  };

  /* harmony default export */ var binary_search = (BinarySearch);
  // CONCATENATED MODULE: ./src/helper/buffer-helper.js
  /**
   * Buffer Helper utils, providing methods dealing buffer length retrieval
  */

  var BufferHelper = {
    /**
     * Return true if `media`'s buffered include `position`
     * @param {HTMLMediaElement|SourceBuffer} media
     * @param {number} position
     * @returns {boolean}
     */
    isBuffered: function isBuffered(media, position) {
      try {
        if (media) {
          var buffered = media.buffered;
          for (var i = 0; i < buffered.length; i++) {
            if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
          }
        }
      } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
      }
      return false;
    },

    bufferInfo: function bufferInfo(media, pos, maxHoleDuration) {
      try {
        if (media) {
          var vbuffered = media.buffered,
              buffered = [],
              i = void 0;
          for (i = 0; i < vbuffered.length; i++) {
            buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
          }return this.bufferedInfo(buffered, pos, maxHoleDuration);
        }
      } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
      }
      return { len: 0, start: pos, end: pos, nextStart: undefined };
    },

    bufferedInfo: function bufferedInfo(buffered, pos, maxHoleDuration) {
      var buffered2 = [],

      // bufferStart and bufferEnd are buffer boundaries around current video position
      bufferLen = void 0,
          bufferStart = void 0,
          bufferEnd = void 0,
          bufferStartNext = void 0,
          i = void 0;
      // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
      buffered.sort(function (a, b) {
        var diff = a.start - b.start;
        if (diff) return diff;else return b.end - a.end;
      });
      // there might be some small holes between buffer time range
      // consider that holes smaller than maxHoleDuration are irrelevant and build another
      // buffer time range representations that discards those holes
      for (i = 0; i < buffered.length; i++) {
        var buf2len = buffered2.length;
        if (buf2len) {
          var buf2end = buffered2[buf2len - 1].end;
          // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
          if (buffered[i].start - buf2end < maxHoleDuration) {
            // merge overlapping time ranges
            // update lastRange.end only if smaller than item.end
            // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
            // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
            if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
          } else {
            // big hole
            buffered2.push(buffered[i]);
          }
        } else {
          // first value
          buffered2.push(buffered[i]);
        }
      }
      for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
        var start = buffered2[i].start,
            end = buffered2[i].end;
        // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
        if (pos + maxHoleDuration >= start && pos < end) {
          // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
          bufferStart = start;
          bufferEnd = end;
          bufferLen = bufferEnd - pos;
        } else if (pos + maxHoleDuration < start) {
          bufferStartNext = start;
          break;
        }
      }
      return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
    }
  };

  /* harmony default export */ var buffer_helper = (BufferHelper);
  // EXTERNAL MODULE: ./src/demux/demuxer-inline.js + 11 modules
  var demuxer_inline = __webpack_require__(8);

  // EXTERNAL MODULE: ./node_modules/events/events.js
  var events_events = __webpack_require__(6);
  var events_default = /*#__PURE__*/__webpack_require__.n(events_events);

  // EXTERNAL MODULE: ./node_modules/webworkify-webpack/index.js
  var webworkify_webpack = __webpack_require__(10);
  var webworkify_webpack_default = /*#__PURE__*/__webpack_require__.n(webworkify_webpack);

  // CONCATENATED MODULE: ./src/helper/mediasource-helper.js
  /**
   * MediaSource helper
   */

  function getMediaSource() {
    if (typeof window !== 'undefined') return window.MediaSource || window.WebKitMediaSource;
  }
  // CONCATENATED MODULE: ./src/demux/demuxer.js
  function demuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









  var demuxer_MediaSource = getMediaSource();

  var demuxer_Demuxer = function () {
    function Demuxer(hls, id) {
      demuxer__classCallCheck(this, Demuxer);

      this.hls = hls;
      this.id = id;
      // observer setup
      var observer = this.observer = new events_default.a();
      var config = hls.config;
      observer.trigger = function trigger(event) {
        for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          data[_key - 1] = arguments[_key];
        }

        observer.emit.apply(observer, [event, event].concat(data));
      };

      observer.off = function off(event) {
        for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          data[_key2 - 1] = arguments[_key2];
        }

        observer.removeListener.apply(observer, [event].concat(data));
      };

      var forwardMessage = function (ev, data) {
        data = data || {};
        data.frag = this.frag;
        data.id = this.id;
        hls.trigger(ev, data);
      }.bind(this);

      // forward events to main thread
      observer.on(events["a" /* default */].FRAG_DECRYPTED, forwardMessage);
      observer.on(events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
      observer.on(events["a" /* default */].FRAG_PARSING_DATA, forwardMessage);
      observer.on(events["a" /* default */].FRAG_PARSED, forwardMessage);
      observer.on(events["a" /* default */].ERROR, forwardMessage);
      observer.on(events["a" /* default */].FRAG_PARSING_METADATA, forwardMessage);
      observer.on(events["a" /* default */].FRAG_PARSING_USERDATA, forwardMessage);
      observer.on(events["a" /* default */].INIT_PTS_FOUND, forwardMessage);

      var typeSupported = {
        mp4: demuxer_MediaSource.isTypeSupported('video/mp4'),
        mpeg: demuxer_MediaSource.isTypeSupported('audio/mpeg'),
        mp3: demuxer_MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
      };
      // navigator.vendor is not always available in Web Worker
      // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
      var vendor = navigator.vendor;
      if (config.enableWorker && typeof Worker !== 'undefined') {
        logger["b" /* logger */].log('demuxing in webworker');
        var w = void 0;
        try {
          w = this.w = webworkify_webpack_default()(/*require.resolve*/(11));
          this.onwmsg = this.onWorkerMessage.bind(this);
          w.addEventListener('message', this.onwmsg);
          w.onerror = function (event) {
            hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].OTHER_ERROR, details: errors["a" /* ErrorDetails */].INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
          };
          w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
        } catch (err) {
          logger["b" /* logger */].error('error while initializing DemuxerWorker, fallback on DemuxerInline');
          if (w) {
            // revoke the Object URL that was used to create demuxer worker, so as not to leak it
            URL.revokeObjectURL(w.objectURL);
          }
          this.demuxer = new demuxer_inline["a" /* default */](observer, typeSupported, config, vendor);
          this.w = undefined;
        }
      } else {
        this.demuxer = new demuxer_inline["a" /* default */](observer, typeSupported, config, vendor);
      }
    }

    Demuxer.prototype.destroy = function destroy() {
      var w = this.w;
      if (w) {
        w.removeEventListener('message', this.onwmsg);
        w.terminate();
        this.w = null;
      } else {
        var demuxer = this.demuxer;
        if (demuxer) {
          demuxer.destroy();
          this.demuxer = null;
        }
      }
      var observer = this.observer;
      if (observer) {
        observer.removeAllListeners();
        this.observer = null;
      }
    };

    Demuxer.prototype.push = function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
      var w = this.w;
      var timeOffset = !isNaN(frag.startDTS) ? frag.startDTS : frag.start;
      var decryptdata = frag.decryptdata;
      var lastFrag = this.frag;
      var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
      var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
      var nextSN = lastFrag && frag.sn === lastFrag.sn + 1;
      var contiguous = !trackSwitch && nextSN;
      if (discontinuity) logger["b" /* logger */].log(this.id + ':discontinuity detected');

      if (trackSwitch) logger["b" /* logger */].log(this.id + ':switch detected');

      this.frag = frag;
      if (w) {
        // post fragment payload as transferable objects for ArrayBuffer (no copy)
        w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, data instanceof ArrayBuffer ? [data] : []);
      } else {
        var demuxer = this.demuxer;
        if (demuxer) demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
      }
    };

    Demuxer.prototype.onWorkerMessage = function onWorkerMessage(ev) {
      var data = ev.data,
          hls = this.hls;
      switch (data.event) {
        case 'init':
          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
          URL.revokeObjectURL(this.w.objectURL);
          break;
        // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
        case events["a" /* default */].FRAG_PARSING_DATA:
          data.data.data1 = new Uint8Array(data.data1);
          if (data.data2) data.data.data2 = new Uint8Array(data.data2);

        /* falls through */
        default:
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
      }
    };

    return Demuxer;
  }();

  /* harmony default export */ var demux_demuxer = (demuxer_Demuxer);
  // CONCATENATED MODULE: ./src/helper/fragment-tracker.js
  function fragment_tracker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function fragment_tracker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function fragment_tracker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




  var FragmentState = {
    NOT_LOADED: 'NOT_LOADED',
    APPENDING: 'APPENDING',
    PARTIAL: 'PARTIAL',
    OK: 'OK'
  };

  var fragment_tracker_FragmentTracker = function (_EventHandler) {
    fragment_tracker__inherits(FragmentTracker, _EventHandler);

    function FragmentTracker(hls) {
      fragment_tracker__classCallCheck(this, FragmentTracker);

      var _this = fragment_tracker__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].BUFFER_APPENDED, events["a" /* default */].FRAG_BUFFERED, events["a" /* default */].FRAG_LOADED));

      _this.bufferPadding = 0.2;

      _this.fragments = Object.create(null);
      _this.timeRanges = Object.create(null);

      _this.config = hls.config;
      return _this;
    }

    FragmentTracker.prototype.destroy = function destroy() {
      this.fragments = null;
      this.timeRanges = null;
      this.config = null;
      event_handler.prototype.destroy.call(this);
      _EventHandler.prototype.destroy.call(this);
    };

    /**
     * Return a Fragment that match the position and levelType.
     * If not found any Fragment, return null
     * @param {number} position
     * @param {LevelType} levelType
     * @returns {Fragment|null}
     */


    FragmentTracker.prototype.getBufferedFrag = function getBufferedFrag(position, levelType) {
      var fragments = this.fragments;
      var bufferedFrags = Object.keys(fragments).filter(function (key) {
        var fragmentEntity = fragments[key];
        if (fragmentEntity.body.type !== levelType) return false;

        if (!fragmentEntity.buffered) return false;

        var frag = fragmentEntity.body;
        return frag.startPTS <= position && position <= frag.endPTS;
      });
      if (bufferedFrags.length === 0) {
        return null;
      } else {
        // https://github.com/video-dev/hls.js/pull/1545#discussion_r166229566
        var bufferedFragKey = bufferedFrags.pop();
        return fragments[bufferedFragKey].body;
      }
    };

    /**
     * Partial fragments effected by coded frame eviction will be removed
     * The browser will unload parts of the buffer to free up memory for new buffer data
     * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
     * @param {String} elementaryStream The elementaryStream of media this is (eg. video/audio)
     * @param {TimeRanges} timeRange TimeRange object from a sourceBuffer
     */


    FragmentTracker.prototype.detectEvictedFragments = function detectEvictedFragments(elementaryStream, timeRange) {
      var _this2 = this;

      var fragmentTimes = void 0,
          time = void 0;
      // Check if any flagged fragments have been unloaded
      Object.keys(this.fragments).forEach(function (key) {
        var fragmentEntity = _this2.fragments[key];
        if (fragmentEntity.buffered === true) {
          var esData = fragmentEntity.range[elementaryStream];
          if (esData) {
            fragmentTimes = esData.time;
            for (var i = 0; i < fragmentTimes.length; i++) {
              time = fragmentTimes[i];

              if (_this2.isTimeBuffered(time.startPTS, time.endPTS, timeRange) === false) {
                // Unregister partial fragment as it needs to load again to be reused
                _this2.removeFragment(fragmentEntity.body);
                break;
              }
            }
          }
        }
      });
    };

    /**
     * Checks if the fragment passed in is loaded in the buffer properly
     * Partially loaded fragments will be registered as a partial fragment
     * @param {Object} fragment Check the fragment against all sourceBuffers loaded
     */


    FragmentTracker.prototype.detectPartialFragments = function detectPartialFragments(fragment) {
      var _this3 = this;

      var fragKey = this.getFragmentKey(fragment);
      var fragmentEntity = this.fragments[fragKey];
      if (fragmentEntity) {
        fragmentEntity.buffered = true;

        Object.keys(this.timeRanges).forEach(function (elementaryStream) {
          if (fragment.hasElementaryStream(elementaryStream) === true) {
            var timeRange = _this3.timeRanges[elementaryStream];
            // Check for malformed fragments
            // Gaps need to be calculated for each elementaryStream
            fragmentEntity.range[elementaryStream] = _this3.getBufferedTimes(fragment.startPTS, fragment.endPTS, timeRange);
          }
        });
      }
    };

    FragmentTracker.prototype.getBufferedTimes = function getBufferedTimes(startPTS, endPTS, timeRange) {
      var fragmentTimes = [];
      var startTime = void 0,
          endTime = void 0;
      var fragmentPartial = false;
      for (var i = 0; i < timeRange.length; i++) {
        startTime = timeRange.start(i) - this.bufferPadding;
        endTime = timeRange.end(i) + this.bufferPadding;
        if (startPTS >= startTime && endPTS <= endTime) {
          // Fragment is entirely contained in buffer
          // No need to check the other timeRange times since it's completely playable
          fragmentTimes.push({
            startPTS: Math.max(startPTS, timeRange.start(i)),
            endPTS: Math.min(endPTS, timeRange.end(i))
          });
          break;
        } else if (startPTS < endTime && endPTS > startTime) {
          // Check for intersection with buffer
          // Get playable sections of the fragment
          fragmentTimes.push({
            startPTS: Math.max(startPTS, timeRange.start(i)),
            endPTS: Math.min(endPTS, timeRange.end(i))
          });
          fragmentPartial = true;
        } else if (endPTS <= startTime) {
          // No need to check the rest of the timeRange as it is in order
          break;
        }
      }

      return {
        time: fragmentTimes,
        partial: fragmentPartial
      };
    };

    FragmentTracker.prototype.getFragmentKey = function getFragmentKey(fragment) {
      return fragment.type + '_' + fragment.level + '_' + fragment.sn;
    };

    /**
     * Gets the partial fragment for a certain time
     * @param {Number} time
     * @returns {Object} fragment Returns a partial fragment at a time or null if there is no partial fragment
     */


    FragmentTracker.prototype.getPartialFragment = function getPartialFragment(time) {
      var _this4 = this;

      var timePadding = void 0,
          startTime = void 0,
          endTime = void 0;
      var bestFragment = null;
      var bestOverlap = 0;
      Object.keys(this.fragments).forEach(function (key) {
        var fragmentEntity = _this4.fragments[key];
        if (_this4.isPartial(fragmentEntity)) {
          startTime = fragmentEntity.body.startPTS - _this4.bufferPadding;
          endTime = fragmentEntity.body.endPTS + _this4.bufferPadding;
          if (time >= startTime && time <= endTime) {
            // Use the fragment that has the most padding from start and end time
            timePadding = Math.min(time - startTime, endTime - time);
            if (bestOverlap <= timePadding) {
              bestFragment = fragmentEntity.body;
              bestOverlap = timePadding;
            }
          }
        }
      });
      return bestFragment;
    };

    /**
     * @param {Object} fragment The fragment to check
     * @returns {String} Returns the fragment state when a fragment never loaded or if it partially loaded
     */


    FragmentTracker.prototype.getState = function getState(fragment) {
      var fragKey = this.getFragmentKey(fragment);
      var fragmentEntity = this.fragments[fragKey];
      var state = FragmentState.NOT_LOADED;

      if (fragmentEntity !== undefined) {
        if (!fragmentEntity.buffered) state = FragmentState.APPENDING;else if (this.isPartial(fragmentEntity) === true) state = FragmentState.PARTIAL;else state = FragmentState.OK;
      }

      return state;
    };

    FragmentTracker.prototype.isPartial = function isPartial(fragmentEntity) {
      return fragmentEntity.buffered === true && (fragmentEntity.range.video !== undefined && fragmentEntity.range.video.partial === true || fragmentEntity.range.audio !== undefined && fragmentEntity.range.audio.partial === true);
    };

    FragmentTracker.prototype.isTimeBuffered = function isTimeBuffered(startPTS, endPTS, timeRange) {
      var startTime = void 0,
          endTime = void 0;
      for (var i = 0; i < timeRange.length; i++) {
        startTime = timeRange.start(i) - this.bufferPadding;
        endTime = timeRange.end(i) + this.bufferPadding;
        if (startPTS >= startTime && endPTS <= endTime) return true;

        if (endPTS <= startTime) {
          // No need to check the rest of the timeRange as it is in order
          return false;
        }
      }

      return false;
    };

    /**
     * Fires when a fragment loading is completed
     */


    FragmentTracker.prototype.onFragLoaded = function onFragLoaded(e) {
      var fragment = e.frag;
      // dont track initsegment (for which sn is not a number)
      if (!isNaN(fragment.sn)) {
        var fragKey = this.getFragmentKey(fragment);
        var fragmentEntity = {
          body: fragment,
          range: Object.create(null),
          buffered: false
        };
        this.fragments[fragKey] = fragmentEntity;
      }
    };

    /**
     * Fires when the buffer is updated
     */


    FragmentTracker.prototype.onBufferAppended = function onBufferAppended(e) {
      var _this5 = this;

      // Store the latest timeRanges loaded in the buffer
      this.timeRanges = e.timeRanges;
      Object.keys(this.timeRanges).forEach(function (elementaryStream) {
        var timeRange = _this5.timeRanges[elementaryStream];
        _this5.detectEvictedFragments(elementaryStream, timeRange);
      });
    };

    /**
     * Fires after a fragment has been loaded into the source buffer
     */


    FragmentTracker.prototype.onFragBuffered = function onFragBuffered(e) {
      this.detectPartialFragments(e.frag);
    };

    /**
     * Return true if fragment tracker has the fragment.
     * @param {Object} fragment
     * @returns {boolean}
     */


    FragmentTracker.prototype.hasFragment = function hasFragment(fragment) {
      var fragKey = this.getFragmentKey(fragment);
      return this.fragments[fragKey] !== undefined;
    };

    /**
     * Remove a fragment from fragment tracker until it is loaded again
     * @param {Object} fragment The fragment to remove
     */


    FragmentTracker.prototype.removeFragment = function removeFragment(fragment) {
      var fragKey = this.getFragmentKey(fragment);
      delete this.fragments[fragKey];
    };

    /**
     * Remove all fragments from fragment tracker.
     */


    FragmentTracker.prototype.removeAllFragments = function removeAllFragments() {
      this.fragments = Object.create(null);
    };

    return FragmentTracker;
  }(event_handler);
  // CONCATENATED MODULE: ./src/helper/level-helper.js
  /**
   * Level Helper class, providing methods dealing with playlist sliding and drift
  */



  function updatePTS(fragments, fromIdx, toIdx) {
    var fragFrom = fragments[fromIdx],
        fragTo = fragments[toIdx],
        fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (!isNaN(fragToPTS)) {
      // update fragment duration.
      // it helps to fix drifts between playlist reported duration and fragment real duration
      if (toIdx > fromIdx) {
        fragFrom.duration = fragToPTS - fragFrom.start;
        if (fragFrom.duration < 0) logger["b" /* logger */].warn('negative duration computed for frag ' + fragFrom.sn + ',level ' + fragFrom.level + ', there should be some duration drift between playlist and fragment!');
      } else {
        fragTo.duration = fragFrom.start - fragToPTS;
        if (fragTo.duration < 0) logger["b" /* logger */].warn('negative duration computed for frag ' + fragTo.sn + ',level ' + fragTo.level + ', there should be some duration drift between playlist and fragment!');
      }
    } else {
      // we dont know startPTS[toIdx]
      if (toIdx > fromIdx) fragTo.start = fragFrom.start + fragFrom.duration;else fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
    }
  }

  function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    // update frag PTS/DTS
    var maxStartPTS = startPTS;
    if (!isNaN(frag.startPTS)) {
      // delta PTS between audio and video
      var deltaPTS = Math.abs(frag.startPTS - startPTS);
      if (isNaN(frag.deltaPTS)) frag.deltaPTS = deltaPTS;else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);

      maxStartPTS = Math.max(startPTS, frag.startPTS);
      startPTS = Math.min(startPTS, frag.startPTS);
      endPTS = Math.max(endPTS, frag.endPTS);
      startDTS = Math.min(startDTS, frag.startDTS);
      endDTS = Math.max(endDTS, frag.endDTS);
    }

    var drift = startPTS - frag.start;
    frag.start = frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.endPTS = endPTS;
    frag.startDTS = startDTS;
    frag.endDTS = endDTS;
    frag.duration = endPTS - startPTS;

    var sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) return 0;

    var fragIdx = void 0,
        fragments = void 0,
        i = void 0;
    fragIdx = sn - details.startSN;
    fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happpen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for (i = fragIdx; i > 0; i--) {
      updatePTS(fragments, i, i - 1);
    } // adjust fragment PTS/duration from seqnum to last frag
    for (i = fragIdx; i < fragments.length - 1; i++) {
      updatePTS(fragments, i, i + 1);
    }details.PTSKnown = true;
    // logger.log(`                                            frag start/end:${startPTS.toFixed(3)}/${endPTS.toFixed(3)}`);

    return drift;
  }

  function mergeDetails(oldDetails, newDetails) {
    var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN,
        end = Math.min(oldDetails.endSN, newDetails.endSN) - newDetails.startSN,
        delta = newDetails.startSN - oldDetails.startSN,
        oldfragments = oldDetails.fragments,
        newfragments = newDetails.fragments,
        ccOffset = 0,
        PTSFrag = void 0;

    // potentially retrieve cached initsegment
    if (newDetails.initSegment && oldDetails.initSegment) newDetails.initSegment = oldDetails.initSegment;

    // check if old/new playlists have fragments in common
    if (end < start) {
      newDetails.PTSKnown = false;
      return;
    }
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    for (var i = start; i <= end; i++) {
      var oldFrag = oldfragments[delta + i],
          newFrag = newfragments[i];
      if (newFrag && oldFrag) {
        ccOffset = oldFrag.cc - newFrag.cc;
        if (!isNaN(oldFrag.startPTS)) {
          newFrag.start = newFrag.startPTS = oldFrag.startPTS;
          newFrag.endPTS = oldFrag.endPTS;
          newFrag.duration = oldFrag.duration;
          newFrag.backtracked = oldFrag.backtracked;
          newFrag.dropped = oldFrag.dropped;
          PTSFrag = newFrag;
        }
      }
    }

    if (ccOffset) {
      logger["b" /* logger */].log('discontinuity sliding from playlist, take drift into account');
      for (i = 0; i < newfragments.length; i++) {
        newfragments[i].cc += ccOffset;
      }
    }

    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) {
      updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    } else {
      // ensure that delta is within oldfragments range
      // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
      // in that case we also need to adjust start offset of all fragments
      if (delta >= 0 && delta < oldfragments.length) {
        // adjust start by sliding offset
        var sliding = oldfragments[delta].start;
        for (i = 0; i < newfragments.length; i++) {
          newfragments[i].start += sliding;
        }
      }
    }
    // if we are here, it means we have fragments overlapping between
    // old and new level. reliable PTS info is thus relying on old level
    newDetails.PTSKnown = oldDetails.PTSKnown;
  }
  // CONCATENATED MODULE: ./src/utils/time-ranges.js
  /**
   *  TimeRanges to string helper
   */

  var TimeRanges = {
    toString: function toString(r) {
      var log = '',
          len = r.length;
      for (var i = 0; i < len; i++) {
        log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
      }return log;
    }
  };

  /* harmony default export */ var time_ranges = (TimeRanges);
  // CONCATENATED MODULE: ./src/utils/discontinuities.js



  function findFirstFragWithCC(fragments, cc) {
    var firstFrag = null;

    for (var i = 0; i < fragments.length; i += 1) {
      var currentFrag = fragments[i];
      if (currentFrag && currentFrag.cc === cc) {
        firstFrag = currentFrag;
        break;
      }
    }

    return firstFrag;
  }

  function findFragWithCC(fragments, CC) {
    return binary_search.search(fragments, function (candidate) {
      if (candidate.cc < CC) return 1;else if (candidate.cc > CC) return -1;else return 0;
    });
  }

  function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
    var shouldAlign = false;
    if (lastLevel && lastLevel.details && details) {
      if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) shouldAlign = true;
    }
    return shouldAlign;
  }

  // Find the first frag in the previous level which matches the CC of the first frag of the new level
  function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
    var prevFrags = prevDetails.fragments;
    var curFrags = curDetails.fragments;

    if (!curFrags.length || !prevFrags.length) {
      logger["b" /* logger */].log('No fragments to align');
      return;
    }

    var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);

    if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
      logger["b" /* logger */].log('No frag in previous level to align on');
      return;
    }

    return prevStartFrag;
  }

  function adjustPts(sliding, details) {
    details.fragments.forEach(function (frag) {
      if (frag) {
        var start = frag.start + sliding;
        frag.start = frag.startPTS = start;
        frag.endPTS = start + frag.duration;
      }
    });
    details.PTSKnown = true;
  }

  // If a change in CC is detected, the PTS can no longer be relied upon
  // Attempt to align the level by using the last level - find the last frag matching the current CC and use it's PTS
  // as a reference
  function alignDiscontinuities(lastFrag, lastLevel, details) {
    if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
      var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
      if (referenceFrag) {
        logger["b" /* logger */].log('Adjusting PTS using last level due to CC increase within current level');
        adjustPts(referenceFrag.start, details);
      }
    }
    // try to align using programDateTime attribute (if available)
    if (details.PTSKnown === false && lastLevel && lastLevel.details && lastLevel.details.fragments && lastLevel.details.fragments.length) {
      // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
      // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
      // then we can deduce that playlist B sliding is 1000+8 = 1008s
      var lastPDT = lastLevel.details.programDateTime;
      var newPDT = details.programDateTime;
      // date diff is in ms. frag.start is in seconds
      var sliding = (newPDT - lastPDT) / 1000 + lastLevel.details.fragments[0].start;
      if (!isNaN(sliding)) {
        logger["b" /* logger */].log('adjusting PTS using programDateTime delta, sliding:' + sliding.toFixed(3));
        adjustPts(sliding, details);
      }
    }
  }
  // CONCATENATED MODULE: ./src/task-loop.js
  function task_loop__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function task_loop__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function task_loop__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



  var TaskLoop = function (_EventHandler) {
    task_loop__inherits(TaskLoop, _EventHandler);

    function TaskLoop(hls) {
      task_loop__classCallCheck(this, TaskLoop);

      for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        events[_key - 1] = arguments[_key];
      }

      var _this = task_loop__possibleConstructorReturn(this, _EventHandler.call.apply(_EventHandler, [this, hls].concat(events)));

      _this._tickInterval = null;
      _this._tickCallCount = 0;
      return _this;
    }

    /**
     * @override
     */


    TaskLoop.prototype.destroy = function destroy() {
      this.clearInterval();
      _EventHandler.prototype.destroy.call(this);
    };

    /**
     * @returns {boolean}
     */


    TaskLoop.prototype.hasInterval = function hasInterval() {
      return this._tickInterval !== null;
    };

    /**
     * @param {number} millis Interval time (ms)
     * @returns {boolean} True when interval has been scheduled, false when already scheduled (no effect)
     */


    TaskLoop.prototype.setInterval = function (_setInterval) {
      function setInterval(_x) {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function (millis) {
      if (!this._tickInterval) {
        this._tickInterval = setInterval(this.tick.bind(this, false), millis);
        return true;
      }
      return false;
    });

    /**
     * @returns {boolean} True when interval was cleared, false when none was set (no effect)
     */


    TaskLoop.prototype.clearInterval = function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      if (this._tickInterval) {
        clearInterval(this._tickInterval);
        this._tickInterval = null;
        return true;
      }
      return false;
    });

    /**
     *
     * @param {Wether to force async} forceAsync
     * @returns {boolean} True when async, false when sync
     */


    TaskLoop.prototype.tick = function tick() {
      this._tickCallCount++;
      if (this._tickCallCount === 1) {
        this.doTick();
        if (this._tickCallCount > 1) setTimeout(this.tick.bind(this), 0);

        this._tickCallCount = 0;
      }
    };

    /**
     * For subclass to implement task logic
     * @abstract
     */


    TaskLoop.prototype.doTick = function doTick() {
      throw new Error('TaskLoop is abstract and `doLoop` must be implemented');
    };

    return TaskLoop;
  }(event_handler);

  /* harmony default export */ var task_loop = (TaskLoop);
  // CONCATENATED MODULE: ./src/controller/stream-controller.js
  var stream_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Stream Controller
  */















  var State = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_LEVEL: 'WAITING_LEVEL',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    BUFFER_FLUSHING: 'BUFFER_FLUSHING',
    ENDED: 'ENDED',
    ERROR: 'ERROR'
  };

  var stream_controller_StreamController = function (_TaskLoop) {
    stream_controller__inherits(StreamController, _TaskLoop);

    function StreamController(hls, fragmentTracker) {
      stream_controller__classCallCheck(this, StreamController);

      var _this = stream_controller__possibleConstructorReturn(this, _TaskLoop.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].LEVEL_LOADED, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_LOAD_EMERGENCY_ABORTED, events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, events["a" /* default */].FRAG_PARSING_DATA, events["a" /* default */].FRAG_PARSED, events["a" /* default */].ERROR, events["a" /* default */].AUDIO_TRACK_SWITCHING, events["a" /* default */].AUDIO_TRACK_SWITCHED, events["a" /* default */].BUFFER_CREATED, events["a" /* default */].BUFFER_APPENDED, events["a" /* default */].BUFFER_FLUSHED));

      _this.fragmentTracker = fragmentTracker;
      _this.config = hls.config;
      _this.audioCodecSwap = false;
      _this._state = State.STOPPED;
      return _this;
    }

    StreamController.prototype.onHandlerDestroying = function onHandlerDestroying() {
      this.stopLoad();
    };

    StreamController.prototype.onHandlerDestroyed = function onHandlerDestroyed() {
      this.state = State.STOPPED;
      this.fragmentTracker = null;
    };

    StreamController.prototype.startLoad = function startLoad(startPosition) {
      if (this.levels) {
        var lastCurrentTime = this.lastCurrentTime,
            hls = this.hls;
        this.stopLoad();
        this.setInterval(100);
        this.level = -1;
        this.fragLoadError = 0;
        if (!this.startFragRequested) {
          // determine load level
          var startLevel = hls.startLevel;
          if (startLevel === -1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          }
          // set new level to playlist loader : this will trigger start level load
          // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
          this.level = hls.nextLoadLevel = startLevel;
          this.loadedmetadata = false;
        }
        // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
        if (lastCurrentTime > 0 && startPosition === -1) {
          logger["b" /* logger */].log('override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          startPosition = lastCurrentTime;
        }
        this.state = State.IDLE;
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
      } else {
        this.forceStartLoad = true;
        this.state = State.STOPPED;
      }
    };

    StreamController.prototype.stopLoad = function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) frag.loader.abort();

        this.fragmentTracker.removeFragment(frag);
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.clearInterval();
      this.state = State.STOPPED;
      this.forceStartLoad = false;
    };

    StreamController.prototype.doTick = function doTick() {
      switch (this.state) {
        case State.BUFFER_FLUSHING:
          // in buffer flushing state, reset fragLoadError counter
          this.fragLoadError = 0;
          break;
        case State.IDLE:
          this._doTickIdle();
          break;
        case State.WAITING_LEVEL:
          var level = this.levels[this.level];
          // check if playlist is already loaded
          if (level && level.details) this.state = State.IDLE;

          break;
        case State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
            logger["b" /* logger */].log('mediaController: retryDate reached, switch back to IDLE state');
            this.state = State.IDLE;
          }
          break;
        case State.ERROR:
        case State.STOPPED:
        case State.FRAG_LOADING:
        case State.PARSING:
        case State.PARSED:
        case State.ENDED:
          break;
        default:
          break;
      }
      // check buffer
      this._checkBuffer();
      // check/update current fragment
      this._checkFragmentChanged();
    };

    // Ironically the "idle" state is the on we do the most logic in it seems ....
    // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
    //       played segment, or on pause/play/seek instead of naively checking every 100ms?


    StreamController.prototype._doTickIdle = function _doTickIdle() {
      var hls = this.hls,
          config = hls.config,
          media = this.media;

      // if start level not parsed yet OR
      // if video not attached AND start fragment already requested OR start frag prefetch disable
      // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
      if (this.levelLastLoaded === undefined || !media && (this.startFragRequested || !config.startFragPrefetch)) return;

      // if we have not yet loaded any fragment, start loading from start position
      var pos = void 0;
      if (this.loadedmetadata) pos = media.currentTime;else pos = this.nextLoadPosition;

      // determine next load level
      var level = hls.nextLoadLevel,
          levelInfo = this.levels[level];

      if (!levelInfo) return;

      var levelBitrate = levelInfo.bitrate,
          maxBufLen = void 0;

      // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
      if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);else maxBufLen = config.maxBufferLength;

      maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);

      // determine next candidate fragment to be loaded, based on current position and end of buffer position
      // ensure up to `config.maxMaxBufferLength` of buffer upfront

      var bufferInfo = buffer_helper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole),
          bufferLen = bufferInfo.len;
      // Stay idle if we are still with buffer margins
      if (bufferLen >= maxBufLen) return;

      // if buffer length is less than maxBufLen try to load a new fragment ...
      logger["b" /* logger */].trace('buffer length of ' + bufferLen.toFixed(3) + ' is below max of ' + maxBufLen.toFixed(3) + '. checking for more payload ...');

      // set next load level : this will trigger a playlist load if needed
      this.level = hls.nextLoadLevel = level;

      var levelDetails = levelInfo.details;
      // if level info not retrieved yet, switch state and wait for level retrieval
      // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
      // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
      if (levelDetails === undefined || levelDetails.live === true && this.levelLastLoaded !== level) {
        this.state = State.WAITING_LEVEL;
        return;
      }

      // we just got done loading the final fragment and there is no other buffered range after ...
      // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
      // so we should not switch to ENDED in that case, to be able to buffer them
      // dont switch to ENDED if we need to backtrack last fragment
      var fragPrevious = this.fragPrevious;
      if (!levelDetails.live && fragPrevious && !fragPrevious.backtracked && fragPrevious.sn === levelDetails.endSN && !bufferInfo.nextStart) {
        // fragPrevious is last fragment. retrieve level duration using last frag start offset + duration
        // real duration might be lower than initial duration if there are drifts between real frag duration and playlist signaling
        var duration = Math.min(media.duration, fragPrevious.start + fragPrevious.duration);
        // if everything (almost) til the end is buffered, let's signal eos
        // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference (audio/video offsets...)
        // tolerate up to one frag duration to cope with these cases.
        // also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
        if (duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration)) {
          // Finalize the media stream
          var data = {};
          if (this.altAudio) data.type = 'video';

          this.hls.trigger(events["a" /* default */].BUFFER_EOS, data);
          this.state = State.ENDED;
          return;
        }
      }

      // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
      this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
    };

    StreamController.prototype._fetchPayloadOrEos = function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
      var fragPrevious = this.fragPrevious,
          level = this.level,
          fragments = levelDetails.fragments,
          fragLen = fragments.length;

      // empty playlist
      if (fragLen === 0) return;

      // find fragment index, contiguous with end of buffer position
      var start = fragments[0].start,
          end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
          bufferEnd = bufferInfo.end,
          frag = void 0;

      if (levelDetails.initSegment && !levelDetails.initSegment.data) {
        frag = levelDetails.initSegment;
      } else {
        // in case of live playlist we need to ensure that requested position is not located before playlist start
        if (levelDetails.live) {
          var initialLiveManifestSize = this.config.initialLiveManifestSize;
          if (fragLen < initialLiveManifestSize) {
            logger["b" /* logger */].warn('Can not start playback of a level, reason: not enough fragments ' + fragLen + ' < ' + initialLiveManifestSize);
            return;
          }

          frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
          // if it explicitely returns null don't load any fragment and exit function now
          if (frag === null) return;
        } else {
          // VoD playlist: if bufferEnd before start of playlist, load first fragment
          if (bufferEnd < start) frag = fragments[0];
        }
      }
      if (!frag) frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);

      if (frag) this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
    };

    StreamController.prototype._ensureFragmentAtLivePoint = function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
      var config = this.hls.config,
          media = this.media;

      var frag = void 0;

      // check if requested position is within seekable boundaries :
      // logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
      var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;

      if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
        var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
        logger["b" /* logger */].log('buffer end: ' + bufferEnd.toFixed(3) + ' is located too far from the end of live sliding playlist, reset currentTime to : ' + liveSyncPosition.toFixed(3));
        bufferEnd = liveSyncPosition;
        if (media && media.readyState && media.duration > liveSyncPosition) media.currentTime = liveSyncPosition;

        this.nextLoadPosition = liveSyncPosition;
      }

      // if end of buffer greater than live edge, don't load any fragment
      // this could happen if live playlist intermittently slides in the past.
      // level 1 loaded [182580161,182580167]
      // level 1 loaded [182580162,182580169]
      // Loading 182580168 of [182580162 ,182580169],level 1 ..
      // Loading 182580169 of [182580162 ,182580169],level 1 ..
      // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
      // level 1 loaded [182580164,182580171]
      //
      // don't return null in case media not loaded yet (readystate === 0)
      if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) return null;

      if (this.startFragRequested && !levelDetails.PTSKnown) {
        /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
           try to load frag matching with next SN.
           even if SN are not synchronized between playlists, loading this frag will help us
           compute playlist sliding and find the right one after in case it was not the right consecutive one */
        if (fragPrevious) {
          if (!levelDetails.programDateTime) {
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            var targetSN = fragPrevious.sn + 1;
            if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
              var fragNext = fragments[targetSN - levelDetails.startSN];
              if (fragPrevious.cc === fragNext.cc) {
                frag = fragNext;
                logger["b" /* logger */].log('live playlist, switching playlist, load frag with next SN: ' + frag.sn);
              }
            }
            // next frag SN not available (or not with same continuity counter)
            // look for a frag sharing the same CC
            if (!frag) {
              frag = binary_search.search(fragments, function (frag) {
                return fragPrevious.cc - frag.cc;
              });
              if (frag) logger["b" /* logger */].log('live playlist, switching playlist, load frag with same CC: ' + frag.sn);
            }
          } else {
            // Relies on PDT in order to switch bitrates (Support EXT-X-DISCONTINUITY without EXT-X-DISCONTINUITY-SEQUENCE)
            frag = this._findFragmentByPDT(fragments, fragPrevious.endPdt + 1);
          }
        }
        if (!frag) {
          /* we have no idea about which fragment should be loaded.
             so let's load mid fragment. it will help computing playlist sliding and find the right one
          */
          frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
          logger["b" /* logger */].log('live playlist, switching playlist, unknown, load middle frag : ' + frag.sn);
        }
      }
      return frag;
    };

    StreamController.prototype._findFragmentByPDT = function _findFragmentByPDT(fragments, PDTValue) {
      if (!fragments || PDTValue === undefined) return null;

      // if less than start
      var firstSegment = fragments[0];

      if (PDTValue < firstSegment.pdt) return null;

      var lastSegment = fragments[fragments.length - 1];

      if (PDTValue >= lastSegment.endPdt) return null;

      for (var seg = 0; seg < fragments.length; ++seg) {
        var frag = fragments[seg];
        if (PDTValue < frag.endPdt) return frag;
      }
      return null;
    };

    StreamController.prototype._findFragmentBySN = function _findFragmentBySN(fragPrevious, fragments, bufferEnd, end) {
      var config = this.hls.config;
      var foundFrag = void 0;
      var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
      var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
      var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
        // offset should be within fragment boundary - config.maxFragLookUpTolerance
        // this is to cope with situations like
        // bufferEnd = 9.991
        // frag[Ø] : [0,10]
        // frag[1] : [10,20]
        // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
        //              frag start               frag start+duration
        //                  |-----------------------------|
        //              <--->                         <--->
        //  ...--------><-----------------------------><---------....
        // previous frag         matching fragment         next frag
        //  return -1             return 0                 return 1
        // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
        // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
        var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
        if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
        // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
        else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) return -1;

        return 0;
      };

      if (bufferEnd < end) {
        if (bufferEnd > end - maxFragLookUpTolerance) maxFragLookUpTolerance = 0;

        // Prefer the next fragment if it's within tolerance
        if (fragNext && !fragmentWithinToleranceTest(fragNext)) foundFrag = fragNext;else foundFrag = binary_search.search(fragments, fragmentWithinToleranceTest);
      }
      return foundFrag;
    };

    StreamController.prototype._findFragment = function _findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
      var config = this.hls.config;
      var frag = void 0;
      var foundFrag = void 0;

      if (bufferEnd < end) {
        if (!levelDetails.programDateTime) {
          // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
          foundFrag = this._findFragmentBySN(fragPrevious, fragments, bufferEnd, end);
        } else {
          // Relies on PDT in order to switch bitrates (Support EXT-X-DISCONTINUITY without EXT-X-DISCONTINUITY-SEQUENCE)
          // compute PDT of bufferEnd: PDT(bufferEnd) = 1000*bufferEnd + PDT(start) = 1000*bufferEnd + PDT(level) - level sliding
          foundFrag = this._findFragmentByPDT(fragments, bufferEnd * 1000 + (levelDetails.programDateTime ? Date.parse(levelDetails.programDateTime) : 0) - 1000 * start);
        }
      } else {
        // reach end of playlist
        foundFrag = fragments[fragLen - 1];
      }
      if (foundFrag) {
        frag = foundFrag;
        var curSNIdx = frag.sn - levelDetails.startSN;
        var sameLevel = fragPrevious && frag.level === fragPrevious.level;
        var prevFrag = fragments[curSNIdx - 1];
        var nextFrag = fragments[curSNIdx + 1];
        // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
        if (fragPrevious && frag.sn === fragPrevious.sn) {
          if (sameLevel && !frag.backtracked) {
            if (frag.sn < levelDetails.endSN) {
              var deltaPTS = fragPrevious.deltaPTS;
              // if there is a significant delta between audio and video, larger than max allowed hole,
              // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
              // let's try to load previous fragment again to get last keyframe
              // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
              if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
                frag = prevFrag;
                logger["b" /* logger */].warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
              } else {
                frag = nextFrag;
                logger["b" /* logger */].log('SN just loaded, load next one: ' + frag.sn);
              }
            } else {
              frag = null;
            }
          } else if (frag.backtracked) {
            // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
            if (nextFrag && nextFrag.backtracked) {
              logger["b" /* logger */].warn('Already backtracked from fragment ' + nextFrag.sn + ', will not backtrack to fragment ' + frag.sn + '. Loading fragment ' + nextFrag.sn);
              frag = nextFrag;
            } else {
              // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
              // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
              logger["b" /* logger */].warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
              frag.dropped = 0;
              if (prevFrag) {
                frag = prevFrag;
                frag.backtracked = true;
              } else if (curSNIdx) {
                // can't backtrack on very first fragment
                frag = null;
              }
            }
          }
        }
      }
      return frag;
    };

    StreamController.prototype._loadFragmentOrKey = function _loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
      // logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
      if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
        logger["b" /* logger */].log('Loading key for ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level);
        this.state = State.KEY_LOADING;
        this.hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
      } else {
        logger["b" /* logger */].log('Loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', currentTime:' + pos.toFixed(3) + ',bufferEnd:' + bufferEnd.toFixed(3));
        // Check if fragment is not loaded
        var fragState = this.fragmentTracker.getState(frag);

        this.fragCurrent = frag;
        this.startFragRequested = true;
        // Don't update nextLoadPosition for fragments which are not buffered
        if (!isNaN(frag.sn) && !frag.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;

        // Allow backtracked fragments to load
        if (frag.backtracked || fragState === FragmentState.NOT_LOADED) {
          frag.autoLevel = this.hls.autoLevelEnabled;
          frag.bitrateTest = this.bitrateTest;

          this.hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
          // lazy demuxer init, as this could take some time ... do it during frag loading
          if (!this.demuxer) this.demuxer = new demux_demuxer(this.hls, 'main');

          this.state = State.FRAG_LOADING;
        } else if (fragState === FragmentState.APPENDING) {
          // Lower the buffer size and try again
          if (this._reduceMaxBufferLength(frag.duration)) this.fragmentTracker.removeFragment(frag);
        }
      }
    };

    StreamController.prototype.getBufferedFrag = function getBufferedFrag(position) {
      return this.fragmentTracker.getBufferedFrag(position, playlist_loader.LevelType.MAIN);
    };

    StreamController.prototype.followingBufferedFrag = function followingBufferedFrag(frag) {
      if (frag) {
        // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.endPTS + 0.5);
      }
      return null;
    };

    StreamController.prototype._checkFragmentChanged = function _checkFragmentChanged() {
      var fragPlayingCurrent = void 0,
          currentTime = void 0,
          video = this.media;
      if (video && video.readyState && video.seeking === false) {
        currentTime = video.currentTime;
        /* if video element is in seeked state, currentTime can only increase.
          (assuming that playback rate is positive ...)
          As sometimes currentTime jumps back to zero after a
          media decode error, check this, to avoid seeking back to
          wrong position after a media decode error
        */
        if (currentTime > video.playbackRate * this.lastCurrentTime) this.lastCurrentTime = currentTime;

        if (buffer_helper.isBuffered(video, currentTime)) {
          fragPlayingCurrent = this.getBufferedFrag(currentTime);
        } else if (buffer_helper.isBuffered(video, currentTime + 0.1)) {
          /* ensure that FRAG_CHANGED event is triggered at startup,
            when first video frame is displayed and playback is paused.
            add a tolerance of 100ms, in case current position is not buffered,
            check if current pos+100ms is buffered and use that buffer range
            for FRAG_CHANGED event reporting */
          fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
        }
        if (fragPlayingCurrent) {
          var fragPlaying = fragPlayingCurrent;
          if (fragPlaying !== this.fragPlaying) {
            this.hls.trigger(events["a" /* default */].FRAG_CHANGED, { frag: fragPlaying });
            var fragPlayingLevel = fragPlaying.level;
            if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) this.hls.trigger(events["a" /* default */].LEVEL_SWITCHED, { level: fragPlayingLevel });

            this.fragPlaying = fragPlaying;
          }
        }
      }
    };

    /*
      on immediate level switch :
       - pause playback if playing
       - cancel any pending load request
       - and trigger a buffer flush
    */


    StreamController.prototype.immediateLevelSwitch = function immediateLevelSwitch() {
      logger["b" /* logger */].log('immediateLevelSwitch');
      if (!this.immediateSwitch) {
        this.immediateSwitch = true;
        var media = this.media,
            previouslyPaused = void 0;
        if (media) {
          previouslyPaused = media.paused;
          media.pause();
        } else {
          // don't restart playback after instant level switch in case media not attached
          previouslyPaused = true;
        }
        this.previouslyPaused = previouslyPaused;
      }
      var fragCurrent = this.fragCurrent;
      if (fragCurrent && fragCurrent.loader) fragCurrent.loader.abort();

      this.fragCurrent = null;
      // flush everything
      this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    };

    /**
     * on immediate level switch end, after new fragment has been buffered:
     * - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
     * - resume the playback if needed
     */


    StreamController.prototype.immediateLevelSwitchEnd = function immediateLevelSwitchEnd() {
      var media = this.media;
      if (media && media.buffered.length) {
        this.immediateSwitch = false;
        if (buffer_helper.isBuffered(media, media.currentTime)) {
          // only nudge if currentTime is buffered
          media.currentTime -= 0.0001;
        }
        if (!this.previouslyPaused) media.play();
      }
    };

    /**
     * try to switch ASAP without breaking video playback:
     * in order to ensure smooth but quick level switching,
     * we need to find the next flushable buffer range
     * we should take into account new segment fetch time
     */


    StreamController.prototype.nextLevelSwitch = function nextLevelSwitch() {
      var media = this.media;
      // ensure that media is defined and that metadata are available (to retrieve currentTime)
      if (media && media.readyState) {
        var fetchdelay = void 0,
            fragPlayingCurrent = void 0,
            nextBufferedFrag = void 0;
        fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
        if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
          // flush buffer preceding current fragment (flush until current fragment start offset)
          // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
          this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
        }
        if (!media.paused) {
          // add a safety delay of 1s
          var nextLevelId = this.hls.nextLoadLevel,
              nextLevel = this.levels[nextLevelId],
              fragLastKbps = this.fragLastKbps;
          if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;else fetchdelay = 0;
        } else {
          fetchdelay = 0;
        }
        // logger.log('fetchdelay:'+fetchdelay);
        // find buffer range that will be reached once new fragment will be fetched
        nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
        if (nextBufferedFrag) {
          // we can flush buffer range following this one without stalling playback
          nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
          if (nextBufferedFrag) {
            // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
            var fragCurrent = this.fragCurrent;
            if (fragCurrent && fragCurrent.loader) fragCurrent.loader.abort();

            this.fragCurrent = null;
            // start flush position is the start PTS of next buffered frag.
            // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
            // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
            this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
          }
        }
      }
    };

    StreamController.prototype.flushMainBuffer = function flushMainBuffer(startOffset, endOffset) {
      this.state = State.BUFFER_FLUSHING;
      var flushScope = { startOffset: startOffset, endOffset: endOffset };
      // if alternate audio tracks are used, only flush video, otherwise flush everything
      if (this.altAudio) flushScope.type = 'video';

      this.hls.trigger(events["a" /* default */].BUFFER_FLUSHING, flushScope);
    };

    StreamController.prototype.onMediaAttached = function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvseeked = this.onMediaSeeked.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('seeked', this.onvseeked);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.levels && config.autoStartLoad) this.hls.startLoad(config.startPosition);
    };

    StreamController.prototype.onMediaDetaching = function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        logger["b" /* logger */].log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // reset fragment backtracked flag
      var levels = this.levels;
      if (levels) {
        levels.forEach(function (level) {
          if (level.details) {
            level.details.fragments.forEach(function (fragment) {
              fragment.backtracked = undefined;
            });
          }
        });
      }
      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('seeked', this.onvseeked);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    };

    StreamController.prototype.onMediaSeeking = function onMediaSeeking() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined,
          config = this.config;
      if (!isNaN(currentTime)) logger["b" /* logger */].log('media seeking to ' + currentTime.toFixed(3));

      var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
      var bufferInfo = buffer_helper.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
      if (this.state === State.FRAG_LOADING) {
        var fragCurrent = this.fragCurrent;
        // check if we are seeking to a unbuffered area AND if frag loading is in progress
        if (bufferInfo.len === 0 && fragCurrent) {
          var tolerance = config.maxFragLookUpTolerance,
              fragStartOffset = fragCurrent.start - tolerance,
              fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
          // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
          if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
            if (fragCurrent.loader) {
              logger["b" /* logger */].log('seeking outside of buffer while fragment load in progress, cancel fragment load');
              fragCurrent.loader.abort();
            }
            this.fragCurrent = null;
            this.fragPrevious = null;
            // switch to IDLE state to load new fragment
            this.state = State.IDLE;
          } else {
            logger["b" /* logger */].log('seeking outside of buffer but within currently loaded fragment range');
          }
        }
      } else if (this.state === State.ENDED) {
        // if seeking to unbuffered area, clean up fragPrevious
        if (bufferInfo.len === 0) this.fragPrevious = 0;

        // switch to IDLE state to check for potential new fragment
        this.state = State.IDLE;
      }
      if (media) this.lastCurrentTime = currentTime;

      // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
      if (!this.loadedmetadata) this.nextLoadPosition = this.startPosition = currentTime;

      // tick to speed up processing
      this.tick();
    };

    StreamController.prototype.onMediaSeeked = function onMediaSeeked() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined;
      if (!isNaN(currentTime)) logger["b" /* logger */].log('media seeked to ' + currentTime.toFixed(3));

      // tick to speed up FRAGMENT_PLAYING triggering
      this.tick();
    };

    StreamController.prototype.onMediaEnded = function onMediaEnded() {
      logger["b" /* logger */].log('media ended');
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    };

    StreamController.prototype.onManifestLoading = function onManifestLoading() {
      // reset buffer on manifest loading
      logger["b" /* logger */].log('trigger BUFFER_RESET');
      this.hls.trigger(events["a" /* default */].BUFFER_RESET);
      this.fragmentTracker.removeAllFragments();
      this.stalled = false;
      this.startPosition = this.lastCurrentTime = 0;
    };

    StreamController.prototype.onManifestParsed = function onManifestParsed(data) {
      var aac = false,
          heaac = false,
          codec = void 0;
      data.levels.forEach(function (level) {
        // detect if we have different kind of audio codecs used amongst playlists
        codec = level.audioCodec;
        if (codec) {
          if (codec.indexOf('mp4a.40.2') !== -1) aac = true;

          if (codec.indexOf('mp4a.40.5') !== -1) heaac = true;
        }
      });
      this.audioCodecSwitch = aac && heaac;
      if (this.audioCodecSwitch) logger["b" /* logger */].log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');

      this.levels = data.levels;
      this.startFragRequested = false;
      var config = this.config;
      if (config.autoStartLoad || this.forceStartLoad) this.hls.startLoad(config.startPosition);
    };

    StreamController.prototype.onLevelLoaded = function onLevelLoaded(data) {
      var newDetails = data.details;
      var newLevelId = data.level;
      var lastLevel = this.levels[this.levelLastLoaded];
      var curLevel = this.levels[newLevelId];
      var duration = newDetails.totalduration;
      var sliding = 0;

      logger["b" /* logger */].log('level ' + newLevelId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);

      if (newDetails.live) {
        var curDetails = curLevel.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown && !isNaN(sliding)) {
            logger["b" /* logger */].log('live playlist sliding:' + sliding.toFixed(3));
          } else {
            logger["b" /* logger */].log('live playlist - outdated PTS, unknown sliding');
            alignDiscontinuities(this.fragPrevious, lastLevel, newDetails);
          }
        } else {
          logger["b" /* logger */].log('live playlist - first load, unknown sliding');
          newDetails.PTSKnown = false;
          alignDiscontinuities(this.fragPrevious, lastLevel, newDetails);
        }
      } else {
        newDetails.PTSKnown = false;
      }
      // override level info
      curLevel.details = newDetails;
      this.levelLastLoaded = newLevelId;
      this.hls.trigger(events["a" /* default */].LEVEL_UPDATED, { details: newDetails, level: newLevelId });

      if (this.startFragRequested === false) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1 || this.lastCurrentTime === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            if (startTimeOffset < 0) {
              logger["b" /* logger */].log('negative start time offset ' + startTimeOffset + ', count from end of last fragment');
              startTimeOffset = sliding + duration + startTimeOffset;
            }
            logger["b" /* logger */].log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
            if (newDetails.live) {
              this.startPosition = this.computeLivePosition(sliding, newDetails);
              logger["b" /* logger */].log('configure startPosition to ' + this.startPosition);
            } else {
              this.startPosition = 0;
            }
          }
          this.lastCurrentTime = this.startPosition;
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
      if (this.state === State.WAITING_LEVEL) this.state = State.IDLE;

      // trigger handler right now
      this.tick();
    };

    StreamController.prototype.onKeyLoaded = function onKeyLoaded() {
      if (this.state === State.KEY_LOADING) {
        this.state = State.IDLE;
        this.tick();
      }
    };

    StreamController.prototype.onFragLoaded = function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var stats = data.stats,
            currentLevel = this.levels[fragCurrent.level],
            details = currentLevel.details;
        logger["b" /* logger */].log('Loaded  ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + fragCurrent.level);
        // reset frag bitrate test in any case after frag loaded event
        this.bitrateTest = false;
        this.stats = stats;
        // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
        // then this means that we should be able to load a fragment at a higher quality level
        if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
          // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
          this.state = State.IDLE;
          this.startFragRequested = false;
          stats.tparsed = stats.tbuffered = performance.now();
          this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else if (fragLoaded.sn === 'initSegment') {
          this.state = State.IDLE;
          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else {
          this.state = State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          var duration = details.totalduration,
              level = fragCurrent.level,
              sn = fragCurrent.sn,
              audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
          if (this.audioCodecSwap) {
            logger["b" /* logger */].log('swapping playlist audio codec');
            if (audioCodec === undefined) audioCodec = this.lastAudioCodec;

            if (audioCodec) {
              if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';else audioCodec = 'mp4a.40.5';
            }
          }
          this.pendingBuffering = true;
          this.appended = false;
          logger["b" /* logger */].log('Parsing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + level + ', cc ' + fragCurrent.cc);
          var demuxer = this.demuxer;
          if (!demuxer) demuxer = this.demuxer = new demux_demuxer(this.hls, 'main');

          // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
          var media = this.media;
          var mediaSeeking = media && media.seeking;
          var accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, undefined);
        }
      }
      this.fragLoadError = 0;
    };

    StreamController.prototype.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;

      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var tracks = data.tracks,
            trackName = void 0,
            track = void 0;

        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (tracks.audio && this.altAudio) delete tracks.audio;

        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          var audioCodec = this.levels[this.level].audioCodec,
              ua = navigator.userAgent.toLowerCase();
          if (audioCodec && this.audioCodecSwap) {
            logger["b" /* logger */].log('swapping playlist audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';else audioCodec = 'mp4a.40.5';
          }
          // in case AAC and HE-AAC audio codecs are signalled in manifest
          // force HE-AAC , as it seems that most browsers prefers that way,
          // except for mono streams OR on FF
          // these conditions might need to be reviewed ...
          if (this.audioCodecSwitch) {
            // don't force HE-AAC if mono stream
            if (track.metadata.channelCount !== 1 &&
            // don't force HE-AAC if firefox
            ua.indexOf('firefox') === -1) audioCodec = 'mp4a.40.5';
          }
          // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
          if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') {
            // Exclude mpeg audio
            audioCodec = 'mp4a.40.2';
            logger["b" /* logger */].log('Android: force audio codec to ' + audioCodec);
          }
          track.levelCodec = audioCodec;
          track.id = data.id;
        }
        track = tracks.video;
        if (track) {
          track.levelCodec = this.levels[this.level].videoCodec;
          track.id = data.id;
        }
        this.hls.trigger(events["a" /* default */].BUFFER_CODECS, tracks);
        // loop through tracks that are going to be provided to bufferController
        for (trackName in tracks) {
          track = tracks[trackName];
          logger["b" /* logger */].log('main track:' + trackName + ',container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            this.appended = true;
            // arm pending Buffering flag before appending a segment
            this.pendingBuffering = true;
            this.hls.trigger(events["a" /* default */].BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
          }
        }
        // trigger handler right now
        this.tick();
      }
    };

    StreamController.prototype.onFragParsingData = function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
      this.state === State.PARSING) {
        var level = this.levels[this.level],
            frag = fragCurrent;
        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        if (data.hasAudio === true) frag.addElementaryStream(loader_fragment.ElementaryStreamTypes.AUDIO);

        if (data.hasVideo === true) frag.addElementaryStream(loader_fragment.ElementaryStreamTypes.VIDEO);

        logger["b" /* logger */].log('Parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb + ',dropped:' + (data.dropped || 0));

        // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
        if (data.type === 'video') {
          frag.dropped = data.dropped;
          if (frag.dropped) {
            if (!frag.backtracked) {
              var levelDetails = level.details;
              if (levelDetails && frag.sn === levelDetails.startSN) {
                logger["b" /* logger */].warn('missing video frame(s) on first frag, appending with gap');
              } else {
                logger["b" /* logger */].warn('missing video frame(s), backtracking fragment');
                // Return back to the IDLE state without appending to buffer
                // Causes findFragments to backtrack a segment and find the keyframe
                // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
                this.fragmentTracker.removeFragment(frag);
                frag.backtracked = true;
                this.nextLoadPosition = data.startPTS;
                this.state = State.IDLE;
                this.fragPrevious = frag;
                this.tick();
                return;
              }
            } else {
              logger["b" /* logger */].warn('Already backtracked on this fragment, appending with the gap');
            }
          } else {
            // Only reset the backtracked flag if we've loaded the frag without any dropped frames
            frag.backtracked = false;
          }
        }

        var drift = updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS),
            hls = this.hls;
        hls.trigger(events["a" /* default */].LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });
        // has remuxer dropped video frames located before first keyframe ?
        [data.data1, data.data2].forEach(function (buffer) {
          // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
          // in that case it is useless to append following segments
          if (buffer && buffer.length && _this2.state === State.PARSING) {
            _this2.appended = true;
            // arm pending Buffering flag before appending a segment
            _this2.pendingBuffering = true;
            hls.trigger(events["a" /* default */].BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
          }
        });
        // trigger handler right now
        this.tick();
      }
    };

    StreamController.prototype.onFragParsed = function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = State.PARSED;
        this._checkAppendedParsed();
      }
    };

    StreamController.prototype.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url,
          trackId = data.id;
      // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
      // don't do anything if we switch to alt audio: audio stream controller is handling it.
      // we will just have to change buffer scheduling on audioTrackSwitched
      if (!altAudio) {
        if (this.mediaBuffer !== this.media) {
          logger["b" /* logger */].log('switching on main audio, use media.buffered to schedule main fragment loading');
          this.mediaBuffer = this.media;
          var fragCurrent = this.fragCurrent;
          // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
          if (fragCurrent.loader) {
            logger["b" /* logger */].log('switching to main audio track, cancel main fragment load');
            fragCurrent.loader.abort();
          }
          this.fragCurrent = null;
          this.fragPrevious = null;
          // destroy demuxer to force init segment generation (following audio switch)
          if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
          }
          // switch to IDLE state to load new fragment
          this.state = State.IDLE;
        }
        var hls = this.hls;
        // switching to main audio, flush all audio and trigger track switched
        hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
        hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
        this.altAudio = false;
      }
    };

    StreamController.prototype.onAudioTrackSwitched = function onAudioTrackSwitched(data) {
      var trackId = data.id,
          altAudio = !!this.hls.audioTracks[trackId].url;
      if (altAudio) {
        var videoBuffer = this.videoBuffer;
        // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
        if (videoBuffer && this.mediaBuffer !== videoBuffer) {
          logger["b" /* logger */].log('switching on alternate audio, use video.buffered to schedule main fragment loading');
          this.mediaBuffer = videoBuffer;
        }
      }
      this.altAudio = altAudio;
      this.tick();
    };

    StreamController.prototype.onBufferCreated = function onBufferCreated(data) {
      var tracks = data.tracks,
          mediaTrack = void 0,
          name = void 0,
          alternate = false;
      for (var type in tracks) {
        var track = tracks[type];
        if (track.id === 'main') {
          name = type;
          mediaTrack = track;
          // keep video source buffer reference
          if (type === 'video') this.videoBuffer = tracks[type].buffer;
        } else {
          alternate = true;
        }
      }
      if (alternate && mediaTrack) {
        logger["b" /* logger */].log('alternate track found, use ' + name + '.buffered to schedule main fragment loading');
        this.mediaBuffer = mediaTrack.buffer;
      } else {
        this.mediaBuffer = this.media;
      }
    };

    StreamController.prototype.onBufferAppended = function onBufferAppended(data) {
      if (data.parent === 'main') {
        var state = this.state;
        if (state === State.PARSING || state === State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    };

    StreamController.prototype._checkAppendedParsed = function _checkAppendedParsed() {
      // trigger handler right now
      if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent;
        if (frag) {
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          logger["b" /* logger */].log('main buffered : ' + time_ranges.toString(media.buffered));
          this.fragPrevious = frag;
          var stats = this.stats;
          stats.tbuffered = performance.now();
          // we should get rid of this.fragLastKbps
          this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
          this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
          this.state = State.IDLE;
        }
        this.tick();
      }
    };

    StreamController.prototype.onError = function onError(data) {
      var frag = data.frag || this.fragCurrent;
      // don't handle frag error not related to main fragment
      if (frag && frag.type !== 'main') return;

      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      var mediaBuffered = !!this.media && buffer_helper.isBuffered(this.media, this.media.currentTime) && buffer_helper.isBuffered(this.media, this.media.currentTime + 0.5);

      switch (data.details) {
        case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
        case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
          if (!data.fatal) {
            // keep retrying until the limit will be reached
            if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
              logger["b" /* logger */].warn('mediaController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              // if loadedmetadata is not set, it means that we are emergency switch down on first frag
              // in that case, reset startFragRequested flag
              if (!this.loadedmetadata) {
                this.startFragRequested = false;
                this.nextLoadPosition = this.startPosition;
              }
              this.fragLoadError++;
              this.state = State.FRAG_LOADING_WAITING_RETRY;
            } else {
              logger["b" /* logger */].error('mediaController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = State.ERROR;
            }
          }
          break;
        case errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT:
          if (this.state !== State.ERROR) {
            if (data.fatal) {
              // if fatal error, stop processing
              this.state = State.ERROR;
              logger["b" /* logger */].warn('streamController: ' + data.details + ',switch to ' + this.state + ' state ...');
            } else {
              // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
              if (!data.levelRetry && this.state === State.WAITING_LEVEL) this.state = State.IDLE;
            }
          }
          break;
        case errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              this._reduceMaxBufferLength(this.config.maxBufferLength);
              this.state = State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole buffer to recover
              logger["b" /* logger */].warn('buffer full error also media.currentTime is not buffered, flush everything');
              this.fragCurrent = null;
              // flush everything
              this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
            }
          }
          break;
        default:
          break;
      }
    };

    StreamController.prototype._reduceMaxBufferLength = function _reduceMaxBufferLength(minLength) {
      var config = this.config;
      if (config.maxMaxBufferLength >= minLength) {
        // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
        config.maxMaxBufferLength /= 2;
        logger["b" /* logger */].warn('main:reduce max buffer length to ' + config.maxMaxBufferLength + 's');
        return true;
      }
      return false;
    };

    StreamController.prototype._checkBuffer = function _checkBuffer() {
      var media = this.media,
          config = this.config;
      // if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
      if (media && media.readyState) {
        var currentTime = media.currentTime,
            mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media,
            buffered = mediaBuffer.buffered;
        // adjust currentTime to start position on loaded metadata
        if (!this.loadedmetadata && buffered.length) {
          this.loadedmetadata = true;
          // only adjust currentTime if different from startPosition or if startPosition not buffered
          // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
          var startPosition = media.seeking ? currentTime : this.startPosition;
          // if currentTime not matching with expected startPosition or startPosition not buffered but close to first buffered
          if (currentTime !== startPosition) {
            // if startPosition not buffered, let's seek to buffered.start(0)

            logger["b" /* logger */].log('target start position not buffered, seek to buffered.start(0) ' + startPosition + ' from current time' + currentTime + ' ');
            media.currentTime = startPosition;
          }
        } else if (this.immediateSwitch) {
          this.immediateLevelSwitchEnd();
        } else {
          var bufferInfo = buffer_helper.bufferInfo(media, currentTime, config.maxBufferHole),
              expectedPlaying = !(media.paused && media.readyState > 1 || // not playing when media is paused and sufficiently buffered
          media.ended || // not playing when media is ended
          media.buffered.length === 0),
              // not playing if nothing buffered
          jumpThreshold = 0.5,
              // tolerance needed as some browsers stalls playback before reaching buffered range end
          playheadMoving = currentTime !== this.lastCurrentTime;

          if (playheadMoving) {
            // played moving, but was previously stalled => now not stuck anymore
            if (this.stallReported) {
              logger["b" /* logger */].warn('playback not stuck anymore @' + currentTime + ', after ' + Math.round(performance.now() - this.stalled) + 'ms');
              this.stallReported = false;
            }
            this.stalled = undefined;
            this.nudgeRetry = 0;
          } else {
            // playhead not moving
            if (expectedPlaying) {
              // playhead not moving BUT media expected to play
              var tnow = performance.now();
              var hls = this.hls;
              if (!this.stalled) {
                // stall just detected, store current time
                this.stalled = tnow;
                this.stallReported = false;
              } else {
                // playback already stalled, check stalling duration
                // if stalling for more than a given threshold, let's try to recover
                var stalledDuration = tnow - this.stalled;
                var bufferLen = bufferInfo.len;
                var nudgeRetry = this.nudgeRetry || 0;
                // Check if fragment is broken
                var partial = this.fragmentTracker.getPartialFragment(currentTime);
                if (partial !== null) {
                  var lastEndTime = 0;
                  // Check if currentTime is between unbuffered regions of partial fragments
                  for (var i = 0; i < media.buffered.length; i++) {
                    var startTime = media.buffered.start(i);
                    if (currentTime >= lastEndTime && currentTime < startTime) {
                      media.currentTime = Math.max(startTime, media.currentTime + 0.1);
                      logger["b" /* logger */].warn('skipping hole, adjusting currentTime from ' + currentTime + ' to ' + media.currentTime);
                      this.stalled = undefined;
                      hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_SEEK_OVER_HOLE, fatal: false, reason: 'fragment loaded with buffer holes, seeking from ' + currentTime + ' to ' + media.currentTime, frag: partial });
                      return;
                    }
                    lastEndTime = media.buffered.end(i);
                  }
                }
                if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
                  // report stalled error once
                  if (!this.stallReported) {
                    this.stallReported = true;
                    logger["b" /* logger */].warn('playback stalling in high buffer @' + currentTime);
                    hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
                  }
                  // reset stalled so to rearm watchdog timer
                  this.stalled = undefined;
                  this.nudgeRetry = ++nudgeRetry;
                  if (nudgeRetry < config.nudgeMaxRetry) {
                    var _currentTime = media.currentTime;
                    var targetTime = _currentTime + nudgeRetry * config.nudgeOffset;
                    logger["b" /* logger */].log('adjust currentTime from ' + _currentTime + ' to ' + targetTime);
                    // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
                    media.currentTime = targetTime;
                    hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_NUDGE_ON_STALL, fatal: false });
                  } else {
                    logger["b" /* logger */].error('still stuck in high buffer @' + currentTime + ' after ' + config.nudgeMaxRetry + ', raise fatal error');
                    hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_STALLED_ERROR, fatal: true });
                  }
                }
              }
            }
          }
        }
      }
    };

    StreamController.prototype.onFragLoadEmergencyAborted = function onFragLoadEmergencyAborted() {
      this.state = State.IDLE;
      // if loadedmetadata is not set, it means that we are emergency switch down on first frag
      // in that case, reset startFragRequested flag
      if (!this.loadedmetadata) {
        this.startFragRequested = false;
        this.nextLoadPosition = this.startPosition;
      }
      this.tick();
    };

    StreamController.prototype.onBufferFlushed = function onBufferFlushed() {
      /* after successful buffer flushing, filter flushed fragments from bufferedFrags
        use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
      */
      var media = this.mediaBuffer ? this.mediaBuffer : this.media;
      // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
      this.fragmentTracker.detectEvictedFragments(loader_fragment.ElementaryStreamTypes.VIDEO, media.buffered);

      // move to IDLE once flush complete. this should trigger new fragment loading
      this.state = State.IDLE;
      // reset reference to frag
      this.fragPrevious = null;
    };

    StreamController.prototype.swapAudioCodec = function swapAudioCodec() {
      this.audioCodecSwap = !this.audioCodecSwap;
    };

    StreamController.prototype.computeLivePosition = function computeLivePosition(sliding, levelDetails) {
      var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
      return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
    };

    stream_controller__createClass(StreamController, [{
      key: 'state',
      set: function set(nextState) {
        if (this.state !== nextState) {
          var previousState = this.state;
          this._state = nextState;
          logger["b" /* logger */].log('main stream:' + previousState + '->' + nextState);
          this.hls.trigger(events["a" /* default */].STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
        }
      },
      get: function get() {
        return this._state;
      }
    }, {
      key: 'currentLevel',
      get: function get() {
        var media = this.media;
        if (media) {
          var frag = this.getBufferedFrag(media.currentTime);
          if (frag) return frag.level;
        }
        return -1;
      }
    }, {
      key: 'nextBufferedFrag',
      get: function get() {
        var media = this.media;
        if (media) {
          // first get end range of current fragment
          return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
        } else {
          return null;
        }
      }
    }, {
      key: 'nextLevel',
      get: function get() {
        var frag = this.nextBufferedFrag;
        if (frag) return frag.level;else return -1;
      }
    }, {
      key: 'liveSyncPosition',
      get: function get() {
        return this._liveSyncPosition;
      },
      set: function set(value) {
        this._liveSyncPosition = value;
      }
    }]);

    return StreamController;
  }(task_loop);

  /* harmony default export */ var stream_controller = (stream_controller_StreamController);
  // CONCATENATED MODULE: ./src/controller/level-controller.js
  var level_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function level_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function level_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function level_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Level Controller
  */







  var level_controller_LevelController = function (_EventHandler) {
    level_controller__inherits(LevelController, _EventHandler);

    function LevelController(hls) {
      level_controller__classCallCheck(this, LevelController);

      var _this = level_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].LEVEL_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].ERROR));

      _this.canload = false;
      _this.currentLevelIndex = null;
      _this.manualLevelIndex = -1;
      _this.timer = null;
      return _this;
    }

    LevelController.prototype.onHandlerDestroying = function onHandlerDestroying() {
      this.cleanTimer();
      this.manualLevelIndex = -1;
    };

    LevelController.prototype.cleanTimer = function cleanTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    };

    LevelController.prototype.startLoad = function startLoad() {
      var levels = this._levels;

      this.canload = true;
      this.levelRetryCount = 0;

      // clean up live level details to force reload them, and reset load errors
      if (levels) {
        levels.forEach(function (level) {
          level.loadError = 0;
          var levelDetails = level.details;
          if (levelDetails && levelDetails.live) level.details = undefined;
        });
      }
      // speed up live playlist refresh if timer exists
      if (this.timer !== null) this.loadLevel();
    };

    LevelController.prototype.stopLoad = function stopLoad() {
      this.canload = false;
    };

    LevelController.prototype.onManifestLoaded = function onManifestLoaded(data) {
      var levels = [];
      var bitrateStart = void 0;
      var levelSet = {};
      var levelFromSet = null;
      var videoCodecFound = false;
      var audioCodecFound = false;
      var chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
      var audioTracks = [];

      // regroup redundant levels together
      data.levels.forEach(function (level) {
        level.loadError = 0;
        level.fragmentError = false;

        videoCodecFound = videoCodecFound || !!level.videoCodec;
        audioCodecFound = audioCodecFound || !!level.audioCodec || !!(level.attrs && level.attrs.AUDIO);

        // erase audio codec info if browser does not support mp4a.40.34.
        // demuxer will autodetect codec and fallback to mpeg/audio
        if (chromeOrFirefox === true && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) level.audioCodec = undefined;

        levelFromSet = levelSet[level.bitrate];

        if (levelFromSet === undefined) {
          level.url = [level.url];
          level.urlId = 0;
          levelSet[level.bitrate] = level;
          levels.push(level);
        } else {
          levelFromSet.url.push(level.url);
        }
      });

      // remove audio-only level if we also have levels with audio+video codecs signalled
      if (videoCodecFound === true && audioCodecFound === true) levels = levels.filter(function (_ref) {
        var videoCodec = _ref.videoCodec;
        return !!videoCodec;
      });

      // only keep levels with supported audio/video codecs
      levels = levels.filter(function (_ref2) {
        var audioCodec = _ref2.audioCodec,
            videoCodec = _ref2.videoCodec;

        return (!audioCodec || isCodecSupportedInMp4(audioCodec)) && (!videoCodec || isCodecSupportedInMp4(videoCodec));
      });

      if (data.audioTracks) audioTracks = data.audioTracks.filter(function (track) {
        return !track.audioCodec || isCodecSupportedInMp4(track.audioCodec, 'audio');
      });

      if (levels.length > 0) {
        // start bitrate is the first bitrate of the manifest
        bitrateStart = levels[0].bitrate;
        // sort level on bitrate
        levels.sort(function (a, b) {
          return a.bitrate - b.bitrate;
        });
        this._levels = levels;
        // find index of first level in sorted levels
        for (var i = 0; i < levels.length; i++) {
          if (levels[i].bitrate === bitrateStart) {
            this._firstLevel = i;
            logger["b" /* logger */].log('manifest loaded,' + levels.length + ' level(s) found, first bitrate:' + bitrateStart);
            break;
          }
        }
        this.hls.trigger(events["a" /* default */].MANIFEST_PARSED, {
          levels: levels,
          audioTracks: audioTracks,
          firstLevel: this._firstLevel,
          stats: data.stats,
          audio: audioCodecFound,
          video: videoCodecFound,
          altAudio: audioTracks.length > 0
        });
      } else {
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].MEDIA_ERROR,
          details: errors["a" /* ErrorDetails */].MANIFEST_INCOMPATIBLE_CODECS_ERROR,
          fatal: true,
          url: this.hls.url,
          reason: 'no level with compatible codecs found in manifest'
        });
      }
    };

    LevelController.prototype.setLevelInternal = function setLevelInternal(newLevel) {
      var levels = this._levels;
      var hls = this.hls;
      // check if level idx is valid
      if (newLevel >= 0 && newLevel < levels.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        if (this.currentLevelIndex !== newLevel) {
          logger["b" /* logger */].log('switching to level ' + newLevel);
          this.currentLevelIndex = newLevel;
          var levelProperties = levels[newLevel];
          levelProperties.level = newLevel;
          hls.trigger(events["a" /* default */].LEVEL_SWITCHING, levelProperties);
        }
        var level = levels[newLevel],
            levelDetails = level.details;
        // check if we need to load playlist for this level
        if (!levelDetails || levelDetails.live === true) {
          // level not retrieved yet, or live playlist we need to (re)load it
          var urlId = level.urlId;
          hls.trigger(events["a" /* default */].LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
        }
      } else {
        // invalid level id given, trigger error
        hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].OTHER_ERROR,
          details: errors["a" /* ErrorDetails */].LEVEL_SWITCH_ERROR,
          level: newLevel,
          fatal: false,
          reason: 'invalid level idx'
        });
      }
    };

    LevelController.prototype.onError = function onError(data) {
      if (data.fatal === true) {
        if (data.type === errors["b" /* ErrorTypes */].NETWORK_ERROR) this.cleanTimer();

        return;
      }

      var levelError = false,
          fragmentError = false;
      var levelIndex = void 0;

      // try to recover not fatal errors
      switch (data.details) {
        case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
        case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
          levelIndex = data.frag.level;
          fragmentError = true;
          break;
        case errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT:
          levelIndex = data.context.level;
          levelError = true;
          break;
        case errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR:
          levelIndex = data.level;
          levelError = true;
          break;
      }

      if (levelIndex !== undefined) this.recoverLevel(data, levelIndex, levelError, fragmentError);
    };

    /**
     * Switch to a redundant stream if any available.
     * If redundant stream is not available, emergency switch down if ABR mode is enabled.
     *
     * @param {Object} errorEvent
     * @param {Number} levelIndex current level index
     * @param {Boolean} levelError
     * @param {Boolean} fragmentError
     */
    // FIXME Find a better abstraction where fragment/level retry management is well decoupled


    LevelController.prototype.recoverLevel = function recoverLevel(errorEvent, levelIndex, levelError, fragmentError) {
      var _this2 = this;

      var config = this.hls.config;
      var errorDetails = errorEvent.details;

      var level = this._levels[levelIndex];
      var redundantLevels = void 0,
          delay = void 0,
          nextLevel = void 0;

      level.loadError++;
      level.fragmentError = fragmentError;

      if (levelError === true) {
        if (this.levelRetryCount + 1 <= config.levelLoadingMaxRetry) {
          // exponential backoff capped to max retry timeout
          delay = Math.min(Math.pow(2, this.levelRetryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout);
          // Schedule level reload
          this.timer = setTimeout(function () {
            return _this2.loadLevel();
          }, delay);
          // boolean used to inform stream controller not to switch back to IDLE on non fatal error
          errorEvent.levelRetry = true;
          this.levelRetryCount++;
          logger["b" /* logger */].warn('level controller, ' + errorDetails + ', retry in ' + delay + ' ms, current retry count is ' + this.levelRetryCount);
        } else {
          logger["b" /* logger */].error('level controller, cannot recover from ' + errorDetails + ' error');
          this.currentLevelIndex = null;
          // stopping live reloading timer if any
          this.cleanTimer();
          // switch error to fatal
          errorEvent.fatal = true;
          return;
        }
      }

      // Try any redundant streams if available for both errors: level and fragment
      // If level.loadError reaches redundantLevels it means that we tried them all, no hope  => let's switch down
      if (levelError === true || fragmentError === true) {
        redundantLevels = level.url.length;

        if (redundantLevels > 1 && level.loadError < redundantLevels) {
          logger["b" /* logger */].warn('level controller, ' + errorDetails + ' for level ' + levelIndex + ': switching to redundant stream id ' + level.urlId);
          level.urlId = (level.urlId + 1) % redundantLevels;
          level.details = undefined;
        } else {
          // Search for available level
          if (this.manualLevelIndex === -1) {
            // When lowest level has been reached, let's start hunt from the top
            nextLevel = levelIndex === 0 ? this._levels.length - 1 : levelIndex - 1;
            logger["b" /* logger */].warn('level controller, ' + errorDetails + ': switch to ' + nextLevel);
            this.hls.nextAutoLevel = this.currentLevelIndex = nextLevel;
          } else if (fragmentError === true) {
            // Allow fragment retry as long as configuration allows.
            // reset this._level so that another call to set level() will trigger again a frag load
            logger["b" /* logger */].warn('level controller, ' + errorDetails + ': reload a fragment');
            this.currentLevelIndex = null;
          }
        }
      }
    };

    // reset errors on the successful load of a fragment


    LevelController.prototype.onFragLoaded = function onFragLoaded(_ref3) {
      var frag = _ref3.frag;

      if (frag !== undefined && frag.type === 'main') {
        var level = this._levels[frag.level];
        if (level !== undefined) {
          level.fragmentError = false;
          level.loadError = 0;
          this.levelRetryCount = 0;
        }
      }
    };

    LevelController.prototype.onLevelLoaded = function onLevelLoaded(data) {
      var _this3 = this;

      var levelId = data.level;
      // only process level loaded events matching with expected level
      if (levelId === this.currentLevelIndex) {
        var curLevel = this._levels[levelId];
        // reset level load error counter on successful level loaded only if there is no issues with fragments
        if (curLevel.fragmentError === false) {
          curLevel.loadError = 0;
          this.levelRetryCount = 0;
        }
        var newDetails = data.details;
        // if current playlist is a live playlist, arm a timer to reload it
        if (newDetails.live) {
          var targetdurationMs = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration);
          var reloadInterval = targetdurationMs,
              curDetails = curLevel.details;
          if (curDetails && newDetails.endSN === curDetails.endSN) {
            // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
            // changed then it MUST wait for a period of one-half the target
            // duration before retrying.
            reloadInterval /= 2;
            logger["b" /* logger */].log('same live playlist, reload twice faster');
          }
          // decrement reloadInterval with level loading delay
          reloadInterval -= performance.now() - data.stats.trequest;
          // in any case, don't reload more than half of target duration
          reloadInterval = Math.max(targetdurationMs / 2, Math.round(reloadInterval));
          logger["b" /* logger */].log('live playlist, reload in ' + Math.round(reloadInterval) + ' ms');
          this.timer = setTimeout(function () {
            return _this3.loadLevel();
          }, reloadInterval);
        } else {
          this.cleanTimer();
        }
      }
    };

    LevelController.prototype.loadLevel = function loadLevel() {
      var level = void 0,
          urlIndex = void 0;

      if (this.currentLevelIndex !== null && this.canload === true) {
        level = this._levels[this.currentLevelIndex];
        if (level !== undefined && level.url.length > 0) {
          urlIndex = level.urlId;
          this.hls.trigger(events["a" /* default */].LEVEL_LOADING, { url: level.url[urlIndex], level: this.currentLevelIndex, id: urlIndex });
        }
      }
    };

    level_controller__createClass(LevelController, [{
      key: 'levels',
      get: function get() {
        return this._levels;
      }
    }, {
      key: 'level',
      get: function get() {
        return this.currentLevelIndex;
      },
      set: function set(newLevel) {
        var levels = this._levels;
        if (levels) {
          newLevel = Math.min(newLevel, levels.length - 1);
          if (this.currentLevelIndex !== newLevel || levels[newLevel].details === undefined) this.setLevelInternal(newLevel);
        }
      }
    }, {
      key: 'manualLevel',
      get: function get() {
        return this.manualLevelIndex;
      },
      set: function set(newLevel) {
        this.manualLevelIndex = newLevel;
        if (this._startLevel === undefined) this._startLevel = newLevel;

        if (newLevel !== -1) this.level = newLevel;
      }
    }, {
      key: 'firstLevel',
      get: function get() {
        return this._firstLevel;
      },
      set: function set(newLevel) {
        this._firstLevel = newLevel;
      }
    }, {
      key: 'startLevel',
      get: function get() {
        // hls.startLevel takes precedence over config.startLevel
        // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
        if (this._startLevel === undefined) {
          var configStartLevel = this.hls.config.startLevel;
          if (configStartLevel !== undefined) return configStartLevel;else return this._firstLevel;
        } else {
          return this._startLevel;
        }
      },
      set: function set(newLevel) {
        this._startLevel = newLevel;
      }
    }, {
      key: 'nextLoadLevel',
      get: function get() {
        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;else return this.hls.nextAutoLevel;
      },
      set: function set(nextLevel) {
        this.level = nextLevel;
        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
      }
    }]);

    return LevelController;
  }(event_handler);

  /* harmony default export */ var level_controller = (level_controller_LevelController);
  // EXTERNAL MODULE: ./src/demux/id3.js
  var id3 = __webpack_require__(4);

  // CONCATENATED MODULE: ./src/utils/texttrack-utils.js

  function sendAddTrackEvent(track, videoEl) {
    var event = null;
    try {
      event = new window.Event('addtrack');
    } catch (err) {
      // for IE11
      event = document.createEvent('Event');
      event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
  }

  function clearCurrentCues(track) {
    if (track && track.cues) {
      while (track.cues.length > 0) {
        track.removeCue(track.cues[0]);
      }
    }
  }
  // CONCATENATED MODULE: ./src/controller/id3-track-controller.js
  function id3_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function id3_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function id3_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * id3 metadata track controller
  */






  var id3_track_controller_ID3TrackController = function (_EventHandler) {
    id3_track_controller__inherits(ID3TrackController, _EventHandler);

    function ID3TrackController(hls) {
      id3_track_controller__classCallCheck(this, ID3TrackController);

      var _this = id3_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].FRAG_PARSING_METADATA));

      _this.id3Track = undefined;
      _this.media = undefined;
      return _this;
    }

    ID3TrackController.prototype.destroy = function destroy() {
      event_handler.prototype.destroy.call(this);
    };

    // Add ID3 metatadata text track.


    ID3TrackController.prototype.onMediaAttached = function onMediaAttached(data) {
      this.media = data.media;
      if (!this.media) ;
    };

    ID3TrackController.prototype.onMediaDetaching = function onMediaDetaching() {
      clearCurrentCues(this.id3Track);
      this.id3Track = undefined;
      this.media = undefined;
    };

    ID3TrackController.prototype.getID3Track = function getID3Track(textTracks) {
      for (var i = 0; i < textTracks.length; i++) {
        var textTrack = textTracks[i];
        if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
          // send 'addtrack' when reusing the textTrack for metadata,
          // same as what we do for captions
          sendAddTrackEvent(textTrack, this.media);

          return textTrack;
        }
      }
      return this.media.addTextTrack('metadata', 'id3');
    };

    ID3TrackController.prototype.onFragParsingMetadata = function onFragParsingMetadata(data) {
      var fragment = data.frag;
      var samples = data.samples;

      // create track dynamically
      if (!this.id3Track) {
        this.id3Track = this.getID3Track(this.media.textTracks);
        this.id3Track.mode = 'hidden';
      }

      // Attempt to recreate Safari functionality by creating
      // WebKitDataCue objects when available and store the decoded
      // ID3 data in the value property of the cue
      var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;

      for (var i = 0; i < samples.length; i++) {
        var frames = id3["a" /* default */].getID3Frames(samples[i].data);
        if (frames) {
          var startTime = samples[i].pts;
          var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;

          // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
          if (startTime === endTime) endTime += 0.0001;

          for (var j = 0; j < frames.length; j++) {
            var frame = frames[j];
            // Safari doesn't put the timestamp frame in the TextTrack
            if (!id3["a" /* default */].isTimeStampFrame(frame)) {
              var cue = new Cue(startTime, endTime, '');
              cue.value = frame;
              this.id3Track.addCue(cue);
            }
          }
        }
      }
    };

    return ID3TrackController;
  }(event_handler);

  /* harmony default export */ var id3_track_controller = (id3_track_controller_ID3TrackController);
  // CONCATENATED MODULE: ./src/helper/is-supported.js


  function is_supported_isSupported() {
    var mediaSource = getMediaSource();
    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

    // if SourceBuffer is exposed ensure its API is valid
    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
    return !!isTypeSupported && !!sourceBufferValidAPI;
  }
  // CONCATENATED MODULE: ./src/utils/ewma.js
  function ewma__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * compute an Exponential Weighted moving average
   * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
   *  - heavily inspired from shaka-player
   */

  var EWMA = function () {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    function EWMA(halfLife) {
      ewma__classCallCheck(this, EWMA);

      // Larger values of alpha expire historical data more slowly.
      this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
      this.estimate_ = 0;
      this.totalWeight_ = 0;
    }

    EWMA.prototype.sample = function sample(weight, value) {
      var adjAlpha = Math.pow(this.alpha_, weight);
      this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
      this.totalWeight_ += weight;
    };

    EWMA.prototype.getTotalWeight = function getTotalWeight() {
      return this.totalWeight_;
    };

    EWMA.prototype.getEstimate = function getEstimate() {
      if (this.alpha_) {
        var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
        return this.estimate_ / zeroFactor;
      } else {
        return this.estimate_;
      }
    };

    return EWMA;
  }();

  /* harmony default export */ var ewma = (EWMA);
  // CONCATENATED MODULE: ./src/utils/ewma-bandwidth-estimator.js
  function ewma_bandwidth_estimator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * EWMA Bandwidth Estimator
   *  - heavily inspired from shaka-player
   * Tracks bandwidth samples and estimates available bandwidth.
   * Based on the minimum of two exponentially-weighted moving averages with
   * different half-lives.
   */



  var ewma_bandwidth_estimator_EwmaBandWidthEstimator = function () {
    function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
      ewma_bandwidth_estimator__classCallCheck(this, EwmaBandWidthEstimator);

      this.hls = hls;
      this.defaultEstimate_ = defaultEstimate;
      this.minWeight_ = 0.001;
      this.minDelayMs_ = 50;
      this.slow_ = new ewma(slow);
      this.fast_ = new ewma(fast);
    }

    EwmaBandWidthEstimator.prototype.sample = function sample(durationMs, numBytes) {
      durationMs = Math.max(durationMs, this.minDelayMs_);
      var bandwidth = 8000 * numBytes / durationMs,

      // console.log('instant bw:'+ Math.round(bandwidth));
      // we weight sample using loading duration....
      weight = durationMs / 1000;
      this.fast_.sample(weight, bandwidth);
      this.slow_.sample(weight, bandwidth);
    };

    EwmaBandWidthEstimator.prototype.canEstimate = function canEstimate() {
      var fast = this.fast_;
      return fast && fast.getTotalWeight() >= this.minWeight_;
    };

    EwmaBandWidthEstimator.prototype.getEstimate = function getEstimate() {
      if (this.canEstimate()) {
        // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
      } else {
        return this.defaultEstimate_;
      }
    };

    EwmaBandWidthEstimator.prototype.destroy = function destroy() {};

    return EwmaBandWidthEstimator;
  }();

  /* harmony default export */ var ewma_bandwidth_estimator = (ewma_bandwidth_estimator_EwmaBandWidthEstimator);
  // CONCATENATED MODULE: ./src/controller/abr-controller.js
  var abr_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function abr_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function abr_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function abr_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * simple ABR Controller
   *  - compute next level based on last fragment bw heuristics
   *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
   */








  var abr_controller_AbrController = function (_EventHandler) {
    abr_controller__inherits(AbrController, _EventHandler);

    function AbrController(hls) {
      abr_controller__classCallCheck(this, AbrController);

      var _this = abr_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FRAG_LOADING, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_BUFFERED, events["a" /* default */].ERROR));

      _this.lastLoadedFragLevel = 0;
      _this._nextAutoLevel = -1;
      _this.hls = hls;
      _this.timer = null;
      _this._bwEstimator = null;
      _this.onCheck = _this._abandonRulesCheck.bind(_this);
      return _this;
    }

    AbrController.prototype.destroy = function destroy() {
      this.clearTimer();
      event_handler.prototype.destroy.call(this);
    };

    AbrController.prototype.onFragLoading = function onFragLoading(data) {
      var frag = data.frag;
      if (frag.type === 'main') {
        if (!this.timer) this.timer = setInterval(this.onCheck, 100);

        // lazy init of bw Estimator, rationale is that we use different params for Live/VoD
        // so we need to wait for stream manifest / playlist type to instantiate it.
        if (!this._bwEstimator) {
          var hls = this.hls,
              level = data.frag.level,
              isLive = hls.levels[level].details.live,
              config = hls.config,
              ewmaFast = void 0,
              ewmaSlow = void 0;

          if (isLive) {
            ewmaFast = config.abrEwmaFastLive;
            ewmaSlow = config.abrEwmaSlowLive;
          } else {
            ewmaFast = config.abrEwmaFastVoD;
            ewmaSlow = config.abrEwmaSlowVoD;
          }
          this._bwEstimator = new ewma_bandwidth_estimator(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
        }
        this.fragCurrent = frag;
      }
    };

    AbrController.prototype._abandonRulesCheck = function _abandonRulesCheck() {
      /*
        monitor fragment retrieval time...
        we compute expected time of arrival of the complete fragment.
        we compare it to expected time of buffer starvation
      */
      var hls = this.hls,
          v = hls.media,
          frag = this.fragCurrent,
          loader = frag.loader,
          minAutoLevel = hls.minAutoLevel;

      // if loader has been destroyed or loading has been aborted, stop timer and return
      if (!loader || loader.stats && loader.stats.aborted) {
        logger["b" /* logger */].warn('frag loader destroy or aborted, disarm abandonRules');
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;
        return;
      }
      var stats = loader.stats;
      /* only monitor frag retrieval time if
      (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
      if (v && stats && (!v.paused && v.playbackRate !== 0 || !v.readyState) && frag.autoLevel && frag.level) {
        var requestDelay = performance.now() - stats.trequest,
            playbackRate = Math.abs(v.playbackRate);
        // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
        if (requestDelay > 500 * frag.duration / playbackRate) {
          var levels = hls.levels,
              loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay),
              // byte/s; at least 1 byte/s to avoid division by zero
          // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
          level = levels[frag.level],
              levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate,
              expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)),
              pos = v.currentTime,
              fragLoadedDelay = (expectedLen - stats.loaded) / loadRate,
              bufferStarvationDelay = (buffer_helper.bufferInfo(v, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
          // consider emergency switch down only if we have less than 2 frag buffered AND
          // time to finish loading current fragment is bigger than buffer starvation delay
          // ie if we risk buffer starvation if bw does not increase quickly
          if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
            var fragLevelNextLoadedDelay = void 0,
                nextLoadLevel = void 0;
            // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
            // we start from current level - 1 and we step down , until we find a matching level
            for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
              // compute time to load next fragment at lower level
              // 0.8 : consider only 80% of current bw to be conservative
              // 8 = bits per byte (bps/Bps)
              var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
              fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
              if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                // we found a lower level that be rebuffering free with current estimated bw !
                break;
              }
            }
            // only emergency switch down if it takes less time to load new fragment at lowest level instead
            // of finishing loading current one ...
            if (fragLevelNextLoadedDelay < fragLoadedDelay) {
              logger["b" /* logger */].warn('loading too slow, abort fragment loading and switch to level ' + nextLoadLevel + ':fragLoadedDelay[' + nextLoadLevel + ']<fragLoadedDelay[' + (frag.level - 1) + '];bufferStarvationDelay:' + fragLevelNextLoadedDelay.toFixed(1) + '<' + fragLoadedDelay.toFixed(1) + ':' + bufferStarvationDelay.toFixed(1));
              // force next load level in auto mode
              hls.nextLoadLevel = nextLoadLevel;
              // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
              this._bwEstimator.sample(requestDelay, stats.loaded);
              // abort fragment loading
              loader.abort();
              // stop abandon rules timer
              this.clearTimer();
              hls.trigger(events["a" /* default */].FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
            }
          }
        }
      }
    };

    AbrController.prototype.onFragLoaded = function onFragLoaded(data) {
      var frag = data.frag;
      if (frag.type === 'main' && !isNaN(frag.sn)) {
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // store level id after successful fragment load
        this.lastLoadedFragLevel = frag.level;
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;

        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
          var level = this.hls.levels[frag.level];
          var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
          var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
          level.loaded = { bytes: loadedBytes, duration: loadedDuration };
          level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        // if fragment has been loaded to perform a bitrate test,
        if (data.frag.bitrateTest) {
          var stats = data.stats;
          stats.tparsed = stats.tbuffered = stats.tload;
          this.onFragBuffered(data);
        }
      }
    };

    AbrController.prototype.onFragBuffered = function onFragBuffered(data) {
      var stats = data.stats,
          frag = data.frag;
      // only update stats on first frag buffering
      // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
      // and leading to wrong bw estimation
      // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
      if (stats.aborted !== true && frag.type === 'main' && !isNaN(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
        // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
        // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
        // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
        var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
        logger["b" /* logger */].log('latency/loading/parsing/append/kbps:' + Math.round(stats.tfirst - stats.trequest) + '/' + Math.round(stats.tload - stats.tfirst) + '/' + Math.round(stats.tparsed - stats.tload) + '/' + Math.round(stats.tbuffered - stats.tparsed) + '/' + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
        this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
        stats.bwEstimate = this._bwEstimator.getEstimate();
        // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
        if (frag.bitrateTest) this.bitrateTestDelay = fragLoadingProcessingMs / 1000;else this.bitrateTestDelay = 0;
      }
    };

    AbrController.prototype.onError = function onError(data) {
      // stop timer in case of frag loading error
      switch (data.details) {
        case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
          this.clearTimer();
          break;
        default:
          break;
      }
    };

    AbrController.prototype.clearTimer = function clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    };

    // return next auto level


    AbrController.prototype._findBestLevel = function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
      for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
        var levelInfo = levels[i],
            levelDetails = levelInfo.details,
            avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration,
            live = levelDetails ? levelDetails.live : false,
            adjustedbw = void 0;
        // follow algorithm captured from stagefright :
        // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
        // Pick the highest bandwidth stream below or equal to estimated bandwidth.
        // consider only 80% of the available bandwidth, but if we are switching up,
        // be even more conservative (70%) to avoid overestimating and immediately
        // switching back.
        if (i <= currentLevel) adjustedbw = bwFactor * currentBw;else adjustedbw = bwUpFactor * currentBw;

        var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate,
            fetchDuration = bitrate * avgDuration / adjustedbw;

        logger["b" /* logger */].trace('level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' + i + '/' + Math.round(adjustedbw) + '/' + bitrate + '/' + avgDuration + '/' + maxFetchDuration + '/' + fetchDuration);
        // if adjusted bw is greater than level bitrate AND
        if (adjustedbw > bitrate && (
        // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
        !fetchDuration || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) {
          // as we are looping from highest to lowest, this will return the best achievable quality level
          return i;
        }
      }
      // not enough time budget even with quality level 0 ... rebuffering might happen
      return -1;
    };

    abr_controller__createClass(AbrController, [{
      key: 'nextAutoLevel',
      get: function get() {
        var forcedAutoLevel = this._nextAutoLevel;
        var bwEstimator = this._bwEstimator;
        // in case next auto level has been forced, and bw not available or not reliable, return forced value
        if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) return forcedAutoLevel;

        // compute next level using ABR logic
        var nextABRAutoLevel = this._nextABRAutoLevel;
        // if forced auto level has been defined, use it to cap ABR computed quality level
        if (forcedAutoLevel !== -1) nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);

        return nextABRAutoLevel;
      },
      set: function set(nextLevel) {
        this._nextAutoLevel = nextLevel;
      }
    }, {
      key: '_nextABRAutoLevel',
      get: function get() {
        var hls = this.hls,
            maxAutoLevel = hls.maxAutoLevel,
            levels = hls.levels,
            config = hls.config,
            minAutoLevel = hls.minAutoLevel;
        var v = hls.media,
            currentLevel = this.lastLoadedFragLevel,
            currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0,
            pos = v ? v.currentTime : 0,

        // playbackRate is the absolute value of the playback rate; if v.playbackRate is 0, we use 1 to load as
        // if we're playing back at the normal rate.
        playbackRate = v && v.playbackRate !== 0 ? Math.abs(v.playbackRate) : 1.0,
            avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate,

        // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
        bufferStarvationDelay = (buffer_helper.bufferInfo(v, pos, config.maxBufferHole).end - pos) / playbackRate;

        // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
        var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
        if (bestLevel >= 0) {
          return bestLevel;
        } else {
          logger["b" /* logger */].trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
          // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
          // if no matching level found, logic will return 0
          var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay,
              bwFactor = config.abrBandWidthFactor,
              bwUpFactor = config.abrBandWidthUpFactor;
          if (bufferStarvationDelay === 0) {
            // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
            var bitrateTestDelay = this.bitrateTestDelay;
            if (bitrateTestDelay) {
              // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
              // max video loading delay used in  automatic start level selection :
              // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
              // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
              // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
              var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
              maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
              logger["b" /* logger */].trace('bitrate test took ' + Math.round(1000 * bitrateTestDelay) + 'ms, set first fragment max fetchDuration to ' + Math.round(1000 * maxStarvationDelay) + ' ms');
              // don't use conservative factor on bitrate test
              bwFactor = bwUpFactor = 1;
            }
          }
          bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
          return Math.max(bestLevel, 0);
        }
      }
    }]);

    return AbrController;
  }(event_handler);

  /* harmony default export */ var abr_controller = (abr_controller_AbrController);
  // CONCATENATED MODULE: ./src/controller/buffer-controller.js
  function buffer_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function buffer_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function buffer_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Buffer Controller
  */







  var buffer_controller_MediaSource = getMediaSource();

  var buffer_controller_BufferController = function (_EventHandler) {
    buffer_controller__inherits(BufferController, _EventHandler);

    function BufferController(hls) {
      buffer_controller__classCallCheck(this, BufferController);

      // the value that we have set mediasource.duration to
      // (the actual duration may be tweaked slighly by the browser)
      var _this = buffer_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].BUFFER_RESET, events["a" /* default */].BUFFER_APPENDING, events["a" /* default */].BUFFER_CODECS, events["a" /* default */].BUFFER_EOS, events["a" /* default */].BUFFER_FLUSHING, events["a" /* default */].LEVEL_PTS_UPDATED, events["a" /* default */].LEVEL_UPDATED));

      _this._msDuration = null;
      // the value that we want to set mediaSource.duration to
      _this._levelDuration = null;
      // current stream state: true - for live broadcast, false - for VoD content
      _this._live = null;
      // cache the self generated object url to detect hijack of video tag
      _this._objectUrl = null;

      // Source Buffer listeners
      _this.onsbue = _this.onSBUpdateEnd.bind(_this);
      _this.onsbe = _this.onSBUpdateError.bind(_this);
      _this.pendingTracks = {};
      _this.tracks = {};
      return _this;
    }

    BufferController.prototype.destroy = function destroy() {
      event_handler.prototype.destroy.call(this);
    };

    BufferController.prototype.onLevelPtsUpdated = function onLevelPtsUpdated(data) {
      var type = data.type;
      var audioTrack = this.tracks.audio;

      // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
      // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
      // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
      // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
      // event if SB is in updating state.
      // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486

      if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
        // Chrome audio mp3 track
        var audioBuffer = this.sourceBuffer.audio;
        var delta = Math.abs(audioBuffer.timestampOffset - data.start);

        // adjust timestamp offset if time delta is greater than 100ms
        if (delta > 0.1) {
          var updating = audioBuffer.updating;

          try {
            audioBuffer.abort();
          } catch (err) {
            updating = true;
            logger["b" /* logger */].warn('can not abort audio buffer: ' + err);
          }

          if (!updating) {
            logger["b" /* logger */].warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
            audioBuffer.timestampOffset = data.start;
          } else {
            this.audioTimestampOffset = data.start;
          }
        }
      }
    };

    BufferController.prototype.onManifestParsed = function onManifestParsed(data) {
      var audioExpected = data.audio,
          videoExpected = data.video || data.levels.length && data.audio,
          sourceBufferNb = 0;
      // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
      // sourcebuffers will be created all at once when the expected nb of tracks will be reached
      // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
      // it will contain the expected nb of source buffers, no need to compute it
      if (data.altAudio && (audioExpected || videoExpected)) {
        sourceBufferNb = (audioExpected ? 1 : 0) + (videoExpected ? 1 : 0);
        logger["b" /* logger */].log(sourceBufferNb + ' sourceBuffer(s) expected');
      }
      this.sourceBufferNb = sourceBufferNb;
    };

    BufferController.prototype.onMediaAttaching = function onMediaAttaching(data) {
      var media = this.media = data.media;
      if (media) {
        // setup the media source
        var ms = this.mediaSource = new buffer_controller_MediaSource();
        // Media Source listeners
        this.onmso = this.onMediaSourceOpen.bind(this);
        this.onmse = this.onMediaSourceEnded.bind(this);
        this.onmsc = this.onMediaSourceClose.bind(this);
        ms.addEventListener('sourceopen', this.onmso);
        ms.addEventListener('sourceended', this.onmse);
        ms.addEventListener('sourceclose', this.onmsc);
        // link video and media Source
        media.src = URL.createObjectURL(ms);
        // cache the locally generated object url
        this._objectUrl = media.src;
      }
    };

    BufferController.prototype.onMediaDetaching = function onMediaDetaching() {
      logger["b" /* logger */].log('media source detaching');
      var ms = this.mediaSource;
      if (ms) {
        if (ms.readyState === 'open') {
          try {
            // endOfStream could trigger exception if any sourcebuffer is in updating state
            // we don't really care about checking sourcebuffer state here,
            // as we are anyway detaching the MediaSource
            // let's just avoid this exception to propagate
            ms.endOfStream();
          } catch (err) {
            logger["b" /* logger */].warn('onMediaDetaching:' + err.message + ' while calling endOfStream');
          }
        }
        ms.removeEventListener('sourceopen', this.onmso);
        ms.removeEventListener('sourceended', this.onmse);
        ms.removeEventListener('sourceclose', this.onmsc);

        // Detach properly the MediaSource from the HTMLMediaElement as
        // suggested in https://github.com/w3c/media-source/issues/53.
        if (this.media) {
          URL.revokeObjectURL(this._objectUrl);

          // clean up video tag src only if it's our own url. some external libraries might
          // hijack the video tag and change its 'src' without destroying the Hls instance first
          if (this.media.src === this._objectUrl) {
            this.media.removeAttribute('src');
            this.media.load();
          } else {
            logger["b" /* logger */].warn('media.src was changed by a third party - skip cleanup');
          }
        }

        this.mediaSource = null;
        this.media = null;
        this._objectUrl = null;
        this.pendingTracks = {};
        this.tracks = {};
        this.sourceBuffer = {};
        this.flushRange = [];
        this.segments = [];
        this.appended = 0;
      }
      this.onmso = this.onmse = this.onmsc = null;
      this.hls.trigger(events["a" /* default */].MEDIA_DETACHED);
    };

    BufferController.prototype.onMediaSourceOpen = function onMediaSourceOpen() {
      logger["b" /* logger */].log('media source opened');
      this.hls.trigger(events["a" /* default */].MEDIA_ATTACHED, { media: this.media });
      var mediaSource = this.mediaSource;
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this.onmso);
      }
      this.checkPendingTracks();
    };

    BufferController.prototype.checkPendingTracks = function checkPendingTracks() {
      // if any buffer codecs pending, check if we have enough to create sourceBuffers
      var pendingTracks = this.pendingTracks,
          pendingTracksNb = Object.keys(pendingTracks).length;
      // if any pending tracks and (if nb of pending tracks gt or equal than expected nb or if unknown expected nb)
      if (pendingTracksNb && (this.sourceBufferNb <= pendingTracksNb || this.sourceBufferNb === 0)) {
        // ok, let's create them now !
        this.createSourceBuffers(pendingTracks);
        this.pendingTracks = {};
        // append any pending segments now !
        this.doAppending();
      }
    };

    BufferController.prototype.onMediaSourceClose = function onMediaSourceClose() {
      logger["b" /* logger */].log('media source closed');
    };

    BufferController.prototype.onMediaSourceEnded = function onMediaSourceEnded() {
      logger["b" /* logger */].log('media source ended');
    };

    BufferController.prototype.onSBUpdateEnd = function onSBUpdateEnd() {
      // update timestampOffset
      if (this.audioTimestampOffset) {
        var audioBuffer = this.sourceBuffer.audio;
        logger["b" /* logger */].warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + this.audioTimestampOffset);
        audioBuffer.timestampOffset = this.audioTimestampOffset;
        delete this.audioTimestampOffset;
      }

      if (this._needsFlush) this.doFlush();

      if (this._needsEos) this.checkEos();

      this.appending = false;
      var parent = this.parent;
      // count nb of pending segments waiting for appending on this sourcebuffer
      var pending = this.segments.reduce(function (counter, segment) {
        return segment.parent === parent ? counter + 1 : counter;
      }, 0);

      // this.sourceBuffer is better to use than media.buffered as it is closer to the PTS data from the fragments
      var timeRanges = {};
      var sourceBuffer = this.sourceBuffer;
      for (var streamType in sourceBuffer) {
        timeRanges[streamType] = sourceBuffer[streamType].buffered;
      }this.hls.trigger(events["a" /* default */].BUFFER_APPENDED, { parent: parent, pending: pending, timeRanges: timeRanges });
      // don't append in flushing mode
      if (!this._needsFlush) this.doAppending();

      this.updateMediaElementDuration();
    };

    BufferController.prototype.onSBUpdateError = function onSBUpdateError(event) {
      logger["b" /* logger */].error('sourceBuffer error:', event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_APPENDING_ERROR, fatal: false });
      // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
    };

    BufferController.prototype.onBufferReset = function onBufferReset() {
      var sourceBuffer = this.sourceBuffer;
      for (var type in sourceBuffer) {
        var sb = sourceBuffer[type];
        try {
          this.mediaSource.removeSourceBuffer(sb);
          sb.removeEventListener('updateend', this.onsbue);
          sb.removeEventListener('error', this.onsbe);
        } catch (err) {}
      }
      this.sourceBuffer = {};
      this.flushRange = [];
      this.segments = [];
      this.appended = 0;
    };

    BufferController.prototype.onBufferCodecs = function onBufferCodecs(tracks) {
      // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
      // if sourcebuffers already created, do nothing ...
      if (Object.keys(this.sourceBuffer).length === 0) {
        for (var trackName in tracks) {
          this.pendingTracks[trackName] = tracks[trackName];
        }var mediaSource = this.mediaSource;
        if (mediaSource && mediaSource.readyState === 'open') {
          // try to create sourcebuffers if mediasource opened
          this.checkPendingTracks();
        }
      }
    };

    BufferController.prototype.createSourceBuffers = function createSourceBuffers(tracks) {
      var sourceBuffer = this.sourceBuffer,
          mediaSource = this.mediaSource;

      for (var trackName in tracks) {
        if (!sourceBuffer[trackName]) {
          var track = tracks[trackName];
          // use levelCodec as first priority
          var codec = track.levelCodec || track.codec;
          var mimeType = track.container + ';codecs=' + codec;
          logger["b" /* logger */].log('creating sourceBuffer(' + mimeType + ')');
          try {
            var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
            sb.addEventListener('updateend', this.onsbue);
            sb.addEventListener('error', this.onsbe);
            this.tracks[trackName] = { codec: codec, container: track.container };
            track.buffer = sb;
          } catch (err) {
            logger["b" /* logger */].error('error while trying to add sourceBuffer:' + err.message);
            this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
          }
        }
      }
      this.hls.trigger(events["a" /* default */].BUFFER_CREATED, { tracks: tracks });
    };

    BufferController.prototype.onBufferAppending = function onBufferAppending(data) {
      if (!this._needsFlush) {
        if (!this.segments) this.segments = [data];else this.segments.push(data);

        this.doAppending();
      }
    };

    BufferController.prototype.onBufferAppendFail = function onBufferAppendFail(data) {
      logger["b" /* logger */].error('sourceBuffer error:', data.event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_APPENDING_ERROR, fatal: false });
    };

    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()


    BufferController.prototype.onBufferEos = function onBufferEos(data) {
      var sb = this.sourceBuffer;
      var dataType = data.type;
      for (var type in sb) {
        if (!dataType || type === dataType) {
          if (!sb[type].ended) {
            sb[type].ended = true;
            logger["b" /* logger */].log(type + ' sourceBuffer now EOS');
          }
        }
      }
      this.checkEos();
    };

    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.


    BufferController.prototype.checkEos = function checkEos() {
      var sb = this.sourceBuffer,
          mediaSource = this.mediaSource;
      if (!mediaSource || mediaSource.readyState !== 'open') {
        this._needsEos = false;
        return;
      }
      for (var type in sb) {
        var sbobj = sb[type];
        if (!sbobj.ended) return;

        if (sbobj.updating) {
          this._needsEos = true;
          return;
        }
      }
      logger["b" /* logger */].log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
      // Notify the media element that it now has all of the media data
      try {
        mediaSource.endOfStream();
      } catch (e) {
        logger["b" /* logger */].warn('exception while calling mediaSource.endOfStream()');
      }
      this._needsEos = false;
    };

    BufferController.prototype.onBufferFlushing = function onBufferFlushing(data) {
      this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
      // attempt flush immediately
      this.flushBufferCounter = 0;
      this.doFlush();
    };

    BufferController.prototype.onLevelUpdated = function onLevelUpdated(_ref) {
      var details = _ref.details;

      if (details.fragments.length > 0) {
        this._levelDuration = details.totalduration + details.fragments[0].start;
        this._live = details.live;
        this.updateMediaElementDuration();
      }
    };

    /**
     * Update Media Source duration to current level duration or override to Infinity if configuration parameter
     * 'liveDurationInfinity` is set to `true`
     * More details: https://github.com/video-dev/hls.js/issues/355
     */


    BufferController.prototype.updateMediaElementDuration = function updateMediaElementDuration() {
      var config = this.hls.config;

      var duration = void 0;

      if (this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== 'open') return;

      for (var type in this.sourceBuffer) {
        if (this.sourceBuffer[type].updating === true) {
          // can't set duration whilst a buffer is updating
          return;
        }
      }

      duration = this.media.duration;
      // initialise to the value that the media source is reporting
      if (this._msDuration === null) this._msDuration = this.mediaSource.duration;

      if (this._live === true && config.liveDurationInfinity === true) {
        // Override duration to Infinity
        logger["b" /* logger */].log('Media Source duration is set to Infinity');
        this._msDuration = this.mediaSource.duration = Infinity;
      } else if (this._levelDuration > this._msDuration && this._levelDuration > duration || duration === Infinity || isNaN(duration)) {
        // levelDuration was the last value we set.
        // not using mediaSource.duration as the browser may tweak this value
        // only update Media Source duration if its value increase, this is to avoid
        // flushing already buffered portion when switching between quality level
        logger["b" /* logger */].log('Updating Media Source duration to ' + this._levelDuration.toFixed(3));
        this._msDuration = this.mediaSource.duration = this._levelDuration;
      }
    };

    BufferController.prototype.doFlush = function doFlush() {
      // loop through all buffer ranges to flush
      while (this.flushRange.length) {
        var range = this.flushRange[0];
        // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
        if (this.flushBuffer(range.start, range.end, range.type)) {
          // range flushed, remove from flush array
          this.flushRange.shift();
          this.flushBufferCounter = 0;
        } else {
          this._needsFlush = true;
          // avoid looping, wait for SB update end to retrigger a flush
          return;
        }
      }
      if (this.flushRange.length === 0) {
        // everything flushed
        this._needsFlush = false;

        // let's recompute this.appended, which is used to avoid flush looping
        var appended = 0;
        var sourceBuffer = this.sourceBuffer;
        try {
          for (var type in sourceBuffer) {
            appended += sourceBuffer[type].buffered.length;
          }
        } catch (error) {
          // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
          // this is harmess at this stage, catch this to avoid reporting an internal exception
          logger["b" /* logger */].error('error while accessing sourceBuffer.buffered');
        }
        this.appended = appended;
        this.hls.trigger(events["a" /* default */].BUFFER_FLUSHED);
      }
    };

    BufferController.prototype.doAppending = function doAppending() {
      var hls = this.hls,
          sourceBuffer = this.sourceBuffer,
          segments = this.segments;
      if (Object.keys(sourceBuffer).length) {
        if (this.media.error) {
          this.segments = [];
          logger["b" /* logger */].error('trying to append although a media error occured, flush segment and abort');
          return;
        }
        if (this.appending) {
          // logger.log(`sb appending in progress`);
          return;
        }
        if (segments && segments.length) {
          var segment = segments.shift();
          try {
            var type = segment.type,
                sb = sourceBuffer[type];
            if (sb) {
              if (!sb.updating) {
                // reset sourceBuffer ended flag before appending segment
                sb.ended = false;
                // logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                this.parent = segment.parent;
                sb.appendBuffer(segment.data);
                this.appendError = 0;
                this.appended++;
                this.appending = true;
              } else {
                segments.unshift(segment);
              }
            } else {
              // in case we don't have any source buffer matching with this segment type,
              // it means that Mediasource fails to create sourcebuffer
              // discard this segment, and trigger update end
              this.onSBUpdateEnd();
            }
          } catch (err) {
            // in case any error occured while appending, put back segment in segments table
            logger["b" /* logger */].error('error while trying to append buffer:' + err.message);
            segments.unshift(segment);
            var event = { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, parent: segment.parent };
            if (err.code !== 22) {
              if (this.appendError) this.appendError++;else this.appendError = 1;

              event.details = errors["a" /* ErrorDetails */].BUFFER_APPEND_ERROR;
              /* with UHD content, we could get loop of quota exceeded error until
                browser is able to evict some data from sourcebuffer. retrying help recovering this
              */
              if (this.appendError > hls.config.appendErrorMaxRetry) {
                logger["b" /* logger */].log('fail ' + hls.config.appendErrorMaxRetry + ' times to append segment in sourceBuffer');
                segments = [];
                event.fatal = true;
                hls.trigger(events["a" /* default */].ERROR, event);
              } else {
                event.fatal = false;
                hls.trigger(events["a" /* default */].ERROR, event);
              }
            } else {
              // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
              // let's stop appending any segments, and report BUFFER_FULL_ERROR error
              this.segments = [];
              event.details = errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR;
              event.fatal = false;
              hls.trigger(events["a" /* default */].ERROR, event);
            }
          }
        }
      }
    };

    /*
      flush specified buffered range,
      return true once range has been flushed.
      as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    */


    BufferController.prototype.flushBuffer = function flushBuffer(startOffset, endOffset, typeIn) {
      var sb = void 0,
          i = void 0,
          bufStart = void 0,
          bufEnd = void 0,
          flushStart = void 0,
          flushEnd = void 0,
          sourceBuffer = this.sourceBuffer;
      if (Object.keys(sourceBuffer).length) {
        logger["b" /* logger */].log('flushBuffer,pos/start/end: ' + this.media.currentTime.toFixed(3) + '/' + startOffset + '/' + endOffset);
        // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
        if (this.flushBufferCounter < this.appended) {
          for (var type in sourceBuffer) {
            // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
            // if no, let's flush all sourcebuffers
            if (typeIn && type !== typeIn) continue;

            sb = sourceBuffer[type];
            // we are going to flush buffer, mark source buffer as 'not ended'
            sb.ended = false;
            if (!sb.updating) {
              try {
                for (i = 0; i < sb.buffered.length; i++) {
                  bufStart = sb.buffered.start(i);
                  bufEnd = sb.buffered.end(i);
                  // workaround firefox not able to properly flush multiple buffered range.
                  if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && endOffset === Number.POSITIVE_INFINITY) {
                    flushStart = startOffset;
                    flushEnd = endOffset;
                  } else {
                    flushStart = Math.max(bufStart, startOffset);
                    flushEnd = Math.min(bufEnd, endOffset);
                  }
                  /* sometimes sourcebuffer.remove() does not flush
                     the exact expected time range.
                     to avoid rounding issues/infinite loop,
                     only flush buffer range of length greater than 500ms.
                  */
                  if (Math.min(flushEnd, bufEnd) - flushStart > 0.5) {
                    this.flushBufferCounter++;
                    logger["b" /* logger */].log('flush ' + type + ' [' + flushStart + ',' + flushEnd + '], of [' + bufStart + ',' + bufEnd + '], pos:' + this.media.currentTime);
                    sb.remove(flushStart, flushEnd);
                    return false;
                  }
                }
              } catch (e) {
                logger["b" /* logger */].warn('exception while accessing sourcebuffer, it might have been removed from MediaSource');
              }
            } else {
              // logger.log('abort ' + type + ' append in progress');
              // this will abort any appending in progress
              // sb.abort();
              logger["b" /* logger */].warn('cannot flush, sb updating in progress');
              return false;
            }
          }
        } else {
          logger["b" /* logger */].warn('abort flushing too many retries');
        }
        logger["b" /* logger */].log('buffer flushed');
      }
      // everything flushed !
      return true;
    };

    return BufferController;
  }(event_handler);

  /* harmony default export */ var buffer_controller = (buffer_controller_BufferController);
  // CONCATENATED MODULE: ./src/controller/cap-level-controller.js
  var cap_level_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function cap_level_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function cap_level_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function cap_level_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * cap stream level to media size dimension controller
  */




  var cap_level_controller_CapLevelController = function (_EventHandler) {
    cap_level_controller__inherits(CapLevelController, _EventHandler);

    function CapLevelController(hls) {
      cap_level_controller__classCallCheck(this, CapLevelController);

      return cap_level_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FPS_DROP_LEVEL_CAPPING, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MANIFEST_PARSED));
    }

    CapLevelController.prototype.destroy = function destroy() {
      if (this.hls.config.capLevelToPlayerSize) {
        this.media = this.restrictedLevels = null;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) this.timer = clearInterval(this.timer);
      }
    };

    CapLevelController.prototype.onFpsDropLevelCapping = function onFpsDropLevelCapping(data) {
      // Don't add a restricted level more than once
      if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) this.restrictedLevels.push(data.droppedLevel);
    };

    CapLevelController.prototype.onMediaAttaching = function onMediaAttaching(data) {
      this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    };

    CapLevelController.prototype.onManifestParsed = function onManifestParsed(data) {
      var hls = this.hls;
      this.restrictedLevels = [];
      if (hls.config.capLevelToPlayerSize) {
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.levels = data.levels;
        hls.firstLevel = this.getMaxLevel(data.firstLevel);
        clearInterval(this.timer);
        this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
      }
    };

    CapLevelController.prototype.detectPlayerSize = function detectPlayerSize() {
      if (this.media) {
        var levelsLength = this.levels ? this.levels.length : 0;
        if (levelsLength) {
          var hls = this.hls;
          hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
          if (hls.autoLevelCapping > this.autoLevelCapping) {
            // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
            // usually happen when the user go to the fullscreen mode.
            hls.streamController.nextLevelSwitch();
          }
          this.autoLevelCapping = hls.autoLevelCapping;
        }
      }
    };

    /*
    * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
    */


    CapLevelController.prototype.getMaxLevel = function getMaxLevel(capLevelIndex) {
      var _this2 = this;

      if (!this.levels) return -1;

      var validLevels = this.levels.filter(function (level, index) {
        return CapLevelController.isLevelAllowed(index, _this2.restrictedLevels) && index <= capLevelIndex;
      });

      return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    };

    CapLevelController.isLevelAllowed = function isLevelAllowed(level) {
      var restrictedLevels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return restrictedLevels.indexOf(level) === -1;
    };

    CapLevelController.getMaxLevelByMediaSize = function getMaxLevelByMediaSize(levels, width, height) {
      if (!levels || levels && !levels.length) return -1;

      // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
      // to determine whether we've chosen the greatest bandwidth for the media's dimensions
      var atGreatestBandiwdth = function atGreatestBandiwdth(curLevel, nextLevel) {
        if (!nextLevel) return true;

        return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
      };

      // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
      // the max level
      var maxLevelIndex = levels.length - 1;

      for (var i = 0; i < levels.length; i += 1) {
        var level = levels[i];
        if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
          maxLevelIndex = i;
          break;
        }
      }

      return maxLevelIndex;
    };

    cap_level_controller__createClass(CapLevelController, [{
      key: 'mediaWidth',
      get: function get() {
        var width = void 0;
        var media = this.media;
        if (media) {
          width = media.width || media.clientWidth || media.offsetWidth;
          width *= CapLevelController.contentScaleFactor;
        }
        return width;
      }
    }, {
      key: 'mediaHeight',
      get: function get() {
        var height = void 0;
        var media = this.media;
        if (media) {
          height = media.height || media.clientHeight || media.offsetHeight;
          height *= CapLevelController.contentScaleFactor;
        }
        return height;
      }
    }], [{
      key: 'contentScaleFactor',
      get: function get() {
        var pixelRatio = 1;
        try {
          pixelRatio = window.devicePixelRatio;
        } catch (e) {}
        return pixelRatio;
      }
    }]);

    return CapLevelController;
  }(event_handler);

  /* harmony default export */ var cap_level_controller = (cap_level_controller_CapLevelController);
  // CONCATENATED MODULE: ./src/controller/fps-controller.js
  function fps_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function fps_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function fps_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * FPS Controller
  */





  var fps_controller_FPSController = function (_EventHandler) {
    fps_controller__inherits(FPSController, _EventHandler);

    function FPSController(hls) {
      fps_controller__classCallCheck(this, FPSController);

      return fps_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING));
    }

    FPSController.prototype.destroy = function destroy() {
      if (this.timer) clearInterval(this.timer);

      this.isVideoPlaybackQualityAvailable = false;
    };

    FPSController.prototype.onMediaAttaching = function onMediaAttaching(data) {
      var config = this.hls.config;
      if (config.capLevelOnFPSDrop) {
        var video = this.video = data.media instanceof HTMLVideoElement ? data.media : null;
        if (typeof video.getVideoPlaybackQuality === 'function') this.isVideoPlaybackQualityAvailable = true;

        clearInterval(this.timer);
        this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
      }
    };

    FPSController.prototype.checkFPS = function checkFPS(video, decodedFrames, droppedFrames) {
      var currentTime = performance.now();
      if (decodedFrames) {
        if (this.lastTime) {
          var currentPeriod = currentTime - this.lastTime,
              currentDropped = droppedFrames - this.lastDroppedFrames,
              currentDecoded = decodedFrames - this.lastDecodedFrames,
              droppedFPS = 1000 * currentDropped / currentPeriod,
              hls = this.hls;
          hls.trigger(events["a" /* default */].FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
          if (droppedFPS > 0) {
            // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
            if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
              var currentLevel = hls.currentLevel;
              logger["b" /* logger */].warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
              if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                currentLevel = currentLevel - 1;
                hls.trigger(events["a" /* default */].FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls.currentLevel });
                hls.autoLevelCapping = currentLevel;
                hls.streamController.nextLevelSwitch();
              }
            }
          }
        }
        this.lastTime = currentTime;
        this.lastDroppedFrames = droppedFrames;
        this.lastDecodedFrames = decodedFrames;
      }
    };

    FPSController.prototype.checkFPSInterval = function checkFPSInterval() {
      var video = this.video;
      if (video) {
        if (this.isVideoPlaybackQualityAvailable) {
          var videoPlaybackQuality = video.getVideoPlaybackQuality();
          this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
        } else {
          this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
      }
    };

    return FPSController;
  }(event_handler);

  /* harmony default export */ var fps_controller = (fps_controller_FPSController);
  // CONCATENATED MODULE: ./src/utils/xhr-loader.js
  function xhr_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * XHR based logger
  */



  var xhr_loader_XhrLoader = function () {
    function XhrLoader(config) {
      xhr_loader__classCallCheck(this, XhrLoader);

      if (config && config.xhrSetup) this.xhrSetup = config.xhrSetup;
    }

    XhrLoader.prototype.destroy = function destroy() {
      this.abort();
      this.loader = null;
    };

    XhrLoader.prototype.abort = function abort() {
      var loader = this.loader;
      if (loader && loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }

      window.clearTimeout(this.requestTimeout);
      this.requestTimeout = null;
      window.clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    };

    XhrLoader.prototype.load = function load(context, config, callbacks) {
      this.context = context;
      this.config = config;
      this.callbacks = callbacks;
      this.stats = { trequest: performance.now(), retry: 0 };
      this.retryDelay = config.retryDelay;
      this.loadInternal();
    };

    XhrLoader.prototype.loadInternal = function loadInternal() {
      var xhr = void 0,
          context = this.context;
      xhr = this.loader = new XMLHttpRequest();

      var stats = this.stats;
      stats.tfirst = 0;
      stats.loaded = 0;
      var xhrSetup = this.xhrSetup;

      try {
        if (xhrSetup) {
          try {
            xhrSetup(xhr, context.url);
          } catch (e) {
            // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
            // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
            xhr.open('GET', context.url, true);
            xhrSetup(xhr, context.url);
          }
        }
        if (!xhr.readyState) xhr.open('GET', context.url, true);
      } catch (e) {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({ code: xhr.status, text: e.message }, context, xhr);
        return;
      }

      if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));

      xhr.onreadystatechange = this.readystatechange.bind(this);
      xhr.onprogress = this.loadprogress.bind(this);
      xhr.responseType = context.responseType;

      // setup timeout before we perform request
      this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
      xhr.send();
    };

    XhrLoader.prototype.readystatechange = function readystatechange(event) {
      var xhr = event.currentTarget,
          readyState = xhr.readyState,
          stats = this.stats,
          context = this.context,
          config = this.config;

      // don't proceed if xhr has been aborted
      if (stats.aborted) return;

      // >= HEADERS_RECEIVED
      if (readyState >= 2) {
        // clear xhr timeout and rearm it if readyState less than 4
        window.clearTimeout(this.requestTimeout);
        if (stats.tfirst === 0) stats.tfirst = Math.max(performance.now(), stats.trequest);

        if (readyState === 4) {
          var status = xhr.status;
          // http status between 200 to 299 are all successful
          if (status >= 200 && status < 300) {
            stats.tload = Math.max(stats.tfirst, performance.now());
            var data = void 0,
                len = void 0;
            if (context.responseType === 'arraybuffer') {
              data = xhr.response;
              len = data.byteLength;
            } else {
              data = xhr.responseText;
              len = data.length;
            }
            stats.loaded = stats.total = len;
            var response = { url: xhr.responseURL, data: data };
            this.callbacks.onSuccess(response, stats, context, xhr);
          } else {
            // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
            if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
              logger["b" /* logger */].error(status + ' while loading ' + context.url);
              this.callbacks.onError({ code: status, text: xhr.statusText }, context, xhr);
            } else {
              // retry
              logger["b" /* logger */].warn(status + ' while loading ' + context.url + ', retrying in ' + this.retryDelay + '...');
              // aborts and resets internal state
              this.destroy();
              // schedule retry
              this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
              // set exponential backoff
              this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
              stats.retry++;
            }
          }
        } else {
          // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
          this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
        }
      }
    };

    XhrLoader.prototype.loadtimeout = function loadtimeout() {
      logger["b" /* logger */].warn('timeout while loading ' + this.context.url);
      this.callbacks.onTimeout(this.stats, this.context, null);
    };

    XhrLoader.prototype.loadprogress = function loadprogress(event) {
      var xhr = event.currentTarget,
          stats = this.stats;

      stats.loaded = event.loaded;
      if (event.lengthComputable) stats.total = event.total;

      var onProgress = this.callbacks.onProgress;
      if (onProgress) {
        // third arg is to provide on progress data
        onProgress(stats, this.context, null, xhr);
      }
    };

    return XhrLoader;
  }();

  /* harmony default export */ var xhr_loader = (xhr_loader_XhrLoader);
  // CONCATENATED MODULE: ./src/controller/audio-track-controller.js
  var audio_track_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function audio_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function audio_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function audio_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * audio track controller
  */






  var audio_track_controller_AudioTrackController = function (_EventHandler) {
    audio_track_controller__inherits(AudioTrackController, _EventHandler);

    function AudioTrackController(hls) {
      audio_track_controller__classCallCheck(this, AudioTrackController);

      var _this = audio_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].AUDIO_TRACK_LOADED, events["a" /* default */].ERROR));

      _this.ticks = 0;
      _this.ontick = _this.tick.bind(_this);
      return _this;
    }

    AudioTrackController.prototype.destroy = function destroy() {
      this.cleanTimer();
      event_handler.prototype.destroy.call(this);
    };

    AudioTrackController.prototype.cleanTimer = function cleanTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    };

    AudioTrackController.prototype.tick = function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) setTimeout(this.tick, 1);

        this.ticks = 0;
      }
    };

    AudioTrackController.prototype.doTick = function doTick() {
      this.updateTrack(this.trackId);
    };

    AudioTrackController.prototype.onError = function onError(data) {
      if (data.fatal && data.type === errors["b" /* ErrorTypes */].NETWORK_ERROR) this.cleanTimer();
    };

    AudioTrackController.prototype.onManifestLoading = function onManifestLoading() {
      // reset audio tracks on manifest loading
      this.tracks = [];
      this.trackId = -1;
    };

    AudioTrackController.prototype.onManifestParsed = function onManifestParsed(data) {
      var _this2 = this;

      var tracks = data.audioTracks || [];
      var defaultFound = false;
      this.tracks = tracks;
      this.hls.trigger(events["a" /* default */].AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
      // loop through available audio tracks and autoselect default if needed
      var id = 0;
      tracks.forEach(function (track) {
        if (track.default && !defaultFound) {
          _this2.audioTrack = id;
          defaultFound = true;
          return;
        }
        id++;
      });
      if (defaultFound === false && tracks.length) {
        logger["b" /* logger */].log('no default audio track defined, use first audio track as default');
        this.audioTrack = 0;
      }
    };

    AudioTrackController.prototype.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
      if (data.id < this.tracks.length) {
        logger["b" /* logger */].log('audioTrack ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(this.ontick, 1000 * data.details.targetduration);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          this.cleanTimer();
        }
      }
    };

    /** get alternate audio tracks list from playlist **/


    AudioTrackController.prototype.setAudioTrackInternal = function setAudioTrackInternal(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        this.trackId = newId;
        logger["b" /* logger */].log('switching to audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            hls = this.hls,
            type = audioTrack.type,
            url = audioTrack.url,
            eventObj = { id: newId, type: type, url: url };
        hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHING, eventObj);
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          logger["b" /* logger */].log('(re)loading playlist for audioTrack ' + newId);
          hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    };

    AudioTrackController.prototype.updateTrack = function updateTrack(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        this.trackId = newId;
        logger["b" /* logger */].log('updating audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            url = audioTrack.url;
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          logger["b" /* logger */].log('(re)loading playlist for audioTrack ' + newId);
          this.hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    };

    audio_track_controller__createClass(AudioTrackController, [{
      key: 'audioTracks',
      get: function get() {
        return this.tracks;
      }

      /** get index of the selected audio track (index in audio track lists) **/

    }, {
      key: 'audioTrack',
      get: function get() {
        return this.trackId;
      }

      /** select an audio track, based on its index in audio track lists**/
      ,
      set: function set(audioTrackId) {
        if (this.trackId !== audioTrackId || this.tracks[audioTrackId].details === undefined) this.setAudioTrackInternal(audioTrackId);
      }
    }]);

    return AudioTrackController;
  }(event_handler);

  /* harmony default export */ var audio_track_controller = (audio_track_controller_AudioTrackController);
  // CONCATENATED MODULE: ./src/controller/audio-stream-controller.js
  var audio_stream_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function audio_stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function audio_stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function audio_stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Audio Stream Controller
  */














  var audio_stream_controller_State = {
    STOPPED: 'STOPPED',
    STARTING: 'STARTING',
    IDLE: 'IDLE',
    PAUSED: 'PAUSED',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    BUFFER_FLUSHING: 'BUFFER_FLUSHING',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS'
  };

  var audio_stream_controller_AudioStreamController = function (_TaskLoop) {
    audio_stream_controller__inherits(AudioStreamController, _TaskLoop);

    function AudioStreamController(hls, fragmentTracker) {
      audio_stream_controller__classCallCheck(this, AudioStreamController);

      var _this = audio_stream_controller__possibleConstructorReturn(this, _TaskLoop.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].AUDIO_TRACKS_UPDATED, events["a" /* default */].AUDIO_TRACK_SWITCHING, events["a" /* default */].AUDIO_TRACK_LOADED, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, events["a" /* default */].FRAG_PARSING_DATA, events["a" /* default */].FRAG_PARSED, events["a" /* default */].ERROR, events["a" /* default */].BUFFER_RESET, events["a" /* default */].BUFFER_CREATED, events["a" /* default */].BUFFER_APPENDED, events["a" /* default */].BUFFER_FLUSHED, events["a" /* default */].INIT_PTS_FOUND));

      _this.fragmentTracker = fragmentTracker;
      _this.config = hls.config;
      _this.audioCodecSwap = false;
      _this._state = audio_stream_controller_State.STOPPED;
      _this.initPTS = [];
      _this.waitingFragment = null;
      _this.videoTrackCC = null;
      return _this;
    }

    AudioStreamController.prototype.onHandlerDestroying = function onHandlerDestroying() {
      this.stopLoad();
    };

    AudioStreamController.prototype.onHandlerDestroyed = function onHandlerDestroyed() {
      this.state = audio_stream_controller_State.STOPPED;
      this.fragmentTracker = null;
    };

    // Signal that video PTS was found


    AudioStreamController.prototype.onInitPtsFound = function onInitPtsFound(data) {
      var demuxerId = data.id,
          cc = data.frag.cc,
          initPTS = data.initPTS;
      if (demuxerId === 'main') {
        // Always update the new INIT PTS
        // Can change due level switch
        this.initPTS[cc] = initPTS;
        this.videoTrackCC = cc;
        logger["b" /* logger */].log('InitPTS for cc: ' + cc + ' found from video track: ' + initPTS);

        // If we are waiting we need to demux/remux the waiting frag
        // With the new initPTS
        if (this.state === audio_stream_controller_State.WAITING_INIT_PTS) this.tick();
      }
    };

    AudioStreamController.prototype.startLoad = function startLoad(startPosition) {
      if (this.tracks) {
        var lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        this.setInterval(100);
        this.fragLoadError = 0;
        if (lastCurrentTime > 0 && startPosition === -1) {
          logger["b" /* logger */].log('audio:override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          this.state = audio_stream_controller_State.IDLE;
        } else {
          this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
          this.state = audio_stream_controller_State.STARTING;
        }
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
        this.tick();
      } else {
        this.startPosition = startPosition;
        this.state = audio_stream_controller_State.STOPPED;
      }
    };

    AudioStreamController.prototype.stopLoad = function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) frag.loader.abort();

        this.fragmentTracker.removeFragment(frag);
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.state = audio_stream_controller_State.STOPPED;
    };

    AudioStreamController.prototype.doTick = function doTick() {
      var pos = void 0,
          track = void 0,
          trackDetails = void 0,
          hls = this.hls,
          config = hls.config;
      // logger.log('audioStream:' + this.state);
      switch (this.state) {
        case audio_stream_controller_State.ERROR:
        // don't do anything in error state to avoid breaking further ...
        case audio_stream_controller_State.PAUSED:
        // don't do anything in paused state either ...
        case audio_stream_controller_State.BUFFER_FLUSHING:
          break;
        case audio_stream_controller_State.STARTING:
          this.state = audio_stream_controller_State.WAITING_TRACK;
          this.loadedmetadata = false;
          break;
        case audio_stream_controller_State.IDLE:
          var tracks = this.tracks;
          // audio tracks not received => exit loop
          if (!tracks) break;

          // if video not attached AND
          // start fragment already requested OR start frag prefetch disable
          // exit loop
          // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
          if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) break;

          // determine next candidate fragment to be loaded, based on current position and
          //  end of buffer position
          // if we have not yet loaded any fragment, start loading from start position
          if (this.loadedmetadata) {
            pos = this.media.currentTime;
          } else {
            pos = this.nextLoadPosition;
            if (pos === undefined) break;
          }
          var media = this.mediaBuffer ? this.mediaBuffer : this.media,
              videoBuffer = this.videoBuffer ? this.videoBuffer : this.media,
              bufferInfo = buffer_helper.bufferInfo(media, pos, config.maxBufferHole),
              mainBufferInfo = buffer_helper.bufferInfo(videoBuffer, pos, config.maxBufferHole),
              bufferLen = bufferInfo.len,
              bufferEnd = bufferInfo.end,
              fragPrevious = this.fragPrevious,

          // ensure we buffer at least config.maxBufferLength (default 30s) or config.maxMaxBufferLength (default: 600s)
          // whichever is smaller.
          // once we reach that threshold, don't buffer more than video (mainBufferInfo.len)
          maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength),
              maxBufLen = Math.max(maxConfigBuffer, mainBufferInfo.len),
              audioSwitch = this.audioSwitch,
              trackId = this.trackId;

          // if buffer length is less than maxBufLen try to load a new fragment
          if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
            trackDetails = tracks[trackId].details;
            // if track info not retrieved yet, switch state and wait for track retrieval
            if (typeof trackDetails === 'undefined') {
              this.state = audio_stream_controller_State.WAITING_TRACK;
              break;
            }

            // check if we need to finalize media stream
            // we just got done loading the final fragment and there is no other buffered range after ...
            // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
            // so we should not switch to ENDED in that case, to be able to buffer them
            if (!audioSwitch && !trackDetails.live && fragPrevious && fragPrevious.sn === trackDetails.endSN && !bufferInfo.nextStart) {
              // if we are not seeking or if we are seeking but everything (almost) til the end is buffered, let's signal eos
              // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
              // between different renditions. using half frag duration should help cope with these cases.
              if (!this.media.seeking || this.media.duration - bufferEnd < fragPrevious.duration / 2) {
                // Finalize the media stream
                this.hls.trigger(events["a" /* default */].BUFFER_EOS, { type: 'audio' });
                this.state = audio_stream_controller_State.ENDED;
                break;
              }
            }

            // find fragment index, contiguous with end of buffer position
            var fragments = trackDetails.fragments,
                fragLen = fragments.length,
                start = fragments[0].start,
                end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
                frag = void 0;

            // When switching audio track, reload audio as close as possible to currentTime
            if (audioSwitch) {
              if (trackDetails.live && !trackDetails.PTSKnown) {
                logger["b" /* logger */].log('switching audiotrack, live stream, unknown PTS,load first fragment');
                bufferEnd = 0;
              } else {
                bufferEnd = pos;
                // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                if (trackDetails.PTSKnown && pos < start) {
                  // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                  if (bufferInfo.end > start || bufferInfo.nextStart) {
                    logger["b" /* logger */].log('alt audio track ahead of main track, seek to start of alt audio track');
                    this.media.currentTime = start + 0.05;
                  } else {
                    return;
                  }
                }
              }
            }
            if (trackDetails.initSegment && !trackDetails.initSegment.data) {
              frag = trackDetails.initSegment;
            } // eslint-disable-line brace-style
            // if bufferEnd before start of playlist, load first fragment
            else if (bufferEnd <= start) {
                frag = fragments[0];
                if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) {
                  // Ensure we find a fragment which matches the continuity of the video track
                  frag = findFragWithCC(fragments, this.videoTrackCC);
                }
                if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                  // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                  // let's force seek to start
                  var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                  logger["b" /* logger */].log('no alt audio available @currentTime:' + this.media.currentTime + ', seeking @' + (nextBuffered + 0.05));
                  this.media.currentTime = nextBuffered + 0.05;
                  return;
                }
              } else {
                var foundFrag = void 0;
                var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
                  // offset should be within fragment boundary - config.maxFragLookUpTolerance
                  // this is to cope with situations like
                  // bufferEnd = 9.991
                  // frag[Ø] : [0,10]
                  // frag[1] : [10,20]
                  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                  //              frag start               frag start+duration
                  //                  |-----------------------------|
                  //              <--->                         <--->
                  //  ...--------><-----------------------------><---------....
                  // previous frag         matching fragment         next frag
                  //  return -1             return 0                 return 1
                  // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                  var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
                  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
                  // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                  else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) return -1;

                  return 0;
                };

                if (bufferEnd < end) {
                  if (bufferEnd > end - maxFragLookUpTolerance) maxFragLookUpTolerance = 0;

                  // Prefer the next fragment if it's within tolerance
                  if (fragNext && !fragmentWithinToleranceTest(fragNext)) foundFrag = fragNext;else foundFrag = binary_search.search(fragments, fragmentWithinToleranceTest);
                } else {
                  // reach end of playlist
                  foundFrag = fragments[fragLen - 1];
                }
                if (foundFrag) {
                  frag = foundFrag;
                  start = foundFrag.start;
                  // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                  if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                    if (frag.sn < trackDetails.endSN) {
                      frag = fragments[frag.sn + 1 - trackDetails.startSN];
                      logger["b" /* logger */].log('SN just loaded, load next one: ' + frag.sn);
                    } else {
                      frag = null;
                    }
                  }
                }
              }
            if (frag) {
              // logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
              if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
                logger["b" /* logger */].log('Loading key for ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId);
                this.state = audio_stream_controller_State.KEY_LOADING;
                hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
              } else {
                logger["b" /* logger */].log('Loading ' + frag.sn + ', cc: ' + frag.cc + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId + ', currentTime:' + pos + ',bufferEnd:' + bufferEnd.toFixed(3));
                // Check if fragment is not loaded
                if (this.fragmentTracker.getState(frag) === FragmentState.NOT_LOADED) {
                  this.fragCurrent = frag;
                  this.startFragRequested = true;
                  if (!isNaN(frag.sn)) this.nextLoadPosition = frag.start + frag.duration;

                  hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
                  this.state = audio_stream_controller_State.FRAG_LOADING;
                }
              }
            }
          }
          break;
        case audio_stream_controller_State.WAITING_TRACK:
          track = this.tracks[this.trackId];
          // check if playlist is already loaded
          if (track && track.details) this.state = audio_stream_controller_State.IDLE;

          break;
        case audio_stream_controller_State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          media = this.media;
          var isSeeking = media && media.seeking;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || isSeeking) {
            logger["b" /* logger */].log('audioStreamController: retryDate reached, switch back to IDLE state');
            this.state = audio_stream_controller_State.IDLE;
          }
          break;
        case audio_stream_controller_State.WAITING_INIT_PTS:
          var videoTrackCC = this.videoTrackCC;
          if (this.initPTS[videoTrackCC] === undefined) break;

          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          var waitingFrag = this.waitingFragment;
          if (waitingFrag) {
            var waitingFragCC = waitingFrag.frag.cc;
            if (videoTrackCC !== waitingFragCC) {
              track = this.tracks[this.trackId];
              if (track.details && track.details.live) {
                logger["b" /* logger */].warn('Waiting fragment CC (' + waitingFragCC + ') does not match video track CC (' + videoTrackCC + ')');
                this.waitingFragment = null;
                this.state = audio_stream_controller_State.IDLE;
              }
            } else {
              this.state = audio_stream_controller_State.FRAG_LOADING;
              this.onFragLoaded(this.waitingFragment);
              this.waitingFragment = null;
            }
          } else {
            this.state = audio_stream_controller_State.IDLE;
          }

          break;
        case audio_stream_controller_State.STOPPED:
        case audio_stream_controller_State.FRAG_LOADING:
        case audio_stream_controller_State.PARSING:
        case audio_stream_controller_State.PARSED:
        case audio_stream_controller_State.ENDED:
          break;
        default:
          break;
      }
    };

    AudioStreamController.prototype.onMediaAttached = function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.tracks && config.autoStartLoad) this.startLoad(config.startPosition);
    };

    AudioStreamController.prototype.onMediaDetaching = function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        logger["b" /* logger */].log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = this.videoBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    };

    AudioStreamController.prototype.onMediaSeeking = function onMediaSeeking() {
      if (this.state === audio_stream_controller_State.ENDED) {
        // switch to IDLE state to check for potential new fragment
        this.state = audio_stream_controller_State.IDLE;
      }
      if (this.media) this.lastCurrentTime = this.media.currentTime;

      // tick to speed up processing
      this.tick();
    };

    AudioStreamController.prototype.onMediaEnded = function onMediaEnded() {
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    };

    AudioStreamController.prototype.onAudioTracksUpdated = function onAudioTracksUpdated(data) {
      logger["b" /* logger */].log('audio tracks updated');
      this.tracks = data.audioTracks;
    };

    AudioStreamController.prototype.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url;
      this.trackId = data.id;

      this.fragCurrent = null;
      this.state = audio_stream_controller_State.PAUSED;
      this.waitingFragment = null;
      // destroy useless demuxer when switching audio to main
      if (!altAudio) {
        if (this.demuxer) {
          this.demuxer.destroy();
          this.demuxer = null;
        }
      } else {
        // switching to audio track, start timer if not already started
        this.setInterval(100);
      }

      // should we switch tracks ?
      if (altAudio) {
        this.audioSwitch = true;
        // main audio track are handled by stream-controller, just do something if switching to alt audio track
        this.state = audio_stream_controller_State.IDLE;
      }
      this.tick();
    };

    AudioStreamController.prototype.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
      var newDetails = data.details,
          trackId = data.id,
          track = this.tracks[trackId],
          duration = newDetails.totalduration,
          sliding = 0;

      logger["b" /* logger */].log('track ' + trackId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);

      if (newDetails.live) {
        var curDetails = track.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          // TODO
          // this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown) logger["b" /* logger */].log('live audio playlist sliding:' + sliding.toFixed(3));else logger["b" /* logger */].log('live audio playlist - outdated PTS, unknown sliding');
        } else {
          newDetails.PTSKnown = false;
          logger["b" /* logger */].log('live audio playlist - first load, unknown sliding');
        }
      } else {
        newDetails.PTSKnown = false;
      }
      track.details = newDetails;

      // compute start position
      if (!this.startFragRequested) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            logger["b" /* logger */].log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            this.startPosition = 0;
          }
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
      if (this.state === audio_stream_controller_State.WAITING_TRACK) this.state = audio_stream_controller_State.IDLE;

      // trigger handler right now
      this.tick();
    };

    AudioStreamController.prototype.onKeyLoaded = function onKeyLoaded() {
      if (this.state === audio_stream_controller_State.KEY_LOADING) {
        this.state = audio_stream_controller_State.IDLE;
        this.tick();
      }
    };

    AudioStreamController.prototype.onFragLoaded = function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === audio_stream_controller_State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var track = this.tracks[this.trackId],
            details = track.details,
            duration = details.totalduration,
            trackId = fragCurrent.level,
            sn = fragCurrent.sn,
            cc = fragCurrent.cc,
            audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2',
            stats = this.stats = data.stats;
        if (sn === 'initSegment') {
          this.state = audio_stream_controller_State.IDLE;

          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
          this.tick();
        } else {
          this.state = audio_stream_controller_State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          this.appended = false;
          if (!this.demuxer) this.demuxer = new demux_demuxer(this.hls, 'audio');

          // Check if we have video initPTS
          // If not we need to wait for it
          var initPTS = this.initPTS[cc];
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          if (details.initSegment || initPTS !== undefined) {
            this.pendingBuffering = true;
            logger["b" /* logger */].log('Demuxing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            var accurateTimeOffset = false; // details.PTSKnown || !details.live;
            this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
          } else {
            logger["b" /* logger */].log('unknown video PTS for continuity counter ' + cc + ', waiting for video PTS before demuxing audio frag ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            this.waitingFragment = data;
            this.state = audio_stream_controller_State.WAITING_INIT_PTS;
          }
        }
      }
      this.fragLoadError = 0;
    };

    AudioStreamController.prototype.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
        var tracks = data.tracks,
            track = void 0;

        // delete any video track found on audio demuxer
        if (tracks.video) delete tracks.video;

        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          track.levelCodec = track.codec;
          track.id = data.id;
          this.hls.trigger(events["a" /* default */].BUFFER_CODECS, tracks);
          logger["b" /* logger */].log('audio track:audio,container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
            if (this.audioSwitch) {
              this.pendingData = [appendObj];
            } else {
              this.appended = true;
              // arm pending Buffering flag before appending a segment
              this.pendingBuffering = true;
              this.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
            }
          }
          // trigger handler right now
          this.tick();
        }
      }
    };

    AudioStreamController.prototype.onFragParsingData = function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
        var trackId = this.trackId,
            track = this.tracks[trackId],
            hls = this.hls;

        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        fragCurrent.addElementaryStream(loader_fragment.ElementaryStreamTypes.AUDIO);

        logger["b" /* logger */].log('parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb);
        updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);

        var audioSwitch = this.audioSwitch,
            media = this.media,
            appendOnBufferFlush = false;
        // Only flush audio from old audio tracks when PTS is known on new audio track
        if (audioSwitch && media) {
          if (media.readyState) {
            var currentTime = media.currentTime;
            logger["b" /* logger */].log('switching audio track : currentTime:' + currentTime);
            if (currentTime >= data.startPTS) {
              logger["b" /* logger */].log('switching audio track : flushing all audio');
              this.state = audio_stream_controller_State.BUFFER_FLUSHING;
              hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
              appendOnBufferFlush = true;
              // Lets announce that the initial audio track switch flush occur
              this.audioSwitch = false;
              hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
            }
          } else {
            // Lets announce that the initial audio track switch flush occur
            this.audioSwitch = false;
            hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
          }
        }

        var pendingData = this.pendingData;

        if (!pendingData) {
          console.warn('Apparently attempt to enqueue media payload without codec initialization data upfront');
          hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: null, fatal: true });
          return;
        }

        if (!this.audioSwitch) {
          [data.data1, data.data2].forEach(function (buffer) {
            if (buffer && buffer.length) pendingData.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
          });
          if (!appendOnBufferFlush && pendingData.length) {
            pendingData.forEach(function (appendObj) {
              // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
              // in that case it is useless to append following segments
              if (_this2.state === audio_stream_controller_State.PARSING) {
                // arm pending Buffering flag before appending a segment
                _this2.pendingBuffering = true;
                _this2.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
              }
            });
            this.pendingData = [];
            this.appended = true;
          }
        }
        // trigger handler right now
        this.tick();
      }
    };

    AudioStreamController.prototype.onFragParsed = function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = audio_stream_controller_State.PARSED;
        this._checkAppendedParsed();
      }
    };

    AudioStreamController.prototype.onBufferReset = function onBufferReset() {
      // reset reference to sourcebuffers
      this.mediaBuffer = this.videoBuffer = null;
      this.loadedmetadata = false;
    };

    AudioStreamController.prototype.onBufferCreated = function onBufferCreated(data) {
      var audioTrack = data.tracks.audio;
      if (audioTrack) {
        this.mediaBuffer = audioTrack.buffer;
        this.loadedmetadata = true;
      }
      if (data.tracks.video) this.videoBuffer = data.tracks.video.buffer;
    };

    AudioStreamController.prototype.onBufferAppended = function onBufferAppended(data) {
      if (data.parent === 'audio') {
        var state = this.state;
        if (state === audio_stream_controller_State.PARSING || state === audio_stream_controller_State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    };

    AudioStreamController.prototype._checkAppendedParsed = function _checkAppendedParsed() {
      // trigger handler right now
      if (this.state === audio_stream_controller_State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent,
            stats = this.stats,
            hls = this.hls;
        if (frag) {
          this.fragPrevious = frag;
          stats.tbuffered = performance.now();
          hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          logger["b" /* logger */].log('audio buffered : ' + time_ranges.toString(media.buffered));
          if (this.audioSwitch && this.appended) {
            this.audioSwitch = false;
            hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: this.trackId });
          }
          this.state = audio_stream_controller_State.IDLE;
        }
        this.tick();
      }
    };

    AudioStreamController.prototype.onError = function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to audio fragment
      if (frag && frag.type !== 'audio') return;

      switch (data.details) {
        case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
          if (!data.fatal) {
            var loadError = this.fragLoadError;
            if (loadError) loadError++;else loadError = 1;

            var config = this.config;
            if (loadError <= config.fragLoadingMaxRetry) {
              this.fragLoadError = loadError;
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
              logger["b" /* logger */].warn('audioStreamController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              this.state = audio_stream_controller_State.FRAG_LOADING_WAITING_RETRY;
            } else {
              logger["b" /* logger */].error('audioStreamController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = audio_stream_controller_State.ERROR;
            }
          }
          break;
        case errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_TIMEOUT:
        case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
        case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
          //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
          if (this.state !== audio_stream_controller_State.ERROR) {
            // if fatal error, stop processing, otherwise move to IDLE to retry loading
            this.state = data.fatal ? audio_stream_controller_State.ERROR : audio_stream_controller_State.IDLE;
            logger["b" /* logger */].warn('audioStreamController: ' + data.details + ' while loading frag,switch to ' + this.state + ' state ...');
          }
          break;
        case errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'audio' && (this.state === audio_stream_controller_State.PARSING || this.state === audio_stream_controller_State.PARSED)) {
            var media = this.mediaBuffer,
                currentTime = this.media.currentTime,
                mediaBuffered = media && buffer_helper.isBuffered(media, currentTime) && buffer_helper.isBuffered(media, currentTime + 0.5);
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              var _config = this.config;
              if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
                // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                _config.maxMaxBufferLength /= 2;
                logger["b" /* logger */].warn('audio:reduce max buffer length to ' + _config.maxMaxBufferLength + 's');
              }
              this.state = audio_stream_controller_State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole audio buffer to recover
              logger["b" /* logger */].warn('buffer full error also media.currentTime is not buffered, flush audio buffer');
              this.fragCurrent = null;
              // flush everything
              this.state = audio_stream_controller_State.BUFFER_FLUSHING;
              this.hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
            }
          }
          break;
        default:
          break;
      }
    };

    AudioStreamController.prototype.onBufferFlushed = function onBufferFlushed() {
      var _this3 = this;

      var pendingData = this.pendingData;
      if (pendingData && pendingData.length) {
        logger["b" /* logger */].log('appending pending audio data on Buffer Flushed');
        pendingData.forEach(function (appendObj) {
          _this3.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
        });
        this.appended = true;
        this.pendingData = [];
        this.state = audio_stream_controller_State.PARSED;
      } else {
        // move to IDLE once flush complete. this should trigger new fragment loading
        this.state = audio_stream_controller_State.IDLE;
        // reset reference to frag
        this.fragPrevious = null;
        this.tick();
      }
    };

    audio_stream_controller__createClass(AudioStreamController, [{
      key: 'state',
      set: function set(nextState) {
        if (this.state !== nextState) {
          var previousState = this.state;
          this._state = nextState;
          logger["b" /* logger */].log('audio stream:' + previousState + '->' + nextState);
        }
      },
      get: function get() {
        return this._state;
      }
    }]);

    return AudioStreamController;
  }(task_loop);

  /* harmony default export */ var audio_stream_controller = (audio_stream_controller_AudioStreamController);
  // CONCATENATED MODULE: ./src/utils/vttcue.js
  /**
   * Copyright 2013 vtt.js Contributors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */

  /* harmony default export */ var vttcue = ((function () {
    if (typeof window !== 'undefined' && window.VTTCue) return window.VTTCue;

    var autoKeyword = 'auto';
    var directionSetting = {
      '': true,
      lr: true,
      rl: true
    };
    var alignSetting = {
      start: true,
      middle: true,
      end: true,
      left: true,
      right: true
    };

    function findDirectionSetting(value) {
      if (typeof value !== 'string') return false;

      var dir = directionSetting[value.toLowerCase()];
      return dir ? value.toLowerCase() : false;
    }

    function findAlignSetting(value) {
      if (typeof value !== 'string') return false;

      var align = alignSetting[value.toLowerCase()];
      return align ? value.toLowerCase() : false;
    }

    function extend(obj) {
      var i = 1;
      for (; i < arguments.length; i++) {
        var cobj = arguments[i];
        for (var p in cobj) {
          obj[p] = cobj[p];
        }
      }

      return obj;
    }

    function VTTCue(startTime, endTime, text) {
      var cue = this;
      var isIE8 = function () {
        if (typeof navigator === 'undefined') return;

        return (/MSIE\s8\.0/.test(navigator.userAgent)
        );
      }();
      var baseObj = {};

      if (isIE8) cue = document.createElement('custom');else baseObj.enumerable = true;

      /**
       * Shim implementation specific properties. These properties are not in
       * the spec.
       */

      // Lets us know when the VTTCue's data has changed in such a way that we need
      // to recompute its display state. This lets us compute its display state
      // lazily.
      cue.hasBeenReset = false;

      /**
       * VTTCue and TextTrackCue properties
       * http://dev.w3.org/html5/webvtt/#vttcue-interface
       */

      var _id = '';
      var _pauseOnExit = false;
      var _startTime = startTime;
      var _endTime = endTime;
      var _text = text;
      var _region = null;
      var _vertical = '';
      var _snapToLines = true;
      var _line = 'auto';
      var _lineAlign = 'start';
      var _position = 50;
      var _positionAlign = 'middle';
      var _size = 50;
      var _align = 'middle';

      Object.defineProperty(cue, 'id', extend({}, baseObj, {
        get: function get() {
          return _id;
        },
        set: function set(value) {
          _id = '' + value;
        }
      }));

      Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
        get: function get() {
          return _pauseOnExit;
        },
        set: function set(value) {
          _pauseOnExit = !!value;
        }
      }));

      Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
        get: function get() {
          return _startTime;
        },
        set: function set(value) {
          if (typeof value !== 'number') throw new TypeError('Start time must be set to a number.');

          _startTime = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
        get: function get() {
          return _endTime;
        },
        set: function set(value) {
          if (typeof value !== 'number') throw new TypeError('End time must be set to a number.');

          _endTime = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'text', extend({}, baseObj, {
        get: function get() {
          return _text;
        },
        set: function set(value) {
          _text = '' + value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'region', extend({}, baseObj, {
        get: function get() {
          return _region;
        },
        set: function set(value) {
          _region = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
        get: function get() {
          return _vertical;
        },
        set: function set(value) {
          var setting = findDirectionSetting(value);
          // Have to check for false because the setting an be an empty string.
          if (setting === false) throw new SyntaxError('An invalid or illegal string was specified.');

          _vertical = setting;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
        get: function get() {
          return _snapToLines;
        },
        set: function set(value) {
          _snapToLines = !!value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'line', extend({}, baseObj, {
        get: function get() {
          return _line;
        },
        set: function set(value) {
          if (typeof value !== 'number' && value !== autoKeyword) throw new SyntaxError('An invalid number or illegal string was specified.');

          _line = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
        get: function get() {
          return _lineAlign;
        },
        set: function set(value) {
          var setting = findAlignSetting(value);
          if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');

          _lineAlign = setting;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'position', extend({}, baseObj, {
        get: function get() {
          return _position;
        },
        set: function set(value) {
          if (value < 0 || value > 100) throw new Error('Position must be between 0 and 100.');

          _position = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
        get: function get() {
          return _positionAlign;
        },
        set: function set(value) {
          var setting = findAlignSetting(value);
          if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');

          _positionAlign = setting;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'size', extend({}, baseObj, {
        get: function get() {
          return _size;
        },
        set: function set(value) {
          if (value < 0 || value > 100) throw new Error('Size must be between 0 and 100.');

          _size = value;
          this.hasBeenReset = true;
        }
      }));

      Object.defineProperty(cue, 'align', extend({}, baseObj, {
        get: function get() {
          return _align;
        },
        set: function set(value) {
          var setting = findAlignSetting(value);
          if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');

          _align = setting;
          this.hasBeenReset = true;
        }
      }));

      /**
       * Other <track> spec defined properties
       */

      // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
      cue.displayState = undefined;

      if (isIE8) return cue;
    }

    /**
     * VTTCue methods
     */

    VTTCue.prototype.getCueAsHTML = function () {
      // Assume WebVTT.convertCueToDOMTree is on the global.
      var WebVTT = window.WebVTT;
      return WebVTT.convertCueToDOMTree(window, this.text);
    };

    return VTTCue;
  })());
  // CONCATENATED MODULE: ./src/utils/vttparser.js
  /*
   * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
   */



  var StringDecoder = function StringDecoder() {
    return {
      decode: function decode(data) {
        if (!data) return '';

        if (typeof data !== 'string') throw new Error('Error - expected string data.');

        return decodeURIComponent(encodeURIComponent(data));
      }
    };
  };

  function VTTParser() {
    this.window = window;
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
  }

  // Try to parse input as a time stamp.
  function parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
      return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }

    var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
    if (!m) return null;

    if (m[3]) {
      // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
      return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
    } else if (m[1] > 59) {
      // Timestamp takes the form of [hours]:[minutes].[milliseconds]
      // First position is hours as it's over 59.
      return computeSeconds(m[1], m[2], 0, m[4]);
    } else {
      // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
      return computeSeconds(0, m[1], m[2], m[4]);
    }
  }

  // A settings object holds key/value pairs and will ignore anything but the first
  // assignment to a specific key.
  function Settings() {
    this.values = Object.create(null);
  }

  Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function set(k, v) {
      if (!this.get(k) && v !== '') this.values[k] = v;
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function get(k, dflt, defaultKey) {
      if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];

      return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function has(k) {
      return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function alt(k, v, a) {
      for (var n = 0; n < a.length; ++n) {
        if (v === a[n]) {
          this.set(k, v);
          break;
        }
      }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function integer(k, v) {
      if (/^-?\d+$/.test(v)) {
        // integer
        this.set(k, parseInt(v, 10));
      }
    },
    // Accept a setting if its a valid percentage.
    percent: function percent(k, v) {
      var m = void 0;
      if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
        v = parseFloat(v);
        if (v >= 0 && v <= 100) {
          this.set(k, v);
          return true;
        }
      }
      return false;
    }
  };

  // Helper function to parse input into groups separated by 'groupDelim', and
  // interprete each group as a key/value pair separated by 'keyValueDelim'.
  function parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [input];
    for (var i in groups) {
      if (typeof groups[i] !== 'string') continue;

      var kv = groups[i].split(keyValueDelim);
      if (kv.length !== 2) continue;

      var k = kv[0];
      var v = kv[1];
      callback(k, v);
    }
  }

  var defaults = new vttcue(0, 0, 0);
  // 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
  //  Safari doesn't yet support this change, but FF and Chrome do.
  var center = defaults.align === 'middle' ? 'middle' : 'center';

  function parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
      var ts = parseTimeStamp(input);
      if (ts === null) throw new Error('Malformed timestamp: ' + oInput);

      // Remove time stamp from input.
      input = input.replace(/^[^\sa-zA-Z-]+/, '');
      return ts;
    }

    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
      var settings = new Settings();

      parseOptions(input, function (k, v) {
        switch (k) {
          case 'region':
            // Find the last region we parsed with the same region id.
            for (var i = regionList.length - 1; i >= 0; i--) {
              if (regionList[i].id === v) {
                settings.set(k, regionList[i].region);
                break;
              }
            }
            break;
          case 'vertical':
            settings.alt(k, v, ['rl', 'lr']);
            break;
          case 'line':
            var vals = v.split(','),
                vals0 = vals[0];
            settings.integer(k, vals0);
            if (settings.percent(k, vals0)) settings.set('snapToLines', false);

            settings.alt(k, vals0, ['auto']);
            if (vals.length === 2) settings.alt('lineAlign', vals[1], ['start', center, 'end']);

            break;
          case 'position':
            vals = v.split(',');
            settings.percent(k, vals[0]);
            if (vals.length === 2) settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);

            break;
          case 'size':
            settings.percent(k, v);
            break;
          case 'align':
            settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
            break;
        }
      }, /:/, /\s/);

      // Apply default values for any missing fields.
      cue.region = settings.get('region', null);
      cue.vertical = settings.get('vertical', '');
      var line = settings.get('line', 'auto');
      if (line === 'auto' && defaults.line === -1) {
        // set numeric line number for Safari
        line = -1;
      }
      cue.line = line;
      cue.lineAlign = settings.get('lineAlign', 'start');
      cue.snapToLines = settings.get('snapToLines', true);
      cue.size = settings.get('size', 100);
      cue.align = settings.get('align', center);
      var position = settings.get('position', 'auto');
      if (position === 'auto' && defaults.position === 50) {
        // set numeric position for Safari
        position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
      }
      cue.position = position;
    }

    function skipWhitespace() {
      input = input.replace(/^\s+/, '');
    }

    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== '-->') {
      // (3) next characters must match '-->'
      throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
    }
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time

    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
  }

  function fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
  }

  VTTParser.prototype = {
    parse: function parse(data) {
      var self = this;

      // If there is no data then we won't decode it, but will just try to parse
      // whatever is in buffer already. This may occur in circumstances, for
      // example when flush() is called.
      if (data) {
        // Try to decode the data that we received.
        self.buffer += self.decoder.decode(data, { stream: true });
      }

      function collectNextLine() {
        var buffer = self.buffer;
        var pos = 0;

        buffer = fixLineBreaks(buffer);

        while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
          ++pos;
        }var line = buffer.substr(0, pos);
        // Advance the buffer early in case we fail below.
        if (buffer[pos] === '\r') ++pos;

        if (buffer[pos] === '\n') ++pos;

        self.buffer = buffer.substr(pos);
        return line;
      }

      // 3.2 WebVTT metadata header syntax
      function parseHeader(input) {
        parseOptions(input, function (k, v) {
          switch (k) {
            case 'Region':
              // 3.3 WebVTT region metadata header syntax
              console.log('parse region', v);
              // parseRegion(v);
              break;
          }
        }, /:/);
      }

      // 5.1 WebVTT file parsing.
      try {
        var line = void 0;
        if (self.state === 'INITIAL') {
          // We can't start parsing until we have the first line.
          if (!/\r\n|\n/.test(self.buffer)) return this;

          line = collectNextLine();
          // strip of UTF-8 BOM if any
          // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
          var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
          if (!m || !m[0]) throw new Error('Malformed WebVTT signature.');

          self.state = 'HEADER';
        }

        var alreadyCollectedLine = false;
        while (self.buffer) {
          // We can't parse a line until we have the full line.
          if (!/\r\n|\n/.test(self.buffer)) return this;

          if (!alreadyCollectedLine) line = collectNextLine();else alreadyCollectedLine = false;

          switch (self.state) {
            case 'HEADER':
              // 13-18 - Allow a header (metadata) under the WEBVTT line.
              if (/:/.test(line)) {
                parseHeader(line);
              } else if (!line) {
                // An empty line terminates the header and starts the body (cues).
                self.state = 'ID';
              }
              continue;
            case 'NOTE':
              // Ignore NOTE blocks.
              if (!line) self.state = 'ID';

              continue;
            case 'ID':
              // Check for the start of NOTE blocks.
              if (/^NOTE($|[ \t])/.test(line)) {
                self.state = 'NOTE';
                break;
              }
              // 19-29 - Allow any number of line terminators, then initialize new cue values.
              if (!line) continue;

              self.cue = new vttcue(0, 0, '');
              self.state = 'CUE';
              // 30-39 - Check if self line contains an optional identifier or timing data.
              if (line.indexOf('-->') === -1) {
                self.cue.id = line;
                continue;
              }
            // Process line as start of a cue.
            /* falls through */
            case 'CUE':
              // 40 - Collect cue timings and settings.
              try {
                parseCue(line, self.cue, self.regionList);
              } catch (e) {
                // In case of an error ignore rest of the cue.
                self.cue = null;
                self.state = 'BADCUE';
                continue;
              }
              self.state = 'CUETEXT';
              continue;
            case 'CUETEXT':
              var hasSubstring = line.indexOf('-->') !== -1;
              // 34 - If we have an empty line then report the cue.
              // 35 - If we have the special substring '-->' then report the cue,
              // but do not collect the line as we need to process the current
              // one as a new cue.
              if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                // We are done parsing self cue.
                if (self.oncue) self.oncue(self.cue);

                self.cue = null;
                self.state = 'ID';
                continue;
              }
              if (self.cue.text) self.cue.text += '\n';

              self.cue.text += line;
              continue;
            case 'BADCUE':
              // BADCUE
              // 54-62 - Collect and discard the remaining cue.
              if (!line) self.state = 'ID';

              continue;
          }
        }
      } catch (e) {
        // If we are currently parsing a cue, report what we have.
        if (self.state === 'CUETEXT' && self.cue && self.oncue) self.oncue(self.cue);

        self.cue = null;
        // Enter BADWEBVTT state if header was not parsed correctly otherwise
        // another exception occurred so enter BADCUE state.
        self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
      }
      return this;
    },
    flush: function flush() {
      var self = this;
      try {
        // Finish decoding the stream.
        self.buffer += self.decoder.decode();
        // Synthesize the end of the current cue or region.
        if (self.cue || self.state === 'HEADER') {
          self.buffer += '\n\n';
          self.parse();
        }
        // If we've flushed, parsed, and we're still on the INITIAL state then
        // that means we don't have enough of the stream to parse the first
        // line.
        if (self.state === 'INITIAL') throw new Error('Malformed WebVTT signature.');
      } catch (e) {
        throw e;
      }
      if (self.onflush) self.onflush();

      return this;
    }
  };



  /* harmony default export */ var vttparser = (VTTParser);
  // CONCATENATED MODULE: ./src/utils/cues.js


  function newCue(track, startTime, endTime, captionScreen) {
    var row = void 0;
    var cue = void 0;
    var indenting = void 0;
    var indent = void 0;
    var text = void 0;
    var VTTCue = window.VTTCue || window.TextTrackCue;

    for (var r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';

      if (!row.isEmpty()) {
        for (var c = 0; c < row.chars.length; c++) {
          if (row.chars[c].uchar.match(/\s/) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        // To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) endTime += 0.0001;

        cue = new VTTCue(startTime, endTime, fixLineBreaks(text.trim()));

        if (indent >= 16) indent--;else indent++;

        // VTTCue.line get's flakey when using controls, so let's now include line 13&14
        // also, drop line 1 since it's to close to the top
        if (navigator.userAgent.match(/Firefox\//)) cue.line = r + 1;else cue.line = r > 7 ? r - 2 : r + 1;

        cue.align = 'left';
        // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
        cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
        track.addCue(cue);
      }
    }
  }
  // CONCATENATED MODULE: ./src/utils/cea-608-parser.js
  function cea_608_parser__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   *
   * This code was ported from the dash.js project at:
   *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
   *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
   *
   * The original copyright appears below:
   *
   * The copyright in this software is being made available under the BSD License,
   * included below. This software may be subject to other third party and contributor
   * rights, including patent rights, and no such rights are granted under this license.
   *
   * Copyright (c) 2015-2016, DASH Industry Forum.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without modification,
   * are permitted provided that the following conditions are met:
   *  1. Redistributions of source code must retain the above copyright notice, this
   *  list of conditions and the following disclaimer.
   *  * Redistributions in binary form must reproduce the above copyright notice,
   *  this list of conditions and the following disclaimer in the documentation and/or
   *  other materials provided with the distribution.
   *  2. Neither the name of Dash Industry Forum nor the names of its
   *  contributors may be used to endorse or promote products derived from this software
   *  without specific prior written permission.
   *
   *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
   *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
   *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
   *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
   *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   *  POSSIBILITY OF SUCH DAMAGE.
   */
  /**
       *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
       */

  var specialCea608CharsCodes = {
    0x2a: 0xe1, // lowercase a, acute accent
    0x5c: 0xe9, // lowercase e, acute accent
    0x5e: 0xed, // lowercase i, acute accent
    0x5f: 0xf3, // lowercase o, acute accent
    0x60: 0xfa, // lowercase u, acute accent
    0x7b: 0xe7, // lowercase c with cedilla
    0x7c: 0xf7, // division symbol
    0x7d: 0xd1, // uppercase N tilde
    0x7e: 0xf1, // lowercase n tilde
    0x7f: 0x2588, // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae, // Registered symbol (R)
    0x81: 0xb0, // degree sign
    0x82: 0xbd, // 1/2 symbol
    0x83: 0xbf, // Inverted (open) question mark
    0x84: 0x2122, // Trademark symbol (TM)
    0x85: 0xa2, // Cents symbol
    0x86: 0xa3, // Pounds sterling
    0x87: 0x266a, // Music 8'th note
    0x88: 0xe0, // lowercase a, grave accent
    0x89: 0x20, // transparent space (regular)
    0x8a: 0xe8, // lowercase e, grave accent
    0x8b: 0xe2, // lowercase a, circumflex accent
    0x8c: 0xea, // lowercase e, circumflex accent
    0x8d: 0xee, // lowercase i, circumflex accent
    0x8e: 0xf4, // lowercase o, circumflex accent
    0x8f: 0xfb, // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1, // capital letter A with acute
    0x91: 0xc9, // capital letter E with acute
    0x92: 0xd3, // capital letter O with acute
    0x93: 0xda, // capital letter U with acute
    0x94: 0xdc, // capital letter U with diaresis
    0x95: 0xfc, // lowercase letter U with diaeresis
    0x96: 0x2018, // opening single quote
    0x97: 0xa1, // inverted exclamation mark
    0x98: 0x2a, // asterisk
    0x99: 0x2019, // closing single quote
    0x9a: 0x2501, // box drawings heavy horizontal
    0x9b: 0xa9, // copyright sign
    0x9c: 0x2120, // Service mark
    0x9d: 0x2022, // (round) bullet
    0x9e: 0x201c, // Left double quotation mark
    0x9f: 0x201d, // Right double quotation mark
    0xa0: 0xc0, // uppercase A, grave accent
    0xa1: 0xc2, // uppercase A, circumflex
    0xa2: 0xc7, // uppercase C with cedilla
    0xa3: 0xc8, // uppercase E, grave accent
    0xa4: 0xca, // uppercase E, circumflex
    0xa5: 0xcb, // capital letter E with diaresis
    0xa6: 0xeb, // lowercase letter e with diaresis
    0xa7: 0xce, // uppercase I, circumflex
    0xa8: 0xcf, // uppercase I, with diaresis
    0xa9: 0xef, // lowercase i, with diaresis
    0xaa: 0xd4, // uppercase O, circumflex
    0xab: 0xd9, // uppercase U, grave accent
    0xac: 0xf9, // lowercase u, grave accent
    0xad: 0xdb, // uppercase U, circumflex
    0xae: 0xab, // left-pointing double angle quotation mark
    0xaf: 0xbb, // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3, // Uppercase A, tilde
    0xb1: 0xe3, // Lowercase a, tilde
    0xb2: 0xcd, // Uppercase I, acute accent
    0xb3: 0xcc, // Uppercase I, grave accent
    0xb4: 0xec, // Lowercase i, grave accent
    0xb5: 0xd2, // Uppercase O, grave accent
    0xb6: 0xf2, // Lowercase o, grave accent
    0xb7: 0xd5, // Uppercase O, tilde
    0xb8: 0xf5, // Lowercase o, tilde
    0xb9: 0x7b, // Open curly brace
    0xba: 0x7d, // Closing curly brace
    0xbb: 0x5c, // Backslash
    0xbc: 0x5e, // Caret
    0xbd: 0x5f, // Underscore
    0xbe: 0x7c, // Pipe (vertical line)
    0xbf: 0x223c, // Tilde operator
    0xc0: 0xc4, // Uppercase A, umlaut
    0xc1: 0xe4, // Lowercase A, umlaut
    0xc2: 0xd6, // Uppercase O, umlaut
    0xc3: 0xf6, // Lowercase o, umlaut
    0xc4: 0xdf, // Esszett (sharp S)
    0xc5: 0xa5, // Yen symbol
    0xc6: 0xa4, // Generic currency sign
    0xc7: 0x2503, // Box drawings heavy vertical
    0xc8: 0xc5, // Uppercase A, ring
    0xc9: 0xe5, // Lowercase A, ring
    0xca: 0xd8, // Uppercase O, stroke
    0xcb: 0xf8, // Lowercase o, strok
    0xcc: 0x250f, // Box drawings heavy down and right
    0xcd: 0x2513, // Box drawings heavy down and left
    0xce: 0x2517, // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
  };

  /**
   * Utils
   */
  var getCharForByte = function getCharForByte(byte) {
    var charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) charCode = specialCea608CharsCodes[byte];

    return String.fromCharCode(charCode);
  };

  var NR_ROWS = 15,
      NR_COLS = 100;
  // Tables to look up row from PAC data
  var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
  var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
  var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
  var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };

  var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];

  /**
   * Simple logger class to be able to write with time-stamps and filter on level.
   */
  var cea_608_parser_logger = {
    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
    time: null,
    verboseLevel: 0, // Only write errors
    setTime: function setTime(newTime) {
      this.time = newTime;
    },
    log: function log(severity, msg) {
      var minLevel = this.verboseFilter[severity];
      if (this.verboseLevel >= minLevel) console.log(this.time + ' [' + severity + '] ' + msg);
    }
  };

  var numArrayToHexArray = function numArrayToHexArray(numArray) {
    var hexArray = [];
    for (var j = 0; j < numArray.length; j++) {
      hexArray.push(numArray[j].toString(16));
    }return hexArray;
  };

  var PenState = function () {
    function PenState(foreground, underline, italics, background, flash) {
      cea_608_parser__classCallCheck(this, PenState);

      this.foreground = foreground || 'white';
      this.underline = underline || false;
      this.italics = italics || false;
      this.background = background || 'black';
      this.flash = flash || false;
    }

    PenState.prototype.reset = function reset() {
      this.foreground = 'white';
      this.underline = false;
      this.italics = false;
      this.background = 'black';
      this.flash = false;
    };

    PenState.prototype.setStyles = function setStyles(styles) {
      var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
      for (var i = 0; i < attribs.length; i++) {
        var style = attribs[i];
        if (styles.hasOwnProperty(style)) this[style] = styles[style];
      }
    };

    PenState.prototype.isDefault = function isDefault() {
      return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
    };

    PenState.prototype.equals = function equals(other) {
      return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    };

    PenState.prototype.copy = function copy(newPenState) {
      this.foreground = newPenState.foreground;
      this.underline = newPenState.underline;
      this.italics = newPenState.italics;
      this.background = newPenState.background;
      this.flash = newPenState.flash;
    };

    PenState.prototype.toString = function toString() {
      return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
    };

    return PenState;
  }();

  /**
   * Unicode character with styling and background.
   * @constructor
   */


  var StyledUnicodeChar = function () {
    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
      cea_608_parser__classCallCheck(this, StyledUnicodeChar);

      this.uchar = uchar || ' '; // unicode character
      this.penState = new PenState(foreground, underline, italics, background, flash);
    }

    StyledUnicodeChar.prototype.reset = function reset() {
      this.uchar = ' ';
      this.penState.reset();
    };

    StyledUnicodeChar.prototype.setChar = function setChar(uchar, newPenState) {
      this.uchar = uchar;
      this.penState.copy(newPenState);
    };

    StyledUnicodeChar.prototype.setPenState = function setPenState(newPenState) {
      this.penState.copy(newPenState);
    };

    StyledUnicodeChar.prototype.equals = function equals(other) {
      return this.uchar === other.uchar && this.penState.equals(other.penState);
    };

    StyledUnicodeChar.prototype.copy = function copy(newChar) {
      this.uchar = newChar.uchar;
      this.penState.copy(newChar.penState);
    };

    StyledUnicodeChar.prototype.isEmpty = function isEmpty() {
      return this.uchar === ' ' && this.penState.isDefault();
    };

    return StyledUnicodeChar;
  }();

  /**
   * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
   * @constructor
   */


  var Row = function () {
    function Row() {
      cea_608_parser__classCallCheck(this, Row);

      this.chars = [];
      for (var i = 0; i < NR_COLS; i++) {
        this.chars.push(new StyledUnicodeChar());
      }this.pos = 0;
      this.currPenState = new PenState();
    }

    Row.prototype.equals = function equals(other) {
      var equal = true;
      for (var i = 0; i < NR_COLS; i++) {
        if (!this.chars[i].equals(other.chars[i])) {
          equal = false;
          break;
        }
      }
      return equal;
    };

    Row.prototype.copy = function copy(other) {
      for (var i = 0; i < NR_COLS; i++) {
        this.chars[i].copy(other.chars[i]);
      }
    };

    Row.prototype.isEmpty = function isEmpty() {
      var empty = true;
      for (var i = 0; i < NR_COLS; i++) {
        if (!this.chars[i].isEmpty()) {
          empty = false;
          break;
        }
      }
      return empty;
    };

    /**
       *  Set the cursor to a valid column.
       */


    Row.prototype.setCursor = function setCursor(absPos) {
      if (this.pos !== absPos) this.pos = absPos;

      if (this.pos < 0) {
        cea_608_parser_logger.log('ERROR', 'Negative cursor position ' + this.pos);
        this.pos = 0;
      } else if (this.pos > NR_COLS) {
        cea_608_parser_logger.log('ERROR', 'Too large cursor position ' + this.pos);
        this.pos = NR_COLS;
      }
    };

    /**
       * Move the cursor relative to current position.
       */


    Row.prototype.moveCursor = function moveCursor(relPos) {
      var newPos = this.pos + relPos;
      if (relPos > 1) {
        for (var i = this.pos + 1; i < newPos + 1; i++) {
          this.chars[i].setPenState(this.currPenState);
        }
      }
      this.setCursor(newPos);
    };

    /**
       * Backspace, move one step back and clear character.
       */


    Row.prototype.backSpace = function backSpace() {
      this.moveCursor(-1);
      this.chars[this.pos].setChar(' ', this.currPenState);
    };

    Row.prototype.insertChar = function insertChar(byte) {
      if (byte >= 0x90) {
        // Extended char
        this.backSpace();
      }
      var char = getCharForByte(byte);
      if (this.pos >= NR_COLS) {
        cea_608_parser_logger.log('ERROR', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
        return;
      }
      this.chars[this.pos].setChar(char, this.currPenState);
      this.moveCursor(1);
    };

    Row.prototype.clearFromPos = function clearFromPos(startPos) {
      var i = void 0;
      for (i = startPos; i < NR_COLS; i++) {
        this.chars[i].reset();
      }
    };

    Row.prototype.clear = function clear() {
      this.clearFromPos(0);
      this.pos = 0;
      this.currPenState.reset();
    };

    Row.prototype.clearToEndOfRow = function clearToEndOfRow() {
      this.clearFromPos(this.pos);
    };

    Row.prototype.getTextString = function getTextString() {
      var chars = [];
      var empty = true;
      for (var i = 0; i < NR_COLS; i++) {
        var char = this.chars[i].uchar;
        if (char !== ' ') empty = false;

        chars.push(char);
      }
      if (empty) return '';else return chars.join('');
    };

    Row.prototype.setPenStyles = function setPenStyles(styles) {
      this.currPenState.setStyles(styles);
      var currChar = this.chars[this.pos];
      currChar.setPenState(this.currPenState);
    };

    return Row;
  }();

  /**
   * Keep a CEA-608 screen of 32x15 styled characters
   * @constructor
  */


  var CaptionScreen = function () {
    function CaptionScreen() {
      cea_608_parser__classCallCheck(this, CaptionScreen);

      this.rows = [];
      for (var i = 0; i < NR_ROWS; i++) {
        this.rows.push(new Row());
      } // Note that we use zero-based numbering (0-14)

      this.currRow = NR_ROWS - 1;
      this.nrRollUpRows = null;
      this.reset();
    }

    CaptionScreen.prototype.reset = function reset() {
      for (var i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }this.currRow = NR_ROWS - 1;
    };

    CaptionScreen.prototype.equals = function equals(other) {
      var equal = true;
      for (var i = 0; i < NR_ROWS; i++) {
        if (!this.rows[i].equals(other.rows[i])) {
          equal = false;
          break;
        }
      }
      return equal;
    };

    CaptionScreen.prototype.copy = function copy(other) {
      for (var i = 0; i < NR_ROWS; i++) {
        this.rows[i].copy(other.rows[i]);
      }
    };

    CaptionScreen.prototype.isEmpty = function isEmpty() {
      var empty = true;
      for (var i = 0; i < NR_ROWS; i++) {
        if (!this.rows[i].isEmpty()) {
          empty = false;
          break;
        }
      }
      return empty;
    };

    CaptionScreen.prototype.backSpace = function backSpace() {
      var row = this.rows[this.currRow];
      row.backSpace();
    };

    CaptionScreen.prototype.clearToEndOfRow = function clearToEndOfRow() {
      var row = this.rows[this.currRow];
      row.clearToEndOfRow();
    };

    /**
       * Insert a character (without styling) in the current row.
       */


    CaptionScreen.prototype.insertChar = function insertChar(char) {
      var row = this.rows[this.currRow];
      row.insertChar(char);
    };

    CaptionScreen.prototype.setPen = function setPen(styles) {
      var row = this.rows[this.currRow];
      row.setPenStyles(styles);
    };

    CaptionScreen.prototype.moveCursor = function moveCursor(relPos) {
      var row = this.rows[this.currRow];
      row.moveCursor(relPos);
    };

    CaptionScreen.prototype.setCursor = function setCursor(absPos) {
      cea_608_parser_logger.log('INFO', 'setCursor: ' + absPos);
      var row = this.rows[this.currRow];
      row.setCursor(absPos);
    };

    CaptionScreen.prototype.setPAC = function setPAC(pacData) {
      cea_608_parser_logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
      var newRow = pacData.row - 1;
      if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;

      // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
      if (this.nrRollUpRows && this.currRow !== newRow) {
        // clear all rows first
        for (var i = 0; i < NR_ROWS; i++) {
          this.rows[i].clear();
        } // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
        // topRowIndex - the start of rows to copy (inclusive index)
        var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        // We only copy if the last position was already shown.
        // We use the cueStartTime value to check this.
        var lastOutputScreen = this.lastOutputScreen;
        if (lastOutputScreen) {
          var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
          if (prevLineTime && prevLineTime < cea_608_parser_logger.time) {
            for (var _i = 0; _i < this.nrRollUpRows; _i++) {
              this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
            }
          }
        }
      }

      this.currRow = newRow;
      var row = this.rows[this.currRow];
      if (pacData.indent !== null) {
        var indent = pacData.indent;
        var prevPos = Math.max(indent - 1, 0);
        row.setCursor(pacData.indent);
        pacData.color = row.chars[prevPos].penState.foreground;
      }
      var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
      this.setPen(styles);
    };

    /**
       * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
       */


    CaptionScreen.prototype.setBkgData = function setBkgData(bkgData) {
      cea_608_parser_logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
      this.backSpace();
      this.setPen(bkgData);
      this.insertChar(0x20); // Space
    };

    CaptionScreen.prototype.setRollUpRows = function setRollUpRows(nrRows) {
      this.nrRollUpRows = nrRows;
    };

    CaptionScreen.prototype.rollUp = function rollUp() {
      if (this.nrRollUpRows === null) {
        cea_608_parser_logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
        return; // Not properly setup
      }
      cea_608_parser_logger.log('TEXT', this.getDisplayText());
      var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      var topRow = this.rows.splice(topRowIndex, 1)[0];
      topRow.clear();
      this.rows.splice(this.currRow, 0, topRow);
      cea_608_parser_logger.log('INFO', 'Rolling up');
      // logger.log('TEXT', this.get_display_text())
    };

    /**
      * Get all non-empty rows with as unicode text.
      */


    CaptionScreen.prototype.getDisplayText = function getDisplayText(asOneRow) {
      asOneRow = asOneRow || false;
      var displayText = [];
      var text = '';
      var rowNr = -1;
      for (var i = 0; i < NR_ROWS; i++) {
        var rowText = this.rows[i].getTextString();
        if (rowText) {
          rowNr = i + 1;
          if (asOneRow) displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');else displayText.push(rowText.trim());
        }
      }
      if (displayText.length > 0) {
        if (asOneRow) text = '[' + displayText.join(' | ') + ']';else text = displayText.join('\n');
      }
      return text;
    };

    CaptionScreen.prototype.getTextAndFormat = function getTextAndFormat() {
      return this.rows;
    };

    return CaptionScreen;
  }();

  // var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

  var Cea608Channel = function () {
    function Cea608Channel(channelNumber, outputFilter) {
      cea_608_parser__classCallCheck(this, Cea608Channel);

      this.chNr = channelNumber;
      this.outputFilter = outputFilter;
      this.mode = null;
      this.verbose = 0;
      this.displayedMemory = new CaptionScreen();
      this.nonDisplayedMemory = new CaptionScreen();
      this.lastOutputScreen = new CaptionScreen();
      this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
      this.writeScreen = this.displayedMemory;
      this.mode = null;
      this.cueStartTime = null; // Keeps track of where a cue started.
    }

    Cea608Channel.prototype.reset = function reset() {
      this.mode = null;
      this.displayedMemory.reset();
      this.nonDisplayedMemory.reset();
      this.lastOutputScreen.reset();
      this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
      this.writeScreen = this.displayedMemory;
      this.mode = null;
      this.cueStartTime = null;
      this.lastCueEndTime = null;
    };

    Cea608Channel.prototype.getHandler = function getHandler() {
      return this.outputFilter;
    };

    Cea608Channel.prototype.setHandler = function setHandler(newHandler) {
      this.outputFilter = newHandler;
    };

    Cea608Channel.prototype.setPAC = function setPAC(pacData) {
      this.writeScreen.setPAC(pacData);
    };

    Cea608Channel.prototype.setBkgData = function setBkgData(bkgData) {
      this.writeScreen.setBkgData(bkgData);
    };

    Cea608Channel.prototype.setMode = function setMode(newMode) {
      if (newMode === this.mode) return;

      this.mode = newMode;
      cea_608_parser_logger.log('INFO', 'MODE=' + newMode);
      if (this.mode === 'MODE_POP-ON') {
        this.writeScreen = this.nonDisplayedMemory;
      } else {
        this.writeScreen = this.displayedMemory;
        this.writeScreen.reset();
      }
      if (this.mode !== 'MODE_ROLL-UP') {
        this.displayedMemory.nrRollUpRows = null;
        this.nonDisplayedMemory.nrRollUpRows = null;
      }
      this.mode = newMode;
    };

    Cea608Channel.prototype.insertChars = function insertChars(chars) {
      for (var i = 0; i < chars.length; i++) {
        this.writeScreen.insertChar(chars[i]);
      }var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
      cea_608_parser_logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
      if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
        cea_608_parser_logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
        this.outputDataUpdate();
      }
    };

    Cea608Channel.prototype.ccRCL = function ccRCL() {
      // Resume Caption Loading (switch mode to Pop On)
      cea_608_parser_logger.log('INFO', 'RCL - Resume Caption Loading');
      this.setMode('MODE_POP-ON');
    };

    Cea608Channel.prototype.ccBS = function ccBS() {
      // BackSpace
      cea_608_parser_logger.log('INFO', 'BS - BackSpace');
      if (this.mode === 'MODE_TEXT') return;

      this.writeScreen.backSpace();
      if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
    };

    Cea608Channel.prototype.ccAOF = function ccAOF() {// Reserved (formerly Alarm Off)

    };

    Cea608Channel.prototype.ccAON = function ccAON() {// Reserved (formerly Alarm On)

    };

    Cea608Channel.prototype.ccDER = function ccDER() {
      // Delete to End of Row
      cea_608_parser_logger.log('INFO', 'DER- Delete to End of Row');
      this.writeScreen.clearToEndOfRow();
      this.outputDataUpdate();
    };

    Cea608Channel.prototype.ccRU = function ccRU(nrRows) {
      // Roll-Up Captions-2,3,or 4 Rows
      cea_608_parser_logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
      this.writeScreen = this.displayedMemory;
      this.setMode('MODE_ROLL-UP');
      this.writeScreen.setRollUpRows(nrRows);
    };

    Cea608Channel.prototype.ccFON = function ccFON() {
      // Flash On
      cea_608_parser_logger.log('INFO', 'FON - Flash On');
      this.writeScreen.setPen({ flash: true });
    };

    Cea608Channel.prototype.ccRDC = function ccRDC() {
      // Resume Direct Captioning (switch mode to PaintOn)
      cea_608_parser_logger.log('INFO', 'RDC - Resume Direct Captioning');
      this.setMode('MODE_PAINT-ON');
    };

    Cea608Channel.prototype.ccTR = function ccTR() {
      // Text Restart in text mode (not supported, however)
      cea_608_parser_logger.log('INFO', 'TR');
      this.setMode('MODE_TEXT');
    };

    Cea608Channel.prototype.ccRTD = function ccRTD() {
      // Resume Text Display in Text mode (not supported, however)
      cea_608_parser_logger.log('INFO', 'RTD');
      this.setMode('MODE_TEXT');
    };

    Cea608Channel.prototype.ccEDM = function ccEDM() {
      // Erase Displayed Memory
      cea_608_parser_logger.log('INFO', 'EDM - Erase Displayed Memory');
      this.displayedMemory.reset();
      this.outputDataUpdate(true);
    };

    Cea608Channel.prototype.ccCR = function ccCR() {
      // Carriage Return
      cea_608_parser_logger.log('CR - Carriage Return');
      this.writeScreen.rollUp();
      this.outputDataUpdate(true);
    };

    Cea608Channel.prototype.ccENM = function ccENM() {
      // Erase Non-Displayed Memory
      cea_608_parser_logger.log('INFO', 'ENM - Erase Non-displayed Memory');
      this.nonDisplayedMemory.reset();
    };

    Cea608Channel.prototype.ccEOC = function ccEOC() {
      // End of Caption (Flip Memories)
      cea_608_parser_logger.log('INFO', 'EOC - End Of Caption');
      if (this.mode === 'MODE_POP-ON') {
        var tmp = this.displayedMemory;
        this.displayedMemory = this.nonDisplayedMemory;
        this.nonDisplayedMemory = tmp;
        this.writeScreen = this.nonDisplayedMemory;
        cea_608_parser_logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
      }
      this.outputDataUpdate(true);
    };

    Cea608Channel.prototype.ccTO = function ccTO(nrCols) {
      // Tab Offset 1,2, or 3 columns
      cea_608_parser_logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
      this.writeScreen.moveCursor(nrCols);
    };

    Cea608Channel.prototype.ccMIDROW = function ccMIDROW(secondByte) {
      // Parse MIDROW command
      var styles = { flash: false };
      styles.underline = secondByte % 2 === 1;
      styles.italics = secondByte >= 0x2e;
      if (!styles.italics) {
        var colorIndex = Math.floor(secondByte / 2) - 0x10;
        var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
        styles.foreground = colors[colorIndex];
      } else {
        styles.foreground = 'white';
      }
      cea_608_parser_logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
      this.writeScreen.setPen(styles);
    };

    Cea608Channel.prototype.outputDataUpdate = function outputDataUpdate() {
      var dispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var t = cea_608_parser_logger.time;
      return;

      if (this.outputFilter) {
        if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
          // Start of a new cue
          this.cueStartTime = t;
        } else {
          if (!this.displayedMemory.equals(this.lastOutputScreen)) {
            if (this.outputFilter.newCue) {
              this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
              if (dispatch === true && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
            }
            this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
          }
        }
        this.lastOutputScreen.copy(this.displayedMemory);
      }
    };

    Cea608Channel.prototype.cueSplitAtTime = function cueSplitAtTime(t) {
      if (this.outputFilter) {
        if (!this.displayedMemory.isEmpty()) {
          if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);

          this.cueStartTime = t;
        }
      }
    };

    return Cea608Channel;
  }();

  var Cea608Parser = function () {
    function Cea608Parser(field, out1, out2) {
      cea_608_parser__classCallCheck(this, Cea608Parser);

      this.field = field || 1;
      this.outputs = [out1, out2];
      this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
      this.currChNr = -1; // Will be 1 or 2
      this.lastCmdA = null; // First byte of last command
      this.lastCmdB = null; // Second byte of last command
      this.bufferedData = [];
      this.startTime = null;
      this.lastTime = null;
      this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    }

    Cea608Parser.prototype.getHandler = function getHandler(index) {
      return this.channels[index].getHandler();
    };

    Cea608Parser.prototype.setHandler = function setHandler(index, newHandler) {
      this.channels[index].setHandler(newHandler);
    };

    /**
       * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
       */


    Cea608Parser.prototype.addData = function addData(t, byteList) {
      var cmdFound = void 0,
          a = void 0,
          b = void 0,
          charsFound = false;

      this.lastTime = t;
      cea_608_parser_logger.setTime(t);

      for (var i = 0; i < byteList.length; i += 2) {
        a = byteList[i] & 0x7f;
        b = byteList[i + 1] & 0x7f;
        if (a === 0 && b === 0) {
          this.dataCounters.padding += 2;
          continue;
        } else {
          cea_608_parser_logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
        }
        cmdFound = this.parseCmd(a, b);
        if (!cmdFound) cmdFound = this.parseMidrow(a, b);

        if (!cmdFound) cmdFound = this.parsePAC(a, b);

        if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);

        if (!cmdFound) {
          charsFound = this.parseChars(a, b);
          if (charsFound) {
            if (this.currChNr && this.currChNr >= 0) {
              var channel = this.channels[this.currChNr - 1];
              channel.insertChars(charsFound);
            } else {
              cea_608_parser_logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
            }
          }
        }
        if (cmdFound) {
          this.dataCounters.cmd += 2;
        } else if (charsFound) {
          this.dataCounters.char += 2;
        } else {
          this.dataCounters.other += 2;
          cea_608_parser_logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
        }
      }
    };

    /**
       * Parse Command.
       * @returns {Boolean} Tells if a command was found
       */


    Cea608Parser.prototype.parseCmd = function parseCmd(a, b) {
      var chNr = null;

      var cond1 = (a === 0x14 || a === 0x1C) && b >= 0x20 && b <= 0x2F;
      var cond2 = (a === 0x17 || a === 0x1F) && b >= 0x21 && b <= 0x23;
      if (!(cond1 || cond2)) return false;

      if (a === this.lastCmdA && b === this.lastCmdB) {
        this.lastCmdA = null;
        this.lastCmdB = null; // Repeated commands are dropped (once)
        cea_608_parser_logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
        return true;
      }

      if (a === 0x14 || a === 0x17) chNr = 1;else chNr = 2; // (a === 0x1C || a=== 0x1f)

      var channel = this.channels[chNr - 1];

      if (a === 0x14 || a === 0x1C) {
        if (b === 0x20) channel.ccRCL();else if (b === 0x21) channel.ccBS();else if (b === 0x22) channel.ccAOF();else if (b === 0x23) channel.ccAON();else if (b === 0x24) channel.ccDER();else if (b === 0x25) channel.ccRU(2);else if (b === 0x26) channel.ccRU(3);else if (b === 0x27) channel.ccRU(4);else if (b === 0x28) channel.ccFON();else if (b === 0x29) channel.ccRDC();else if (b === 0x2A) channel.ccTR();else if (b === 0x2B) channel.ccRTD();else if (b === 0x2C) channel.ccEDM();else if (b === 0x2D) channel.ccCR();else if (b === 0x2E) channel.ccENM();else if (b === 0x2F) channel.ccEOC();
      } else {
        // a == 0x17 || a == 0x1F
        channel.ccTO(b - 0x20);
      }
      this.lastCmdA = a;
      this.lastCmdB = b;
      this.currChNr = chNr;
      return true;
    };

    /**
       * Parse midrow styling command
       * @returns {Boolean}
       */


    Cea608Parser.prototype.parseMidrow = function parseMidrow(a, b) {
      var chNr = null;

      if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
        if (a === 0x11) chNr = 1;else chNr = 2;

        if (chNr !== this.currChNr) {
          cea_608_parser_logger.log('ERROR', 'Mismatch channel in midrow parsing');
          return false;
        }
        var channel = this.channels[chNr - 1];
        channel.ccMIDROW(b);
        cea_608_parser_logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
        return true;
      }
      return false;
    };
    /**
       * Parse Preable Access Codes (Table 53).
       * @returns {Boolean} Tells if PAC found
       */


    Cea608Parser.prototype.parsePAC = function parsePAC(a, b) {
      var chNr = null;
      var row = null;

      var case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1F) && b >= 0x40 && b <= 0x7F;
      var case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5F;
      if (!(case1 || case2)) return false;

      if (a === this.lastCmdA && b === this.lastCmdB) {
        this.lastCmdA = null;
        this.lastCmdB = null;
        return true; // Repeated commands are dropped (once)
      }

      chNr = a <= 0x17 ? 1 : 2;

      if (b >= 0x40 && b <= 0x5F) {
        row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
      } else {
        // 0x60 <= b <= 0x7F
        row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
      }
      var pacData = this.interpretPAC(row, b);
      var channel = this.channels[chNr - 1];
      channel.setPAC(pacData);
      this.lastCmdA = a;
      this.lastCmdB = b;
      this.currChNr = chNr;
      return true;
    };

    /**
       * Interpret the second byte of the pac, and return the information.
       * @returns {Object} pacData with style parameters.
       */


    Cea608Parser.prototype.interpretPAC = function interpretPAC(row, byte) {
      var pacIndex = byte;
      var pacData = { color: null, italics: false, indent: null, underline: false, row: row };

      if (byte > 0x5F) pacIndex = byte - 0x60;else pacIndex = byte - 0x40;

      pacData.underline = (pacIndex & 1) === 1;
      if (pacIndex <= 0xd) {
        pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
      } else if (pacIndex <= 0xf) {
        pacData.italics = true;
        pacData.color = 'white';
      } else {
        pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
      }
      return pacData; // Note that row has zero offset. The spec uses 1.
    };

    /**
       * Parse characters.
       * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
       */


    Cea608Parser.prototype.parseChars = function parseChars(a, b) {
      var channelNr = null,
          charCodes = null,
          charCode1 = null;

      if (a >= 0x19) {
        channelNr = 2;
        charCode1 = a - 8;
      } else {
        channelNr = 1;
        charCode1 = a;
      }
      if (charCode1 >= 0x11 && charCode1 <= 0x13) {
        // Special character
        var oneCode = b;
        if (charCode1 === 0x11) oneCode = b + 0x50;else if (charCode1 === 0x12) oneCode = b + 0x70;else oneCode = b + 0x90;

        cea_608_parser_logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
        charCodes = [oneCode];
      } else if (a >= 0x20 && a <= 0x7f) {
        charCodes = b === 0 ? [a] : [a, b];
      }
      if (charCodes) {
        var hexCodes = numArrayToHexArray(charCodes);
        cea_608_parser_logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
        this.lastCmdA = null;
        this.lastCmdB = null;
      }
      return charCodes;
    };

    /**
      * Parse extended background attributes as well as new foreground color black.
      * @returns{Boolean} Tells if background attributes are found
      */


    Cea608Parser.prototype.parseBackgroundAttributes = function parseBackgroundAttributes(a, b) {
      var bkgData = void 0,
          index = void 0,
          chNr = void 0,
          channel = void 0;

      var case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
      var case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
      if (!(case1 || case2)) return false;

      bkgData = {};
      if (a === 0x10 || a === 0x18) {
        index = Math.floor((b - 0x20) / 2);
        bkgData.background = backgroundColors[index];
        if (b % 2 === 1) bkgData.background = bkgData.background + '_semi';
      } else if (b === 0x2d) {
        bkgData.background = 'transparent';
      } else {
        bkgData.foreground = 'black';
        if (b === 0x2f) bkgData.underline = true;
      }
      chNr = a < 0x18 ? 1 : 2;
      channel = this.channels[chNr - 1];
      channel.setBkgData(bkgData);
      this.lastCmdA = null;
      this.lastCmdB = null;
      return true;
    };

    /**
       * Reset state of parser and its channels.
       */


    Cea608Parser.prototype.reset = function reset() {
      for (var i = 0; i < this.channels.length; i++) {
        if (this.channels[i]) this.channels[i].reset();
      }
      this.lastCmdA = null;
      this.lastCmdB = null;
    };

    /**
       * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
       */


    Cea608Parser.prototype.cueSplitAtTime = function cueSplitAtTime(t) {
      for (var i = 0; i < this.channels.length; i++) {
        if (this.channels[i]) this.channels[i].cueSplitAtTime(t);
      }
    };

    return Cea608Parser;
  }();

  /* harmony default export */ var cea_608_parser = (Cea608Parser);
  // CONCATENATED MODULE: ./src/utils/output-filter.js
  function output_filter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var OutputFilter = function () {
    function OutputFilter(timelineController, track) {
      output_filter__classCallCheck(this, OutputFilter);

      this.timelineController = timelineController;
      this.track = track;
      this.startTime = null;
      this.endTime = null;
      this.screen = null;
    }

    OutputFilter.prototype.dispatchCue = function dispatchCue() {
      if (this.startTime === null) return;

      this.timelineController.addCues('textTrack' + this.track, this.startTime, this.endTime, this.screen);
      this.startTime = null;
    };

    OutputFilter.prototype.newCue = function newCue(startTime, endTime, screen) {
      if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;

      this.endTime = endTime;
      this.screen = screen;
      this.timelineController.createCaptionsTrack(this.track);
    };

    return OutputFilter;
  }();

  /* harmony default export */ var output_filter = (OutputFilter);
  // CONCATENATED MODULE: ./src/utils/webvtt-parser.js



  // String.prototype.startsWith is not supported in IE11
  var startsWith = function startsWith(inputString, searchString, position) {
    return inputString.substr(position || 0, searchString.length) === searchString;
  };

  var cueString2millis = function cueString2millis(timeString) {
    var ts = parseInt(timeString.substr(-3));
    var secs = parseInt(timeString.substr(-6, 2));
    var mins = parseInt(timeString.substr(-9, 2));
    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;

    if (isNaN(ts) || isNaN(secs) || isNaN(mins) || isNaN(hours)) return -1;

    ts += 1000 * secs;
    ts += 60 * 1000 * mins;
    ts += 60 * 60 * 1000 * hours;

    return ts;
  };

  // From https://github.com/darkskyapp/string-hash
  var hash = function hash(text) {
    var hash = 5381;
    var i = text.length;
    while (i) {
      hash = hash * 33 ^ text.charCodeAt(--i);
    }return (hash >>> 0).toString();
  };

  var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    var currCC = vttCCs[cc];
    var prevCC = vttCCs[currCC.prevCC];

    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
      vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
      currCC.new = false;
      return;
    }

    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while (prevCC && prevCC.new) {
      vttCCs.ccOffset += currCC.start - prevCC.start;
      currCC.new = false;
      currCC = prevCC;
      prevCC = vttCCs[currCC.prevCC];
    }

    vttCCs.presentationOffset = presentationTime;
  };

  var WebVTTParser = {
    parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
      // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
      var re = /\r\n|\n\r|\n|\r/g;
      // Uint8Array.prototype.reduce is not implemented in IE11
      var vttLines = Object(id3["b" /* utf8ArrayToStr */])(new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');

      var cueTime = '00:00.000';
      var mpegTs = 0;
      var localTime = 0;
      var presentationTime = 0;
      var cues = [];
      var parsingError = void 0;
      var inHeader = true;
      // let VTTCue = VTTCue || window.TextTrackCue;

      // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
      var parser = new vttparser();

      parser.oncue = function (cue) {
        // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
        var currCC = vttCCs[cc];
        var cueOffset = vttCCs.ccOffset;

        // Update offsets for new discontinuities
        if (currCC && currCC.new) {
          if (localTime !== undefined) {
            // When local time is provided, offset = discontinuity start time - local time
            cueOffset = vttCCs.ccOffset = currCC.start;
          } else {
            calculateOffset(vttCCs, cc, presentationTime);
          }
        }

        if (presentationTime) {
          // If we have MPEGTS, offset = presentation time + discontinuity offset
          cueOffset = presentationTime + vttCCs.ccOffset - vttCCs.presentationOffset;
        }

        cue.startTime += cueOffset - localTime;
        cue.endTime += cueOffset - localTime;

        // Create a unique hash id for a cue based on start/end times and text.
        // This helps timeline-controller to avoid showing repeated captions.
        cue.id = hash(cue.startTime.toString()) + hash(cue.endTime.toString()) + hash(cue.text);

        // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
        cue.text = decodeURIComponent(encodeURIComponent(cue.text));
        if (cue.endTime > 0) cues.push(cue);
      };

      parser.onparsingerror = function (e) {
        parsingError = e;
      };

      parser.onflush = function () {
        if (parsingError && errorCallBack) {
          errorCallBack(parsingError);
          return;
        }
        callBack(cues);
      };

      // Go through contents line by line.
      vttLines.forEach(function (line) {
        if (inHeader) {
          // Look for X-TIMESTAMP-MAP in header.
          if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
            // Once found, no more are allowed anyway, so stop searching.
            inHeader = false;
            // Extract LOCAL and MPEGTS.
            line.substr(16).split(',').forEach(function (timestamp) {
              if (startsWith(timestamp, 'LOCAL:')) cueTime = timestamp.substr(6);else if (startsWith(timestamp, 'MPEGTS:')) mpegTs = parseInt(timestamp.substr(7));
            });
            try {
              // Calculate subtitle offset in milliseconds.
              // If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
              syncPTS = syncPTS < 0 ? syncPTS + 8589934592 : syncPTS;
              // Adjust MPEGTS by sync PTS.
              mpegTs -= syncPTS;
              // Convert cue time to seconds
              localTime = cueString2millis(cueTime) / 1000;
              // Convert MPEGTS to seconds from 90kHz.
              presentationTime = mpegTs / 90000;

              if (localTime === -1) parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
            } catch (e) {
              parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
            }
            // Return without parsing X-TIMESTAMP-MAP line.
            return;
          } else if (line === '') {
            inHeader = false;
          }
        }
        // Parse line by default.
        parser.parse(line + '\n');
      });

      parser.flush();
    }
  };

  /* harmony default export */ var webvtt_parser = (WebVTTParser);
  // CONCATENATED MODULE: ./src/controller/timeline-controller.js
  function timeline_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function timeline_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function timeline_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Timeline Controller
  */









  function reuseVttTextTrack(inUseTrack, manifestTrack) {
    return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
  }

  function intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
  }

  var timeline_controller_TimelineController = function (_EventHandler) {
    timeline_controller__inherits(TimelineController, _EventHandler);

    function TimelineController(hls) {
      timeline_controller__classCallCheck(this, TimelineController);

      var _this = timeline_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].FRAG_PARSING_USERDATA, events["a" /* default */].FRAG_DECRYPTED, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].LEVEL_SWITCHING, events["a" /* default */].INIT_PTS_FOUND));

      _this.hls = hls;
      _this.config = hls.config;
      _this.enabled = true;
      _this.Cues = hls.config.cueHandler;
      _this.textTracks = [];
      _this.tracks = [];
      _this.unparsedVttFrags = [];
      _this.initPTS = undefined;
      _this.cueRanges = [];

      if (_this.config.enableCEA708Captions) {
        var channel1 = new output_filter(_this, 1);
        var channel2 = new output_filter(_this, 2);

        _this.cea608Parser = new cea_608_parser(0, channel1, channel2);
      }
      return _this;
    }

    TimelineController.prototype.addCues = function addCues(channel, startTime, endTime, screen) {
      // skip cues which overlap more than 50% with previously parsed time ranges
      var ranges = this.cueRanges;
      var merged = false;
      for (var i = ranges.length; i--;) {
        var cueRange = ranges[i];
        var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
        if (overlap >= 0) {
          cueRange[0] = Math.min(cueRange[0], startTime);
          cueRange[1] = Math.max(cueRange[1], endTime);
          merged = true;
          if (overlap / (endTime - startTime) > 0.5) return;
        }
      }
      if (!merged) ranges.push([startTime, endTime]);

      this.Cues.newCue(this[channel], startTime, endTime, screen);
    };

    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.


    TimelineController.prototype.onInitPtsFound = function onInitPtsFound(data) {
      var _this2 = this;

      if (typeof this.initPTS === 'undefined') this.initPTS = data.initPTS;

      // Due to asynchrony, initial PTS may arrive later than the first VTT fragments are loaded.
      // Parse any unparsed fragments upon receiving the initial PTS.
      if (this.unparsedVttFrags.length) {
        this.unparsedVttFrags.forEach(function (frag) {
          _this2.onFragLoaded(frag);
        });
        this.unparsedVttFrags = [];
      }
    };

    TimelineController.prototype.getExistingTrack = function getExistingTrack(channelNumber) {
      var media = this.media;
      if (media) {
        for (var i = 0; i < media.textTracks.length; i++) {
          var textTrack = media.textTracks[i];
          var propName = 'textTrack' + channelNumber;
          if (textTrack[propName] === true) return textTrack;
        }
      }
      return null;
    };

    TimelineController.prototype.createCaptionsTrack = function createCaptionsTrack(track) {
      var trackVar = 'textTrack' + track;
      if (!this[trackVar]) {
        // Enable reuse of existing text track.
        var existingTrack = this.getExistingTrack(track);
        if (!existingTrack) {
          var textTrack = this.createTextTrack('captions', this.config['captionsTextTrack' + track + 'Label'], this.config['captionsTextTrack' + track + 'LanguageCode']);
          if (textTrack) {
            textTrack[trackVar] = true;
            this[trackVar] = textTrack;
          }
        } else {
          this[trackVar] = existingTrack;
          clearCurrentCues(this[trackVar]);

          sendAddTrackEvent(this[trackVar], this.media);
        }
      }
    };

    TimelineController.prototype.createTextTrack = function createTextTrack(kind, label, lang) {
      var media = this.media;
      if (media) return media.addTextTrack(kind, label, lang);
    };

    TimelineController.prototype.destroy = function destroy() {
      event_handler.prototype.destroy.call(this);
    };

    TimelineController.prototype.onMediaAttaching = function onMediaAttaching(data) {
      this.media = data.media;
      this._cleanTracks();
    };

    TimelineController.prototype.onMediaDetaching = function onMediaDetaching() {
      clearCurrentCues(this.textTrack1);
      clearCurrentCues(this.textTrack2);
    };

    TimelineController.prototype.onManifestLoading = function onManifestLoading() {
      this.lastSn = -1; // Detect discontiguity in fragment parsing
      this.prevCC = -1;
      this.vttCCs = { ccOffset: 0, presentationOffset: 0 }; // Detect discontinuity in subtitle manifests
      this._cleanTracks();
    };

    TimelineController.prototype._cleanTracks = function _cleanTracks() {
      // clear outdated subtitles
      var media = this.media;
      if (media) {
        var textTracks = media.textTracks;
        if (textTracks) {
          for (var i = 0; i < textTracks.length; i++) {
            clearCurrentCues(textTracks[i]);
          }
        }
      }
    };

    TimelineController.prototype.onManifestLoaded = function onManifestLoaded(data) {
      var _this3 = this;

      this.textTracks = [];
      this.unparsedVttFrags = this.unparsedVttFrags || [];
      this.initPTS = undefined;
      this.cueRanges = [];

      if (this.config.enableWebVTT) {
        this.tracks = data.subtitles || [];
        var inUseTracks = this.media ? this.media.textTracks : [];

        this.tracks.forEach(function (track, index) {
          var textTrack = void 0;
          if (index < inUseTracks.length) {
            var inUseTrack = inUseTracks[index];
            // Reuse tracks with the same label, but do not reuse 608/708 tracks
            if (reuseVttTextTrack(inUseTrack, track)) textTrack = inUseTrack;
          }
          if (!textTrack) textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);

          if (track.default) textTrack.mode = _this3.hls.subtitleDisplay ? 'showing' : 'hidden';else textTrack.mode = 'disabled';

          _this3.textTracks.push(textTrack);
        });
      }
    };

    TimelineController.prototype.onLevelSwitching = function onLevelSwitching() {
      this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
    };

    TimelineController.prototype.onFragLoaded = function onFragLoaded(data) {
      var frag = data.frag,
          payload = data.payload;
      if (frag.type === 'main') {
        var sn = frag.sn;
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (sn !== this.lastSn + 1) {
          var cea608Parser = this.cea608Parser;
          if (cea608Parser) cea608Parser.reset();
        }
        this.lastSn = sn;
      } // eslint-disable-line brace-style
      // If fragment is subtitle type, parse as WebVTT.
      else if (frag.type === 'subtitle') {
          if (payload.byteLength) {
            // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
            if (typeof this.initPTS === 'undefined') {
              this.unparsedVttFrags.push(data);
              return;
            }

            var decryptData = frag.decryptdata;
            // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
            if (decryptData == null || decryptData.key == null || decryptData.method !== 'AES-128') this._parseVTTs(frag, payload);
          } else {
            // In case there is no payload, finish unsuccessfully.
            this.hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
          }
        }
    };

    TimelineController.prototype._parseVTTs = function _parseVTTs(frag, payload) {
      var vttCCs = this.vttCCs;
      if (!vttCCs[frag.cc]) {
        vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
        this.prevCC = frag.cc;
      }
      var textTracks = this.textTracks,
          hls = this.hls;

      // Parse the WebVTT file contents.
      webvtt_parser.parse(payload, this.initPTS, vttCCs, frag.cc, function (cues) {
        var currentTrack = textTracks[frag.trackId];
        // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
        // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
        // and trying to access getCueById method of cues will throw an exception
        if (currentTrack.mode === 'disabled') {
          hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
          return;
        }
        // Add cues and trigger event with success true.
        cues.forEach(function (cue) {
          // Sometimes there are cue overlaps on segmented vtts so the same
          // cue can appear more than once in different vtt files.
          // This avoid showing duplicated cues with same timecode and text.
          if (!currentTrack.cues.getCueById(cue.id)) {
            try {
              currentTrack.addCue(cue);
            } catch (err) {
              var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
              textTrackCue.id = cue.id;
              currentTrack.addCue(textTrackCue);
            }
          }
        });
        hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
      }, function (e) {
        // Something went wrong while parsing. Trigger event with success false.
        logger["b" /* logger */].log('Failed to parse VTT cue: ' + e);
        hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
      });
    };

    TimelineController.prototype.onFragDecrypted = function onFragDecrypted(data) {
      var decryptedData = data.payload,
          frag = data.frag;

      if (frag.type === 'subtitle') {
        if (typeof this.initPTS === 'undefined') {
          this.unparsedVttFrags.push(data);
          return;
        }

        this._parseVTTs(frag, decryptedData);
      }
    };

    TimelineController.prototype.onFragParsingUserdata = function onFragParsingUserdata(data) {
      // push all of the CEA-708 messages into the interpreter
      // immediately. It will create the proper timestamps based on our PTS value
      if (this.enabled && this.config.enableCEA708Captions) {
        for (var i = 0; i < data.samples.length; i++) {
          var ccdatas = this.extractCea608Data(data.samples[i].bytes);
          this.cea608Parser.addData(data.samples[i].pts, ccdatas);
        }
      }
    };

    TimelineController.prototype.extractCea608Data = function extractCea608Data(byteArray) {
      var count = byteArray[0] & 31;
      var position = 2;
      var tmpByte = void 0,
          ccbyte1 = void 0,
          ccbyte2 = void 0,
          ccValid = void 0,
          ccType = void 0;
      var actualCCBytes = [];

      for (var j = 0; j < count; j++) {
        tmpByte = byteArray[position++];
        ccbyte1 = 0x7F & byteArray[position++];
        ccbyte2 = 0x7F & byteArray[position++];
        ccValid = (4 & tmpByte) !== 0;
        ccType = 3 & tmpByte;

        if (ccbyte1 === 0 && ccbyte2 === 0) continue;

        if (ccValid) {
          if (ccType === 0) {
            // || ccType === 1
            actualCCBytes.push(ccbyte1);
            actualCCBytes.push(ccbyte2);
          }
        }
      }
      return actualCCBytes;
    };

    return TimelineController;
  }(event_handler);

  /* harmony default export */ var timeline_controller = (timeline_controller_TimelineController);
  // CONCATENATED MODULE: ./src/controller/subtitle-track-controller.js
  var subtitle_track_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function subtitle_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function subtitle_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function subtitle_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * subtitle track controller
  */





  function filterSubtitleTracks(textTrackList) {
    var tracks = [];
    for (var i = 0; i < textTrackList.length; i++) {
      if (textTrackList[i].kind === 'subtitles') tracks.push(textTrackList[i]);
    }
    return tracks;
  }

  var subtitle_track_controller_SubtitleTrackController = function (_EventHandler) {
    subtitle_track_controller__inherits(SubtitleTrackController, _EventHandler);

    function SubtitleTrackController(hls) {
      subtitle_track_controller__classCallCheck(this, SubtitleTrackController);

      var _this = subtitle_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].SUBTITLE_TRACK_LOADED));

      _this.tracks = [];
      _this.trackId = -1;
      _this.media = undefined;

      /**
       * @member {boolean} subtitleDisplay Enable/disable subtitle display rendering
       */
      _this.subtitleDisplay = false;
      return _this;
    }

    SubtitleTrackController.prototype._onTextTracksChanged = function _onTextTracksChanged() {
      // Media is undefined when switching streams via loadSource()
      if (!this.media) return;

      var trackId = -1;
      var tracks = filterSubtitleTracks(this.media.textTracks);
      for (var id = 0; id < tracks.length; id++) {
        if (tracks[id].mode === 'hidden') {
          // Do not break in case there is a following track with showing.
          trackId = id;
        } else if (tracks[id].mode === 'showing') {
          trackId = id;
          break;
        }
      }

      // Setting current subtitleTrack will invoke code.
      this.subtitleTrack = trackId;
    };

    SubtitleTrackController.prototype.destroy = function destroy() {
      event_handler.prototype.destroy.call(this);
    };

    // Listen for subtitle track change, then extract the current track ID.


    SubtitleTrackController.prototype.onMediaAttached = function onMediaAttached(data) {
      var _this2 = this;

      this.media = data.media;
      if (!this.media) return;

      if (this.queuedDefaultTrack !== undefined) {
        this.subtitleTrack = this.queuedDefaultTrack;
        delete this.queuedDefaultTrack;
      }

      this.trackChangeListener = this._onTextTracksChanged.bind(this);

      this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
      if (this.useTextTrackPolling) {
        this.subtitlePollingInterval = setInterval(function () {
          _this2.trackChangeListener();
        }, 500);
      } else {
        this.media.textTracks.addEventListener('change', this.trackChangeListener);
      }
    };

    SubtitleTrackController.prototype.onMediaDetaching = function onMediaDetaching() {
      if (!this.media) return;

      if (this.useTextTrackPolling) clearInterval(this.subtitlePollingInterval);else this.media.textTracks.removeEventListener('change', this.trackChangeListener);

      this.media = undefined;
    };

    // Reset subtitle tracks on manifest loading


    SubtitleTrackController.prototype.onManifestLoading = function onManifestLoading() {
      this.tracks = [];
      this.trackId = -1;
    };

    // Fired whenever a new manifest is loaded.


    SubtitleTrackController.prototype.onManifestLoaded = function onManifestLoaded(data) {
      var _this3 = this;

      var tracks = data.subtitles || [];
      this.tracks = tracks;
      this.trackId = -1;
      this.hls.trigger(events["a" /* default */].SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });

      // loop through available subtitle tracks and autoselect default if needed
      // TODO: improve selection logic to handle forced, etc
      tracks.forEach(function (track) {
        if (track.default) {
          // setting this.subtitleTrack will trigger internal logic
          // if media has not been attached yet, it will fail
          // we keep a reference to the default track id
          // and we'll set subtitleTrack when onMediaAttached is triggered
          if (_this3.media) _this3.subtitleTrack = track.id;else _this3.queuedDefaultTrack = track.id;
        }
      });
    };

    // Trigger subtitle track playlist reload.


    SubtitleTrackController.prototype.onTick = function onTick() {
      var trackId = this.trackId;
      var subtitleTrack = this.tracks[trackId];
      if (!subtitleTrack) return;

      var details = subtitleTrack.details;
      // check if we need to load playlist for this subtitle Track
      if (details === undefined || details.live === true) {
        // track not retrieved yet, or live playlist we need to (re)load it
        logger["b" /* logger */].log('(re)loading playlist for subtitle track ' + trackId);
        this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
      }
    };

    SubtitleTrackController.prototype.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(data) {
      var _this4 = this;

      if (data.id < this.tracks.length) {
        logger["b" /* logger */].log('subtitle track ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(function () {
            _this4.onTick();
          }, 1000 * data.details.targetduration, this);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    };

    /** get alternate subtitle tracks list from playlist **/


    SubtitleTrackController.prototype.setSubtitleTrackInternal = function setSubtitleTrackInternal(newId) {
      // check if level idx is valid
      if (newId < -1 || newId >= this.tracks.length) return;

      // stopping live reloading timer if any
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      var textTracks = filterSubtitleTracks(this.media.textTracks);

      // hide currently enabled subtitle track
      if (this.trackId !== -1) textTracks[this.trackId].mode = 'disabled';

      this.trackId = newId;
      logger["b" /* logger */].log('switching to subtitle track ' + newId);
      this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_SWITCH, { id: newId });

      if (newId === -1) return;

      var subtitleTrack = this.tracks[newId];
      if (newId < textTracks.length) textTracks[newId].mode = this.subtitleDisplay ? 'showing' : 'hidden';

      // check if we need to load playlist for this subtitle Track
      var details = subtitleTrack.details;
      if (details === undefined || details.live === true) {
        // track not retrieved yet, or live playlist we need to (re)load it
        logger["b" /* logger */].log('(re)loading playlist for subtitle track ' + newId);
        this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
      }
    };

    subtitle_track_controller__createClass(SubtitleTrackController, [{
      key: 'subtitleTracks',
      get: function get() {
        return this.tracks;
      }

      /** get index of the selected subtitle track (index in subtitle track lists) **/

    }, {
      key: 'subtitleTrack',
      get: function get() {
        return this.trackId;
      }

      /** select a subtitle track, based on its index in subtitle track lists**/
      ,
      set: function set(subtitleTrackId) {
        if (this.trackId !== subtitleTrackId) {
          // || this.tracks[subtitleTrackId].details === undefined) {
          this.setSubtitleTrackInternal(subtitleTrackId);
        }
      }
    }]);

    return SubtitleTrackController;
  }(event_handler);

  /* harmony default export */ var subtitle_track_controller = (subtitle_track_controller_SubtitleTrackController);
  // EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
  var decrypter = __webpack_require__(5);

  // CONCATENATED MODULE: ./src/controller/subtitle-stream-controller.js
  function subtitle_stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function subtitle_stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function subtitle_stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /*
   * Subtitle Stream Controller
  */






  var subtitle_stream_controller_State = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING'
  };

  var subtitle_stream_controller_SubtitleStreamController = function (_TaskLoop) {
    subtitle_stream_controller__inherits(SubtitleStreamController, _TaskLoop);

    function SubtitleStreamController(hls) {
      subtitle_stream_controller__classCallCheck(this, SubtitleStreamController);

      var _this = subtitle_stream_controller__possibleConstructorReturn(this, _TaskLoop.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].ERROR, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].SUBTITLE_TRACKS_UPDATED, events["a" /* default */].SUBTITLE_TRACK_SWITCH, events["a" /* default */].SUBTITLE_TRACK_LOADED, events["a" /* default */].SUBTITLE_FRAG_PROCESSED));

      _this.config = hls.config;
      _this.vttFragSNsProcessed = {};
      _this.vttFragQueues = undefined;
      _this.currentlyProcessing = null;
      _this.state = subtitle_stream_controller_State.STOPPED;
      _this.currentTrackId = -1;
      _this.decrypter = new decrypter["a" /* default */](hls.observer, hls.config);
      return _this;
    }

    SubtitleStreamController.prototype.onHandlerDestroyed = function onHandlerDestroyed() {
      this.state = subtitle_stream_controller_State.STOPPED;
    };

    // Remove all queued items and create a new, empty queue for each track.


    SubtitleStreamController.prototype.clearVttFragQueues = function clearVttFragQueues() {
      var _this2 = this;

      this.vttFragQueues = {};
      this.tracks.forEach(function (track) {
        _this2.vttFragQueues[track.id] = [];
      });
    };

    // If no frag is being processed and queue isn't empty, initiate processing of next frag in line.


    SubtitleStreamController.prototype.nextFrag = function nextFrag() {
      if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
        var frag = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
        this.fragCurrent = frag;
        this.hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
        this.state = subtitle_stream_controller_State.FRAG_LOADING;
      }
    };

    // When fragment has finished processing, add sn to list of completed if successful.


    SubtitleStreamController.prototype.onSubtitleFragProcessed = function onSubtitleFragProcessed(data) {
      if (data.success) this.vttFragSNsProcessed[data.frag.trackId].push(data.frag.sn);

      this.currentlyProcessing = null;
      this.state = subtitle_stream_controller_State.IDLE;
      this.nextFrag();
    };

    SubtitleStreamController.prototype.onMediaAttached = function onMediaAttached() {
      this.state = subtitle_stream_controller_State.IDLE;
    };

    // If something goes wrong, procede to next frag, if we were processing one.


    SubtitleStreamController.prototype.onError = function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to subtitle fragment
      if (frag && frag.type !== 'subtitle') return;

      if (this.currentlyProcessing) {
        this.currentlyProcessing = null;
        this.nextFrag();
      }
    };

    SubtitleStreamController.prototype.doTick = function doTick() {
      var _this3 = this;

      switch (this.state) {
        case subtitle_stream_controller_State.IDLE:
          var tracks = this.tracks;
          var trackId = this.currentTrackId;

          var processedFragSNs = this.vttFragSNsProcessed[trackId],
              fragQueue = this.vttFragQueues[trackId],
              currentFragSN = this.currentlyProcessing ? this.currentlyProcessing.sn : -1;

          var alreadyProcessed = function alreadyProcessed(frag) {
            return processedFragSNs.indexOf(frag.sn) > -1;
          };

          var alreadyInQueue = function alreadyInQueue(frag) {
            return fragQueue.some(function (fragInQueue) {
              return fragInQueue.sn === frag.sn;
            });
          };

          // exit if tracks don't exist
          if (!tracks) break;

          var trackDetails;

          if (trackId < tracks.length) trackDetails = tracks[trackId].details;

          if (typeof trackDetails === 'undefined') break;

          // Add all fragments that haven't been, aren't currently being and aren't waiting to be processed, to queue.
          trackDetails.fragments.forEach(function (frag) {
            if (!(alreadyProcessed(frag) || frag.sn === currentFragSN || alreadyInQueue(frag))) {
              // Load key if subtitles are encrypted
              if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
                logger["b" /* logger */].log('Loading key for ' + frag.sn);
                _this3.state = subtitle_stream_controller_State.KEY_LOADING;
                _this3.hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
              } else {
                // Frags don't know their subtitle track ID, so let's just add that...
                frag.trackId = trackId;
                fragQueue.push(frag);
                _this3.nextFrag();
              }
            }
          });
      }
    };

    // Got all new subtitle tracks.


    SubtitleStreamController.prototype.onSubtitleTracksUpdated = function onSubtitleTracksUpdated(data) {
      var _this4 = this;

      logger["b" /* logger */].log('subtitle tracks updated');
      this.tracks = data.subtitleTracks;
      this.clearVttFragQueues();
      this.vttFragSNsProcessed = {};
      this.tracks.forEach(function (track) {
        _this4.vttFragSNsProcessed[track.id] = [];
      });
    };

    SubtitleStreamController.prototype.onSubtitleTrackSwitch = function onSubtitleTrackSwitch(data) {
      this.currentTrackId = data.id;
      if (this.currentTrackId === -1) return;

      // Check if track was already loaded and if so make sure we finish
      // downloading its frags, if not all have been downloaded yet
      var currentTrack = this.tracks[this.currentTrackId];
      var details = currentTrack.details;
      if (details !== undefined) this.tick();
    };

    // Got a new set of subtitle fragments.


    SubtitleStreamController.prototype.onSubtitleTrackLoaded = function onSubtitleTrackLoaded() {
      this.tick();
    };

    SubtitleStreamController.prototype.onKeyLoaded = function onKeyLoaded() {
      if (this.state === subtitle_stream_controller_State.KEY_LOADING) {
        this.state = subtitle_stream_controller_State.IDLE;
        this.tick();
      }
    };

    SubtitleStreamController.prototype.onFragLoaded = function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          decryptData = data.frag.decryptdata;
      var fragLoaded = data.frag,
          hls = this.hls;
      if (this.state === subtitle_stream_controller_State.FRAG_LOADING && fragCurrent && data.frag.type === 'subtitle' && fragCurrent.sn === data.frag.sn) {
        // check to see if the payload needs to be decrypted
        if (data.payload.byteLength > 0 && decryptData != null && decryptData.key != null && decryptData.method === 'AES-128') {
          var startTime = void 0;
          try {
            startTime = performance.now();
          } catch (error) {
            startTime = Date.now();
          }
          // decrypt the subtitles
          this.decrypter.decrypt(data.payload, decryptData.key.buffer, decryptData.iv.buffer, function (decryptedData) {
            var endTime = void 0;
            try {
              endTime = performance.now();
            } catch (error) {
              endTime = Date.now();
            }
            hls.trigger(events["a" /* default */].FRAG_DECRYPTED, { frag: fragLoaded, payload: decryptedData, stats: { tstart: startTime, tdecrypt: endTime } });
          });
        }
      }
    };

    return SubtitleStreamController;
  }(task_loop);

  /* harmony default export */ var subtitle_stream_controller = (subtitle_stream_controller_SubtitleStreamController);
  // CONCATENATED MODULE: ./src/controller/eme-controller.js
  var eme_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function eme_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function eme_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function eme_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /**
   * @author Stephan Hesse <disparat@gmail.com> | <tchakabam@gmail.com>
   *
   * DRM support for Hls.js
   */







  var MAX_LICENSE_REQUEST_FAILURES = 3;

  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
   */
  var KeySystems = {
    WIDEVINE: 'com.widevine.alpha',
    PLAYREADY: 'com.microsoft.playready'
  };

  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
   * @param {Array<string>} audioCodecs List of required audio codecs to support
   * @param {Array<string>} videoCodecs List of required video codecs to support
   * @param {object} drmSystemOptions Optional parameters/requirements for the key-system
   * @returns {Array<MediaSystemConfiguration>} An array of supported configurations
   */

  var createWidevineMediaKeySystemConfigurations = function createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs, drmSystemOptions) {
    /* jshint ignore:line */
    var baseConfig = {
      // initDataTypes: ['keyids', 'mp4'],
      // label: "",
      // persistentState: "not-allowed", // or "required" ?
      // distinctiveIdentifier: "not-allowed", // or "required" ?
      // sessionTypes: ['temporary'],
      videoCapabilities: [
        // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
      ]
    };

    videoCodecs.forEach(function (codec) {
      baseConfig.videoCapabilities.push({
        contentType: 'video/mp4; codecs="' + codec + '"'
      });
    });

    return [baseConfig];
  };

  /**
   * The idea here is to handle key-system (and their respective platforms) specific configuration differences
   * in order to work with the local requestMediaKeySystemAccess method.
   *
   * We can also rule-out platform-related key-system support at this point by throwing an error or returning null.
   *
   * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
   * @param {Array<string>} audioCodecs List of required audio codecs to support
   * @param {Array<string>} videoCodecs List of required video codecs to support
   * @returns {Array<MediaSystemConfiguration> | null} A non-empty Array of MediaKeySystemConfiguration objects or `null`
   */
  var getSupportedMediaKeySystemConfigurations = function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs) {
    switch (keySystem) {
      case KeySystems.WIDEVINE:
        return createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs);
      default:
        throw Error('Unknown key-system: ' + keySystem);
    }
  };

  /**
   * Controller to deal with encrypted media extensions (EME)
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
   *
   * @class
   * @constructor
   */

  var eme_controller_EMEController = function (_EventHandler) {
    eme_controller__inherits(EMEController, _EventHandler);

    /**
       * @constructs
       * @param {Hls} hls Our Hls.js instance
       */
    function EMEController(hls) {
      eme_controller__classCallCheck(this, EMEController);

      var _this = eme_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MANIFEST_PARSED));

      _this._widevineLicenseUrl = hls.config.widevineLicenseUrl;
      _this._licenseXhrSetup = hls.config.licenseXhrSetup;
      _this._emeEnabled = hls.config.emeEnabled;

      _this._requestMediaKeySystemAccess = hls.config.requestMediaKeySystemAccessFunc;

      _this._mediaKeysList = [];
      _this._media = null;

      _this._hasSetMediaKeys = false;
      _this._isMediaEncrypted = false;

      _this._requestLicenseFailureCount = 0;
      return _this;
    }

    /**
       *
       * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
       * @returns {string} License server URL for key-system (if any configured, otherwise causes error)
       */


    EMEController.prototype.getLicenseServerUrl = function getLicenseServerUrl(keySystem) {
      var url = void 0;
      switch (keySystem) {
        case KeySystems.WIDEVINE:
          url = this._widevineLicenseUrl;
          break;
        default:
          url = null;
          break;
      }

      if (!url) {
        logger["b" /* logger */].error('No license server URL configured for key-system "' + keySystem + '"');
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_LICENSE_REQUEST_FAILED,
          fatal: true
        });
      }

      return url;
    };

    /**
       * Requests access object and adds it to our list upon success
       * @private
       * @param {string} keySystem System ID (see `KeySystems`)
       * @param {Array<string>} audioCodecs List of required audio codecs to support
       * @param {Array<string>} videoCodecs List of required video codecs to support
       */


    EMEController.prototype._attemptKeySystemAccess = function _attemptKeySystemAccess(keySystem, audioCodecs, videoCodecs) {
      var _this2 = this;

      // TODO: add other DRM "options"

      var mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs);

      if (!mediaKeySystemConfigs) {
        logger["b" /* logger */].warn('Can not create config for key-system (maybe because platform is not supported):', keySystem);
        return;
      }

      logger["b" /* logger */].log('Requesting encrypted media key-system access');

      // expecting interface like window.navigator.requestMediaKeySystemAccess
      this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs).then(function (mediaKeySystemAccess) {
        _this2._onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess);
      }).catch(function (err) {
        logger["b" /* logger */].error('Failed to obtain key-system "' + keySystem + '" access:', err);
      });
    };

    /**
       * Handles obtaining access to a key-system
       *
       * @param {string} keySystem
       * @param {MediaKeySystemAccess} mediaKeySystemAccess https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemAccess
       */
    EMEController.prototype._onMediaKeySystemAccessObtained = function _onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess) {
      var _this3 = this;

      logger["b" /* logger */].log('Access for key-system "' + keySystem + '" obtained');

      var mediaKeysListItem = {
        mediaKeys: null,
        mediaKeysSession: null,
        mediaKeysSessionInitialized: false,
        mediaKeySystemAccess: mediaKeySystemAccess,
        mediaKeySystemDomain: keySystem
      };

      this._mediaKeysList.push(mediaKeysListItem);

      mediaKeySystemAccess.createMediaKeys().then(function (mediaKeys) {
        mediaKeysListItem.mediaKeys = mediaKeys;

        logger["b" /* logger */].log('Media-keys created for key-system "' + keySystem + '"');

        _this3._onMediaKeysCreated();
      }).catch(function (err) {
        logger["b" /* logger */].error('Failed to create media-keys:', err);
      });
    };

    /**
       * Handles key-creation (represents access to CDM). We are going to create key-sessions upon this
       * for all existing keys where no session exists yet.
       */


    EMEController.prototype._onMediaKeysCreated = function _onMediaKeysCreated() {
      var _this4 = this;

      // check for all key-list items if a session exists, otherwise, create one
      this._mediaKeysList.forEach(function (mediaKeysListItem) {
        if (!mediaKeysListItem.mediaKeysSession) {
          mediaKeysListItem.mediaKeysSession = mediaKeysListItem.mediaKeys.createSession();
          _this4._onNewMediaKeySession(mediaKeysListItem.mediaKeysSession);
        }
      });
    };

    /**
       *
       * @param {*} keySession
       */


    EMEController.prototype._onNewMediaKeySession = function _onNewMediaKeySession(keySession) {
      var _this5 = this;

      logger["b" /* logger */].log('New key-system session ' + keySession.sessionId);

      keySession.addEventListener('message', function (event) {
        _this5._onKeySessionMessage(keySession, event.message);
      }, false);
    };

    EMEController.prototype._onKeySessionMessage = function _onKeySessionMessage(keySession, message) {
      logger["b" /* logger */].log('Got EME message event, creating license request');

      this._requestLicense(message, function (data) {
        logger["b" /* logger */].log('Received license data, updating key-session');
        keySession.update(data);
      });
    };

    EMEController.prototype._onMediaEncrypted = function _onMediaEncrypted(initDataType, initData) {
      logger["b" /* logger */].log('Media is encrypted using "' + initDataType + '" init data type');

      this._isMediaEncrypted = true;
      this._mediaEncryptionInitDataType = initDataType;
      this._mediaEncryptionInitData = initData;

      this._attemptSetMediaKeys();
      this._generateRequestWithPreferredKeySession();
    };

    EMEController.prototype._attemptSetMediaKeys = function _attemptSetMediaKeys() {
      if (!this._hasSetMediaKeys) {
        // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
        var keysListItem = this._mediaKeysList[0];
        if (!keysListItem || !keysListItem.mediaKeys) {
          logger["b" /* logger */].error('Fatal: Media is encrypted but no CDM access or no keys have been obtained yet');
          this.hls.trigger(events["a" /* default */].ERROR, {
            type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
            details: errors["a" /* ErrorDetails */].KEY_SYSTEM_NO_KEYS,
            fatal: true
          });
          return;
        }

        logger["b" /* logger */].log('Setting keys for encrypted media');

        this._media.setMediaKeys(keysListItem.mediaKeys);
        this._hasSetMediaKeys = true;
      }
    };

    EMEController.prototype._generateRequestWithPreferredKeySession = function _generateRequestWithPreferredKeySession() {
      var _this6 = this;

      // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
      var keysListItem = this._mediaKeysList[0];
      if (!keysListItem) {
        logger["b" /* logger */].error('Fatal: Media is encrypted but not any key-system access has been obtained yet');
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_NO_ACCESS,
          fatal: true
        });
        return;
      }

      if (keysListItem.mediaKeysSessionInitialized) {
        logger["b" /* logger */].warn('Key-Session already initialized but requested again');
        return;
      }

      var keySession = keysListItem.mediaKeysSession;
      if (!keySession) {
        logger["b" /* logger */].error('Fatal: Media is encrypted but no key-session existing');
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_NO_SESSION,
          fatal: true
        });
      }

      var initDataType = this._mediaEncryptionInitDataType;
      var initData = this._mediaEncryptionInitData;

      logger["b" /* logger */].log('Generating key-session request for "' + initDataType + '" init data type');

      keysListItem.mediaKeysSessionInitialized = true;

      keySession.generateRequest(initDataType, initData).then(function () {
        logger["b" /* logger */].debug('Key-session generation succeeded');
      }).catch(function (err) {
        logger["b" /* logger */].error('Error generating key-session request:', err);
        _this6.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_NO_SESSION,
          fatal: false
        });
      });
    };

    /**
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       * @returns {XMLHttpRequest} Unsent (but opened state) XHR object
       */


    EMEController.prototype._createLicenseXhr = function _createLicenseXhr(url, keyMessage, callback) {
      var xhr = new XMLHttpRequest();
      var licenseXhrSetup = this._licenseXhrSetup;

      try {
        if (licenseXhrSetup) {
          try {
            licenseXhrSetup(xhr, url);
          } catch (e) {
            // let's try to open before running setup
            xhr.open('POST', url, true);
            licenseXhrSetup(xhr, url);
          }
        }
        // if licenseXhrSetup did not yet call open, let's do it now
        if (!xhr.readyState) xhr.open('POST', url, true);
      } catch (e) {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        logger["b" /* logger */].error('Error setting up key-system license XHR', e);
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_LICENSE_REQUEST_FAILED,
          fatal: true
        });
        return;
      }

      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, xhr, url, keyMessage, callback);
      return xhr;
    };

    /**
       * @param {XMLHttpRequest} xhr
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       *
       */


    EMEController.prototype._onLicenseRequestReadyStageChange = function _onLicenseRequestReadyStageChange(xhr, url, keyMessage, callback) {
      switch (xhr.readyState) {
        case 4:
          if (xhr.status === 200) {
            this._requestLicenseFailureCount = 0;
            logger["b" /* logger */].log('License request succeeded');
            callback(xhr.response);
          } else {
            logger["b" /* logger */].error('License Request XHR failed (' + url + '). Status: ' + xhr.status + ' (' + xhr.statusText + ')');

            this._requestLicenseFailureCount++;
            if (this._requestLicenseFailureCount <= MAX_LICENSE_REQUEST_FAILURES) {
              var attemptsLeft = MAX_LICENSE_REQUEST_FAILURES - this._requestLicenseFailureCount + 1;
              logger["b" /* logger */].warn('Retrying license request, ' + attemptsLeft + ' attempts left');
              this._requestLicense(keyMessage, callback);
              return;
            }

            this.hls.trigger(events["a" /* default */].ERROR, {
              type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
              details: errors["a" /* ErrorDetails */].KEY_SYSTEM_LICENSE_REQUEST_FAILED,
              fatal: true
            });
          }
          break;
      }
    };

    /**
       * @param {object} keysListItem
       * @param {ArrayBuffer} keyMessage
       * @returns {ArrayBuffer} Challenge data posted to license server
       */


    EMEController.prototype._generateLicenseRequestChallenge = function _generateLicenseRequestChallenge(keysListItem, keyMessage) {
      var challenge = void 0;

      if (keysListItem.mediaKeySystemDomain === KeySystems.PLAYREADY) {
        logger["b" /* logger */].error('PlayReady is not supported (yet)');

        // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
        /*
          if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
              // For PlayReady CDMs, we need to dig the Challenge out of the XML.
              var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
              if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
                  challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
              } else {
                  throw 'Cannot find <Challenge> in key message';
              }
              var headerNames = keyMessageXml.getElementsByTagName('name');
              var headerValues = keyMessageXml.getElementsByTagName('value');
              if (headerNames.length !== headerValues.length) {
                  throw 'Mismatched header <name>/<value> pair in key message';
              }
              for (var i = 0; i < headerNames.length; i++) {
                  xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
              }
          }
          */
      } else if (keysListItem.mediaKeySystemDomain === KeySystems.WIDEVINE) {
        // For Widevine CDMs, the challenge is the keyMessage.
        challenge = keyMessage;
      } else {
        logger["b" /* logger */].error('Unsupported key-system:', keysListItem.mediaKeySystemDomain);
      }

      return challenge;
    };

    EMEController.prototype._requestLicense = function _requestLicense(keyMessage, callback) {
      logger["b" /* logger */].log('Requesting content license for key-system');

      var keysListItem = this._mediaKeysList[0];
      if (!keysListItem) {
        logger["b" /* logger */].error('Fatal error: Media is encrypted but no key-system access has been obtained yet');
        this.hls.trigger(events["a" /* default */].ERROR, {
          type: errors["b" /* ErrorTypes */].KEY_SYSTEM_ERROR,
          details: errors["a" /* ErrorDetails */].KEY_SYSTEM_NO_ACCESS,
          fatal: true
        });
        return;
      }

      var url = this.getLicenseServerUrl(keysListItem.mediaKeySystemDomain);
      var xhr = this._createLicenseXhr(url, keyMessage, callback);

      logger["b" /* logger */].log('Sending license request to URL: ' + url);

      xhr.send(this._generateLicenseRequestChallenge(keysListItem, keyMessage));
    };

    EMEController.prototype.onMediaAttached = function onMediaAttached(data) {
      var _this7 = this;

      if (!this._emeEnabled) return;

      var media = data.media;

      // keep reference of media
      this._media = media;

      // FIXME: also handle detaching media !

      media.addEventListener('encrypted', function (e) {
        _this7._onMediaEncrypted(e.initDataType, e.initData);
      });
    };

    EMEController.prototype.onManifestParsed = function onManifestParsed(data) {
      if (!this._emeEnabled) return;

      var audioCodecs = data.levels.map(function (level) {
        return level.audioCodec;
      });
      var videoCodecs = data.levels.map(function (level) {
        return level.videoCodec;
      });

      this._attemptKeySystemAccess(KeySystems.WIDEVINE, audioCodecs, videoCodecs);
    };

    eme_controller__createClass(EMEController, [{
      key: 'requestMediaKeySystemAccess',
      get: function get() {
        if (!this._requestMediaKeySystemAccess) throw new Error('No requestMediaKeySystemAccess function configured');

        return this._requestMediaKeySystemAccess;
      }
    }]);

    return EMEController;
  }(event_handler);

  /* harmony default export */ var eme_controller = (eme_controller_EMEController);
  // CONCATENATED MODULE: ./src/helper/mediakeys-helper.js
  var requestMediaKeySystemAccess = function () {
    if (window.navigator && window.navigator.requestMediaKeySystemAccess) return window.navigator.requestMediaKeySystemAccess.bind(window.navigator);else return null;
  }();


  // CONCATENATED MODULE: ./src/config.js
  /**
   * HLS config
   */






  // import FetchLoader from './utils/fetch-loader';












  var hlsDefaultConfig = {
    autoStartLoad: true, // used by stream-controller
    startPosition: -1, // used by stream-controller
    defaultAudioCodec: undefined, // used by stream-controller
    debug: false, // used by logger
    capLevelOnFPSDrop: false, // used by fps-controller
    capLevelToPlayerSize: false, // used by cap-level-controller
    initialLiveManifestSize: 1, // used by stream-controller
    maxBufferLength: 30, // used by stream-controller
    maxBufferSize: 60 * 1000 * 1000, // used by stream-controller
    maxBufferHole: 0.5, // used by stream-controller

    lowBufferWatchdogPeriod: 0.5, // used by stream-controller
    highBufferWatchdogPeriod: 3, // used by stream-controller
    nudgeOffset: 0.1, // used by stream-controller
    nudgeMaxRetry: 3, // used by stream-controller
    maxFragLookUpTolerance: 0.25, // used by stream-controller
    liveSyncDurationCount: 3, // used by stream-controller
    liveMaxLatencyDurationCount: Infinity, // used by stream-controller
    liveSyncDuration: undefined, // used by stream-controller
    liveMaxLatencyDuration: undefined, // used by stream-controller
    liveDurationInfinity: false, // used by buffer-controller
    maxMaxBufferLength: 600, // used by stream-controller
    enableWorker: true, // used by demuxer
    enableSoftwareAES: true, // used by decrypter
    manifestLoadingTimeOut: 10000, // used by playlist-loader
    manifestLoadingMaxRetry: 1, // used by playlist-loader
    manifestLoadingRetryDelay: 1000, // used by playlist-loader
    manifestLoadingMaxRetryTimeout: 64000, // used by playlist-loader
    startLevel: undefined, // used by level-controller
    levelLoadingTimeOut: 10000, // used by playlist-loader
    levelLoadingMaxRetry: 4, // used by playlist-loader
    levelLoadingRetryDelay: 1000, // used by playlist-loader
    levelLoadingMaxRetryTimeout: 64000, // used by playlist-loader
    fragLoadingTimeOut: 20000, // used by fragment-loader
    fragLoadingMaxRetry: 6, // used by fragment-loader
    fragLoadingRetryDelay: 1000, // used by fragment-loader
    fragLoadingMaxRetryTimeout: 64000, // used by fragment-loader
    startFragPrefetch: false, // used by stream-controller
    fpsDroppedMonitoringPeriod: 5000, // used by fps-controller
    fpsDroppedMonitoringThreshold: 0.2, // used by fps-controller
    appendErrorMaxRetry: 3, // used by buffer-controller
    loader: xhr_loader,
    // loader: FetchLoader,
    fLoader: undefined, // used by fragment-loader
    pLoader: undefined, // used by playlist-loader
    xhrSetup: undefined, // used by xhr-loader
    licenseXhrSetup: undefined, // used by eme-controller
    // fetchSetup: undefined,
    abrController: abr_controller,
    bufferController: buffer_controller,
    capLevelController: cap_level_controller,
    fpsController: fps_controller,
    stretchShortVideoTrack: false, // used by mp4-remuxer
    maxAudioFramesDrift: 1, // used by mp4-remuxer
    forceKeyFrameOnDiscontinuity: true, // used by ts-demuxer
    abrEwmaFastLive: 3, // used by abr-controller
    abrEwmaSlowLive: 9, // used by abr-controller
    abrEwmaFastVoD: 3, // used by abr-controller
    abrEwmaSlowVoD: 9, // used by abr-controller
    abrEwmaDefaultEstimate: 5e5, // 500 kbps  // used by abr-controller
    abrBandWidthFactor: 0.95, // used by abr-controller
    abrBandWidthUpFactor: 0.7, // used by abr-controller
    abrMaxWithRealBitrate: false, // used by abr-controller
    maxStarvationDelay: 4, // used by abr-controller
    maxLoadingDelay: 4, // used by abr-controller
    minAutoBitrate: 0, // used by hls
    emeEnabled: false, // used by eme-controller
    widevineLicenseUrl: undefined, // used by eme-controller
    requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess // used by eme-controller
  };

  {
    hlsDefaultConfig.subtitleStreamController = subtitle_stream_controller;
    hlsDefaultConfig.subtitleTrackController = subtitle_track_controller;
    hlsDefaultConfig.timelineController = timeline_controller;
    hlsDefaultConfig.cueHandler = cues_namespaceObject; // used by timeline-controller
    hlsDefaultConfig.enableCEA708Captions = true; // used by timeline-controller
    hlsDefaultConfig.enableWebVTT = true; // used by timeline-controller
    hlsDefaultConfig.captionsTextTrack1Label = 'English'; // used by timeline-controller
    hlsDefaultConfig.captionsTextTrack1LanguageCode = 'en'; // used by timeline-controller
    hlsDefaultConfig.captionsTextTrack2Label = 'Spanish'; // used by timeline-controller
    hlsDefaultConfig.captionsTextTrack2LanguageCode = 'es'; // used by timeline-controller
  }

  {
    hlsDefaultConfig.audioStreamController = audio_stream_controller;
    hlsDefaultConfig.audioTrackController = audio_track_controller;
  }

  hlsDefaultConfig.emeController = eme_controller;
  // CONCATENATED MODULE: ./src/hls.js
  var hls__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function hls__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





















  // polyfill for IE11
  __webpack_require__(12);

  /**
   * @module Hls
   * @class
   * @constructor
   */

  var hls_Hls = function () {

    /**
     * @type {boolean}
     */
    Hls.isSupported = function isSupported() {
      return is_supported_isSupported();
    };

    /**
     * @type {HlsEvents}
     */


    hls__createClass(Hls, null, [{
      key: 'version',

      /**
       * @type {string}
       */
      get: function get() {
        return "0.9.1";
      }
    }, {
      key: 'Events',
      get: function get() {
        return events["a" /* default */];
      }

      /**
       * @type {HlsErrorTypes}
       */

    }, {
      key: 'ErrorTypes',
      get: function get() {
        return errors["b" /* ErrorTypes */];
      }

      /**
       * @type {HlsErrorDetails}
       */

    }, {
      key: 'ErrorDetails',
      get: function get() {
        return errors["a" /* ErrorDetails */];
      }

      /**
       * @type {HlsConfig}
       */

    }, {
      key: 'DefaultConfig',
      get: function get() {
        if (!Hls.defaultConfig) return hlsDefaultConfig;

        return Hls.defaultConfig;
      }

      /**
       * @type {HlsConfig}
       */
      ,
      set: function set(defaultConfig) {
        Hls.defaultConfig = defaultConfig;
      }

      /**
       * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
       *
       * @constructs Hls
       * @param {HlsConfig} config
       */

    }]);

    function Hls() {
      var _this = this;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      hls__classCallCheck(this, Hls);

      var defaultConfig = Hls.DefaultConfig;

      if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');

      for (var prop in defaultConfig) {
        if (prop in config) continue;
        config[prop] = defaultConfig[prop];
      }

      if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');

      if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');

      Object(logger["a" /* enableLogs */])(config.debug);
      this.config = config;
      this._autoLevelCapping = -1;
      // observer setup
      var observer = this.observer = new events_default.a();
      observer.trigger = function trigger(event) {
        for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          data[_key - 1] = arguments[_key];
        }

        observer.emit.apply(observer, [event, event].concat(data));
      };

      observer.off = function off(event) {
        for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          data[_key2 - 1] = arguments[_key2];
        }

        observer.removeListener.apply(observer, [event].concat(data));
      };
      this.on = observer.on.bind(observer);
      this.off = observer.off.bind(observer);
      this.trigger = observer.trigger.bind(observer);

      // core controllers and network loaders

      /**
       * @member {AbrController} abrController
       */
      var abrController = this.abrController = new config.abrController(this);

      var bufferController = new config.bufferController(this);
      var capLevelController = new config.capLevelController(this);
      var fpsController = new config.fpsController(this);
      var playListLoader = new playlist_loader(this);
      var fragmentLoader = new fragment_loader(this);
      var keyLoader = new key_loader(this);
      var id3TrackController = new id3_track_controller(this);

      // network controllers

      /**
       * @member {LevelController} levelController
       */
      var levelController = this.levelController = new level_controller(this);

      // FIXME: FragmentTracker must be defined before StreamController because the order of event handling is important
      var fragmentTracker = new fragment_tracker_FragmentTracker(this);

      /**
       * @member {StreamController} streamController
       */
      var streamController = this.streamController = new stream_controller(this, fragmentTracker);

      var networkControllers = [levelController, streamController];

      // optional audio stream controller
      /**
       * @var {ICoreComponent | Controller}
       */
      var Controller = config.audioStreamController;
      if (Controller) networkControllers.push(new Controller(this, fragmentTracker));

      /**
       * @member {INetworkController[]} networkControllers
       */
      this.networkControllers = networkControllers;

      /**
       * @var {ICoreComponent[]}
       */
      var coreComponents = [playListLoader, fragmentLoader, keyLoader, abrController, bufferController, capLevelController, fpsController, id3TrackController, fragmentTracker];

      // optional audio track and subtitle controller
      Controller = config.audioTrackController;
      if (Controller) {
        var audioTrackController = new Controller(this);

        /**
         * @member {AudioTrackController} audioTrackController
         */
        this.audioTrackController = audioTrackController;
        coreComponents.push(audioTrackController);
      }

      Controller = config.subtitleTrackController;
      if (Controller) {
        var subtitleTrackController = new Controller(this);

        /**
         * @member {SubtitleTrackController} subtitleTrackController
         */
        this.subtitleTrackController = subtitleTrackController;
        coreComponents.push(subtitleTrackController);
      }

      Controller = config.emeController;
      if (Controller) {
        var emeController = new Controller(this);

        /**
         * @member {EMEController} emeController
         */
        this.emeController = emeController;
        coreComponents.push(emeController);
      }

      // optional subtitle controller
      [config.subtitleStreamController, config.timelineController].forEach(function (Controller) {
        if (Controller) coreComponents.push(new Controller(_this));
      });

      /**
       * @member {ICoreComponent[]}
       */
      this.coreComponents = coreComponents;
    }

    /**
     * Dispose of the instance
     */


    Hls.prototype.destroy = function destroy() {
      logger["b" /* logger */].log('destroy');
      this.trigger(events["a" /* default */].DESTROYING);
      this.detachMedia();
      this.coreComponents.concat(this.networkControllers).forEach(function (component) {
        component.destroy();
      });
      this.url = null;
      this.observer.removeAllListeners();
      this._autoLevelCapping = -1;
    };

    /**
     * Attach a media element
     * @param {HTMLMediaElement} media
     */


    Hls.prototype.attachMedia = function attachMedia(media) {
      logger["b" /* logger */].log('attachMedia');
      this.media = media;
      this.trigger(events["a" /* default */].MEDIA_ATTACHING, { media: media });
    };

    /**
     * Detach from the media
     */


    Hls.prototype.detachMedia = function detachMedia() {
      logger["b" /* logger */].log('detachMedia');
      this.trigger(events["a" /* default */].MEDIA_DETACHING);
      this.media = null;
    };

    /**
     * Set the source URL. Can be relative or absolute.
     * @param {string} url
     */


    Hls.prototype.loadSource = function loadSource(url) {
      url = url_toolkit_default.a.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
      logger["b" /* logger */].log('loadSource:' + url);
      this.url = url;
      // when attaching to a source URL, trigger a playlist load
      this.trigger(events["a" /* default */].MANIFEST_LOADING, { url: url });
    };

    /**
     * Start loading data from the stream source.
     * Depending on default config, client starts loading automatically when a source is set.
     *
     * @param {number} startPosition Set the start position to stream from
     * @default -1 None (from earliest point)
     */


    Hls.prototype.startLoad = function startLoad() {
      var startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

      logger["b" /* logger */].log('startLoad(' + startPosition + ')');
      this.networkControllers.forEach(function (controller) {
        controller.startLoad(startPosition);
      });
    };

    /**
     * Stop loading of any stream data.
     */


    Hls.prototype.stopLoad = function stopLoad() {
      logger["b" /* logger */].log('stopLoad');
      this.networkControllers.forEach(function (controller) {
        controller.stopLoad();
      });
    };

    /**
     * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
     */


    Hls.prototype.swapAudioCodec = function swapAudioCodec() {
      logger["b" /* logger */].log('swapAudioCodec');
      this.streamController.swapAudioCodec();
    };

    /**
     * When the media-element fails, this allows to detach and then re-attach it
     * as one call (convenience method).
     *
     * Automatic recovery of media-errors by this process is configurable.
     */


    Hls.prototype.recoverMediaError = function recoverMediaError() {
      logger["b" /* logger */].log('recoverMediaError');
      var media = this.media;
      this.detachMedia();
      this.attachMedia(media);
    };

    /**
     * @type {QualityLevel[]}
     */


    hls__createClass(Hls, [{
      key: 'levels',
      get: function get() {
        return this.levelController.levels;
      }

      /**
       * Index of quality level currently played
       * @type {number}
       */

    }, {
      key: 'currentLevel',
      get: function get() {
        return this.streamController.currentLevel;
      }

      /**
       * Set quality level index immediately .
       * This will flush the current buffer to replace the quality asap.
       * That means playback will interrupt at least shortly to re-buffer and re-sync eventually.
       * @type {number} -1 for automatic level selection
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set currentLevel:' + newLevel);
        this.loadLevel = newLevel;
        this.streamController.immediateLevelSwitch();
      }

      /**
       * Index of next quality level loaded as scheduled by stream controller.
       * @type {number}
       */

    }, {
      key: 'nextLevel',
      get: function get() {
        return this.streamController.nextLevel;
      }

      /**
       * Set quality level index for next loaded data.
       * This will switch the video quality asap, without interrupting playback.
       * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
       * @type {number} -1 for automatic level selection
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set nextLevel:' + newLevel);
        this.levelController.manualLevel = newLevel;
        this.streamController.nextLevelSwitch();
      }

      /**
       * Return the quality level of the currently or last (of none is loaded currently) segment
       * @type {number}
       */

    }, {
      key: 'loadLevel',
      get: function get() {
        return this.levelController.level;
      }

      /**
       * Set quality level index for next loaded data in a conservative way.
       * This will switch the quality without flushing, but interrupt current loading.
       * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
       * @type {number} newLevel -1 for automatic level selection
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set loadLevel:' + newLevel);
        this.levelController.manualLevel = newLevel;
      }

      /**
       * get next quality level loaded
       * @type {number}
       */

    }, {
      key: 'nextLoadLevel',
      get: function get() {
        return this.levelController.nextLoadLevel;
      }

      /**
       * Set quality level of next loaded segment in a fully "non-destructive" way.
       * Same as `loadLevel` but will wait for next switch (until current loading is done).
       * @type {number} level
       */
      ,
      set: function set(level) {
        this.levelController.nextLoadLevel = level;
      }

      /**
       * Return "first level": like a default level, if not set,
       * falls back to index of first level referenced in manifest
       * @type {number}
       */

    }, {
      key: 'firstLevel',
      get: function get() {
        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
      }

      /**
       * Sets "first-level", see getter.
       * @type {number}
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set firstLevel:' + newLevel);
        this.levelController.firstLevel = newLevel;
      }

      /**
       * Return start level (level of first fragment that will be played back)
       * if not overrided by user, first level appearing in manifest will be used as start level
       * if -1 : automatic start level selection, playback will start from level matching download bandwidth
       * (determined from download of first segment)
       * @type {number}
       */

    }, {
      key: 'startLevel',
      get: function get() {
        return this.levelController.startLevel;
      }

      /**
       * set  start level (level of first fragment that will be played back)
       * if not overrided by user, first level appearing in manifest will be used as start level
       * if -1 : automatic start level selection, playback will start from level matching download bandwidth
       * (determined from download of first segment)
       * @type {number} newLevel
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set startLevel:' + newLevel);
        var hls = this;
        // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
        if (newLevel !== -1) newLevel = Math.max(newLevel, hls.minAutoLevel);

        hls.levelController.startLevel = newLevel;
      }

      /**
       * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
       * @type {number}
       */

    }, {
      key: 'autoLevelCapping',
      get: function get() {
        return this._autoLevelCapping;
      }

      /**
       * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
       * @type {number}
       */
      ,
      set: function set(newLevel) {
        logger["b" /* logger */].log('set autoLevelCapping:' + newLevel);
        this._autoLevelCapping = newLevel;
      }

      /**
       * True when automatic level selection enabled
       * @type {boolean}
       */

    }, {
      key: 'autoLevelEnabled',
      get: function get() {
        return this.levelController.manualLevel === -1;
      }

      /**
       * Level set manually (if any)
       * @type {number}
       */

    }, {
      key: 'manualLevel',
      get: function get() {
        return this.levelController.manualLevel;
      }

      /**
       * min level selectable in auto mode according to config.minAutoBitrate
       * @type {number}
       */

    }, {
      key: 'minAutoLevel',
      get: function get() {
        var hls = this,
            levels = hls.levels,
            minAutoBitrate = hls.config.minAutoBitrate,
            len = levels ? levels.length : 0;
        for (var i = 0; i < len; i++) {
          var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
          if (levelNextBitrate > minAutoBitrate) return i;
        }
        return 0;
      }

      /**
       * max level selectable in auto mode according to autoLevelCapping
       * @type {number}
       */

    }, {
      key: 'maxAutoLevel',
      get: function get() {
        var hls = this;
        var levels = hls.levels;
        var autoLevelCapping = hls.autoLevelCapping;
        var maxAutoLevel = void 0;
        if (autoLevelCapping === -1 && levels && levels.length) maxAutoLevel = levels.length - 1;else maxAutoLevel = autoLevelCapping;

        return maxAutoLevel;
      }

      /**
       * next automatically selected quality level
       * @type {number}
       */

    }, {
      key: 'nextAutoLevel',
      get: function get() {
        var hls = this;
        // ensure next auto level is between  min and max auto level
        return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
      }

      /**
       * this setter is used to force next auto level.
       * this is useful to force a switch down in auto mode:
       * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
       * forced value is valid for one fragment. upon succesful frag loading at forced level,
       * this value will be resetted to -1 by ABR controller.
       * @type {number}
       */
      ,
      set: function set(nextLevel) {
        var hls = this;
        hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
      }

      /**
       * @type {AudioTrack[]}
       */

    }, {
      key: 'audioTracks',
      get: function get() {
        var audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTracks : [];
      }

      /**
       * index of the selected audio track (index in audio track lists)
       * @type {number}
       */

    }, {
      key: 'audioTrack',
      get: function get() {
        var audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTrack : -1;
      }

      /**
       * selects an audio track, based on its index in audio track lists
       * @type {number}
       */
      ,
      set: function set(audioTrackId) {
        var audioTrackController = this.audioTrackController;
        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
      }

      /**
       * @type {Seconds}
       */

    }, {
      key: 'liveSyncPosition',
      get: function get() {
        return this.streamController.liveSyncPosition;
      }

      /**
       * get alternate subtitle tracks list from playlist
       * @type {SubtitleTrack[]}
       */

    }, {
      key: 'subtitleTracks',
      get: function get() {
        var subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
      }

      /**
       * index of the selected subtitle track (index in subtitle track lists)
       * @type {number}
       */

    }, {
      key: 'subtitleTrack',
      get: function get() {
        var subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
      }

      /**
       * select an subtitle track, based on its index in subtitle track lists
       * @type{number}
       */
      ,
      set: function set(subtitleTrackId) {
        var subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
      }

      /**
       * @type {booelan}
       */

    }, {
      key: 'subtitleDisplay',
      get: function get() {
        var subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
      }

      /**
       * Enable/disable subtitle display rendering
       * @type {boolean}
       */
      ,
      set: function set(value) {
        var subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
      }
    }]);

    return Hls;
  }();

  /* harmony default export */ var src_hls = __webpack_exports__["default"] = (hls_Hls);

  /***/ }),
  /* 10 */
  /***/ (function(module, exports, __webpack_require__) {

  function webpackBootstrapFunc (modules) {
  /******/  // The module cache
  /******/  var installedModules = {};

  /******/  // The require function
  /******/  function __webpack_require__(moduleId) {

  /******/    // Check if module is in cache
  /******/    if(installedModules[moduleId])
  /******/      return installedModules[moduleId].exports;

  /******/    // Create a new module (and put it into the cache)
  /******/    var module = installedModules[moduleId] = {
  /******/      i: moduleId,
  /******/      l: false,
  /******/      exports: {}
  /******/    };

  /******/    // Execute the module function
  /******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

  /******/    // Flag the module as loaded
  /******/    module.l = true;

  /******/    // Return the exports of the module
  /******/    return module.exports;
  /******/  }

  /******/  // expose the modules object (__webpack_modules__)
  /******/  __webpack_require__.m = modules;

  /******/  // expose the module cache
  /******/  __webpack_require__.c = installedModules;

  /******/  // identity function for calling harmony imports with the correct context
  /******/  __webpack_require__.i = function(value) { return value; };

  /******/  // define getter function for harmony exports
  /******/  __webpack_require__.d = function(exports, name, getter) {
  /******/    if(!__webpack_require__.o(exports, name)) {
  /******/      Object.defineProperty(exports, name, {
  /******/        configurable: false,
  /******/        enumerable: true,
  /******/        get: getter
  /******/      });
  /******/    }
  /******/  };

  /******/  // define __esModule on exports
  /******/  __webpack_require__.r = function(exports) {
  /******/    Object.defineProperty(exports, '__esModule', { value: true });
  /******/  };

  /******/  // getDefaultExport function for compatibility with non-harmony modules
  /******/  __webpack_require__.n = function(module) {
  /******/    var getter = module && module.__esModule ?
  /******/      function getDefault() { return module['default']; } :
  /******/      function getModuleExports() { return module; };
  /******/    __webpack_require__.d(getter, 'a', getter);
  /******/    return getter;
  /******/  };

  /******/  // Object.prototype.hasOwnProperty.call
  /******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

  /******/  // __webpack_public_path__
  /******/  __webpack_require__.p = "/";

  /******/  // on error function for async loading
  /******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };

    var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
    return f.default || f // try to call default if defined to also support babel esmodule exports
  }

  var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
  var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)'; // additional chars when output.pathinfo is true

  // http://stackoverflow.com/a/2593661/130442
  function quoteRegExp (str) {
    return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
  }

  function getModuleDependencies (sources, module, queueName) {
    var retval = {};
    retval[queueName] = [];

    var fnString = module.toString();
    var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
    if (!wrapperSignature) return retval
    var webpackRequireName = wrapperSignature[1];

    // main bundle deps
    var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
    var match;
    while ((match = re.exec(fnString))) {
      if (match[3] === 'dll-reference') continue
      retval[queueName].push(match[3]);
    }

    // dll deps
    re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
    while ((match = re.exec(fnString))) {
      if (!sources[match[2]]) {
        retval[queueName].push(match[1]);
        sources[match[2]] = __webpack_require__(match[1]).m;
      }
      retval[match[2]] = retval[match[2]] || [];
      retval[match[2]].push(match[4]);
    }

    return retval
  }

  function hasValuesInQueues (queues) {
    var keys = Object.keys(queues);
    return keys.reduce(function (hasValues, key) {
      return hasValues || queues[key].length > 0
    }, false)
  }

  function getRequiredModules (sources, moduleId) {
    var modulesQueue = {
      main: [moduleId]
    };
    var requiredModules = {
      main: []
    };
    var seenModules = {
      main: {}
    };

    while (hasValuesInQueues(modulesQueue)) {
      var queues = Object.keys(modulesQueue);
      for (var i = 0; i < queues.length; i++) {
        var queueName = queues[i];
        var queue = modulesQueue[queueName];
        var moduleToCheck = queue.pop();
        seenModules[queueName] = seenModules[queueName] || {};
        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
        seenModules[queueName][moduleToCheck] = true;
        requiredModules[queueName] = requiredModules[queueName] || [];
        requiredModules[queueName].push(moduleToCheck);
        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
        var newModulesKeys = Object.keys(newModules);
        for (var j = 0; j < newModulesKeys.length; j++) {
          modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
          modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
        }
      }
    }

    return requiredModules
  }

  module.exports = function (moduleId, options) {
    options = options || {};
    var sources = {
      main: __webpack_require__.m
    };

    var requiredModules = options.all ? { main: Object.keys(sources) } : getRequiredModules(sources, moduleId);

    var src = '';

    Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
      var entryModule = 0;
      while (requiredModules[module][entryModule]) {
        entryModule++;
      }
      requiredModules[module].push(entryModule);
      sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
      src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n';
    });

    src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '})(self);';

    var blob = new window.Blob([src], { type: 'text/javascript' });
    if (options.bare) { return blob }

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var workerUrl = URL.createObjectURL(blob);
    var worker = new window.Worker(workerUrl);
    worker.objectURL = workerUrl;

    return worker
  };


  /***/ }),
  /* 11 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demux_demuxer_inline__ = __webpack_require__(8);
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(1);
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(0);
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_events__ = __webpack_require__(6);
  /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_events__);
  /* demuxer web worker.
   *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
   *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
   */






  var DemuxerWorker = function DemuxerWorker(self) {
    // observer setup
    var observer = new __WEBPACK_IMPORTED_MODULE_3_events___default.a();
    observer.trigger = function trigger(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      observer.emit.apply(observer, [event, event].concat(data));
    };

    observer.off = function off(event) {
      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        data[_key2 - 1] = arguments[_key2];
      }

      observer.removeListener.apply(observer, [event].concat(data));
    };

    var forwardMessage = function forwardMessage(ev, data) {
      self.postMessage({ event: ev, data: data });
    };

    self.addEventListener('message', function (ev) {
      var data = ev.data;
      // console.log('demuxer cmd:' + data.cmd);
      switch (data.cmd) {
        case 'init':
          var config = JSON.parse(data.config);
          self.demuxer = new __WEBPACK_IMPORTED_MODULE_0__demux_demuxer_inline__["a" /* default */](observer, data.typeSupported, config, data.vendor);
          try {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["a" /* enableLogs */])(config.debug === true);
          } catch (err) {
            console.warn('demuxerWorker: unable to enable logs');
          }
          // signal end of worker init
          forwardMessage('init', null);
          break;
        case 'demux':
          self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
          break;
        default:
          break;
      }
    });

    // forward events to main thread
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_DECRYPTED, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSED, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].ERROR, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_METADATA, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].INIT_PTS_FOUND, forwardMessage);

    // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
    observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_DATA, function (ev, data) {
      var transferable = [];
      var message = { event: ev, data: data };
      if (data.data1) {
        message.data1 = data.data1.buffer;
        transferable.push(data.data1.buffer);
        delete data.data1;
      }
      if (data.data2) {
        message.data2 = data.data2.buffer;
        transferable.push(data.data2.buffer);
        delete data.data2;
      }
      self.postMessage(message, transferable);
    });
  };

  /* harmony default export */ __webpack_exports__["default"] = (DemuxerWorker);

  /***/ }),
  /* 12 */
  /***/ (function(module, exports) {

  /*! http://mths.be/endswith v0.2.0 by @mathias */
  if (!String.prototype.endsWith) {
  	(function() {
  		var defineProperty = (function() {
  			// IE 8 only supports `Object.defineProperty` on DOM elements
  			try {
  				var object = {};
  				var $defineProperty = Object.defineProperty;
  				var result = $defineProperty(object, object, object) && $defineProperty;
  			} catch(error) {}
  			return result;
  		}());
  		var toString = {}.toString;
  		var endsWith = function(search) {
  			if (this == null) {
  				throw TypeError();
  			}
  			var string = String(this);
  			if (search && toString.call(search) == '[object RegExp]') {
  				throw TypeError();
  			}
  			var stringLength = string.length;
  			var searchString = String(search);
  			var searchLength = searchString.length;
  			var pos = stringLength;
  			if (arguments.length > 1) {
  				var position = arguments[1];
  				if (position !== undefined) {
  					// `ToInteger`
  					pos = position ? Number(position) : 0;
  					if (pos != pos) { // better `isNaN`
  						pos = 0;
  					}
  				}
  			}
  			var end = Math.min(Math.max(pos, 0), stringLength);
  			var start = end - searchLength;
  			if (start < 0) {
  				return false;
  			}
  			var index = -1;
  			while (++index < searchLength) {
  				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
  					return false;
  				}
  			}
  			return true;
  		};
  		if (defineProperty) {
  			defineProperty(String.prototype, 'endsWith', {
  				'value': endsWith,
  				'configurable': true,
  				'writable': true
  			});
  		} else {
  			String.prototype.endsWith = endsWith;
  		}
  	}());
  }


  /***/ })
  /******/ ])["default"];
  });

  });

  var HlsCore = unwrapExports(hls);

  var defaultCustomConfig = {
    debug: false,
    enableWorker: true
  };

  var _class$c;

  function _applyDecoratedDescriptor$9(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  var LOG_TAG$1 = 'chimee-kernel-hls';

  var Hls = (_class$c = function (_CustEvent) {
    _inherits$1(Hls, _CustEvent);

    _createClass(Hls, null, [{
      key: 'isSupport',
      value: function isSupport() {
        return HlsCore.isSupported();
      }
    }]);

    function Hls(videoElement, config) {
      var customConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck$1(this, Hls);

      var _this = _possibleConstructorReturn$1(this, (Hls.__proto__ || _Object$getPrototypeOf(Hls)).call(this));

      _this.version = '1.3.2';

      if (!isElement(videoElement)) throw new Error('video element passed in ' + LOG_TAG$1 + ' must be a HTMLVideoElement, but not ' + (typeof videoElement === 'undefined' ? 'undefined' : _typeof(videoElement)));
      if (!isObject(config)) throw new Error('config of ' + LOG_TAG$1 + ' must be an Object but not ' + (typeof config === 'undefined' ? 'undefined' : _typeof(config)));
      _this.video = videoElement;
      _this.config = config;
      _this.customConfig = deepAssign({}, defaultCustomConfig, customConfig);
      _this.hlsKernel = new HlsCore(_this.customConfig);
      _this.bindEvents();
      _this.attachMedia();
      return _this;
    }

    _createClass(Hls, [{
      key: 'bindEvents',
      value: function bindEvents() {
        var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var hlsKernel = this.hlsKernel;
        /* istanbul ignore else */
        if (hlsKernel) {
          hlsKernel[remove ? 'off' : 'on'](HlsCore.Events.ERROR, this.hlsErrorHandler);
        }
      }
    }, {
      key: 'load',
      value: function load() {
        return this.hlsKernel.loadSource(this.config.src);
      }
    }, {
      key: 'startLoad',
      value: function startLoad() {
        return this.hlsKernel.startLoad();
      }
    }, {
      key: 'stopLoad',
      value: function stopLoad() {
        return this.hlsKernel.stopLoad();
      }
    }, {
      key: 'attachMedia',
      value: function attachMedia() {
        return this.hlsKernel.attachMedia(this.video);
      }
    }, {
      key: 'play',
      value: function play() {
        return this.video.play();
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        this.bindEvents(true);
        return this.hlsKernel.destroy();
      }
    }, {
      key: 'seek',
      value: function seek(seconds) {
        this.video.currentTime = seconds;
      }
    }, {
      key: 'pause',
      value: function pause() {
        return this.video.pause();
      }
    }, {
      key: 'refresh',
      value: function refresh() {
        this.hlsKernel.stopLoad();
        return this.hlsKernel.loadSource(this.config.src);
      }
    }, {
      key: 'hlsErrorHandler',
      value: function hlsErrorHandler(event, data) {
        this.emit('error', data);
        this.emit(event, data);
        /* istanbul ignore next */
        Log$1.error(LOG_TAG$1 + (event ? ' ' + event : ''), data.details);
      }
    }]);

    return Hls;
  }(CustEvent), (_applyDecoratedDescriptor$9(_class$c.prototype, 'hlsErrorHandler', [autobind], _Object$getOwnPropertyDescriptor(_class$c.prototype, 'hlsErrorHandler'), _class$c.prototype)), _class$c);

  var lib = createCommonjsModule(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
  	module.exports = factory();
  })(typeof self !== 'undefined' ? self : commonjsGlobal, function() {
  return /******/ (function(modules) { // webpackBootstrap
  /******/ 	// The module cache
  /******/ 	var installedModules = {};
  /******/
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
  /******/
  /******/ 		// Check if module is in cache
  /******/ 		if(installedModules[moduleId]) {
  /******/ 			return installedModules[moduleId].exports;
  /******/ 		}
  /******/ 		// Create a new module (and put it into the cache)
  /******/ 		var module = installedModules[moduleId] = {
  /******/ 			i: moduleId,
  /******/ 			l: false,
  /******/ 			exports: {}
  /******/ 		};
  /******/
  /******/ 		// Execute the module function
  /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
  /******/
  /******/ 		// Flag the module as loaded
  /******/ 		module.l = true;
  /******/
  /******/ 		// Return the exports of the module
  /******/ 		return module.exports;
  /******/ 	}
  /******/
  /******/
  /******/ 	// expose the modules object (__webpack_modules__)
  /******/ 	__webpack_require__.m = modules;
  /******/
  /******/ 	// expose the module cache
  /******/ 	__webpack_require__.c = installedModules;
  /******/
  /******/ 	// define getter function for harmony exports
  /******/ 	__webpack_require__.d = function(exports, name, getter) {
  /******/ 		if(!__webpack_require__.o(exports, name)) {
  /******/ 			Object.defineProperty(exports, name, {
  /******/ 				configurable: false,
  /******/ 				enumerable: true,
  /******/ 				get: getter
  /******/ 			});
  /******/ 		}
  /******/ 	};
  /******/
  /******/ 	// getDefaultExport function for compatibility with non-harmony modules
  /******/ 	__webpack_require__.n = function(module) {
  /******/ 		var getter = module && module.__esModule ?
  /******/ 			function getDefault() { return module['default']; } :
  /******/ 			function getModuleExports() { return module; };
  /******/ 		__webpack_require__.d(getter, 'a', getter);
  /******/ 		return getter;
  /******/ 	};
  /******/
  /******/ 	// Object.prototype.hasOwnProperty.call
  /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
  /******/
  /******/ 	// __webpack_public_path__
  /******/ 	__webpack_require__.p = "";
  /******/
  /******/ 	// Load entry module and return exports
  /******/ 	return __webpack_require__(__webpack_require__.s = 12);
  /******/ })
  /************************************************************************/
  /******/ ([
  /* 0 */
  /***/ (function(module, exports, __webpack_require__) {


  /**
   * chimee-helper-events v0.1.0
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  (function (global, factory) {
  	 factory(exports);
  }(this, (function (exports) {
  function unwrapExports$$1 (x) {
  	return x && x.__esModule ? x['default'] : x;
  }

  function createCommonjsModule$$1(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  // 7.1.4 ToInteger
  var ceil  = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function(it){
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function(it){
    if(it == undefined)throw TypeError("Can't call method on  " + it);
    return it;
  };

  // true  -> String#at
  // false -> String#codePointAt
  var _stringAt = function(TO_STRING){
    return function(that, pos){
      var s = String(_defined(that))
        , i = _toInteger(pos)
        , l = s.length
        , a, b;
      if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
        ? TO_STRING ? s.charAt(i) : a
        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

  var _library = true;

  var _global = createCommonjsModule$$1(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
  if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule$$1(function (module) {
  var core = module.exports = {version: '2.4.0'};
  if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
  });

  var _aFunction = function(it){
    if(typeof it != 'function')throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function(fn, that, length){
    _aFunction(fn);
    if(that === undefined)return fn;
    switch(length){
      case 1: return function(a){
        return fn.call(that, a);
      };
      case 2: return function(a, b){
        return fn.call(that, a, b);
      };
      case 3: return function(a, b, c){
        return fn.call(that, a, b, c);
      };
    }
    return function(/* ...args */){
      return fn.apply(that, arguments);
    };
  };

  var _isObject = function(it){
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function(it){
    if(!_isObject(it))throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function(exec){
    try {
      return !!exec();
    } catch(e){
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function(){
    return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
  });

  var document$1 = _global.document;
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function(it){
    return is ? document$1.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function(){
    return Object.defineProperty(_domCreate('div'), 'a', {get: function(){ return 7; }}).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function(it, S){
    if(!_isObject(it))return it;
    var fn, val;
    if(S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it)))return val;
    if(typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it)))return val;
    if(!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it)))return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP             = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes){
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if(_ie8DomDefine)try {
      return dP(O, P, Attributes);
    } catch(e){ /* empty */ }
    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
    if('value' in Attributes)O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function(bitmap, value){
    return {
      enumerable  : !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable    : !(bitmap & 4),
      value       : value
    };
  };

  var _hide = _descriptors ? function(object, key, value){
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function(object, key, value){
    object[key] = value;
    return object;
  };

  var PROTOTYPE = 'prototype';

  var $export = function(type, name, source){
    var IS_FORCED = type & $export.F
      , IS_GLOBAL = type & $export.G
      , IS_STATIC = type & $export.S
      , IS_PROTO  = type & $export.P
      , IS_BIND   = type & $export.B
      , IS_WRAP   = type & $export.W
      , exports   = IS_GLOBAL ? _core : _core[name] || (_core[name] = {})
      , expProto  = exports[PROTOTYPE]
      , target    = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE]
      , key, own, out;
    if(IS_GLOBAL)source = name;
    for(key in source){
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if(own && key in exports)continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? _ctx(out, _global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? (function(C){
        var F = function(a, b, c){
          if(this instanceof C){
            switch(arguments.length){
              case 0: return new C;
              case 1: return new C(a);
              case 2: return new C(a, b);
            } return new C(a, b, c);
          } return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      // make static versions for prototype methods
      })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if(IS_PROTO){
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if(type & $export.R && expProto && !expProto[key])_hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library` 
  var _export = $export;

  var _redefine = _hide;

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function(it, key){
    return hasOwnProperty.call(it, key);
  };

  var toString = {}.toString;

  var _cof = function(it){
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function(it){
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings

  var _toIobject = function(it){
    return _iobject(_defined(it));
  };

  // 7.1.15 ToLength
  var min       = Math.min;
  var _toLength = function(it){
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max       = Math.max;
  var min$1       = Math.min;
  var _toIndex = function(index, length){
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes

  var _arrayIncludes = function(IS_INCLUDES){
    return function($this, el, fromIndex){
      var O      = _toIobject($this)
        , length = _toLength(O.length)
        , index  = _toIndex(fromIndex, length)
        , value;
      // Array#includes uses SameValueZero equality algorithm
      if(IS_INCLUDES && el != el)while(length > index){
        value = O[index++];
        if(value != value)return true;
      // Array#toIndex ignores holes, Array#includes - not
      } else for(;length > index; index++)if(IS_INCLUDES || index in O){
        if(O[index] === el)return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var SHARED = '__core-js_shared__';
  var store  = _global[SHARED] || (_global[SHARED] = {});
  var _shared = function(key){
    return store[key] || (store[key] = {});
  };

  var id = 0;
  var px = Math.random();
  var _uid = function(key){
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var shared = _shared('keys');
  var _sharedKey = function(key){
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO$1     = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function(object, names){
    var O      = _toIobject(object)
      , i      = 0
      , result = []
      , key;
    for(key in O)if(key != IE_PROTO$1)_has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if(_has(O, key = names[i++])){
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)


  var _objectKeys = Object.keys || function keys(O){
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties){
    _anObject(O);
    var keys   = _objectKeys(Properties)
      , length = keys.length
      , i = 0
      , P;
    while(length > i)_objectDp.f(O, P = keys[i++], Properties[P]);
    return O;
  };

  var _html = _global.document && document.documentElement;

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var IE_PROTO    = _sharedKey('IE_PROTO');
  var Empty       = function(){ /* empty */ };
  var PROTOTYPE$1   = 'prototype';

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function(){
    // Thrash, waste and sodomy: IE GC bug
    var iframe = _domCreate('iframe')
      , i      = _enumBugKeys.length
      , lt     = '<'
      , gt     = '>'
      , iframeDocument;
    iframe.style.display = 'none';
    _html.appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while(i--)delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
    return createDict();
  };

  var _objectCreate = Object.create || function create(O, Properties){
    var result;
    if(O !== null){
      Empty[PROTOTYPE$1] = _anObject(O);
      result = new Empty;
      Empty[PROTOTYPE$1] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : _objectDps(result, Properties);
  };

  var _wks = createCommonjsModule$$1(function (module) {
  var store      = _shared('wks')
    , Symbol     = _global.Symbol
    , USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function(name){
    return store[name] || (store[name] =
      USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
  });

  var def = _objectDp.f;
  var TAG = _wks('toStringTag');

  var _setToStringTag = function(it, tag, stat){
    if(it && !_has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
  };

  var IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  _hide(IteratorPrototype, _wks('iterator'), function(){ return this; });

  var _iterCreate = function(Constructor, NAME, next){
    Constructor.prototype = _objectCreate(IteratorPrototype, {next: _propertyDesc(1, next)});
    _setToStringTag(Constructor, NAME + ' Iterator');
  };

  // 7.1.13 ToObject(argument)

  var _toObject = function(it){
    return Object(_defined(it));
  };

  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var IE_PROTO$2    = _sharedKey('IE_PROTO');
  var ObjectProto = Object.prototype;

  var _objectGpo = Object.getPrototypeOf || function(O){
    O = _toObject(O);
    if(_has(O, IE_PROTO$2))return O[IE_PROTO$2];
    if(typeof O.constructor == 'function' && O instanceof O.constructor){
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectProto : null;
  };

  var ITERATOR       = _wks('iterator');
  var BUGGY          = !([].keys && 'next' in [].keys());
  var FF_ITERATOR    = '@@iterator';
  var KEYS           = 'keys';
  var VALUES         = 'values';

  var _iterDefine = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
    _iterCreate(Constructor, NAME, next);
    var getMethod = function(kind){
      if(!BUGGY && kind in proto)return proto[kind];
      switch(kind){
        case KEYS: return function keys(){ return new Constructor(this, kind); };
        case VALUES: return function values(){ return new Constructor(this, kind); };
      } return function entries(){ return new Constructor(this, kind); };
    };
    var TAG        = NAME + ' Iterator'
      , DEF_VALUES = DEFAULT == VALUES
      , VALUES_BUG = false
      , proto      = Base.prototype
      , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
      , $default   = $native || getMethod(DEFAULT)
      , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
      , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
      , methods, key, IteratorPrototype;
    // Fix native
    if($anyNative){
      IteratorPrototype = _objectGpo($anyNative.call(new Base));
      if(IteratorPrototype !== Object.prototype){
        // Set @@toStringTag to native iterators
        _setToStringTag(IteratorPrototype, TAG, true);
      }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
    // Define iterator
    if((FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
      _hide(proto, ITERATOR, $default);
    }
    if(DEFAULT){
      methods = {
        values:  DEF_VALUES ? $default : getMethod(VALUES),
        keys:    IS_SET     ? $default : getMethod(KEYS),
        entries: $entries
      };
      if(FORCED)for(key in methods){
        if(!(key in proto))_redefine(proto, key, methods[key]);
      } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

  var $at  = _stringAt(true);

  // 21.1.3.27 String.prototype[@@iterator]()
  _iterDefine(String, 'String', function(iterated){
    this._t = String(iterated); // target
    this._i = 0;                // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , index = this._i
      , point;
    if(index >= O.length)return {value: undefined, done: true};
    point = $at(O, index);
    this._i += point.length;
    return {value: point, done: false};
  });

  var _iterStep = function(done, value){
    return {value: value, done: !!done};
  };

  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  var es6_array_iterator = _iterDefine(Array, 'Array', function(iterated, kind){
    this._t = _toIobject(iterated); // target
    this._i = 0;                   // next index
    this._k = kind;                // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , kind  = this._k
      , index = this._i++;
    if(!O || index >= O.length){
      this._t = undefined;
      return _iterStep(1);
    }
    if(kind == 'keys'  )return _iterStep(0, index);
    if(kind == 'values')return _iterStep(0, O[index]);
    return _iterStep(0, [index, O[index]]);
  }, 'values');

  var TO_STRING_TAG = _wks('toStringTag');

  for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
    var NAME       = collections[i]
      , Collection = _global[NAME]
      , proto      = Collection && Collection.prototype;
    if(proto && !proto[TO_STRING_TAG])_hide(proto, TO_STRING_TAG, NAME);
  }

  var f$1 = _wks;

  var _wksExt = {
  	f: f$1
  };

  var iterator$2 = _wksExt.f('iterator');

  var iterator = createCommonjsModule$$1(function (module) {
  module.exports = { "default": iterator$2, __esModule: true };
  });

  var _meta = createCommonjsModule$$1(function (module) {
  var META     = _uid('meta')
    , setDesc  = _objectDp.f
    , id       = 0;
  var isExtensible = Object.isExtensible || function(){
    return true;
  };
  var FREEZE = !_fails(function(){
    return isExtensible(Object.preventExtensions({}));
  });
  var setMeta = function(it){
    setDesc(it, META, {value: {
      i: 'O' + ++id, // object ID
      w: {}          // weak collections IDs
    }});
  };
  var fastKey = function(it, create){
    // return primitive with prefix
    if(!_isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if(!_has(it, META)){
      // can't set metadata to uncaught frozen object
      if(!isExtensible(it))return 'F';
      // not necessary to add metadata
      if(!create)return 'E';
      // add missing metadata
      setMeta(it);
    // return object ID
    } return it[META].i;
  };
  var getWeak = function(it, create){
    if(!_has(it, META)){
      // can't set metadata to uncaught frozen object
      if(!isExtensible(it))return true;
      // not necessary to add metadata
      if(!create)return false;
      // add missing metadata
      setMeta(it);
    // return hash weak collections IDs
    } return it[META].w;
  };
  // add metadata on freeze-family methods calling
  var onFreeze = function(it){
    if(FREEZE && meta.NEED && isExtensible(it) && !_has(it, META))setMeta(it);
    return it;
  };
  var meta = module.exports = {
    KEY:      META,
    NEED:     false,
    fastKey:  fastKey,
    getWeak:  getWeak,
    onFreeze: onFreeze
  };
  });

  var defineProperty = _objectDp.f;
  var _wksDefine = function(name){
    var $Symbol = _core.Symbol || (_core.Symbol = {});
    if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: _wksExt.f(name)});
  };

  var _keyof = function(object, el){
    var O      = _toIobject(object)
      , keys   = _objectKeys(O)
      , length = keys.length
      , index  = 0
      , key;
    while(length > index)if(O[key = keys[index++]] === el)return key;
  };

  var f$2 = Object.getOwnPropertySymbols;

  var _objectGops = {
  	f: f$2
  };

  var f$3 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$3
  };

  // all enumerable object keys, includes symbols

  var _enumKeys = function(it){
    var result     = _objectKeys(it)
      , getSymbols = _objectGops.f;
    if(getSymbols){
      var symbols = getSymbols(it)
        , isEnum  = _objectPie.f
        , i       = 0
        , key;
      while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
    } return result;
  };

  // 7.2.2 IsArray(argument)

  var _isArray = Array.isArray || function isArray(arg){
    return _cof(arg) == 'Array';
  };

  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

  var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
    return _objectKeysInternal(O, hiddenKeys);
  };

  var _objectGopn = {
  	f: f$5
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var gOPN$1      = _objectGopn.f;
  var toString$1  = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function(it){
    try {
      return gOPN$1(it);
    } catch(e){
      return windowNames.slice();
    }
  };

  var f$4 = function getOwnPropertyNames(it){
    return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject(it));
  };

  var _objectGopnExt = {
  	f: f$4
  };

  var gOPD$1           = Object.getOwnPropertyDescriptor;

  var f$6 = _descriptors ? gOPD$1 : function getOwnPropertyDescriptor(O, P){
    O = _toIobject(O);
    P = _toPrimitive(P, true);
    if(_ie8DomDefine)try {
      return gOPD$1(O, P);
    } catch(e){ /* empty */ }
    if(_has(O, P))return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
  };

  var _objectGopd = {
  	f: f$6
  };

  // ECMAScript 6 symbols shim
  var META           = _meta.KEY;
  var gOPD           = _objectGopd.f;
  var dP$1             = _objectDp.f;
  var gOPN           = _objectGopnExt.f;
  var $Symbol        = _global.Symbol;
  var $JSON          = _global.JSON;
  var _stringify     = $JSON && $JSON.stringify;
  var PROTOTYPE$2      = 'prototype';
  var HIDDEN         = _wks('_hidden');
  var TO_PRIMITIVE   = _wks('toPrimitive');
  var isEnum         = {}.propertyIsEnumerable;
  var SymbolRegistry = _shared('symbol-registry');
  var AllSymbols     = _shared('symbols');
  var OPSymbols      = _shared('op-symbols');
  var ObjectProto$1    = Object[PROTOTYPE$2];
  var USE_NATIVE     = typeof $Symbol == 'function';
  var QObject        = _global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = _descriptors && _fails(function(){
    return _objectCreate(dP$1({}, 'a', {
      get: function(){ return dP$1(this, 'a', {value: 7}).a; }
    })).a != 7;
  }) ? function(it, key, D){
    var protoDesc = gOPD(ObjectProto$1, key);
    if(protoDesc)delete ObjectProto$1[key];
    dP$1(it, key, D);
    if(protoDesc && it !== ObjectProto$1)dP$1(ObjectProto$1, key, protoDesc);
  } : dP$1;

  var wrap = function(tag){
    var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
    return typeof it == 'symbol';
  } : function(it){
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D){
    if(it === ObjectProto$1)$defineProperty(OPSymbols, key, D);
    _anObject(it);
    key = _toPrimitive(key, true);
    _anObject(D);
    if(_has(AllSymbols, key)){
      if(!D.enumerable){
        if(!_has(it, HIDDEN))dP$1(it, HIDDEN, _propertyDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if(_has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
        D = _objectCreate(D, {enumerable: _propertyDesc(0, false)});
      } return setSymbolDesc(it, key, D);
    } return dP$1(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P){
    _anObject(it);
    var keys = _enumKeys(P = _toIobject(P))
      , i    = 0
      , l = keys.length
      , key;
    while(l > i)$defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P){
    return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key){
    var E = isEnum.call(this, key = _toPrimitive(key, true));
    if(this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key))return false;
    return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
    it  = _toIobject(it);
    key = _toPrimitive(key, true);
    if(it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key))return;
    var D = gOPD(it, key);
    if(D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it){
    var names  = gOPN(_toIobject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i){
      if(!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
    } return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
    var IS_OP  = it === ObjectProto$1
      , names  = gOPN(IS_OP ? OPSymbols : _toIobject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i){
      if(_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true))result.push(AllSymbols[key]);
    } return result;
  };

  // 19.4.1.1 Symbol([description])
  if(!USE_NATIVE){
    $Symbol = function Symbol(){
      if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
      var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function(value){
        if(this === ObjectProto$1)$set.call(OPSymbols, value);
        if(_has(this, HIDDEN) && _has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, _propertyDesc(1, value));
      };
      if(_descriptors && setter)setSymbolDesc(ObjectProto$1, tag, {configurable: true, set: $set});
      return wrap(tag);
    };
    _redefine($Symbol[PROTOTYPE$2], 'toString', function toString(){
      return this._k;
    });

    _objectGopd.f = $getOwnPropertyDescriptor;
    _objectDp.f   = $defineProperty;
    _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
    _objectPie.f  = $propertyIsEnumerable;
    _objectGops.f = $getOwnPropertySymbols;

    if(_descriptors && !_library){
      _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    _wksExt.f = function(name){
      return wrap(_wks(name));
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE, {Symbol: $Symbol});

  for(var symbols = (
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
  ).split(','), i$1 = 0; symbols.length > i$1; )_wks(symbols[i$1++]);

  for(var symbols = _objectKeys(_wks.store), i$1 = 0; symbols.length > i$1; )_wksDefine(symbols[i$1++]);

  _export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key){
      return _has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(key){
      if(isSymbol(key))return _keyof(SymbolRegistry, key);
      throw TypeError(key + ' is not a symbol!');
    },
    useSetter: function(){ setter = true; },
    useSimple: function(){ setter = false; }
  });

  _export(_export.S + _export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function(){
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it){
      if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
      var args = [it]
        , i    = 1
        , replacer, $replacer;
      while(arguments.length > i)args.push(arguments[i++]);
      replacer = args[1];
      if(typeof replacer == 'function')$replacer = replacer;
      if($replacer || !_isArray(replacer))replacer = function(key, value){
        if($replacer)value = $replacer.call(this, key, value);
        if(!isSymbol(value))return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });

  // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
  $Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  _setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  _setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  _setToStringTag(_global.JSON, 'JSON', true);

  _wksDefine('asyncIterator');

  _wksDefine('observable');

  var index = _core.Symbol;

  var symbol = createCommonjsModule$$1(function (module) {
  module.exports = { "default": index, __esModule: true };
  });

  var _typeof_1 = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;



  var _iterator2 = _interopRequireDefault(iterator);



  var _symbol2 = _interopRequireDefault(symbol);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  });

  var _typeof = unwrapExports$$1(_typeof_1);

  var classCallCheck = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  });

  var _classCallCheck = unwrapExports$$1(classCallCheck);

  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  _export(_export.S + _export.F * !_descriptors, 'Object', {defineProperty: _objectDp.f});

  var $Object = _core.Object;
  var defineProperty$3 = function defineProperty(it, key, desc){
    return $Object.defineProperty(it, key, desc);
  };

  var defineProperty$1 = createCommonjsModule$$1(function (module) {
  module.exports = { "default": defineProperty$3, __esModule: true };
  });

  var createClass = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;



  var _defineProperty2 = _interopRequireDefault(defineProperty$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  });

  var _createClass = unwrapExports$$1(createClass);

  // 19.1.2.1 Object.assign(target, source, ...)
  var $assign  = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  var _objectAssign = !$assign || _fails(function(){
    var A = {}
      , B = {}
      , S = Symbol()
      , K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k){ B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source){ // eslint-disable-line no-unused-vars
    var T     = _toObject(target)
      , aLen  = arguments.length
      , index = 1
      , getSymbols = _objectGops.f
      , isEnum     = _objectPie.f;
    while(aLen > index){
      var S      = _iobject(arguments[index++])
        , keys   = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S)
        , length = keys.length
        , j      = 0
        , key;
      while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
    } return T;
  } : $assign;

  // 19.1.3.1 Object.assign(target, source)


  _export(_export.S + _export.F, 'Object', {assign: _objectAssign});

  var assign$1 = _core.Object.assign;

  var assign = createCommonjsModule$$1(function (module) {
  module.exports = { "default": assign$1, __esModule: true };
  });

  var _Object$assign = unwrapExports$$1(assign);

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  _export(_export.S, 'Object', {create: _objectCreate});

  var $Object$1 = _core.Object;
  var create$1 = function create(P, D){
    return $Object$1.create(P, D);
  };

  var create = createCommonjsModule$$1(function (module) {
  module.exports = { "default": create$1, __esModule: true };
  });

  var _Object$create = unwrapExports$$1(create);

  // most Object methods by ES6 should accept primitives

  var _objectSap = function(KEY, exec){
    var fn  = (_core.Object || {})[KEY] || Object[KEY]
      , exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function(){ fn(1); }), 'Object', exp);
  };

  // 19.1.2.14 Object.keys(O)


  _objectSap('keys', function(){
    return function keys(it){
      return _objectKeys(_toObject(it));
    };
  });

  var keys$1 = _core.Object.keys;

  var keys = createCommonjsModule$$1(function (module) {
  module.exports = { "default": keys$1, __esModule: true };
  });

  // 20.1.2.3 Number.isInteger(number)
  var floor$1    = Math.floor;
  var _isInteger = function isInteger(it){
    return !_isObject(it) && isFinite(it) && floor$1(it) === it;
  };

  // 20.1.2.3 Number.isInteger(number)


  _export(_export.S, 'Number', {isInteger: _isInteger});

  var isInteger$2 = _core.Number.isInteger;

  var isInteger$1 = createCommonjsModule$$1(function (module) {
  module.exports = { "default": isInteger$2, __esModule: true };
  });

  var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

  var space   = '[' + _stringWs + ']';
  var non     = '\u200b\u0085';
  var ltrim   = RegExp('^' + space + space + '*');
  var rtrim   = RegExp(space + space + '*$');

  var exporter = function(KEY, exec, ALIAS){
    var exp   = {};
    var FORCE = _fails(function(){
      return !!_stringWs[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
    if(ALIAS)exp[ALIAS] = fn;
    _export(_export.P + _export.F * FORCE, 'String', exp);
  };

  // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim
  var trim = exporter.trim = function(string, TYPE){
    string = String(_defined(string));
    if(TYPE & 1)string = string.replace(ltrim, '');
    if(TYPE & 2)string = string.replace(rtrim, '');
    return string;
  };

  var _stringTrim = exporter;

  var $parseFloat = _global.parseFloat;
  var $trim       = _stringTrim.trim;

  var _parseFloat$3 = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str){
    var string = $trim(String(str), 3)
      , result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;

  // 20.1.2.12 Number.parseFloat(string)
  _export(_export.S + _export.F * (Number.parseFloat != _parseFloat$3), 'Number', {parseFloat: _parseFloat$3});

  var _parseFloat$1 = parseFloat;

  var _parseFloat = createCommonjsModule$$1(function (module) {
  module.exports = { "default": _parseFloat$1, __esModule: true };
  });

  /**
   * toxic-predicate-functions v0.1.2
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  /**
   * to check whether a variable is array
   * @param {Anything} arr
   * @return {Boolean} true when it is a boolean
   */
  function isArray$1(arr) {
    return Array.isArray(arr);
  }

  /**
   * 判断是否为function
   * @param  {Anything}  obj [description]
   * @return {Boolean}     [description]
   */
  function isFunction(obj) {
    return typeof obj === 'function';
  }

  /**
   * 判断是否是对象
   * @param  {Anything}  obj 传入对象
   * @return {Boolean}     [description]
   */
  function isObject$1(obj) {
    // incase of arrow function and array
    return Object(obj) === obj && String(obj) === '[object Object]' && !isFunction(obj) && !isArray$1(obj);
  }

  /**
  * @module event
  * @author huzunjie
  * @description 自定义事件基础类
  */

  /* 缓存事件监听方法及包装，内部数据格式：
   * targetIndex_<type:'click|mouseup|done'>: [ [
   *   function(){ ... handler ... },
   *   function(){ ... handlerWrap ... handler.apply(target, arguments) ... },
   *   isOnce
   * ]]
   */
  var _evtListenerCache = _Object$create(null);
  _evtListenerCache.count = 0;

  /**
   * 得到某对象的某事件类型对应的监听队列数组
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型(这里的时间类型不只是名称，还是缓存标识，可以通过添加后缀来区分)
   * @return {Array}
   */
  function getEvtTypeCache(target, type) {

    var evtId = target.__evt_id;
    if (!evtId) {

      /* 设置__evt_id不可枚举 */
      Object.defineProperty(target, '__evt_id', {
        writable: true,
        enumerable: false,
        configurable: true
      });

      /* 空对象初始化绑定索引 */
      evtId = target.__evt_id = ++_evtListenerCache.count;
    }

    var typeCacheKey = evtId + '_' + type;
    var evtTypeCache = _evtListenerCache[typeCacheKey];
    if (!evtTypeCache) {
      evtTypeCache = _evtListenerCache[typeCacheKey] = [];
    }

    return evtTypeCache;
  }

  /**
   * 触发事件监听方法
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Object} eventObj 触发事件时要传回的event对象
   * @return {undefined}
   */
  function emitEventCache(target, type, eventObj) {
    var evt = _Object$create(null);
    evt.type = type;
    evt.target = target;
    if (eventObj) {
      _Object$assign(evt, isObject$1(eventObj) ? eventObj : { data: eventObj });
    }
    getEvtTypeCache(target, type).forEach(function (item) {
      (item[1] || item[0]).apply(target, [evt]);
    });
  }

  /**
   * 添加事件监听到缓存
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @param {Boolean} isOnce 是否单次执行
   * @param {Function} handlerWrap
   * @return {undefined}
   */
  function addEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var handlerWrap = arguments[4];

    if (isFunction(isOnce) && !handlerWrap) {
      handlerWrap = isOnce;
      isOnce = undefined;
    }
    var handlers = [handler, undefined, isOnce];
    if (isOnce && !handlerWrap) {
      handlerWrap = function handlerWrap() {
        removeEventCache(target, type, handler, isOnce);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(target, args);
      };
    }
    if (handlerWrap) {
      handlers[1] = handlerWrap;
    }
    getEvtTypeCache(target, type).push(handlers);
  }

  /**
   * 移除事件监听
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @return {undefined}
   */
  function removeEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var typeCache = getEvtTypeCache(target, type);

    if (handler || isOnce) {
      /* 有指定 handler 则清除对应监听 */
      var handlerId = -1;
      var handlerWrap = void 0;
      typeCache.find(function (item, i) {
        if ((!handler || item[0] === handler) && (!isOnce || item[2])) {
          handlerId = i;
          handlerWrap = item[1];
          return true;
        }
      });
      if (handlerId !== -1) {
        typeCache.splice(handlerId, 1);
      }
      return handlerWrap;
    } else {
      /* 未指定 handler 则清除type对应的所有监听 */
      typeCache.length = 0;
    }
  }

  /**
   * @class CustEvent
   * @description
   * Event 自定义事件类
   * 1. 可以使用不传参得到的实例作为eventBus使用
   * 2. 可以通过指定target，用多个实例操作同一target对象的事件管理
   * 3. 当设定target时，可以通过设置assign为true，来给target实现"on\once\off\emit"方法
   * @param  {Object}  target 发生事件的对象（空则默认为event实例）
   * @param  {Boolean}  assign 是否将"on\once\off\emit"方法实现到target对象上
   * @return {event}
   */
  var CustEvent = function () {
    function CustEvent(target, assign$$1) {
      var _this = this;

      _classCallCheck(this, CustEvent);

      /* 设置__target不可枚举 */
      Object.defineProperty(this, '__target', {
        writable: true,
        enumerable: false,
        configurable: true
      });
      this.__target = this;

      if (target) {

        if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
          throw new Error('CusEvent target are not object');
        }
        this.__target = target;

        /* 为target实现on\once\off\emit */
        if (assign$$1) {
          ['on', 'once', 'off', 'emit'].forEach(function (mth) {
            target[mth] = _this[mth];
          });
        }
      }
    }

    /**
     * 添加事件监听
     * @param {String} type 事件类型
     * @param {Function} handler 监听函数
     * @param {Boolean} isOnce 单次监听类型
     * @return {event}
     */


    _createClass(CustEvent, [{
      key: 'on',
      value: function on(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        addEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 添加事件监听,并且只执行一次
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数
       * @return {event}
       */

    }, {
      key: 'once',
      value: function once(type, handler) {
        return this.on(type, handler, true);
      }

      /**
       * 移除事件监听
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数(不指定handler则清除type对应的所有事件监听)
       * @param {Boolean} isOnce 单次监听类型
       * @return {event}
       */

    }, {
      key: 'off',
      value: function off(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        removeEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 触发事件监听函数
       * @param {String} type 事件类型
       * @return {event}
       */

    }, {
      key: 'emit',
      value: function emit(type, data) {
        emitEventCache(this.__target, type, { data: data });
        return this;
      }
    }]);

    return CustEvent;
  }();

  exports.emitEventCache = emitEventCache;
  exports.addEventCache = addEventCache;
  exports.removeEventCache = removeEventCache;
  exports.CustEvent = CustEvent;

  Object.defineProperty(exports, '__esModule', { value: true });

  })));


  /***/ }),
  /* 1 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ERRORNO = exports.ERRORNO = {
    NET_ERROR: 100,
    CODEC_ERROR: 101,
    CANNOT_SEEK: 102,
    ENDOFSTREAM_ERROR: 103,
    MEDIASOURCE_ERROR: 104,
    SOURCEBUFFER_ERROR: 105,
    SBABORT_ERROR: 106,
    APPENDBUFFER_ERROR: 107
  };

  /***/ }),
  /* 2 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });
  var PLAYER_EVENTS = exports.PLAYER_EVENTS = {
      LOADER_OPEN: 'loader-open',
      LOADER_CHUNK_ARRIVAL: 'loader-chunk-arrival',
      MEDIA_DEMUX_FLV: 'media-demux-flv',
      MEDIA_SEGMENT_INIT: 'media-segment-init',
      MEDIA_INFO: 'media-info',
      MEDIA_SEGMENT: 'media-segment',
      PLAYING: 'playing',
      CANPLAY: 'canplay',
      TIMEUPDATE: 'timeupdate'
  };

  /***/ }),
  /* 3 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var Error = function Error(type) {
      _classCallCheck(this, Error);

      this.type = type;
  };

  exports.default = Error;

  /***/ }),
  /* 4 */
  /***/ (function(module, exports, __webpack_require__) {


  /**
   * chimee-helper-log v0.1.3
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  (function (global, factory) {
  	 module.exports = factory();
  }(this, (function () {
  function unwrapExports$$1 (x) {
  	return x && x.__esModule ? x['default'] : x;
  }

  function createCommonjsModule$$1(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var classCallCheck = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  });

  var _classCallCheck = unwrapExports$$1(classCallCheck);

  var _global = createCommonjsModule$$1(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
  if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule$$1(function (module) {
  var core = module.exports = {version: '2.4.0'};
  if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
  });

  var _aFunction = function(it){
    if(typeof it != 'function')throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function(fn, that, length){
    _aFunction(fn);
    if(that === undefined)return fn;
    switch(length){
      case 1: return function(a){
        return fn.call(that, a);
      };
      case 2: return function(a, b){
        return fn.call(that, a, b);
      };
      case 3: return function(a, b, c){
        return fn.call(that, a, b, c);
      };
    }
    return function(/* ...args */){
      return fn.apply(that, arguments);
    };
  };

  var _isObject = function(it){
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function(it){
    if(!_isObject(it))throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function(exec){
    try {
      return !!exec();
    } catch(e){
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function(){
    return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
  });

  var document$1 = _global.document;
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function(it){
    return is ? document$1.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function(){
    return Object.defineProperty(_domCreate('div'), 'a', {get: function(){ return 7; }}).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function(it, S){
    if(!_isObject(it))return it;
    var fn, val;
    if(S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it)))return val;
    if(typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it)))return val;
    if(!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it)))return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP             = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes){
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if(_ie8DomDefine)try {
      return dP(O, P, Attributes);
    } catch(e){ /* empty */ }
    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
    if('value' in Attributes)O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function(bitmap, value){
    return {
      enumerable  : !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable    : !(bitmap & 4),
      value       : value
    };
  };

  var _hide = _descriptors ? function(object, key, value){
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function(object, key, value){
    object[key] = value;
    return object;
  };

  var PROTOTYPE = 'prototype';

  var $export = function(type, name, source){
    var IS_FORCED = type & $export.F
      , IS_GLOBAL = type & $export.G
      , IS_STATIC = type & $export.S
      , IS_PROTO  = type & $export.P
      , IS_BIND   = type & $export.B
      , IS_WRAP   = type & $export.W
      , exports   = IS_GLOBAL ? _core : _core[name] || (_core[name] = {})
      , expProto  = exports[PROTOTYPE]
      , target    = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE]
      , key, own, out;
    if(IS_GLOBAL)source = name;
    for(key in source){
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if(own && key in exports)continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? _ctx(out, _global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? (function(C){
        var F = function(a, b, c){
          if(this instanceof C){
            switch(arguments.length){
              case 0: return new C;
              case 1: return new C(a);
              case 2: return new C(a, b);
            } return new C(a, b, c);
          } return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      // make static versions for prototype methods
      })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if(IS_PROTO){
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if(type & $export.R && expProto && !expProto[key])_hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library` 
  var _export = $export;

  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  _export(_export.S + _export.F * !_descriptors, 'Object', {defineProperty: _objectDp.f});

  var $Object = _core.Object;
  var defineProperty$2 = function defineProperty(it, key, desc){
    return $Object.defineProperty(it, key, desc);
  };

  var defineProperty = createCommonjsModule$$1(function (module) {
  module.exports = { "default": defineProperty$2, __esModule: true };
  });

  var createClass = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;



  var _defineProperty2 = _interopRequireDefault(defineProperty);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  });

  var _createClass = unwrapExports$$1(createClass);

  // 7.1.4 ToInteger
  var ceil  = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function(it){
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function(it){
    if(it == undefined)throw TypeError("Can't call method on  " + it);
    return it;
  };

  // true  -> String#at
  // false -> String#codePointAt
  var _stringAt = function(TO_STRING){
    return function(that, pos){
      var s = String(_defined(that))
        , i = _toInteger(pos)
        , l = s.length
        , a, b;
      if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
        ? TO_STRING ? s.charAt(i) : a
        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

  var _library = true;

  var _redefine = _hide;

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function(it, key){
    return hasOwnProperty.call(it, key);
  };

  var toString = {}.toString;

  var _cof = function(it){
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function(it){
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings

  var _toIobject = function(it){
    return _iobject(_defined(it));
  };

  // 7.1.15 ToLength
  var min       = Math.min;
  var _toLength = function(it){
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max       = Math.max;
  var min$1       = Math.min;
  var _toIndex = function(index, length){
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes

  var _arrayIncludes = function(IS_INCLUDES){
    return function($this, el, fromIndex){
      var O      = _toIobject($this)
        , length = _toLength(O.length)
        , index  = _toIndex(fromIndex, length)
        , value;
      // Array#includes uses SameValueZero equality algorithm
      if(IS_INCLUDES && el != el)while(length > index){
        value = O[index++];
        if(value != value)return true;
      // Array#toIndex ignores holes, Array#includes - not
      } else for(;length > index; index++)if(IS_INCLUDES || index in O){
        if(O[index] === el)return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var SHARED = '__core-js_shared__';
  var store  = _global[SHARED] || (_global[SHARED] = {});
  var _shared = function(key){
    return store[key] || (store[key] = {});
  };

  var id = 0;
  var px = Math.random();
  var _uid = function(key){
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var shared = _shared('keys');
  var _sharedKey = function(key){
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO$1     = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function(object, names){
    var O      = _toIobject(object)
      , i      = 0
      , result = []
      , key;
    for(key in O)if(key != IE_PROTO$1)_has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if(_has(O, key = names[i++])){
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)


  var _objectKeys = Object.keys || function keys(O){
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties){
    _anObject(O);
    var keys   = _objectKeys(Properties)
      , length = keys.length
      , i = 0
      , P;
    while(length > i)_objectDp.f(O, P = keys[i++], Properties[P]);
    return O;
  };

  var _html = _global.document && document.documentElement;

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var IE_PROTO    = _sharedKey('IE_PROTO');
  var Empty       = function(){ /* empty */ };
  var PROTOTYPE$1   = 'prototype';

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function(){
    // Thrash, waste and sodomy: IE GC bug
    var iframe = _domCreate('iframe')
      , i      = _enumBugKeys.length
      , lt     = '<'
      , gt     = '>'
      , iframeDocument;
    iframe.style.display = 'none';
    _html.appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while(i--)delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
    return createDict();
  };

  var _objectCreate = Object.create || function create(O, Properties){
    var result;
    if(O !== null){
      Empty[PROTOTYPE$1] = _anObject(O);
      result = new Empty;
      Empty[PROTOTYPE$1] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : _objectDps(result, Properties);
  };

  var _wks = createCommonjsModule$$1(function (module) {
  var store      = _shared('wks')
    , Symbol     = _global.Symbol
    , USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function(name){
    return store[name] || (store[name] =
      USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
  });

  var def = _objectDp.f;
  var TAG = _wks('toStringTag');

  var _setToStringTag = function(it, tag, stat){
    if(it && !_has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
  };

  var IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  _hide(IteratorPrototype, _wks('iterator'), function(){ return this; });

  var _iterCreate = function(Constructor, NAME, next){
    Constructor.prototype = _objectCreate(IteratorPrototype, {next: _propertyDesc(1, next)});
    _setToStringTag(Constructor, NAME + ' Iterator');
  };

  // 7.1.13 ToObject(argument)

  var _toObject = function(it){
    return Object(_defined(it));
  };

  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var IE_PROTO$2    = _sharedKey('IE_PROTO');
  var ObjectProto = Object.prototype;

  var _objectGpo = Object.getPrototypeOf || function(O){
    O = _toObject(O);
    if(_has(O, IE_PROTO$2))return O[IE_PROTO$2];
    if(typeof O.constructor == 'function' && O instanceof O.constructor){
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectProto : null;
  };

  var ITERATOR       = _wks('iterator');
  var BUGGY          = !([].keys && 'next' in [].keys());
  var FF_ITERATOR    = '@@iterator';
  var KEYS           = 'keys';
  var VALUES         = 'values';

  var _iterDefine = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
    _iterCreate(Constructor, NAME, next);
    var getMethod = function(kind){
      if(!BUGGY && kind in proto)return proto[kind];
      switch(kind){
        case KEYS: return function keys(){ return new Constructor(this, kind); };
        case VALUES: return function values(){ return new Constructor(this, kind); };
      } return function entries(){ return new Constructor(this, kind); };
    };
    var TAG        = NAME + ' Iterator'
      , DEF_VALUES = DEFAULT == VALUES
      , VALUES_BUG = false
      , proto      = Base.prototype
      , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
      , $default   = $native || getMethod(DEFAULT)
      , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
      , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
      , methods, key, IteratorPrototype;
    // Fix native
    if($anyNative){
      IteratorPrototype = _objectGpo($anyNative.call(new Base));
      if(IteratorPrototype !== Object.prototype){
        // Set @@toStringTag to native iterators
        _setToStringTag(IteratorPrototype, TAG, true);
      }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
    // Define iterator
    if((FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
      _hide(proto, ITERATOR, $default);
    }
    if(DEFAULT){
      methods = {
        values:  DEF_VALUES ? $default : getMethod(VALUES),
        keys:    IS_SET     ? $default : getMethod(KEYS),
        entries: $entries
      };
      if(FORCED)for(key in methods){
        if(!(key in proto))_redefine(proto, key, methods[key]);
      } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

  var $at  = _stringAt(true);

  // 21.1.3.27 String.prototype[@@iterator]()
  _iterDefine(String, 'String', function(iterated){
    this._t = String(iterated); // target
    this._i = 0;                // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , index = this._i
      , point;
    if(index >= O.length)return {value: undefined, done: true};
    point = $at(O, index);
    this._i += point.length;
    return {value: point, done: false};
  });

  var _iterStep = function(done, value){
    return {value: value, done: !!done};
  };

  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  var es6_array_iterator = _iterDefine(Array, 'Array', function(iterated, kind){
    this._t = _toIobject(iterated); // target
    this._i = 0;                   // next index
    this._k = kind;                // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , kind  = this._k
      , index = this._i++;
    if(!O || index >= O.length){
      this._t = undefined;
      return _iterStep(1);
    }
    if(kind == 'keys'  )return _iterStep(0, index);
    if(kind == 'values')return _iterStep(0, O[index]);
    return _iterStep(0, [index, O[index]]);
  }, 'values');

  var TO_STRING_TAG = _wks('toStringTag');

  for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
    var NAME       = collections[i]
      , Collection = _global[NAME]
      , proto      = Collection && Collection.prototype;
    if(proto && !proto[TO_STRING_TAG])_hide(proto, TO_STRING_TAG, NAME);
  }

  var f$1 = _wks;

  var _wksExt = {
  	f: f$1
  };

  var iterator$2 = _wksExt.f('iterator');

  var iterator = createCommonjsModule$$1(function (module) {
  module.exports = { "default": iterator$2, __esModule: true };
  });

  var _meta = createCommonjsModule$$1(function (module) {
  var META     = _uid('meta')
    , setDesc  = _objectDp.f
    , id       = 0;
  var isExtensible = Object.isExtensible || function(){
    return true;
  };
  var FREEZE = !_fails(function(){
    return isExtensible(Object.preventExtensions({}));
  });
  var setMeta = function(it){
    setDesc(it, META, {value: {
      i: 'O' + ++id, // object ID
      w: {}          // weak collections IDs
    }});
  };
  var fastKey = function(it, create){
    // return primitive with prefix
    if(!_isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if(!_has(it, META)){
      // can't set metadata to uncaught frozen object
      if(!isExtensible(it))return 'F';
      // not necessary to add metadata
      if(!create)return 'E';
      // add missing metadata
      setMeta(it);
    // return object ID
    } return it[META].i;
  };
  var getWeak = function(it, create){
    if(!_has(it, META)){
      // can't set metadata to uncaught frozen object
      if(!isExtensible(it))return true;
      // not necessary to add metadata
      if(!create)return false;
      // add missing metadata
      setMeta(it);
    // return hash weak collections IDs
    } return it[META].w;
  };
  // add metadata on freeze-family methods calling
  var onFreeze = function(it){
    if(FREEZE && meta.NEED && isExtensible(it) && !_has(it, META))setMeta(it);
    return it;
  };
  var meta = module.exports = {
    KEY:      META,
    NEED:     false,
    fastKey:  fastKey,
    getWeak:  getWeak,
    onFreeze: onFreeze
  };
  });

  var defineProperty$4 = _objectDp.f;
  var _wksDefine = function(name){
    var $Symbol = _core.Symbol || (_core.Symbol = {});
    if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty$4($Symbol, name, {value: _wksExt.f(name)});
  };

  var _keyof = function(object, el){
    var O      = _toIobject(object)
      , keys   = _objectKeys(O)
      , length = keys.length
      , index  = 0
      , key;
    while(length > index)if(O[key = keys[index++]] === el)return key;
  };

  var f$2 = Object.getOwnPropertySymbols;

  var _objectGops = {
  	f: f$2
  };

  var f$3 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$3
  };

  // all enumerable object keys, includes symbols

  var _enumKeys = function(it){
    var result     = _objectKeys(it)
      , getSymbols = _objectGops.f;
    if(getSymbols){
      var symbols = getSymbols(it)
        , isEnum  = _objectPie.f
        , i       = 0
        , key;
      while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
    } return result;
  };

  // 7.2.2 IsArray(argument)

  var _isArray = Array.isArray || function isArray(arg){
    return _cof(arg) == 'Array';
  };

  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

  var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
    return _objectKeysInternal(O, hiddenKeys);
  };

  var _objectGopn = {
  	f: f$5
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var gOPN$1      = _objectGopn.f;
  var toString$1  = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function(it){
    try {
      return gOPN$1(it);
    } catch(e){
      return windowNames.slice();
    }
  };

  var f$4 = function getOwnPropertyNames(it){
    return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject(it));
  };

  var _objectGopnExt = {
  	f: f$4
  };

  var gOPD$1           = Object.getOwnPropertyDescriptor;

  var f$6 = _descriptors ? gOPD$1 : function getOwnPropertyDescriptor(O, P){
    O = _toIobject(O);
    P = _toPrimitive(P, true);
    if(_ie8DomDefine)try {
      return gOPD$1(O, P);
    } catch(e){ /* empty */ }
    if(_has(O, P))return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
  };

  var _objectGopd = {
  	f: f$6
  };

  // ECMAScript 6 symbols shim
  var META           = _meta.KEY;
  var gOPD           = _objectGopd.f;
  var dP$1             = _objectDp.f;
  var gOPN           = _objectGopnExt.f;
  var $Symbol        = _global.Symbol;
  var $JSON          = _global.JSON;
  var _stringify     = $JSON && $JSON.stringify;
  var PROTOTYPE$2      = 'prototype';
  var HIDDEN         = _wks('_hidden');
  var TO_PRIMITIVE   = _wks('toPrimitive');
  var isEnum         = {}.propertyIsEnumerable;
  var SymbolRegistry = _shared('symbol-registry');
  var AllSymbols     = _shared('symbols');
  var OPSymbols      = _shared('op-symbols');
  var ObjectProto$1    = Object[PROTOTYPE$2];
  var USE_NATIVE     = typeof $Symbol == 'function';
  var QObject        = _global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = _descriptors && _fails(function(){
    return _objectCreate(dP$1({}, 'a', {
      get: function(){ return dP$1(this, 'a', {value: 7}).a; }
    })).a != 7;
  }) ? function(it, key, D){
    var protoDesc = gOPD(ObjectProto$1, key);
    if(protoDesc)delete ObjectProto$1[key];
    dP$1(it, key, D);
    if(protoDesc && it !== ObjectProto$1)dP$1(ObjectProto$1, key, protoDesc);
  } : dP$1;

  var wrap = function(tag){
    var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
    return typeof it == 'symbol';
  } : function(it){
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D){
    if(it === ObjectProto$1)$defineProperty(OPSymbols, key, D);
    _anObject(it);
    key = _toPrimitive(key, true);
    _anObject(D);
    if(_has(AllSymbols, key)){
      if(!D.enumerable){
        if(!_has(it, HIDDEN))dP$1(it, HIDDEN, _propertyDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if(_has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
        D = _objectCreate(D, {enumerable: _propertyDesc(0, false)});
      } return setSymbolDesc(it, key, D);
    } return dP$1(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P){
    _anObject(it);
    var keys = _enumKeys(P = _toIobject(P))
      , i    = 0
      , l = keys.length
      , key;
    while(l > i)$defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P){
    return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key){
    var E = isEnum.call(this, key = _toPrimitive(key, true));
    if(this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key))return false;
    return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
    it  = _toIobject(it);
    key = _toPrimitive(key, true);
    if(it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key))return;
    var D = gOPD(it, key);
    if(D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it){
    var names  = gOPN(_toIobject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i){
      if(!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
    } return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
    var IS_OP  = it === ObjectProto$1
      , names  = gOPN(IS_OP ? OPSymbols : _toIobject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i){
      if(_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true))result.push(AllSymbols[key]);
    } return result;
  };

  // 19.4.1.1 Symbol([description])
  if(!USE_NATIVE){
    $Symbol = function Symbol(){
      if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
      var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function(value){
        if(this === ObjectProto$1)$set.call(OPSymbols, value);
        if(_has(this, HIDDEN) && _has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, _propertyDesc(1, value));
      };
      if(_descriptors && setter)setSymbolDesc(ObjectProto$1, tag, {configurable: true, set: $set});
      return wrap(tag);
    };
    _redefine($Symbol[PROTOTYPE$2], 'toString', function toString(){
      return this._k;
    });

    _objectGopd.f = $getOwnPropertyDescriptor;
    _objectDp.f   = $defineProperty;
    _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
    _objectPie.f  = $propertyIsEnumerable;
    _objectGops.f = $getOwnPropertySymbols;

    if(_descriptors && !_library){
      _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    _wksExt.f = function(name){
      return wrap(_wks(name));
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE, {Symbol: $Symbol});

  for(var symbols = (
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
  ).split(','), i$1 = 0; symbols.length > i$1; )_wks(symbols[i$1++]);

  for(var symbols = _objectKeys(_wks.store), i$1 = 0; symbols.length > i$1; )_wksDefine(symbols[i$1++]);

  _export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key){
      return _has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(key){
      if(isSymbol(key))return _keyof(SymbolRegistry, key);
      throw TypeError(key + ' is not a symbol!');
    },
    useSetter: function(){ setter = true; },
    useSimple: function(){ setter = false; }
  });

  _export(_export.S + _export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function(){
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it){
      if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
      var args = [it]
        , i    = 1
        , replacer, $replacer;
      while(arguments.length > i)args.push(arguments[i++]);
      replacer = args[1];
      if(typeof replacer == 'function')$replacer = replacer;
      if($replacer || !_isArray(replacer))replacer = function(key, value){
        if($replacer)value = $replacer.call(this, key, value);
        if(!isSymbol(value))return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });

  // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
  $Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  _setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  _setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  _setToStringTag(_global.JSON, 'JSON', true);

  _wksDefine('asyncIterator');

  _wksDefine('observable');

  var index = _core.Symbol;

  var symbol = createCommonjsModule$$1(function (module) {
  module.exports = { "default": index, __esModule: true };
  });

  var _typeof_1 = createCommonjsModule$$1(function (module, exports) {

  exports.__esModule = true;



  var _iterator2 = _interopRequireDefault(iterator);



  var _symbol2 = _interopRequireDefault(symbol);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  });

  var _typeof = unwrapExports$$1(_typeof_1);

  // most Object methods by ES6 should accept primitives

  var _objectSap = function(KEY, exec){
    var fn  = (_core.Object || {})[KEY] || Object[KEY]
      , exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function(){ fn(1); }), 'Object', exp);
  };

  // 19.1.2.14 Object.keys(O)


  _objectSap('keys', function(){
    return function keys(it){
      return _objectKeys(_toObject(it));
    };
  });

  var keys$1 = _core.Object.keys;

  var keys = createCommonjsModule$$1(function (module) {
  module.exports = { "default": keys$1, __esModule: true };
  });

  // 20.1.2.3 Number.isInteger(number)
  var floor$1    = Math.floor;
  var _isInteger = function isInteger(it){
    return !_isObject(it) && isFinite(it) && floor$1(it) === it;
  };

  // 20.1.2.3 Number.isInteger(number)


  _export(_export.S, 'Number', {isInteger: _isInteger});

  var isInteger$2 = _core.Number.isInteger;

  var isInteger$1 = createCommonjsModule$$1(function (module) {
  module.exports = { "default": isInteger$2, __esModule: true };
  });

  var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

  var space   = '[' + _stringWs + ']';
  var non     = '\u200b\u0085';
  var ltrim   = RegExp('^' + space + space + '*');
  var rtrim   = RegExp(space + space + '*$');

  var exporter = function(KEY, exec, ALIAS){
    var exp   = {};
    var FORCE = _fails(function(){
      return !!_stringWs[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
    if(ALIAS)exp[ALIAS] = fn;
    _export(_export.P + _export.F * FORCE, 'String', exp);
  };

  // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim
  var trim = exporter.trim = function(string, TYPE){
    string = String(_defined(string));
    if(TYPE & 1)string = string.replace(ltrim, '');
    if(TYPE & 2)string = string.replace(rtrim, '');
    return string;
  };

  var _stringTrim = exporter;

  var $parseFloat = _global.parseFloat;
  var $trim       = _stringTrim.trim;

  var _parseFloat$3 = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str){
    var string = $trim(String(str), 3)
      , result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;

  // 20.1.2.12 Number.parseFloat(string)
  _export(_export.S + _export.F * (Number.parseFloat != _parseFloat$3), 'Number', {parseFloat: _parseFloat$3});

  var _parseFloat$1 = parseFloat;

  var _parseFloat = createCommonjsModule$$1(function (module) {
  module.exports = { "default": _parseFloat$1, __esModule: true };
  });

  /**
   * toxic-predicate-functions v0.1.2
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  /**
   * 判断是否是string
   * @param  {Anything}  str [description]
   * @return {Boolean}     [description]
   */
  function isString(str) {
    return typeof str === 'string' || str instanceof String;
  }

  function formatter(tag, msg) {
    if (!isString(tag)) throw new TypeError('Log\'s method only acccept string as argument, but not ' + tag + ' in ' + (typeof tag === 'undefined' ? 'undefined' : _typeof(tag)));
    if (!isString(msg)) return '[' + Log.GLOBAL_TAG + '] > ' + tag;
    tag = Log.FORCE_GLOBAL_TAG ? Log.GLOBAL_TAG : tag || Log.GLOBAL_TAG;
    return '[' + tag + '] > ' + msg;
  }
  /**
   * Log Object
   */

  var Log = function () {
    function Log() {
      _classCallCheck(this, Log);
    }

    _createClass(Log, null, [{
      key: 'error',

      /**
       * equal to console.error, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */
      value: function error(tag, msg) {
        if (!Log.ENABLE_ERROR) {
          return;
        }

        (console.error || console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.info, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {string}
       */

    }, {
      key: 'info',
      value: function info(tag, msg) {
        if (!Log.ENABLE_INFO) {
          return;
        }
        (console.info || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.warn, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'warn',
      value: function warn(tag, msg) {
        if (!Log.ENABLE_WARN) {
          return;
        }
        (console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.debug, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'debug',
      value: function debug(tag, msg) {
        if (!Log.ENABLE_DEBUG) {
          return;
        }
        (console.debug || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.verbose, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'verbose',
      value: function verbose(tag, msg) {
        if (!Log.ENABLE_VERBOSE) {
          return;
        }
        console.log(formatter(tag, msg));
      }
    }]);

    return Log;
  }();

  Log.GLOBAL_TAG = 'chimee';
  Log.FORCE_GLOBAL_TAG = false;
  Log.ENABLE_ERROR = true;
  Log.ENABLE_INFO = true;
  Log.ENABLE_WARN = true;
  Log.ENABLE_DEBUG = true;
  Log.ENABLE_VERBOSE = true;

  return Log;

  })));


  /***/ }),
  /* 5 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
  	value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _fetch = __webpack_require__(16);

  var _fetch2 = _interopRequireDefault(_fetch);

  var _xhrRange = __webpack_require__(18);

  var _xhrRange2 = _interopRequireDefault(_xhrRange);

  var _websocket = __webpack_require__(19);

  var _websocket2 = _interopRequireDefault(_websocket);

  var _xhrMozChunk = __webpack_require__(20);

  var _xhrMozChunk2 = _interopRequireDefault(_xhrMozChunk);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _playerEvents = __webpack_require__(2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * 处理range的静态函数
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * author songguangyu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * email 522963130@qq.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */

  /**
   * Ioloader 处理io的调用器 缓存多余数据
   * @class Ioloader
   * @param  {object} video config
   */
  var Ioloader = function (_CustEvent) {
  	_inherits(Ioloader, _CustEvent);

  	function Ioloader(config) {
  		_classCallCheck(this, Ioloader);

  		var _this = _possibleConstructorReturn(this, (Ioloader.__proto__ || Object.getPrototypeOf(Ioloader)).call(this));

  		_this.loader = null;
  		_this.config = {};
  		_this.config = config || {};
  		_this.bufferSize = 1024 * 1024 * 3; // initial size: 3MB
  		_this.cacheBuffer = new ArrayBuffer(_this.bufferSize);
  		_this.cacheRemain = 0;
  		_this.stashByteStart = 0;
  		_this.enableStash = true;
  		_this.stashSize = _this.config.stashSize || 1024 * 384;
  		_this.resumeFrom = 0;
  		_this.currentRange = {};
  		_this.totalReceive = 0;
  		_this.seekPonit = undefined;
  		_this.timer = null;
  		_this.heartBeatInterval = null;
  		_this.preTotalReceive = 0;
  		_this.seekLock = false;
  		_this.webSocketURLReg = /wss?:\/\/(.+?)/;
  		_this.selectLoader();
  		_this.bindEvent();
  		return _this;
  	}

  	/**
   * 自动选择io处理器
   */


  	_createClass(Ioloader, [{
  		key: 'selectLoader',
  		value: function selectLoader() {
  			var config = this.config;
  			var url = this.config.src;
  			if (this.webSocketURLReg.test(url)) {
  				this.loader = new _websocket2.default(url, config, this.queryHandle);
  			} else if (_fetch2.default.isSupport()) {
  				this.loader = new _fetch2.default(url, config, this.queryHandle);
  			} else if (_xhrMozChunk2.default.isSupport()) {
  				this.loader = new _xhrMozChunk2.default(url, config, this.queryHandle);
  			} else if (_xhrRange2.default.isSupport()) {
  				this.loader = new _xhrRange2.default(url, config, this.queryHandle);
  			}
  			this.loader.arrivalDataCallback = this.onLoaderChunkArrival.bind(this);
  		}
  		/**
    * 绑定事件
    */

  	}, {
  		key: 'bindEvent',
  		value: function bindEvent() {
  			var _this2 = this;

  			this.loader.on('end', function () {
  				var buffer = _this2.cacheBuffer.slice(0, _this2.cacheRemain);
  				_this2.arrivalDataCallback(buffer, _this2.stashByteStart);
  				_this2.emit('end');
  			});
  			['error', 'performance'].forEach(function (eventName) {
  				_this2.loader.on(eventName, function (handle) {
  					_this2.emit(eventName, handle.data);
  				});
  			});
  		}
  		/**
     * 解除事件绑定
     */

  	}, {
  		key: 'unbindEvent',
  		value: function unbindEvent() {
  			this.loader.off('end');
  			this.loader.off('error');
  			this.loader.off('performance');
  		}
  		/**
    * 数据接收器
    * @param  {arrayBuffer} chunk data
    * @param  {number} chunk byte postion
    */

  	}, {
  		key: 'onLoaderChunkArrival',
  		value: function onLoaderChunkArrival(chunk, byteStart, keyframePoint) {
  			if (typeof this.startReceiveTime === 'undefined') {
  				this.startReceiveTime = Date.now();
  			}
  			if (this.seekLock && keyframePoint === undefined) {
  				return;
  			}
  			if (keyframePoint !== undefined) {
  				this.seekPonit = keyframePoint;
  				this.seekLock = false;
  			}
  			if (this.arrivalDataCallback) {
  				this.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.LOADER_CHUNK_ARRIVAL, byteLength: chunk.byteLength, ts: Date.now() });
  				this.totalReceive += chunk.byteLength;

  				if (this.cacheRemain === 0 && this.stashByteStart === 0) {
  					// This is the first chunk after seek action
  					this.stashByteStart = byteStart;
  				}
  				if (this.cacheRemain + chunk.byteLength <= this.stashSize) {
  					// 小于cache大小 则看做数据太小 进行缓存 不进行下发
  					var stashArray = new Uint8Array(this.cacheBuffer, 0, this.stashSize);
  					stashArray.set(new Uint8Array(chunk), this.cacheRemain);
  					this.cacheRemain += chunk.byteLength;
  				} else {
  					// 大于cache大小的 则把数据放入播放器 溢出数据进行缓存
  					if (this.startReceiveTime) {
  						this.emit('performance', {
  							type: 'first-flv-package-duration',
  							value: Date.now() - this.startReceiveTime
  						});
  						this.startReceiveTime = undefined;
  					}
  					var _stashArray = new Uint8Array(this.cacheBuffer, 0, this.bufferSize);
  					if (this.cacheRemain > 0) {
  						var buffer = this.cacheBuffer.slice(0, this.cacheRemain);
  						var consumed = 0;
  						var transmuxerStart = Date.now();
  						if (this.seekPonit !== undefined) {
  							consumed = this.arrivalDataCallback(buffer, this.stashByteStart, this.seekPonit);
  							this.seekPonit = undefined;
  						} else {
  							consumed = this.arrivalDataCallback(buffer, this.stashByteStart);
  						}
  						this.emit('performance', {
  							type: 'first-flv-to-mp4',
  							value: Date.now() - transmuxerStart
  						});

  						if (consumed < buffer.byteLength) {
  							if (consumed > 0) {
  								var remainArray = new Uint8Array(buffer, consumed);
  								_stashArray.set(remainArray, 0);
  								this.cacheRemain = remainArray.byteLength;
  								this.stashByteStart += consumed;
  							}
  						} else {
  							this.cacheRemain = 0;
  							this.stashByteStart += consumed;
  						}
  						if (this.cacheRemain + chunk.byteLength > this.bufferSize) {
  							this.expandBuffer(this.cacheRemain + chunk.byteLength);
  							_stashArray = new Uint8Array(this.cacheBuffer, 0, this.bufferSize);
  						}
  						_stashArray.set(new Uint8Array(chunk), this.cacheRemain);
  						this.cacheRemain += chunk.byteLength;
  					} else {
  						var _consumed = 0;
  						var _transmuxerStart = Date.now();
  						if (this.seekPonit !== undefined) {
  							_consumed = this.arrivalDataCallback(chunk, byteStart, this.seekPonit);
  							this.seekPonit = undefined;
  						} else {
  							_consumed = this.arrivalDataCallback(chunk, byteStart);
  						}
  						this.emit('performance', {
  							type: 'first-flv-to-mp4',
  							value: Date.now() - _transmuxerStart
  						});
  						if (_consumed < chunk.byteLength) {
  							var remain = chunk.byteLength - _consumed;
  							if (remain > this.bufferSize) {
  								this.expandBuffer(remain);
  								_stashArray = new Uint8Array(this.cacheBuffer, 0, this.bufferSize);
  							}
  							_stashArray.set(new Uint8Array(chunk, _consumed), 0);
  							this.cacheRemain += remain;
  							this.stashByteStart = byteStart + _consumed;
  						}
  					}
  				}
  			}
  		}
  		/**
    * 清空缓存buffer
    */

  	}, {
  		key: 'initCacheBuffer',
  		value: function initCacheBuffer() {
  			this.cacheRemain = 0;
  			this.totalReceive = 0;
  			this.cacheBuffer = new ArrayBuffer(this.bufferSize);
  		}

  		/**
    * 动态扩展buffer存储器大小
    * @param  {number} chunk byte size
    */

  	}, {
  		key: 'expandBuffer',
  		value: function expandBuffer(expectedBytes) {
  			var bufferNewSize = this.bufferSize;
  			// while (bufferNewSize < expectedBytes) {
  			//   bufferNewSize *= 2;
  			// }
  			if (bufferNewSize < expectedBytes) {
  				bufferNewSize = expectedBytes;
  			}
  			this.cacheBuffer = new ArrayBuffer(bufferNewSize);
  			this.bufferSize = bufferNewSize;
  		}

  		/**
    * 暂停
    */

  	}, {
  		key: 'pause',
  		value: function pause() {
  			this.loader.pause();
  		}

  		/**
    * 打开连接
    */

  	}, {
  		key: 'open',
  		value: function open(startBytes, keyframePoint) {
  			this.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.LOADER_OPEN, ts: Date.now() });
  			this.loader.open({ from: startBytes || 0, to: -1 }, keyframePoint);
  			this.heartbeat();
  		}

  		/**
    * 心跳
    */

  	}, {
  		key: 'heartbeat',
  		value: function heartbeat() {
  			var _this3 = this;

  			clearInterval(this.heartBeatInterval);
  			this.heartBeatInterval = setInterval(function () {
  				_this3.emit('heartbeat', {
  					speed: _this3.totalReceive - _this3.preTotalReceive,
  					totalReceive: _this3.totalReceive
  				});
  				_this3.preTotalReceive = _this3.totalReceive;
  			}, 1000);
  		}

  		/**
    * 重新播放
    */

  	}, {
  		key: 'resume',
  		value: function resume() {
  			this.paused = false;
  			var bytes = this.totalReceive;
  			this.open(bytes);
  		}

  		/**
    * seek
    */

  	}, {
  		key: 'seek',
  		value: function seek(bytes, dropCache, keyframePoint) {
  			this.seekLock = true;
  			this.totalReceive = bytes;
  			this.preTotalReceive = bytes;
  			this.initCacheBuffer();
  			this.cacheRemain = 0;
  			this.stashByteStart = 0;
  			this.open(bytes, keyframePoint);
  		}

  		/**
    * destory
    */

  	}, {
  		key: 'destroy',
  		value: function destroy() {
  			this.pause();
  			this.initCacheBuffer();
  			window.clearInterval(this.heartBeatInterval);
  			this.heartBeatInterval = null;
  			this.unbindEvent();
  		}
  	}]);

  	return Ioloader;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = Ioloader;

  /***/ }),
  /* 6 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function (range) {
    var headers = {};
    var param = void 0;

    if (range.to !== -1) {
      param = 'bytes=' + range.from.toString() + '-' + range.to.toString();
    } else {
      param = 'bytes=' + range.from.toString() + '-';
    }
    headers['Range'] = param;

    return {
      headers: headers
    };
  };

  /***/ }),
  /* 7 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


  var _flvParse = __webpack_require__(22);

  var _flvParse2 = _interopRequireDefault(_flvParse);

  var _tagdemux = __webpack_require__(8);

  var _tagdemux2 = _interopRequireDefault(_tagdemux);

  var _mp4remux = __webpack_require__(10);

  var _mp4remux2 = _interopRequireDefault(_mp4remux);

  var _mp4moof = __webpack_require__(28);

  var _mp4moof2 = _interopRequireDefault(_mp4moof);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _error = __webpack_require__(3);

  var _error2 = _interopRequireDefault(_error);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var flv2fmp4 = function () {

      /**
       * Creates an instance of flv2fmp4.
       * config 里面有_isLive属性,是否是直播
       * @param {any} config
       *
       * @memberof flv2fmp4
       */
      function flv2fmp4(config) {
          _classCallCheck(this, flv2fmp4);

          _mp4remux2.default.init();
          this._config = config;

          // 外部方法赋值
          this.onInitSegment = null;
          this.onMediaSegment = null;
          this.onMediaInfo = null;
          this.seekCallBack = null;
          this._onCdnDropFrame = null;

          // 内部使用
          this.loadmetadata = false;
          this.ftyp_moov = null; //单路
          this._tagdemux = new _tagdemux2.default();
          this._flvparse = new _flvParse2.default();
          this.ftyp_moov_v = null; //双路视频
          this.ftyp_moov_a = null; //双路音频
          this.metaSuccRun = false;
          this.metas = [];
          this.parseChunk = null;
          this.hasVideo = false;
          this.hasAudio = false;
          this._error = null;
          // 临时记录seek时间
          this._pendingResolveSeekPoint = -1;

          // 临时记录flv数据起始时间
          this._tempBaseTime = 0;

          // 处理flv数据入口
          this.setflvBase = this.setflvBasefrist;

          this._tagdemux._onTrackMetadata = this.Metadata.bind(this);
          this._tagdemux._onMediaInfo = this.metaSucc.bind(this);
          this._tagdemux._onDataAvailable = this.onDataAvailable.bind(this);
          this._tagdemux._onError = this.error.bind(this);
          this._tagdemux._onCdnDropFrame = this.onCdnDropFrame.bind(this);
          this.m4mof = new _mp4moof2.default(this._config);
          this.m4mof.onMediaSegment = this.onMdiaSegment.bind(this);
      }

      _createClass(flv2fmp4, [{
          key: 'seek',
          value: function seek(baseTime) {
              this._flvparse.dispose();
              this.setflvBase = this.setflvBasefrist;
              if (baseTime == undefined || baseTime == 0) {
                  baseTime = 0;
                  this._pendingResolveSeekPoint = -1;
              }
              if (this._tempBaseTime != baseTime) {
                  this._tempBaseTime = baseTime;
                  this._tagdemux._timestampBase = baseTime;
                  this.m4mof.seek(baseTime);
                  this.m4mof.insertDiscontinuity();
                  this._pendingResolveSeekPoint = baseTime;
              }
          }

          /**
           * 不要主动调用这个接口!!!!!!!!!!!!!!!!!!!!!!!!!!!!
           * 第一次接受数据,和seek时候接受数据入口,
           *
           * @param {any} arraybuff
           * @param {any} baseTime
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflvBasefrist',
          value: function setflvBasefrist(arraybuff, baseTime) {

              var offset = 0;
              try {
                  offset = this._flvparse.setFlv(new Uint8Array(arraybuff));
              } catch (error) {
                  this.error(error);
              }
              if (this._flvparse.arrTag.length == 0) return offset;
              // if(this._flvparse.arrTag[0].tagType!=18){
              //     if(this.error)this.error(new Error('without metadata tag'));
              // }
              if (this._flvparse.arrTag.length > 0) {
                  this._tagdemux.hasAudio = this.hasAudio = this._flvparse._hasAudio;
                  this._tagdemux.hasVideo = this.hasVideo = this._flvparse._hasVideo;

                  if (this._tempBaseTime != 0 && this._tempBaseTime == this._flvparse.arrTag[0].getTime()) {
                      this._tagdemux._timestampBase = 0;
                  }
                  try {
                      this._tagdemux.moofTag(this._flvparse.arrTag);
                  } catch (error) {
                      this.error(error);
                  }
                  this.setflvBase = this.setflvBaseUsually;
              }

              return offset;
          }

          /**
           * 不要主动调用这个接口!!!!!!!!!!!!!!!!!!!!!!!!!!!!
           * 后续接受数据接口
           * @param {any} arraybuff
           * @param {any} baseTime
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflvBaseUsually',
          value: function setflvBaseUsually(arraybuff, baseTime) {
              var offset = 0;
              try {
                  offset = this._flvparse.setFlv(new Uint8Array(arraybuff));
              } catch (error) {
                  this.error(error);
              }
              if (this._flvparse.arrTag.length > 0) {
                  try {
                      this._tagdemux.moofTag(this._flvparse.arrTag);
                  } catch (error) {
                      this.error(error);
                  }
              }

              return offset;
          }

          /**
           * 不要主动调用这个接口!!!!!!!!!!!!!!!!!!!!!!!!!!!!
           * moof回调
           *
           * @param {any} track
           * @param {any} value
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'onMdiaSegment',
          value: function onMdiaSegment(track, value) {

              if (this.onMediaSegment) {
                  this.onMediaSegment(track, new Uint8Array(value.data));
              }
              if (this._pendingResolveSeekPoint != -1 && track == 'video') {
                  var seekpoint = this._pendingResolveSeekPoint;
                  this._pendingResolveSeekPoint = -1;
                  if (this.seekCallBack) {
                      this.seekCallBack(seekpoint);
                  }
              }
          }

          /**
           *
           * 音频和视频的初始化tag
           *
           * @param {any} type
           * @param {any} meta
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'Metadata',
          value: function Metadata(type, meta) {
              switch (type) {
                  case 'video':
                      this.metas.push(['video', meta]);
                      this.m4mof._videoMeta = meta;
                      if (this.hasVideo && !this.hasAudio) {
                          this.metaSucc();
                          return;
                      }
                      break;
                  case 'audio':
                      this.metas.push(['audio', meta]);
                      this.m4mof._audioMeta = meta;
                      if (!this.hasVideo && this.hasAudio) {
                          this.metaSucc();
                          return;
                      }
                      break;
              }
              if (this.hasVideo && this.hasAudio && this.m4mof._videoMeta && this.m4mof._audioMeta) {
                  this.metaSucc();
              }
          }

          /**
           * metadata解读成功后触发及第一个视频tag和第一个音频tag
           *
           * @param {any} mi
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'metaSucc',
          value: function metaSucc(mi) {
              var _this = this;

              if (this.onMediaInfo && mi) {

                  this.onMediaInfo(mi || this._tagdemux._mediaInfo, { hasAudio: this.hasAudio, hasVideo: this.hasVideo });
              }
              // 获取ftyp和moov
              if (this.metas.length == 0) {
                  this.metaSuccRun = true;
                  return;
              }
              if (mi) return;
              if (this.metas.length > 1) {
                  // this.ftyp_moov_v=
                  this.metas.map(function (item) {
                      if (item[0] == 'video') {
                          _this.ftyp_moov_v = _mp4remux2.default.generateInitSegment([item[1]]);
                      } else {
                          _this.ftyp_moov_a = _mp4remux2.default.generateInitSegment([item[1]]);
                      }
                  });
              } else {
                  this.ftyp_moov = _mp4remux2.default.generateInitSegment([this.metas[0][1]]);
              }

              if (this.onInitSegment && this.loadmetadata == false) {

                  if (this.ftyp_moov) {
                      this.onInitSegment(this.ftyp_moov);
                  } else {
                      this.onInitSegment(this.ftyp_moov_v, this.ftyp_moov_a);
                  }
                  this.loadmetadata = true;
              }
          }
      }, {
          key: 'onDataAvailable',
          value: function onDataAvailable(audiotrack, videotrack) {
              // this.m4mof.remux(audiotrack, videotrack);

              try {
                  this.m4mof.remux(audiotrack, videotrack);
              } catch (e) {
                  this.error(e);
              }
          }

          /**
           * cdn丢帧回调
           */

      }, {
          key: 'onCdnDropFrame',
          value: function onCdnDropFrame(data) {
              if (this._onCdnDropFrame) this._onCdnDropFrame(data);
          }

          /**
           * 传入flv的二进制数据
           * 统一入口
           * @param {any} arraybuff
           * @param {any} baseTime flv数据开始时间
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflv',
          value: function setflv(arraybuff, baseTime) {
              return this.setflvBase(arraybuff, baseTime);
          }

          /**
           *
           * 本地调试代码,不用理会
           * @param {any} arraybuff
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflvloc',
          value: function setflvloc(arraybuff) {
              var offset = _flvParse2.default.setFlv(new Uint8Array(arraybuff));

              if (_flvParse2.default.arrTag.length > 0) {
                  return _flvParse2.default.arrTag;
              }
          }
          /**
           * 
           *  异常抛出处理
           * @param {any} e 
           * @memberof flv2fmp4
           */

      }, {
          key: 'error',
          value: function error(e) {
              if (this._error) {
                  this._error(e);
              }
          }
      }]);

      return flv2fmp4;
  }();

  /**
   * 封装的对外类,有些方法不想对外暴露,所以封装这么一个类
   *
   * @class foreign
   */


  var foreign = function (_CustEvent) {
      _inherits(foreign, _CustEvent);

      function foreign(config) {
          _classCallCheck(this, foreign);

          var _this2 = _possibleConstructorReturn(this, (foreign.__proto__ || Object.getPrototypeOf(foreign)).call(this));

          _this2.f2m = new flv2fmp4(config);
          _this2.f2m._error = _this2.error.bind(_this2);
          // 外部方法赋值
          _this2._onInitSegment = null;
          _this2._onMediaSegment = null;
          _this2._onMediaInfo = null;
          _this2._seekCallBack = null;
          return _this2;
      }

      _createClass(foreign, [{
          key: 'error',
          value: function error(e) {
              this.emit('error', e.type);
          }
          /**
           *
           * 跳转
           * @param {any} basetime  跳转时间
           *
           * @memberof foreign
           */

      }, {
          key: 'seek',
          value: function seek(basetime) {
              this.f2m.seek(basetime);
          }

          /**
           * 传入flv的二进制数据
           * 统一入口
           * @param {any} arraybuff
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflv',
          value: function setflv(arraybuff) {
              return this.f2m.setflv(arraybuff, 0);
          }

          /**
           *
           * 本地调试代码,不用理会
           * @param {any} arraybuff
           * @returns
           *
           * @memberof flv2fmp4
           */

      }, {
          key: 'setflvloc',
          value: function setflvloc(arraybuff) {
              return this.f2m.setflvloc(arraybuff);
          }

          /**
           * 赋值初始化seg接受方法
           *
           *
           * @memberof foreign
           */

      }, {
          key: 'onInitSegment',
          set: function set(fun) {
              this._onInitSegment = fun;
              this.f2m.onInitSegment = fun;
          }

          /**
           * 赋值moof接受方法
           *
           *
           * @memberof foreign
           */

      }, {
          key: 'onMediaSegment',
          set: function set(fun) {
              this._onMediaSegment = fun;
              this.f2m.onMediaSegment = fun;
          }

          /**
           * 赋值metadata接受方法
           *
           *
           * @memberof foreign
           */

      }, {
          key: 'onMediaInfo',
          set: function set(fun) {
              this._onMediaInfo = fun;
              this.f2m.onMediaInfo = fun;
          }

          /**
           * 赋值是否跳转回调接受方法
           *
           *
           * @memberof foreign
           */

      }, {
          key: 'seekCallBack',
          set: function set(fun) {
              this._seekCallBack = fun;
              this.f2m.seekCallBack = fun;
          }

          /**
           * cdn丢帧回调
           */

      }, {
          key: 'onCdnDropFrame',
          set: function set(fun) {
              console.log('set fun');
              this.f2m._onCdnDropFrame = fun;
          }
      }]);

      return foreign;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = foreign;

  /***/ }),
  /* 8 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


  var _flvdemux = __webpack_require__(24);

  var _flvdemux2 = _interopRequireDefault(_flvdemux);

  var _mediaInfo = __webpack_require__(27);

  var _mediaInfo2 = _interopRequireDefault(_mediaInfo);

  var _spsParser = __webpack_require__(9);

  var _spsParser2 = _interopRequireDefault(_spsParser);

  var _error = __webpack_require__(3);

  var _error2 = _interopRequireDefault(_error);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var tagDemux = function () {
      function tagDemux() {
          _classCallCheck(this, tagDemux);

          this.TAG = this.constructor.name;

          this._config = {};

          this._onError = null;
          this._onMediaInfo = null;
          this._onTrackMetadata = null;
          this._onDataAvailable = null;
          this._onCdnDropFrame = null;

          this._dataOffset = 0;
          this._firstParse = true;
          this._dispatch = false;

          this._hasAudio = false;
          this._hasVideo = false;

          this._audioInitialMetadataDispatched = false;
          this._videoInitialMetadataDispatched = false;

          this._mediaInfo = new _mediaInfo2.default();
          this._mediaInfo.hasAudio = this._hasAudio;
          this._mediaInfo.hasVideo = this._hasVideo;
          this._metadata = null;
          this._audioMetadata = null;
          this._videoMetadata = null;

          this._naluLengthSize = 4;
          this._timestampBase = 0; // int32, in milliseconds
          this._timescale = 1000;
          this._duration = 0; // int32, in milliseconds
          this._durationOverrided = false;
          this._referenceFrameRate = {
              fixed: true,
              fps: 23.976,
              fps_num: 23976,
              fps_den: 1000
          };

          this._videoTrack = { type: 'video', id: 1, sequenceNumber: 0, addcoefficient: 2, samples: [], length: 0 };
          this._audioTrack = { type: 'audio', id: 2, sequenceNumber: 0, addcoefficient: 2, samples: [], length: 0 };

          this._littleEndian = function () {
              var buf = new ArrayBuffer(2);
              new DataView(buf).setInt16(0, 256, true); // little-endian write
              return new Int16Array(buf)[0] === 256; // platform-spec read, if equal then LE
          }();

          // 时间戳修正
          this._timeInfo = {
              // aac第一个帧的dts
              aacFirstDts: 0,
              // aac当前处理帧帧相对第一个帧dts的偏移量
              aacCurrentDtsOffset: 0,
              // aac当前处理帧需要修正时长
              aacCurrentFixedLen: 0,
              // aac dts修正记录
              aacFixedRecord: [],
              avcSampleDuration: 40,
              avcLastDts: 0,
              avcLastPts: 0
          };
      }

      _createClass(tagDemux, [{
          key: 'onMediaInfo',
          value: function onMediaInfo(callback) {
              this._onMediaInfo = callback;
          }
      }, {
          key: 'parseFirstTimeStamp',
          value: function parseFirstTimeStamp(flvtag) {
              if (this._mediaInfo.beginTimeStamp) {
                  return;
              }
              this._mediaInfo.beginTimeStamp = flvtag.getTime();
              if (this._mediaInfo.audioCodec && this._mediaInfo.videoCodec) {
                  this._onMediaInfo(this._mediaInfo);
              }
          }
      }, {
          key: 'parseMetadata',
          value: function parseMetadata(arr) {
              var data = _flvdemux2.default.parseMetadata(arr);
              // kwai 因为首次上报mediaInfo的时候，是等到video开始parse之后拿到video相关信息补充才上报
              // 所以二次上报的时候不能走老逻辑了……临时性魔改这里
              if (this._mediaInfo.metadata) {
                  this._mediaInfo.metadata = data.onMetaData;
                  this._onMediaInfo(this._mediaInfo);
              }
              this._parseScriptData(data);
              // console.log(this._mediaInfo, this._mediaInfo.isComplete());
          }
      }, {
          key: '_parseScriptData',
          value: function _parseScriptData(obj) {
              var scriptData = obj;

              if (scriptData.hasOwnProperty('onMetaData')) {
                  if (this._metadata) ;
                  this._metadata = scriptData;
                  var onMetaData = this._metadata.onMetaData;

                  if (typeof onMetaData.hasAudio === 'boolean') {
                      // hasAudio
                      this._hasAudio = onMetaData.hasAudio;
                      this._mediaInfo.hasAudio = this._hasAudio;
                  }
                  if (typeof onMetaData.hasVideo === 'boolean') {
                      // hasVideo
                      this._hasVideo = onMetaData.hasVideo;
                      this._mediaInfo.hasVideo = this._hasVideo;
                  }
                  if (typeof onMetaData.audiodatarate === 'number') {
                      // audiodatarate
                      this._mediaInfo.audioDataRate = onMetaData.audiodatarate;
                  }
                  if (typeof onMetaData.videodatarate === 'number') {
                      // videodatarate
                      this._mediaInfo.videoDataRate = onMetaData.videodatarate;
                  }
                  if (typeof onMetaData.width === 'number') {
                      // width
                      this._mediaInfo.width = onMetaData.width;
                  }
                  if (typeof onMetaData.height === 'number') {
                      // height
                      this._mediaInfo.height = onMetaData.height;
                  }
                  if (typeof onMetaData.duration === 'number') {
                      // duration
                      if (!this._durationOverrided) {
                          var duration = Math.floor(onMetaData.duration * this._timescale);
                          this._duration = duration;
                          this._mediaInfo.duration = duration;
                      }
                  } else {
                      this._mediaInfo.duration = 0;
                  }
                  if (typeof onMetaData.framerate === 'number') {
                      // framerate
                      var fps_num = Math.floor(onMetaData.framerate * 1000);
                      if (fps_num > 0) {
                          var fps = fps_num / 1000;
                          this._referenceFrameRate.fixed = true;
                          this._referenceFrameRate.fps = fps;
                          this._referenceFrameRate.fps_num = fps_num;
                          this._referenceFrameRate.fps_den = 1000;
                          this._mediaInfo.fps = fps;
                          this._timeInfo.avcSampleDuration = Math.ceil(1000 / this._mediaInfo.fps) || 40;
                      }
                  }
                  if (_typeof(onMetaData.keyframes) === 'object') {
                      // keyframes
                      this._mediaInfo.hasKeyframesIndex = true;
                      var keyframes = onMetaData.keyframes;
                      keyframes.times = onMetaData.times;
                      keyframes.filepositions = onMetaData.filepositions;
                      this._mediaInfo.keyframesIndex = this._parseKeyframesIndex(keyframes);
                      onMetaData.keyframes = null; // keyframes has been extracted, remove it
                  } else {
                      this._mediaInfo.hasKeyframesIndex = false;
                  }
                  this._dispatch = false;
                  this._mediaInfo.metadata = onMetaData;
                  console.log(this.TAG, 'Parsed onMetaData');
                  // if (this._mediaInfo.isComplete()) {
                  // this._onMediaInfo(this._mediaInfo);
                  // }
                  return this._mediaInfo;
              }
          }
      }, {
          key: '_parseKeyframesIndex',
          value: function _parseKeyframesIndex(keyframes) {
              var times = [];
              var filepositions = [];

              // ignore first keyframe which is actually AVC Sequence Header (AVCDecoderConfigurationRecord)
              for (var i = 1; i < keyframes.times.length; i++) {
                  var time = this._timestampBase + Math.floor(keyframes.times[i] * 1000);
                  times.push(time);
                  filepositions.push(keyframes.filepositions[i]);
              }

              return {
                  times: times,
                  filepositions: filepositions
              };
          }

          /**
           * 传入tags输出moof和mdat
           *
           * @param {any} tags
           *
           * @memberof tagDemux
           */

      }, {
          key: 'moofTag',
          value: function moofTag(tags) {

              for (var i = 0; i < tags.length; i++) {
                  this._dispatch = true;
                  this.parseChunks(tags[i]);
                  // console.log("tagTimestamp", tags[i].getTime(), tags[i]);
              }
              if (this._isInitialMetadataDispatched()) {
                  if (this._dispatch && (this._audioTrack.length || this._videoTrack.length)) {
                      this._onDataAvailable(this._audioTrack, this._videoTrack);
                  }
              }
          }
      }, {
          key: 'parseChunks',
          value: function parseChunks(flvtag) {

              switch (flvtag.tagType) {
                  case 8:
                      // Audio
                      this._parseAudioData(flvtag.body.buffer, 0, flvtag.body.length, flvtag.getTime());
                      this.parseFirstTimeStamp(flvtag);
                      break;
                  case 9:
                      // Video
                      this._parseVideoData(flvtag.body.buffer, 0, flvtag.body.length, flvtag.getTime(), 0);
                      // kwai上报第一帧video的timestamp
                      this.parseFirstTimeStamp(flvtag);
                      break;
                  case 18:
                      // ScriptDataObject
                      // kwai需要在mediaInfo上补充初始的timestamp
                      this.parseMetadata(flvtag.body);
                      break;
              }
          }
      }, {
          key: '_parseVideoData',
          value: function _parseVideoData(arrayBuffer, dataOffset, dataSize, tagTimestamp, tagPosition) {
              if (tagTimestamp == this._timestampBase && this._timestampBase != 0) {
                  throw new _error2.default(tagTimestamp, this._timestampBase, '夭寿啦这个视频不是从0开始');
                  // this.timestampBase(0);
              }
              if (dataSize <= 1) {
                  console.log(this.TAG, 'Flv: Invalid video packet, missing VideoData payload!');
                  return;
              }
              // 获取 video tag body 第一字节
              var spec = new Uint8Array(arrayBuffer, dataOffset, dataSize)[0];
              // 获取是否是关键帧
              var frameType = (spec & 240) >>> 4;
              // 获取编码格式
              var codecId = spec & 15;

              if (codecId !== 7) {
                  if (this._onError) this._onError('Flv: Unsupported codec in video frame: ' + codecId);
                  return;
              }

              this._parseAVCVideoPacket(arrayBuffer, dataOffset + 1, dataSize - 1, tagTimestamp, tagPosition, frameType);
          }
      }, {
          key: '_parseAVCVideoPacket',
          value: function _parseAVCVideoPacket(arrayBuffer, dataOffset, dataSize, tagTimestamp, tagPosition, frameType) {

              if (dataSize < 4) {
                  console.log(this.TAG, 'Flv: Invalid AVC packet, missing AVCPacketType or/and CompositionTime');
                  return;
              }

              var le = this._littleEndian;
              // 获取 video tag body 第2字节到结尾
              var v = new DataView(arrayBuffer, dataOffset, dataSize);

              // IF CodecID == 7  AVCPacketType
              // 0 = AVC sequence header
              // 1 = AVC NALU
              // 2 = AVC end of sequence (lower level NALU sequence ender is not required or supported)
              var packetType = v.getUint8(0);
              // 3字节
              // IF AVCPacketType == 1
              //  Composition time offset
              // ELSE
              //  0
              var cts = v.getUint32(0, !le) & 0x00FFFFFF;

              // IF AVCPacketType == 0 AVCDecoderConfigurationRecord（AVC sequence header）
              // IF AVCPacketType == 1 One or more NALUs (Full frames are required)

              /**
               *AVCDecoderConfigurationRecord.包含着是H.264解码相关比较重要的sps和pps信息，
               *再给AVC解码器送数据 流之前一定要把sps和pps信息送出，否则的话解码器不能正常解码。
               *而且在解码器stop之后再次start之前，如seek、快进快退状态切换等，
               *都 需要重新送一遍sps和pps的信息.AVCDecoderConfigurationRecord在FLV文件中一般情况也是出现1次，
               *也就是第一个 video tag.
               */
              if (packetType === 0) {
                  // AVCDecoderConfigurationRecord
                  this._parseAVCDecoderConfigurationRecord(arrayBuffer, dataOffset + 4, dataSize - 4);
              } else if (packetType === 1) {
                  // One or more Nalus
                  this._parseAVCVideoData(arrayBuffer, dataOffset + 4, dataSize - 4, tagTimestamp, tagPosition, frameType, cts);
              } else if (packetType === 2) ; else {
                  this._onError('Flv: Invalid video packet type ' + packetType);
                  return;
              }
          }

          /**
           * AVC 初始化
           */

      }, {
          key: '_parseAVCDecoderConfigurationRecord',
          value: function _parseAVCDecoderConfigurationRecord(arrayBuffer, dataOffset, dataSize) {
              if (dataSize < 7) {
                  console.log(this.TAG, 'Flv: Invalid AVCDecoderConfigurationRecord, lack of data!');
                  return;
              }

              var meta = this._videoMetadata;
              var track = this._videoTrack;
              var le = this._littleEndian;
              var v = new DataView(arrayBuffer, dataOffset, dataSize);

              if (!meta) {
                  meta = this._videoMetadata = {};
                  meta.type = 'video';
                  meta.id = track.id;
                  meta.timescale = this._timescale;
                  meta.duration = this._duration;
              } else {
                  if (typeof meta.avcc !== 'undefined') {
                      console.log(this.TAG, 'Found another AVCDecoderConfigurationRecord!');
                  }
              }

              var version = v.getUint8(0); // configurationVersion
              var avcProfile = v.getUint8(1); // avcProfileIndication
              var profileCompatibility = v.getUint8(2); // profile_compatibility
              var avcLevel = v.getUint8(3); // AVCLevelIndication

              if (version !== 1 || avcProfile === 0) {
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: Invalid AVCDecoderConfigurationRecord');
                  return;
              }

              this._naluLengthSize = (v.getUint8(4) & 3) + 1; // lengthSizeMinusOne
              if (this._naluLengthSize !== 3 && this._naluLengthSize !== 4) {
                  // holy shit!!!
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: Strange NaluLengthSizeMinusOne: ' + (this._naluLengthSize - 1));
                  return;
              }

              var spsCount = v.getUint8(5) & 31; // numOfSequenceParameterSets
              if (spsCount === 0 || spsCount > 1) {
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: Invalid H264 SPS count: ' + spsCount);
                  return;
              }

              var offset = 6;

              for (var i = 0; i < spsCount; i++) {
                  var len = v.getUint16(offset, !le); // sequenceParameterSetLength
                  offset += 2;

                  if (len === 0) {
                      continue;
                  }

                  // Notice: Nalu without startcode header (00 00 00 01)
                  var sps = new Uint8Array(arrayBuffer, dataOffset + offset, len);
                  offset += len;

                  var config = _spsParser2.default.parseSPS(sps);
                  meta.codecWidth = config.codec_size.width;
                  meta.codecHeight = config.codec_size.height;
                  meta.presentWidth = config.present_size.width;
                  meta.presentHeight = config.present_size.height;
                  meta.config = config;
                  meta.profile = config.profile_string;
                  meta.level = config.level_string;
                  meta.bitDepth = config.bit_depth;
                  meta.chromaFormat = config.chroma_format;
                  meta.sarRatio = config.sar_ratio;
                  meta.frameRate = config.frame_rate;

                  if (config.frame_rate.fixed === false || config.frame_rate.fps_num === 0 || config.frame_rate.fps_den === 0) {
                      meta.frameRate = this._referenceFrameRate;
                  }

                  var fps_den = meta.frameRate.fps_den;
                  var fps_num = meta.frameRate.fps_num;
                  meta.refSampleDuration = Math.floor(meta.timescale * (fps_den / fps_num));

                  var codecArray = sps.subarray(1, 4);
                  var codecString = 'avc1.';
                  for (var j = 0; j < 3; j++) {
                      var h = codecArray[j].toString(16);
                      if (h.length < 2) {
                          h = '0' + h;
                      }
                      codecString += h;
                  }
                  meta.codec = codecString;

                  var mi = this._mediaInfo;
                  mi.width = meta.codecWidth;
                  mi.height = meta.codecHeight;
                  mi.fps = meta.frameRate.fps;
                  mi.profile = meta.profile;
                  mi.level = meta.level;
                  mi.chromaFormat = config.chroma_format_string;
                  mi.sarNum = meta.sarRatio.width;
                  mi.sarDen = meta.sarRatio.height;
                  mi.videoCodec = codecString;
                  mi.meta = meta;
                  if (mi.hasAudio) {
                      if (mi.audioCodec != null) {
                          mi.mimeType = 'video/x-flv; codecs="' + mi.videoCodec + ',' + mi.audioCodec + '"';
                      }
                  } else {
                      mi.mimeType = 'video/x-flv; codecs="' + mi.videoCodec + '"';
                  }
                  if (mi.isComplete()) {
                      this._onMediaInfo(mi);
                  }
              }

              var ppsCount = v.getUint8(offset); // numOfPictureParameterSets
              if (ppsCount === 0 || ppsCount > 1) {
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: Invalid H264 PPS count: ' + ppsCount);
                  return;
              }

              offset++;

              for (var _i = 0; _i < ppsCount; _i++) {
                  var _len = v.getUint16(offset, !le); // pictureParameterSetLength
                  offset += 2;

                  if (_len === 0) {
                      continue;
                  }

                  // pps is useless for extracting video information
                  offset += _len;
              }

              meta.avcc = new Uint8Array(dataSize);
              meta.avcc.set(new Uint8Array(arrayBuffer, dataOffset, dataSize), 0);
              console.log(this.TAG, 'Parsed AVCDecoderConfigurationRecord');

              if (this._isInitialMetadataDispatched()) {
                  // flush parsed frames
                  if (this._dispatch && (this._audioTrack.length || this._videoTrack.length)) {
                      this._onDataAvailable(this._audioTrack, this._videoTrack);
                  }
              } else {
                  this._videoInitialMetadataDispatched = true;
              }
              // notify new metadata
              this._dispatch = false;
              // if (this._onTrackMetadata) {
              //     this._onTrackMetadata.call(null, meta);
              // }

              this._onTrackMetadata('video', meta);
          }
      }, {
          key: 'timestampBase',
          value: function timestampBase(i) {
              this._timestampBase = i;
          }

          /**
           * 普通的AVC 片段
           */

      }, {
          key: '_parseAVCVideoData',
          value: function _parseAVCVideoData(arrayBuffer, dataOffset, dataSize, tagTimestamp, tagPosition, frameType, cts) {

              var le = this._littleEndian;
              var v = new DataView(arrayBuffer, dataOffset, dataSize);

              var units = [],
                  length = 0;

              var offset = 0;
              var lengthSize = this._naluLengthSize;
              var dts = this._timestampBase + tagTimestamp;
              var keyframe = frameType === 1; // from FLV Frame Type constants

              var avcDts = dts;
              // 清理aac对齐数据
              for (var i = 0; i < this._timeInfo.aacFixedRecord.length; i++) {
                  if (dts > this._timeInfo.aacFixedRecord[i].ed) {
                      this._timeInfo.aacFixedRecord.splice(0, i);
                      break;
                  }
              }

              // 是否需要对齐，通过pts差计算
              if (this._timeInfo.avcLastDts) {
                  // 帧间距增加时尝试对齐
                  if (avcDts - this._timeInfo.avcLastDts > this._timeInfo.avcSampleDuration) {
                      var fixByAudio = false;
                      // 尝试利用acc的时间修正记录this._timeInfo.aacFixedRecord为参照修正视频时间，进行对齐
                      for (var _i2 = 0; _i2 < this._timeInfo.aacFixedRecord.length; _i2++) {
                          if (avcDts >= this._timeInfo.aacFixedRecord[_i2].st && avcDts <= this._timeInfo.aacFixedRecord[_i2].ed) {
                              avcDts = avcDts - this._timeInfo.aacFixedRecord[_i2].fix;
                              fixByAudio = true;
                              // 修正后是否仍然有时间跳变
                              if (this._timeInfo.aacFixedRecord[_i2].ed == Number.POSITIVE_INFINITY && avcDts - this._timeInfo.avcLastDts > this._timeInfo.avcSampleDuration) {
                                  fixByAudio = false;
                              }
                              break;
                          }
                      }

                      // 无法参照音频时间修正时，累加一个this._timeInfo.avcSampleDuration
                      if (!fixByAudio) {
                          avcDts = this._timeInfo.avcLastDts + this._timeInfo.avcSampleDuration;
                      }

                      // 同步后重叠，加速播放
                      if (avcDts <= this._timeInfo.avcLastDts) {
                          avcDts = this._timeInfo.avcLastDts + 1;
                      }
                  }
              }
              var avcPts = avcDts + cts;
              while (offset < dataSize) {
                  if (offset + 4 >= dataSize) {
                      console.log(this.TAG, 'Malformed Nalu near timestamp ' + dts + ', offset = ' + offset + ', dataSize = ' + dataSize);
                      break; // data not enough for next Nalu
                  }
                  // Nalu with length-header (AVC1)
                  var naluSize = v.getUint32(offset, !le); // Big-Endian read
                  if (lengthSize === 3) {
                      naluSize >>>= 8;
                  }
                  if (naluSize > dataSize - lengthSize) {
                      console.log(this.TAG, 'Malformed Nalus near timestamp ' + dts + ', NaluSize > DataSize!');
                      return;
                  }

                  var unitType = v.getUint8(offset + lengthSize) & 0x1F;

                  if (unitType === 5) {
                      // IDR
                      keyframe = true;
                  }

                  var data = new Uint8Array(arrayBuffer, dataOffset + offset, lengthSize + naluSize);
                  var unit = { type: unitType, data: data };
                  units.push(unit);
                  length += data.byteLength;

                  offset += lengthSize + naluSize;
              }

              if (units.length) {
                  var track = this._videoTrack;
                  var avcSample = {
                      units: units,
                      length: length,
                      isKeyframe: keyframe,
                      dts: avcDts,
                      cts: cts,
                      pts: avcPts
                  };
                  if (keyframe) {
                      avcSample.fileposition = tagPosition;
                  }
                  track.samples.push(avcSample);
                  track.length += length;
              }
              this._timeInfo.avcLastDts = avcDts;
          }
      }, {
          key: '_parseAudioData',
          value: function _parseAudioData(arrayBuffer, dataOffset, dataSize, tagTimestamp) {
              if (tagTimestamp == this._timestampBase && this._timestampBase != 0) {
                  console.log(tagTimestamp, this._timestampBase, '夭寿啦这个视频不是从0开始');
                  // timestampBase(0);
              }

              if (dataSize <= 1) {
                  console.log(this.TAG, 'Flv: Invalid audio packet, missing SoundData payload!');
                  return;
              }

              var meta = this._audioMetadata;
              var track = this._audioTrack;

              if (!meta || !meta.codec) {
                  // initial metadata
                  meta = this._audioMetadata = {};
                  meta.type = 'audio';
                  meta.id = track.id;
                  meta.timescale = this._timescale;
                  meta.duration = this._duration;

                  var le = this._littleEndian;
                  var v = new DataView(arrayBuffer, dataOffset, dataSize);

                  var soundSpec = v.getUint8(0);

                  var soundFormat = soundSpec >>> 4;
                  if (soundFormat !== 10) {
                      // AAC
                      // TODO: support MP3 audio codec
                      this._onError(DemuxErrors.CODEC_UNSUPPORTED, 'Flv: Unsupported audio codec idx: ' + soundFormat);
                      return;
                  }

                  var soundRate = 0;
                  var soundRateIndex = (soundSpec & 12) >>> 2;

                  var soundRateTable = [5500, 11025, 22050, 44100, 48000];

                  if (soundRateIndex < soundRateTable.length) {
                      soundRate = soundRateTable[soundRateIndex];
                  } else {
                      this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: Invalid audio sample rate idx: ' + soundRateIndex);
                      return;
                  }
                  var soundType = soundSpec & 1;

                  meta.audioSampleRate = soundRate;
                  meta.channelCount = soundType === 0 ? 1 : 2;
                  meta.refSampleDuration = Math.floor(1024 / meta.audioSampleRate * meta.timescale);
                  meta.codec = 'mp4a.40.5';
              }

              var aacData = this._parseAACAudioData(arrayBuffer, dataOffset + 1, dataSize - 1);
              if (aacData == undefined) {
                  return;
              }

              if (aacData.packetType === 0) {
                  // AAC sequence header (AudioSpecificConfig)
                  if (meta.config) {
                      console.log(this.TAG, 'Found another AudioSpecificConfig!');
                  }
                  var misc = aacData.data;
                  meta.audioSampleRate = misc.samplingRate;
                  meta.channelCount = misc.channelCount;
                  meta.codec = misc.codec;
                  meta.config = misc.config;
                  // The decode result of an aac sample is 1024 PCM samples
                  meta.refSampleDuration = Math.floor(1024 / meta.audioSampleRate * meta.timescale);
                  console.log(this.TAG, 'Parsed AudioSpecificConfig');

                  if (this._isInitialMetadataDispatched()) {
                      // Non-initial metadata, force dispatch (or flush) parsed frames to remuxer
                      if (this._dispatch && (this._audioTrack.length || this._videoTrack.length)) {
                          this._onDataAvailable(this._audioTrack, this._videoTrack);
                      }
                  } else {
                      this._audioInitialMetadataDispatched = true;
                  }
                  // then notify new metadata
                  this._dispatch = false;

                  var mi = this._mediaInfo;
                  mi.audioCodec = 'mp4a.40.' + misc.originalAudioObjectType;
                  mi.audioSampleRate = meta.audioSampleRate;
                  mi.audioChannelCount = meta.channelCount;
                  if (mi.hasVideo) {
                      if (mi.videoCodec != null) {
                          mi.mimeType = 'video/x-flv; codecs="' + mi.videoCodec + ',' + mi.audioCodec + '"';
                      }
                  } else {
                      mi.mimeType = 'video/x-flv; codecs="' + mi.audioCodec + '"';
                  }
                  this._onTrackMetadata('audio', meta);
                  if (mi.isComplete()) {
                      this._onMediaInfo(mi);
                  }
                  return;
              } else if (aacData.packetType === 1) {
                  // AAC raw frame data
                  var dts = this._timestampBase + tagTimestamp;
                  if (!this._timeInfo.aacFirstDts) this._timeInfo.aacFirstDts = dts;
                  // 通过时间计算的dts与通过帧长度计算的dts比对，判断是否发生了跳帧
                  var dtsDiff = dts - Math.floor(this._timeInfo.aacFirstDts + this._timeInfo.aacCurrentDtsOffset) - this._timeInfo.aacCurrentFixedLen;
                  if (dtsDiff > 1) {
                      this._timeInfo.aacCurrentFixedLen += dtsDiff;
                      // 闭合上个跳帧范围记录
                      if (this._timeInfo.aacFixedRecord.length) {
                          this._timeInfo.aacFixedRecord[this._timeInfo.aacFixedRecord.length - 1].ed = dts;
                      }
                      // 需要修正的时间范围:st到ed范围内的时间修正fix的长度
                      this._timeInfo.aacFixedRecord.push({ st: dts, fix: this._timeInfo.aacCurrentFixedLen, ed: Number.POSITIVE_INFINITY });
                      if (this._onCdnDropFrame) this._onCdnDropFrame(dtsDiff);
                  }
                  // aac帧长度
                  var aacFrameLen = 1024 * 1000 / meta.audioSampleRate;
                  // 通过aac帧长度累加计算dts
                  var aacDts = Math.floor(this._timeInfo.aacFirstDts + this._timeInfo.aacCurrentDtsOffset);
                  var aacSample = {
                      unit: aacData.data,
                      dts: aacDts,
                      pts: aacDts,
                      length: aacFrameLen
                  };
                  this._timeInfo.aacCurrentDtsOffset += aacFrameLen;
                  track.samples.push(aacSample);
                  track.length += aacData.data.length;
              } else {
                  console.log(this.TAG, 'Flv: Unsupported AAC data type ' + aacData.packetType);
              }
          }
      }, {
          key: '_parseAACAudioData',
          value: function _parseAACAudioData(arrayBuffer, dataOffset, dataSize) {
              if (dataSize <= 1) {
                  console.log(this.TAG, 'Flv: Invalid AAC packet, missing AACPacketType or/and Data!');
                  return;
              }

              var result = {};
              var array = new Uint8Array(arrayBuffer, dataOffset, dataSize);

              result.packetType = array[0];

              if (array[0] === 0) {
                  result.data = this._parseAACAudioSpecificConfig(arrayBuffer, dataOffset + 1, dataSize - 1);
              } else {
                  result.data = array.subarray(1);
              }

              return result;
          }
      }, {
          key: '_parseAACAudioSpecificConfig',
          value: function _parseAACAudioSpecificConfig(arrayBuffer, dataOffset, dataSize) {
              var array = new Uint8Array(arrayBuffer, dataOffset, dataSize);
              var config = null;

              var mpegSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];

              /* Audio Object Type:
                 0: Null
                 1: AAC Main
                 2: AAC LC
                 3: AAC SSR (Scalable Sample Rate)
                 4: AAC LTP (Long Term Prediction)
                 5: HE-AAC / SBR (Spectral Band Replication)
                 6: AAC Scalable
              */

              var audioObjectType = 0;
              var originalAudioObjectType = 0;
              var samplingIndex = 0;
              var extensionSamplingIndex = null;
              // debugger;
              // 5 bits
              audioObjectType = originalAudioObjectType = array[0] >>> 3;
              // 4 bits
              samplingIndex = (array[0] & 0x07) << 1 | array[1] >>> 7;
              if (samplingIndex < 0 || samplingIndex >= mpegSamplingRates.length) {
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: AAC invalid sampling frequency index!');
                  return;
              }

              var samplingFrequence = mpegSamplingRates[samplingIndex];

              // 4 bits
              var channelConfig = (array[1] & 0x78) >>> 3;
              if (channelConfig < 0 || channelConfig >= 8) {
                  this._onError(DemuxErrors.FORMAT_ERROR, 'Flv: AAC invalid channel configuration');
                  return;
              }

              if (audioObjectType === 5) {
                  // HE-AAC?
                  // 4 bits
                  extensionSamplingIndex = (array[1] & 0x07) << 1 | array[2] >>> 7;
              }

              // workarounds for various browsers
              var userAgent = self.navigator.userAgent.toLowerCase();

              if (userAgent.indexOf('firefox') !== -1) {
                  // firefox: use SBR (HE-AAC) if freq less than 24kHz
                  if (samplingIndex >= 6) {
                      audioObjectType = 5;
                      config = new Array(4);
                      extensionSamplingIndex = samplingIndex - 3;
                  } else {
                      // use LC-AAC
                      audioObjectType = 2;
                      config = new Array(2);
                      extensionSamplingIndex = samplingIndex;
                  }
              } else if (userAgent.indexOf('android') !== -1) {
                  // android: always use LC-AAC
                  audioObjectType = 2;
                  config = new Array(2);
                  extensionSamplingIndex = samplingIndex;
              } else {
                  // for other browsers, e.g. chrome...
                  // Always use HE-AAC to make it easier to switch aac codec profile
                  audioObjectType = 5;
                  extensionSamplingIndex = samplingIndex;
                  config = new Array(4);

                  if (samplingIndex >= 6) {
                      extensionSamplingIndex = samplingIndex - 3;
                  } else if (channelConfig === 1) {
                      // Mono channel
                      audioObjectType = 2;
                      config = new Array(2);
                      extensionSamplingIndex = samplingIndex;
                  }
              }

              config[0] = audioObjectType << 3;
              config[0] |= (samplingIndex & 0x0F) >>> 1;
              config[1] = (samplingIndex & 0x0F) << 7;
              config[1] |= (channelConfig & 0x0F) << 3;
              if (audioObjectType === 5) {
                  config[1] |= (extensionSamplingIndex & 0x0F) >>> 1;
                  config[2] = (extensionSamplingIndex & 0x01) << 7;
                  // extended audio object type: force to 2 (LC-AAC)
                  config[2] |= 2 << 2;
                  config[3] = 0;
              }

              return {
                  config: config,
                  samplingRate: samplingFrequence,
                  channelCount: channelConfig,
                  codec: 'mp4a.40.' + audioObjectType,
                  originalAudioObjectType: originalAudioObjectType
              };
          }
      }, {
          key: '_isInitialMetadataDispatched',
          value: function _isInitialMetadataDispatched() {
              if (this._hasAudio && this._hasVideo) {
                  // both audio & video
                  return this._audioInitialMetadataDispatched && this._videoInitialMetadataDispatched;
              }
              if (this._hasAudio && !this._hasVideo) {
                  // audio only
                  return this._audioInitialMetadataDispatched;
              }
              if (!this._hasAudio && this._hasVideo) {
                  // video only
                  return this._videoInitialMetadataDispatched;
              }
          }
      }, {
          key: 'hasAudio',
          set: function set(s) {
              this._mediaInfo.hasAudio = this._hasAudio = s;
          }
      }, {
          key: 'hasVideo',
          set: function set(s) {
              this._mediaInfo.hasVideo = this._hasVideo = s;
          }
      }, {
          key: 'onCdnDropFrame',
          set: function set(fun) {
              this._onCdnDropFrame = fun;
          }
      }]);

      return tagDemux;
  }();
  // export default new tagDemux();


  exports.default = tagDemux;

  /***/ }),
  /* 9 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (C) 2016 Bilibili. All Rights Reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @author zheng qian <xqq@xqq.im>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *     http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */
  /* eslint-disable */


  var _expGolomb = __webpack_require__(26);

  var _expGolomb2 = _interopRequireDefault(_expGolomb);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var SPSParser = function () {
      function SPSParser() {
          _classCallCheck(this, SPSParser);
      }

      _createClass(SPSParser, null, [{
          key: '_ebsp2rbsp',
          value: function _ebsp2rbsp(uint8array) {
              var src = uint8array;
              var src_length = src.byteLength;
              var dst = new Uint8Array(src_length);
              var dst_idx = 0;

              for (var i = 0; i < src_length; i++) {
                  if (i >= 2) {
                      // Unescape: Skip 0x03 after 00 00
                      if (src[i] === 0x03 && src[i - 1] === 0x00 && src[i - 2] === 0x00) {
                          continue;
                      }
                  }
                  dst[dst_idx] = src[i];
                  dst_idx++;
              }

              return new Uint8Array(dst.buffer, 0, dst_idx);
          }
      }, {
          key: 'parseSPS',
          value: function parseSPS(uint8array) {
              var rbsp = SPSParser._ebsp2rbsp(uint8array);
              var gb = new _expGolomb2.default(rbsp);

              gb.readByte();
              var profile_idc = gb.readByte(); // profile_idc
              gb.readByte(); // constraint_set_flags[5] + reserved_zero[3]
              var level_idc = gb.readByte(); // level_idc
              gb.readUEG(); // seq_parameter_set_id

              var profile_string = SPSParser.getProfileString(profile_idc);
              var level_string = SPSParser.getLevelString(level_idc);
              var chroma_format_idc = 1;
              var chroma_format = 420;
              var chroma_format_table = [0, 420, 422, 444];
              var bit_depth = 8;

              if (profile_idc === 100 || profile_idc === 110 || profile_idc === 122 || profile_idc === 244 || profile_idc === 44 || profile_idc === 83 || profile_idc === 86 || profile_idc === 118 || profile_idc === 128 || profile_idc === 138 || profile_idc === 144) {

                  chroma_format_idc = gb.readUEG();
                  if (chroma_format_idc === 3) {
                      gb.readBits(1); // separate_colour_plane_flag
                  }
                  if (chroma_format_idc <= 3) {
                      chroma_format = chroma_format_table[chroma_format_idc];
                  }

                  bit_depth = gb.readUEG() + 8; // bit_depth_luma_minus8
                  gb.readUEG(); // bit_depth_chroma_minus8
                  gb.readBits(1); // qpprime_y_zero_transform_bypass_flag
                  if (gb.readBool()) {
                      // seq_scaling_matrix_present_flag
                      var scaling_list_count = chroma_format_idc !== 3 ? 8 : 12;
                      for (var i = 0; i < scaling_list_count; i++) {
                          if (gb.readBool()) {
                              // seq_scaling_list_present_flag
                              if (i < 6) {
                                  SPSParser._skipScalingList(gb, 16);
                              } else {
                                  SPSParser._skipScalingList(gb, 64);
                              }
                          }
                      }
                  }
              }
              gb.readUEG(); // log2_max_frame_num_minus4
              var pic_order_cnt_type = gb.readUEG();
              if (pic_order_cnt_type === 0) {
                  gb.readUEG(); // log2_max_pic_order_cnt_lsb_minus_4
              } else if (pic_order_cnt_type === 1) {
                  gb.readBits(1); // delta_pic_order_always_zero_flag
                  gb.readSEG(); // offset_for_non_ref_pic
                  gb.readSEG(); // offset_for_top_to_bottom_field
                  var num_ref_frames_in_pic_order_cnt_cycle = gb.readUEG();
                  for (var _i = 0; _i < num_ref_frames_in_pic_order_cnt_cycle; _i++) {
                      gb.readSEG(); // offset_for_ref_frame
                  }
              }
              gb.readUEG(); // max_num_ref_frames
              gb.readBits(1); // gaps_in_frame_num_value_allowed_flag

              var pic_width_in_mbs_minus1 = gb.readUEG();
              var pic_height_in_map_units_minus1 = gb.readUEG();

              var frame_mbs_only_flag = gb.readBits(1);
              if (frame_mbs_only_flag === 0) {
                  gb.readBits(1); // mb_adaptive_frame_field_flag
              }
              gb.readBits(1); // direct_8x8_inference_flag

              var frame_crop_left_offset = 0;
              var frame_crop_right_offset = 0;
              var frame_crop_top_offset = 0;
              var frame_crop_bottom_offset = 0;

              var frame_cropping_flag = gb.readBool();
              if (frame_cropping_flag) {
                  frame_crop_left_offset = gb.readUEG();
                  frame_crop_right_offset = gb.readUEG();
                  frame_crop_top_offset = gb.readUEG();
                  frame_crop_bottom_offset = gb.readUEG();
              }

              var sar_width = 1,
                  sar_height = 1;
              var fps = 0,
                  fps_fixed = true,
                  fps_num = 0,
                  fps_den = 0;

              var vui_parameters_present_flag = gb.readBool();
              if (vui_parameters_present_flag) {
                  if (gb.readBool()) {
                      // aspect_ratio_info_present_flag
                      var aspect_ratio_idc = gb.readByte();
                      var sar_w_table = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2];
                      var sar_h_table = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];

                      if (aspect_ratio_idc > 0 && aspect_ratio_idc < 16) {
                          sar_width = sar_w_table[aspect_ratio_idc - 1];
                          sar_height = sar_h_table[aspect_ratio_idc - 1];
                      } else if (aspect_ratio_idc === 255) {
                          sar_width = gb.readByte() << 8 | gb.readByte();
                          sar_height = gb.readByte() << 8 | gb.readByte();
                      }
                  }

                  if (gb.readBool()) {
                      // overscan_info_present_flag
                      gb.readBool(); // overscan_appropriate_flag
                  }
                  if (gb.readBool()) {
                      // video_signal_type_present_flag
                      gb.readBits(4); // video_format & video_full_range_flag
                      if (gb.readBool()) {
                          // colour_description_present_flag
                          gb.readBits(24); // colour_primaries & transfer_characteristics & matrix_coefficients
                      }
                  }
                  if (gb.readBool()) {
                      // chroma_loc_info_present_flag
                      gb.readUEG(); // chroma_sample_loc_type_top_field
                      gb.readUEG(); // chroma_sample_loc_type_bottom_field
                  }
                  if (gb.readBool()) {
                      // timing_info_present_flag
                      var num_units_in_tick = gb.readBits(32);
                      var time_scale = gb.readBits(32);
                      fps_fixed = gb.readBool(); // fixed_frame_rate_flag

                      fps_num = time_scale;
                      fps_den = num_units_in_tick * 2;
                      fps = fps_num / fps_den;
                  }
              }

              var sarScale = 1;
              if (sar_width !== 1 || sar_height !== 1) {
                  sarScale = sar_width / sar_height;
              }

              var crop_unit_x = 0,
                  crop_unit_y = 0;
              if (chroma_format_idc === 0) {
                  crop_unit_x = 1;
                  crop_unit_y = 2 - frame_mbs_only_flag;
              } else {
                  var sub_wc = chroma_format_idc === 3 ? 1 : 2;
                  var sub_hc = chroma_format_idc === 1 ? 2 : 1;
                  crop_unit_x = sub_wc;
                  crop_unit_y = sub_hc * (2 - frame_mbs_only_flag);
              }

              var codec_width = (pic_width_in_mbs_minus1 + 1) * 16;
              var codec_height = (2 - frame_mbs_only_flag) * ((pic_height_in_map_units_minus1 + 1) * 16);

              codec_width -= (frame_crop_left_offset + frame_crop_right_offset) * crop_unit_x;
              codec_height -= (frame_crop_top_offset + frame_crop_bottom_offset) * crop_unit_y;

              var present_width = Math.ceil(codec_width * sarScale);

              gb.destroy();
              gb = null;

              return {
                  profile_string: profile_string, // baseline, high, high10, ...
                  level_string: level_string, // 3, 3.1, 4, 4.1, 5, 5.1, ...
                  bit_depth: bit_depth, // 8bit, 10bit, ...
                  chroma_format: chroma_format, // 4:2:0, 4:2:2, ...
                  chroma_format_string: SPSParser.getChromaFormatString(chroma_format),

                  frame_rate: {
                      fixed: fps_fixed,
                      fps: fps,
                      fps_den: fps_den,
                      fps_num: fps_num
                  },

                  sar_ratio: {
                      width: sar_width,
                      height: sar_height
                  },

                  codec_size: {
                      width: codec_width,
                      height: codec_height
                  },

                  present_size: {
                      width: present_width,
                      height: codec_height
                  }
              };
          }
      }, {
          key: '_skipScalingList',
          value: function _skipScalingList(gb, count) {
              var last_scale = 8,
                  next_scale = 8;
              var delta_scale = 0;
              for (var i = 0; i < count; i++) {
                  if (next_scale !== 0) {
                      delta_scale = gb.readSEG();
                      next_scale = (last_scale + delta_scale + 256) % 256;
                  }
                  last_scale = next_scale === 0 ? last_scale : next_scale;
              }
          }
      }, {
          key: 'getProfileString',
          value: function getProfileString(profile_idc) {
              switch (profile_idc) {
                  case 66:
                      return 'Baseline';
                  case 77:
                      return 'Main';
                  case 88:
                      return 'Extended';
                  case 100:
                      return 'High';
                  case 110:
                      return 'High10';
                  case 122:
                      return 'High422';
                  case 244:
                      return 'High444';
                  default:
                      return 'Unknown';
              }
          }
      }, {
          key: 'getLevelString',
          value: function getLevelString(level_idc) {
              return (level_idc / 10).toFixed(1);
          }
      }, {
          key: 'getChromaFormatString',
          value: function getChromaFormatString(chroma) {
              switch (chroma) {
                  case 420:
                      return '4:2:0';
                  case 422:
                      return '4:2:2';
                  case 444:
                      return '4:4:4';
                  default:
                      return 'Unknown';
              }
          }
      }]);

      return SPSParser;
  }();

  exports.default = SPSParser;

  /***/ }),
  /* 10 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * 代码借鉴了flv.js
   * 增加了自己的注释和写法
   */
  /* eslint-disable */
  var MP4 = function () {
      function MP4() {
          _classCallCheck(this, MP4);
      }

      _createClass(MP4, null, [{
          key: 'init',
          value: function init() {
              MP4.types = {
                  avc1: [],
                  avcC: [],
                  btrt: [],
                  dinf: [],
                  dref: [],
                  esds: [],
                  ftyp: [],
                  hdlr: [],
                  mdat: [],
                  mdhd: [],
                  mdia: [],
                  mfhd: [],
                  minf: [],
                  moof: [],
                  moov: [],
                  mp4a: [],
                  mvex: [],
                  mvhd: [],
                  sdtp: [],
                  stbl: [],
                  stco: [],
                  stsc: [],
                  stsd: [],
                  stsz: [],
                  stts: [],
                  tfdt: [],
                  tfhd: [],
                  traf: [],
                  trak: [],
                  trun: [],
                  trex: [],
                  tkhd: [],
                  vmhd: [],
                  smhd: []
              };

              for (var name in MP4.types) {
                  if (MP4.types.hasOwnProperty(name)) {
                      MP4.types[name] = [name.charCodeAt(0), name.charCodeAt(1), name.charCodeAt(2), name.charCodeAt(3)];
                  }
              }

              var constants = MP4.constants = {};

              constants.FTYP = new Uint8Array([0x69, 0x73, 0x6F, 0x6D, // major_brand: isom		isom	MP4  Base Media v1 [IS0 14496-12:2003]	ISO	YES	video/mp4
              0x0, 0x0, 0x0, 0x1, // minor_version: 0x01
              0x69, 0x73, 0x6F, 0x6D, // isom
              0x61, 0x76, 0x63, 0x31 // avc1
              ]);

              constants.STSD_PREFIX = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags  version字段后会有一个entry count字段
              0x00, 0x00, 0x00, 0x01 // entry_count	根据entry的个数，每个entry会有type信息，如“vide”、“sund”等，根据type不同sample description会提供不同的信息，例如对于video track，会有“VisualSampleEntry”类型信息，对于audio track会有“AudioSampleEntry”类型信息。
              ]);

              constants.STTS = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              0x00, 0x00, 0x00, 0x00 // entry_count     0个索引
              ]);

              constants.STSC = constants.STCO = constants.STTS;

              constants.STSZ = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              0x00, 0x00, 0x00, 0x00, // sample_size
              0x00, 0x00, 0x00, 0x00 // sample_count
              ]);

              constants.HDLR_VIDEO = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              0x00, 0x00, 0x00, 0x00, // pre_defined
              0x76, 0x69, 0x64, 0x65, // handler_type: 'vide' 在media box中，该值为4个字符		“vide”— video track
              0x00, 0x00, 0x00, 0x00, // reserved: 3 * 4 bytes
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // 保留位
              0x56, 0x69, 0x64, 0x65, 0x6F, 0x48, 0x61, 0x6E, 0x64, 0x6C, 0x65, 0x72, 0x00 // name: VideoHandler 长度不定		track type name，以‘\0’结尾的字符串
              ]);

              constants.HDLR_AUDIO = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              0x00, 0x00, 0x00, 0x00, // pre_defined
              0x73, 0x6F, 0x75, 0x6E, // handler_type: 'soun'在media box中，该值为4个字符		“soun”— audio track
              0x00, 0x00, 0x00, 0x00, // reserved: 3 * 4 bytes
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // 保留位
              0x53, 0x6F, 0x75, 0x6E, 0x64, 0x48, 0x61, 0x6E, 0x64, 0x6C, 0x65, 0x72, 0x00 // name: SoundHandler 长度不定		track type name，以‘\0’结尾的字符串
              ]);

              constants.DREF = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              0x00, 0x00, 0x00, 0x01, // entry_count 1个url
              // url	box开始
              0x00, 0x00, 0x00, 0x0C, // entry_size
              0x75, 0x72, 0x6C, 0x20, // type 'url '
              0x00, 0x00, 0x00, 0x01 // version(0) + flags 当“url”或“urn”的box flag为1时，字符串均为空。
              ]);

              // Sound media header
              constants.SMHD = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags	box版本，0或1，一般为0。
              0x00, 0x00, 0x00, 0x00 // balance(2) + reserved(2) 立体声平衡，[8.8] 格式值，一般为0，-1.0表示全部左声道，1.0表示全部右声道+2位保留位
              ]);

              // video media header
              constants.VMHD = new Uint8Array([0x00, 0x00, 0x00, 0x01, // version(0) + flags
              0x00, 0x00, // graphicsmode: 2 bytes 视频合成模式，为0时拷贝原始图像，否则与opcolor进行合成   //理论上是4位啊  暂时保留
              0x00, 0x00, 0x00, 0x00, // opcolor: 3 * 2 bytes ｛red，green，blue｝
              0x00, 0x00]);
          }

          /**
           * 封装box
           */

      }, {
          key: 'box',
          value: function box(type) {
              var size = 8;
              var result = null;
              var datas = Array.prototype.slice.call(arguments, 1);
              var arrayCount = datas.length;

              for (var i = 0; i < arrayCount; i++) {
                  size += datas[i].byteLength;
              }
              // box头部大小
              result = new Uint8Array(size);
              result[0] = size >>> 24 & 0xFF; // size
              result[1] = size >>> 16 & 0xFF;
              result[2] = size >>> 8 & 0xFF;
              result[3] = size & 0xFF;
              // 写入box的type
              result.set(type, 4); // type

              var offset = 8;
              for (var _i = 0; _i < arrayCount; _i++) {
                  // data body
                  result.set(datas[_i], offset);
                  offset += datas[_i].byteLength;
              }

              return result;
          }

          // 创建ftyp&moov

      }, {
          key: 'generateInitSegment',
          value: function generateInitSegment(meta) {
              if (meta.constructor != Array) {
                  meta = [meta];
              }
              var ftyp = MP4.box(MP4.types.ftyp, MP4.constants.FTYP);
              var moov = MP4.moov(meta);

              var result = new Uint8Array(ftyp.byteLength + moov.byteLength);
              result.set(ftyp, 0);
              result.set(moov, ftyp.byteLength);
              return result;
          }

          // Movie metadata box

      }, {
          key: 'moov',
          value: function moov(meta) {
              var mvhd = MP4.mvhd(meta[0].timescale, meta[0].duration); // /moov里面的第一个box
              var vtrak = MP4.trak(meta[0]);
              var atrak = void 0;
              if (meta.length > 1) {
                  atrak = MP4.trak(meta[1]);
              }

              var mvex = MP4.mvex(meta);
              if (meta.length > 1) {
                  return MP4.box(MP4.types.moov, mvhd, vtrak, atrak, mvex);
              } else {
                  return MP4.box(MP4.types.moov, mvhd, vtrak, mvex);
              }
          }

          // Movie header box

      }, {
          key: 'mvhd',
          value: function mvhd(timescale, duration) {
              return MP4.box(MP4.types.mvhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags     1位的box版本+3位flags   box版本，0或1，一般为0。（以下字节数均按version=0）
              0x00, 0x00, 0x00, 0x00, // creation_time    创建时间  （相对于UTC时间1904-01-01零点的秒数）
              0x00, 0x00, 0x00, 0x00, // modification_time   修改时间
              timescale >>> 24 & 0xFF, // timescale: 4 bytes		文件媒体在1秒时间内的刻度值，可以理解为1秒长度
              timescale >>> 16 & 0xFF, timescale >>> 8 & 0xFF, timescale & 0xFF, duration >>> 24 & 0xFF, // duration: 4 bytes	该track的时间长度，用duration和time scale值可以计算track时长，比如audio track的time scale = 8000, duration = 560128，时长为70.016，video track的time scale = 600, duration = 42000，时长为70
              duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, 0x00, 0x01, 0x00, 0x00, // Preferred rate: 1.0   推荐播放速率，高16位和低16位分别为小数点整数部分和小数部分，即[16.16] 格式，该值为1.0（0x00010000）表示正常前向播放
              0x01, 0x00, 0x00, 0x00, // PreferredVolume(1.0, 2bytes) + reserved(2bytes)	与rate类似，[8.8] 格式，1.0（0x0100）表示最大音量
              0x00, 0x00, 0x00, 0x00, // reserved: 4 + 4 bytes	保留位
              0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, // ----begin composition matrix----
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // 视频变换矩阵   线性代数
              0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // ----end composition matrix----
              0x00, 0x00, 0x00, 0x00, // ----begin pre_defined 6 * 4 bytes----
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre-defined 保留位
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // ----end pre_defined 6 * 4 bytes----
              0xFF, 0xFF, 0xFF, 0xFF // next_track_ID 下一个track使用的id号
              ]));
          }

          // Track box

      }, {
          key: 'trak',
          value: function trak(meta) {
              return MP4.box(MP4.types.trak, MP4.tkhd(meta), MP4.mdia(meta));
          }

          // Track header box

      }, {
          key: 'tkhd',
          value: function tkhd(meta) {
              var trackId = meta.id,
                  duration = meta.duration;
              var width = meta.presentWidth,
                  height = meta.presentHeight;

              return MP4.box(MP4.types.tkhd, new Uint8Array([0x00, 0x00, 0x00, 0x07, // version(0) + flags 1位版本 box版本，0或1，一般为0。（以下字节数均按version=0）按位或操作结果值，预定义如下：
              // 0x000001 track_enabled，否则该track不被播放；
              // 0x000002 track_in_movie，表示该track在播放中被引用；
              // 0x000004 track_in_preview，表示该track在预览时被引用。
              // 一般该值为7，1+2+4 如果一个媒体所有track均未设置track_in_movie和track_in_preview，将被理解为所有track均设置了这两项；对于hint track，该值为0
              // hint track  这个特殊的track并不包含媒体数据，而是包含了一些将其他数据track打包成流媒体的指示信息。
              0x00, 0x00, 0x00, 0x00, // creation_time	创建时间（相对于UTC时间1904-01-01零点的秒数）
              0x00, 0x00, 0x00, 0x00, // modification_time	修改时间
              trackId >>> 24 & 0xFF, // track_ID: 4 bytes	id号，不能重复且不能为0
              trackId >>> 16 & 0xFF, trackId >>> 8 & 0xFF, trackId & 0xFF, 0x00, 0x00, 0x00, 0x00, // reserved: 4 bytes    保留位
              duration >>> 24 & 0xFF, // duration: 4 bytes  	track的时间长度
              duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, 0x00, 0x00, 0x00, 0x00, // reserved: 2 * 4 bytes    保留位
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // layer(2bytes) + alternate_group(2bytes)  视频层，默认为0，值小的在上层.track分组信息，默认为0表示该track未与其他track有群组关系
              0x00, 0x00, 0x00, 0x00, // volume(2bytes) + reserved(2bytes)    [8.8] 格式，如果为音频track，1.0（0x0100）表示最大音量；否则为0   +保留位
              0x00, 0x01, 0x00, 0x00, // ----begin composition matrix----
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, // 视频变换矩阵
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // ----end composition matrix----
              width >>> 8 & 0xFF, // //宽度
              width & 0xFF, 0x00, 0x00, height >>> 8 & 0xFF, // 高度
              height & 0xFF, 0x00, 0x00]));
          }

          /**
           * “mdia”也是个container box，其子box的结构和种类还是比较复杂的。先来看一个“mdia”的实例结构树图。
           * 总体来说，“mdia”定义了track媒体类型以及sample数据，描述sample信息。一般“mdia”包含一个“mdhd”，
           * 一个“hdlr”和一个“minf”，其中“mdhd”为media header box，“hdlr”为handler reference box，
           * “minf”为media information box。
           *
           * mdia
           * 		mdhd
           * 		hdlr
           * 		minf
           * 			smhd
           * 			dinf
           * 				dref
           * 					url
           * 			stbl
           * 				stsd
           * 					mp4a
           * 						esds
           * 				stts
           * 				stsc
           * 				stsz
           * 				stco
           */

      }, {
          key: 'mdia',
          value: function mdia(meta) {
              return MP4.box(MP4.types.mdia, MP4.mdhd(meta), MP4.hdlr(meta), MP4.minf(meta));
          }

          // Media header box

      }, {
          key: 'mdhd',
          value: function mdhd(meta) {
              var timescale = meta.timescale;
              var duration = meta.duration;
              return MP4.box(MP4.types.mdhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags // version(0) + flags		box版本，0或1，一般为0。
              0x00, 0x00, 0x00, 0x00, // creation_time    创建时间
              0x00, 0x00, 0x00, 0x00, // modification_time修改时间
              timescale >>> 24 & 0xFF, // timescale: 4 bytes    文件媒体在1秒时间内的刻度值，可以理解为1秒长度
              timescale >>> 16 & 0xFF, timescale >>> 8 & 0xFF, timescale & 0xFF, duration >>> 24 & 0xFF, // duration: 4 bytes  track的时间长度
              duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, 0x55, 0xC4, // language: und (undetermined) 媒体语言码。最高位为0，后面15位为3个字符（见ISO 639-2/T标准中定义）
              0x00, 0x00 // pre_defined = 0
              ]));
          }

          // Media handler reference box

      }, {
          key: 'hdlr',
          value: function hdlr(meta) {
              var data = null;
              if (meta.type === 'audio') {
                  data = MP4.constants.HDLR_AUDIO;
              } else {
                  data = MP4.constants.HDLR_VIDEO;
              }
              return MP4.box(MP4.types.hdlr, data);
          }

          /**
          * “minf”存储了解释track媒体数据的handler-specific信息，media handler用这些信息将媒体时间映射到媒体数据并进行处理。“minf”中的信息格式和内容与媒体类型以及解释媒体数据的media handler密切相关，其他media handler不知道如何解释这些信息。“minf”是一个container box，其实际内容由子box说明。
          一般情况下，“minf”包含一个header box，一个“dinf”和一个“stbl”，其中，header box根据track type（即media handler type）分为“vmhd”、“smhd”、“hmhd”和“nmhd”，“dinf”为data information box，“stbl”为sample table box。下面分别介绍。
          *
          */
          // Media infomation box

      }, {
          key: 'minf',
          value: function minf(meta) {
              // header box根据track type（即media handler type）分为“vmhd”、“smhd”、“hmhd”和“nmhd”
              var xmhd = null;
              if (meta.type === 'audio') {
                  xmhd = MP4.box(MP4.types.smhd, MP4.constants.SMHD);
              } else {
                  xmhd = MP4.box(MP4.types.vmhd, MP4.constants.VMHD);
              }
              return MP4.box(MP4.types.minf, xmhd, MP4.dinf(), MP4.stbl(meta));
          }

          /**
           * Data Information Box
           * “dinf”解释如何定位媒体信息，是一个container box。“dinf”一般包含一个“dref”，即data reference box；
           * “dref”下会包含若干个“url”或“urn”，这些box组成一个表，用来定位track数据。
           * 简单的说，track可以被分成若干段，每一段都可以根据“url”或“urn”指向的地址来获取数据，
           * sample描述中会用这些片段的序号将这些片段组成一个完整的track。
           * 一般情况下，当数据被完全包含在文件中时，“url”或“urn”中的定位字符串是空的。
           */

      }, {
          key: 'dinf',
          value: function dinf() {
              var result = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, MP4.constants.DREF));
              return result;
          }

          /**
          * Sample Table Box（stbl）
          	*	“stbl”几乎是普通的MP4文件中最复杂的一个box了，首先需要回忆一下sample的概念。
          * 	sample是媒体数据存储的单位，存储在media的chunk中，chunk和sample的长度均可互不相同，如下图所示。
          “stbl”是一个container box，其子box包括：sample description box（stsd）、
          * time to sample box（stts）、sample size box（stsz或stz2）、
          * sample to chunk box（stsc）、chunk offset box（stco或co64）、
          * composition time to sample box（ctts）、sync sample box（stss）
          * stsd”必不可少，且至少包含一个条目，该box包含了data reference box进行sample数据检索的信息。
          * 没有“stsd”就无法计算media sample的存储位置。“stsd”包含了编码的信息，其存储的信息随媒体类型不同而不同。
          * 			stbl
          * 				stsd
          * 					avc1
          * 						avcC
          * 				stts
          * 				stsc
          * 				stsz
          * 				stco
          */

      }, {
          key: 'stbl',
          value: function stbl(meta) {
              var result = MP4.box(MP4.types.stbl, // type: stbl
              MP4.stsd(meta), // Sample Description Table
              MP4.box(MP4.types.stts, MP4.constants.STTS), // Time-To-Sample    因为stts的entry count 为0
              // 所以没有关键帧index 的stss
              // 也没有CTTS box CTTS是记录偏移量
              MP4.box(MP4.types.stsc, MP4.constants.STSC), // Sample-To-Chunk
              MP4.box(MP4.types.stsz, MP4.constants.STSZ), // Sample size
              MP4.box(MP4.types.stco, MP4.constants.STCO) // Chunk offset
              );
              return result;
          }

          /**
          * Sample Description Box（stsd）
          		box header和version字段后会有一个entry count字段，
          * 			根据entry的个数，每个entry会有type信息，如“vide”、“sund”等，
          * 		根据type不同sample description会提供不同的信息，例如对于video track，
          * 会有“VisualSampleEntry”类型信息，对于audio track会有“AudioSampleEntry”类型信息。
          * * 				stsd
          * 					mp4a
          * 						esds
          *
          *
          *
          *
          * 		 4 bytes - length in total
          	 4 bytes - 4 char code of sample description table (stsd)
          	 4 bytes - version & flags
          	 4 bytes - number of sample entries (num_sample_entries)
          		 [
          		    4 bytes - length of sample entry (len_sample_entry)
          		    4 bytes - 4 char code of sample entry
          		    ('len_sample_entry' - 8) bytes of data
          		 ] (repeated 'num_sample_entries' times)
          	(4 bytes - optional 0x00000000 as end of box marker )
          */

      }, {
          key: 'stsd',
          value: function stsd(meta) {
              if (meta.type === 'audio') {
                  return MP4.box(MP4.types.stsd, MP4.constants.STSD_PREFIX, MP4.mp4a(meta));
              } else {
                  return MP4.box(MP4.types.stsd, MP4.constants.STSD_PREFIX, MP4.avc1(meta));
              }
          }
      }, {
          key: 'mp4a',
          value: function mp4a(meta) {
              var channelCount = meta.channelCount;
              var sampleRate = meta.audioSampleRate;

              var data = new Uint8Array([0x00, 0x00, 0x00, 0x00, // reserved(4) 6个字节，设置为0；
              0x00, 0x00, 0x00, 0x01, // reserved(2) + data_reference_index(2)
              0x00, 0x00, 0x00, 0x00, // reserved: 2 * 4 bytes 保留位
              0x00, 0x00, 0x00, 0x00, 0x00, channelCount, // channelCount(2) 单声道还是双声道
              0x00, 0x10, // sampleSize(2)
              0x00, 0x00, 0x00, 0x00, // reserved(4) 4字节保留位
              sampleRate >>> 8 & 0xFF, // Audio sample rate 显然要右移16位才有意义	template unsigned int(32) samplerate = {timescale of media}<<16;
              sampleRate & 0xFF, 0x00, 0x00]);

              return MP4.box(MP4.types.mp4a, data, MP4.esds(meta));
          }
      }, {
          key: 'esds',
          value: function esds(meta) {
              var config = meta.config;
              var configSize = config.length;
              var data = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version 0 + flags

              0x03, // descriptor_type    MP4ESDescrTag
              0x17 + configSize, // length3
              0x00, 0x01, // es_id
              0x00, // stream_priority

              0x04, // descriptor_type    MP4DecConfigDescrTag
              0x0F + configSize, // length
              0x40, // codec: mpeg4_audio
              /**
               *当objectTypeIndication为0x40时，为MPEG-4 Audio（MPEG-4 Audio generally is thought of as AAC
               * but there is a whole framework of audio codecs that can Go in MPEG-4 Audio including AAC, BSAC, ALS, CELP,
               * and something called MP3On4），如果想更细分format为aac还是mp3，
               * 可以读取MP4DecSpecificDescr层data[0]的前五位
               */
              0x15, // stream_type: Audio
              0x00, 0x00, 0x00, // buffer_size
              0x00, 0x00, 0x00, 0x00, // maxBitrate
              0x00, 0x00, 0x00, 0x00, // avgBitrate

              0x05 // descriptor_type MP4DecSpecificDescrTag
              ].concat([configSize]).concat(config).concat([0x06, 0x01, 0x02 // GASpecificConfig
              ]));
              return MP4.box(MP4.types.esds, data);
          }

          /**
           * 改版
           *stsd下的avc1视频解析
           */

      }, {
          key: 'avc1',
          value: function avc1(meta) {
              var avcc = meta.avcc;
              var width = meta.codecWidth,
                  height = meta.codecHeight;

              var data = new Uint8Array([0x00, 0x00, 0x00, 0x00, // // reserved(4)    6个 保留位	Reserved：6个字节，设置为0；
              0x00, 0x00, 0x00, 0x01, // reserved(2) + {{{{data_reference_index(2)  数据引用索引}}}}
              0x00, 0x00, 0x00, 0x00, // pre_defined(2) + reserved(2)
              0x00, 0x00, 0x00, 0x00, // pre_defined: 3 * 4 bytes  3*4个字节的保留位
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, width >>> 8 & 0xFF, // width: 2 bytes
              width & 0xFF, height >>> 8 & 0xFF, // height: 2 bytes
              height & 0xFF, 0x00, 0x48, 0x00, 0x00, // horizresolution: 4 bytes 常数
              0x00, 0x48, 0x00, 0x00, // vertresolution: 4 bytes 常数
              0x00, 0x00, 0x00, 0x00, // reserved: 4 bytes 保留位
              0x00, 0x01, // frame_count
              // frame_count表明多少帧压缩视频存储在每个样本。默认是1,每样一帧;它可能超过1每个样本的多个帧数
              0x04, //	strlen compressorname: 32 bytes			String[32]
              // 32个8 bit    第一个8bit表示长度,剩下31个8bit表示内容
              0x67, 0x31, 0x31, 0x31, // compressorname: 32 bytes    翻译过来是g111
              0x00, 0x00, 0x00, 0x00, //
              0x00, 0x00, 0x00, 0x00, //
              0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x18, // depth 颜色深度
              0xFF, 0xFF // pre_defined = -1
              ]);
              return MP4.box(MP4.types.avc1, data, MP4.box(MP4.types.avcC, avcc));
          }

          // Movie Extends box

      }, {
          key: 'mvex',
          value: function mvex(meta) {
              if (meta.length > 1) {
                  return MP4.box(MP4.types.mvex, MP4.trex(meta[0]), MP4.trex(meta[1]));
              } else {
                  return MP4.box(MP4.types.mvex, MP4.trex(meta[0]));
              }
          }

          // Track Extends box

      }, {
          key: 'trex',
          value: function trex(meta) {
              var trackId = meta.id;
              var data = new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) + flags
              trackId >>> 24 & 0xFF, // track_ID
              trackId >>> 16 & 0xFF, trackId >>> 8 & 0xFF, trackId & 0xFF, 0x00, 0x00, 0x00, 0x01, // default_sample_description_index
              0x00, 0x00, 0x00, 0x00, // default_sample_duration
              0x00, 0x00, 0x00, 0x00, // default_sample_size
              0x00, 0x01, 0x00, 0x01 // default_sample_flags
              ]);
              // if (meta.type !== 'video') {
              //     data[data.length - 1] = 0x00;
              // }
              return MP4.box(MP4.types.trex, data);
          }

          // Movie fragment box

      }, {
          key: 'moof',
          value: function moof(track, baseMediaDecodeTime) {
              return MP4.box(MP4.types.moof, MP4.mfhd(track.sequenceNumber), MP4.traf(track, baseMediaDecodeTime));
          }
      }, {
          key: 'mfhd',
          value: function mfhd(sequenceNumber) {
              var data = new Uint8Array([0x00, 0x00, 0x00, 0x00, sequenceNumber >>> 24 & 0xFF, // sequence_number: int32
              sequenceNumber >>> 16 & 0xFF, sequenceNumber >>> 8 & 0xFF, sequenceNumber & 0xFF]);
              return MP4.box(MP4.types.mfhd, data);
          }

          // Track fragment box

      }, {
          key: 'traf',
          value: function traf(track, baseMediaDecodeTime) {
              var trackId = track.id;

              // Track fragment header box
              var tfhd = MP4.box(MP4.types.tfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) & flags
              trackId >>> 24 & 0xFF, // track_ID
              trackId >>> 16 & 0xFF, trackId >>> 8 & 0xFF, trackId & 0xFF]));
              // Track Fragment Decode Time
              var tfdt = MP4.box(MP4.types.tfdt, new Uint8Array([0x00, 0x00, 0x00, 0x00, // version(0) & flags
              baseMediaDecodeTime >>> 24 & 0xFF, // baseMediaDecodeTime: int32
              baseMediaDecodeTime >>> 16 & 0xFF, baseMediaDecodeTime >>> 8 & 0xFF, baseMediaDecodeTime & 0xFF]));
              var sdtp = MP4.sdtp(track);
              var trun = MP4.trun(track, sdtp.byteLength + 16 + 16 + 8 + 16 + 8 + 8);

              return MP4.box(MP4.types.traf, tfhd, tfdt, trun, sdtp);
          }

          // Sample Dependency Type box

      }, {
          key: 'sdtp',
          value: function sdtp(track) {
              var samples = track.samples || [];
              var sampleCount = samples.length;
              var data = new Uint8Array(4 + sampleCount);
              // 0~4 bytes: version(0) & flags
              for (var i = 0; i < sampleCount; i++) {
                  var flags = samples[i].flags;
                  data[i + 4] = flags.isLeading << 6 | // is_leading: 2 (bit)
                  flags.dependsOn << 4 // sample_depends_on
                  | flags.isDependedOn << 2 // sample_is_depended_on
                  | flags.hasRedundancy; // sample_has_redundancy
              }
              return MP4.box(MP4.types.sdtp, data);
          }

          // Track fragment run box

      }, {
          key: 'trun',
          value: function trun(track, offset) {
              var samples = track.samples || [];
              var sampleCount = samples.length;
              var dataSize = 12 + 16 * sampleCount;
              var data = new Uint8Array(dataSize);
              offset += 8 + dataSize;

              data.set([0x00, 0x00, 0x0F, 0x01, // version(0) & flags
              sampleCount >>> 24 & 0xFF, // sample_count
              sampleCount >>> 16 & 0xFF, sampleCount >>> 8 & 0xFF, sampleCount & 0xFF, offset >>> 24 & 0xFF, // data_offset
              offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF], 0);

              for (var i = 0; i < sampleCount; i++) {

                  var duration = samples[i].duration;

                  var size = samples[i].size;
                  var flags = samples[i].flags;
                  var cts = samples[i].cts;
                  data.set([duration >>> 24 & 0xFF, // sample_duration
                  duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, size >>> 24 & 0xFF, // sample_size
                  size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF, flags.isLeading << 2 | flags.dependsOn, // sample_flags
                  flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.isNonSync, 0x00, 0x00, // sample_degradation_priority
                  cts >>> 24 & 0xFF, // sample_composition_time_offset
                  cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF], 12 + 16 * i);
              }
              return MP4.box(MP4.types.trun, data);
          }
      }, {
          key: 'mdat',
          value: function mdat(data) {
              return MP4.box(MP4.types.mdat, data);
          }
      }]);

      return MP4;
  }();

  exports.default = MP4;

  /***/ }),
  /* 11 */
  /***/ (function(module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function(global) {
  /**
   * chimee-helper v0.2.11
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  (function (global, factory) {
  	 factory(exports);
  }(this, (function (exports) {
  var commonjsGlobal$$1 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};



  function unwrapExports$$1 (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule$$1(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };

  // true  -> String#at
  // false -> String#codePointAt
  var _stringAt = function (TO_STRING) {
    return function (that, pos) {
      var s = String(_defined(that));
      var i = _toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
        ? TO_STRING ? s.charAt(i) : a
        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

  var _library = true;

  var _global = createCommonjsModule$$1(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule$$1(function (module) {
  var core = module.exports = { version: '2.5.3' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  });

  var _core_1 = _core.version;

  var _aFunction = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function (fn, that, length) {
    _aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var _isObject = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function (it) {
    if (!_isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document$1 = _global.document;
  // typeof document.createElement is 'object' in old IE
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function (it) {
    return is ? document$1.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function () {
    return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function (it, S) {
    if (!_isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if (_ie8DomDefine) try {
      return dP(O, P, Attributes);
    } catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var _hide = _descriptors ? function (object, key, value) {
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var PROTOTYPE = 'prototype';

  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && key in exports) continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? _ctx(out, _global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? (function (C) {
        var F = function (a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0: return new C();
              case 1: return new C(a);
              case 2: return new C(a, b);
            } return new C(a, b, c);
          } return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      // make static versions for prototype methods
      })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library`
  var _export = $export;

  var _redefine = _hide;

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  var _iterators = {};

  var toString = {}.toString;

  var _cof = function (it) {
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  // eslint-disable-next-line no-prototype-builtins
  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings


  var _toIobject = function (it) {
    return _iobject(_defined(it));
  };

  // 7.1.15 ToLength

  var min = Math.min;
  var _toLength = function (it) {
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max = Math.max;
  var min$1 = Math.min;
  var _toAbsoluteIndex = function (index, length) {
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes



  var _arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = _toIobject($this);
      var length = _toLength(O.length);
      var index = _toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
      } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});
  var _shared = function (key) {
    return store[key] || (store[key] = {});
  };

  var id = 0;
  var px = Math.random();
  var _uid = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var shared = _shared('keys');

  var _sharedKey = function (key) {
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO$1 = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function (object, names) {
    var O = _toIobject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO$1) _has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)



  var _objectKeys = Object.keys || function keys(O) {
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    _anObject(O);
    var keys = _objectKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
    return O;
  };

  var document$2 = _global.document;
  var _html = document$2 && document$2.documentElement;

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



  var IE_PROTO = _sharedKey('IE_PROTO');
  var Empty = function () { /* empty */ };
  var PROTOTYPE$1 = 'prototype';

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = _domCreate('iframe');
    var i = _enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    _html.appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
    return createDict();
  };

  var _objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE$1] = _anObject(O);
      result = new Empty();
      Empty[PROTOTYPE$1] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : _objectDps(result, Properties);
  };

  var _wks = createCommonjsModule$$1(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] =
      USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
  });

  var def = _objectDp.f;

  var TAG = _wks('toStringTag');

  var _setToStringTag = function (it, tag, stat) {
    if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
  };

  var IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  _hide(IteratorPrototype, _wks('iterator'), function () { return this; });

  var _iterCreate = function (Constructor, NAME, next) {
    Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
    _setToStringTag(Constructor, NAME + ' Iterator');
  };

  // 7.1.13 ToObject(argument)

  var _toObject = function (it) {
    return Object(_defined(it));
  };

  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


  var IE_PROTO$2 = _sharedKey('IE_PROTO');
  var ObjectProto = Object.prototype;

  var _objectGpo = Object.getPrototypeOf || function (O) {
    O = _toObject(O);
    if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectProto : null;
  };

  var ITERATOR = _wks('iterator');
  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';

  var returnThis = function () { return this; };

  var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    _iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
      if (!BUGGY && kind in proto) return proto[kind];
      switch (kind) {
        case KEYS: return function keys() { return new Constructor(this, kind); };
        case VALUES: return function values() { return new Constructor(this, kind); };
      } return function entries() { return new Constructor(this, kind); };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = (!BUGGY && $native) || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
      IteratorPrototype = _objectGpo($anyNative.call(new Base()));
      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        _setToStringTag(IteratorPrototype, TAG, true);
      }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;
      $default = function values() { return $native.call(this); };
    }
    // Define iterator
    if ((FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      _hide(proto, ITERATOR, $default);
    }
    // Plug for library
    _iterators[NAME] = $default;
    _iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) _redefine(proto, key, methods[key]);
      } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

  var $at = _stringAt(true);

  // 21.1.3.27 String.prototype[@@iterator]()
  _iterDefine(String, 'String', function (iterated) {
    this._t = String(iterated); // target
    this._i = 0;                // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return { value: undefined, done: true };
    point = $at(O, index);
    this._i += point.length;
    return { value: point, done: false };
  });

  // call something on iterator step with safe closing on error

  var _iterCall = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) _anObject(ret.call(iterator));
      throw e;
    }
  };

  // check on default Array iterator

  var ITERATOR$1 = _wks('iterator');
  var ArrayProto = Array.prototype;

  var _isArrayIter = function (it) {
    return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
  };

  var _createProperty = function (object, index, value) {
    if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
    else object[index] = value;
  };

  // getting tag from 19.1.3.6 Object.prototype.toString()

  var TAG$1 = _wks('toStringTag');
  // ES3 wrong here
  var ARG = _cof(function () { return arguments; }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (e) { /* empty */ }
  };

  var _classof = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
      // builtinTag case
      : ARG ? _cof(O)
      // ES3 arguments fallback
      : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };

  var ITERATOR$2 = _wks('iterator');

  var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR$2]
      || it['@@iterator']
      || _iterators[_classof(it)];
  };

  var ITERATOR$3 = _wks('iterator');
  var SAFE_CLOSING = false;

  try {
    var riter = [7][ITERATOR$3]();
    riter['return'] = function () { SAFE_CLOSING = true; };
    // eslint-disable-next-line no-throw-literal
    
  } catch (e) { /* empty */ }

  var _iterDetect = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;
    try {
      var arr = [7];
      var iter = arr[ITERATOR$3]();
      iter.next = function () { return { done: safe = true }; };
      arr[ITERATOR$3] = function () { return iter; };
      exec(arr);
    } catch (e) { /* empty */ }
    return safe;
  };

  _export(_export.S + _export.F * !_iterDetect(function (iter) {  }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
      var O = _toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = core_getIteratorMethod(O);
      var length, result, step, iterator;
      if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
      // if object isn't iterable or it's array with default iterator - use simple case
      if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = _toLength(O.length);
        for (result = new C(length); length > index; index++) {
          _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }
      result.length = index;
      return result;
    }
  });

  var from$1 = _core.Array.from;

  var from = createCommonjsModule$$1(function (module) {
  module.exports = { "default": from$1, __esModule: true };
  });

  var _Array$from = unwrapExports$$1(from);

  var toConsumableArray = createCommonjsModule$$1(function (module, exports) {
  exports.__esModule = true;



  var _from2 = _interopRequireDefault(from);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  };
  });

  var _toConsumableArray = unwrapExports$$1(toConsumableArray);

  var _iterStep = function (done, value) {
    return { value: value, done: !!done };
  };

  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
    this._t = _toIobject(iterated); // target
    this._i = 0;                   // next index
    this._k = kind;                // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return _iterStep(1);
    }
    if (kind == 'keys') return _iterStep(0, index);
    if (kind == 'values') return _iterStep(0, O[index]);
    return _iterStep(0, [index, O[index]]);
  }, 'values');

  // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
  _iterators.Arguments = _iterators.Array;

  var TO_STRING_TAG = _wks('toStringTag');

  var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
    'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
    'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
    'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
    'TextTrackList,TouchList').split(',');

  for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = _global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
    _iterators[NAME] = _iterators.Array;
  }

  var f$1 = _wks;

  var _wksExt = {
  	f: f$1
  };

  var iterator$2 = _wksExt.f('iterator');

  var iterator = createCommonjsModule$$1(function (module) {
  module.exports = { "default": iterator$2, __esModule: true };
  });

  unwrapExports$$1(iterator);

  var _meta = createCommonjsModule$$1(function (module) {
  var META = _uid('meta');


  var setDesc = _objectDp.f;
  var id = 0;
  var isExtensible = Object.isExtensible || function () {
    return true;
  };
  var FREEZE = !_fails(function () {
    return isExtensible(Object.preventExtensions({}));
  });
  var setMeta = function (it) {
    setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {}          // weak collections IDs
    } });
  };
  var fastKey = function (it, create) {
    // return primitive with prefix
    if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F';
      // not necessary to add metadata
      if (!create) return 'E';
      // add missing metadata
      setMeta(it);
    // return object ID
    } return it[META].i;
  };
  var getWeak = function (it, create) {
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true;
      // not necessary to add metadata
      if (!create) return false;
      // add missing metadata
      setMeta(it);
    // return hash weak collections IDs
    } return it[META].w;
  };
  // add metadata on freeze-family methods calling
  var onFreeze = function (it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
    return it;
  };
  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  });

  var _meta_1 = _meta.KEY;
  var _meta_2 = _meta.NEED;
  var _meta_3 = _meta.fastKey;
  var _meta_4 = _meta.getWeak;
  var _meta_5 = _meta.onFreeze;

  var defineProperty = _objectDp.f;
  var _wksDefine = function (name) {
    var $Symbol = _core.Symbol || (_core.Symbol = {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
  };

  var f$2 = Object.getOwnPropertySymbols;

  var _objectGops = {
  	f: f$2
  };

  var f$3 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$3
  };

  // all enumerable object keys, includes symbols



  var _enumKeys = function (it) {
    var result = _objectKeys(it);
    var getSymbols = _objectGops.f;
    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = _objectPie.f;
      var i = 0;
      var key;
      while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
    } return result;
  };

  // 7.2.2 IsArray(argument)

  var _isArray = Array.isArray || function isArray(arg) {
    return _cof(arg) == 'Array';
  };

  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

  var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

  var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return _objectKeysInternal(O, hiddenKeys);
  };

  var _objectGopn = {
  	f: f$5
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

  var gOPN$1 = _objectGopn.f;
  var toString$1 = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function (it) {
    try {
      return gOPN$1(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  var f$4 = function getOwnPropertyNames(it) {
    return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject(it));
  };

  var _objectGopnExt = {
  	f: f$4
  };

  var gOPD$1 = Object.getOwnPropertyDescriptor;

  var f$6 = _descriptors ? gOPD$1 : function getOwnPropertyDescriptor(O, P) {
    O = _toIobject(O);
    P = _toPrimitive(P, true);
    if (_ie8DomDefine) try {
      return gOPD$1(O, P);
    } catch (e) { /* empty */ }
    if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
  };

  var _objectGopd = {
  	f: f$6
  };

  // ECMAScript 6 symbols shim





  var META = _meta.KEY;



















  var gOPD = _objectGopd.f;
  var dP$1 = _objectDp.f;
  var gOPN = _objectGopnExt.f;
  var $Symbol = _global.Symbol;
  var $JSON = _global.JSON;
  var _stringify = $JSON && $JSON.stringify;
  var PROTOTYPE$2 = 'prototype';
  var HIDDEN = _wks('_hidden');
  var TO_PRIMITIVE = _wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = _shared('symbol-registry');
  var AllSymbols = _shared('symbols');
  var OPSymbols = _shared('op-symbols');
  var ObjectProto$1 = Object[PROTOTYPE$2];
  var USE_NATIVE = typeof $Symbol == 'function';
  var QObject = _global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = _descriptors && _fails(function () {
    return _objectCreate(dP$1({}, 'a', {
      get: function () { return dP$1(this, 'a', { value: 7 }).a; }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto$1, key);
    if (protoDesc) delete ObjectProto$1[key];
    dP$1(it, key, D);
    if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
  } : dP$1;

  var wrap = function (tag) {
    var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
    _anObject(it);
    key = _toPrimitive(key, true);
    _anObject(D);
    if (_has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
      } return setSymbolDesc(it, key, D);
    } return dP$1(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P) {
    _anObject(it);
    var keys = _enumKeys(P = _toIobject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i) $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P) {
    return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = _toPrimitive(key, true));
    if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
    return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = _toIobject(it);
    key = _toPrimitive(key, true);
    if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(_toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    } return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto$1;
    var names = gOPN(IS_OP ? OPSymbols : _toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
    } return result;
  };

  // 19.4.1.1 Symbol([description])
  if (!USE_NATIVE) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function (value) {
        if (this === ObjectProto$1) $set.call(OPSymbols, value);
        if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, _propertyDesc(1, value));
      };
      if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
      return wrap(tag);
    };
    _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
      return this._k;
    });

    _objectGopd.f = $getOwnPropertyDescriptor;
    _objectDp.f = $defineProperty;
    _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
    _objectPie.f = $propertyIsEnumerable;
    _objectGops.f = $getOwnPropertySymbols;

    if (_descriptors && !_library) {
      _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    _wksExt.f = function (name) {
      return wrap(_wks(name));
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

  for (var es6Symbols = (
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
  ).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

  for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

  _export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function (key) {
      return _has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
      for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function () { setter = true; },
    useSimple: function () { setter = false; }
  });

  _export(_export.S + _export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;
      while (arguments.length > i) args.push(arguments[i++]);
      $replacer = replacer = args[1];
      if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!_isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });

  // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
  $Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  _setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  _setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  _setToStringTag(_global.JSON, 'JSON', true);

  _wksDefine('asyncIterator');

  _wksDefine('observable');

  var symbol$2 = _core.Symbol;

  var symbol = createCommonjsModule$$1(function (module) {
  module.exports = { "default": symbol$2, __esModule: true };
  });

  unwrapExports$$1(symbol);

  var _typeof_1 = createCommonjsModule$$1(function (module, exports) {
  exports.__esModule = true;



  var _iterator2 = _interopRequireDefault(iterator);



  var _symbol2 = _interopRequireDefault(symbol);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  });

  var _typeof = unwrapExports$$1(_typeof_1);

  // most Object methods by ES6 should accept primitives



  var _objectSap = function (KEY, exec) {
    var fn = (_core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
  };

  // 19.1.2.14 Object.keys(O)



  _objectSap('keys', function () {
    return function keys(it) {
      return _objectKeys(_toObject(it));
    };
  });

  var keys$1 = _core.Object.keys;

  var keys = createCommonjsModule$$1(function (module) {
  module.exports = { "default": keys$1, __esModule: true };
  });

  var _Object$keys = unwrapExports$$1(keys);

  // 20.1.2.3 Number.isInteger(number)

  var floor$1 = Math.floor;
  var _isInteger = function isInteger(it) {
    return !_isObject(it) && isFinite(it) && floor$1(it) === it;
  };

  // 20.1.2.3 Number.isInteger(number)


  _export(_export.S, 'Number', { isInteger: _isInteger });

  var isInteger$2 = _core.Number.isInteger;

  var isInteger$1 = createCommonjsModule$$1(function (module) {
  module.exports = { "default": isInteger$2, __esModule: true };
  });

  var _Number$isInteger = unwrapExports$$1(isInteger$1);

  var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

  var space = '[' + _stringWs + ']';
  var non = '\u200b\u0085';
  var ltrim = RegExp('^' + space + space + '*');
  var rtrim = RegExp(space + space + '*$');

  var exporter = function (KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = _fails(function () {
      return !!_stringWs[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    _export(_export.P + _export.F * FORCE, 'String', exp);
  };

  // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim
  var trim = exporter.trim = function (string, TYPE) {
    string = String(_defined(string));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };

  var _stringTrim = exporter;

  var $parseFloat = _global.parseFloat;
  var $trim = _stringTrim.trim;

  var _parseFloat$3 = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $trim(String(str), 3);
    var result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;

  // 20.1.2.12 Number.parseFloat(string)
  _export(_export.S + _export.F * (Number.parseFloat != _parseFloat$3), 'Number', { parseFloat: _parseFloat$3 });

  var _parseFloat$1 = parseFloat;

  var _parseFloat = createCommonjsModule$$1(function (module) {
  module.exports = { "default": _parseFloat$1, __esModule: true };
  });

  var _Number$parseFloat = unwrapExports$$1(_parseFloat);

  /**
   * toxic-predicate-functions v0.1.5
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  /**
   * to check whether the object is defined or not
   */
  function defined$1(obj) {
    return typeof obj !== 'undefined';
  }
  /**
   * is void element or not ? Means it will return true when val is undefined or null
   */
  function isVoid(obj) {
    return obj === undefined || obj === null;
  }
  /**
   * to check whether a variable is array
   */
  function isArray(arr) {
    return Array.isArray(arr);
  }

  /**
   * is it a function or not
   */
  function isFunction(obj) {
    return typeof obj === 'function';
  }

  /**
   * is it an object or not
   */
  function isObject$1(obj) {
    // incase of arrow function and array
    return Object(obj) === obj && String(obj) === '[object Object]' && !isFunction(obj) && !isArray(obj);
  }
  /**
   * to tell you if it's a real number
   */
  function isNumber(obj) {
    return typeof obj === 'number';
  }
  /**
   * to tell you if the val can be transfer into number
   */
  function isNumeric(obj) {
    return !isArray(obj) && obj - _Number$parseFloat(obj) + 1 >= 0;
  }
  /**
   * is it an interget or not
   */
  function isInteger(num) {
    return _Number$isInteger(num);
  }

  /**
   * return true when the value is "", {}, [], 0, null, undefined, false.
   */
  function isEmpty(obj) {
    if (isArray(obj)) {
      return obj.length === 0;
    } else if (isObject$1(obj)) {
      return _Object$keys(obj).length === 0;
    } else {
      return !obj;
    }
  }
  /**
   * is it an event or not
   */
  function isEvent(obj) {
    return obj instanceof Event || (obj && obj.originalEvent) instanceof Event;
  }
  /**
   * is it a blob
   */
  function isBlob(obj) {
    return obj instanceof Blob;
  }
  /**
   * is it a file uploaded by user through file inpue
   */
  function isFile(obj) {
    return isBlob(obj) && isString(obj.name);
  }
  /**
   * is it a date
   */
  function isDate(obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
  }
  /**
   * is it a string
   */
  function isString(str) {
    return typeof str === 'string' || str instanceof String;
  }
  /**
   * is Boolean or not
   */
  function isBoolean(bool) {
    return typeof bool === 'boolean';
  }
  /**
   * is a promise or not
   */
  function isPromise(obj) {
    return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
  }
  /**
   * is Primitive type or not, whick means it will return true when data is number/string/boolean/undefined/null
   */
  function isPrimitive(val) {
    return isVoid(val) || isBoolean(val) || isString(val) || isNumber(val);
  }
  /**
   * is it an url, but this test require the url to have an protocol
   */
  function isUrl(str) {
    return isString(str) && !!str.match(/^((https?|ftp|rtsp|mms):\/\/)(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}\.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+\.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.[a-z]{2,6}|localhost)(:[0-9]{1,4})?((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\/?)$/i);
  }
  /**
   * to test if a HTML node
   */
  function isNode(obj) {
    return !!((typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string');
  }
  /**
   * to test if a HTML element
   */
  function isElement(obj) {
    return !!((typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string');
  }
  /**
   * check if node A is node B's parent or not
   */
  function isChildNode(parent, child) {
    if (!isNode(parent) || !isNode(child)) {
      return false;
    }
    return child.parentNode === parent;
  }
  /**
   * check if node B is node A's posterrity or not
   */
  function isPosterityNode(parent, child) {
    if (!isNode(parent) || !isNode(child)) {
      return false;
    }
    while (child.parentNode) {
      child = child.parentNode;
      if (child === parent) {
        return true;
      }
    }
    return false;
  }
  /**
   * check if the string is an HTMLString
   */
  function isHTMLString(str) {
    return (/<[^>]+?>/.test(str)
    );
  }
  /**
   * check if is an error
   */
  function isError(val) {
    return val instanceof Error;
  }
  /**
   * check if is an RegExp
   */
  function isRegExp(val) {
    return val instanceof RegExp;
  }

  /**
   * toxic-utils v0.2.0
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  /**
   * the handler to generate an deep traversal handler
   * @param  {Function} fn the function you wanna run when you reach in the deep property
   * @return {Function}    the handler
   */
  function genTraversalHandler(fn) {
    var setter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (target, key, value) {
      target[key] = value;
    };

    // use recursive to move what in source to the target
    // if you do not provide a target, we will create a new target
    function recursiveFn(source, target, key) {
      if (isArray(source) || isObject$1(source)) {
        target = isPrimitive(target) ? isObject$1(source) ? {} : [] : target;
        for (var _key in source) {
          // $FlowFixMe: support computed key here
          setter(target, _key, recursiveFn(source[_key], target[_key], _key));
          // target[key] = recursiveFn(source[key], target[key], key);
        }
        return target;
      }
      return fn(source, target, key);
    }
    return recursiveFn;
  }
  var _deepAssign = genTraversalHandler(function (val) {
    return val;
  });
  /**
   * deeply clone an object
   * @param  {Array|Object} source if you pass in other type, it will throw an error
   * @return {clone-target}        the new Object
   */
  function deepClone(source) {
    if (isPrimitive(source)) {
      throw new TypeError('deepClone only accept non primitive type');
    }
    return _deepAssign(source);
  }
  /**
   * merge multiple objects
   * @param  {...Object} args [description]
   * @return {merge-object}         [description]
   */
  function deepAssign() {
    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args.length < 2) {
      throw new Error('deepAssign accept two and more argument');
    }
    for (var i = args.length - 1; i > -1; i--) {
      if (isPrimitive(args[i])) {
        throw new TypeError('deepAssign only accept non primitive type');
      }
    }
    var target = args.shift();
    args.forEach(function (source) {
      return _deepAssign(source, target);
    });
    return target;
  }

  /**
   * camelize any string, e.g hello world -> helloWorld
   * @param  {string} str only accept string!
   * @return {string}     camelize string
   */
  function camelize(str, isBig) {
    return str.replace(/(^|[^a-zA-Z]+)([a-zA-Z])/g, function (match, spilt, initials, index) {
      return !isBig && index === 0 ? initials.toLowerCase() : initials.toUpperCase();
    });
  }
  /**
   * hypenate any string e.g hello world -> hello-world
   * @param  {string} str only accept string
   * @return {string}
   */
  function hypenate(str) {
    return camelize(str).replace(/([A-Z])/g, function (match) {
      return '-' + match.toLowerCase();
    });
  }

  /**
   * bind the function with some context. we have some fallback strategy here
   * @param {function} fn the function which we need to bind the context on
   * @param {any} context the context object
   */
  function bind(fn, context) {
    if (fn.bind) {
      return fn.bind(context);
    } else if (fn.apply) {
      return function __autobind__() {
        for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return fn.apply(context, args);
      };
    } else {
      return function __autobind__() {
        for (var _len3 = arguments.length, args = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return fn.call.apply(fn, [context].concat(_toConsumableArray(args)));
      };
    }
  }

  /**
   * generate an uuid
   */
  function uuid() {
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
  }
  /**
   * generate an random number which length is 4
   */
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }

  /**
   * generate an random number with specific length
   */
  function rand(length) {
    var str = '';
    while (str.length < length) {
      str += S4();
    }
    return str.slice(0, length);
  }

  /**
   * get an deep property
   */
  function getDeepProperty(obj, keys) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$throwError = _ref.throwError,
        throwError = _ref$throwError === undefined ? false : _ref$throwError,
        backup = _ref.backup;

    if (isString(keys)) {
      keys = keys.split('.');
    }
    if (!isArray(keys)) {
      throw new TypeError('keys of getDeepProperty must be string or Array<string>');
    }
    var read = [];
    var target = obj;
    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];
      if (isVoid(target)) {
        if (throwError) {
          throw new Error('obj' + (read.length > 0 ? '.' + read.join('.') : ' itself') + ' is ' + target);
        } else {
          return backup;
        }
      }
      target = target[key];
      read.push(key);
    }
    return target;
  }

  var _anInstance = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
      throw TypeError(name + ': incorrect invocation!');
    } return it;
  };

  var _forOf = createCommonjsModule$$1(function (module) {
  var BREAK = {};
  var RETURN = {};
  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
    var f = _ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
      result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = _iterCall(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };
  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
  });

  // 7.3.20 SpeciesConstructor(O, defaultConstructor)


  var SPECIES = _wks('species');
  var _speciesConstructor = function (O, D) {
    var C = _anObject(O).constructor;
    var S;
    return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
  };

  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  var _invoke = function (fn, args, that) {
    var un = that === undefined;
    switch (args.length) {
      case 0: return un ? fn()
                        : fn.call(that);
      case 1: return un ? fn(args[0])
                        : fn.call(that, args[0]);
      case 2: return un ? fn(args[0], args[1])
                        : fn.call(that, args[0], args[1]);
      case 3: return un ? fn(args[0], args[1], args[2])
                        : fn.call(that, args[0], args[1], args[2]);
      case 4: return un ? fn(args[0], args[1], args[2], args[3])
                        : fn.call(that, args[0], args[1], args[2], args[3]);
    } return fn.apply(that, args);
  };

  var process$1 = _global.process;
  var setTask = _global.setImmediate;
  var clearTask = _global.clearImmediate;
  var MessageChannel = _global.MessageChannel;
  var Dispatch = _global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer;
  var channel;
  var port;
  var run = function () {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };
  var listener = function (event) {
    run.call(event.data);
  };
  // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;
      while (arguments.length > i) args.push(arguments[i++]);
      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        _invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };
      defer(counter);
      return counter;
    };
    clearTask = function clearImmediate(id) {
      delete queue[id];
    };
    // Node.js 0.8-
    if (_cof(process$1) == 'process') {
      defer = function (id) {
        process$1.nextTick(_ctx(run, id, 1));
      };
    // Sphere (JS game engine) Dispatch API
    } else if (Dispatch && Dispatch.now) {
      defer = function (id) {
        Dispatch.now(_ctx(run, id, 1));
      };
    // Browsers with MessageChannel, includes WebWorkers
    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = _ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
      defer = function (id) {
        _global.postMessage(id + '', '*');
      };
      _global.addEventListener('message', listener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in _domCreate('script')) {
      defer = function (id) {
        _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
          _html.removeChild(this);
          run.call(id);
        };
      };
    // Rest old browsers
    } else {
      defer = function (id) {
        setTimeout(_ctx(run, id, 1), 0);
      };
    }
  }
  var _task = {
    set: setTask,
    clear: clearTask
  };

  var macrotask = _task.set;
  var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
  var process$2 = _global.process;
  var Promise = _global.Promise;
  var isNode$2 = _cof(process$2) == 'process';

  var _microtask = function () {
    var head, last, notify;

    var flush = function () {
      var parent, fn;
      if (isNode$2 && (parent = process$2.domain)) parent.exit();
      while (head) {
        fn = head.fn;
        head = head.next;
        try {
          fn();
        } catch (e) {
          if (head) notify();
          else last = undefined;
          throw e;
        }
      } last = undefined;
      if (parent) parent.enter();
    };

    // Node.js
    if (isNode$2) {
      notify = function () {
        process$2.nextTick(flush);
      };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
    } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode('');
      new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
      notify = function () {
        node.data = toggle = !toggle;
      };
    // environments with maybe non-completely correct, but existent Promise
    } else if (Promise && Promise.resolve) {
      var promise = Promise.resolve();
      notify = function () {
        promise.then(flush);
      };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else {
      notify = function () {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(_global, flush);
      };
    }

    return function (fn) {
      var task = { fn: fn, next: undefined };
      if (last) last.next = task;
      if (!head) {
        head = task;
        notify();
      } last = task;
    };
  };

  // 25.4.1.5 NewPromiseCapability(C)


  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = _aFunction(resolve);
    this.reject = _aFunction(reject);
  }

  var f$7 = function (C) {
    return new PromiseCapability(C);
  };

  var _newPromiseCapability = {
  	f: f$7
  };

  var _perform = function (exec) {
    try {
      return { e: false, v: exec() };
    } catch (e) {
      return { e: true, v: e };
    }
  };

  var _promiseResolve = function (C, x) {
    _anObject(C);
    if (_isObject(x) && x.constructor === C) return x;
    var promiseCapability = _newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };

  var _redefineAll = function (target, src, safe) {
    for (var key in src) {
      if (safe && target[key]) target[key] = src[key];
      else _hide(target, key, src[key]);
    } return target;
  };

  var SPECIES$1 = _wks('species');

  var _setSpecies = function (KEY) {
    var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
    if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  };

  var task = _task.set;
  var microtask = _microtask();



  var PROMISE = 'Promise';
  var TypeError$1 = _global.TypeError;
  var process = _global.process;
  var $Promise = _global[PROMISE];
  var isNode$1 = _classof(process) == 'process';
  var empty = function () { /* empty */ };
  var Internal;
  var newGenericPromiseCapability;
  var OwnPromiseCapability;
  var Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

  var USE_NATIVE$1 = !!function () {
    try {
      // correct subclassing with @@species support
      var promise = $Promise.resolve(1);
      var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
        exec(empty, empty);
      };
      // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
      return (isNode$1 || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
    } catch (e) { /* empty */ }
  }();

  // helpers
  var isThenable = function (it) {
    var then;
    return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };
  var notify = function (promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;
      var run = function (reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then;
        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }
            if (handler === true) result = value;
            else {
              if (domain) domain.enter();
              result = handler(value);
              if (domain) domain.exit();
            }
            if (result === reaction.promise) {
              reject(TypeError$1('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          reject(e);
        }
      };
      while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };
  var onUnhandled = function (promise) {
    task.call(_global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;
      if (unhandled) {
        result = _perform(function () {
          if (isNode$1) {
            process.emit('unhandledRejection', value, promise);
          } else if (handler = _global.onunhandledrejection) {
            handler({ promise: promise, reason: value });
          } else if ((console = _global.console) && console.error) {
            console.error('Unhandled promise rejection', value);
          }
        });
        // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
        promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
      } promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };
  var isUnhandled = function (promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };
  var onHandleUnhandled = function (promise) {
    task.call(_global, function () {
      var handler;
      if (isNode$1) {
        process.emit('rejectionHandled', promise);
      } else if (handler = _global.onrejectionhandled) {
        handler({ promise: promise, reason: promise._v });
      }
    });
  };
  var $reject = function (value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };
  var $resolve = function (value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
      if (promise === value) throw TypeError$1("Promise can't be resolved itself");
      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = { _w: promise, _d: false }; // wrap
          try {
            then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({ _w: promise, _d: false }, e); // wrap
    }
  };

  // constructor polyfill
  if (!USE_NATIVE$1) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
      _anInstance(this, $Promise, PROMISE, '_h');
      _aFunction(executor);
      Internal.call(this);
      try {
        executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    };
    // eslint-disable-next-line no-unused-vars
    Internal = function Promise(executor) {
      this._c = [];             // <- awaiting reactions
      this._a = undefined;      // <- checked in isUnhandled reactions
      this._s = 0;              // <- state
      this._d = false;          // <- done
      this._v = undefined;      // <- value
      this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
      this._n = false;          // <- notify
    };
    Internal.prototype = _redefineAll($Promise.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = isNode$1 ? process.domain : undefined;
        this._c.push(reaction);
        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function (onRejected) {
        return this.then(undefined, onRejected);
      }
    });
    OwnPromiseCapability = function () {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = _ctx($resolve, promise, 1);
      this.reject = _ctx($reject, promise, 1);
    };
    _newPromiseCapability.f = newPromiseCapability = function (C) {
      return C === $Promise || C === Wrapper
        ? new OwnPromiseCapability(C)
        : newGenericPromiseCapability(C);
    };
  }

  _export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
  _setToStringTag($Promise, PROMISE);
  _setSpecies(PROMISE);
  Wrapper = _core[PROMISE];

  // statics
  _export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  _export(_export.S + _export.F * (_library), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
      return _promiseResolve(this === Wrapper ? $Promise : this, x);
    }
  });
  _export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
    $Promise.all(iter)['catch'](empty);
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = _perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        _forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = _perform(function () {
        _forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });

  _export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
    var C = _speciesConstructor(this, _core.Promise || _global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return _promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return _promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  } });

  // https://github.com/tc39/proposal-promise-try




  _export(_export.S, 'Promise', { 'try': function (callbackfn) {
    var promiseCapability = _newPromiseCapability.f(this);
    var result = _perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

  var promise$1 = _core.Promise;

  var promise = createCommonjsModule$$1(function (module) {
  module.exports = { "default": promise$1, __esModule: true };
  });

  var _Promise = unwrapExports$$1(promise);

  // **********************  judgement   ************************
  /**
   * check if the code running in browser environment (not include worker env)
   * @returns {Boolean}
   */
  var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

  // **********************  对象操作  ************************
  /**
   * 转变一个类数组对象为数组
   */
  function makeArray(obj) {
    return _Array$from(obj);
  }

  /**
   * sort Object attributes by function
   * and transfer them into array
   * @param  {Object} obj Object form from numric
   * @param  {Function} fn sort function
   * @return {Array} the sorted attirbutes array
   */
  function transObjectAttrIntoArray(obj) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
      return +a - +b;
    };

    return _Object$keys(obj).sort(fn).reduce(function (order, key) {
      return order.concat(obj[key]);
    }, []);
  }
  /**
   * run a queue one by one.If include function reject or return false it will stop
   * @param  {Array} queue the queue which we want to run one by one
   * @return {Promise}    tell us whether a queue run finished
   */
  function runRejectableQueue(queue) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return new _Promise(function (resolve, reject) {
      var step = function step(index) {
        if (index >= queue.length) {
          resolve();
          return;
        }
        var result = isFunction(queue[index]) ? queue[index].apply(queue, _toConsumableArray(args)) : queue[index];
        if (result === false) return reject('stop');
        return _Promise.resolve(result).then(function () {
          return step(index + 1);
        }).catch(function (err) {
          return reject(err || 'stop');
        });
      };
      step(0);
    });
  }
  /**
   * run a queue one by one.If include function return false it will stop
   * @param  {Array} queue the queue which we want to run one by one
   * @return {boolean} tell the user if the queue run finished
   */
  function runStoppableQueue(queue) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var step = function step(index) {
      if (index >= queue.length) {
        return true;
      }
      var result = isFunction(queue[index]) ? queue[index].apply(queue, _toConsumableArray(args)) : queue[index];
      if (result === false) return false;
      return step(++index);
    };
    return step(0);
  }

  function checkContinuation(uint8array, start, checkLength) {
    var array = uint8array;
    if (start + checkLength < array.length) {
      while (checkLength--) {
        if ((array[++start] & 0xC0) !== 0x80) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  // decodeUTF8
  function decodeUTF8(uint8array) {
    var out = [];
    var input = uint8array;
    var i = 0;
    var length = uint8array.length;

    while (i < length) {
      if (input[i] < 0x80) {
        out.push(String.fromCharCode(input[i]));
        ++i;
        continue;
      } else if (input[i] < 0xC0) ; else if (input[i] < 0xE0) {
        if (checkContinuation(input, i, 1)) {
          var ucs4 = (input[i] & 0x1F) << 6 | input[i + 1] & 0x3F;
          if (ucs4 >= 0x80) {
            out.push(String.fromCharCode(ucs4 & 0xFFFF));
            i += 2;
            continue;
          }
        }
      } else if (input[i] < 0xF0) {
        if (checkContinuation(input, i, 2)) {
          var _ucs = (input[i] & 0xF) << 12 | (input[i + 1] & 0x3F) << 6 | input[i + 2] & 0x3F;
          if (_ucs >= 0x800 && (_ucs & 0xF800) !== 0xD800) {
            out.push(String.fromCharCode(_ucs & 0xFFFF));
            i += 3;
            continue;
          }
        }
      } else if (input[i] < 0xF8) {
        if (checkContinuation(input, i, 3)) {
          var _ucs2 = (input[i] & 0x7) << 18 | (input[i + 1] & 0x3F) << 12 | (input[i + 2] & 0x3F) << 6 | input[i + 3] & 0x3F;
          if (_ucs2 > 0x10000 && _ucs2 < 0x110000) {
            _ucs2 -= 0x10000;
            out.push(String.fromCharCode(_ucs2 >>> 10 | 0xD800));
            out.push(String.fromCharCode(_ucs2 & 0x3FF | 0xDC00));
            i += 4;
            continue;
          }
        }
      }
      out.push(String.fromCharCode(0xFFFD));
      ++i;
    }
    return out.join('');
  }

  function debounce(func, wait, immediate) {
    // immediate默认为false
    var timeout = void 0,
        args = void 0,
        context = void 0,
        timestamp = void 0,
        result = void 0;

    var later = function later() {
      // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
      var last = new Date() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function () {
      context = this;
      args = arguments;
      timestamp = new Date();
      // 第一次调用该方法时，且immediate为true，则调用func函数
      var callNow = immediate && !timeout;
      // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  }

  /**
   * 函数节流（控制函数执行频率）
   * @param  {Function} func 要节流控制的函数，必填
   * @return {Number}   wait 等待时长
   * @return {Object}   options {
   *                      leading<是否首次调用立即执行，否：则按wait设定等待到期后调用才执行>:false,
   *                      trailing<是否在调用并未到期时启用定时器，以保证一定执行>:true
   *                    }
   * @return {Object}   cxt 上下文对象
   * @return {Function}
   */
  function throttle(func, wait, options, cxt) {
    /* options的默认值
     *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
     *  options.leading = true;
     * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
     *  options.trailing = true;
     * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
     */
    var context = void 0,
        args = void 0,
        result = void 0;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
      previous = options.leading === false ? 0 : new Date() - 0;
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    wait = wait || 0;
    return function () {
      var now = new Date();
      if (!previous && options.leading === false) previous = now;
      // 计算剩余时间
      var remaining = wait - (now - previous);
      if (cxt) {
        context = cxt;
      } else {
        context = this;
      }

      args = arguments;
      // 当到达wait指定的时间间隔，则调用func函数
      // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
      if (remaining <= 0 || remaining > wait) {
        // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        // options.trailing=true时，延时执行func函数
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }

  // requestAnimationFrame
  var raf = inBrowser && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame) || function (cb) {
    return setTimeout(cb, 17);
  };

  // cancelAnimationFrame
  var caf = inBrowser && (window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.msCancelAnimationFrame || window.oCancelAnimationFrame) || function (id) {
    clearTimeout(id);
  };

  // 根据要求的位数，将9格式化为 09\009\0009...
  function strRepeat(num, bit) {
    var pBit = bit;
    num = '' + (num || '');
    var numLen = num.length;
    bit = (bit || numLen) - numLen;
    var paddingStr = bit > 0 ? num.repeat ? '0'.repeat(bit) : new Array(bit + 1).join('0') : '';
    return (paddingStr + num).slice(0, pBit);
  }

  // video 时间格式化
  function formatTime(time) {
    var hh = Math.floor(time / 3600);
    time = Math.floor(time % 3600);
    var mm = strRepeat(Math.floor(time / 60), 2);
    time = Math.floor(time % 60);
    var ss = strRepeat(time, 2);
    return hh >= 1 ? hh + ':' + mm + ':' + ss : mm + ':' + ss;
  }

  /**
   * 追加样式代码到head的style标签，不存在则创建
   * @param {String} cssText 样式文本
   * @return {HTMLElement}
   */
  function appendCSS(cssText) {
    var doc = document;
    var styleEl = doc.querySelector('style');
    if (!styleEl) {
      styleEl = doc.createElement('style');
      var header = doc.querySelector('head');
      header && header.appendChild(styleEl);
    }
    styleEl.appendChild(doc.createTextNode(cssText));
    return styleEl;
  }

  /**
   * 格式化日期对象为：年-月-日 时:分:秒.毫秒
   * @param {Date} date Date日期对象
   * @param {String} pattern 要输出的日期格式，默认：`yyyy-MM-dd hh:mm:ss.i`
   * @return {String}
   */
  function formatDate() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss.i';

    var year = date.getFullYear().toString();
    var fields = {
      M: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds(),
      i: date.getMilliseconds()
    };
    pattern = pattern.replace(/(y+)/ig, function (_, yearPattern) {
      return year.substr(4 - Math.min(4, yearPattern.length));
    });

    var _loop = function _loop(i) {
      pattern = pattern.replace(new RegExp('(' + i + '+)', 'g'), function (_, pattStr) {
        return (fields[i] < 10 && pattStr.length > 1 ? '0' : '') + fields[i];
      });
    };

    for (var i in fields) {
      _loop(i);
    }
    return pattern;
  }

  /**
   * 读取本地存储的值（不支持localStorage则降级到cookie）
   * @param {String} key 目标数据key
   * @return {String}
   */
  function getLocalStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      try {
        var regRt = document.cookie.match(new RegExp('(^| )' + key + '=([^;]*)(;|$)'));
        return isArray(regRt) ? unescape(regRt[2]) : '';
      } catch (e) {
        return '';
      }
    }
  }
  /**
   * 将指定key对应值写入本地存储（不支持localStorage则降级到cookie）
   * @param {String} key
   * @param {String} val
   * @return {String}
   */
  function setLocalStorage(key, val) {
    try {
      window.localStorage.setItem(key, val);
    } catch (e) {
      var expires = new Date();
      // 默认存储300天
      expires.setTime(expires.getTime() + 24 * 3600 * 1000 * 300);
      try {
        document.cookie = key + '=' + escape(val) + ';expires=' + expires.toUTCString() + ';path=/;';
      } catch (e) {
        console.error(e);
      }
    }
  }

  var classCallCheck = createCommonjsModule$$1(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  });

  var _classCallCheck = unwrapExports$$1(classCallCheck);

  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  _export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

  var $Object = _core.Object;
  var defineProperty$3 = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
  };

  var defineProperty$1 = createCommonjsModule$$1(function (module) {
  module.exports = { "default": defineProperty$3, __esModule: true };
  });

  unwrapExports$$1(defineProperty$1);

  var createClass = createCommonjsModule$$1(function (module, exports) {
  exports.__esModule = true;



  var _defineProperty2 = _interopRequireDefault(defineProperty$1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  });

  var _createClass = unwrapExports$$1(createClass);

  // 19.1.2.1 Object.assign(target, source, ...)





  var $assign = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  var _objectAssign = !$assign || _fails(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) { // eslint-disable-line no-unused-vars
    var T = _toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = _objectGops.f;
    var isEnum = _objectPie.f;
    while (aLen > index) {
      var S = _iobject(arguments[index++]);
      var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    } return T;
  } : $assign;

  // 19.1.3.1 Object.assign(target, source)


  _export(_export.S + _export.F, 'Object', { assign: _objectAssign });

  var assign$1 = _core.Object.assign;

  var assign = createCommonjsModule$$1(function (module) {
  module.exports = { "default": assign$1, __esModule: true };
  });

  var _Object$assign = unwrapExports$$1(assign);

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  _export(_export.S, 'Object', { create: _objectCreate });

  var $Object$1 = _core.Object;
  var create$1 = function create(P, D) {
    return $Object$1.create(P, D);
  };

  var create = createCommonjsModule$$1(function (module) {
  module.exports = { "default": create$1, __esModule: true };
  });

  var _Object$create = unwrapExports$$1(create);

  /**
   * chimee-helper-events v0.1.0
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  /**
  * @module event
  * @author huzunjie
  * @description 自定义事件基础类
  */

  /* 缓存事件监听方法及包装，内部数据格式：
   * targetIndex_<type:'click|mouseup|done'>: [ [
   *   function(){ ... handler ... },
   *   function(){ ... handlerWrap ... handler.apply(target, arguments) ... },
   *   isOnce
   * ]]
   */
  var _evtListenerCache = _Object$create(null);
  _evtListenerCache.count = 0;

  /**
   * 得到某对象的某事件类型对应的监听队列数组
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型(这里的时间类型不只是名称，还是缓存标识，可以通过添加后缀来区分)
   * @return {Array}
   */
  function getEvtTypeCache(target, type) {

    var evtId = target.__evt_id;
    if (!evtId) {

      /* 设置__evt_id不可枚举 */
      Object.defineProperty(target, '__evt_id', {
        writable: true,
        enumerable: false,
        configurable: true
      });

      /* 空对象初始化绑定索引 */
      evtId = target.__evt_id = ++_evtListenerCache.count;
    }

    var typeCacheKey = evtId + '_' + type;
    var evtTypeCache = _evtListenerCache[typeCacheKey];
    if (!evtTypeCache) {
      evtTypeCache = _evtListenerCache[typeCacheKey] = [];
    }

    return evtTypeCache;
  }

  /**
   * 触发事件监听方法
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Object} eventObj 触发事件时要传回的event对象
   * @return {undefined}
   */
  function emitEventCache(target, type, eventObj) {
    var evt = _Object$create(null);
    evt.type = type;
    evt.target = target;
    if (eventObj) {
      _Object$assign(evt, isObject$1(eventObj) ? eventObj : { data: eventObj });
    }
    getEvtTypeCache(target, type).forEach(function (item) {
      (item[1] || item[0]).apply(target, [evt]);
    });
  }

  /**
   * 添加事件监听到缓存
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @param {Boolean} isOnce 是否单次执行
   * @param {Function} handlerWrap
   * @return {undefined}
   */
  function addEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var handlerWrap = arguments[4];

    if (isFunction(isOnce) && !handlerWrap) {
      handlerWrap = isOnce;
      isOnce = undefined;
    }
    var handlers = [handler, undefined, isOnce];
    if (isOnce && !handlerWrap) {
      handlerWrap = function handlerWrap() {
        removeEventCache(target, type, handler, isOnce);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(target, args);
      };
    }
    if (handlerWrap) {
      handlers[1] = handlerWrap;
    }
    getEvtTypeCache(target, type).push(handlers);
  }

  /**
   * 移除事件监听
   * @param  {Object}  target 发生事件的对象
   * @param {String} type 事件类型
   * @param {Function} handler 监听函数
   * @return {undefined}
   */
  function removeEventCache(target, type, handler) {
    var isOnce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var typeCache = getEvtTypeCache(target, type);

    if (handler || isOnce) {
      /* 有指定 handler 则清除对应监听 */
      var handlerId = -1;
      var handlerWrap = void 0;
      typeCache.find(function (item, i) {
        if ((!handler || item[0] === handler) && (!isOnce || item[2])) {
          handlerId = i;
          handlerWrap = item[1];
          return true;
        }
      });
      if (handlerId !== -1) {
        typeCache.splice(handlerId, 1);
      }
      return handlerWrap;
    } else {
      /* 未指定 handler 则清除type对应的所有监听 */
      typeCache.length = 0;
    }
  }

  /**
   * @class CustEvent
   * @description
   * Event 自定义事件类
   * 1. 可以使用不传参得到的实例作为eventBus使用
   * 2. 可以通过指定target，用多个实例操作同一target对象的事件管理
   * 3. 当设定target时，可以通过设置assign为true，来给target实现"on\once\off\emit"方法
   * @param  {Object}  target 发生事件的对象（空则默认为event实例）
   * @param  {Boolean}  assign 是否将"on\once\off\emit"方法实现到target对象上
   * @return {event}
   */
  var CustEvent = function () {
    function CustEvent(target, assign$$1) {
      var _this = this;

      _classCallCheck(this, CustEvent);

      /* 设置__target不可枚举 */
      Object.defineProperty(this, '__target', {
        writable: true,
        enumerable: false,
        configurable: true
      });
      this.__target = this;

      if (target) {

        if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
          throw new Error('CusEvent target are not object');
        }
        this.__target = target;

        /* 为target实现on\once\off\emit */
        if (assign$$1) {
          ['on', 'once', 'off', 'emit'].forEach(function (mth) {
            target[mth] = _this[mth];
          });
        }
      }
    }

    /**
     * 添加事件监听
     * @param {String} type 事件类型
     * @param {Function} handler 监听函数
     * @param {Boolean} isOnce 单次监听类型
     * @return {event}
     */


    _createClass(CustEvent, [{
      key: 'on',
      value: function on(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        addEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 添加事件监听,并且只执行一次
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数
       * @return {event}
       */

    }, {
      key: 'once',
      value: function once(type, handler) {
        return this.on(type, handler, true);
      }

      /**
       * 移除事件监听
       * @param {String} type 事件类型
       * @param {Function} handler 监听函数(不指定handler则清除type对应的所有事件监听)
       * @param {Boolean} isOnce 单次监听类型
       * @return {event}
       */

    }, {
      key: 'off',
      value: function off(type, handler) {
        var isOnce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        removeEventCache(this.__target, type, handler, isOnce);
        return this;
      }

      /**
       * 触发事件监听函数
       * @param {String} type 事件类型
       * @return {event}
       */

    }, {
      key: 'emit',
      value: function emit(type, data) {
        emitEventCache(this.__target, type, { data: data });
        return this;
      }
    }]);

    return CustEvent;
  }();

  /**
   * @module dom
   * @author huzunjie
   * @description 一些常用的DOM判断及操作方法，可以使用dom.$('*')包装DOM，实现类jQuery的链式操作；当然这里的静态方法也可以直接使用。
   */

  var _divEl = inBrowser ? document.createElement('div') : {};
  var _textAttrName = 'innerText';
  'textContent' in _divEl && (_textAttrName = 'textContent');
  var _arrPrototype = Array.prototype;

  /**
   * 读取HTML元素属性值
   * @param {HTMLElement} el 目标元素
   * @param {String} attrName 目标属性名称
   * @return {String}
   */
  function getAttr(el, attrName) {
    return el.getAttribute(attrName);
  }

  /**
   * 设置HTML元素属性值
   * @param {HTMLElement} el 目标元素
   * @param {String} attrName 目标属性名称
   * @param {String} attrVal 目标属性值
   */
  function setAttr(el, attrName, attrVal) {
    if (attrVal === undefined) {
      el.removeAttribute(attrName);
    } else {
      el.setAttribute(attrName, attrVal);
    }
  }

  /**
   * 为HTML元素添加className
   * @param {HTMLElement} el 目标元素
   * @param {String} cls 要添加的className（多个以空格分割）
   */
  function addClassName(el, cls) {
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    var clsArr = cls.split(/\s+/);
    if (el.classList) {
      clsArr.forEach(function (c) {
        return el.classList.add(c);
      });
    } else {
      var curCls = ' ' + (el.className || '') + ' ';
      clsArr.forEach(function (c) {
        curCls.indexOf(' ' + c + ' ') === -1 && (curCls += ' ' + c);
      });
      el.className = curCls.trim();
    }
  }

  /**
   * 为HTML元素移除className
   * @param {HTMLElement} el 目标元素
   * @param {String} cls 要移除的className（多个以空格分割）
   */
  function removeClassName(el, cls) {
    if (!cls || !(cls = cls.trim())) {
      return;
    }

    var clsArr = cls.split(/\s+/);
    if (el.classList) {
      clsArr.forEach(function (c) {
        return el.classList.remove(c);
      });
    } else {
      var curCls = ' ' + el.className + ' ';
      clsArr.forEach(function (c) {
        var tar = ' ' + c + ' ';
        while (curCls.indexOf(tar) !== -1) {
          curCls = curCls.replace(tar, ' ');
        }
      });
      el.className = curCls.trim();
    }
  }

  /**
   * 检查HTML元素是否已设置className
   * @param {HTMLElement} el 目标元素
   * @param {String} className 要检查的className
   * @return {Boolean}
   */
  function hasClassName(el, className) {
    return new RegExp('(?:^|\\s)' + className + '(?=\\s|$)').test(el.className);
  }

  /**
   * addEventListener 是否已支持 passive
   * @return {Boolean}
   */
  exports.supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        exports.supportsPassive = true;
      }
    });
    if (inBrowser) window.addEventListener('test', null, opts);
  } catch (e) {
    console.error(e);
  }

  /**
   * 为HTML元素移除事件监听
   * @param {HTMLElement} el 目标元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} once 是否只监听一次
   * @param {Boolean} capture 是否在捕获阶段的监听
   */
  function removeEvent(el, type, handler) {
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && exports.supportsPassive) {
      capture = { passive: true };
    }
    if (once) {
      /* 尝试从缓存中读取包装后的方法 */
      var handlerWrap = removeEventCache(el, type + '_once', handler);
      if (handlerWrap) {
        handler = handlerWrap;
      }
    }
    el.removeEventListener(type, handler, capture);
  }

  /**
   * 为HTML元素添加事件监听
   * @param {HTMLElement} el 目标元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} once 是否只监听一次
   * @param {Boolean|Object} capture 是否在捕获阶段监听，这里也可以传入 { passive: true } 表示被动模式
   */
  function addEvent(el, type, handler) {
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && exports.supportsPassive) {
      capture = { passive: true };
    }
    if (once) {
      var oldHandler = handler;
      handler = function () {
        return function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          oldHandler.apply(this, args);
          removeEvent(el, type, handler, once, capture);
        };
      }();
      /* 将包装后的方法记录到缓存中 */
      addEventCache(el, type + '_once', oldHandler, handler);
    }

    el.addEventListener(type, handler, capture);
  }

  /**
   * 为HTML元素添加事件代理
   * @param {HTMLElement} el 目标元素
   * @param {String} selector 要被代理的元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} capture 是否在捕获阶段监听
   */
  function addDelegate(el, selector, type, handler) {
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && exports.supportsPassive) {
      capture = { passive: true };
    }
    var handlerWrap = function handlerWrap(e) {
      var targetElsArr = findParents(e.target || e.srcElement, el, true);
      var targetElArr = query(selector, el, true);
      var retEl = void 0;
      if (targetElArr.find) {
        retEl = targetElArr.find(function (seEl) {
          return targetElsArr.find(function (tgEl) {
            return seEl === tgEl;
          });
        });
      } else {
        // Fixed IE11 Array.find not defined bug
        targetElArr.forEach(function (seEl) {
          return !retEl && targetElsArr.forEach(function (tgEl) {
            if (!retEl && seEl === tgEl) {
              retEl = tgEl;
            }
          });
        });
      }
      retEl && handler.apply(retEl, arguments);
    };
    /* 将包装后的方法记录到缓存中 */
    addEventCache(el, type + '_delegate_' + selector, handler, handlerWrap);
    el.addEventListener(type, handlerWrap, capture);
  }

  /**
   * 为HTML元素移除事件代理
   * @param {HTMLElement} el 目标元素
   * @param {String} selector 要被代理的元素
   * @param {String} type 事件名称
   * @param {Function} handler 处理函数
   * @param {Boolean} capture 是否在捕获阶段监听
   */
  function removeDelegate(el, selector, type, handler) {
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (capture !== undefined && !isBoolean(capture) && exports.supportsPassive) {
      capture = { passive: true };
    }
    /* 尝试从缓存中读取包装后的方法 */
    var handlerWrap = removeEventCache(el, type + '_delegate_' + selector, handler);
    handlerWrap && el.removeEventListener(type, handlerWrap, capture);
  }

  /**
   * 读取HTML元素样式值
   * @param {HTMLElement} el 目标元素
   * @param {String} key 样式key
   * @return {String}
   */
  function getStyle(el, key) {
    return (el.currentStyle || document.defaultView.getComputedStyle(el, null))[key] || el.style[key];
  }

  /**
   * 设置HTML元素样式值
   * @param {HTMLElement} el 目标元素
   * @param {String} key 样式key
   * @param {String} val 样式值
   */
  function setStyle(el, key, val) {
    if (isObject$1(key)) {
      for (var k in key) {
        setStyle(el, k, key[k]);
      }
    } else {
      el.style[key] = val;
    }
  }

  /**
   * 根据选择器查询目标元素
   * @param {String} selector 选择器,用于 querySelectorAll
   * @param {HTMLElement} container 父容器
   * @param {Boolean} toArray 强制输出为数组
   * @return {NodeList|Array}
   */
  function query(selector) {
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    var toArray = arguments[2];

    var retNodeList = container.querySelectorAll(selector);
    return toArray ? _Array$from(retNodeList) : retNodeList;
  }

  /**
   * 从DOM树中移除el
   * @param {HTMLElement} el 目标元素
   */
  function removeEl(el) {
    el.parentNode.removeChild(el);
  }

  /**
   * 查找元素的父节点们
   * @param {HTMLElement} el 目标元素
   * @param {HTMLElement} endEl 最大父容器（不指定则找到html）
   * @param {Boolean} haveEl 包含当前元素
   * @param {Boolean} haveEndEl 包含设定的最大父容器
   */
  function findParents(el) {
    var endEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var haveEl = arguments[2];
    var haveEndEl = arguments[3];

    var retEls = [];
    if (haveEl) {
      retEls.push(el);
    }
    while (el && el.parentNode !== endEl) {
      el = el.parentNode;
      el && retEls.push(el);
    }
    if (haveEndEl) {
      retEls.push(endEl);
    }
    return retEls;
  }

  /**
   * @class NodeWrap
   * @description
   * NodeWrap DOM包装器，用以实现基本的链式操作
   * new dom.NodeWrap('*') 相当于 dom.$('*')
   * 这里面用于DOM操作的属性方法都是基于上面静态方法实现，有需要可以随时修改补充
   * @param {String} selector 选择器(兼容 String||HTMLString||NodeList||NodeArray||HTMLElement)
   * @param {HTMLElement} container 父容器（默认为document）
   */

  var NodeWrap = function () {
    function NodeWrap(selector) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

      _classCallCheck(this, NodeWrap);

      var _this = this;
      _this.selector = selector;

      /* String||NodeList||HTMLElement 识别处理 */
      var elsArr = void 0;
      if (selector && selector.constructor === NodeList) {
        /* 支持直接传入NodeList来构建包装器 */
        elsArr = makeArray(selector);
      } else if (isArray(selector)) {
        /* 支持直接传入Node数组来构建包装器 */
        elsArr = selector;
      } else if (isString(selector)) {
        if (selector.indexOf('<') === 0) {
          /* 支持直接传入HTML字符串来新建DOM并构建包装器 */
          _divEl.innerHTML = selector;
          elsArr = query('*', _divEl, true);
        } else {
          /* 支持直接传入字符串选择器来查找DOM并构建包装器 */
          elsArr = query(selector, container, true);
        }
      } else {
        /* 其他任意对象直接构建包装器 */
        elsArr = [selector];
      }
      _Object$assign(_this, elsArr);

      /* NodeWrap本意可以 extends Array省略构造方法中下面这部分代码，但目前编译不支持 */
      _this.length = elsArr.length;
    }

    /**
     * 循环遍历DOM集合
     * @param {Function} fn 遍历函数 fn(item, i)
     * @return {Object}
     */


    _createClass(NodeWrap, [{
      key: 'each',
      value: function each() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _arrPrototype.forEach.apply(this, args);
        return this;
      }

      /**
       * 添加元素到DOM集合
       * @param {HTMLElement} el 要加入的元素
       * @return {this}
       */

    }, {
      key: 'push',
      value: function push() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _arrPrototype.push.apply(this, args);
        return this;
      }

      /**
       * 截取DOM集合片段，并得到新的包装器splice
       * @param {Nubmer} start
       * @param {Nubmer} count
       * @return {NodeWrap} 新的DOM集合包装器
       */

    }, {
      key: 'splice',
      value: function splice() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return $(_arrPrototype.splice.apply(this, args));
      }

      /**
       * 查找子元素
       * @param {String} selector 选择器
       * @return {NodeWrap} 新的DOM集合包装器
       */

    }, {
      key: 'find',
      value: function find(selector) {
        var childs = [];
        this.each(function (el) {
          childs = childs.concat(query(selector, el, true));
        });
        var childsWrap = $(childs);
        childsWrap.parent = this;
        childsWrap.selector = selector;
        return childsWrap;
      }

      /**
       * 添加子元素
       * @param {HTMLElement} childEls 要添加的HTML元素
       * @return {this}
       */

    }, {
      key: 'append',
      value: function append(childEls) {
        var childsWrap = $(childEls);
        var firstEl = this[0];
        childsWrap.each(function (newEl) {
          return firstEl.appendChild(newEl);
        });
        return this;
      }

      /**
       * 将元素集合添加到指定容器
       * @param {HTMLElement} parentEl 要添加到父容器
       * @return {this}
       */

    }, {
      key: 'appendTo',
      value: function appendTo(parentEl) {
        $(parentEl).append(this);
        return this;
      }

      /**
       * DOM集合text内容读写操作
       * @param {String} val 文本内容（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'text',
      value: function text(val) {
        if (arguments.length === 0) {
          return this[0][_textAttrName];
        }
        return this.each(function (el) {
          el[_textAttrName] = val;
        });
      }

      /**
       * DOM集合HTML内容读写操作
       * @param {String} html html内容（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'html',
      value: function html(_html) {
        if (arguments.length === 0) {
          return this[0].innerHTML;
        }
        return this.each(function (el) {
          el.innerHTML = _html;
        });
      }

      /**
       * DOM集合属性读写操作
       * @param {String} name 属性名称
       * @param {String} val 属性值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'attr',
      value: function attr(name, val) {
        if (arguments.length === 1) {
          return getAttr(this[0], name);
        }
        return this.each(function (el) {
          return setAttr(el, name, val);
        });
      }

      /**
       * DOM集合dataset读写操作
       * @param {String} key 键名
       * @param {Any} val 键值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'data',
      value: function data(key, val) {
        if (arguments.length === 0) {
          return this[0].dataset || {};
        }
        if (arguments.length === 1) {
          return (this[0].dataset || {})[key];
        }
        return this.each(function (el) {
          (el.dataset || (el.dataset = {}))[key] = val;
        });
      }

      /**
       * DOM集合样式读写操作
       * @param {String} key 样式key
       * @param {String} val 样式值（如果有设置该参数则执行写操作，否则执行读操作）
       * @return {this}
       */

    }, {
      key: 'css',
      value: function css(key, val) {
        if (arguments.length === 1 && !isObject$1(key)) {
          return getStyle(this[0], key);
        }
        return this.each(function (el) {
          return setStyle(el, key, val);
        });
      }

      /**
       * 为DOM集合增加className
       * @param {String} cls 要增加的className
       * @return {this}
       */

    }, {
      key: 'addClass',
      value: function addClass(cls) {
        return this.each(function (el) {
          return addClassName(el, cls);
        });
      }

      /**
       * 移除当前DOM集合的className
       * @param {String} cls 要移除的className
       * @return {this}
       */

    }, {
      key: 'removeClass',
      value: function removeClass(cls) {
        return this.each(function (el) {
          return removeClassName(el, cls);
        });
      }

      /**
       * 检查索引0的DOM是否有className
       * @param {String} cls 要检查的className
       * @return {this}
       */

    }, {
      key: 'hasClass',
      value: function hasClass(cls) {
        return hasClassName(this[0], cls);
      }

      /**
       * 为DOM集合添加事件监听
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} once 是否只监听一次
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'on',
      value: function on(type, handler) {
        var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return addEvent(el, type, handler, once, capture);
        });
      }

      /**
       * 为DOM集合解除事件监听
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} once 是否只监听一次
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'off',
      value: function off(type, handler) {
        var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return removeEvent(el, type, handler, once, capture);
        });
      }

      /**
       * 为DOM集合绑定事件代理
       * @param {String} selector 目标子元素选择器
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'delegate',
      value: function delegate(selector, type, handler) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return addDelegate(el, selector, type, handler, capture);
        });
      }

      /**
       * 为DOM集合解绑事件代理
       * @param {String} selector 目标子元素选择器
       * @param {String} type 事件名称
       * @param {Function} handler 处理函数
       * @param {Boolean} capture 是否在捕获阶段监听
       * @return {this}
       */

    }, {
      key: 'undelegate',
      value: function undelegate(selector, type, handler) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return this.each(function (el) {
          return removeDelegate(el, selector, type, handler, capture);
        });
      }

      /**
       * 从DOM树中移除
       * @return {this}
       */

    }, {
      key: 'remove',
      value: function remove() {
        return this.each(function (el) {
          return removeEl(el);
        });
      }
    }]);

    return NodeWrap;
  }();

  function $(selector, container) {
    return selector.constructor === NodeWrap ? selector : new NodeWrap(selector, container);
  }

  /**
   * chimee-helper-log v0.1.3
   * (c) 2017 toxic-johann
   * Released under MIT
   */

  function formatter(tag, msg) {
    if (!isString(tag)) throw new TypeError('Log\'s method only acccept string as argument, but not ' + tag + ' in ' + (typeof tag === 'undefined' ? 'undefined' : _typeof(tag)));
    if (!isString(msg)) return '[' + Log.GLOBAL_TAG + '] > ' + tag;
    tag = Log.FORCE_GLOBAL_TAG ? Log.GLOBAL_TAG : tag || Log.GLOBAL_TAG;
    return '[' + tag + '] > ' + msg;
  }
  /**
   * Log Object
   */

  var Log = function () {
    function Log() {
      _classCallCheck(this, Log);
    }

    _createClass(Log, null, [{
      key: 'error',

      /**
       * equal to console.error, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */
      value: function error(tag, msg) {
        if (!Log.ENABLE_ERROR) {
          return;
        }

        (console.error || console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.info, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {boolean}
       */

      /**
       * @member {string}
       */

    }, {
      key: 'info',
      value: function info(tag, msg) {
        if (!Log.ENABLE_INFO) {
          return;
        }
        (console.info || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.warn, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'warn',
      value: function warn(tag, msg) {
        if (!Log.ENABLE_WARN) {
          return;
        }
        (console.warn || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.debug, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'debug',
      value: function debug(tag, msg) {
        if (!Log.ENABLE_DEBUG) {
          return;
        }
        (console.debug || console.log).call(console, formatter(tag, msg));
      }
      /**
       * equal to console.verbose, output `[${tag}] > {$msg}`
       * @param {string} tag optional, the header of log 
       * @param {string} msg the message
       */

    }, {
      key: 'verbose',
      value: function verbose(tag, msg) {
        if (!Log.ENABLE_VERBOSE) {
          return;
        }
        console.log(formatter(tag, msg));
      }
    }]);

    return Log;
  }();

  Log.GLOBAL_TAG = 'chimee';
  Log.FORCE_GLOBAL_TAG = false;
  Log.ENABLE_ERROR = true;
  Log.ENABLE_INFO = true;
  Log.ENABLE_WARN = true;
  Log.ENABLE_DEBUG = true;
  Log.ENABLE_VERBOSE = true;

  var uaParser = createCommonjsModule$$1(function (module, exports) {
  /**
   * UAParser.js v0.7.17
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
   * Dual licensed under GPLv2 & MIT
   */

  (function (window, undefined) {

      var LIBVERSION  = '0.7.17',
          EMPTY       = '',
          UNKNOWN     = '?',
          FUNC_TYPE   = 'function',
          UNDEF_TYPE  = 'undefined',
          OBJ_TYPE    = 'object',
          STR_TYPE    = 'string',
          MAJOR       = 'major', // deprecated
          MODEL       = 'model',
          NAME        = 'name',
          TYPE        = 'type',
          VENDOR      = 'vendor',
          VERSION     = 'version',
          ARCHITECTURE= 'architecture',
          CONSOLE     = 'console',
          MOBILE      = 'mobile',
          TABLET      = 'tablet',
          SMARTTV     = 'smarttv',
          WEARABLE    = 'wearable',
          EMBEDDED    = 'embedded';


      ///////////
      // Helper
      //////////


      var util = {
          extend : function (regexes, extensions) {
              var margedRegexes = {};
              for (var i in regexes) {
                  if (extensions[i] && extensions[i].length % 2 === 0) {
                      margedRegexes[i] = extensions[i].concat(regexes[i]);
                  } else {
                      margedRegexes[i] = regexes[i];
                  }
              }
              return margedRegexes;
          },
          has : function (str1, str2) {
            if (typeof str1 === "string") {
              return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
            } else {
              return false;
            }
          },
          lowerize : function (str) {
              return str.toLowerCase();
          },
          major : function (version) {
              return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
          },
          trim : function (str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
          }
      };


      ///////////////
      // Map helper
      //////////////


      var mapper = {

          rgx : function (ua, arrays) {

              //var result = {},
              var i = 0, j, k, p, q, matches, match;//, args = arguments;

              /*// construct object barebones
              for (p = 0; p < args[1].length; p++) {
                  q = args[1][p];
                  result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
              }*/

              // loop through all regexes maps
              while (i < arrays.length && !matches) {

                  var regex = arrays[i],       // even sequence (0,2,4,..)
                      props = arrays[i + 1];   // odd sequence (1,3,5,..)
                  j = k = 0;

                  // try matching uastring with regexes
                  while (j < regex.length && !matches) {

                      matches = regex[j++].exec(ua);

                      if (!!matches) {
                          for (p = 0; p < props.length; p++) {
                              match = matches[++k];
                              q = props[p];
                              // check if given property is actually array
                              if (typeof q === OBJ_TYPE && q.length > 0) {
                                  if (q.length == 2) {
                                      if (typeof q[1] == FUNC_TYPE) {
                                          // assign modified match
                                          this[q[0]] = q[1].call(this, match);
                                      } else {
                                          // assign given value, ignore regex match
                                          this[q[0]] = q[1];
                                      }
                                  } else if (q.length == 3) {
                                      // check whether function or regex
                                      if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                          // call function (usually string mapper)
                                          this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                      } else {
                                          // sanitize match using given regex
                                          this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                      }
                                  } else if (q.length == 4) {
                                          this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                  }
                              } else {
                                  this[q] = match ? match : undefined;
                              }
                          }
                      }
                  }
                  i += 2;
              }
              // console.log(this);
              //return this;
          },

          str : function (str, map) {

              for (var i in map) {
                  // check if array
                  if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                      for (var j = 0; j < map[i].length; j++) {
                          if (util.has(map[i][j], str)) {
                              return (i === UNKNOWN) ? undefined : i;
                          }
                      }
                  } else if (util.has(map[i], str)) {
                      return (i === UNKNOWN) ? undefined : i;
                  }
              }
              return str;
          }
      };


      ///////////////
      // String map
      //////////////


      var maps = {

          browser : {
              oldsafari : {
                  version : {
                      '1.0'   : '/8',
                      '1.2'   : '/1',
                      '1.3'   : '/3',
                      '2.0'   : '/412',
                      '2.0.2' : '/416',
                      '2.0.3' : '/417',
                      '2.0.4' : '/419',
                      '?'     : '/'
                  }
              }
          },

          device : {
              amazon : {
                  model : {
                      'Fire Phone' : ['SD', 'KF']
                  }
              },
              sprint : {
                  model : {
                      'Evo Shift 4G' : '7373KT'
                  },
                  vendor : {
                      'HTC'       : 'APA',
                      'Sprint'    : 'Sprint'
                  }
              }
          },

          os : {
              windows : {
                  version : {
                      'ME'        : '4.90',
                      'NT 3.11'   : 'NT3.51',
                      'NT 4.0'    : 'NT4.0',
                      '2000'      : 'NT 5.0',
                      'XP'        : ['NT 5.1', 'NT 5.2'],
                      'Vista'     : 'NT 6.0',
                      '7'         : 'NT 6.1',
                      '8'         : 'NT 6.2',
                      '8.1'       : 'NT 6.3',
                      '10'        : ['NT 6.4', 'NT 10.0'],
                      'RT'        : 'ARM'
                  }
              }
          }
      };


      //////////////
      // Regex map
      /////////////


      var regexes = {

          browser : [[

              // Presto based
              /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
              /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
              /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
              /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
              ], [NAME, VERSION], [

              /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
              ], [[NAME, 'Opera Mini'], VERSION], [

              /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
              ], [[NAME, 'Opera'], VERSION], [

              // Mixed
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                  // Lunascape/Maxthon/Netfront/Jasmine/Blazer

              // Trident based
              /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                  // Avant/IEMobile/SlimBrowser/Baidu
              /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

              // Webkit/KHTML based
              /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
              /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
                                                                                  // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
              ], [NAME, VERSION], [

              /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
              ], [[NAME, 'IE'], VERSION], [

              /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
              ], [NAME, VERSION], [

              /(yabrowser)\/([\w\.]+)/i                                           // Yandex
              ], [[NAME, 'Yandex'], VERSION], [

              /(puffin)\/([\w\.]+)/i                                              // Puffin
              ], [[NAME, 'Puffin'], VERSION], [

              /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                  // UCBrowser
              ], [[NAME, 'UCBrowser'], VERSION], [

              /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
              ], [[NAME, /_/g, ' '], VERSION], [

              /(micromessenger)\/([\w\.]+)/i                                      // WeChat
              ], [[NAME, 'WeChat'], VERSION], [

              /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
              ], [NAME, VERSION], [

              /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
              ], [NAME, VERSION], [

              /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
              ], [VERSION, [NAME, 'MIUI Browser']], [

              /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
              ], [VERSION, [NAME, 'Facebook']], [

              /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
              ], [VERSION, [NAME, 'Chrome Headless']], [

              /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
              ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

              /((?:oculus|samsung)browser)\/([\w\.]+)/i
              ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

              /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
              ], [VERSION, [NAME, 'Android Browser']], [

              /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                  // Chrome/OmniWeb/Arora/Tizen/Nokia
              ], [NAME, VERSION], [

              /(dolfin)\/([\w\.]+)/i                                              // Dolphin
              ], [[NAME, 'Dolphin'], VERSION], [

              /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
              ], [[NAME, 'Chrome'], VERSION], [

              /(coast)\/([\w\.]+)/i                                               // Opera Coast
              ], [[NAME, 'Opera Coast'], VERSION], [

              /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
              ], [VERSION, [NAME, 'Firefox']], [

              /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
              ], [VERSION, [NAME, 'Mobile Safari']], [

              /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
              ], [VERSION, NAME], [

              /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
              ], [[NAME, 'GSA'], VERSION], [

              /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
              ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

              /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
              /(webkit|khtml)\/([\w\.]+)/i
              ], [NAME, VERSION], [

              // Gecko based
              /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
              ], [[NAME, 'Netscape'], VERSION], [
              /(swiftfox)/i,                                                      // Swiftfox
              /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                  // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
              /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                  // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
              /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

              // Other
              /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                  // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
              /(links)\s\(([\w\.]+)/i,                                            // Links
              /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
              /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
              /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
              ], [NAME, VERSION]

              /* /////////////////////
              // Media players BEGIN
              ////////////////////////

              , [

              /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
              /(coremedia) v((\d+)[\w\._]+)/i
              ], [NAME, VERSION], [

              /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
              ], [NAME, VERSION], [

              /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
              ], [NAME, VERSION], [

              /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                  // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                  // NSPlayer/PSP-InternetRadioPlayer/Videos
              /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
              /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
              /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
              ], [NAME, VERSION], [
              /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
              ], [NAME, VERSION], [

              /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
              ], [[NAME, 'Flip Player'], VERSION], [

              /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                  // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
              ], [NAME], [

              /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                  // Gstreamer
              ], [NAME, VERSION], [

              /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
              /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                  // Java/urllib/requests/wget/cURL
              /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
              ], [NAME, VERSION], [

              /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
              ], [[NAME, /_/g, ' '], VERSION], [

              /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                  // MPlayer SVN
              ], [NAME, VERSION], [

              /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
              ], [NAME, VERSION], [

              /(mplayer)/i,                                                       // MPlayer (no other info)
              /(yourmuze)/i,                                                      // YourMuze
              /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
              ], [NAME], [

              /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
              ], [NAME, VERSION], [

              /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
              ], [NAME, VERSION], [

              /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
              ], [NAME, VERSION], [

              /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
              /(winamp)\s((\d+)[\w\.-]+)/i,
              /(winamp)mpeg\/((\d+)[\w\.-]+)/i
              ], [NAME, VERSION], [

              /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                  // inlight radio
              ], [NAME], [

              /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                  // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                  // SoundTap/Totem/Stagefright/Streamium
              ], [NAME, VERSION], [

              /(smp)((\d+)[\d\.]+)/i                                              // SMP
              ], [NAME, VERSION], [

              /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
              /(vlc)\/((\d+)[\w\.-]+)/i,
              /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
              /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
              /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
              ], [NAME, VERSION], [

              /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
              /(windows-media-player)\/((\d+)[\w\.-]+)/i
              ], [[NAME, /-/g, ' '], VERSION], [

              /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                  // Windows Media Server
              ], [VERSION, [NAME, 'Windows']], [

              /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
              ], [NAME, VERSION], [

              /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
              /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
              ], [[NAME, 'rad.io'], VERSION]

              //////////////////////
              // Media players END
              ////////////////////*/

          ],

          cpu : [[

              /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
              ], [[ARCHITECTURE, 'amd64']], [

              /(ia32(?=;))/i                                                      // IA32 (quicktime)
              ], [[ARCHITECTURE, util.lowerize]], [

              /((?:i[346]|x)86)[;\)]/i                                            // IA32
              ], [[ARCHITECTURE, 'ia32']], [

              // PocketPC mistakenly identified as PowerPC
              /windows\s(ce|mobile);\sppc;/i
              ], [[ARCHITECTURE, 'arm']], [

              /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
              ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

              /(sun4\w)[;\)]/i                                                    // SPARC
              ], [[ARCHITECTURE, 'sparc']], [

              /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                  // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
              ], [[ARCHITECTURE, util.lowerize]]
          ],

          device : [[

              /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
              ], [MODEL, VENDOR, [TYPE, TABLET]], [

              /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
              ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

              /(apple\s{0,1}tv)/i                                                 // Apple TV
              ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

              /(archos)\s(gamepad2?)/i,                                           // Archos
              /(hp).+(touchpad)/i,                                                // HP TouchPad
              /(hp).+(tablet)/i,                                                  // HP Tablet
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
              /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
              ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
              /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
              ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

              /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
              ], [MODEL, VENDOR, [TYPE, MOBILE]], [
              /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
              ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

              /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
              /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                  // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
              /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
              /(asus)-?(\w+)/i                                                    // Asus
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
              ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                  // Asus Tablets
              /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
              ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

              /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
              /(sony)?(?:sgp.+)\sbuild\//i
              ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
              /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
              ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

              /\s(ouya)\s/i,                                                      // Ouya
              /(nintendo)\s([wids3u]+)/i                                          // Nintendo
              ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

              /android.+;\s(shield)\sbuild/i                                      // Nvidia
              ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

              /(playstation\s[34portablevi]+)/i                                   // Playstation
              ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

              /(sprint\s(\w+))/i                                                  // Sprint Phones
              ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

              /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
              /(zte)-(\w+)*/i,                                                    // ZTE
              /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                  // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
              ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

              /(nexus\s9)/i                                                       // HTC Nexus 9
              ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

              /d\/huawei([\w\s-]+)[;\)]/i,
              /(nexus\s6p)/i                                                      // Huawei
              ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

              /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
              ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
              /(kin\.[onetw]{3})/i                                                // Microsoft Kin
              ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                  // Motorola
              /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
              /mot[\s-]?(\w+)*/i,
              /(XT\d{3,4}) build\//i,
              /(nexus\s6)/i
              ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
              /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
              ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

              /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
              ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

              /hbbtv.+maple;(\d+)/i
              ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

              /\(dtv[\);].+(aquos)/i                                              // Sharp
              ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

              /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
              /((SM-T\w+))/i
              ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
              /smart-tv.+(samsung)/i
              ], [VENDOR, [TYPE, SMARTTV], MODEL], [
              /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
              /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
              /sec-((sgh\w+))/i
              ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

              /sie-(\w+)*/i                                                       // Siemens
              ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

              /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
              /(nokia)[\s_-]?([\w-]+)*/i
              ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

              /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
              ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

              /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
              ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
              /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
              ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
              /(lg) netcast\.tv/i                                                 // LG SmartTV
              ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
              /(nexus\s[45])/i,                                                   // LG
              /lg[e;\s\/-]+(\w+)*/i,
              /android.+lg(\-?[\d\w]+)\s+build/i
              ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

              /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
              ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

              /linux;.+((jolla));/i                                               // Jolla
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /((pebble))app\/[\d\.]+\s/i                                         // Pebble
              ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

              /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /crkey/i                                                            // Google Chromecast
              ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

              /android.+;\s(glass)\s\d/i                                          // Google Glass
              ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

              /android.+;\s(pixel c)\s/i                                          // Google Pixel C
              ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

              /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
              ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

              /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
              /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
              /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
              /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
              ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
              /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
              ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
              /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
              ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

              /android.+a000(1)\s+build/i                                         // OnePlus
              ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

              /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
              ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
              ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
              ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

              /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
              ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
              ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
              ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
              ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

              /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
              ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

              /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
              ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

              /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
              /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
              ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
              ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

              /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
              ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
              ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

              /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
              ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

              /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
              ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
              ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

              /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
              ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

              /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
              ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

              /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
              ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
              /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
              ], [[TYPE, util.lowerize], VENDOR, MODEL], [

              /(android.+)[;\/].+build/i                                          // Generic Android Device
              ], [MODEL, [VENDOR, 'Generic']]


          /*//////////////////////////
              // TODO: move to string map
              ////////////////////////////

              /(C6603)/i                                                          // Sony Xperia Z C6603
              ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
              /(C6903)/i                                                          // Sony Xperia Z 1
              ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

              /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
              ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
              ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
              ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G313HZ)/i                                                      // Samsung Galaxy V
              ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
              ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
              /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
              ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
              ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

              /(T3C)/i                                                            // Advan Vandroid T3C
              ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
              /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
              ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
              /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
              ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

              /(V972M)/i                                                          // ZTE V972M
              ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

              /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
              ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
              /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
              ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

              /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
              ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

              /////////////
              // END TODO
              ///////////*/

          ],

          engine : [[

              /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
              ], [VERSION, [NAME, 'EdgeHTML']], [

              /(presto)\/([\w\.]+)/i,                                             // Presto
              /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
              /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
              /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
              ], [NAME, VERSION], [

              /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
              ], [VERSION, NAME]
          ],

          os : [[

              // Windows based
              /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
              ], [NAME, VERSION], [
              /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
              /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
              /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
              ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
              /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
              ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

              // Mobile/Embedded OS
              /\((bb)(10);/i                                                      // BlackBerry 10
              ], [[NAME, 'BlackBerry'], VERSION], [
              /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
              /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
              /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                  // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
              /linux;.+(sailfish);/i                                              // Sailfish OS
              ], [NAME, VERSION], [
              /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
              ], [[NAME, 'Symbian'], VERSION], [
              /\((series40);/i                                                    // Series 40
              ], [NAME], [
              /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
              ], [[NAME, 'Firefox OS'], VERSION], [

              // Console
              /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

              // GNU/Linux based
              /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
              /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
              /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                  // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                  // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
              /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
              /(gnu)\s?([\w\.]+)*/i                                               // GNU
              ], [NAME, VERSION], [

              /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
              ], [[NAME, 'Chromium OS'], VERSION],[

              // Solaris
              /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
              ], [[NAME, 'Solaris'], VERSION], [

              // BSD based
              /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
              ], [NAME, VERSION],[

              /(haiku)\s(\w+)/i                                                  // Haiku
              ], [NAME, VERSION],[

              /cfnetwork\/.+darwin/i,
              /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
              ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

              /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
              /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
              ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

              // Other
              /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
              /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
              /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                  // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
              /(unix)\s?([\w\.]+)*/i                                              // UNIX
              ], [NAME, VERSION]
          ]
      };


      /////////////////
      // Constructor
      ////////////////
      /*
      var Browser = function (name, version) {
          this[NAME] = name;
          this[VERSION] = version;
      };
      var CPU = function (arch) {
          this[ARCHITECTURE] = arch;
      };
      var Device = function (vendor, model, type) {
          this[VENDOR] = vendor;
          this[MODEL] = model;
          this[TYPE] = type;
      };
      var Engine = Browser;
      var OS = Browser;
      */
      var UAParser = function (uastring, extensions) {

          if (typeof uastring === 'object') {
              extensions = uastring;
              uastring = undefined;
          }

          if (!(this instanceof UAParser)) {
              return new UAParser(uastring, extensions).getResult();
          }

          var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
          var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
          //var browser = new Browser();
          //var cpu = new CPU();
          //var device = new Device();
          //var engine = new Engine();
          //var os = new OS();

          this.getBrowser = function () {
              var browser = { name: undefined, version: undefined };
              mapper.rgx.call(browser, ua, rgxmap.browser);
              browser.major = util.major(browser.version); // deprecated
              return browser;
          };
          this.getCPU = function () {
              var cpu = { architecture: undefined };
              mapper.rgx.call(cpu, ua, rgxmap.cpu);
              return cpu;
          };
          this.getDevice = function () {
              var device = { vendor: undefined, model: undefined, type: undefined };
              mapper.rgx.call(device, ua, rgxmap.device);
              return device;
          };
          this.getEngine = function () {
              var engine = { name: undefined, version: undefined };
              mapper.rgx.call(engine, ua, rgxmap.engine);
              return engine;
          };
          this.getOS = function () {
              var os = { name: undefined, version: undefined };
              mapper.rgx.call(os, ua, rgxmap.os);
              return os;
          };
          this.getResult = function () {
              return {
                  ua      : this.getUA(),
                  browser : this.getBrowser(),
                  engine  : this.getEngine(),
                  os      : this.getOS(),
                  device  : this.getDevice(),
                  cpu     : this.getCPU()
              };
          };
          this.getUA = function () {
              return ua;
          };
          this.setUA = function (uastring) {
              ua = uastring;
              //browser = new Browser();
              //cpu = new CPU();
              //device = new Device();
              //engine = new Engine();
              //os = new OS();
              return this;
          };
          return this;
      };

      UAParser.VERSION = LIBVERSION;
      UAParser.BROWSER = {
          NAME    : NAME,
          MAJOR   : MAJOR, // deprecated
          VERSION : VERSION
      };
      UAParser.CPU = {
          ARCHITECTURE : ARCHITECTURE
      };
      UAParser.DEVICE = {
          MODEL   : MODEL,
          VENDOR  : VENDOR,
          TYPE    : TYPE,
          CONSOLE : CONSOLE,
          MOBILE  : MOBILE,
          SMARTTV : SMARTTV,
          TABLET  : TABLET,
          WEARABLE: WEARABLE,
          EMBEDDED: EMBEDDED
      };
      UAParser.ENGINE = {
          NAME    : NAME,
          VERSION : VERSION
      };
      UAParser.OS = {
          NAME    : NAME,
          VERSION : VERSION
      };
      //UAParser.Utils = util;

      ///////////
      // Export
      //////////


      // check js environment
      {
          // nodejs env
          if (module.exports) {
              exports = module.exports = UAParser;
          }
          // TODO: test!!!!!!!!
          /*
          if (require && require.main === module && process) {
              // cli
              var jsonize = function (arr) {
                  var res = [];
                  for (var i in arr) {
                      res.push(new UAParser(arr[i]).getResult());
                  }
                  process.stdout.write(JSON.stringify(res, null, 2) + '\n');
              };
              if (process.stdin.isTTY) {
                  // via args
                  jsonize(process.argv.slice(2));
              } else {
                  // via pipe
                  var str = '';
                  process.stdin.on('readable', function() {
                      var read = process.stdin.read();
                      if (read !== null) {
                          str += read;
                      }
                  });
                  process.stdin.on('end', function () {
                      jsonize(str.replace(/\n$/, '').split('\n'));
                  });
              }
          }
          */
          exports.UAParser = UAParser;
      }

      // jQuery/Zepto specific (optional)
      // Note:
      //   In AMD env the global scope should be kept clean, but jQuery is an exception.
      //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
      //   and we should catch that.
      var $ = window && (window.jQuery || window.Zepto);
      if (typeof $ !== UNDEF_TYPE) {
          var parser = new UAParser();
          $.ua = parser.getResult();
          $.ua.get = function () {
              return parser.getUA();
          };
          $.ua.set = function (uastring) {
              parser.setUA(uastring);
              var result = parser.getResult();
              for (var prop in result) {
                  $.ua[prop] = result[prop];
              }
          };
      }

  })(typeof window === 'object' ? window : commonjsGlobal$$1);
  });

  var uaParser_1 = uaParser.UAParser;

  exports.Log = Log;
  exports.UAParser = uaParser;
  exports.genTraversalHandler = genTraversalHandler;
  exports.deepClone = deepClone;
  exports.deepAssign = deepAssign;
  exports.camelize = camelize;
  exports.hypenate = hypenate;
  exports.bind = bind;
  exports.uuid = uuid;
  exports.S4 = S4;
  exports.rand = rand;
  exports.getDeepProperty = getDeepProperty;
  exports.defined = defined$1;
  exports.isVoid = isVoid;
  exports.isArray = isArray;
  exports.isFunction = isFunction;
  exports.isObject = isObject$1;
  exports.isNumber = isNumber;
  exports.isNumeric = isNumeric;
  exports.isInteger = isInteger;
  exports.isEmpty = isEmpty;
  exports.isEvent = isEvent;
  exports.isBlob = isBlob;
  exports.isFile = isFile;
  exports.isDate = isDate;
  exports.isString = isString;
  exports.isBoolean = isBoolean;
  exports.isPromise = isPromise;
  exports.isPrimitive = isPrimitive;
  exports.isUrl = isUrl;
  exports.isNode = isNode;
  exports.isElement = isElement;
  exports.isChildNode = isChildNode;
  exports.isPosterityNode = isPosterityNode;
  exports.isHTMLString = isHTMLString;
  exports.isError = isError;
  exports.isRegExp = isRegExp;
  exports.inBrowser = inBrowser;
  exports.makeArray = makeArray;
  exports.transObjectAttrIntoArray = transObjectAttrIntoArray;
  exports.runRejectableQueue = runRejectableQueue;
  exports.runStoppableQueue = runStoppableQueue;
  exports.decodeUTF8 = decodeUTF8;
  exports.debounce = debounce;
  exports.throttle = throttle;
  exports.raf = raf;
  exports.caf = caf;
  exports.strRepeat = strRepeat;
  exports.formatTime = formatTime;
  exports.appendCSS = appendCSS;
  exports.formatDate = formatDate;
  exports.getLocalStorage = getLocalStorage;
  exports.setLocalStorage = setLocalStorage;
  exports.emitEventCache = emitEventCache;
  exports.addEventCache = addEventCache;
  exports.removeEventCache = removeEventCache;
  exports.CustEvent = CustEvent;
  exports.getAttr = getAttr;
  exports.setAttr = setAttr;
  exports.addClassName = addClassName;
  exports.removeClassName = removeClassName;
  exports.hasClassName = hasClassName;
  exports.removeEvent = removeEvent;
  exports.addEvent = addEvent;
  exports.addDelegate = addDelegate;
  exports.removeDelegate = removeDelegate;
  exports.getStyle = getStyle;
  exports.setStyle = setStyle;
  exports.query = query;
  exports.removeEl = removeEl;
  exports.findParents = findParents;
  exports.NodeWrap = NodeWrap;
  exports.$ = $;

  Object.defineProperty(exports, '__esModule', { value: true });

  })));

  /* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)));

  /***/ }),
  /* 12 */
  /***/ (function(module, exports, __webpack_require__) {

  module.exports = __webpack_require__(13);


  /***/ }),
  /* 13 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _mseController = __webpack_require__(14);

  var _mseController2 = _interopRequireDefault(_mseController);

  var _transmuxer = __webpack_require__(15);

  var _transmuxer2 = _interopRequireDefault(_transmuxer);

  var _config = __webpack_require__(33);

  var _config2 = _interopRequireDefault(_config);

  var _chimeeHelper = __webpack_require__(11);

  var _playerLogger = __webpack_require__(35);

  var _playerLogger2 = _interopRequireDefault(_playerLogger);

  var _playerEvents = __webpack_require__(2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var FlvRealtimeBeaconBuilder = function () {
    function FlvRealtimeBeaconBuilder(src) {
      _classCallCheck(this, FlvRealtimeBeaconBuilder);

      this._resetForNewSession(src);
      this._resetForNewInterval();
    }

    _createClass(FlvRealtimeBeaconBuilder, [{
      key: '_resetForNewSession',
      value: function _resetForNewSession(src) {
        this.currentPlaybackSpeed = 1.0;
        this.lastDownloadedBytes = 0.0;
        this.playUrl = src;
        this.domain = new URL(src).hostname;
        this.playStartTimestampMillis = new Date().getTime();
        this.lastVideoBuffered = { start: -1e9, end: -1e9 };
      }
    }, {
      key: '_resetForNewInterval',
      value: function _resetForNewInterval() {
        this.currentPlaybackSpeedTimestamp = new Date().getTime();
        this.playbackSpeedStat = {
          '0.75x': 0,
          '1.25x': 0,
          '1.5x': 0
        };
        this.statTimestampMillis = new Date().getTime();
        this.bufferingCount = 0;
        this.bufferingDurationMillis = 0;
        // null indicates not buffering, non-null indicates buffering
        this.bufferingStartTimestampMillis = this.bufferingStartTimestampMillis ? new Date().getTime() : null;
        this.downloadedBytes = 0;
        this.audioBufferedMillis = 0;
        this.videoBufferedMillis = 0;
        this.demuxedDurationSec = 0;
        this.excessiveDataDroppedSec = 0;
        // block时缓冲区仍然有数据的情况
        this.blockCountWithBuffer = 0;
        this.bufferDuringBlockSum = 0;
      }
    }, {
      key: 'videoBufferedUpdated',
      value: function videoBufferedUpdated(buffered) {
        if (buffered.length === 0) {
          return;
        }
        var start = buffered.start(buffered.length - 1);
        var end = buffered.end(buffered.length - 1);
        if (start > this.lastVideoBuffered.end + 1e-3) {
          this.demuxedDurationSec += end - start;
          this.lastVideoBuffered = { start: start, end: end };
        } else {
          this.demuxedDurationSec += Math.max(0, end - this.lastVideoBuffered.end);
          this.lastVideoBuffered.end = end;
        }
      }
    }, {
      key: 'playbackSpeedChanged',
      value: function playbackSpeedChanged(newSpeed) {
        var EPS = 1e-3;
        var now = new Date().getTime();
        var accumulatedMs = now - this.currentPlaybackSpeedTimestamp;
        var speedKey = Math.abs(newSpeed - 0.75) < EPS ? '0.75x' : Math.abs(newSpeed - 1.25) < EPS ? '1.25x' : Math.abs(newSpeed - 1.5) < EPS ? '1.5x' : null;
        if (!speedKey) {
          // Some speeds, like "1x", are not counted
          return;
        }
        this.playbackSpeedStat[speedKey] += accumulatedMs;
        this.currentPlaybackSpeedTimestamp = new Date().getTime();
      }
    }, {
      key: 'bufferingStarted',
      value: function bufferingStarted(bufferedLength) {
        var BUFFERED_THRESHOLD = 0.3;
        ++this.bufferingCount;
        this.bufferingStartTimestampMillis = new Date().getTime();

        // 卡时缓冲区>300ms数量
        if (bufferedLength > BUFFERED_THRESHOLD) {
          this.bufferDuringBlockSum += bufferedLength;
          this.blockCountWithBuffer++;
        }
      }
    }, {
      key: 'bufferingEnded',
      value: function bufferingEnded() {
        var now = new Date().getTime();
        if (this.bufferingStartTimestampMillis != null) {
          // If this.bufferingStartTimestampMillis is null or undefined
          // Do not accumulated buffering duration
          this.bufferingDurationMillis += now - this.bufferingStartTimestampMillis;
        }
        this.bufferingStartTimestampMillis = null;
      }
    }, {
      key: 'updateDownloadedBytes',
      value: function updateDownloadedBytes(newDownloadedBytes) {
        var newlyDownloaded = newDownloadedBytes - this.lastDownloadedBytes;
        this.downloadedBytes += newlyDownloaded;
        this.lastDownloadedBytes = newDownloadedBytes;
      }
    }, {
      key: 'setAudioBufferedSec',
      value: function setAudioBufferedSec(audioBufferedSec) {
        this.audioBufferedMillis = Math.round(audioBufferedSec * 1000);
      }
    }, {
      key: 'setVideoBufferedSec',
      value: function setVideoBufferedSec(videoBufferedSec) {
        this.videoBufferedMillis = Math.round(videoBufferedSec * 1000);
      }
    }, {
      key: 'excessiveDataDropped',
      value: function excessiveDataDropped(droppedSec) {
        this.excessiveDataDroppedSec += droppedSec;
      }
    }, {
      key: 'buildAndStartNewInterval',
      value: function buildAndStartNewInterval() {
        var now = new Date().getTime();
        var ongoingBufferingDuration = this.bufferingStartTimestampMillis == null ? 0 : now - this.bufferingStartTimestampMillis;
        var ongoingBufferingCount = this.bufferingStartTimestampMillis == null ? 0 : 1;
        var ret = {
          'play_url': this.playUrl,
          'domain': this.domain,
          'play_start_time': this.playStartTimestampMillis,
          'tick_start': this.statTimestampMillis,
          'tick_duration': now - this.statTimestampMillis,
          'block_count': this.bufferingCount,
          'buffer_time': this.bufferingDurationMillis + ongoingBufferingDuration,
          'kbytes_received': this.downloadedBytes >> 10,
          'played_video_duration': now - this.statTimestampMillis - (this.bufferingDurationMillis + ongoingBufferingDuration),
          'demuxed_video_duration': Math.round(this.demuxedDurationSec * 1000),
          'dropped_packet_duration': Math.round(this.excessiveDataDroppedSec * 1000),
          'a_buf_len': this.audioBufferedMillis,
          'v_buf_len': this.videoBufferedMillis,
          'speed_chg_metric': this.playbackSpeedStat,
          'block_count_with_buffer': this.blockCountWithBuffer,
          'buffer_during_block': this.blockCountWithBuffer > 0 ? Math.round(this.bufferDuringBlockSum / this.blockCountWithBuffer * 1000) : 0
        };
        this._resetForNewInterval();
        return ret;
      }
    }]);

    return FlvRealtimeBeaconBuilder;
  }();

  /**
   * flv controller
   * @export
   * @class Flv
   */


  var Flv = function (_CustEvent) {
    _inherits(Flv, _CustEvent);

    _createClass(Flv, null, [{
      key: 'isSupport',
      value: function isSupport() {
        var parser = new _chimeeHelper.UAParser();
        var info = parser.getBrowser();
        if (info.name === 'Safari' && parseInt(info.major) < 10) {
          return false;
        }
        if (window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.640020,mp4a.40.2"')) {
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: 'version',
      get: function get() {
        return "1.4.11";
      }

      /**
      * flv Wrapper
      * @param {any} wrap videoElement
      * @param {any} option
      * @class Flv
      */

    }]);

    function Flv(videodom, config) {
      _classCallCheck(this, Flv);

      var _this2 = _possibleConstructorReturn(this, (Flv.__proto__ || Object.getPrototypeOf(Flv)).call(this));

      _this2.tag = 'flv-player';
      _this2.video = videodom;
      _this2.box = 'flv';
      _this2.timer = null;
      _this2.seekTimer = null;
      _this2.checkBufferTimer = null;
      _this2.realtimeBeaconTimer = null;
      _this2.config = (0, _chimeeHelper.deepAssign)({}, _config2.default, config);
      _this2.requestSetTime = false;
      _this2.throttle = null;
      _this2.bindEvents();
      _this2.attachMedia();
      _this2.initLogger();
      console.log('kernel', Flv.version);
      return _this2;
    }
    /**
     * 初始化事件处理器
     */


    _createClass(Flv, [{
      key: 'initLogger',
      value: function initLogger() {
        var _this3 = this;

        this.logger = new _playerLogger2.default();
        this.logger.on('performance', function (handle) {
          _this3.emit('performance', handle.data);
        });
      }
      /**
       * internal set currentTime
       * @memberof Flv
       */

    }, {
      key: 'internalPropertyHandle',
      value: function internalPropertyHandle() {
        if (!Object.getOwnPropertyDescriptor) {
          return;
        }
        var _this = this;
        var time = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'currentTime');

        Object.defineProperty(this.video, 'currentTime', {
          get: function get() {
            return time.get.call(_this.video);
          },
          set: function set(t) {
            if (!_this.currentTimeLock) {
              throw new Error('can not set currentTime by youself');
            } else {
              return time.set.call(_this.video, t);
            }
          }
        });
      }

      /**
       * bind events
       * @memberof Flv
       */

    }, {
      key: 'bindEvents',
      value: function bindEvents() {
        if (this.video) {

          this._onVideoCanplay = this._onVideoCanplay.bind(this);
          this._onVideoWaiting = this._onVideoWaiting.bind(this);
          this._onVideoPlaying = this._onVideoPlaying.bind(this);
          this._onVideoTimeupdate = this._onVideoTimeupdate.bind(this);
          this.video.addEventListener('canplay', this._onVideoCanplay);
          this.video.addEventListener('waiting', this._onVideoWaiting);
          this.video.addEventListener('playing', this._onVideoPlaying);
          this.video.addEventListener('timeupdate', this._onVideoTimeupdate);
          this._lastBufferd = null;
          this.checkBufferTimer = setInterval(this._checkBuffer.bind(this), 200);
        }
      }
      /**
       *  移除mediasource事件
       */

    }, {
      key: 'unbindMediaSourceEvent',
      value: function unbindMediaSourceEvent(mediaSource) {
        mediaSource.off('error');
        mediaSource.off('bufferFull');
        mediaSource.off('updateend');
        mediaSource.off('player-event');
      }
      /**
       * new mediaSource
       * @memberof Flv
       */

    }, {
      key: 'attachMedia',
      value: function attachMedia() {
        var _this4 = this;

        this.mediaSource = new _mseController2.default(this.video, this.config);

        this.mediaSource.on('error', function (errorMessage) {
          _this4.emit('error', errorMessage.data);
          if (_this4.transmuxer) {
            _this4.transmuxer.pause();
          }
        });
        this.mediaSource.on('bufferFull', function () {
          _this4.pauseTransmuxer();
        });
        this.mediaSource.on('updateend', function () {
          _this4.onmseUpdateEnd();
        });
        this.mediaSource.on('player-event', function (handle) {
          _this4.logger.record(handle.data);
        });
      }

      /**
       * load
       * @param {string} video url
       * @memberof Flv
       */

    }, {
      key: 'load',
      value: function load(src) {
        if (src) {
          this.config.src = src;
        }
        this.realtimeBeaconBuilder = new FlvRealtimeBeaconBuilder(this.config.src);
        this.realtimeBeaconTimer = setInterval(this._sendRealtimeBeacon.bind(this), 10000);
        this.transmuxer = new _transmuxer2.default(this.mediaSource, this.config, this.globalEvent);
        this.transmuxerEvent(this.transmuxer);
        this.transmuxer.loadSource();
      }
      /**
       * 移除transmuxer事件
       * @param {} transmuxer 
       */

    }, {
      key: 'unbindTransmuxerEvent',
      value: function unbindTransmuxerEvent(transmuxer) {
        transmuxer.off('mediaSegment');
        transmuxer.off('mediaSegmentInit');
        transmuxer.off('error');
        transmuxer.off('end');
        transmuxer.off('heartbeat');
        transmuxer.off('performance');
        transmuxer.off('mediaInfo');
        transmuxer.off('player-event');
      }
    }, {
      key: 'transmuxerEvent',
      value: function transmuxerEvent(transmuxer) {
        var _this5 = this;

        var mediaSource = this.mediaSource;
        transmuxer.on('mediaSegment', function (handle) {
          mediaSource.emit('mediaSegment', handle.data);
        });

        transmuxer.on('mediaSegmentInit', function (handle) {
          mediaSource.emit('mediaSegmentInit', handle.data);
        });

        transmuxer.on('error', function (errorMessage) {
          _this5.emit('error', errorMessage.data);
          transmuxer.pause();
          mediaSource.pause();
        });

        transmuxer.on('end', function (handle) {
          mediaSource.endOfStream();
        });

        transmuxer.on('heartbeat', function (handle) {
          _this5.emit('heartbeat', handle.data);
          _this5.realtimeBeaconBuilder.updateDownloadedBytes(handle.data.totalReceive);
        });
        transmuxer.on('performance', function (handle) {
          var _handle$data = handle.data,
              type = _handle$data.type,
              value = _handle$data.value;

          if (type === 'first-flv-to-mp4') {
            _this5.firstFlvToMp4 = _this5.firstFlvToMp4 || 0;
            _this5.firstFlvToMp4 += value;
            return;
          }
          if (type === 'receive-first-package-duration') {
            _this5.receiveFirstPAckageDuration = _this5.receiveFirstPAckageDuration || 0;
            _this5.receiveFirstPAckageDuration += value;
            return;
          }
          if (type === 'first-flv-package-duration') {
            _this5.firstFlvPackageDuration = _this5.firstFlvPackageDuration || 0;
            _this5.firstFlvPackageDuration += value;
          }
        });

        transmuxer.on('mediaInfo', function (mediaInfo) {
          if (!_this5.mediaInfo) {
            _this5.mediaInfo = mediaInfo;
            _this5.emit('mediaInfo', mediaInfo.data);
            mediaSource.init(mediaInfo.data);
            _this5.video.src = URL.createObjectURL(mediaSource.mediaSource);
            _this5.video.addEventListener('seeking', _this5._throttle.call(_this5));
          } else {
            // kwai 多次media上报也扔出去（应对metadata切换）
            _this5.emit('mediaInfo', mediaInfo.data);
          }
        });
        transmuxer.on('player-event', function (handle) {
          _this5.logger.record(handle.data);
        });
      }
    }, {
      key: '_throttle',
      value: function _throttle() {
        this.throttle = (0, _chimeeHelper.throttle)(this._seek.bind(this), 200, { leading: false });
        return this.throttle;
      }

      /**
       * seek in buffered
       * @param {number} seek time
       * @memberof Flv
       */

    }, {
      key: 'isTimeinBuffered',
      value: function isTimeinBuffered(seconds) {
        var buffered = this.video.buffered;
        for (var i = 0; i < buffered.length; i++) {
          var from = buffered.start(i);
          var to = buffered.end(i);
          if (seconds >= from && seconds < to) {
            return true;
          }
        }
        return false;
      }
    }, {
      key: '_getBufferEnd',
      value: function _getBufferEnd(buffered, currentTime) {
        var currentRangeEnd = 0;

        for (var i = 0; i < buffered.length; i++) {
          var start = buffered.start(i);
          var end = buffered.end(i);
          if (start <= currentTime && currentTime < end) {
            currentRangeEnd = end;
            return currentRangeEnd;
          }
        }
      }

      /**
       * get current buffer end
       * @memberof Flv
       */

    }, {
      key: 'getCurrentBufferEnd',
      value: function getCurrentBufferEnd() {
        return this._getBufferEnd(this.video.buffered, this.video.currentTime);
      }

      /**
       * _seek
       * @param {number} seek time
       * @memberof Flv
       */

    }, {
      key: '_seek',
      value: function _seek(seconds) {
        var _this6 = this;

        if (!this.transmuxer) return;

        this.currentTimeLock = true;
        var currentTime = (0, _chimeeHelper.isNumber)(seconds) && !isNaN(seconds) ? seconds : this.video.currentTime;
        if (this.requestSetTime) {
          this.requestSetTime = false;
          this.currentTimeLock = false;
          return;
        }
        if (this.isTimeinBuffered(currentTime)) {
          if (this.config.alwaysSeekKeyframe) {
            var nearlestkeyframe = this.transmuxer.getNearestKeyframe(Math.floor(currentTime * 1000));
            if (nearlestkeyframe) {
              this.requestSetTime = true;
              this.video.currentTime = nearlestkeyframe.keyframetime / 1000;
            }
          }
        } else {
          _chimeeHelper.Log.verbose(this.tag, 'do seek');
          this.transmuxer.pause();
          var _nearlestkeyframe = this.transmuxer.getNearestKeyframe(Math.floor(currentTime * 1000));
          currentTime = _nearlestkeyframe.keyframetime / 1000;
          this.seekTimer = setTimeout(function () {
            _this6.mediaSource.seek(currentTime);
            _this6.transmuxer.seek(_nearlestkeyframe);
          }, 100);
          this.requestSetTime = true;
          this.video.currentTime = currentTime;
          window.clearInterval(this.timer);
          this.timer = null;
        }
        this.currentTimeLock = false;
        return currentTime;
      }

      /**
       * mediaSource updateend
       * @memberof Flv
       */

    }, {
      key: 'onmseUpdateEnd',
      value: function onmseUpdateEnd() {
        if (this.mediaSource.sourceBuffer.video) {
          this.realtimeBeaconBuilder.videoBufferedUpdated(this.mediaSource.sourceBuffer.video.buffered);
        }
        if (this.config.isLive) {
          return;
        }
        var currentBufferEnd = this.getCurrentBufferEnd();
        var currentTime = this.video.currentTime;
        if (currentBufferEnd >= currentTime + this.config.lazyLoadMaxDuration && this.timer === null) {
          _chimeeHelper.Log.verbose(this.tag, 'Maximum buffering duration exceeded, suspend transmuxing task');
          this.pauseTransmuxer();
        }
      }
      /**
       * heartbeat
       * @memberof Flv
       */

    }, {
      key: 'heartbeat',
      value: function heartbeat() {
        var currentTime = this.video.currentTime;
        var buffered = this.video.buffered;
        var needResume = false;
        for (var i = 0; i < buffered.length; i++) {
          var from = buffered.start(i);
          var to = buffered.end(i);
          if (currentTime >= from && currentTime < to) {
            if (currentTime >= to - this.config.lazyLoadRecoverDuration) {
              needResume = true;
            }
            break;
          }
        }

        if (needResume) {
          window.clearInterval(this.timer);
          this.timer = null;
          _chimeeHelper.Log.verbose(this.tag, 'Continue loading from paused position');
          this.transmuxer.resume();
          this.mediaSource.resume();
        }
      }

      /**
       * Check buffer length regularly and apply various policies to avoid buffering
       * @memberof Flv
       */

    }, {
      key: '_checkBuffer',
      value: function _checkBuffer() {
        var _this7 = this;

        var EPS = 1e-3;
        if (this.config.isLive) {
          // Live stream, try to maintain buffer between 3s and 8s
          // TODO make 3s and 8s configurable
          var currentBufferEnd = this.getCurrentBufferEnd();
          if (typeof currentBufferEnd === 'undefined') {
            // QUICKFIX:
            // if getCurrentBuffereEnd() is undefined, check if currentTime is in a gap,
            // and if it is jump to the latest buffered area

            var _buffered = this.video.buffered;
            var lenBuffered = _buffered.length;
            if (lenBuffered > 0 && _buffered.start(lenBuffered - 1) > this.video.currentTime + EPS) {
              // In a gap, jump to latest buffered area
              _chimeeHelper.Log.verbose('currentTime being in no-data GaP detected. Jumping to ' + _buffered.start(lenBuffered - 1));
              this.video.currentTime = _buffered.start(lenBuffered - 1);
              currentBufferEnd = _buffered.end(lenBuffered - 1);
            } else {
              // Not in a gap, noop
              return;
            }
          }
          var buffered = currentBufferEnd - this.video.currentTime;
          if (this._lastBufferd != null) {
            var changePlaybackRate = function changePlaybackRate(toRate) {
              _chimeeHelper.Log.verbose('Change playback rate from ' + _this7.video.playbackRate + ' to ' + toRate + ', buffered:' + buffered);
              _this7.video.playbackRate = toRate;
              _this7.realtimeBeaconBuilder.playbackSpeedChanged(toRate);
            };
            if (this.video.playbackRate < 1 - EPS) {
              // Slowed down case. If buffer recovers to >= 5s, resume regular speed
              if (buffered > 5 - EPS) {
                changePlaybackRate(1.0);
              }
            } else if (this.video.playbackRate > 1 + EPS) {
              // Speeded up case. If buffer recovers to <= 5s, resume regular speed
              if (buffered < 5 + EPS) {
                changePlaybackRate(1.0);
              }
            }
          }
          this._lastBufferd = buffered;
        }
      }

      /**
       * Emit realtime analystic data
       */

    }, {
      key: '_sendRealtimeBeacon',
      value: function _sendRealtimeBeacon() {
        if (this.mediaSource.sourceBuffer.audio) {
          var bufferEnd = this._getBufferEnd(this.mediaSource.sourceBuffer.audio.buffered, this.video.currentTime);
          this.realtimeBeaconBuilder.setAudioBufferedSec(bufferEnd - this.video.currentTime);
        }
        if (this.mediaSource.sourceBuffer.video) {
          var _bufferEnd = this._getBufferEnd(this.mediaSource.sourceBuffer.video.buffered, this.video.currentTime);
          this.realtimeBeaconBuilder.setVideoBufferedSec(_bufferEnd - this.video.currentTime);
        }
        var beacon = this.realtimeBeaconBuilder.buildAndStartNewInterval();
        this.emit('realtimeBeacon', beacon);
      }
      /**
       * ‘canplay’ event listener
       */

    }, {
      key: '_onVideoCanplay',
      value: function _onVideoCanplay() {
        this.logger.record({ type: _playerEvents.PLAYER_EVENTS.CANPLAY, ts: Date.now() });
        if (this.config.isLive) {
          this.video.play();
        }
        if (this.config.lockInternalProperty) {
          this.internalPropertyHandle();
        }
      }

      /**
       * 'waiting' event listener
       */

    }, {
      key: '_onVideoWaiting',
      value: function _onVideoWaiting() {
        if (this.video && !this.video.seeking) {
          var bufferedLength = 0;
          var buffered = this.video.buffered;
          if (buffered.length > 0) {
            bufferedLength = this.video.buffered.end(buffered.length - 1) - this.video.currentTime;
          }
          this.realtimeBeaconBuilder.bufferingStarted(bufferedLength);
        }
      }

      /**
       * 'playing' event listener
       */

    }, {
      key: '_onVideoPlaying',
      value: function _onVideoPlaying() {
        var bufferedLength = 0;
        var buffered = this.video.buffered;
        // console.log(buffered.start(0), buffered.end(0), this.video.currentTime);
        for (var i = 0; i < buffered.length; i++) {
          if (buffered.start(i) - 0.1 <= this.video.currentTime && buffered.end(i) >= this.video.currentTime) {
            bufferedLength = buffered.end(i) - this.video.currentTime;
            break;
          }
        }
        this.logger.record({ type: _playerEvents.PLAYER_EVENTS.PLAYING, buffered: bufferedLength, ts: Date.now() });
        this.realtimeBeaconBuilder.bufferingEnded();
      }

      /**
       * 'timeupdate' event listener
       */

    }, {
      key: '_onVideoTimeupdate',
      value: function _onVideoTimeupdate() {
        console.log('time update');
        this.video.removeEventListener('timeupdate', this._onVideoTimeupdate);
        this.logger.record({ type: _playerEvents.PLAYER_EVENTS.TIMEUPDATE, ts: Date.now() });
      }

      /**
       * pause transmuxer
       * @memberof Flv
       */

    }, {
      key: 'pauseTransmuxer',
      value: function pauseTransmuxer() {
        this.transmuxer.pause();
        this.mediaSource.pause();
        if (!this.timer) {
          this.timer = setInterval(this.heartbeat.bind(this), 1000);
        }
      }
    }, {
      key: 'resume',
      value: function resume() {
        this._seek(0);
      }

      /**
       * destroy
       * @memberof Flv
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        window.clearInterval(this.timer);
        window.clearInterval(this.seekTimer);
        window.clearInterval(this.checkBufferTimer);
        if (this.realtimeBeaconTimer) {
          window.clearInterval(this.realtimeBeaconTimer);
          // Send last realtime beacon
          this._sendRealtimeBeacon();
          this.realtimeBeaconTimer = null;
        }
        this.video.removeEventListener('canplay', this._onVideoCanplay);
        this.video.removeEventListener('seeking', this.throttle);
        this.video.removeEventListener('waiting', this._onVideoWaiting);
        this.video.removeEventListener('playing', this._onVideoPlaying);
        this.video.removeEventListener('timeupdate', this._onVideoTimeupdate);
        if (this.video) {
          URL.revokeObjectURL(this.video.src);
          this.video.src = '';
          this.video.removeAttribute('src');
          if (this.transmuxer) {
            this.unbindTransmuxerEvent(this.transmuxer);
            this.transmuxer.pause();
            this.transmuxer.destroy();
            this.transmuxer = null;
          }
          if (this.mediaSource) {
            this.unbindMediaSourceEvent(this.mediaSource);
            this.mediaSource.destroy();
            this.mediaSource = null;
          }
        }
        this.logger.off('performance');
        this.logger = null;
      }
    }, {
      key: 'seek',
      value: function seek(seconds) {
        return this._seek(seconds);
      }
    }, {
      key: 'play',
      value: function play() {
        return this.video.play();
      }
    }, {
      key: 'pause',
      value: function pause() {
        return this.video.pause();
      }
    }, {
      key: 'refresh',
      value: function refresh() {
        if (this.transmuxer && this.mediaSource) {
          this._seek(0);
        } else {
          _chimeeHelper.Log.verbose(this.tag, 'transmuxer & mediaSource not ready');
        }
      }

      /**
       * stop stream load
       * @memberof Flv
       */

    }, {
      key: 'stopLoad',
      value: function stopLoad() {
        this.transmuxer && this.transmuxer.pause();
        this.mediaSource && this.mediaSource.pause();
        if (this.realtimeBeaconTimer) {
          // Send the last realtime beacon and clear timer
          window.clearInterval(this.realtimeBeaconTimer);
          this._sendRealtimeBeacon();
          this.realtimeBeaconTimer = null;
        }
      }
    }]);

    return Flv;
  }(_chimeeHelper.CustEvent);

  exports.default = Flv;

  /***/ }),
  /* 14 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _chimeeHelperEvents = __webpack_require__(0);

  var _chimeeHelperLog = __webpack_require__(4);

  var _chimeeHelperLog2 = _interopRequireDefault(_chimeeHelperLog);

  var _$const = __webpack_require__(1);

  var _playerEvents = __webpack_require__(2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var MSEController = function (_CustEvent) {
    _inherits(MSEController, _CustEvent);

    /**
     * Mediasource 控制层
     * @class Mediasource
     * @param {Element} videoElement
     * @param {object} config
     */
    function MSEController(videoElement, config) {
      _classCallCheck(this, MSEController);

      var _this = _possibleConstructorReturn(this, (MSEController.__proto__ || Object.getPrototypeOf(MSEController)).call(this));

      _this.video = videoElement;
      _this.config = config;
      _this.tag = 'mse-controller';
      _this.e = {
        onSourceOpen: _this.onSourceOpen.bind(_this),
        onSourceEnded: _this.onSourceEnded.bind(_this),
        onSourceClose: _this.onSourceClose.bind(_this),
        onSourceBufferError: _this.onSourceBufferError.bind(_this)
      };
      _this.hasVideo = true;
      _this.hasAudio = true;
      _this.removeRangesList = {
        video: [],
        audio: []
      };
      _this.removeBucketing = false;
      _this.timer = {
        video: null,
        audio: null
      };
      _this.queue = {
        video: [],
        audio: []
      };
      _this.sourceBuffer = {
        video: null,
        audio: null
      };
      _this.mimeCodec = {
        video: null,
        audio: null
      };
      _this.sourceBufferEvent();
      _this.complete = false;
      return _this;
    }

    /**
     * mediaSource init
     * @param {Object} mediaInfo
     */


    _createClass(MSEController, [{
      key: 'init',
      value: function init(mediaInfo) {
        this.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.MEDIA_INFO, ts: Date.now() });
        if (this.mediaSource) {
          _chimeeHelperLog2.default.Error(this.tag, 'MediaSource has been attached to an HTMLMediaElement!');
          this.emit('error', { errno: _$const.ERRORNO.MEDIASOURCE_ERROR, errmsg: 'MediaSource has been attached to an HTMLMediaElement!' });
          return;
        }

        if (mediaInfo.hasAudio) {
          this.mimeCodec['audio'] = 'audio/mp4; codecs="' + mediaInfo.audioCodec + '"';
        } else {
          this.hasAudio = false;
        }
        if (mediaInfo.hasVideo) {
          this.mimeCodec['video'] = 'video/mp4; codecs="' + mediaInfo.videoCodec + '"';
        } else {
          this.hasVideo = false;
        }
        var ms = this.mediaSource = new window.MediaSource();
        ms.addEventListener('sourceopen', this.e.onSourceOpen);
        ms.addEventListener('sourceended', this.e.onSourceEnded);
        ms.addEventListener('sourceclose', this.e.onSourceClose);
      }

      /**
       * mediaSource open
       */

    }, {
      key: 'onSourceOpen',
      value: function onSourceOpen() {
        _chimeeHelperLog2.default.verbose(this.tag, 'MediaSource onSourceOpen');
        this.mediaSource.removeEventListener('sourceopen', this.e.onSourceOpen);
        if (this.hasAudio) {
          this.addSourceBuffer('audio');
        }
        if (this.hasVideo) {
          this.addSourceBuffer('video');
        }
        if (this.hasQueueList()) {
          this.doUpdate();
        }
        this.emit('source_open');
      }

      /**
       * addSourceBuffer
       * @param {String} tag type
       */

    }, {
      key: 'addSourceBuffer',
      value: function addSourceBuffer(type) {
        var _this2 = this;

        this.sourceBuffer[type] = this.mediaSource.addSourceBuffer(this.mimeCodec[type]);
        _chimeeHelperLog2.default.verbose(this.tag, 'add sourcebuffer ' + type);
        var sb = this.sourceBuffer[type];
        sb.addEventListener('error', this.e.onSourceBufferError);
        sb.addEventListener('abort', function () {
          return _chimeeHelperLog2.default.verbose(_this2.tag, 'sourceBuffer: abort');
        });
        sb.addEventListener('updateend', function () {
          if (!_this2.sourceBuffer) {
            return;
          }
          if (_this2.hasRemoveList()) {
            if (_this2.removeRangesList.video.length) {
              _this2.cleanRangesList('video');
            }
            if (_this2.removeRangesList.audio.length) {
              _this2.cleanRangesList('audio');
            }
          } else if (_this2.hasQueueList()) {
            _this2.doUpdate();
          } else if (_this2.complete && !_this2.sourceBuffer[type].updating) {
            _this2.endOfStream();
          }
          _this2.emit('updateend');
        });
      }
    }, {
      key: 'hasRemoveList',
      value: function hasRemoveList() {
        return this.removeRangesList.video.length || this.removeRangesList.audio.length;
      }
    }, {
      key: 'hasQueueList',
      value: function hasQueueList() {
        return this.queue.video.length || this.queue.audio.length;
      }

      /**
      * addSourceBuffer
      */

    }, {
      key: 'doUpdate',
      value: function doUpdate() {
        for (var type in this.queue) {
          if (this.queue[type].length > 0 && !this.sourceBuffer[type].updating) {
            var data = this.queue[type].shift();
            this.appendBuffer(data, type);
          }
        }
      }

      /**
       * sourceBuffer event
       */

    }, {
      key: 'sourceBufferEvent',
      value: function sourceBufferEvent() {
        var _this3 = this;

        this.on('mediaSegment', function (handler) {
          var data = handler.data;
          var type = data.type;
          _this3.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.MEDIA_SEGMENT, byteLength: data.data.byteLength, ts: Date.now() });
          if (_this3.needCleanupSourceBuffer(type)) {
            _this3.doCleanupSourceBuffer(type);
          }
          // if(!this.sourceBuffer[type] || (this.sourceBuffer[type].updating || this.queue[type].length > 0)) {
          //   this.queue[type].push(data.data);
          // } else {
          //   this.appendBuffer(data.data, type);
          // }
          _this3.queue[type].push(data.data);
          if (_this3.sourceBuffer[type] && !_this3.hasRemoveList()) {
            _this3.doUpdate();
          }
        });

        this.on('mediaSegmentInit', function (handler) {
          _this3.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.MEDIA_SEGMENT_INIT, ts: Date.now() });
          var data = handler.data;
          var type = data.type;
          // if (!this.sourceBuffer[type] || (this.sourceBuffer[type].updating || this.queue[type].length > 0)) {
          //   this.queue[type].push(data.data);
          // } else {
          //  this.appendBuffer(data.data, type);
          // }
          _this3.queue[type].push(data.data);
        });
      }

      /**
       * need clean sourcebuffer
       * @param {String} tag type
       */

    }, {
      key: 'needCleanupSourceBuffer',
      value: function needCleanupSourceBuffer(type) {
        var currentTime = this.video.currentTime;

        // const sb = this.sourceBuffer[type];
        // const buffered = sb.buffered;
        var buffered = this.video.buffered;
        if (buffered.length >= 1) {
          if (currentTime - buffered.start(0) >= this.config.autoCleanupMaxBackwardDuration) {
            return true;
          }
        }
        return false;
      }

      /**
       * clean buffer
       * @param {String} tag type
       */

    }, {
      key: 'doCleanupSourceBuffer',
      value: function doCleanupSourceBuffer(type) {
        var currentTime = this.video.currentTime;
        var sb = this.sourceBuffer[type];
        var buffered = sb.buffered;
        var doRemove = false;
        for (var i = 0; i < buffered.length; i++) {
          var start = buffered.start(i);
          var end = buffered.end(i);
          if (start <= currentTime && currentTime < end + 3) {
            if (currentTime - start >= this.config.autoCleanupMaxBackwardDuration) {
              doRemove = true;
              var removeEnd = currentTime - this.config.autoCleanupMinBackwardDuration;
              this.removeRangesList[type].push({ start: start, end: removeEnd });
            }
          }
        }
        if (doRemove && !this.sourceBuffer[type].updating) {
          this.cleanRangesList(type);
        }
      }

      /**
       * clean bufferlist
       * @param {String} tag type
       */

    }, {
      key: 'cleanRangesList',
      value: function cleanRangesList(type) {
        if (this.sourceBuffer[type].updating) {
          return;
        }
        var sb = this.sourceBuffer[type];
        while (this.removeRangesList[type].length && !sb.updating) {
          var ranges = this.removeRangesList[type].shift();
          sb.remove(ranges.start, ranges.end);
        }
      }

      /**
       * appendBuffer
       * @param {Object} data
       * @param {String} tag type
       */

    }, {
      key: 'appendBuffer',
      value: function appendBuffer(data, type) {
        if (!this.sourceBuffer[type]) {
          return;
        }
        try {
          this.sourceBuffer[type].appendBuffer(data.buffer);
        } catch (e) {
          var removeEnd = this.video.currentTime - 3;
          console.log('removeEnd', removeEnd);
          if (removeEnd > 0) {
            for (var t in this.sourceBuffer) {
              this.sourceBuffer[t].remove(0, removeEnd);
            }
          }
          this.queue[type].unshift(data);
          // 清理缓存
          setTimeout(this.doUpdate.bind(this), 100);
          console.error(e);
          // if(e.code === 22) {
          //   // chrome can cache about 350M
          //   Log.verbose(this.tag, 'MediaSource bufferFull');
          //   this.emit('bufferFull');
          // } else {
          //   // this.emit('error', {errno: ERRORNO.APPENDBUFFER_ERROR, errmsg: e});
          // }
        }
      }

      /**
       * sourcebuffer end
       */

    }, {
      key: 'onSourceEnded',
      value: function onSourceEnded() {
        _chimeeHelperLog2.default.verbose(this.tag, 'MediaSource onSourceEnded');
      }

      /**
       * sourcebuffer close
       */

    }, {
      key: 'onSourceClose',
      value: function onSourceClose() {
        _chimeeHelperLog2.default.verbose(this.tag, 'MediaSource onSourceClose');
        if (this.mediaSource && this.e !== null) {
          this.mediaSource.removeEventListener('sourceopen', this.e.onSourceOpen);
          this.mediaSource.removeEventListener('sourceended', this.e.onSourceEnded);
          this.mediaSource.removeEventListener('sourceclose', this.e.onSourceClose);
        }
      }

      /**
      * sourcebuffer error
      * @param {Object} evnet
      */

    }, {
      key: 'onSourceBufferError',
      value: function onSourceBufferError(e) {
        this.emit('error', { errnono: _$const.ERRORNO.SOURCEBUFFER_ERROR, errmsg: e.message });
        _chimeeHelperLog2.default.error(this.tag, 'SourceBuffer Error: ' + e);
      }

      /**
       * seek
       */

    }, {
      key: 'seek',
      value: function seek() {
        for (var type in this.sourceBuffer) {
          var sb = this.sourceBuffer[type];
          if (!sb) {
            continue;
          }
          if (this.mediaSource.readyState === 'open') {
            try {
              sb.abort();
            } catch (e) {
              this.emit('error', { errno: _$const.ERRORNO.SBABORT_ERROR, errmsg: e });
              _chimeeHelperLog2.default.error(this.tag, e.message);
            }
          }
          this.queue[type] = [];
          for (var i = 0; i < sb.buffered.length; i++) {
            var start = sb.buffered.start(i);
            var end = sb.buffered.end(i);
            this.removeRangesList[type].push({ start: start, end: end });
          }
          if (!sb.updating) {
            this.cleanRangesList(type);
          }
        }
      }

      /**
       * resume
       */

    }, {
      key: 'resume',
      value: function resume() {
        this.doUpdate();
      }

      /**
       * pause
       */

    }, {
      key: 'pause',
      value: function pause() {
        // this.endOfStream();
      }
    }, {
      key: 'endOfStream',
      value: function endOfStream() {
        if (this.mediaSource) {
          var ms = this.mediaSource;
          this.complete = true;
          var sb = this.sourceBuffer;
          if (sb.video && sb.video.updating || sb.audio && sb.audio.updating) {
            return;
          } else {
            if (ms.readyState === 'open') {
              try {
                ms.endOfStream();
                this.complete = false;
              } catch (error) {
                _chimeeHelperLog2.default.verbose(this.tag, error);
                this.emit('error', { errno: _$const.ERRORNO.ENDOFSTREAM_ERROR, errmsg: error });
              }
            }
          }
        }
      }

      /**
       * destroy
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        if (this.mediaSource) {
          var ms = this.mediaSource;
          // pending segments should be discard
          this.queue = {
            video: [],
            audio: []
          };
          this.sourceBuffer = {
            video: null,
            audio: null
          };
          this.mimeCodec = {
            video: null,
            audio: null
          };
          // remove all sourcebuffers
          var sb = this.sourceBuffer;
          this.complete = false;
          this.endOfStream();
          if (sb) {
            if (ms.readyState !== 'closed') {
              ms.removeSourceBuffer(sb);
              sb.removeEventListener('error', this.e.onSourceBufferError);
              sb.removeEventListener('updateend', this.e.onSourceBufferUpdateEnd);
            }
            this.sourceBuffer = null;
          }
          ms.removeEventListener('sourceopen', this.e.onSourceOpen);
          ms.removeEventListener('sourceended', this.e.onSourceEnded);
          ms.removeEventListener('sourceclose', this.e.onSourceClose);
          this.mediaSource = null;
        }
        this.off('mediaSegmentInit');
        this.off('mediaSegment');
      }
    }]);

    return MSEController;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = MSEController;

  /***/ }),
  /* 15 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _ioLoader = __webpack_require__(5);

  var _ioLoader2 = _interopRequireDefault(_ioLoader);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _webworkifyWebpack = __webpack_require__(21);

  var _webworkifyWebpack2 = _interopRequireDefault(_webworkifyWebpack);

  var _flv2fmp = __webpack_require__(7);

  var _flv2fmp2 = _interopRequireDefault(_flv2fmp);

  var _$const = __webpack_require__(1);

  var _playerEvents = __webpack_require__(2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /**
   * Transmuxer controller
   * @class Transmuxer
   * @param {mediaSource} mediaSource
   * @param {object} config
   */
  var Transmuxer = function (_CustEvent) {
    _inherits(Transmuxer, _CustEvent);

    function Transmuxer(mediaSource, config, globalEvent) {
      _classCallCheck(this, Transmuxer);

      var _this = _possibleConstructorReturn(this, (Transmuxer.__proto__ || Object.getPrototypeOf(Transmuxer)).call(this));

      _this.config = config || {};
      _this.tag = 'transmuxer';
      _this.loader = null;
      _this.CPU = null;
      _this.keyframePoint = false;
      _this.w = null;
      if (_this.config.webWorker) {
        _this.onWorkMessage = _this.onWorkMessage.bind(_this);
        _this.w = (0, _webworkifyWebpack2.default)(/*require.resolve*/(32));
        _this.w.addEventListener('message', _this.onWorkMessage);
        _this.w.postMessage(JSON.parse(JSON.stringify({ cmd: 'init', data: config })));
      }
      _this.lock = 0;
      return _this;
    }

    _createClass(Transmuxer, [{
      key: 'onWorkMessage',
      value: function onWorkMessage(e) {
        this.parseCallback.call(this, e.data);
      }
      /**
      * instance ioloader
      */

    }, {
      key: 'loadSource',
      value: function loadSource() {
        if (this.config.webWorker) {
          this.w.postMessage({ cmd: 'loadSource' });
        } else {
          this.loader = new _ioLoader2.default(this.config);
          this.loader.arrivalDataCallback = this.arrivalDataCallback.bind(this);
          this.loaderBindEvent(this.loader);
          this.loader.open();
        }
      }
      /**
       * bindEvent
       */

    }, {
      key: 'loaderBindEvent',
      value: function loaderBindEvent(loader) {
        var _this2 = this;

        loader.on('end', function () {
          _this2.emit('end');
        });
        loader.on('error', function (handle) {
          _this2.emit('error', handle.data);
        });
        loader.on('heartbeat', function (handle) {
          _this2.emit('heartbeat', handle.data);
        });
        this.loader.on('player-event', function (handler) {
          _this2.emit('player-event', handler.data);
        });
      }
      /**
       * 解除事件绑定
       */

    }, {
      key: 'loaderUnbindEvent',
      value: function loaderUnbindEvent(loader) {
        loader.off('end');
        loader.off('error');
        loader.off('heartbeat');
        loader.off('player-event');
      }
      /**
      * loader data callback
      * @param {arraybuffer} data
      * @param {number} bytestart
      * @param {keyframePoint} keyframe
      */

    }, {
      key: 'arrivalDataCallback',
      value: function arrivalDataCallback(data, byteStart, keyframePoint) {
        var _this3 = this;

        if (!this.CPU) {
          this.CPU = new _flv2fmp2.default(this.config);
          this.CPU.onInitSegment = this.onRemuxerInitSegmentArrival.bind(this);
          this.CPU.onMediaSegment = this.onRemuxerMediaSegmentArrival.bind(this);
          this.CPU.onMediaInfo = this.onMediaInfo.bind(this);
          this.CPU.onCdnDropFrame = this.onCdnDropFrame.bind(this);
          this.CPU.on('error', function (handle) {
            _this3.emit('error', { errno: _$const.ERRORNO.CODEC_ERROR, errmsg: handle.data });
          });
        }
        if (keyframePoint !== undefined) {
          this.CPU.seek(keyframePoint);
        }
        this.emit('player-event', { type: _playerEvents.PLAYER_EVENTS.MEDIA_DEMUX_FLV, byteLength: data.byteLength, ts: Date.now() });
        var consumed = this.CPU.setflv(data);
        return consumed;
      }

      /**
       * loader data callback
       * @param {arraybuffer} data
       */

    }, {
      key: 'parseCallback',
      value: function parseCallback(data) {
        switch (data.cmd) {
          case 'mediaSegmentInit':
            this.emit('mediaSegmentInit', data.source);
            break;
          case 'mediaSegment':
            this.emit('mediaSegment', data.source);
            break;
          case 'mediainfo':
            this.mediaInfo = data.source;
            this.emit('mediaInfo', data.source);
            break;
          case 'end':
            this.emit('end');
            break;
          case 'error':
            this.emit('error', data.source);
            break;
          case 'player-event':
            this.emit('player-event', data.source);
            break;
          case 'heartbeat':
            this.emit('heartbeat', data.source);
            break;
          case 'cdnDropFrame':
            this.emit('cdnDropFrame', { dropAudio: data.source });
            break;
        }
      }

      /**
       * Demux mediaInfo
       *  @param {object} video message info
       */

    }, {
      key: 'onMediaInfo',
      value: function onMediaInfo(mediaInfo) {
        this.mediaInfo = mediaInfo;
        this.emit('mediaInfo', mediaInfo);
      }
      /**
       * cdn丢帧回调
       */

    }, {
      key: 'onCdnDropFrame',
      value: function onCdnDropFrame(len) {
        this.emit('cdnDropFrame', { dropAudio: len });
      }

      /**
       * remuxer init segment arrival
       * @param {arraybuffer} video data
       */

    }, {
      key: 'onRemuxerInitSegmentArrival',
      value: function onRemuxerInitSegmentArrival(video, audio) {
        this.emit('mediaSegmentInit', {
          type: 'video',
          data: video
        });
        if (audio) {
          this.emit('mediaSegmentInit', {
            type: 'audio',
            data: audio
          });
        }
      }

      /**
       * remuxer  segment arrival
       * @param {String} tag type
       * @param {arraybuffer} video data
       */

    }, {
      key: 'onRemuxerMediaSegmentArrival',
      value: function onRemuxerMediaSegmentArrival(type, data) {
        this.emit('mediaSegment', { type: type, data: data });
      }

      /**
       * get video mediaInfo
       */

    }, {
      key: 'getMediaInfo',
      value: function getMediaInfo() {
        return this.mediaInfo;
      }

      /**
      * stop loader
      */

    }, {
      key: 'pause',
      value: function pause() {
        if (this.config.webWorker) {
          this.w.postMessage({ cmd: 'pause' });
        } else {
          this.loader.pause();
        }
      }

      /**
       * resume loader
       */

    }, {
      key: 'resume',
      value: function resume() {
        if (this.config.webWorker) {
          this.w.postMessage({ cmd: 'resume' });
        } else {
          this.loader.resume();
        }
      }
      /**
      * flv can seek
      */

    }, {
      key: 'isSeekable',
      value: function isSeekable() {
        return this.mediaInfo.hasKeyframesIndex;
      }
      /**
       * video seek
       * @param {object} 关键帧集合
       */

    }, {
      key: 'seek',
      value: function seek(keyframe) {
        if (!this.isSeekable()) {
          this.emit('error', { errno: _$const.ERRORNO.CANNOT_SEEK, errmsg: '这个flv视频不支持seek' });
          return false;
        }
        if (this.config.webWorker) {
          this.w.postMessage({ cmd: 'seek', keyframe: keyframe });
        } else {
          this.loader.seek(keyframe.keyframePoint, false, keyframe.keyframetime);
        }
      }

      /**
       * destroy
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        if (this.config.webWorker) {
          this.w.postMessage({ cmd: 'destroy' });
          this.w.removeEventListener('message', this.onWorkMessage);
          this.w.terminate();
        } else {
          if (this.loader) {
            this.loaderUnbindEvent(this.loader);
            this.loader.destroy();
            this.loader = null;
          }
          if (this.CPU) {
            this.CPU.off('error');
            this.CPU = null;
          }
        }
      }

      /**
       * get nearlest keyframe binary search
       * @param {Number} video time
       */

    }, {
      key: 'getNearestKeyframe',
      value: function getNearestKeyframe(times) {
        if (this.mediaInfo && this.mediaInfo.keyframesIndex) {
          var keyframesList = this.mediaInfo.keyframesIndex.times;
          var keyframesPositions = this.mediaInfo.keyframesIndex.filepositions;
          var binarySearch = function binarySearch(list, val) {
            var length = list.length;
            var index = Math.floor(length / 2);
            if (length === 1) {
              var position = keyframesList.indexOf(list[0]);
              return {
                keyframetime: list[0],
                keyframePoint: keyframesPositions[position]
              };
            } else if (list[index] > val) {
              return binarySearch(list.slice(0, index), val);
            } else if (list[index] < val) {
              return binarySearch(list.slice(index), val);
            } else {
              var _position = keyframesList.indexOf(list[0]);
              return {
                keyframetime: list[0],
                keyframePoint: keyframesPositions[_position]
              };
            }
          };
          return binarySearch(keyframesList, times);
        } else {
          return 0;
        }
      }
    }]);

    return Transmuxer;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = Transmuxer;

  /***/ }),
  /* 16 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
  	value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _handleQuery = __webpack_require__(17);

  var _handleQuery2 = _interopRequireDefault(_handleQuery);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _chimeeHelperLog = __webpack_require__(4);

  var _chimeeHelperLog2 = _interopRequireDefault(_chimeeHelperLog);

  var _$const = __webpack_require__(1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * fetch firfox 直播 点播
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * author songguangyu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * email 522963130@qq.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */


  /**
   * FetchLoader
   * @class FetchLoader
   * @param {string} video url
   * @param  {object} range.from range.to
   */
  var FetchLoader = function (_CustEvent) {
  	_inherits(FetchLoader, _CustEvent);

  	_createClass(FetchLoader, null, [{
  		key: 'isSupport',


  		/**
      * broswer is support moz-chunk
      */
  		value: function isSupport() {
  			if (self.fetch && self.ReadableStream) {
  				return true;
  			} else {
  				return false;
  			}
  		}
  	}]);

  	function FetchLoader(src, config) {
  		_classCallCheck(this, FetchLoader);

  		var _this = _possibleConstructorReturn(this, (FetchLoader.__proto__ || Object.getPrototypeOf(FetchLoader)).call(this));

  		_this.tag = 'fetch';
  		_this.fetching = false;
  		_this.config = config;
  		_this.range = {
  			from: 0,
  			to: 524288
  		};
  		_this.src = src;
  		_this.totalRange = null;
  		_this.block = 524288;
  		_this.reader = null;
  		_this.requestAbort = false;
  		_this.arrivalDataCallback = null;
  		_this.bytesStart = 0;
  		_this.heartbeat = null;
  		return _this;
  	}
  	/**
     * if don't need range don't set
     * @param  {object} range.from range.to
     */


  	_createClass(FetchLoader, [{
  		key: 'open',
  		value: function open(range, keyframePoint) {
  			var _this2 = this;

  			this.requestAbort = false;
  			var reqHeaders = new Headers();
  			var r = range || { from: 0, to: -1 };
  			if (!this.config.isLive) {
  				this.range.from = r.from;
  				this.range.to = r.to;
  				var queryResult = (0, _handleQuery2.default)(r, this.config);
  				if (typeof queryResult === 'string') {
  					this.src = this.config.src + queryResult;
  				} else {
  					for (var i in queryResult) {
  						reqHeaders.append(i, queryResult[i]);
  					}
  				}
  			}
  			if (keyframePoint) {
  				this.bytesStart = 0;
  			}
  			this.bytesStart = range.from;
  			var params = {
  				method: 'GET',
  				headers: reqHeaders,
  				mode: 'cors',
  				cache: 'default',
  				referrerPolicy: 'no-referrer-when-downgrade'
  			};

  			// kwai http建联时间统计
  			var receiveStart = Date.now();
  			fetch(this.src, params).then(function (res) {
  				_this2.emit('performance', {
  					type: 'receive-first-package-duration',
  					value: Date.now() - receiveStart
  				});
  				if (res.ok) {
  					var reader = res.body.getReader();
  					return _this2.pump(reader, keyframePoint);
  				}
  			}).catch(function (e) {
  				_this2.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: e.toString() });
  			});
  		}

  		/**
      * pause video
      */

  	}, {
  		key: 'pause',
  		value: function pause() {
  			this.requestAbort = true;
  		}

  		/**
      * pump data
      */

  	}, {
  		key: 'pump',
  		value: function pump(reader, keyframePoint) {
  			var _this3 = this;

  			// ReadableStreamReader
  			return reader.read().then(function (result) {
  				if (result.done) {
  					_this3.emit('end');
  					_chimeeHelperLog2.default.verbose(_this3.tag, 'load end');
  				} else {
  					if (_this3.requestAbort === true) {
  						_this3.requestAbort = false;
  						return reader.cancel();
  					}
  					var chunk = result.value.buffer;
  					if (_this3.arrivalDataCallback) {
  						_this3.arrivalDataCallback(chunk, _this3.bytesStart, keyframePoint);
  						_this3.bytesStart += chunk.byteLength;
  					}
  					setTimeout(function () {
  						_this3.pump(reader);
  					}, 0);
  				}
  			}).catch(function (e) {
  				_this3.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: e.message });
  			});
  		}
  	}]);

  	return FetchLoader;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = FetchLoader;

  /***/ }),
  /* 17 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  exports.default = function (range, config) {
      if (config.seekType === 'range') {
          var headers = {};
          var param = void 0;
          if (range.to !== -1) {
              param = 'bytes=' + range.from.toString() + '-' + range.to.toString();
          } else {
              param = 'bytes=' + range.from.toString() + '-';
          }
          headers['Range'] = param;
          return headers;
      } else {
          var _param = void 0;
          if (range.to !== -1) {
              _param = '?start=' + range.from.toString() + '&end=' + range.to.toString();
          } else {
              _param = '?start=' + range.from.toString();
          }
          return _param;
      }
  };

  /***/ }),
  /* 18 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _handleRange = __webpack_require__(6);

  var _handleRange2 = _interopRequireDefault(_handleRange);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _$const = __webpack_require__(1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * XHR 点播
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * author songguangyu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * email 522963130@qq.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */
  // import Log from 'helper/log';


  /**
   * MozChunkLoader
   * @class MozChunkLoader
   * @param {string} video url
   * @param  {object} range.from range.to
   */
  var RangeLoader = function (_CustEvent) {
    _inherits(RangeLoader, _CustEvent);

    _createClass(RangeLoader, null, [{
      key: 'isSupport',


      /**
      * broswer is support XMLHttpRequest
      */
      value: function isSupport() {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', 'https://example.com', true);
          xhr.responseType = 'arraybuffer';
          return xhr.responseType === 'arraybuffer';
        } catch (e) {
          return false;
        }
      }
    }]);

    function RangeLoader(src, config) {
      _classCallCheck(this, RangeLoader);

      var _this = _possibleConstructorReturn(this, (RangeLoader.__proto__ || Object.getPrototypeOf(RangeLoader)).call(this));

      _this.tag = 'RangeLoader';
      _this.xhr = null;
      _this.src = src;
      _this.totalLength = null;
      _this.chunkSizeKB = 524288;
      _this.range = {};
      _this.bytesStart = 0;
      _this.needSeek = false;
      _this.keyframePoint = null;
      return _this;
    }
    /**
     * if don't need range don't set
     * @param  {object} range.from range.to
     */


    _createClass(RangeLoader, [{
      key: 'open',
      value: function open(range, keyframePoint) {
        var xhr = this.xhr = new XMLHttpRequest();
        xhr.open('GET', this.src, true);
        xhr.responseType = 'arraybuffer';
        xhr.onreadystatechange = this.onReadyStateChange.bind(this);
        xhr.onprogress = this.onProgress.bind(this);
        xhr.onload = this.onLoad.bind(this);
        xhr.onerror = this.onXhrError.bind(this);
        var r = range || { from: 0, to: -1 };
        this.range.from = r.from;
        if (r.to === -1) {
          r.to = r.from + this.chunkSizeKB;
        }
        if (keyframePoint) {
          this.bytesStart = range.from;
          this.needSeek = true;
          this.keyframePoint = keyframePoint;
        }
        this.range.to = r.to;
        var headers = (0, _handleRange2.default)(r).headers;
        for (var i in headers) {
          xhr.setRequestHeader(i, headers[i]);
        }
        xhr.send();
      }

      /**
       * pause
       */

    }, {
      key: 'pause',
      value: function pause() {
        this.abort();
      }
      /**
       * abort request
       */

    }, {
      key: 'abort',
      value: function abort() {
        if (this.xhr) {
          this.xhr.onreadystatechange = null;
          this.xhr.onprogress = null;
          this.xhr.onload = null;
          this.xhr.onerror = null;
          this.xhr.abort();
          this.xhr = null;
        }
      }

      /**
       * destroy xhr Object clean cache
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        if (this.xhr) {
          this.abort();
          this.xhr.onreadystatechange = null;
          this.xhr.onprogress = null;
          this.xhr.onload = null;
          this.xhr.onerror = null;
          this.xhr = null;
        }
        this.totalLength = null;
        this.bytesStart = null;
        this.range = {};
      }

      /**
       * xhr onReadyStateChange
       */

    }, {
      key: 'onReadyStateChange',
      value: function onReadyStateChange(e) {
        var xhr = this.xhr;
        if (xhr.readyState === 2) {
          if (xhr.status < 200 || xhr.status > 299) {
            var info = {
              from: this.range.from,
              to: this.range.to,
              url: this.src,
              msg: 'http Error: http code ' + xhr.status
            };
            this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
          }
        }
      }

      /**
       * xhr onProgress
       */

    }, {
      key: 'onProgress',
      value: function onProgress(e) {
        if (!this.totalLength) {
          this.totalLength = e.total;
          this.abort();
          this.open();
        }
      }

      /**
       * xhr onLoad
       */

    }, {
      key: 'onLoad',
      value: function onLoad(e) {
        if (!this.totalLength) {
          return;
        }

        if (this.arrivalDataCallback) {
          var chunk = e.target.response;
          if (this.needSeek) {
            this.needSeek = false;
            this.arrivalDataCallback(chunk, this.bytesStart, this.keyframePoint);
          } else {
            this.arrivalDataCallback(chunk, this.bytesStart);
          }
          this.bytesStart += chunk.byteLength;
          this.open({ from: this.bytesStart, to: -1 });
        }
      }

      /**
       * xhr onXhrError
       */

    }, {
      key: 'onXhrError',
      value: function onXhrError(e) {
        var info = {
          from: this.range.from,
          to: this.range.to,
          url: this.src,
          msg: e.constructor.name + ' ' + e.type
        };
        this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
      }
    }]);

    return RangeLoader;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = RangeLoader;

  /***/ }),
  /* 19 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
  	value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _chimeeHelperEvents = __webpack_require__(0);

  var _$const = __webpack_require__(1);

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var WebSocketLoader = function (_CustEvent) {
  	_inherits(WebSocketLoader, _CustEvent);

  	_createClass(WebSocketLoader, null, [{
  		key: 'isSupported',
  		value: function isSupported() {
  			try {
  				return typeof window.WebSocket !== 'undefined';
  			} catch (e) {
  				return false;
  			}
  		}
  	}]);

  	function WebSocketLoader(src, config) {
  		_classCallCheck(this, WebSocketLoader);

  		var _this = _possibleConstructorReturn(this, (WebSocketLoader.__proto__ || Object.getPrototypeOf(WebSocketLoader)).call(this));

  		_this.tag = 'WebSocket';
  		_this.src = src;
  		_this._ws = null;
  		_this._requestAbort = false;
  		_this._receivedLength = 0;
  		return _this;
  	}

  	_createClass(WebSocketLoader, [{
  		key: 'open',
  		value: function open(range, keyframePoint) {
  			try {
  				var ws = this._ws = new self.WebSocket(this.src);
  				ws.binaryType = 'arraybuffer';
  				ws.onopen = this.onWebSocketOpen.bind(this);
  				ws.onclose = this.onWebSocketClose.bind(this);
  				ws.onmessage = this.onWebSocketMessage.bind(this);
  				ws.onerror = this.onWebSocketError.bind(this);
  			} catch (e) {
  				var info = {
  					code: e.code,
  					msg: e.message
  				};
  				this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
  			}
  		}
  	}, {
  		key: 'pause',
  		value: function pause() {
  			var ws = this._ws;
  			if (ws && (ws.readyState === 0 || ws.readyState === 1)) {
  				this._requestAbort = true;
  				ws.close();
  			}
  			this._ws = null;
  		}
  	}, {
  		key: 'onWebSocketClose',
  		value: function onWebSocketClose(e) {
  			if (this._requestAbort === true) {
  				this._requestAbort = false;
  				return;
  			}
  			this.emit('end');
  		}
  	}, {
  		key: 'onWebSocketOpen',
  		value: function onWebSocketOpen() {}
  	}, {
  		key: 'onWebSocketMessage',
  		value: function onWebSocketMessage(e) {
  			var _this2 = this;

  			if (e.data instanceof ArrayBuffer) {
  				this.dispatchArrayBuffer(e.data);
  			} else if (e.data instanceof Blob) {
  				var reader = new FileReader();
  				reader.onload = function () {
  					_this2.dispatchArrayBuffer(reader.result);
  				};
  				reader.readAsArrayBuffer(e.data);
  			} else {
  				var info = { code: -1, msg: 'Unsupported WebSocket message type: ' + e.data.constructor.name };
  				this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
  			}
  		}
  	}, {
  		key: 'dispatchArrayBuffer',
  		value: function dispatchArrayBuffer(arraybuffer) {
  			var chunk = arraybuffer;
  			var byteStart = this.receivedLength;
  			this.receivedLength += chunk.byteLength;

  			if (this.arrivalDataCallback) {
  				this.arrivalDataCallback(chunk, byteStart);
  			}
  		}
  	}, {
  		key: 'onWebSocketError',
  		value: function onWebSocketError(e) {
  			var info = {
  				code: e.code,
  				msg: e.message
  			};
  			this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
  		}
  	}]);

  	return WebSocketLoader;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = WebSocketLoader;

  /***/ }),
  /* 20 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _handleRange = __webpack_require__(6);

  var _handleRange2 = _interopRequireDefault(_handleRange);

  var _chimeeHelperEvents = __webpack_require__(0);

  var _$const = __webpack_require__(1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * XHR firfox 直播 点播
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * author songguangyu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * email 522963130@qq.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */
  // import Log from 'helper/log';


  /**
   * MozChunkLoader
   * @class MozChunkLoader
   * @param {string} video url
   * @param  {object} range.from range.to
   */
  var MozChunkLoader = function (_CustEvent) {
    _inherits(MozChunkLoader, _CustEvent);

    _createClass(MozChunkLoader, null, [{
      key: 'isSupport',


      /**
       * broswer is support moz-chunk
       */
      value: function isSupport() {
        try {
          var xhr = new XMLHttpRequest();
          // Firefox 37- requires .open() to be called before setting responseType
          xhr.open('GET', 'https://example.com', true);
          xhr.responseType = 'moz-chunked-arraybuffer';
          return xhr.responseType === 'moz-chunked-arraybuffer';
        } catch (e) {
          return false;
        }
      }
    }]);

    function MozChunkLoader(src, config) {
      _classCallCheck(this, MozChunkLoader);

      var _this = _possibleConstructorReturn(this, (MozChunkLoader.__proto__ || Object.getPrototypeOf(MozChunkLoader)).call(this));

      _this.tag = 'mozChunkLoader';
      _this.xhr = null;
      _this.src = src;
      _this.config = config;
      _this.totalLength = null;
      _this.chunkSizeKB = 393216;
      _this.range = {};
      _this.bytesStart = 0;
      _this.keyframePoint = null;
      return _this;
    }
    /**
     * if don't need range don't set
     * @param  {object} range.from range.to
     */


    _createClass(MozChunkLoader, [{
      key: 'open',
      value: function open(range, keyframePoint) {
        var xhr = this.xhr = new XMLHttpRequest();
        xhr.open('GET', this.src, true);
        xhr.responseType = 'moz-chunked-arraybuffer';
        xhr.onreadystatechange = this.onReadyStateChange.bind(this);
        xhr.onprogress = this.onProgress.bind(this);
        xhr.onload = this.onLoadEnd.bind(this);
        xhr.onerror = this.onXhrError.bind(this);
        if (!this.config.isLive) {
          var r = range || { from: 0, to: -1 };
          this.range.from = r.from;
          this.range.to = r.to;
          if (keyframePoint) {
            this.needSeek = true;
            this.keyframePoint = keyframePoint;
          }
          var headers = (0, _handleRange2.default)(r).headers;
          for (var i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }
        }
        xhr.send();
      }

      /**
       * pause
       */

    }, {
      key: 'pause',
      value: function pause() {
        this.abort();
      }
      /**
       * abort request
       */

    }, {
      key: 'abort',
      value: function abort() {
        if (this.xhr) {
          this.xhr.onreadystatechange = null;
          this.xhr.onprogress = null;
          this.xhr.onload = null;
          this.xhr.onerror = null;
          this.xhr.abort();
          this.xhr = null;
        }
      }

      /**
       * destroy xhr Object clean cache
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        if (this.xhr) {
          this.abort();
          this.xhr.onreadystatechange = null;
          this.xhr.onprogress = null;
          this.xhr.onload = null;
          this.xhr.onerror = null;
          this.xhr = null;
        }
        this.totalLength = null;
        this.bytesStart = null;
        this.range = {};
      }

      /**
       * xhr onReadyStateChange
       */

    }, {
      key: 'onReadyStateChange',
      value: function onReadyStateChange(e) {
        var xhr = this.xhr;
        if (xhr.readyState === 2) {
          if (xhr.status < 200 || xhr.status > 299) {
            var info = {
              from: this.range.from,
              to: this.range.to,
              url: this.src,
              msg: 'http Error: http code ' + xhr.status
            };
            this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
          }
        }
      }

      /**
       * xhr onProgress
       */

    }, {
      key: 'onProgress',
      value: function onProgress(e) {
        if (!this.totalLength) {
          this.totalLength = e.total;
          if (e.total !== null && e.total !== 0) {
            this.totalLength = e.total;
          }
        }

        var chunk = e.target.response;
        if (this.needSeek) {
          this.needSeek = false;
          this.arrivalDataCallback(chunk, this.bytesStart, this.keyframePoint);
        } else {
          this.arrivalDataCallback(chunk, this.bytesStart);
        }
        this.bytesStart += chunk.byteLength;
      }

      /**
       * xhr onLoadEnd
       */

    }, {
      key: 'onLoadEnd',
      value: function onLoadEnd(e) {
        this.emit(this.tag, 'video load end');
      }

      /**
       * xhr onXhrError
       */

    }, {
      key: 'onXhrError',
      value: function onXhrError(e) {
        var info = {
          from: this.range.from,
          to: this.range.to,
          url: this.src,
          msg: e.constructor.name + ' ' + e.type
        };
        this.emit('error', { errno: _$const.ERRORNO.NET_ERROR, errmsg: info });
      }
    }]);

    return MozChunkLoader;
  }(_chimeeHelperEvents.CustEvent);

  exports.default = MozChunkLoader;

  /***/ }),
  /* 21 */
  /***/ (function(module, exports, __webpack_require__) {

  function webpackBootstrapFunc (modules) {
  /******/  // The module cache
  /******/  var installedModules = {};

  /******/  // The require function
  /******/  function __webpack_require__(moduleId) {

  /******/    // Check if module is in cache
  /******/    if(installedModules[moduleId])
  /******/      return installedModules[moduleId].exports;

  /******/    // Create a new module (and put it into the cache)
  /******/    var module = installedModules[moduleId] = {
  /******/      i: moduleId,
  /******/      l: false,
  /******/      exports: {}
  /******/    };

  /******/    // Execute the module function
  /******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

  /******/    // Flag the module as loaded
  /******/    module.l = true;

  /******/    // Return the exports of the module
  /******/    return module.exports;
  /******/  }

  /******/  // expose the modules object (__webpack_modules__)
  /******/  __webpack_require__.m = modules;

  /******/  // expose the module cache
  /******/  __webpack_require__.c = installedModules;

  /******/  // identity function for calling harmony imports with the correct context
  /******/  __webpack_require__.i = function(value) { return value; };

  /******/  // define getter function for harmony exports
  /******/  __webpack_require__.d = function(exports, name, getter) {
  /******/    if(!__webpack_require__.o(exports, name)) {
  /******/      Object.defineProperty(exports, name, {
  /******/        configurable: false,
  /******/        enumerable: true,
  /******/        get: getter
  /******/      });
  /******/    }
  /******/  };

  /******/  // define __esModule on exports
  /******/  __webpack_require__.r = function(exports) {
  /******/    Object.defineProperty(exports, '__esModule', { value: true });
  /******/  };

  /******/  // getDefaultExport function for compatibility with non-harmony modules
  /******/  __webpack_require__.n = function(module) {
  /******/    var getter = module && module.__esModule ?
  /******/      function getDefault() { return module['default']; } :
  /******/      function getModuleExports() { return module; };
  /******/    __webpack_require__.d(getter, 'a', getter);
  /******/    return getter;
  /******/  };

  /******/  // Object.prototype.hasOwnProperty.call
  /******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

  /******/  // __webpack_public_path__
  /******/  __webpack_require__.p = "/";

  /******/  // on error function for async loading
  /******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };

    var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
    return f.default || f // try to call default if defined to also support babel esmodule exports
  }

  var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
  var dependencyRegExp = '\\(\\s*(\/\\*.*?\\*\/)?\\s*.*?(' + moduleNameReqExp + ').*?\\)'; // additional chars when output.pathinfo is true

  // http://stackoverflow.com/a/2593661/130442
  function quoteRegExp (str) {
    return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
  }

  function isNumeric(n) {
    return !isNaN(1 * n); // 1 * n converts integers, integers as string ("123"), 1e3 and "1e3" to integers and strings to NaN
  }

  function getModuleDependencies (sources, module, queueName) {
    var retval = {};
    retval[queueName] = [];

    var fnString = module.toString();
    var wrapperSignature = fnString.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
    if (!wrapperSignature) return retval
    var webpackRequireName = wrapperSignature[1];

    // main bundle deps
    var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
    var match;
    while ((match = re.exec(fnString))) {
      if (match[3] === 'dll-reference') continue
      retval[queueName].push(match[3]);
    }

    // dll deps
    re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
    while ((match = re.exec(fnString))) {
      if (!sources[match[2]]) {
        retval[queueName].push(match[1]);
        sources[match[2]] = __webpack_require__(match[1]).m;
      }
      retval[match[2]] = retval[match[2]] || [];
      retval[match[2]].push(match[4]);
    }

    // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3
    var keys = Object.keys(retval);
    for (var i = 0; i < keys.length; i++) {
      for (var j = 0; j < retval[keys[i]].length; j++) {
        if (isNumeric(retval[keys[i]][j])) {
          retval[keys[i]][j] = 1 * retval[keys[i]][j];
        }
      }
    }

    return retval
  }

  function hasValuesInQueues (queues) {
    var keys = Object.keys(queues);
    return keys.reduce(function (hasValues, key) {
      return hasValues || queues[key].length > 0
    }, false)
  }

  function getRequiredModules (sources, moduleId) {
    var modulesQueue = {
      main: [moduleId]
    };
    var requiredModules = {
      main: []
    };
    var seenModules = {
      main: {}
    };

    while (hasValuesInQueues(modulesQueue)) {
      var queues = Object.keys(modulesQueue);
      for (var i = 0; i < queues.length; i++) {
        var queueName = queues[i];
        var queue = modulesQueue[queueName];
        var moduleToCheck = queue.pop();
        seenModules[queueName] = seenModules[queueName] || {};
        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
        seenModules[queueName][moduleToCheck] = true;
        requiredModules[queueName] = requiredModules[queueName] || [];
        requiredModules[queueName].push(moduleToCheck);
        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
        var newModulesKeys = Object.keys(newModules);
        for (var j = 0; j < newModulesKeys.length; j++) {
          modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
          modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
        }
      }
    }

    return requiredModules
  }

  module.exports = function (moduleId, options) {
    options = options || {};
    var sources = {
      main: __webpack_require__.m
    };

    var requiredModules = options.all ? { main: Object.keys(sources.main) } : getRequiredModules(sources, moduleId);

    var src = '';

    Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
      var entryModule = 0;
      while (requiredModules[module][entryModule]) {
        entryModule++;
      }
      requiredModules[module].push(entryModule);
      sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
      src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n';
    });

    src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '}))(self);';

    var blob = new window.Blob([src], { type: 'text/javascript' });
    if (options.bare) { return blob }

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var workerUrl = URL.createObjectURL(blob);
    var worker = new window.Worker(workerUrl);
    worker.objectURL = workerUrl;

    return worker
  };


  /***/ }),
  /* 22 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


  var _flvTag = __webpack_require__(23);

  var _flvTag2 = _interopRequireDefault(_flvTag);

  var _tagdemux = __webpack_require__(8);

  var _tagdemux2 = _interopRequireDefault(_tagdemux);

  var _error = __webpack_require__(3);

  var _error2 = _interopRequireDefault(_error);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var FlvParse = function () {
      function FlvParse() {
          _classCallCheck(this, FlvParse);

          this.tempUint8 = new Uint8Array();
          this.arrTag = [];
          this.index = 0;
          this.tempArr = [];
          this.stop = false;
          this.offset = 0;
          this.frist = true;
          this._hasAudio = false;
          this._hasVideo = false;
          this._dispose = false;
          this.busy = false;
          this.busyArr = [];
      }

      /**
       * 接受 外部的flv二进制数据
       */


      _createClass(FlvParse, [{
          key: 'setFlv',
          value: function setFlv(uint8) {
              // this.stop = true;
              this.busy = true;
              this._dispose = false;
              this.stop = false;
              this.arrTag = [];
              this.index = 0;
              this.tempUint8 = uint8;
              if (this.tempUint8.length > 13 && this.tempUint8[0] == 70 && this.tempUint8[1] == 76 && this.tempUint8[2] == 86) {
                  this.probe(this.tempUint8.buffer);
                  this.read(9); // 略掉9个字节的flv header tag
                  this.read(4); // 略掉第一个4字节的 tag size
                  this.parse();
                  this.frist = false;
                  this.busy = false;
                  return this.offset;
              } else if (!this.frist) {
                  this.parse();
                  return this.offset;
              } else {
                  return this.offset;
              }
          }
      }, {
          key: 'probe',
          value: function probe(buffer) {
              var data = new Uint8Array(buffer);
              var mismatch = { match: false };

              if (data[0] !== 0x46 || data[1] !== 0x4C || data[2] !== 0x56 || data[3] !== 0x01) {
                  return mismatch;
              }

              var hasAudio = (data[4] & 4) >>> 2 !== 0;
              var hasVideo = (data[4] & 1) !== 0;

              if (!hasAudio && !hasVideo) {
                  return mismatch;
              }
              this._hasAudio = _tagdemux2.default._hasAudio = hasAudio;
              this._hasVideo = _tagdemux2.default._hasVideo = hasVideo;
              return {
                  match: true,
                  hasAudioTrack: hasAudio,
                  hasVideoTrack: hasVideo
              };
          }
      }, {
          key: 'dispose',
          value: function dispose() {}
          /**
           * 开始解析
           */

      }, {
          key: 'parse',
          value: function parse() {

              while (this.index < this.tempUint8.length && !this.stop) {
                  this.offset = this.index;

                  var t = new _flvTag2.default();
                  if (this.tempUint8.length - this.index >= 11) {
                      t.tagType = this.read(1)[0]; // 取出tag类型
                      t.dataSize = this.read(3); // 取出包体大小
                      t.Timestamp = this.read(4); // 取出解码时间
                      t.StreamID = this.read(3); // 取出stream id
                  } else {
                      this.stop = true;
                      continue;
                  }
                  if (t.tagType == 18 || t.tagType == 8 || t.tagType == 9) ; else {
                      throw new _error2.default('wrong tagType' + t.tagType);
                  }
                  if (this.tempUint8.length - this.index >= this.getBodySum(t.dataSize) + 4) {
                      t.body = this.read(this.getBodySum(t.dataSize)); // 取出body
                      if (t.tagType == 9 && this._hasVideo) {
                          this.arrTag.push(t);
                      }
                      if (t.tagType == 8 && this._hasAudio) {
                          this.arrTag.push(t);
                      }
                      if (t.tagType == 18) {
                          // kwai 因为有转屏需求，所以需要重复上报metadata
                          this.arrTag.push(t);
                      }
                      t.size = this.read(4);
                  } else {
                      this.stop = true;
                      continue;
                  }
                  this.offset = this.index;
              }

              return this.offset;
          }
      }, {
          key: 'read',
          value: function read(length) {
              // let u8a = new Uint8Array(length);
              // u8a.set(this.tempUint8.subarray(this.index, this.index + length), 0);
              var u8a = this.tempUint8.slice(this.index, this.index + length);
              this.index += length;
              return u8a;
          }

          /**
           * 计算tag包体大小
           */

      }, {
          key: 'getBodySum',
          value: function getBodySum(arr) {
              var _str = '';
              _str += arr[0].toString(16).length == 1 ? '0' + arr[0].toString(16) : arr[0].toString(16);
              _str += arr[1].toString(16).length == 1 ? '0' + arr[1].toString(16) : arr[1].toString(16);
              _str += arr[2].toString(16).length == 1 ? '0' + arr[2].toString(16) : arr[2].toString(16);
              return parseInt(_str, 16);
          }
      }]);

      return FlvParse;
  }();

  exports.default = FlvParse;

  /***/ }),
  /* 23 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /* eslint-disable */
  var FlvTag = function () {
      function FlvTag() {
          _classCallCheck(this, FlvTag);

          this.tagType = -1;
          this.dataSize = -1;
          this.Timestamp = -1;
          this.StreamID = -1;
          this.body = -1;
          this.time = -1;
          this.arr = [];
          this.size = -1;
      }

      _createClass(FlvTag, [{
          key: 'getTime',
          value: function getTime() {
              // this.Timestamp.pop();
              this.arr = [];
              for (var i = 0; i < this.Timestamp.length; i++) {
                  this.arr.push(this.Timestamp[i].toString(16).length == 1 ? '0' + this.Timestamp[i].toString(16) : this.Timestamp[i].toString(16));
              }
              this.arr.pop();
              var time = this.arr.join('');
              this.time = parseInt(time, 16);
              return parseInt(time, 16);
          }
      }]);

      return FlvTag;
  }();

  exports.default = FlvTag;

  /***/ }),
  /* 24 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


  var _decodeUTF = __webpack_require__(25);

  var _decodeUTF2 = _interopRequireDefault(_decodeUTF);

  var _spsParser = __webpack_require__(9);

  var _spsParser2 = _interopRequireDefault(_spsParser);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  var le = null;

  var flvDemux = function () {
      function flvDemux() {
          _classCallCheck(this, flvDemux);
      }

      _createClass(flvDemux, null, [{
          key: 'parseObject',
          value: function parseObject(arrayBuffer, dataOffset, dataSize) {

              var name = flvDemux.parseString(arrayBuffer, dataOffset, dataSize);
              var value = flvDemux.parseScript(arrayBuffer, dataOffset + name.size);
              var isObjectEnd = value.objectEnd;

              return {
                  data: {
                      name: name.data,
                      value: value.data
                  },
                  size: value.size,
                  objectEnd: isObjectEnd
              };
          }
      }, {
          key: 'parseVariable',
          value: function parseVariable(arrayBuffer, dataOffset, dataSize) {
              return flvDemux.parseObject(arrayBuffer, dataOffset, dataSize);
          }
      }, {
          key: 'parseLongString',
          value: function parseLongString(arrayBuffer, dataOffset, dataSize) {

              var v = new DataView(arrayBuffer, dataOffset);
              var length = v.getUint32(0, !le);

              var str = void 0;
              if (length > 0) {
                  str = (0, _decodeUTF2.default)(new Uint8Array(arrayBuffer, dataOffset + 4, length));
              } else {
                  str = '';
              }

              return {
                  data: str,
                  size: 4 + length
              };
          }
      }, {
          key: 'parseDate',
          value: function parseDate(arrayBuffer, dataOffset, dataSize) {

              var v = new DataView(arrayBuffer, dataOffset);
              var timestamp = v.getFloat64(0, !le);
              var localTimeOffset = v.getInt16(8, !le);
              timestamp += localTimeOffset * 60 * 1000; // get UTC time

              return {
                  data: new Date(timestamp),
                  size: 8 + 2
              };
          }
      }, {
          key: 'parseString',
          value: function parseString(arrayBuffer, dataOffset, dataSize) {
              var v = new DataView(arrayBuffer, dataOffset);
              var length = v.getUint16(0, !le);
              var str = void 0;
              if (length > 0) {
                  str = (0, _decodeUTF2.default)(new Uint8Array(arrayBuffer, dataOffset + 2, length));
              } else {
                  str = '';
              }
              return {
                  data: str,
                  size: 2 + length
              };
          }

          /**
           * 解析metadata
           */

      }, {
          key: 'parseMetadata',
          value: function parseMetadata(arr) {
              le = function () {
                  var buf = new ArrayBuffer(2);
                  new DataView(buf).setInt16(0, 256, true); // little-endian write
                  return new Int16Array(buf)[0] === 256; // platform-spec read, if equal then LE
              }();
              var name = flvDemux.parseScript(arr, 0);
              var value = flvDemux.parseScript(arr, name.size, arr.length - name.size);
              // return {}
              var data = {};
              data[name.data] = value.data;
              return data;
          }
      }, {
          key: 'parseScript',
          value: function parseScript(arr, offset, dataSize) {
              var dataOffset = offset;
              var uint8 = new Uint8Array(arr);
              var buffer = uint8.buffer;
              var dv = new DataView(buffer, 0, dataSize);
              var value = null;
              var type = dv.getUint8(dataOffset);
              dataOffset += 1;

              switch (type) {
                  case 0:
                      // Number(Double) type
                      value = dv.getFloat64(dataOffset, !le);
                      dataOffset += 8;
                      break;
                  case 1:
                      {
                          // Boolean type
                          var b = dv.getUint8(dataOffset);
                          value = !!b;
                          dataOffset += 1;
                          break;
                      }
                  case 2:
                      {
                          // String type
                          // dataOffset += 1;
                          var amfstr = flvDemux.parseString(buffer, dataOffset);
                          value = amfstr.data;
                          dataOffset += amfstr.size;
                          break;
                      }
                  case 3:

                      {
                          // Object(s) type
                          value = {};
                          var terminal = 0; // workaround for malformed Objects which has missing ScriptDataObjectEnd
                          if ((dv.getUint32(dataSize - 4, !le) & 0x00FFFFFF) === 9) {
                              terminal = 3;
                          }
                          while (dataOffset < dataSize - 4) {
                              // 4 === type(UI8) + ScriptDataObjectEnd(UI24)
                              var amfobj = flvDemux.parseObject(buffer, dataOffset, dataSize - offset - terminal);

                              if (amfobj.objectEnd) {
                                  break;
                              }
                              value[amfobj.data.name] = amfobj.data.value;
                              // dataOffset += amfobj.size;
                              dataOffset = amfobj.size;
                          }
                          if (dataOffset <= dataSize - 3) {
                              var marker = v.getUint32(dataOffset - 1, !le) & 0x00FFFFFF;
                              if (marker === 9) {
                                  dataOffset += 3;
                              }
                          }
                          break;
                      }
                  case 8:
                      {
                          // ECMA array type (Mixed array)
                          value = {};
                          // dataOffset += 1;
                          dataOffset += 4; // ECMAArrayLength(UI32)
                          if ((dv.getUint32(dataSize - 4, !le) & 0x00FFFFFF) === 9) ;
                          while (dataOffset < dataSize - 8) {
                              // 8 === type(UI8) + ECMAArrayLength(UI32) + ScriptDataVariableEnd(UI24)
                              var amfvar = flvDemux.parseVariable(buffer, dataOffset);

                              if (amfvar.objectEnd) {
                                  break;
                              }
                              value[amfvar.data.name] = amfvar.data.value;
                              dataOffset = amfvar.size;
                          }
                          if (dataOffset <= dataSize - 3) {
                              var _marker = dv.getUint32(dataOffset - 1, !le) & 0x00FFFFFF;
                              if (_marker === 9) {
                                  dataOffset += 3;
                              }
                          }
                          break;
                      }
                  case 9:
                      // ScriptDataObjectEnd
                      value = undefined;
                      dataOffset = 1;
                      break;
                  case 10:
                      {
                          // Strict array type
                          // ScriptDataValue[n]. NOTE: according to video_file_format_spec_v10_1.pdf
                          value = [];
                          var strictArrayLength = dv.getUint32(dataOffset, !le);
                          dataOffset += 4;
                          for (var i = 0; i < strictArrayLength; i++) {
                              var val = flvDemux.parseScript(buffer, dataOffset);
                              value.push(val.data);
                              dataOffset = val.size;
                          }
                          break;
                      }
                  case 11:
                      {
                          // Date type
                          var date = flvDemux.parseDate(buffer, dataOffset + 1, dataSize - 1);
                          value = date.data;
                          dataOffset += date.size;
                          break;
                      }
                  case 12:
                      {
                          // Long string type
                          var amfLongStr = flvDemux.parseString(buffer, dataOffset + 1, dataSize - 1);
                          value = amfLongStr.data;
                          dataOffset += amfLongStr.size;
                          break;
                      }
                  default:
                      // ignore and skip
                      dataOffset = dataSize;
                      console.log('AMF', 'Unsupported AMF value type ' + type);
              }
              return {
                  data: value,
                  size: dataOffset
              };
          }
      }]);

      return flvDemux;
  }();

  exports.default = flvDemux;

  /***/ }),
  /* 25 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });
  /* eslint-disable */
  function decodeUTF8(uint8array) {
      var out = [];
      var input = uint8array;
      var i = 0;
      var length = uint8array.length;

      while (i < length) {
          if (input[i] < 0x80) {
              out.push(String.fromCharCode(input[i]));
              ++i;
              continue;
          } else if (input[i] < 0xC0) ; else if (input[i] < 0xE0) {
              if (checkContinuation(input, i, 1)) {
                  var ucs4 = (input[i] & 0x1F) << 6 | input[i + 1] & 0x3F;
                  if (ucs4 >= 0x80) {
                      out.push(String.fromCharCode(ucs4 & 0xFFFF));
                      i += 2;
                      continue;
                  }
              }
          } else if (input[i] < 0xF0) {
              if (checkContinuation(input, i, 2)) {
                  var _ucs = (input[i] & 0xF) << 12 | (input[i + 1] & 0x3F) << 6 | input[i + 2] & 0x3F;
                  if (_ucs >= 0x800 && (_ucs & 0xF800) !== 0xD800) {
                      out.push(String.fromCharCode(_ucs & 0xFFFF));
                      i += 3;
                      continue;
                  }
              }
          } else if (input[i] < 0xF8) {
              if (checkContinuation(input, i, 3)) {
                  var _ucs2 = (input[i] & 0x7) << 18 | (input[i + 1] & 0x3F) << 12 | (input[i + 2] & 0x3F) << 6 | input[i + 3] & 0x3F;
                  if (_ucs2 > 0x10000 && _ucs2 < 0x110000) {
                      _ucs2 -= 0x10000;
                      out.push(String.fromCharCode(_ucs2 >>> 10 | 0xD800));
                      out.push(String.fromCharCode(_ucs2 & 0x3FF | 0xDC00));
                      i += 4;
                      continue;
                  }
              }
          }
          out.push(String.fromCharCode(0xFFFD));
          ++i;
      }

      return out.join('');
  }

  function checkContinuation(uint8array, start, checkLength) {
      var array = uint8array;
      if (start + checkLength < array.length) {
          while (checkLength--) {
              if ((array[++start] & 0xC0) !== 0x80) return false;
          }
          return true;
      } else {
          return false;
      }
  }
  exports.default = decodeUTF8;

  /***/ }),
  /* 26 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * Copyright (C) 2016 Bilibili. All Rights Reserved.
   *
   * @author zheng qian <xqq@xqq.im>
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* eslint-disable */
  // Exponential-Golomb buffer decoder
  var ExpGolomb = function () {
      function ExpGolomb(uint8array) {
          _classCallCheck(this, ExpGolomb);

          this.TAG = this.constructor.name;

          this._buffer = uint8array;
          this._buffer_index = 0;
          this._total_bytes = uint8array.byteLength;
          this._total_bits = uint8array.byteLength * 8;
          this._current_word = 0;
          this._current_word_bits_left = 0;
      }

      _createClass(ExpGolomb, [{
          key: 'destroy',
          value: function destroy() {
              this._buffer = null;
          }
      }, {
          key: '_fillCurrentWord',
          value: function _fillCurrentWord() {
              var buffer_bytes_left = this._total_bytes - this._buffer_index;
              if (buffer_bytes_left <= 0) {
                  throw new IllegalStateException('ExpGolomb: _fillCurrentWord() but no bytes available');
              }

              var bytes_read = Math.min(4, buffer_bytes_left);
              var word = new Uint8Array(4);
              word.set(this._buffer.subarray(this._buffer_index, this._buffer_index + bytes_read));
              this._current_word = new DataView(word.buffer).getUint32(0, false);

              this._buffer_index += bytes_read;
              this._current_word_bits_left = bytes_read * 8;
          }
      }, {
          key: 'readBits',
          value: function readBits(bits) {
              if (bits > 32) {
                  throw new InvalidArgumentException('ExpGolomb: readBits() bits exceeded max 32bits!');
              }

              if (bits <= this._current_word_bits_left) {
                  var _result = this._current_word >>> 32 - bits;
                  this._current_word <<= bits;
                  this._current_word_bits_left -= bits;
                  return _result;
              }

              var result = this._current_word_bits_left ? this._current_word : 0;
              result = result >>> 32 - this._current_word_bits_left;
              var bits_need_left = bits - this._current_word_bits_left;

              this._fillCurrentWord();
              var bits_read_next = Math.min(bits_need_left, this._current_word_bits_left);

              var result2 = this._current_word >>> 32 - bits_read_next;
              this._current_word <<= bits_read_next;
              this._current_word_bits_left -= bits_read_next;

              result = result << bits_read_next | result2;
              return result;
          }
      }, {
          key: 'readBool',
          value: function readBool() {
              return this.readBits(1) === 1;
          }
      }, {
          key: 'readByte',
          value: function readByte() {
              return this.readBits(8);
          }
      }, {
          key: '_skipLeadingZero',
          value: function _skipLeadingZero() {
              var zero_count = void 0;
              for (zero_count = 0; zero_count < this._current_word_bits_left; zero_count++) {
                  if ((this._current_word & 0x80000000 >>> zero_count) !== 0) {
                      this._current_word <<= zero_count;
                      this._current_word_bits_left -= zero_count;
                      return zero_count;
                  }
              }
              this._fillCurrentWord();
              return zero_count + this._skipLeadingZero();
          }
      }, {
          key: 'readUEG',
          value: function readUEG() {
              // unsigned exponential golomb
              var leading_zeros = this._skipLeadingZero();
              return this.readBits(leading_zeros + 1) - 1;
          }
      }, {
          key: 'readSEG',
          value: function readSEG() {
              // signed exponential golomb
              var value = this.readUEG();
              if (value & 0x01) {
                  return value + 1 >>> 1;
              } else {
                  return -1 * (value >>> 1);
              }
          }
      }]);

      return ExpGolomb;
  }();

  exports.default = ExpGolomb;

  /***/ }),
  /* 27 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * Copyright (C) 2016 Bilibili. All Rights Reserved.
   *
   * @author zheng qian <xqq@xqq.im>
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* eslint-disable */
  var MediaInfo = function () {
      function MediaInfo() {
          _classCallCheck(this, MediaInfo);

          this.mimeType = null;
          this.duration = null;

          this.hasAudio = null;
          this.hasVideo = null;
          this.audioCodec = null;
          this.videoCodec = null;
          this.audioDataRate = null;
          this.videoDataRate = null;

          this.audioSampleRate = null;
          this.audioChannelCount = null;

          this.width = null;
          this.height = null;
          this.fps = null;
          this.profile = null;
          this.level = null;
          this.chromaFormat = null;
          this.sarNum = null;
          this.sarDen = null;

          this.metadata = null;
          this.segments = null; // MediaInfo[]
          this.segmentCount = null;
          this.hasKeyframesIndex = null;
          this.keyframesIndex = null;
      }

      _createClass(MediaInfo, [{
          key: "isComplete",
          value: function isComplete() {
              var audioInfoComplete = this.hasAudio === false || this.hasAudio === true && this.audioCodec != null && this.audioSampleRate != null && this.audioChannelCount != null;

              var videoInfoComplete = this.hasVideo === false || this.hasVideo === true && this.videoCodec != null && this.width != null && this.height != null && this.fps != null && this.profile != null && this.level != null && this.chromaFormat != null && this.sarNum != null && this.sarDen != null;

              // keyframesIndex may not be present
              return this.mimeType != null && this.duration != null && this.metadata != null && this.hasKeyframesIndex != null && audioInfoComplete && videoInfoComplete;
          }
      }, {
          key: "isSeekable",
          value: function isSeekable() {
              return this.hasKeyframesIndex === true;
          }
      }]);

      return MediaInfo;
  }();

  exports.default = MediaInfo;

  /***/ }),
  /* 28 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (C) 2016 Bilibili. All Rights Reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * @author zheng qian <xqq@xqq.im>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *     http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */

  // import Log from '../utils/logger.js';


  var _aacSilent = __webpack_require__(29);

  var _aacSilent2 = _interopRequireDefault(_aacSilent);

  var _browser = __webpack_require__(30);

  var _browser2 = _interopRequireDefault(_browser);

  var _mp4remux = __webpack_require__(10);

  var _mp4remux2 = _interopRequireDefault(_mp4remux);

  var _mediaSegmentInfo = __webpack_require__(31);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  // Fragmented mp4 remuxer
  var MP4Remuxer = function () {
      function MP4Remuxer(config) {
          _classCallCheck(this, MP4Remuxer);

          this.TAG = 'MP4Remuxer';

          this._isLive = config.isLive === true;

          this._dtsBase = -1;
          this._dtsBaseInited = false;
          this._audioDtsBase = Infinity;
          this._videoDtsBase = Infinity;
          this._audioNextDts = undefined;
          this._videoNextDts = undefined;

          this._audioMeta = null;
          this._videoMeta = null;

          this._audioSegmentInfoList = new _mediaSegmentInfo.MediaSegmentInfoList('audio');
          this._videoSegmentInfoList = new _mediaSegmentInfo.MediaSegmentInfoList('video');

          this._onInitSegment = null;
          this._onMediaSegment = null;

          // Workaround for chrome < 50: Always force first sample as a Random Access Point in media segment
          // see https://bugs.chromium.org/p/chromium/issues/detail?id=229412
          this._forceFirstIDR = _browser2.default.chrome && (_browser2.default.version.major < 50 || _browser2.default.version.major === 50 && _browser2.default.version.build < 2661) ? true : false;

          // Workaround for IE11/Edge: Fill silent aac frame after keyframe-seeking
          // Make audio beginDts equals with video beginDts, in order to fix seek freeze
          this._fillSilentAfterSeek = _browser2.default.msedge || _browser2.default.msie;

          // While only FireFox supports 'audio/mp4, codecs="mp3"', use 'audio/mpeg' for chrome, safari, ...
          this._mp3UseMpegAudio = !_browser2.default.firefox;
      }

      _createClass(MP4Remuxer, [{
          key: 'destroy',
          value: function destroy() {
              this._dtsBase = -1;
              this._dtsBaseInited = false;
              this._audioMeta = null;
              this._videoMeta = null;
              this._audioSegmentInfoList.clear();
              this._audioSegmentInfoList = null;
              this._videoSegmentInfoList.clear();
              this._videoSegmentInfoList = null;
              this._onInitSegment = null;
              this._onMediaSegment = null;
          }
      }, {
          key: 'bindDataSource',
          value: function bindDataSource(producer) {
              producer.onDataAvailable = this.remux.bind(this);
              producer.onTrackMetadata = this._onTrackMetadataReceived.bind(this);
              return this;
          }

          /* prototype: function onInitSegment(type: string, initSegment: ArrayBuffer): void
             InitSegment: {
                 type: string,
                 data: ArrayBuffer,
                 codec: string,
                 container: string
             }
          */

      }, {
          key: 'insertDiscontinuity',
          value: function insertDiscontinuity() {
              this._audioNextDts = this._videoNextDts = undefined;
          }
      }, {
          key: 'seek',
          value: function seek(originalDts) {
              this._videoSegmentInfoList.clear();
              this._audioSegmentInfoList.clear();
          }
      }, {
          key: 'remux',
          value: function remux(audioTrack, videoTrack) {
              if (!this._onMediaSegment) {
                  throw new IllegalStateException('MP4Remuxer: onMediaSegment callback must be specificed!');
              }
              if (!this._dtsBaseInited) {
                  this._calculateDtsBase(audioTrack, videoTrack);
              }
              this._remuxVideo(videoTrack);
              this._remuxAudio(audioTrack);
          }
      }, {
          key: '_onTrackMetadataReceived',
          value: function _onTrackMetadataReceived(type, metadata) {
              var metabox = null;

              var container = 'mp4';
              var codec = metadata.codec;

              if (type === 'audio') {
                  this._audioMeta = metadata;
                  if (metadata.codec === 'mp3' && this._mp3UseMpegAudio) {
                      // 'audio/mpeg' for MP3 audio track
                      container = 'mpeg';
                      codec = '';
                      metabox = new Uint8Array();
                  } else {
                      // 'audio/mp4, codecs="codec"'
                      metabox = _mp4remux2.default.generateInitSegment(metadata);
                  }
              } else if (type === 'video') {
                  this._videoMeta = metadata;
                  metabox = _mp4remux2.default.generateInitSegment(metadata);
              } else {
                  return;
              }

              // dispatch metabox (Initialization Segment)
              if (!this._onInitSegment) {
                  throw new IllegalStateException('MP4Remuxer: onInitSegment callback must be specified!');
              }
              this._onInitSegment(type, {
                  type: type,
                  data: metabox.buffer,
                  codec: codec,
                  container: type + '/' + container,
                  mediaDuration: metadata.duration // in timescale 1000 (milliseconds)
              });
          }
      }, {
          key: '_calculateDtsBase',
          value: function _calculateDtsBase(audioTrack, videoTrack) {
              if (this._dtsBaseInited) {
                  return;
              }

              if (audioTrack.samples && audioTrack.samples.length) {
                  this._audioDtsBase = audioTrack.samples[0].dts;
              }
              if (videoTrack.samples && videoTrack.samples.length) {
                  this._videoDtsBase = videoTrack.samples[0].dts;
              }

              this._dtsBase = Math.min(this._audioDtsBase, this._videoDtsBase);
              this._dtsBaseInited = true;
          }
      }, {
          key: '_remuxAudio',
          value: function _remuxAudio(audioTrack) {
              if (this._audioMeta == null) {
                  return;
              }

              var track = audioTrack;
              var samples = track.samples;
              var dtsCorrection = undefined;
              var firstDts = -1,
                  lastDts = -1;
              var refSampleDuration = this._audioMeta.refSampleDuration;

              var mpegRawTrack = this._audioMeta.codec === 'mp3' && this._mp3UseMpegAudio;
              var firstSegmentAfterSeek = this._dtsBaseInited && this._audioNextDts === undefined;

              var insertPrefixSilentFrame = false;

              if (!samples || samples.length <= 1) {
                  return;
              }

              var offset = 0;
              var mdatbox = null;
              var mdatBytes = 0;

              // calculate initial mdat size
              if (mpegRawTrack) {
                  // for raw mpeg buffer
                  offset = 0;
                  mdatBytes = track.length;
              } else {
                  // for fmp4 mdat box
                  offset = 8; // size + type
                  mdatBytes = 8 + track.length;
              }

              var firstSampleOriginalDts = samples[0].dts - this._dtsBase;

              // calculate dtsCorrection
              if (this._audioNextDts) {
                  dtsCorrection = firstSampleOriginalDts - this._audioNextDts;
              } else {
                  // this._audioNextDts == undefined
                  if (this._audioSegmentInfoList.isEmpty()) {
                      dtsCorrection = 0;
                      if (this._fillSilentAfterSeek && !this._videoSegmentInfoList.isEmpty()) {
                          if (this._audioMeta.originalCodec !== 'mp3') {
                              insertPrefixSilentFrame = true;
                          }
                      }
                  } else {
                      var lastSample = this._audioSegmentInfoList.getLastSampleBefore(firstSampleOriginalDts);
                      if (lastSample != null) {
                          var distance = firstSampleOriginalDts - (lastSample.originalDts + lastSample.duration);
                          if (distance <= 3) {
                              distance = 0;
                          }
                          var expectedDts = lastSample.dts + lastSample.duration + distance;
                          dtsCorrection = firstSampleOriginalDts - expectedDts;
                      } else {
                          // lastSample == null, cannot found
                          dtsCorrection = 0;
                      }
                  }
              }

              if (insertPrefixSilentFrame) {
                  // align audio segment beginDts to match with current video segment's beginDts
                  var firstSampleDts = firstSampleOriginalDts - dtsCorrection;
                  var videoSegment = this._videoSegmentInfoList.getLastSegmentBefore(firstSampleOriginalDts);
                  if (videoSegment != null && videoSegment.beginDts < firstSampleDts) {
                      var silentUnit = _aacSilent2.default.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                      if (silentUnit) {
                          var dts = videoSegment.beginDts;
                          var silentFrameDuration = firstSampleDts - videoSegment.beginDts;
                          Log.v(this.TAG, 'InsertPrefixSilentAudio: dts: ' + dts + ', duration: ' + silentFrameDuration);
                          samples.unshift({ unit: silentUnit, dts: dts, pts: dts });
                          mdatBytes += silentUnit.byteLength;
                      } // silentUnit == null: Cannot generate, skip
                  } else {
                      insertPrefixSilentFrame = false;
                  }
              }

              var mp4Samples = [];
              dtsCorrection = 0;

              // Correct dts for each sample, and calculate sample duration. Then output to mp4Samples
              for (var i = 0; i + 1 < samples.length; i++) {
                  var sample = samples[i];
                  var unit = sample.unit;
                  var originalDts = sample.dts - this._dtsBase;
                  var _dts = originalDts - dtsCorrection;

                  if (firstDts === -1) {
                      firstDts = _dts;
                  }

                  var sampleDuration = 0;

                  if (i !== samples.length - 1) {
                      var nextDts = samples[i + 1].dts - this._dtsBase - dtsCorrection;
                      sampleDuration = nextDts - _dts;
                  } else {
                      // the last sample
                      if (mp4Samples.length >= 1) {
                          // use second last sample duration
                          sampleDuration = mp4Samples[mp4Samples.length - 1].duration;
                      } else {
                          // the only one sample, use reference sample duration
                          sampleDuration = Math.floor(refSampleDuration);
                      }
                  }

                  // // Silent frame generation, if large timestamp gap detected
                  // if (sampleDuration > refSampleDuration * 1.5 && this._audioMeta.codec !== 'mp3') {
                  //     // We need to insert silent frames to fill timestamp gap
                  //     needFillSilentFrames = true;
                  //     let delta = Math.abs(sampleDuration - refSampleDuration);
                  //     let frameCount = Math.ceil(delta / refSampleDuration);
                  //     let currentDts = dts + refSampleDuration;  // Notice: in float

                  //     // console.log(this.TAG, 'Large audio timestamp gap detected, may cause AV sync to drift. ' +
                  //     //                 'Silent frames will be generated to avoid unsync.\n' +
                  //     //                 `dts: ${dts + sampleDuration} ms, expected: ${dts + Math.round(refSampleDuration)} ms, ` +
                  //     //                 `delta: ${Math.round(delta)} ms, generate: ${frameCount} frames`);

                  //     let silentUnit = AAC.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                  //     if (silentUnit == null) {
                  //         // console.log(this.TAG, 'Unable to generate silent frame for ' +
                  //         //                 `${this._audioMeta.originalCodec} with ${this._audioMeta.channelCount} channels, repeat last frame`);
                  //         // Repeat last frame
                  //         silentUnit = unit;
                  //     }
                  //     silentFrames = [];

                  //     for (let j = 0; j < frameCount; j++) {
                  //         let intDts = Math.round(currentDts);  // round to integer
                  //         if (silentFrames.length > 0) {
                  //             // Set previous frame sample duration
                  //             let previousFrame = silentFrames[silentFrames.length - 1];
                  //             previousFrame.duration = intDts - previousFrame.dts;
                  //         }
                  //         let frame = {
                  //             dts: intDts,
                  //             pts: intDts,
                  //             cts: 0,
                  //             unit: silentUnit,
                  //             size: silentUnit.byteLength,
                  //             duration: 0,  // wait for next sample
                  //             originalDts: originalDts,
                  //             flags: {
                  //                 isLeading: 0,
                  //                 dependsOn: 1,
                  //                 isDependedOn: 0,
                  //                 hasRedundancy: 0
                  //             }
                  //         };
                  //         silentFrames.push(frame);
                  //         mdatBytes += unit.byteLength;
                  //         currentDts += refSampleDuration;
                  //     }

                  //     // last frame: align end time to next frame dts
                  //     let lastFrame = silentFrames[silentFrames.length - 1];
                  //     lastFrame.duration = dts + sampleDuration - lastFrame.dts;

                  //     // silentFrames.forEach((frame) => {
                  //     //     Log.w(this.TAG, `SilentAudio: dts: ${frame.dts}, duration: ${frame.duration}`);
                  //     // });

                  //     // Set correct sample duration for current frame
                  //     sampleDuration = Math.round(refSampleDuration);
                  // }

                  mp4Samples.push({
                      dts: _dts,
                      pts: _dts,
                      cts: 0,
                      unit: sample.unit,
                      size: sample.unit.byteLength,
                      duration: sampleDuration,
                      originalDts: originalDts,
                      flags: {
                          isLeading: 0,
                          dependsOn: 1,
                          isDependedOn: 0,
                          hasRedundancy: 0
                      }
                  });
              }

              // allocate mdatbox
              if (mpegRawTrack) {
                  // allocate for raw mpeg buffer
                  mdatbox = new Uint8Array(mdatBytes);
              } else {
                  var _mdatBytes = 8; // + videoTrack.length;
                  for (var _i = 0; _i < mp4Samples.length; ++_i) {
                      _mdatBytes += mp4Samples[_i].size;
                  }

                  mdatbox = new Uint8Array(_mdatBytes);
                  // size field
                  mdatbox[0] = _mdatBytes >>> 24 & 0xFF;
                  mdatbox[1] = _mdatBytes >>> 16 & 0xFF;
                  mdatbox[2] = _mdatBytes >>> 8 & 0xFF;
                  mdatbox[3] = _mdatBytes & 0xFF;
                  // type field (fourCC)
                  mdatbox.set(_mp4remux2.default.types.mdat, 4);
              }

              // Write samples into mdatbox
              for (var _i2 = 0; _i2 < mp4Samples.length; _i2++) {
                  var _unit = mp4Samples[_i2].unit;
                  mdatbox.set(_unit, offset);
                  offset += _unit.byteLength;
              }

              var latest = mp4Samples[mp4Samples.length - 1];
              lastDts = latest.dts + latest.duration;
              // console.log(latest.dts,latest.originalDts);
              // lastDts = latest.originalDts + latest.duration;
              this._audioNextDts = lastDts;
              // console.log('dtsCorrection',dtsCorrection,'firstSampleOriginalDts',firstSampleOriginalDts,'_dtsBase',this._dtsBase,'this._audioNextDts',this._audioNextDts,'latest.dts',latest.dts,latest.originalDts)

              // fill media segment info & add to info list
              var info = new _mediaSegmentInfo.MediaSegmentInfo();
              info.beginDts = firstDts;
              info.endDts = lastDts;
              info.beginPts = firstDts;
              info.endPts = lastDts;
              info.originalBeginDts = mp4Samples[0].originalDts;
              info.originalEndDts = latest.originalDts + latest.duration;
              info.firstSample = new _mediaSegmentInfo.SampleInfo(mp4Samples[0].dts, mp4Samples[0].pts, mp4Samples[0].duration, mp4Samples[0].originalDts, false);
              info.lastSample = new _mediaSegmentInfo.SampleInfo(latest.dts, latest.pts, latest.duration, latest.originalDts, false);
              if (!this._isLive) {
                  this._audioSegmentInfoList.append(info);
              }

              track.samples = mp4Samples;
              track.sequenceNumber++;
              // track.sequenceNumber += track.addcoefficient;
              var moofbox = null;

              if (mpegRawTrack) {
                  // Generate empty buffer, because useless for raw mpeg
                  moofbox = new Uint8Array();
              } else {
                  // Generate moof for fmp4 segment
                  moofbox = _mp4remux2.default.moof(track, firstDts);
              }

              track.samples = [samples[samples.length - 1]];
              track.length = 0;

              var segment = {
                  type: 'audio',
                  data: this._mergeBoxes(moofbox, mdatbox).buffer,
                  sampleCount: mp4Samples.length,
                  info: info
              };

              if (mpegRawTrack && firstSegmentAfterSeek) {
                  // For MPEG audio stream in MSE, if seeking occurred, before appending new buffer
                  // We need explicitly set timestampOffset to the desired point in timeline for mpeg SourceBuffer.
                  segment.timestampOffset = firstDts;
              }

              this._onMediaSegment('audio', segment);
          }
      }, {
          key: '_remuxVideo',
          value: function _remuxVideo(videoTrack) {
              if (this._videoMeta == null) {
                  return;
              }

              var track = videoTrack;
              var samples = track.samples;
              var dtsCorrection = undefined;
              var firstDts = -1,
                  lastDts = -1;
              var firstPts = -1,
                  lastPts = -1;

              if (!samples || samples.length <= 1) {
                  return;
              }

              var firstSampleOriginalDts = samples[0].dts - this._dtsBase;

              // calculate dtsCorrection
              if (this._videoNextDts) {
                  dtsCorrection = Math.max(firstSampleOriginalDts - this._videoNextDts, 0);
              } else {
                  // this._videoNextDts == undefined
                  if (this._videoSegmentInfoList.isEmpty()) {
                      dtsCorrection = 0;
                  } else {
                      var lastSample = this._videoSegmentInfoList.getLastSampleBefore(firstSampleOriginalDts);
                      if (lastSample != null) {
                          var distance = firstSampleOriginalDts - (lastSample.originalDts + lastSample.duration);
                          if (distance <= 3) {
                              distance = 0;
                          }
                          var expectedDts = lastSample.dts + lastSample.duration + distance;
                          dtsCorrection = firstSampleOriginalDts - expectedDts;
                      } else {
                          // lastSample == null, cannot found
                          dtsCorrection = 0;
                      }
                  }
              }

              var info = new _mediaSegmentInfo.MediaSegmentInfo();
              var mp4Samples = [];
              var firstFrameDtsCorrection = dtsCorrection;
              dtsCorrection = 0;

              // Correct dts for each sample, and calculate sample duration. Then output to mp4Samples
              for (var i = 0; i + 1 < samples.length; i++) {
                  var sample = samples[i];
                  var originalDts = sample.dts - this._dtsBase - (i == 0 ? firstFrameDtsCorrection : 0);
                  var isKeyframe = sample.isKeyframe;
                  var dts = originalDts - dtsCorrection;
                  var cts = sample.cts;
                  var pts = dts + cts;

                  if (firstDts === -1) {
                      firstDts = dts;
                      firstPts = pts;
                  }

                  var sampleDuration = 0;

                  if (i !== samples.length - 1) {
                      var nextDts = samples[i + 1].dts - this._dtsBase - dtsCorrection;
                      sampleDuration = nextDts - dts;
                  } else {
                      // the last sample
                      if (mp4Samples.length >= 1) {
                          // use second last sample duration
                          sampleDuration = mp4Samples[mp4Samples.length - 1].duration;
                      } else {
                          // the only one sample, use reference sample duration
                          sampleDuration = Math.floor(this._videoMeta.refSampleDuration);
                      }
                  }

                  if (isKeyframe) {
                      var syncPoint = new _mediaSegmentInfo.SampleInfo(dts, pts, sampleDuration, sample.dts, true);
                      syncPoint.fileposition = sample.fileposition;
                      info.appendSyncPoint(syncPoint);
                  }

                  mp4Samples.push({
                      dts: dts,
                      pts: pts,
                      cts: cts,
                      units: sample.units,
                      size: sample.length,
                      isKeyframe: isKeyframe,
                      duration: sampleDuration,
                      originalDts: originalDts,
                      flags: {
                          isLeading: 0,
                          dependsOn: isKeyframe ? 2 : 1,
                          isDependedOn: isKeyframe ? 1 : 0,
                          hasRedundancy: 0,
                          isNonSync: isKeyframe ? 0 : 1
                      }
                  });
              }

              var offset = 8;
              var mdatBytes = 8; // + videoTrack.length;
              for (var _i3 = 0; _i3 < mp4Samples.length; ++_i3) {
                  mdatBytes += mp4Samples[_i3].size;
              }
              var mdatbox = new Uint8Array(mdatBytes);
              mdatbox[0] = mdatBytes >>> 24 & 0xFF;
              mdatbox[1] = mdatBytes >>> 16 & 0xFF;
              mdatbox[2] = mdatBytes >>> 8 & 0xFF;
              mdatbox[3] = mdatBytes & 0xFF;
              mdatbox.set(_mp4remux2.default.types.mdat, 4);
              // Write samples into mdatbox
              for (var _i4 = 0; _i4 < mp4Samples.length; _i4++) {
                  var units = mp4Samples[_i4].units;
                  while (units.length) {
                      var unit = units.shift();
                      var data = unit.data;
                      mdatbox.set(data, offset);
                      offset += data.byteLength;
                  }
              }

              var latest = mp4Samples[mp4Samples.length - 1];
              lastDts = latest.dts + latest.duration;
              // lastDts = latest.originalDts + latest.duration;
              lastPts = latest.pts + latest.duration;
              this._videoNextDts = lastDts;

              // fill media segment info & add to info list
              info.beginDts = firstDts;
              info.endDts = lastDts;
              info.beginPts = firstPts;
              info.endPts = lastPts;
              info.originalBeginDts = mp4Samples[0].originalDts;
              info.originalEndDts = latest.originalDts + latest.duration;
              info.firstSample = new _mediaSegmentInfo.SampleInfo(mp4Samples[0].dts, mp4Samples[0].pts, mp4Samples[0].duration, mp4Samples[0].originalDts, mp4Samples[0].isKeyframe);
              info.lastSample = new _mediaSegmentInfo.SampleInfo(latest.dts, latest.pts, latest.duration, latest.originalDts, latest.isKeyframe);
              if (!this._isLive) {
                  this._videoSegmentInfoList.append(info);
              }

              track.samples = mp4Samples;
              track.sequenceNumber++;
              // track.sequenceNumber += track.addcoefficient;

              // workaround for chrome < 50: force first sample as a random access point
              // see https://bugs.chromium.org/p/chromium/issues/detail?id=229412
              if (this._forceFirstIDR) {
                  var flags = mp4Samples[0].flags;
                  flags.dependsOn = 2;
                  flags.isNonSync = 0;
              }

              var moofbox = _mp4remux2.default.moof(track, firstDts);
              track.samples = [samples[samples.length - 1]];
              track.length = 0;

              this._onMediaSegment('video', {
                  type: 'video',
                  data: this._mergeBoxes(moofbox, mdatbox).buffer,
                  sampleCount: mp4Samples.length,
                  info: info
              });
          }
      }, {
          key: '_mergeBoxes',
          value: function _mergeBoxes(moof, mdat) {
              var result = new Uint8Array(moof.byteLength + mdat.byteLength);
              result.set(moof, 0);
              result.set(mdat, moof.byteLength);
              return result;
          }
      }, {
          key: 'onInitSegment',
          get: function get() {
              return this._onInitSegment;
          },
          set: function set(callback) {
              this._onInitSegment = callback;
          }

          /* prototype: function onMediaSegment(type: string, mediaSegment: MediaSegment): void
             MediaSegment: {
                 type: string,
                 data: ArrayBuffer,
                 sampleCount: int32
                 info: MediaSegmentInfo
             }
          */

      }, {
          key: 'onMediaSegment',
          get: function get() {
              return this._onMediaSegment;
          },
          set: function set(callback) {
              this._onMediaSegment = callback;
          }
      }]);

      return MP4Remuxer;
  }();

  exports.default = MP4Remuxer;

  /***/ }),
  /* 29 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * Copyright (C) 2016 Bilibili. All Rights Reserved.
   *
   * This file is modified from dailymotion's hls.js library (hls.js/src/helper/aac.js)
   * @author zheng qian <xqq@xqq.im>
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* eslint-disable */
  var AAC = function () {
      function AAC() {
          _classCallCheck(this, AAC);
      }

      _createClass(AAC, null, [{
          key: "getSilentFrame",
          value: function getSilentFrame(channelCount) {
              if (channelCount === 1) {
                  return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
              } else if (channelCount === 2) {
                  return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
              } else if (channelCount === 3) {
                  return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
              } else if (channelCount === 4) {
                  return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
              } else if (channelCount === 5) {
                  return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
              } else if (channelCount === 6) {
                  return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
              }
              return null;
          }
      }]);

      return AAC;
  }();

  exports.default = AAC;

  /***/ }),
  /* 30 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });
  /*
   * Copyright (C) 2016 Bilibili. All Rights Reserved.
   *
   * @author zheng qian <xqq@xqq.im>
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* eslint-disable */
  var Browser = {};

  function detect() {
      // modified from jquery-browser-plugin

      var ua = self.navigator.userAgent.toLowerCase();

      var match = /(edge)\/([\w.]+)/.exec(ua) || /(opr)[\/]([\w.]+)/.exec(ua) || /(chrome)[ \/]([\w.]+)/.exec(ua) || /(iemobile)[\/]([\w.]+)/.exec(ua) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('trident') >= 0 && /(rv)(?::| )([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

      var platform_match = /(ipad)/.exec(ua) || /(ipod)/.exec(ua) || /(windows phone)/.exec(ua) || /(iphone)/.exec(ua) || /(kindle)/.exec(ua) || /(android)/.exec(ua) || /(windows)/.exec(ua) || /(mac)/.exec(ua) || /(linux)/.exec(ua) || /(cros)/.exec(ua) || [];

      var matched = {
          browser: match[5] || match[3] || match[1] || '',
          version: match[2] || match[4] || '0',
          majorVersion: match[4] || match[2] || '0',
          platform: platform_match[0] || ''
      };

      var browser = {};
      if (matched.browser) {
          browser[matched.browser] = true;

          var versionArray = matched.majorVersion.split('.');
          browser.version = {
              major: parseInt(matched.majorVersion, 10),
              string: matched.version
          };
          if (versionArray.length > 1) {
              browser.version.minor = parseInt(versionArray[1], 10);
          }
          if (versionArray.length > 2) {
              browser.version.build = parseInt(versionArray[2], 10);
          }
      }

      if (matched.platform) {
          browser[matched.platform] = true;
      }

      if (browser.chrome || browser.opr || browser.safari) {
          browser.webkit = true;
      }

      // MSIE. IE11 has 'rv' identifer
      if (browser.rv || browser.iemobile) {
          if (browser.rv) {
              delete browser.rv;
          }
          var msie = 'msie';
          matched.browser = msie;
          browser[msie] = true;
      }

      // Microsoft Edge
      if (browser.edge) {
          delete browser.edge;
          var msedge = 'msedge';
          matched.browser = msedge;
          browser[msedge] = true;
      }

      // Opera 15+
      if (browser.opr) {
          var opera = 'opera';
          matched.browser = opera;
          browser[opera] = true;
      }

      // Stock android browsers are marked as Safari
      if (browser.safari && browser.android) {
          var android = 'android';
          matched.browser = android;
          browser[android] = true;
      }

      browser.name = matched.browser;
      browser.platform = matched.platform;

      for (var key in Browser) {
          if (Browser.hasOwnProperty(key)) {
              delete Browser[key];
          }
      }
      Browser = browser;
      // Object.assign(Browser, browser);
  }

  detect();

  exports.default = Browser;

  /***/ }),
  /* 31 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /*
   * Copyright (C) 2016 Bilibili. All Rights Reserved.
   *
   * @author zheng qian <xqq@xqq.im>
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* eslint-disable */
  // Represents an media sample (audio / video)
  var SampleInfo = exports.SampleInfo = function SampleInfo(dts, pts, duration, originalDts, isSync) {
      _classCallCheck(this, SampleInfo);

      this.dts = dts;
      this.pts = pts;
      this.duration = duration;
      this.originalDts = originalDts;
      this.isSyncPoint = isSync;
      this.fileposition = null;
  };

  // Media Segment concept is defined in Media Source Extensions spec.
  // Particularly in ISO BMFF format, an Media Segment contains a moof box followed by a mdat box.


  var MediaSegmentInfo = exports.MediaSegmentInfo = function () {
      function MediaSegmentInfo() {
          _classCallCheck(this, MediaSegmentInfo);

          this.beginDts = 0;
          this.endDts = 0;
          this.beginPts = 0;
          this.endPts = 0;
          this.originalBeginDts = 0;
          this.originalEndDts = 0;
          this.syncPoints = []; // SampleInfo[n], for video IDR frames only
          this.firstSample = null; // SampleInfo
          this.lastSample = null; // SampleInfo
      }

      _createClass(MediaSegmentInfo, [{
          key: "appendSyncPoint",
          value: function appendSyncPoint(sampleInfo) {
              // also called Random Access Point
              sampleInfo.isSyncPoint = true;
              this.syncPoints.push(sampleInfo);
          }
      }]);

      return MediaSegmentInfo;
  }();

  // Ordered list for recording video IDR frames, sorted by originalDts


  var IDRSampleList = exports.IDRSampleList = function () {
      function IDRSampleList() {
          _classCallCheck(this, IDRSampleList);

          this._list = [];
      }

      _createClass(IDRSampleList, [{
          key: "clear",
          value: function clear() {
              this._list = [];
          }
      }, {
          key: "appendArray",
          value: function appendArray(syncPoints) {
              var list = this._list;

              if (syncPoints.length === 0) {
                  return;
              }

              if (list.length > 0 && syncPoints[0].originalDts < list[list.length - 1].originalDts) {
                  this.clear();
              }

              Array.prototype.push.apply(list, syncPoints);
          }
      }, {
          key: "getLastSyncPointBeforeDts",
          value: function getLastSyncPointBeforeDts(dts) {
              if (this._list.length == 0) {
                  return null;
              }

              var list = this._list;
              var idx = 0;
              var last = list.length - 1;
              var mid = 0;
              var lbound = 0;
              var ubound = last;

              if (dts < list[0].dts) {
                  idx = 0;
                  lbound = ubound + 1;
              }

              while (lbound <= ubound) {
                  mid = lbound + Math.floor((ubound - lbound) / 2);
                  if (mid === last || dts >= list[mid].dts && dts < list[mid + 1].dts) {
                      idx = mid;
                      break;
                  } else if (list[mid].dts < dts) {
                      lbound = mid + 1;
                  } else {
                      ubound = mid - 1;
                  }
              }
              return this._list[idx];
          }
      }]);

      return IDRSampleList;
  }();

  // Data structure for recording information of media segments in single track.


  var MediaSegmentInfoList = exports.MediaSegmentInfoList = function () {
      function MediaSegmentInfoList(type) {
          _classCallCheck(this, MediaSegmentInfoList);

          this._type = type;
          this._list = [];
          this._lastAppendLocation = -1; // cached last insert location
      }

      _createClass(MediaSegmentInfoList, [{
          key: "isEmpty",
          value: function isEmpty() {
              return this._list.length === 0;
          }
      }, {
          key: "clear",
          value: function clear() {
              this._list = [];
              this._lastAppendLocation = -1;
          }
      }, {
          key: "_searchNearestSegmentBefore",
          value: function _searchNearestSegmentBefore(originalBeginDts) {
              var list = this._list;
              if (list.length === 0) {
                  return -2;
              }
              var last = list.length - 1;
              var mid = 0;
              var lbound = 0;
              var ubound = last;

              var idx = 0;

              if (originalBeginDts < list[0].originalBeginDts) {
                  idx = -1;
                  return idx;
              }

              while (lbound <= ubound) {
                  mid = lbound + Math.floor((ubound - lbound) / 2);
                  if (mid === last || originalBeginDts > list[mid].lastSample.originalDts && originalBeginDts < list[mid + 1].originalBeginDts) {
                      idx = mid;
                      break;
                  } else if (list[mid].originalBeginDts < originalBeginDts) {
                      lbound = mid + 1;
                  } else {
                      ubound = mid - 1;
                  }
              }
              return idx;
          }
      }, {
          key: "_searchNearestSegmentAfter",
          value: function _searchNearestSegmentAfter(originalBeginDts) {
              return this._searchNearestSegmentBefore(originalBeginDts) + 1;
          }
      }, {
          key: "append",
          value: function append(mediaSegmentInfo) {
              var list = this._list;
              var msi = mediaSegmentInfo;
              var lastAppendIdx = this._lastAppendLocation;
              var insertIdx = 0;

              if (lastAppendIdx !== -1 && lastAppendIdx < list.length && msi.originalBeginDts >= list[lastAppendIdx].lastSample.originalDts && (lastAppendIdx === list.length - 1 || lastAppendIdx < list.length - 1 && msi.originalBeginDts < list[lastAppendIdx + 1].originalBeginDts)) {
                  insertIdx = lastAppendIdx + 1; // use cached location idx
              } else {
                  if (list.length > 0) {
                      insertIdx = this._searchNearestSegmentBefore(msi.originalBeginDts) + 1;
                  }
              }

              this._lastAppendLocation = insertIdx;
              this._list.splice(insertIdx, 0, msi);
          }
      }, {
          key: "getLastSegmentBefore",
          value: function getLastSegmentBefore(originalBeginDts) {
              var idx = this._searchNearestSegmentBefore(originalBeginDts);
              if (idx >= 0) {
                  return this._list[idx];
              } else {
                  // -1
                  return null;
              }
          }
      }, {
          key: "getLastSampleBefore",
          value: function getLastSampleBefore(originalBeginDts) {
              var segment = this.getLastSegmentBefore(originalBeginDts);
              if (segment != null) {
                  return segment.lastSample;
              } else {
                  return null;
              }
          }
      }, {
          key: "getLastSyncPointBefore",
          value: function getLastSyncPointBefore(originalBeginDts) {
              var segmentIdx = this._searchNearestSegmentBefore(originalBeginDts);
              var syncPoints = this._list[segmentIdx].syncPoints;
              while (syncPoints.length === 0 && segmentIdx > 0) {
                  segmentIdx--;
                  syncPoints = this._list[segmentIdx].syncPoints;
              }
              if (syncPoints.length > 0) {
                  return syncPoints[syncPoints.length - 1];
              } else {
                  return null;
              }
          }
      }, {
          key: "type",
          get: function get() {
              return this._type;
          }
      }, {
          key: "length",
          get: function get() {
              return this._list.length;
          }
      }]);

      return MediaSegmentInfoList;
  }();

  /***/ }),
  /* 32 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function (ctx) {
    var CPU = null;
    var loader = null;
    var config = {};
    ctx.addEventListener('message', function (e) {
      switch (e.data.cmd) {
        case 'init':
          config = e.data.data;
          break;
        case 'loadSource':
          loader = new _ioLoader2.default(config);
          loaderBindEvent();
          loader.arrivalDataCallback = arrivalDataCallbackWorker;
          loader.open();
          break;
        case 'pause':
          loader.pause();
          break;
        case 'seek':
          seek(e.data.keyframe);
          break;
        case 'resume':
          loader.resume();
          break;
        case 'destroy':
          destroy();
          break;
      }  });

    function init() {
      CPU = new _flv2fmp2.default(config);
      CPU.onInitSegment = onRemuxerInitSegmentArrival;
      CPU.onMediaSegment = onRemuxerMediaSegmentArrival;
      CPU.onError = onCPUError;
      CPU.onMediaInfo = onMediaInfo;
      CPU.onCdnDropFrame = onCdnDropFrame;
      CPU.on('error', function (handle) {
        self.postMessage({ cmd: 'error', source: handle.data });
      });
    }

    function onRemuxerInitSegmentArrival(video, audio) {
      self.postMessage({
        cmd: 'mediaSegmentInit',
        source: {
          type: 'video',
          data: video
        }
      });
      if (audio) {
        self.postMessage({
          cmd: 'mediaSegmentInit',
          source: {
            type: 'audio',
            data: audio
          }
        });
      }
    }

    function onRemuxerMediaSegmentArrival(type, data) {
      self.postMessage({ cmd: 'mediaSegment', source: { type: type, data: data } });
    }

    function onCPUError(error) {
      self.postMessage({ cmd: 'error', source: error });
    }

    function onMediaInfo(mediainfo) {
      self.postMessage({ cmd: 'mediainfo', source: mediainfo });
    }

    /**
     * cdn丢帧回调
     */
    function onCdnDropFrame(len) {
      self.postMessage({ cmd: 'cdnDropFrame', source: len });
    }

    function seek(keyframe) {
      loader.seek(keyframe.keyframePoint, false, keyframe.keyframetime);
    }

    function destroy() {
      if (loader) {
        loader.destroy();
        loaderUnbindEvent(loader);
        loader = null;
      }
      if (CPU) {
        CPU.off('error');
        CPU = null;
      }
    }

    function arrivalDataCallbackWorker(data, byteStart, keyframePoint) {
      if (!CPU) {
        init();
      }
      if (keyframePoint) {
        CPU.seek(keyframePoint);
      }
      self.postMessage({ cmd: 'player-event', source: { type: _playerEvents.PLAYER_EVENTS.MEDIA_DEMUX_FLV, ts: Date.now() } });
      var consumed = CPU.setflv(data);
      return consumed;
    }

    /**
     * 给loader绑定事件
     */
    function loaderBindEvent() {
      if (loader) {
        loader.on('end', function () {
          self.postMessage({ cmd: 'end' });
        });
        loader.on('error', function (handle) {
          self.postMessage({ cmd: 'error', source: handle.data });
        });
        loader.on('heartbeat', function (handle) {
          self.postMessage({ cmd: 'heartbeat', source: handle.data });
        });
        loader.on('player-event', function (handle) {
          self.postMessage({ cmd: 'player-event', source: handle.data });
        });
      }
    }
    /**
     * 解除事件绑定
     */
    function loaderUnbindEvent(target) {
      if (target) {
        target.off('end');
        target.off('error');
        target.off('heartbeat');
        target.off('player-event');
      }
    }
  };

  var _flv2fmp = __webpack_require__(7);

  var _flv2fmp2 = _interopRequireDefault(_flv2fmp);

  var _ioLoader = __webpack_require__(5);

  var _ioLoader2 = _interopRequireDefault(_ioLoader);

  var _playerEvents = __webpack_require__(2);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  /***/ }),
  /* 33 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    isLive: false, // 是否是直播
    box: 'flv', // 容器
    seekInKeyframe: true, // 总是seek 到关键帧
    alwaysSeekKeyframe: true, // 总是seek 到关键帧
    lazyLoadMaxDuration: 2 * 60, // 懒加载 最大播放长度
    lazyLoadRecoverDuration: 30, // 懒加载还有多少长度 重启加载功能
    lockInternalProperty: false, // 锁定原生的选项
    debug: true, // 是否开启debug模式
    webWorker: false, // 是否开启webworker
    autoCleanupSourceBuffer: true, // 是否自动清除 sourcebuffer
    autoCleanupMaxBackwardDuration: 10, // 清除sourcebuffer最大时间
    autoCleanupMinBackwardDuration: 10, // 清除sourcebuffer最小时间
    stashSize: 1024 * 384, // io缓存大小 直播下建议设置成 1024 * 128
    seekType: 'range' // seek请求的方式 是range 还是 query
  };

  /***/ }),
  /* 34 */
  /***/ (function(module, exports) {

  var g;

  // This works in non-strict mode
  g = (function() {
  	return this;
  })();

  try {
  	// This works if eval is allowed (see CSP)
  	g = g || Function("return this")() || (0, eval)("this");
  } catch(e) {
  	// This works if the window reference is available
  	if(typeof window === "object")
  		g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;


  /***/ }),
  /* 35 */
  /***/ (function(module, exports, __webpack_require__) {


  Object.defineProperty(exports, "__esModule", {
      value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _chimeeHelper = __webpack_require__(11);

  var _playerEvents = __webpack_require__(2);

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  /**
   * 播放日志处理。收集播放器事件，集中处理
   */
  var PlayerLogger = function (_CustEvent) {
      _inherits(PlayerLogger, _CustEvent);

      function PlayerLogger() {
          _classCallCheck(this, PlayerLogger);

          var _this = _possibleConstructorReturn(this, (PlayerLogger.__proto__ || Object.getPrototypeOf(PlayerLogger)).call(this));

          _this.reset();
          return _this;
      }

      /**
       * 重置状态
       */


      _createClass(PlayerLogger, [{
          key: 'reset',
          value: function reset() {
              this.loaderOpenTs = 0;
              this.receiveFirstPackageTs = 0;
              this.firstDemuxFlvTs = 0;
              this.firstSegmentTs = 0;
              this.firstPlay = 0;
          }

          /**
           * 记录事件及对应的数据
           * @param {object} event 事件数据
           * @param {string} type 事件类型
           */

      }, {
          key: 'record',
          value: function record(event) {
              event.ts = event.ts || Date.now();
              // 目前只记录播放前数据
              if (!this.firstPlay) {
                  this.processFirstPlayData(event);
              }
          }

          /**
           * 处理播放开始前的数据
           * @param {object} event 事件数据
           * @param {number} event.ts 事件触发时间戳
           * @param {string} event.type 事件类型 
           */

      }, {
          key: 'processFirstPlayData',
          value: function processFirstPlayData(event) {
              switch (event.type) {
                  case _playerEvents.PLAYER_EVENTS.LOADER_CHUNK_ARRIVAL:
                      if (!this.receiveFirstPackageTs) {
                          this.receiveFirstPackageTs = event.ts;
                          this.emit('performance', {
                              type: 'receive-first-package-duration',
                              value: this.receiveFirstPackageTs - this.loaderOpenTs
                          });
                      }
                      break;
                  case _playerEvents.PLAYER_EVENTS.MEDIA_DEMUX_FLV:
                      if (!this.firstDemuxFlvTs) {
                          this.firstDemuxFlvTs = event.ts;
                          this.emit('performance', {
                              type: 'first-flv-package-duration',
                              value: this.firstDemuxFlvTs - this.receiveFirstPackageTs
                          });
                      }
                      break;
                  case _playerEvents.PLAYER_EVENTS.MEDIA_SEGMENT:
                      if (!this.firstSegmentTs) {
                          this.firstSegmentTs = event.ts;
                          this.emit('performance', {
                              type: 'first-flv-to-mp4',
                              value: this.firstSegmentTs - this.firstDemuxFlvTs
                          });
                      }
                      break;
                  case _playerEvents.PLAYER_EVENTS.LOADER_OPEN:
                      if (!this.loaderOpenTs) {
                          this.loaderOpenTs = event.ts;
                          this.emit('performance', {
                              type: 'first_loader_open_timestamp',
                              value: this.loaderOpenTs
                          });
                      }
                      break;
                  case _playerEvents.PLAYER_EVENTS.PLAYING:
                  case _playerEvents.PLAYER_EVENTS.CANPLAY:
                  case _playerEvents.PLAYER_EVENTS.TIMEUPDATE:
                      if (!this.firstPlay) {
                          this.firstPlay = event.ts;
                          this.emit('performance', {
                              type: 'first_video_frame_duration',
                              value: this.firstPlay - this.firstSegmentTs
                          });
                      }
                      break;
              }
          }
      }]);

      return PlayerLogger;
  }(_chimeeHelper.CustEvent);

  exports.default = PlayerLogger;

  /***/ })
  /******/ ])["default"];
  });
  });

  var chimeeKernelFlv = unwrapExports(lib);

  Chimee.install(chimeeControl);
  Chimee.install(chimeeCenterState);
  Chimee.install(contextmenuConf);
  Chimee.install(index$1);

  var ChimeePlayer = /*#__PURE__*/function (_Chimee) {
    inherits(ChimeePlayer, _Chimee);

    function ChimeePlayer(config) {
      var _this;

      classCallCheck(this, ChimeePlayer);

      if (!isObject(config)) throw new TypeError('You must pass an Object as config when you new ChimeePlayer'); // 添加UI插件

      config.plugin = config.plugin || config.plugins;
      if (!isArray(config.plugin)) config.plugin = [];
      var innerPlugins = [chimeeControl.name, chimeeCenterState.name, contextmenuConf.name, index$1.name];
      var configPluginNames = config.plugin.map(function (item) {
        return isObject(item) ? item.name : item;
      });
      innerPlugins.forEach(function (name) {
        if (configPluginNames.indexOf(name) > -1) return;
        config.plugin.push(name);
      }); // 添加解码器

      config.kernels = deepAssign(config.kernels || {}, {
        hls: {
          handler: Hls
        },
        flv: {
          handler: chimeeKernelFlv
        }
      });
      _this = possibleConstructorReturn(this, getPrototypeOf(ChimeePlayer).call(this, config)); // 右键菜单的播放暂停

      _this.on('play', function () {
        return _this.chimeeContextmenu.updatemenu([{
          text: '暂停',
          action: 'pause'
        }]);
      });

      _this.on('pause', function () {
        return _this.chimeeContextmenu.updatemenu([{
          text: '播放',
          action: 'play'
        }]);
      });

      return _this;
    }

    return ChimeePlayer;
  }(Chimee); // 暴露浮层工厂方法


  ChimeePlayer.popupFactory = popupFactory;

  return ChimeePlayer;

})));



//////////////////
// WEBPACK FOOTER
// ./~/chimee-player/lib/chimee-player.browser.js
// module id = 233
// module chunks = 6